import { jsx as p, jsxs as C, Fragment as at } from "react/jsx-runtime";
import he, { forwardRef as qT, createElement as JE, useState as ae, useCallback as Q, useEffect as le, useRef as fe, useLayoutEffect as Sn, useContext as Dv, useImperativeHandle as Pw, createContext as Ov, useId as zT, useMemo as Ve, memo as mt } from "react";
import { Link as jT } from "react-router-dom";
import { createPortal as sE } from "react-dom";
const Hw = (e, t = "", n = "") => {
  let a = e;
  const o = /([(*[\])]*\b[oO][oO][cC]:\s*([^()\n[\]*]*)([(*[\])]*))/i, i = /^\s*\/[cC][mM][dD]:?\s*(.*)$/im;
  let c = e.match(o);
  if (c && c[2]) {
    const s = c[2].trim(), l = `${t}${s}${n}`;
    a = e.replace(c[0], l).replace(/\s\s+/g, " ").trim();
  } else if (c = e.match(i), c && c[1]) {
    const s = c[1].trim(), l = `${t}${s}${n}`;
    a = e.replace(c[0], l).trim();
  }
  return a;
};
function Bw(e) {
  const t = Math.abs(e), n = e < 0 ? "-" : "";
  return t >= 1e6 ? n + (t / 1e6).toFixed(1) + "m" : t >= 1e3 ? n + (t / 1e3).toFixed(1) + "k" : e ? e.toString() : "0";
}
const Fw = (e) => e.replace(/“([^”]+)”|"([^"]+)"|~~([^~]+)~~/g, (n, a, o, i) => a ? `<quote>${a}</quote>` : o ? `<quote>${o}</quote>` : i ? `<del>${i}</del>` : n), Pv = "-", $w = (e) => {
  const t = qw(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: a
  } = e;
  return {
    getClassGroupId: (c) => {
      const s = c.split(Pv);
      return s[0] === "" && s.length !== 1 && s.shift(), VT(s, t) || Uw(c);
    },
    getConflictingClassGroupIds: (c, s) => {
      const l = n[c] || [];
      return s && a[c] ? [...l, ...a[c]] : l;
    }
  };
}, VT = (e, t) => {
  var c;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], a = t.nextPart.get(n), o = a ? VT(e.slice(1), a) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Pv);
  return (c = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : c.classGroupId;
}, _A = /^\[(.+)\]$/, Uw = (e) => {
  if (_A.test(e)) {
    const t = _A.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, qw = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, a = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return jw(Object.entries(e.classGroups), n).forEach(([i, c]) => {
    ev(c, a, i, t);
  }), a;
}, ev = (e, t, n, a) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : bA(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (zw(o)) {
        ev(o(a), t, n, a);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, c]) => {
      ev(c, bA(t, i), n, a);
    });
  });
}, bA = (e, t) => {
  let n = e;
  return t.split(Pv).forEach((a) => {
    n.nextPart.has(a) || n.nextPart.set(a, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(a);
  }), n;
}, zw = (e) => e.isThemeGetter, jw = (e, t) => t ? e.map(([n, a]) => {
  const o = a.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([c, s]) => [t + c, s])) : i);
  return [n, o];
}) : e, Vw = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  const o = (i, c) => {
    n.set(i, c), t++, t > e && (t = 0, a = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let c = n.get(i);
      if (c !== void 0)
        return c;
      if ((c = a.get(i)) !== void 0)
        return o(i, c), c;
    },
    set(i, c) {
      n.has(i) ? n.set(i, c) : o(i, c);
    }
  };
}, GT = "!", Gw = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, a = t.length === 1, o = t[0], i = t.length, c = (s) => {
    const l = [];
    let u = 0, h = 0, k;
    for (let _ = 0; _ < s.length; _++) {
      let L = s[_];
      if (u === 0) {
        if (L === o && (a || s.slice(_, _ + i) === t)) {
          l.push(s.slice(h, _)), h = _ + i;
          continue;
        }
        if (L === "/") {
          k = _;
          continue;
        }
      }
      L === "[" ? u++ : L === "]" && u--;
    }
    const f = l.length === 0 ? s : s.substring(h), y = f.startsWith(GT), m = y ? f.substring(1) : f, g = k && k > h ? k - h : void 0;
    return {
      modifiers: l,
      hasImportantModifier: y,
      baseClassName: m,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: c
  }) : c;
}, Ww = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((a) => {
    a[0] === "[" ? (t.push(...n.sort(), a), n = []) : n.push(a);
  }), t.push(...n.sort()), t;
}, Xw = (e) => ({
  cache: Vw(e.cacheSize),
  parseClassName: Gw(e),
  ...$w(e)
}), Yw = /\s+/, Kw = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: a,
    getConflictingClassGroupIds: o
  } = t, i = [], c = e.trim().split(Yw);
  let s = "";
  for (let l = c.length - 1; l >= 0; l -= 1) {
    const u = c[l], {
      modifiers: h,
      hasImportantModifier: k,
      baseClassName: f,
      maybePostfixModifierPosition: y
    } = n(u);
    let m = !!y, g = a(m ? f.substring(0, y) : f);
    if (!g) {
      if (!m) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = a(f), !g) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const _ = Ww(h).join(":"), L = k ? _ + GT : _, N = L + g;
    if (i.includes(N))
      continue;
    i.push(N);
    const I = o(g, m);
    for (let S = 0; S < I.length; ++S) {
      const O = I[S];
      i.push(L + O);
    }
    s = u + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function Zw() {
  let e = 0, t, n, a = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = WT(t)) && (a && (a += " "), a += n);
  return a;
}
const WT = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let a = 0; a < e.length; a++)
    e[a] && (t = WT(e[a])) && (n && (n += " "), n += t);
  return n;
};
function tv(e, ...t) {
  let n, a, o, i = c;
  function c(l) {
    const u = t.reduce((h, k) => k(h), e());
    return n = Xw(u), a = n.cache.get, o = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const u = a(l);
    if (u)
      return u;
    const h = Kw(l, n);
    return o(l, h), h;
  }
  return function() {
    return i(Zw.apply(null, arguments));
  };
}
const $e = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, XT = /^\[(?:([a-z-]+):)?(.+)\]$/i, Qw = /^\d+\/\d+$/, Jw = /* @__PURE__ */ new Set(["px", "full", "screen"]), eS = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, tS = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, nS = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, aS = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, oS = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Tn = (e) => li(e) || Jw.has(e) || Qw.test(e), Fn = (e) => _i(e, "length", hS), li = (e) => !!e && !Number.isNaN(Number(e)), wE = (e) => _i(e, "number", li), Si = (e) => !!e && Number.isInteger(Number(e)), rS = (e) => e.endsWith("%") && li(e.slice(0, -1)), ge = (e) => XT.test(e), $n = (e) => eS.test(e), iS = /* @__PURE__ */ new Set(["length", "size", "percentage"]), cS = (e) => _i(e, iS, YT), sS = (e) => _i(e, "position", YT), lS = /* @__PURE__ */ new Set(["image", "url"]), dS = (e) => _i(e, lS, yS), uS = (e) => _i(e, "", pS), Ri = () => !0, _i = (e, t, n) => {
  const a = XT.exec(e);
  return a ? a[1] ? typeof t == "string" ? a[1] === t : t.has(a[1]) : n(a[2]) : !1;
}, hS = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  tS.test(e) && !nS.test(e)
), YT = () => !1, pS = (e) => aS.test(e), yS = (e) => oS.test(e), nv = () => {
  const e = $e("colors"), t = $e("spacing"), n = $e("blur"), a = $e("brightness"), o = $e("borderColor"), i = $e("borderRadius"), c = $e("borderSpacing"), s = $e("borderWidth"), l = $e("contrast"), u = $e("grayscale"), h = $e("hueRotate"), k = $e("invert"), f = $e("gap"), y = $e("gradientColorStops"), m = $e("gradientColorStopPositions"), g = $e("inset"), _ = $e("margin"), L = $e("opacity"), N = $e("padding"), I = $e("saturate"), S = $e("scale"), O = $e("sepia"), A = $e("skew"), B = $e("space"), z = $e("translate"), j = () => ["auto", "contain", "none"], G = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", ge, t], H = () => [ge, t], ee = () => ["", Tn, Fn], Y = () => ["auto", li, ge], U = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Z = () => ["solid", "dashed", "dotted", "double", "none"], te = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], re = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ue = () => ["", "0", ge], E = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ve = () => [li, ge];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ri],
      spacing: [Tn, Fn],
      blur: ["none", "", $n, ge],
      brightness: ve(),
      borderColor: [e],
      borderRadius: ["none", "", "full", $n, ge],
      borderSpacing: H(),
      borderWidth: ee(),
      contrast: ve(),
      grayscale: ue(),
      hueRotate: ve(),
      invert: ue(),
      gap: H(),
      gradientColorStops: [e],
      gradientColorStopPositions: [rS, Fn],
      inset: $(),
      margin: $(),
      opacity: ve(),
      padding: H(),
      saturate: ve(),
      scale: ve(),
      sepia: ue(),
      skew: ve(),
      space: H(),
      translate: H()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ge]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [$n]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": E()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": E()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...U(), ge]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: G()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": G()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": G()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Si, ge]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ge]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ue()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ue()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Si, ge]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ri]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Si, ge]
        }, ge]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Y()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Y()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ri]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Si, ge]
        }, ge]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Y()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Y()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...re()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...re(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...re(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [N]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [N]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [N]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [N]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [N]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [N]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [N]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [N]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [N]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [_]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [_]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [_]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [_]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [_]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [_]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [_]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [_]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [_]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [B]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [B]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ge, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ge, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ge, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [$n]
        }, $n]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ge, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ge, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", $n, Fn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", wE]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ri]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ge]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", li, wE]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Tn, ge]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ge]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ge]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [L]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [L]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Tn, Fn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Tn, ge]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: H()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ge]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ge]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [L]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...U(), sS]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", cS]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, dS]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [y]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [L]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Z(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [L]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Z()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Tn, ge]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Tn, Fn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ee()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [L]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Tn, Fn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", $n, uS]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ri]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [L]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...te(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": te()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [a]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", $n, ge]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [h]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [k]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [I]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [O]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [a]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [h]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [k]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [L]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [I]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [O]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [c]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [c]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [c]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ge]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ve()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ge]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ve()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ge]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Si, ge]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [z]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [z]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ge]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ge]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": H()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": H()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": H()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": H()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": H()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": H()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": H()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": H()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": H()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": H()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": H()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": H()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": H()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": H()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": H()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": H()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": H()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": H()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ge]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Tn, Fn, wE]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, kS = (e, {
  cacheSize: t,
  prefix: n,
  separator: a,
  experimentalParseClassName: o,
  extend: i = {},
  override: c = {}
}) => {
  zi(e, "cacheSize", t), zi(e, "prefix", n), zi(e, "separator", a), zi(e, "experimentalParseClassName", o);
  for (const s in c)
    fS(e[s], c[s]);
  for (const s in i)
    mS(e[s], i[s]);
  return e;
}, zi = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, fS = (e, t) => {
  if (t)
    for (const n in t)
      zi(e, n, t[n]);
}, mS = (e, t) => {
  if (t)
    for (const n in t) {
      const a = t[n];
      a !== void 0 && (e[n] = (e[n] || []).concat(a));
    }
}, pc = (e, ...t) => typeof e == "function" ? tv(nv, e, ...t) : tv(() => kS(nv(), e), ...t), gS = /* @__PURE__ */ tv(nv);
function KT(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = KT(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function wn() {
  for (var e, t, n = 0, a = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = KT(e)) && (a && (a += " "), a += t);
  return a;
}
function P(...e) {
  return gS(wn(e));
}
function MS(e, t = 0, n = 100) {
  return Number.isFinite(e) ? Math.min(n, Math.max(t, e)) : t;
}
const LA = ({
  index: e,
  setIndex: t,
  containerWidth: n,
  scrollContainerRef: a,
  loop: o,
  items: i
}) => {
  a != null && a.current && n > 0 && (o ? e < 0 ? e = i.length - 1 : e >= i.length && (e = 0) : e = Math.max(0, Math.min(e, i.length - 1)), a.current.scrollTo({
    left: e * n,
    behavior: "smooth"
  }), t(e));
}, _S = 5e3, bS = 300, LS = (e) => e == null ? _S : e * 1e3, xS = (e) => LS(e) + bS;
var ES = /* @__PURE__ */ ((e) => (e.GENERATING = "generating", e.PREVIEW = "preview", e.DRAFT = "draft", e.ERROR = "error", e))(ES || {});
const vS = {
  generating: {
    className: "text-gray-10 bg-gray-4",
    text: "Generating..."
  },
  preview: {
    className: "text-yellow-9 bg-yellow-2",
    text: "Ready for Preview"
  },
  draft: {
    className: "text-text1 bg-element",
    text: "Draft"
  },
  error: {
    className: "text-red-9 bg-red-2",
    text: "Error"
  }
};
var AS = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e.SUCCESS = "success", e.WARNING = "warning", e.DANGER = "danger", e.ACTIVE = "active", e.OUTLINED = "outlined", e))(AS || {}), ft = /* @__PURE__ */ ((e) => (e.DEFAULT = "DEFAULT", e.ERROR = "ERROR", e.ALERT = "ALERT", e.SUCCESS = "SUCCESS", e))(ft || {}), ac = /* @__PURE__ */ ((e) => (e.ERROR = "ERROR", e.SUCCESS = "SUCCESS", e))(ac || {}), av = /* @__PURE__ */ ((e) => (e.ERROR = "ERROR", e.SUCCESS = "SUCCESS", e))(av || {}), jt = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.WARNING = "warning", e.SUCCESS = "success", e.INFO = "info", e))(jt || {}), di = /* @__PURE__ */ ((e) => (e.WORDS = "words", e.CHARS = "chars", e.LINES = "lines", e))(di || {}), q1 = /* @__PURE__ */ ((e) => (e.UNCHANGED = "unchanged", e.ADDED = "added", e.REMOVED = "removed", e))(q1 || {}), R = /* @__PURE__ */ ((e) => (e.ADD = "PlusCircle", e.ALERT_TRIANGLE = "TriangleAlert", e.ARROW_LEFT = "ArrowLeft", e.ARROW_RIGHT = "ArrowRight", e.ARROW_LEFT_RIGHT = "ArrowLeftRight", e.ARROW_UP = "ArrowUp", e.ARROW_UP_RIGHT = "ArrowUpRight", e.ARROW_DOWN_UP = "ArrowDownUp", e.AUDIO = "AudioLines", e.BADGE_CHECK = "BadgeCheck", e.BAN = "Ban", e.BELL = "Bell", e.BLOCKS = "Blocks", e.BOOK = "BookOpen", e.BOOKMARK = "Bookmark", e.BOOKMARK_CHECK = "BookmarkCheck", e.BOOK_TEXT = "BookText", e.BOOK_LOCK = "BookLock", e.BOT = "Bot", e.CALENDAR = "CalendarDays", e.CHART_NETWORK = "ChartNetwork", e.CHART_NO_AXES_COMBINED = "ChartNoAxesCombined", e.CHECK = "Check", e.CHECK_CIRCLE = "CircleCheck", e.CHEVRONS_UP_DOWN = "ChevronsUpDown", e.CHEVRON_DOWN = "ChevronDown", e.CHEVRON_LEFT = "ChevronLeft", e.CHEVRON_RIGHT = "ChevronRight", e.CHEVRON_UP = "ChevronUp", e.CIRCLE_ALERT = "CircleAlert", e.CIRCLE_MINUS = "CircleMinus", e.CLOSE = "X", e.CLOSE_CIRCLE = "XCircle", e.COPY = "Copy", e.COMPASS = "Compass", e.COFFEE = "Coffee", e.CROWN = "Crown", e.DEVICE = "MonitorSmartphone", e.DICES = "Dices", e.DISLIKE = "ThumbsDown", e.DOWNLOAD = "Download", e.EARTH = "Earth", e.EDIT = "Pencil", e.EYE_OFF = "EyeOff", e.EYE = "Eye", e.EXTERNAL_LINK = "ExternalLink", e.FAVORITE = "Heart", e.FILE = "File", e.FLAG = "Flag", e.FLAME = "Flame", e.FOLDER = "Folder", e.FOLDER_OPEN = "FolderOpen", e.GEM = "Gem", e.GIFT = "Gift", e.GLOBE = "Globe", e.HOME = "Home", e.IMAGE = "Image", e.IMAGE_OFF = "ImageOff", e.IMAGE_PLUS = "ImagePlus", e.IMAGES = "Images", e.INFO = "Info", e.LAYERS = "Layers", e.LANGUAGES = "Languages", e.LIBRARY_BIG = "LibraryBig", e.LIGHT = "Lightbulb", e.LIKE = "ThumbsUp", e.LINK = "Link2", e.LINK_CHAIN = "Link", e.LIST_FILTER = "ListFilter", e.LOADER = "Loader", e.LOCK = "LockKeyhole", e.LOGIN = "LogIn", e.LOGOUT = "LogOut", e.LOGS = "Logs", e.MAIL = "Mail", e.MENU = "Menu", e.MESSAGE = "MessageSquareText", e.MESSAGE_CIRCLE = "MessageCircle", e.MESSAGE_CIRCLE_MORE = "MessageCircleMore", e.MESSAGE_MORE = "MessageSquareMore", e.MESSAGE_PLUS = "MessageSquarePlus", e.MIC = "Mic", e.MIC_OFF = "MicOff", e.MINUS = "Minus", e.MOON = "Moon", e.MORE_HORIZONTAL = "MoreHorizontal", e.MOVE_UP_RIGHT = "MoveUpRight", e.MORE_VERTICAL = "MoreVertical", e.MULTI_MESSAGE = "MessagesSquare", e.NEWS = "Newspaper", e.PAUSE = "Pause", e.PEN_TOOL = "PenTool", e.PIN = "Pin", e.PLAY = "Play", e.PLAY_CIRCLE = "PlayCircle", e.PLUS = "Plus", e.PLUS_SQUARE = "PlusSquare", e.REFRESH = "RefreshCcw", e.ROTATE_CW = "RotateCw", e.ROUNDED_CLOSE = "CircleX", e.SAD = "Frown", e.SAVE = "Save", e.SEARCH = "Search", e.SEND = "Send", e.SETTINGS = "Settings", e.SHARE = "Share2", e.SHARE_LINK = "Share", e.SHIELD_CHECK = "ShieldCheck", e.SKIP_FORWARD = "SkipForward", e.SLIDER_HORIZONTAL = "SlidersHorizontal", e.SLIDER_VERTICAL = "SlidersVertical", e.SPARKLE = "Sparkle", e.SPARKLES = "Sparkles", e.SQUARE = "Square", e.SQUARE_USER = "SquareUser", e.SQUARE_USER_ROUND = "SquareUserRound", e.SQUARE_ADD = "SquarePlus", e.STAR = "Star", e.STOP_CIRCLE = "StopCircle", e.SUN = "Sun", e.TAG = "Tag", e.TAGS = "Tags", e.THREE_DOTS = "EllipsisVertical", e.TICKET = "Ticket", e.TRASH = "Trash", e.TROPHY = "Trophy", e.UNLOCK = "LockKeyholeOpen", e.UPLOAD = "Upload", e.USER = "CircleUser", e.USER_CANCEL = "UserX", e.USER_COG = "UserCog", e.USER_PEN = "UserPen", e.USERS = "Users", e.VENETIAN_MASK = "VenetianMask", e.VOLUME_2 = "Volume2", e.WAYPOINTS = "Waypoints", e.WAND_SPARKLES = "WandSparkles", e.WRENCH = "Wrench", e.ZAP = "Zap", e.MOVE_RIGHT = "MoveRight", e.MOVE_LEFT = "MoveLeft", e.DROPLET = "Droplet", e.DROPLET_OFF = "DropletOff", e.CLIPBOARD = "Clipboard", e.CLIPBOARD_CHECK = "ClipboardCheck", e.CLOCK = "Clock", e.BRAIN = "Brain", e.COINS = "Coins", e.KEY = "Key", e.LEAF = "Leaf", e.MUSIC = "Music", e.SKULL = "Skull", e.SWORD = "Sword", e.TARGET = "Target", e.CREDIT_CARD = "CreditCard", e.HISTORY = "History", e))(R || {}), IS = /* @__PURE__ */ ((e) => (e.NONE = "none", e.LEFT_OUTER_ICON = "leftOuterIcon", e.LEFT_INNER_ICON = "leftInnerIcon", e.RIGHT_OUTER_ICON = "rightOuterIcon", e.RIGHT_INNER_ICON = "rightInnerIcon", e))(IS || {}), F1 = /* @__PURE__ */ ((e) => (e.START = "start", e.END = "end", e))(F1 || {}), tt = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.BOTTOM = "bottom", e.TOP = "top", e))(tt || {}), TS = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e))(TS || {}), NS = /* @__PURE__ */ ((e) => (e.USER = "user", e.BOT = "bot", e))(NS || {}), we = /* @__PURE__ */ ((e) => (e.SQUARE = "square", e.PILL = "pill", e))(we || {}), G1 = /* @__PURE__ */ ((e) => (e.SQUARE = "Square", e.ROUNDED = "Rounded", e))(G1 || {}), me = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e))(me || {}), _e = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL_MINUS = "smallMinus", e.SMALL = "small", e.SMALL_PLUS = "smallPlus", e.MEDIUM = "medium", e.LARGE = "large", e))(_e || {}), Ue = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e))(Ue || {}), dt = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e))(dt || {}), ii = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.COMPACT = "compact", e))(ii || {}), pn = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e.FULLSCREEN = "fullScreen", e.Default = "default", e.Free = "free", e))(pn || {}), ye = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e))(ye || {}), Xt = /* @__PURE__ */ ((e) => (e.XSMALL = "xSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e))(Xt || {}), ji = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e))(ji || {}), Yn = /* @__PURE__ */ ((e) => (e.DEFAULT = "medium", e.SMALL = "small", e))(Yn || {}), We = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e))(We || {}), CS = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e))(CS || {}), wS = /* @__PURE__ */ ((e) => (e.UNMODERATED = "unmoderated", e.ACTIVE = "active", e.REJECTED = "rejected", e.NEEDS_REVIEW = "needs_review", e))(wS || {});
const SS = {
  unmoderated: {
    // className: "bg-blue-10",
  },
  active: {
    // className: "bg-green-9",
  },
  rejected: {
    className: "bg-yellow-9"
  },
  needs_review: {
    className: "bg-blue-9"
  }
};
var RS = /* @__PURE__ */ ((e) => (e.REJECTED = "rejected", e.NEEDS_REVIEW = "needs_review", e))(RS || {});
const DS = {
  rejected: {
    className: "bg-red-9"
  },
  needs_review: {
    className: "bg-red-9"
  }
};
var x = /* @__PURE__ */ ((e) => (e.LABEL_LARGE_REGULAR = "LabelLargeRegular", e.LABEL_LARGE_MEDIUM = "LabelLargeMedium", e.LABEL_LARGE_BOLD = "LabelLargeBold", e.LABEL_MEDIUM_REGULAR = "LabelMediumRegular", e.LABEL_MEDIUM_MEDIUM = "LabelMediumMedium", e.LABEL_MEDIUM_BOLD = "LabelMediumBold", e.LABEL_SMALL_REGULAR = "LabelSmallRegular", e.LABEL_SMALL_MEDIUM = "LabelSmallMedium", e.LABEL_SMALL_BOLD = "LabelSmallBold", e.LABEL_XSMALL_REGULAR = "LabelXSmallRegular", e.LABEL_XSMALL_MEDIUM = "LabelXSmallMedium", e.LABEL_XSMALL_BOLD = "LabelXSmallBold", e.PARAGRAPH_LARGE_REGULAR = "ParagraphLargeRegular", e.PARAGRAPH_LARGE_MEDIUM = "ParagraphLargeMedium", e.PARAGRAPH_LARGE_BOLD = "ParagraphLargeBold", e.PARAGRAPH_MEDIUM_REGULAR = "ParagraphMediumRegular", e.PARAGRAPH_MEDIUM_MEDIUM = "ParagraphMediumMedium", e.PARAGRAPH_MEDIUM_BOLD = "ParagraphMediumBold", e.PARAGRAPH_SMALL_REGULAR = "ParagraphSmallRegular", e.PARAGRAPH_SMALL_MEDIUM = "ParagraphSmallMedium", e.PARAGRAPH_SMALL_BOLD = "ParagraphSmallBold", e.PARAGRAPH_XSMALL_REGULAR = "ParagraphXSmallRegular", e.PARAGRAPH_XSMALL_MEDIUM = "ParagraphXSmallMedium", e.PARAGRAPH_XSMALL_BOLD = "ParagraphXSmallBold", e.HEADING_LARGE_REGULAR = "HeadingLargeRegular", e.HEADING_LARGE_MEDIUM = "HeadingLargeMedium", e.HEADING_LARGE_BOLD = "HeadingLargeBold", e.HEADING_LARGE_BLACK = "HeadingLargeBlack", e.HEADING_SMALL_REGULAR = "HeadingSmallRegular", e.HEADING_SMALL_MEDIUM = "HeadingSmallMedium", e.HEADING_SMALL_BOLD = "HeadingSmallBold", e.HEADING_SMALL_BLACK = "HeadingSmallBlack", e.HEADING_6_BLACK = "Heading6Black", e.HEADING_6_BOLD = "Heading6Bold", e.HEADING_6_MEDIUM = "Heading6Medium", e.HEADING_6_REGULAR = "Heading6Regular", e.HEADING_5_BLACK = "Heading5Black", e.HEADING_5_BOLD = "Heading5Bold", e.HEADING_5_MEDIUM = "Heading5Medium", e.HEADING_5_REGULAR = "Heading5Regular", e.HEADING_4_BLACK = "Heading4Black", e.HEADING_4_BOLD = "Heading4Bold", e.HEADING_4_MEDIUM = "Heading4Medium", e.HEADING_4_REGULAR = "Heading4Regular", e.HEADING_3_BLACK = "Heading3Black", e.HEADING_3_BOLD = "Heading3Bold", e.HEADING_3_MEDIUM = "Heading3Medium", e.HEADING_3_REGULAR = "Heading3Regular", e.HEADING_2_BLACK = "Heading2Black", e.HEADING_2_BOLD = "Heading2Bold", e.HEADING_2_MEDIUM = "Heading2Medium", e.HEADING_2_REGULAR = "Heading2Regular", e.HEADING_1_BLACK = "Heading1Black", e.HEADING_1_BOLD = "Heading1Bold", e.HEADING_1_MEDIUM = "Heading1Medium", e.HEADING_1_REGULAR = "Heading1Regular", e.MOBILE_HEADING_1_BLACK = "MobileHeading1Black", e.MOBILE_HEADING_1_BOLD = "MobileHeading1Bold", e.MOBILE_HEADING_1_MEDIUM = "MobileHeading1Medium", e.MOBILE_HEADING_1_REGULAR = "MobileHeading1Regular", e.MOBILE_HEADING_2_BLACK = "MobileHeading2Black", e.MOBILE_HEADING_2_BOLD = "MobileHeading2Bold", e.MOBILE_HEADING_2_MEDIUM = "MobileHeading2Medium", e.MOBILE_HEADING_2_REGULAR = "MobileHeading2Regular", e.MOBILE_HEADING_3_BLACK = "MobileHeading3Black", e.MOBILE_HEADING_3_BOLD = "MobileHeading3Bold", e.MOBILE_HEADING_3_MEDIUM = "MobileHeading3Medium", e.MOBILE_HEADING_3_REGULAR = "MobileHeading3Regular", e.MOBILE_HEADING_4_BLACK = "MobileHeading4Black", e.MOBILE_HEADING_4_BOLD = "MobileHeading4Bold", e.MOBILE_HEADING_4_MEDIUM = "MobileHeading4Medium", e.MOBILE_HEADING_4_REGULAR = "MobileHeading4Regular", e.MOBILE_HEADING_5_BLACK = "MobileHeading5Black", e.MOBILE_HEADING_5_BOLD = "MobileHeading5Bold", e.MOBILE_HEADING_5_MEDIUM = "MobileHeading5Medium", e.MOBILE_HEADING_5_REGULAR = "MobileHeading5Regular", e.MOBILE_HEADING_6_BLACK = "MobileHeading6Black", e.MOBILE_HEADING_6_BOLD = "MobileHeading6Bold", e.MOBILE_HEADING_6_MEDIUM = "MobileHeading6Medium", e.MOBILE_HEADING_6_REGULAR = "MobileHeading6Regular", e.DISPLAY_LARGE_BLACK = "DisplayLargeBlack", e.DISPLAY_LARGE_BOLD = "DisplayLargeBold", e.DISPLAY_LARGE_MEDIUM = "DisplayLargeMedium", e.DISPLAY_LARGE_REGULAR = "DisplayLargeRegular", e.DISPLAY_SMALL_BLACK = "DisplaySmallBlack", e.DISPLAY_SMALL_BOLD = "DisplaySmallBold", e.DISPLAY_SMALL_MEDIUM = "DisplaySmallMedium", e.DISPLAY_SMALL_REGULAR = "DisplaySmallRegular", e))(x || {}), J = /* @__PURE__ */ ((e) => (e.TEXT = "Text", e.CONTAINED = "Contained", e.OUTLINED = "Outlined", e.INVERSE = "Inverse", e.TRANSPARENT = "Transparent", e.SECONDARY = "Secondary", e.DARK = "Dark", e.OUTLINED_DANGER = "OutlinedDanger", e))(J || {}), Ze = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.ACTIVE = "active", e.CONTRAST = "contrast", e.OUTLINED = "Outlined", e.SOFT_SUCCESS = "softSuccess", e.SOFT_PURPLE = "softPurple", e.SOFT_NEUTRAL = "softNeutral", e))(Ze || {}), ut = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.INCLUDE = "Include", e.EXCLUDE = "Exclude", e))(ut || {}), ZT = /* @__PURE__ */ ((e) => (e.SOLID = "Solid", e.PLAIN = "Plain", e))(ZT || {}), z1 = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.ALERT = "Alert", e.ERROR = "Error", e))(z1 || {}), Y9 = /* @__PURE__ */ ((e) => (e.TOP = "Top", e.POP_UP = "Pop-up", e.IN_LINE = "In-line", e.BOTTOM = "Bottom", e))(Y9 || {}), oc = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.BORDERED = "Bordered", e))(oc || {}), W1 = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.PRIMARY = "Primary", e))(W1 || {}), rc = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.DEFAULT_OUTLINED = "DefaultOutlined", e))(rc || {}), Bt = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.OUTLINED = "Outlined", e.COLORED = "Colored", e))(Bt || {}), Et = /* @__PURE__ */ ((e) => (e.SUBMITTED = "submitted", e.PUBLISHED = "published", e.BASIC = "basic", e))(Et || {}), OS = /* @__PURE__ */ ((e) => (e.NATIVE = "Native", e.MOBILE_WEB = "MOBILE_WEB", e.TABLET_WEB = "TABLET_WEB", e.DESKTOP_WEB = "DESKTOP_WEB", e))(OS || {});
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PS = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), QT = (...e) => e.filter((t, n, a) => !!t && t.trim() !== "" && a.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var HS = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JT = qT(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: a,
    className: o = "",
    children: i,
    iconNode: c,
    ...s
  }, l) => JE(
    "svg",
    {
      ref: l,
      ...HS,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: a ? Number(n) * 24 / Number(t) : n,
      className: QT("lucide", o),
      ...s
    },
    [
      ...c.map(([u, h]) => JE(u, h)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r = (e, t) => {
  const n = qT(
    ({ className: a, ...o }, i) => JE(JT, {
      ref: i,
      iconNode: t,
      className: QT(`lucide-${PS(e)}`, a),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BS = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
], Sc = r("AArrowDown", BS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FS = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
], Rc = r("AArrowUp", FS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $S = [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
], Dc = r("ALargeSmall", $S);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const US = [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
], Oc = r("Accessibility", US);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qS = [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
], Pc = r("Activity", qS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zS = [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
], Hc = r("AirVent", zS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jS = [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
], Bc = r("Airplay", jS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VS = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], ra = r("AlarmClockCheck", VS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GS = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], ia = r("AlarmClockMinus", GS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WS = [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
], Fc = r("AlarmClockOff", WS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XS = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], ca = r("AlarmClockPlus", XS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YS = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
], $c = r("AlarmClock", YS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KS = [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
], Uc = r("AlarmSmoke", KS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZS = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
], qc = r("Album", ZS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QS = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
], zc = r("AlignCenterHorizontal", QS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JS = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
], jc = r("AlignCenterVertical", JS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eR = [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], Vc = r("AlignCenter", eR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tR = [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
], Gc = r("AlignEndHorizontal", tR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nR = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
], Wc = r("AlignEndVertical", nR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aR = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
], Xc = r(
  "AlignHorizontalDistributeCenter",
  aR
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oR = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
], Yc = r("AlignHorizontalDistributeEnd", oR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rR = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
], Kc = r(
  "AlignHorizontalDistributeStart",
  rR
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iR = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], Zc = r("AlignHorizontalJustifyCenter", iR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cR = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
], Qc = r("AlignHorizontalJustifyEnd", cR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sR = [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], Jc = r("AlignHorizontalJustifyStart", sR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lR = [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
], es = r("AlignHorizontalSpaceAround", lR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dR = [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
], ts = r("AlignHorizontalSpaceBetween", dR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uR = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], ns = r("AlignJustify", uR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hR = [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], as = r("AlignLeft", hR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pR = [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], os = r("AlignRight", pR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yR = [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
], rs = r("AlignStartHorizontal", yR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kR = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], is = r("AlignStartVertical", kR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fR = [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
], cs = r("AlignVerticalDistributeCenter", fR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mR = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], ss = r("AlignVerticalDistributeEnd", mR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gR = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
], ls = r("AlignVerticalDistributeStart", gR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MR = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], ds = r("AlignVerticalJustifyCenter", MR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _R = [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
], us = r("AlignVerticalJustifyEnd", _R);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bR = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
], hs = r("AlignVerticalJustifyStart", bR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LR = [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
], ps = r("AlignVerticalSpaceAround", LR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xR = [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
], ys = r("AlignVerticalSpaceBetween", xR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ER = [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], ks = r("Ambulance", ER);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vR = [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
], fs = r("Ampersand", vR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AR = [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
], ms = r("Ampersands", AR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IR = [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
], gs = r("Amphora", IR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TR = [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
], Ms = r("Anchor", TR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NR = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
], _s = r("Angry", NR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CR = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
], bs = r("Annoyed", CR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wR = [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], Ls = r("Antenna", wR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SR = [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
], xs = r("Anvil", SR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RR = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
], Es = r("Aperture", RR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DR = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
], vs = r("AppWindowMac", DR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OR = [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
], As = r("AppWindow", OR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PR = [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
], Is = r("Apple", PR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HR = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
], Ts = r("ArchiveRestore", HR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BR = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
], Ns = r("ArchiveX", BR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FR = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
], Cs = r("Archive", FR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $R = [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], ws = r("Armchair", $R);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UR = [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
], Ss = r("ArrowBigDownDash", UR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qR = [["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]], Rs = r("ArrowBigDown", qR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zR = [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
], Ds = r("ArrowBigLeftDash", zR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jR = [["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]], Os = r("ArrowBigLeft", jR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VR = [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
], Ps = r("ArrowBigRightDash", VR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GR = [["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]], Hs = r("ArrowBigRight", GR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WR = [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
], Bs = r("ArrowBigUpDash", WR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XR = [["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]], Fs = r("ArrowBigUp", XR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YR = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], $s = r("ArrowDown01", YR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KR = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], Us = r("ArrowDown10", KR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZR = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], sa = r("ArrowDownAZ", ZR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QR = [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
], qs = r("ArrowDownFromLine", QR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JR = [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
], zs = r("ArrowDownLeft", JR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eD = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
], js = r("ArrowDownNarrowWide", eD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tD = [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
], Vs = r("ArrowDownRight", tD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nD = [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], Gs = r("ArrowDownToDot", nD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aD = [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
], Ws = r("ArrowDownToLine", aD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oD = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
], Xs = r("ArrowDownUp", oD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rD = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
], la = r("ArrowDownWideNarrow", rD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iD = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], da = r("ArrowDownZA", iD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cD = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], Ys = r("ArrowDown", cD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sD = [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
], Ks = r("ArrowLeftFromLine", sD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lD = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
], Zs = r("ArrowLeftRight", lD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dD = [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
], Qs = r("ArrowLeftToLine", dD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uD = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], Js = r("ArrowLeft", uD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hD = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
], el = r("ArrowRightFromLine", hD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pD = [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], tl = r("ArrowRightLeft", pD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yD = [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], nl = r("ArrowRightToLine", yD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kD = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], al = r("ArrowRight", kD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fD = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], ol = r("ArrowUp01", fD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mD = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], rl = r("ArrowUp10", mD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gD = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], ua = r("ArrowUpAZ", gD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MD = [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
], il = r("ArrowUpDown", MD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _D = [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], cl = r("ArrowUpFromDot", _D);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bD = [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], sl = r("ArrowUpFromLine", bD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LD = [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
], ll = r("ArrowUpLeft", LD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xD = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
], ha = r("ArrowUpNarrowWide", xD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ED = [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
], dl = r("ArrowUpRight", ED);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vD = [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
], ul = r("ArrowUpToLine", vD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AD = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
], hl = r("ArrowUpWideNarrow", AD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ID = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], pa = r("ArrowUpZA", ID);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TD = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], pl = r("ArrowUp", TD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ND = [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
], yl = r("ArrowsUpFromLine", ND);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CD = [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
], kl = r("Asterisk", CD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wD = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
], fl = r("AtSign", wD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SD = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
], ml = r("Atom", SD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RD = [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
], gl = r("AudioLines", RD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DD = [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
], Ml = r("AudioWaveform", DD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OD = [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
], _l = r("Award", OD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PD = [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
], bl = r("Axe", PD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HD = [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
], ya = r("Axis3d", HD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BD = [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
], Ll = r("Baby", BD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FD = [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
], xl = r("Backpack", FD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $D = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], El = r("BadgeAlert", $D);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
], vl = r("BadgeCent", UD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], ka = r("BadgeCheck", qD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], Al = r("BadgeDollarSign", zD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], Il = r("BadgeEuro", jD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
], Tl = r("BadgeHelp", VD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
], Nl = r("BadgeIndianRupee", GD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
], Cl = r("BadgeInfo", WD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
], wl = r("BadgeJapaneseYen", XD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], Sl = r("BadgeMinus", YD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], Rl = r("BadgePercent", KD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], Dl = r("BadgePlus", ZD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
], Ol = r("BadgePoundSterling", QD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JD = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
], Pl = r("BadgeRussianRuble", JD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eO = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
], Hl = r("BadgeSwissFranc", eO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tO = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], Bl = r("BadgeX", tO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nO = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
], Fl = r("Badge", nO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aO = [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
], $l = r("BaggageClaim", aO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oO = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
], Ul = r("Ban", oO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rO = [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
], ql = r("Banana", rO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iO = [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
], zl = r("Bandage", iO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cO = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
], jl = r("Banknote", cO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sO = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], Vl = r("Barcode", sO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lO = [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], Gl = r("Baseline", lO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dO = [
  ["path", { d: "M10 4 8 6", key: "1rru8s" }],
  ["path", { d: "M17 19v2", key: "ts1sot" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M7 19v2", key: "12npes" }],
  [
    "path",
    {
      d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "14ym8i"
    }
  ]
], Wl = r("Bath", dO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uO = [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], Xl = r("BatteryCharging", uO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hO = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
], Yl = r("BatteryFull", hO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pO = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
], Kl = r("BatteryLow", pO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yO = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
], Zl = r("BatteryMedium", yO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kO = [
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["path", { d: "M13.5 7H16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5", key: "jzl4pj" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6.5 17H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2.5", key: "1ar5vp" }],
  ["path", { d: "M7 12h6", key: "iekk3h" }]
], Ql = r("BatteryPlus", kO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fO = [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
], Jl = r("BatteryWarning", fO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mO = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], e0 = r("Battery", mO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gO = [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
], t0 = r("Beaker", gO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MO = [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], n0 = r("BeanOff", MO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _O = [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
], a0 = r("Bean", _O);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bO = [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
], o0 = r("BedDouble", bO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LO = [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
], r0 = r("BedSingle", LO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xO = [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
], i0 = r("Bed", xO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EO = [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
], c0 = r("Beef", EO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vO = [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
], s0 = r("BeerOff", vO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AO = [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
], l0 = r("Beer", AO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
      key: "1tip0g"
    }
  ],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
], d0 = r("BellDot", IO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TO = [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
], u0 = r("BellElectric", TO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  [
    "path",
    {
      d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
      key: "bdwj86"
    }
  ]
], h0 = r("BellMinus", NO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
], p0 = r("BellOff", CO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
], y0 = r("BellPlus", wO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }]
], k0 = r("BellRing", SO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RO = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], f0 = r("Bell", RO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DO = [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
], fa = r("BetweenHorizontalEnd", DO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OO = [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
], ma = r("BetweenHorizontalStart", OO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PO = [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
], m0 = r("BetweenVerticalEnd", PO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HO = [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
], g0 = r("BetweenVerticalStart", HO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BO = [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
], M0 = r("BicepsFlexed", BO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FO = [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
], _0 = r("Bike", FO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $O = [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
], b0 = r("Binary", $O);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UO = [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
], L0 = r("Binoculars", UO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qO = [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
], x0 = r("Biohazard", qO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zO = [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
], E0 = r("Bird", zO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jO = [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
], v0 = r("Bitcoin", jO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VO = [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
], A0 = r("Blend", VO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GO = [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
], I0 = r("Blinds", GO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WO = [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
], T0 = r("Blocks", WO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XO = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
], N0 = r("BluetoothConnected", XO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YO = [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
], C0 = r("BluetoothOff", YO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KO = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], w0 = r("BluetoothSearching", KO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZO = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]], S0 = r("Bluetooth", ZO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QO = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
], R0 = r("Bold", QO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JO = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], D0 = r("Bolt", JO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eP = [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
], O0 = r("Bomb", eP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tP = [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
], P0 = r("Bone", tP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
], H0 = r("BookA", nP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aP = [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
], B0 = r("BookAudio", aP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
], F0 = r("BookCheck", oP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rP = [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
], $0 = r("BookCopy", rP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iP = [
  ["path", { d: "M12 17h1.5", key: "1gkc67" }],
  ["path", { d: "M12 22h1.5", key: "1my7sn" }],
  ["path", { d: "M12 2h1.5", key: "19tvb7" }],
  ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1", key: "10akbh" }],
  ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5", key: "1vrfjs" }],
  ["path", { d: "M20 14v3h-2.5", key: "1naeju" }],
  ["path", { d: "M20 8.5V10", key: "1ctpfu" }],
  ["path", { d: "M4 10V8.5", key: "1o3zg5" }],
  ["path", { d: "M4 19.5V14", key: "ob81pf" }],
  ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8", key: "s8vcyb" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
], ga = r("BookDashed", iP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cP = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
], U0 = r("BookDown", cP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], q0 = r("BookHeadphones", sP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lP = [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], z0 = r("BookHeart", lP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dP = [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
], j0 = r("BookImage", dP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uP = [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
], V0 = r("BookKey", uP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hP = [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
], G0 = r("BookLock", hP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pP = [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], W0 = r("BookMarked", pP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], X0 = r("BookMinus", yP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kP = [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
], Y0 = r("BookOpenCheck", kP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fP = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
], K0 = r("BookOpenText", fP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mP = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
], Z0 = r("BookOpen", mP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gP = [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], Q0 = r("BookPlus", gP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
], J0 = r("BookText", MP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _P = [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], e2 = r("BookType", _P);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bP = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], t2 = r("BookUp2", bP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LP = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], n2 = r("BookUp", LP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xP = [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
], a2 = r("BookUser", xP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EP = [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
], o2 = r("BookX", EP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vP = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], r2 = r("Book", vP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AP = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], i2 = r("BookmarkCheck", AP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IP = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], c2 = r("BookmarkMinus", IP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TP = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], s2 = r("BookmarkPlus", TP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NP = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], l2 = r("BookmarkX", NP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CP = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
], d2 = r("Bookmark", CP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wP = [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
], u2 = r("BoomBox", wP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SP = [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
], h2 = r("BotMessageSquare", SP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RP = [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
], p2 = r("BotOff", RP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DP = [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
], y2 = r("Bot", DP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OP = [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
], k2 = r("Box", OP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PP = [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
], f2 = r("Boxes", PP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HP = [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
], Ma = r("Braces", HP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BP = [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
], m2 = r("Brackets", BP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
], g2 = r("BrainCircuit", FP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $P = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
], M2 = r("BrainCog", $P);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UP = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
], _2 = r("Brain", UP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qP = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
], b2 = r("BrickWall", qP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zP = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], L2 = r("BriefcaseBusiness", zP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jP = [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
], x2 = r("BriefcaseConveyorBelt", jP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VP = [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], E2 = r("BriefcaseMedical", VP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GP = [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], v2 = r("Briefcase", GP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
], A2 = r("BringToFront", WP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XP = [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
], I2 = r("Brush", XP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YP = [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
], T2 = r("BugOff", YP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KP = [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
], N2 = r("BugPlay", KP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZP = [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
], C2 = r("Bug", ZP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QP = [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], w2 = r("Building2", QP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JP = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
], S2 = r("Building", JP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eH = [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
], R2 = r("BusFront", eH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tH = [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
], D2 = r("Bus", tH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nH = [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], O2 = r("CableCar", nH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aH = [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
], P2 = r("Cable", aH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oH = [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
], H2 = r("CakeSlice", oH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rH = [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
], B2 = r("Cake", rH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iH = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], F2 = r("Calculator", iH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cH = [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], $2 = r("Calendar1", cH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sH = [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], U2 = r("CalendarArrowDown", sH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lH = [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], q2 = r("CalendarArrowUp", lH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], z2 = r("CalendarCheck2", dH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
], j2 = r("CalendarCheck", uH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hH = [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
], V2 = r("CalendarClock", hH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pH = [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], G2 = r("CalendarCog", pH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
], W2 = r("CalendarDays", yH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
], X2 = r("CalendarFold", kH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fH = [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
], Y2 = r("CalendarHeart", fH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
], K2 = r("CalendarMinus2", mH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gH = [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], Z2 = r("CalendarMinus", gH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MH = [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Q2 = r("CalendarOff", MH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _H = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
], J2 = r("CalendarPlus2", _H);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
], ed = r("CalendarPlus", bH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LH = [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
], td = r("CalendarRange", LH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xH = [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], nd = r("CalendarSearch", xH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EH = [
  ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "vu0qm5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "1qgeyt" }],
  ["path", { d: "M21 22v-4h-4", key: "hrummi" }],
  ["path", { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3", key: "mctw84" }],
  ["path", { d: "M3 10h4", key: "1el30a" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], ad = r("CalendarSync", EH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
], od = r("CalendarX2", vH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
], rd = r("CalendarX", AH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IH = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], id = r("Calendar", IH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TH = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
], cd = r("CameraOff", TH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NH = [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
], sd = r("Camera", NH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CH = [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
], ld = r("CandyCane", CH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wH = [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], dd = r("CandyOff", wH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SH = [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
], ud = r("Candy", SH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RH = [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
], hd = r("Cannabis", RH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DH = [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
], pd = r("CaptionsOff", DH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OH = [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
], _a = r("Captions", OH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PH = [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], yd = r("CarFront", PH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HH = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], kd = r("CarTaxiFront", HH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BH = [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
], fd = r("Car", BH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FH = [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
], md = r("Caravan", FH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $H = [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
], gd = r("Carrot", $H);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UH = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
], Md = r("CaseLower", UH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qH = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
], _d = r("CaseSensitive", qH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zH = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
], bd = r("CaseUpper", zH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jH = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
], Ld = r("CassetteTape", jH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VH = [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
], xd = r("Cast", VH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GH = [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
], Ed = r("Castle", GH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WH = [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
], vd = r("Cat", WH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XH = [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
], Ad = r("Cctv", XH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YH = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
], ba = r("ChartArea", YH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KH = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], La = r("ChartBarBig", KH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZH = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
], Id = r("ChartBarDecreasing", ZH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QH = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], Td = r("ChartBarIncreasing", QH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JH = [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], Nd = r("ChartBarStacked", JH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eB = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], xa = r("ChartBar", eB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tB = [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], Ea = r("ChartCandlestick", tB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nB = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], va = r("ChartColumnBig", nB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aB = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
], Cd = r("ChartColumnDecreasing", aB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oB = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], Aa = r("ChartColumnIncreasing", oB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rB = [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], wd = r("ChartColumnStacked", rB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iB = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], Ia = r("ChartColumn", iB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cB = [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
], Sd = r("ChartGantt", cB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sB = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
], Ta = r("ChartLine", sB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lB = [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
], Rd = r("ChartNetwork", lB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dB = [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
], Dd = r("ChartNoAxesColumnDecreasing", dB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uB = [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
], Na = r("ChartNoAxesColumnIncreasing", uB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hB = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
], Ca = r("ChartNoAxesColumn", hB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pB = [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
], Od = r("ChartNoAxesCombined", pB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yB = [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
], wa = r("ChartNoAxesGantt", yB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kB = [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
], Sa = r("ChartPie", kB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fB = [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], Ra = r("ChartScatter", fB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mB = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
], Pd = r("ChartSpline", mB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gB = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], Hd = r("CheckCheck", gB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MB = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Bd = r("Check", MB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _B = [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
], Fd = r("ChefHat", _B);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bB = [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
], $d = r("Cherry", bB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LB = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Ud = r("ChevronDown", LB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xB = [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
], qd = r("ChevronFirst", xB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EB = [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
], zd = r("ChevronLast", EB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vB = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], jd = r("ChevronLeft", vB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AB = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Vd = r("ChevronRight", AB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IB = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Gd = r("ChevronUp", IB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TB = [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
], Wd = r("ChevronsDownUp", TB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NB = [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
], Xd = r("ChevronsDown", NB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CB = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], Yd = r("ChevronsLeftRightEllipsis", CB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wB = [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
], Kd = r("ChevronsLeftRight", wB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SB = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
], Zd = r("ChevronsLeft", SB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RB = [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
], Qd = r("ChevronsRightLeft", RB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DB = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
], Jd = r("ChevronsRight", DB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OB = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], eu = r("ChevronsUpDown", OB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PB = [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
], tu = r("ChevronsUp", PB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
], nu = r("Chrome", HB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BB = [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
], au = r("Church", BB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FB = [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], ou = r("CigaretteOff", FB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $B = [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], ru = r("Cigarette", $B);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Da = r("CircleAlert", UB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], Oa = r("CircleArrowDown", qB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
], Pa = r("CircleArrowLeft", zB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jB = [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
], Ha = r("CircleArrowOutDownLeft", jB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VB = [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
], Ba = r("CircleArrowOutDownRight", VB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GB = [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
], Fa = r("CircleArrowOutUpLeft", GB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WB = [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
], $a = r("CircleArrowOutUpRight", WB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], Ua = r("CircleArrowRight", XB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], qa = r("CircleArrowUp", YB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KB = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], za = r("CircleCheckBig", KB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], ja = r("CircleCheck", ZB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], Va = r("CircleChevronDown", QB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], Ga = r("CircleChevronLeft", JB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], Wa = r("CircleChevronRight", eF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], Xa = r("CircleChevronUp", tF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nF = [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
], iu = r("CircleDashed", nF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aF = [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Ya = r("CircleDivide", aF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], cu = r("CircleDollarSign", oF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rF = [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], su = r("CircleDotDashed", rF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], lu = r("CircleDot", iF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], du = r("CircleEllipsis", cF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sF = [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], uu = r("CircleEqual", sF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lF = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], hu = r("CircleFadingArrowUp", lF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dF = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], pu = r("CircleFadingPlus", dF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uF = [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
], Ka = r("CircleGauge", uF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Za = r("CircleHelp", hF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], Qa = r("CircleMinus", pF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yF = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
], yu = r("CircleOff", yF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
], Ja = r("CircleParkingOff", kF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], eo = r("CircleParking", fF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
], to = r("CirclePause", mF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], no = r("CirclePercent", gF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
], ao = r("CirclePlay", MF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _F = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], oo = r("CirclePlus", _F);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bF = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], ro = r("CirclePower", bF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
], io = r("CircleSlash2", LF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], ku = r("CircleSlash", xF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EF = [["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }]], fu = r("CircleSmall", EF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
], co = r("CircleStop", vF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AF = [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], so = r("CircleUserRound", AF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
], lo = r("CircleUser", IF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], uo = r("CircleX", TF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NF = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], mu = r("Circle", NF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CF = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
], gu = r("CircuitBoard", CF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wF = [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
], Mu = r("Citrus", wF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SF = [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
], _u = r("Clapperboard", SF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
], bu = r("ClipboardCheck", RF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
], Lu = r("ClipboardCopy", DF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], xu = r("ClipboardList", OF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
], Eu = r("ClipboardMinus", PF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HF = [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
], vu = r("ClipboardPaste", HF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
], ho = r("ClipboardPenLine", BF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], po = r("ClipboardPen", FF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $F = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
], Au = r("ClipboardPlus", $F);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
], Iu = r("ClipboardType", UF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
], Tu = r("ClipboardX", qF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zF = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
], Nu = r("Clipboard", zF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
], Cu = r("Clock1", jF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
], wu = r("Clock10", VF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
], Su = r("Clock11", GF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
], Ru = r("Clock12", WF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
], Du = r("Clock2", XF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
], Ou = r("Clock3", YF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], Pu = r("Clock4", KF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
], Hu = r("Clock5", ZF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
], Bu = r("Clock6", QF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JF = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
], Fu = r("Clock7", JF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e$ = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
], $u = r("Clock8", e$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t$ = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
], Uu = r("Clock9", t$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n$ = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
], qu = r("ClockAlert", n$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a$ = [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
], zu = r("ClockArrowDown", a$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o$ = [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
], ju = r("ClockArrowUp", o$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r$ = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], Vu = r("Clock", r$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i$ = [
  ["path", { d: "M12 12v4", key: "tww15h" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708", key: "xsb5ju" }]
], Gu = r("CloudAlert", i$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c$ = [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
], Wu = r("CloudCog", c$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s$ = [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
], yo = r("CloudDownload", s$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
], Xu = r("CloudDrizzle", l$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
], Yu = r("CloudFog", d$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
], Ku = r("CloudHail", u$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h$ = [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
], Zu = r("CloudLightning", h$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p$ = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], Qu = r("CloudMoonRain", p$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y$ = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
], Ju = r("CloudMoon", y$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k$ = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
], eh = r("CloudOff", k$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
], th = r("CloudRainWind", f$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], nh = r("CloudRain", m$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g$ = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
], ah = r("CloudSnow", g$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M$ = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], oh = r("CloudSunRain", M$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _$ = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
], rh = r("CloudSun", _$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b$ = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
], ko = r("CloudUpload", b$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L$ = [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
], ih = r("Cloud", L$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x$ = [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
], ch = r("Cloudy", x$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E$ = [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
], sh = r("Clover", E$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v$ = [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
], lh = r("Club", v$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A$ = [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
], fo = r("CodeXml", A$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I$ = [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
], dh = r("Code", I$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T$ = [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
], uh = r("Codepen", T$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N$ = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
], hh = r("Codesandbox", N$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C$ = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
], ph = r("Coffee", C$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w$ = [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
], yh = r("Cog", w$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S$ = [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
], kh = r("Coins", S$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R$ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
], mo = r("Columns2", R$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D$ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], go = r("Columns3", D$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O$ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
], fh = r("Columns4", O$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P$ = [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
], mh = r("Combine", P$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$ = [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
], gh = r("Command", H$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B$ = [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Mh = r("Compass", B$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F$ = [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
], _h = r("Component", F$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $$ = [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
], bh = r("Computer", $$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U$ = [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
], Lh = r("ConciergeBell", U$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q$ = [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
], xh = r("Cone", q$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z$ = [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
], Eh = r("Construction", z$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j$ = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], Mo = r("ContactRound", j$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V$ = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], vh = r("Contact", V$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G$ = [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
], Ah = r("Container", G$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W$ = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
], Ih = r("Contrast", W$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X$ = [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
], Th = r("Cookie", X$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y$ = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
], Nh = r("CookingPot", Y$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K$ = [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Ch = r("CopyCheck", K$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z$ = [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], wh = r("CopyMinus", Z$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q$ = [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Sh = r("CopyPlus", Q$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J$ = [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Rh = r("CopySlash", J$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eU = [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Dh = r("CopyX", eU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tU = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Oh = r("Copy", tU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
], Ph = r("Copyleft", nU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
], Hh = r("Copyright", aU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oU = [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
], Bh = r("CornerDownLeft", oU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rU = [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
], Fh = r("CornerDownRight", rU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iU = [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
], $h = r("CornerLeftDown", iU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cU = [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
], Uh = r("CornerLeftUp", cU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sU = [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
], qh = r("CornerRightDown", sU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lU = [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
], zh = r("CornerRightUp", lU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dU = [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
], jh = r("CornerUpLeft", dU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uU = [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
], Vh = r("CornerUpRight", uU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hU = [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
], Gh = r("Cpu", hU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
], Wh = r("CreativeCommons", pU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yU = [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
], Xh = r("CreditCard", yU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kU = [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
], Yh = r("Croissant", kU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fU = [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
], Kh = r("Crop", fU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mU = [
  [
    "path",
    {
      d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
      key: "1xbrqy"
    }
  ]
], Zh = r("Cross", mU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
], Qh = r("Crosshair", gU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MU = [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], Jh = r("Crown", MU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _U = [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
], ep = r("Cuboid", _U);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bU = [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
], tp = r("CupSoda", bU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LU = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
], np = r("Currency", LU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xU = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
], ap = r("Cylinder", xU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EU = [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
], op = r("Dam", EU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vU = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
], rp = r("DatabaseBackup", vU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AU = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
], ip = r("DatabaseZap", AU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IU = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
], cp = r("Database", IU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TU = [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
], sp = r("Delete", TU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NU = [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
], lp = r("Dessert", NU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CU = [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
], dp = r("Diameter", CU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wU = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], up = r("DiamondMinus", wU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SU = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
], _o = r("DiamondPercent", SU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RU = [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], hp = r("DiamondPlus", RU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DU = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
], pp = r("Diamond", DU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], yp = r("Dice1", OU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
], kp = r("Dice2", PU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], fp = r("Dice3", HU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
], mp = r("Dice4", BU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], gp = r("Dice5", FU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $U = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], Mp = r("Dice6", $U);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UU = [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
], _p = r("Dices", UU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qU = [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], bp = r("Diff", qU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], Lp = r("Disc2", zU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
], xp = r("Disc3", jU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VU = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], Ep = r("DiscAlbum", VU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GU = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], vp = r("Disc", GU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WU = [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
], Ap = r("Divide", WU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XU = [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
], Ip = r("DnaOff", XU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YU = [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
], Tp = r("Dna", YU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KU = [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
], Np = r("Dock", KU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZU = [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
], Cp = r("Dog", ZU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QU = [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
], wp = r("DollarSign", QU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JU = [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Sp = r("Donut", JU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eq = [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
], Rp = r("DoorClosed", eq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tq = [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
], Dp = r("DoorOpen", tq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nq = [["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]], Op = r("Dot", nq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aq = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
], Pp = r("Download", aq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oq = [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
], Hp = r("DraftingCompass", oq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rq = [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
], Bp = r("Drama", rq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iq = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
], Fp = r("Dribbble", iq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cq = [
  [
    "path",
    { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z", key: "ioqxb1" }
  ],
  [
    "path",
    {
      d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
      key: "1rs59n"
    }
  ],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }]
], $p = r("Drill", cq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sq = [
  [
    "path",
    {
      d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
      key: "8suz2t"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208", key: "19dw9m" }
  ]
], Up = r("DropletOff", sq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lq = [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
], qp = r("Droplet", lq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dq = [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
], zp = r("Droplets", dq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uq = [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
], jp = r("Drum", uq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hq = [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
], Vp = r("Drumstick", hq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pq = [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
], Gp = r("Dumbbell", pq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yq = [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Wp = r("EarOff", yq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kq = [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
], Xp = r("Ear", kq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fq = [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], Yp = r("EarthLock", fq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mq = [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], bo = r("Earth", mq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gq = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
], Kp = r("Eclipse", gq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mq = [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
], Zp = r("EggFried", Mq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _q = [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Qp = r("EggOff", _q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bq = [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
], Jp = r("Egg", bq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lq = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Lo = r("EllipsisVertical", Lq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xq = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], xo = r("Ellipsis", xq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eq = [
  ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "yrdkhy" }],
  ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "gzkvyz" }]
], ey = r("EqualApproximately", Eq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vq = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
], ty = r("EqualNot", vq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aq = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
], ny = r("Equal", Aq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iq = [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
], ay = r("Eraser", Iq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tq = [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
], oy = r("EthernetPort", Tq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nq = [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
], ry = r("Euro", Nq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cq = [
  ["path", { d: "m15 15 6 6", key: "1s409w" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ["path", { d: "M21 16.2V21h-4.8", key: "1hrera" }],
  ["path", { d: "M21 7.8V3h-4.8", key: "ul1q53" }],
  ["path", { d: "M3 16.2V21h4.8", key: "1x04uo" }],
  ["path", { d: "m3 21 6-6", key: "wwnumi" }],
  ["path", { d: "M3 7.8V3h4.8", key: "1ijppm" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }]
], iy = r("Expand", Cq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wq = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], cy = r("ExternalLink", wq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sq = [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
], sy = r("EyeClosed", Sq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rq = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], ly = r("EyeOff", Rq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dq = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], dy = r("Eye", Dq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oq = [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
], uy = r("Facebook", Oq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pq = [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
], hy = r("Factory", Pq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hq = [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
], py = r("Fan", Hq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bq = [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
], yy = r("FastForward", Bq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fq = [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
], ky = r("Feather", Fq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $q = [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
], fy = r("Fence", $q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uq = [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
], my = r("FerrisWheel", Uq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qq = [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
], gy = r("Figma", qq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zq = [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
], My = r("FileArchive", zq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jq = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
], _y = r("FileAudio2", jq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vq = [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
], by = r("FileAudio", Vq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gq = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
], Eo = r("FileAxis3d", Gq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wq = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
], Ly = r("FileBadge2", Wq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xq = [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
], xy = r("FileBadge", Xq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yq = [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
], Ey = r("FileBox", Yq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kq = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
], vo = r("FileChartColumnIncreasing", Kq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zq = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
], Ao = r("FileChartColumn", Zq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qq = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
], Io = r("FileChartLine", Qq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jq = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
], To = r("FileChartPie", Jq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ez = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
], vy = r("FileCheck2", ez);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
], Ay = r("FileCheck", tz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nz = [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
], Iy = r("FileClock", nz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const az = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], Ty = r("FileCode2", az);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oz = [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
], Ny = r("FileCode", oz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rz = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
], No = r("FileCog", rz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], Cy = r("FileDiff", iz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], wy = r("FileDigit", cz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
], Sy = r("FileDown", sz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
], Ry = r("FileHeart", lz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
], Dy = r("FileImage", dz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], Oy = r("FileInput", uz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
], Py = r("FileJson2", hz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
], Hy = r("FileJson", pz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
], By = r("FileKey2", yz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
], Fy = r("FileKey", kz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
], $y = r("FileLock2", fz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
], Uy = r("FileLock", mz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
], qy = r("FileMinus2", gz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], zy = r("FileMinus", Mz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _z = [
  ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4", key: "1d3kfm" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }]
], jy = r("FileMusic", _z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bz = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
], Vy = r("FileOutput", bz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lz = [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
], Co = r("FilePenLine", Lz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xz = [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], wo = r("FilePen", xz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ez = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
], Gy = r("FilePlus2", Ez);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
], Wy = r("FilePlus", vz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Az = [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
], Xy = r("FileQuestion", Az);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iz = [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
], Yy = r("FileScan", Iz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
], Ky = r("FileSearch2", Tz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nz = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
], Zy = r("FileSearch", Nz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
], Qy = r("FileSliders", Cz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
], Jy = r("FileSpreadsheet", wz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sz = [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
], ek = r("FileStack", Sz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rz = [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
], tk = r("FileSymlink", Rz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
], nk = r("FileTerminal", Dz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], ak = r("FileText", Oz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
], ok = r("FileType2", Pz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
], rk = r("FileType", Hz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
], ik = r("FileUp", Bz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fz = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], ck = r("FileUser", Fz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $z = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
], sk = r("FileVideo2", $z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
], lk = r("FileVideo", Uz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
], dk = r("FileVolume2", qz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zz = [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
], uk = r("FileVolume", zz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], hk = r("FileWarning", jz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
], pk = r("FileX2", Vz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
], yk = r("FileX", Gz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
], kk = r("File", Wz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xz = [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
], fk = r("Files", Xz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yz = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
], mk = r("Film", Yz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kz = [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], gk = r("FilterX", Kz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zz = [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
], Mk = r("Filter", Zz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qz = [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
], _k = r("Fingerprint", Qz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jz = [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
], bk = r("FireExtinguisher", Jz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ej = [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
], Lk = r("FishOff", ej);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tj = [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
], xk = r("FishSymbol", tj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nj = [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
], Ek = r("Fish", nj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aj = [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], vk = r("FlagOff", aj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oj = [["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]], Ak = r("FlagTriangleLeft", oj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rj = [["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]], Ik = r("FlagTriangleRight", rj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ij = [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
], Tk = r("Flag", ij);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cj = [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
], Nk = r("FlameKindling", cj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sj = [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
], Ck = r("Flame", sj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lj = [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], wk = r("FlashlightOff", lj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dj = [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
], Sk = r("Flashlight", dj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uj = [
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563", key: "k0duyd" }],
  ["path", { d: "M6.453 15H15", key: "1f0z33" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], Rk = r("FlaskConicalOff", uj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hj = [
  [
    "path",
    {
      d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
      key: "18mbvz"
    }
  ],
  ["path", { d: "M6.453 15h11.094", key: "3shlmq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], Dk = r("FlaskConical", hj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pj = [
  ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2", key: "1s42pc" }],
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], Ok = r("FlaskRound", pj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yj = [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], Pk = r("FlipHorizontal2", yj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kj = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], Hk = r("FlipHorizontal", kj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fj = [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], Bk = r("FlipVertical2", fj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mj = [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], Fk = r("FlipVertical", mj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gj = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
], $k = r("Flower2", gj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mj = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
], Uk = r("Flower", Mj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _j = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], qk = r("Focus", _j);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bj = [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
], zk = r("FoldHorizontal", bj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lj = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
], jk = r("FoldVertical", Lj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xj = [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
], Vk = r("FolderArchive", xj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ej = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], Gk = r("FolderCheck", Ej);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vj = [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
], Wk = r("FolderClock", vj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aj = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], Xk = r("FolderClosed", Aj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ij = [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
], Yk = r("FolderCode", Ij);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tj = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
], So = r("FolderCog", Tj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nj = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
], Kk = r("FolderDot", Nj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cj = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
], Zk = r("FolderDown", Cj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wj = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
], Qk = r("FolderGit2", wj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sj = [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
], Jk = r("FolderGit", Sj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rj = [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
], e4 = r("FolderHeart", Rj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dj = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
], t4 = r("FolderInput", Dj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oj = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
], n4 = r("FolderKanban", Oj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pj = [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
], a4 = r("FolderKey", Pj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hj = [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
], o4 = r("FolderLock", Hj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bj = [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], r4 = r("FolderMinus", Bj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fj = [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
], i4 = r("FolderOpenDot", Fj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $j = [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
], c4 = r("FolderOpen", $j);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uj = [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
], s4 = r("FolderOutput", Uj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qj = [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
], Ro = r("FolderPen", qj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zj = [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], l4 = r("FolderPlus", zj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jj = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
], d4 = r("FolderRoot", jj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vj = [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
], u4 = r("FolderSearch2", Vj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gj = [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
], h4 = r("FolderSearch", Gj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wj = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
], p4 = r("FolderSymlink", Wj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xj = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
], y4 = r("FolderSync", Xj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yj = [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
], k4 = r("FolderTree", Yj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kj = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
], f4 = r("FolderUp", Kj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zj = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
], m4 = r("FolderX", Zj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qj = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], g4 = r("Folder", Qj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jj = [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
], M4 = r("Folders", Jj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eV = [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
], _4 = r("Footprints", eV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tV = [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
], b4 = r("Forklift", tV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nV = [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
], L4 = r("Forward", nV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aV = [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
], x4 = r("Frame", aV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oV = [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
], E4 = r("Framer", oV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rV = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], v4 = r("Frown", rV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iV = [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
], A4 = r("Fuel", iV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cV = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
], I4 = r("Fullscreen", cV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sV = [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
], T4 = r("GalleryHorizontalEnd", sV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lV = [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
], N4 = r("GalleryHorizontal", lV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dV = [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
], C4 = r("GalleryThumbnails", dV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uV = [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
], w4 = r("GalleryVerticalEnd", uV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hV = [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
], S4 = r("GalleryVertical", hV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pV = [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
], R4 = r("Gamepad2", pV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yV = [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], D4 = r("Gamepad", yV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kV = [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
], O4 = r("Gauge", kV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fV = [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
], P4 = r("Gavel", fV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mV = [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
], H4 = r("Gem", mV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gV = [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
], B4 = r("Ghost", gV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MV = [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
], F4 = r("Gift", MV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _V = [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], $4 = r("GitBranchPlus", _V);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bV = [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
], U4 = r("GitBranch", bV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LV = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
], Do = r("GitCommitHorizontal", LV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xV = [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
], q4 = r("GitCommitVertical", xV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EV = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
], z4 = r("GitCompareArrows", EV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vV = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
], j4 = r("GitCompare", vV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AV = [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
], V4 = r("GitFork", AV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IV = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
], G4 = r("GitGraph", IV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TV = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
], W4 = r("GitMerge", TV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NV = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
], X4 = r("GitPullRequestArrow", NV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CV = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], Y4 = r("GitPullRequestClosed", CV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wV = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
], K4 = r("GitPullRequestCreateArrow", wV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SV = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], Z4 = r("GitPullRequestCreate", SV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RV = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], Q4 = r("GitPullRequestDraft", RV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DV = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], J4 = r("GitPullRequest", DV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OV = [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
], ef = r("Github", OV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PV = [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
], tf = r("Gitlab", PV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HV = [
  [
    "path",
    {
      d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
      key: "p55z4y"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
], nf = r("GlassWater", HV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BV = [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
], af = r("Glasses", BV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FV = [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], of = r("GlobeLock", FV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $V = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], rf = r("Globe", $V);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UV = [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
], cf = r("Goal", UV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qV = [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
], sf = r("Grab", qV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zV = [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
], lf = r("GraduationCap", zV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jV = [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
], df = r("Grape", jV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VV = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], Oo = r("Grid2x2Check", VV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GV = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
], Po = r("Grid2x2Plus", GV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WV = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
], Ho = r("Grid2x2X", WV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XV = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], Bo = r("Grid2x2", XV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YV = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], un = r("Grid3x3", YV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KV = [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
], uf = r("GripHorizontal", KV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZV = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], hf = r("GripVertical", ZV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QV = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], pf = r("Grip", QV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JV = [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
], yf = r("Group", JV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eG = [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
], kf = r("Guitar", eG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tG = [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
], ff = r("Ham", tG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nG = [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
], mf = r("Hammer", nG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aG = [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
], gf = r("HandCoins", aG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oG = [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
], Mf = r("HandHeart", oG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rG = [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
], Fo = r("HandHelping", rG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iG = [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
], _f = r("HandMetal", iG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cG = [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
      key: "n2g93r"
    }
  ],
  ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2", key: "1o2jem" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M5 10a7 7 0 0 1 14 0", key: "1ega1o" }],
  ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2", key: "1hescx" }]
], bf = r("HandPlatter", cG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sG = [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
], Lf = r("Hand", sG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lG = [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
], xf = r("Handshake", lG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dG = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], Ef = r("HardDriveDownload", dG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uG = [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], vf = r("HardDriveUpload", uG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hG = [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
], Af = r("HardDrive", hG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pG = [
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1", key: "g3x8cw" }]
], If = r("HardHat", pG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yG = [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
], Tf = r("Hash", yG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kG = [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
], Nf = r("Haze", kG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fG = [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
], Cf = r("HdmiPort", fG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mG = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
], wf = r("Heading1", mG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gG = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
], Sf = r("Heading2", gG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MG = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
], Rf = r("Heading3", MG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _G = [
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3", key: "tj5zdr" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }],
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }]
], Df = r("Heading4", _G);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bG = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
], Of = r("Heading5", bG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LG = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
], Pf = r("Heading6", LG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xG = [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
], Hf = r("Heading", xG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EG = [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
], Bf = r("HeadphoneOff", EG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vG = [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
], Ff = r("Headphones", vG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AG = [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
], $f = r("Headset", AG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IG = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
], Uf = r("HeartCrack", IG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TG = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
], qf = r("HeartHandshake", TG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NG = [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
], zf = r("HeartOff", NG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CG = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
], jf = r("HeartPulse", CG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wG = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
], Vf = r("Heart", wG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SG = [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
], Gf = r("Heater", SG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RG = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
], Wf = r("Hexagon", RG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DG = [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
], Xf = r("Highlighter", DG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OG = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], Yf = r("History", OG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PG = [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Kf = r("HopOff", PG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HG = [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
], Zf = r("Hop", HG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BG = [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
], Qf = r("Hospital", BG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FG = [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
], Jf = r("Hotel", FG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $G = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
], e3 = r("Hourglass", $G);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UG = [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
], t3 = r("HousePlug", UG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qG = [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
], n3 = r("HousePlus", qG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zG = [
  ["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01", key: "1wy54i" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ],
  ["path", { d: "M7 10.754a8 8 0 0 1 10 0", key: "exoy2g" }]
], a3 = r("HouseWifi", zG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jG = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
], $o = r("House", jG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VG = [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
], Uo = r("IceCreamBowl", VG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GG = [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
], qo = r("IceCreamCone", GG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WG = [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
], o3 = r("IdCard", WG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XG = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], r3 = r("ImageDown", XG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YG = [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], i3 = r("ImageMinus", YG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KG = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
], c3 = r("ImageOff", KG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZG = [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], s3 = r("ImagePlay", ZG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QG = [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], l3 = r("ImagePlus", QG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JG = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], d3 = r("ImageUp", JG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eW = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M17 21h2a2 2 0 0 0 2-2", key: "130fy9" }],
  ["path", { d: "M21 12v3", key: "1wzk3p" }],
  ["path", { d: "m21 3-5 5", key: "1g5oa7" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2", key: "kk3yz1" }],
  ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19", key: "fyekpt" }],
  ["path", { d: "M9 3h3", key: "d52fa" }],
  ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1", key: "1wpmix" }]
], u3 = r("ImageUpscale", eW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tW = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], h3 = r("Image", tW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nW = [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
], p3 = r("Images", nW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aW = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
], y3 = r("Import", aW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oW = [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
], k3 = r("Inbox", oW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rW = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
], zo = r("IndentDecrease", rW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iW = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
], jo = r("IndentIncrease", iW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cW = [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
], f3 = r("IndianRupee", cW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sW = [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
], m3 = r("Infinity", sW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lW = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], g3 = r("Info", lW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dW = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
], M3 = r("InspectionPanel", dW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uW = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
], _3 = r("Instagram", uW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hW = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
], b3 = r("Italic", hW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pW = [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
], L3 = r("IterationCcw", pW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yW = [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
], x3 = r("IterationCw", yW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kW = [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
], E3 = r("JapaneseYen", kW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fW = [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
], v3 = r("Joystick", fW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mW = [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
], A3 = r("Kanban", mW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gW = [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
], I3 = r("KeyRound", gW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MW = [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
], T3 = r("KeySquare", MW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _W = [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
], N3 = r("Key", _W);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bW = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
], C3 = r("KeyboardMusic", bW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LW = [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
], w3 = r("KeyboardOff", LW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xW = [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
], S3 = r("Keyboard", xW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EW = [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
], R3 = r("LampCeiling", EW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vW = [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
], D3 = r("LampDesk", vW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AW = [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
], O3 = r("LampFloor", AW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IW = [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
], P3 = r("LampWallDown", IW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TW = [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
], H3 = r("LampWallUp", TW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NW = [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
], B3 = r("Lamp", NW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CW = [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
], F3 = r("LandPlot", CW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wW = [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
], $3 = r("Landmark", wW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SW = [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
], U3 = r("Languages", SW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RW = [
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2", key: "8ur36m" }]
], q3 = r("LaptopMinimalCheck", RW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DW = [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
], Vo = r("LaptopMinimal", DW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OW = [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
], z3 = r("Laptop", OW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PW = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
], j3 = r("LassoSelect", PW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HW = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
], V3 = r("Lasso", HW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BW = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], G3 = r("Laugh", BW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FW = [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
], W3 = r("Layers2", FW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $W = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], Go = r("Layers", $W);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UW = [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
], X3 = r("LayoutDashboard", UW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qW = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
], Y3 = r("LayoutGrid", qW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zW = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
], K3 = r("LayoutList", zW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jW = [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], Z3 = r("LayoutPanelLeft", jW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VW = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], Q3 = r("LayoutPanelTop", VW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GW = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
], J3 = r("LayoutTemplate", GW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WW = [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
], e5 = r("Leaf", WW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XW = [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
], t5 = r("LeafyGreen", XW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YW = [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
], n5 = r("Lectern", YW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KW = [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
], a5 = r("LetterText", KW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZW = [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
], o5 = r("LibraryBig", ZW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QW = [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
], r5 = r("Library", QW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JW = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], i5 = r("LifeBuoy", JW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eX = [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
], c5 = r("Ligature", eX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tX = [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], s5 = r("LightbulbOff", tX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nX = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], l5 = r("Lightbulb", nX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aX = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], d5 = r("Link2Off", aX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oX = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], u5 = r("Link2", oX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rX = [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
], h5 = r("Link", rX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iX = [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
], p5 = r("Linkedin", iX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cX = [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
], y5 = r("ListCheck", cX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sX = [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], k5 = r("ListChecks", sX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lX = [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
], f5 = r("ListCollapse", lX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dX = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
], m5 = r("ListEnd", dX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uX = [
  ["path", { d: "M10 18h4", key: "1ulq68" }],
  ["path", { d: "M11 6H3", key: "1u26ik" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 9V3", key: "xwwp7m" }],
  ["path", { d: "M7 12h8", key: "7a1bxv" }]
], g5 = r("ListFilterPlus", uX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hX = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], M5 = r("ListFilter", hX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pX = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], _5 = r("ListMinus", pX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yX = [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
], b5 = r("ListMusic", yX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kX = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], L5 = r("ListOrdered", kX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fX = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], x5 = r("ListPlus", fX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mX = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
], E5 = r("ListRestart", mX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gX = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
], v5 = r("ListStart", gX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MX = [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], A5 = r("ListTodo", MX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _X = [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
], I5 = r("ListTree", _X);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bX = [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
], T5 = r("ListVideo", bX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LX = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
], N5 = r("ListX", LX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xX = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], C5 = r("List", xX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EX = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], Wo = r("LoaderCircle", EX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vX = [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], w5 = r("LoaderPinwheel", vX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AX = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], S5 = r("Loader", AX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IX = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], R5 = r("LocateFixed", IX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TX = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], D5 = r("LocateOff", TX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NX = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
], O5 = r("Locate", NX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CX = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
], Xo = r("LockKeyholeOpen", CX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wX = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
], P5 = r("LockKeyhole", wX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SX = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
], Yo = r("LockOpen", SX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RX = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], H5 = r("Lock", RX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DX = [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
], B5 = r("LogIn", DX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OX = [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
], F5 = r("LogOut", OX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PX = [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
], $5 = r("Logs", PX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HX = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
], U5 = r("Lollipop", HX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BX = [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
], q5 = r("Luggage", BX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FX = [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
], z5 = r("Magnet", FX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $X = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], j5 = r("MailCheck", $X);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UX = [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], V5 = r("MailMinus", UX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qX = [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
], G5 = r("MailOpen", qX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zX = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], W5 = r("MailPlus", zX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jX = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], X5 = r("MailQuestion", jX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VX = [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
], Y5 = r("MailSearch", VX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GX = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], K5 = r("MailWarning", GX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WX = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
], Z5 = r("MailX", WX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XX = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
], Q5 = r("Mail", XX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YX = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
], J5 = r("Mailbox", YX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KX = [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
], em = r("Mails", KX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZX = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], tm = r("MapPinCheckInside", ZX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QX = [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
], nm = r("MapPinCheck", QX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JX = [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
], am = r("MapPinHouse", JX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eY = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], om = r("MapPinMinusInside", eY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tY = [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
], rm = r("MapPinMinus", tY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nY = [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
], im = r("MapPinOff", nY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aY = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], cm = r("MapPinPlusInside", aY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oY = [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
], sm = r("MapPinPlus", oY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rY = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], lm = r("MapPinXInside", rY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iY = [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
], dm = r("MapPinX", iY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cY = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], um = r("MapPin", cY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sY = [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
], hm = r("MapPinned", sY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lY = [
  [
    "path",
    {
      d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
      key: "svfegj"
    }
  ],
  ["path", { d: "M15 5.764V12", key: "1ocw4k" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], pm = r("MapPlus", lY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dY = [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], ym = r("Map", dY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uY = [
  ["path", { d: "m14 6 4 4", key: "1q72g9" }],
  ["path", { d: "M17 3h4v4", key: "19p9u1" }],
  ["path", { d: "m21 3-7.75 7.75", key: "1cjbfd" }],
  ["circle", { cx: "9", cy: "15", r: "6", key: "bx5svt" }]
], km = r("MarsStroke", uY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hY = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m21 3-6.75 6.75", key: "pv0uzu" }],
  ["circle", { cx: "10", cy: "14", r: "6", key: "1qwbdc" }]
], fm = r("Mars", hY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pY = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
], mm = r("Martini", pY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yY = [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], gm = r("Maximize2", yY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kY = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
], Mm = r("Maximize", kY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fY = [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
], _m = r("Medal", fY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mY = [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], bm = r("MegaphoneOff", mY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gY = [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
], Lm = r("Megaphone", gY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MY = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], xm = r("Meh", MY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Y = [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
], Em = r("MemoryStick", _Y);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bY = [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
], vm = r("Menu", bY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LY = [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
], Am = r("Merge", LY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xY = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
], Im = r("MessageCircleCode", xY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EY = [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
], Tm = r("MessageCircleDashed", EY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
], Nm = r("MessageCircleHeart", vY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], Cm = r("MessageCircleMore", AY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IY = [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
], wm = r("MessageCircleOff", IY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], Sm = r("MessageCirclePlus", TY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Rm = r("MessageCircleQuestion", NY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
], Dm = r("MessageCircleReply", CY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], Om = r("MessageCircleWarning", wY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Pm = r("MessageCircleX", SY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RY = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
], Hm = r("MessageCircle", RY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DY = [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], Bm = r("MessageSquareCode", DY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OY = [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
], Fm = r("MessageSquareDashed", OY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PY = [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], $m = r("MessageSquareDiff", PY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HY = [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], Um = r("MessageSquareDot", HY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
], qm = r("MessageSquareHeart", BY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FY = [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
], zm = r("MessageSquareLock", FY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Y = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
], jm = r("MessageSquareMore", $Y);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UY = [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
], Vm = r("MessageSquareOff", UY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], Gm = r("MessageSquarePlus", qY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
], Wm = r("MessageSquareQuote", zY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
], Xm = r("MessageSquareReply", jY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VY = [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
], Ym = r("MessageSquareShare", VY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
], Km = r("MessageSquareText", GY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
], Zm = r("MessageSquareWarning", WY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], Qm = r("MessageSquareX", XY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YY = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], Jm = r("MessageSquare", YY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KY = [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
], e6 = r("MessagesSquare", KY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZY = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], t6 = r("MicOff", ZY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QY = [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
], Ko = r("MicVocal", QY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JY = [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], n6 = r("Mic", JY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eK = [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
], a6 = r("Microchip", eK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tK = [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
], o6 = r("Microscope", tK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nK = [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
], r6 = r("Microwave", nK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aK = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
], i6 = r("Milestone", aK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oK = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], c6 = r("MilkOff", oK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rK = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
], s6 = r("Milk", rK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iK = [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], l6 = r("Minimize2", iK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cK = [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
], d6 = r("Minimize", cK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sK = [["path", { d: "M5 12h14", key: "1ays0h" }]], u6 = r("Minus", sK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lK = [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], h6 = r("MonitorCheck", lK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dK = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], p6 = r("MonitorCog", dK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uK = [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], y6 = r("MonitorDot", uK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hK = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], k6 = r("MonitorDown", hK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pK = [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], f6 = r("MonitorOff", pK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yK = [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], m6 = r("MonitorPause", yK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kK = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
], g6 = r("MonitorPlay", kK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fK = [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
], M6 = r("MonitorSmartphone", fK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mK = [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
], _6 = r("MonitorSpeaker", mK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gK = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
], b6 = r("MonitorStop", gK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MK = [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], L6 = r("MonitorUp", MK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _K = [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], x6 = r("MonitorX", _K);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bK = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], E6 = r("Monitor", bK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LK = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
], v6 = r("MoonStar", LK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xK = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
], A6 = r("Moon", xK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EK = [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
], I6 = r("MountainSnow", EK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vK = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]], T6 = r("Mountain", vK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AK = [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], N6 = r("MouseOff", AK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IK = [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
], C6 = r("MousePointer2", IK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TK = [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
], w6 = r("MousePointerBan", TK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NK = [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
], S6 = r("MousePointerClick", NK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CK = [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
], R6 = r("MousePointer", CK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wK = [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
], D6 = r("Mouse", wK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SK = [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
], Zo = r("Move3d", SK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RK = [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
], O6 = r("MoveDiagonal2", RK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DK = [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
], P6 = r("MoveDiagonal", DK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OK = [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], H6 = r("MoveDownLeft", OK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PK = [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], B6 = r("MoveDownRight", PK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HK = [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], F6 = r("MoveDown", HK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BK = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
], $6 = r("MoveHorizontal", BK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FK = [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], U6 = r("MoveLeft", FK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $K = [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], q6 = r("MoveRight", $K);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UK = [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], z6 = r("MoveUpLeft", UK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qK = [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], j6 = r("MoveUpRight", qK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zK = [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], V6 = r("MoveUp", zK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jK = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
], G6 = r("MoveVertical", jK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VK = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], W6 = r("Move", VK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GK = [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
], X6 = r("Music2", GK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WK = [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
], Y6 = r("Music3", WK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XK = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], K6 = r("Music4", XK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YK = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], Z6 = r("Music", YK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KK = [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Q6 = r("Navigation2Off", KK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZK = [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
], J6 = r("Navigation2", ZK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QK = [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], eg = r("NavigationOff", QK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JK = [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
], tg = r("Navigation", JK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eZ = [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
], ng = r("Network", eZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tZ = [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
], ag = r("Newspaper", tZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nZ = [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
], og = r("Nfc", nZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aZ = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "m9 4 6 4", key: "t8piew" }],
  ["path", { d: "m9 8 6-4", key: "sndyih" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }]
], rg = r("NonBinary", aZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oZ = [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
], ig = r("NotebookPen", oZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rZ = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
], cg = r("NotebookTabs", rZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iZ = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
], sg = r("NotebookText", iZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cZ = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
], lg = r("Notebook", cZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sZ = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], dg = r("NotepadTextDashed", sZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lZ = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], ug = r("NotepadText", lZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dZ = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], hg = r("NutOff", dZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uZ = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
], pg = r("Nut", uZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hZ = [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
], Qo = r("OctagonAlert", hZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pZ = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], yg = r("OctagonMinus", pZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yZ = [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], Jo = r("OctagonPause", yZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kZ = [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], er = r("OctagonX", kZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fZ = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], kg = r("Octagon", fZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mZ = [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
], fg = r("Omega", mZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gZ = [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
], mg = r("Option", gZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MZ = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
], gg = r("Orbit", MZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Z = [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
], Mg = r("Origami", _Z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bZ = [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
], _g = r("Package2", bZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LZ = [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], bg = r("PackageCheck", LZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xZ = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], Lg = r("PackageMinus", xZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EZ = [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
], xg = r("PackageOpen", EZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vZ = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], Eg = r("PackagePlus", vZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AZ = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
], vg = r("PackageSearch", AZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IZ = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
], Ag = r("PackageX", IZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TZ = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
], Ig = r("Package", TZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NZ = [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
], Tg = r("PaintBucket", NZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CZ = [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
], Ng = r("PaintRoller", CZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wZ = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
], tr = r("PaintbrushVertical", wZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SZ = [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
], Cg = r("Paintbrush", SZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RZ = [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
], wg = r("Palette", RZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
], Sg = r("PanelBottomClose", DZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
], nr = r("PanelBottomDashed", OZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], Rg = r("PanelBottomOpen", PZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], Dg = r("PanelBottom", HZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], ar = r("PanelLeftClose", BZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
], or = r("PanelLeftDashed", FZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Z = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
], rr = r("PanelLeftOpen", $Z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], ir = r("PanelLeft", UZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
], Og = r("PanelRightClose", qZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
], cr = r("PanelRightDashed", zZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
], Pg = r("PanelRightOpen", jZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], Hg = r("PanelRight", VZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
], Bg = r("PanelTopClose", GZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
], sr = r("PanelTopDashed", WZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
], Fg = r("PanelTopOpen", XZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
], $g = r("PanelTop", YZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
], Ug = r("PanelsLeftBottom", KZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], qg = r("PanelsRightBottom", ZZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QZ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
], lr = r("PanelsTopLeft", QZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JZ = [
  ["path", { d: "M13.234 20.252 21 12.3", key: "1cbrk9" }],
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
      key: "1pkts6"
    }
  ]
], zg = r("Paperclip", JZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eQ = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
], jg = r("Parentheses", eQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tQ = [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
], Vg = r("ParkingMeter", tQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nQ = [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
], Gg = r("PartyPopper", nQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aQ = [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
], Wg = r("Pause", aQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oQ = [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
], Xg = r("PawPrint", oQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rQ = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], Yg = r("PcCase", rQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iQ = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
], dr = r("PenLine", iQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cQ = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Kg = r("PenOff", cQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sQ = [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
], Zg = r("PenTool", sQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lQ = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], ur = r("Pen", lQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dQ = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
], Qg = r("PencilLine", dQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uQ = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Jg = r("PencilOff", uQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hQ = [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], e8 = r("PencilRuler", hQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pQ = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], t8 = r("Pencil", pQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yQ = [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
], n8 = r("Pentagon", yQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kQ = [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
], a8 = r("Percent", kQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fQ = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
], o8 = r("PersonStanding", fQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mQ = [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
], r8 = r("PhilippinePeso", mQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gQ = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
], i8 = r("PhoneCall", gQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MQ = [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], c8 = r("PhoneForwarded", MQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Q = [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], s8 = r("PhoneIncoming", _Q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bQ = [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], l8 = r("PhoneMissed", bQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LQ = [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
], d8 = r("PhoneOff", LQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xQ = [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], u8 = r("PhoneOutgoing", xQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EQ = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], h8 = r("Phone", EQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vQ = [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
], p8 = r("Pi", vQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AQ = [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
], y8 = r("Piano", AQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IQ = [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
], k8 = r("Pickaxe", IQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TQ = [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
], f8 = r("PictureInPicture2", TQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NQ = [
  ["path", { d: "M2 10h6V4", key: "zwrco" }],
  ["path", { d: "m2 4 6 6", key: "ug085t" }],
  ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7", key: "git5jr" }],
  ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3", key: "1f7fh3" }],
  ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1", key: "1wjs3o" }]
], m8 = r("PictureInPicture", NQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CQ = [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
], g8 = r("PiggyBank", CQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wQ = [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
], M8 = r("PilcrowLeft", wQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SQ = [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
], _8 = r("PilcrowRight", SQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RQ = [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
], b8 = r("Pilcrow", RQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DQ = [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
], L8 = r("PillBottle", DQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OQ = [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
], x8 = r("Pill", OQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PQ = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
], E8 = r("PinOff", PQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HQ = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
], v8 = r("Pin", HQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BQ = [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
], A8 = r("Pipette", BQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FQ = [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
], I8 = r("Pizza", FQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Q = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
], T8 = r("PlaneLanding", $Q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UQ = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
], N8 = r("PlaneTakeoff", UQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qQ = [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
], C8 = r("Plane", qQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zQ = [["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]], w8 = r("Play", zQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jQ = [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
], S8 = r("Plug2", jQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VQ = [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
], hr = r("PlugZap", VQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GQ = [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
], R8 = r("Plug", GQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WQ = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], D8 = r("Plus", WQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XQ = [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
], O8 = r("PocketKnife", XQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YQ = [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
], P8 = r("Pocket", YQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KQ = [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
], H8 = r("Podcast", KQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZQ = [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], B8 = r("PointerOff", ZQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QQ = [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
], F8 = r("Pointer", QQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JQ = [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
], $8 = r("Popcorn", JQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eJ = [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
], U8 = r("Popsicle", eJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tJ = [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
], q8 = r("PoundSterling", tJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nJ = [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], z8 = r("PowerOff", nJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aJ = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
], j8 = r("Power", aJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oJ = [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
], V8 = r("Presentation", oJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rJ = [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
], G8 = r("PrinterCheck", rJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iJ = [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
], W8 = r("Printer", iJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cJ = [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
], X8 = r("Projector", cJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sJ = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
], Y8 = r("Proportions", sJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lJ = [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
], K8 = r("Puzzle", lJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dJ = [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], Z8 = r("Pyramid", dJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uJ = [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
], Q8 = r("QrCode", uJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hJ = [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
], J8 = r("Quote", hJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pJ = [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
], eM = r("Rabbit", pJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yJ = [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
], tM = r("Radar", yJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kJ = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
], nM = r("Radiation", kJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fJ = [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
], aM = r("Radical", fJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mJ = [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], oM = r("RadioReceiver", mJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gJ = [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
], rM = r("RadioTower", gJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MJ = [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
], iM = r("Radio", MJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _J = [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], cM = r("Radius", _J);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bJ = [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
], sM = r("RailSymbol", bJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LJ = [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
], lM = r("Rainbow", LJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xJ = [
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M13.236 18a3 3 0 0 0-2.2-5", key: "1tbvmo" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }],
  [
    "path",
    {
      d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
      key: "9ch7kn"
    }
  ],
  ["path", { d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18", key: "3s7e9i" }]
], dM = r("Rat", xJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EJ = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], uM = r("Ratio", EJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], hM = r("ReceiptCent", vJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
], pM = r("ReceiptEuro", AJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
], yM = r("ReceiptIndianRupee", IJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], kM = r("ReceiptJapaneseYen", TJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
], fM = r("ReceiptPoundSterling", NJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
], mM = r("ReceiptRussianRuble", CJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
], gM = r("ReceiptSwissFranc", wJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
], MM = r("ReceiptText", SJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RJ = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
], _M = r("Receipt", RJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DJ = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], pr = r("RectangleEllipsis", DJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OJ = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], bM = r("RectangleHorizontal", OJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PJ = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
], LM = r("RectangleVertical", PJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HJ = [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
], xM = r("Recycle", HJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BJ = [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
], EM = r("Redo2", BJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FJ = [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], vM = r("RedoDot", FJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $J = [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], AM = r("Redo", $J);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UJ = [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], IM = r("RefreshCcwDot", UJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qJ = [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
], TM = r("RefreshCcw", qJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zJ = [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], NM = r("RefreshCwOff", zJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jJ = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], CM = r("RefreshCw", jJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VJ = [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
], wM = r("Refrigerator", VJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GJ = [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
], SM = r("Regex", GJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WJ = [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
], RM = r("RemoveFormatting", WJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XJ = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
], DM = r("Repeat1", XJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YJ = [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
], OM = r("Repeat2", YJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KJ = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
], PM = r("Repeat", KJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZJ = [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], HM = r("ReplaceAll", ZJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QJ = [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], BM = r("Replace", QJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JJ = [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
], FM = r("ReplyAll", JJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eee = [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
], $M = r("Reply", eee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tee = [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
], UM = r("Rewind", tee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nee = [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
], qM = r("Ribbon", nee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aee = [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
], zM = r("Rocket", aee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oee = [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
], jM = r("RockingChair", oee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ree = [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
], VM = r("RollerCoaster", ree);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iee = [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
], yr = r("Rotate3d", iee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cee = [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
], GM = r("RotateCcwSquare", cee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const see = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], WM = r("RotateCcw", see);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lee = [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
], XM = r("RotateCwSquare", lee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dee = [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
], YM = r("RotateCw", dee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uee = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], KM = r("RouteOff", uee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hee = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], ZM = r("Route", hee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pee = [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
], QM = r("Router", pee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yee = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
], kr = r("Rows2", yee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kee = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], fr = r("Rows3", kee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fee = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
], JM = r("Rows4", fee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mee = [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], e_ = r("Rss", mee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gee = [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
], t_ = r("Ruler", gee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mee = [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
], n_ = r("RussianRuble", Mee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ee = [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
], a_ = r("Sailboat", _ee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bee = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
], o_ = r("Salad", bee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lee = [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
], r_ = r("Sandwich", Lee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xee = [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
], i_ = r("SatelliteDish", xee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eee = [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
], c_ = r("Satellite", Eee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vee = [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
], s_ = r("SaveAll", vee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aee = [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
], l_ = r("SaveOff", Aee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iee = [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
], d_ = r("Save", Iee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tee = [
  ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11", key: "13dt1j" }],
  ["path", { d: "M5.293 18.707 11 13", key: "ezgbsx" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }]
], mr = r("Scale3d", Tee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nee = [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
], u_ = r("Scale", Nee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cee = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
], h_ = r("Scaling", Cee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wee = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
], p_ = r("ScanBarcode", wee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const See = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], y_ = r("ScanEye", See);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ree = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
], k_ = r("ScanFace", Ree);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dee = [
  [
    "path",
    {
      d: "M11.246 16.657a1 1 0 0 0 1.508 0l3.57-4.101A2.75 2.75 0 1 0 12 9.168a2.75 2.75 0 1 0-4.324 3.388z",
      key: "1algrk"
    }
  ],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], f_ = r("ScanHeart", Dee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oee = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
], m_ = r("ScanLine", Oee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pee = [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
], g_ = r("ScanQrCode", Pee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hee = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
], M_ = r("ScanSearch", Hee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bee = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
], __ = r("ScanText", Bee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fee = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], b_ = r("Scan", Fee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ee = [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  [
    "path",
    {
      d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10",
      key: "1xqip1"
    }
  ],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6", key: "9d2mlk" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
], L_ = r("School", $ee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uee = [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], x_ = r("ScissorsLineDashed", Uee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qee = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
], E_ = r("Scissors", qee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zee = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], v_ = r("ScreenShareOff", zee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jee = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
], A_ = r("ScreenShare", jee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vee = [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], I_ = r("ScrollText", Vee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gee = [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], T_ = r("Scroll", Gee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wee = [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], N_ = r("SearchCheck", Wee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xee = [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], C_ = r("SearchCode", Xee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yee = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], w_ = r("SearchSlash", Yee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kee = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], S_ = r("SearchX", Kee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zee = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], R_ = r("Search", Zee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qee = [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
], D_ = r("Section", Qee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jee = [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
], gr = r("SendHorizontal", Jee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ete = [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
], O_ = r("SendToBack", ete);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tte = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], P_ = r("Send", tte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nte = [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
], H_ = r("SeparatorHorizontal", nte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ate = [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
], B_ = r("SeparatorVertical", ate);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ote = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
], F_ = r("ServerCog", ote);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rte = [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
], $_ = r("ServerCrash", rte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ite = [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], U_ = r("ServerOff", ite);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cte = [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
], q_ = r("Server", cte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ste = [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
], z_ = r("Settings2", ste);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lte = [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], j_ = r("Settings", lte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dte = [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
], V_ = r("Shapes", dte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ute = [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
], G_ = r("Share2", ute);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hte = [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
], W_ = r("Share", hte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pte = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
], X_ = r("Sheet", pte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yte = [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
], Y_ = r("Shell", yte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], K_ = r("ShieldAlert", kte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
], Z_ = r("ShieldBan", fte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Q_ = r("ShieldCheck", mte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], J_ = r("ShieldEllipsis", gte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
], e7 = r("ShieldHalf", Mte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _te = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], t7 = r("ShieldMinus", _te);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bte = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
], n7 = r("ShieldOff", bte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], a7 = r("ShieldPlus", Lte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], o7 = r("ShieldQuestion", xte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ete = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], Mr = r("ShieldX", Ete);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vte = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
], r7 = r("Shield", vte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ate = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
], i7 = r("ShipWheel", Ate);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ite = [
  ["path", { d: "M12 10.189V14", key: "1p8cqu" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
      key: "7tigtc"
    }
  ],
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "1924j5"
    }
  ]
], c7 = r("Ship", Ite);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tte = [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
], s7 = r("Shirt", Tte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nte = [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
], l7 = r("ShoppingBag", Nte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cte = [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
], d7 = r("ShoppingBasket", Cte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wte = [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
], u7 = r("ShoppingCart", wte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ste = [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
], h7 = r("Shovel", Ste);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rte = [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
], p7 = r("ShowerHead", Rte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dte = [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
], y7 = r("Shrink", Dte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ote = [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
], k7 = r("Shrub", Ote);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pte = [
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22", key: "1ailkh" }],
  ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2", key: "km57vx" }],
  ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45", key: "os18l9" }]
], f7 = r("Shuffle", Pte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hte = [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
], m7 = r("Sigma", Hte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bte = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
], g7 = r("SignalHigh", Bte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fte = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
], M7 = r("SignalLow", Fte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $te = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
], _7 = r("SignalMedium", $te);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ute = [["path", { d: "M2 20h.01", key: "4haj6o" }]], b7 = r("SignalZero", Ute);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qte = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
], L7 = r("Signal", qte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zte = [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
], x7 = r("Signature", zte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jte = [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
], E7 = r("SignpostBig", jte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vte = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
], v7 = r("Signpost", Vte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gte = [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
], A7 = r("Siren", Gte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wte = [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
], I7 = r("SkipBack", Wte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xte = [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
], T7 = r("SkipForward", Xte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yte = [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], N7 = r("Skull", Yte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kte = [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
], C7 = r("Slack", Kte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zte = [["path", { d: "M22 2 2 22", key: "y4kqgn" }]], w7 = r("Slash", Zte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qte = [
  [
    "path",
    {
      d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
      key: "1sllp5"
    }
  ]
], S7 = r("Slice", Qte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jte = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], R7 = r("SlidersHorizontal", Jte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ene = [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
], _r = r("SlidersVertical", ene);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tne = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
], D7 = r("SmartphoneCharging", tne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nne = [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
], O7 = r("SmartphoneNfc", nne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ane = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], P7 = r("Smartphone", ane);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const one = [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
], H7 = r("SmilePlus", one);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rne = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], B7 = r("Smile", rne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ine = [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
], F7 = r("Snail", ine);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cne = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6h-4", key: "15hhxa" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "M22 12h-6.5L14 15", key: "1mxi28" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h4", key: "1otusx" }]
], $7 = r("Snowflake", cne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sne = [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
], U7 = r("Sofa", sne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lne = [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
], q7 = r("Soup", lne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dne = [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], z7 = r("Space", dne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const une = [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
], j7 = r("Spade", une);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hne = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
], V7 = r("Sparkle", hne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pne = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
], br = r("Sparkles", pne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yne = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
], G7 = r("Speaker", yne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kne = [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
], W7 = r("Speech", kne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fne = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
], X7 = r("SpellCheck2", fne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mne = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], Y7 = r("SpellCheck", mne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gne = [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
], K7 = r("Spline", gne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mne = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
], Z7 = r("Split", Mne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ne = [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
], Q7 = r("SprayCan", _ne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bne = [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
], J7 = r("Sprout", bne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
], Lr = r("SquareActivity", Lne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
], xr = r("SquareArrowDownLeft", xne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ene = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
], Er = r("SquareArrowDownRight", Ene);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], vr = r("SquareArrowDown", vne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ane = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
], Ar = r("SquareArrowLeft", Ane);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ine = [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Ir = r("SquareArrowOutDownLeft", Ine);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tne = [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
], Tr = r("SquareArrowOutDownRight", Tne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nne = [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
], Nr = r("SquareArrowOutUpLeft", Nne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cne = [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
], Cr = r("SquareArrowOutUpRight", Cne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], wr = r("SquareArrowRight", wne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
], Sr = r("SquareArrowUpLeft", Sne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
], Rr = r("SquareArrowUpRight", Rne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], Dr = r("SquareArrowUp", Dne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const One = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
], Or = r("SquareAsterisk", One);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pne = [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], Pr = r("SquareBottomDashedScissors", Pne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
], hn = r("SquareChartGantt", Hne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bne = [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Hr = r("SquareCheckBig", Bne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Br = r("SquareCheck", Fne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], Fr = r("SquareChevronDown", $ne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Une = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], $r = r("SquareChevronLeft", Une);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], Ur = r("SquareChevronRight", qne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], qr = r("SquareChevronUp", zne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jne = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], zr = r("SquareCode", jne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vne = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
], eb = r("SquareDashedBottomCode", Vne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gne = [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
], tb = r("SquareDashedBottom", Gne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wne = [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
], jr = r("SquareDashedKanban", Wne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xne = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
], Vr = r("SquareDashedMousePointer", Xne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yne = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
], Gr = r("SquareDashed", Yne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
], Wr = r("SquareDivide", Kne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], Xr = r("SquareDot", Zne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
], Yr = r("SquareEqual", Qne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jne = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
], Kr = r("SquareFunction", Jne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
], Zr = r("SquareKanban", eae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
], Qr = r("SquareLibrary", tae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
], Jr = r("SquareM", nae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
], e1 = r("SquareMenu", aae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], t1 = r("SquareMinus", oae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rae = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
], n1 = r("SquareMousePointer", rae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iae = [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
], a1 = r("SquareParkingOff", iae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], o1 = r("SquareParking", cae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sae = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], Pt = r("SquarePen", sae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], r1 = r("SquarePercent", lae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
], i1 = r("SquarePi", dae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
], c1 = r("SquarePilcrow", uae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
], s1 = r("SquarePlay", hae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], l1 = r("SquarePlus", pae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yae = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], d1 = r("SquarePower", yae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kae = [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], nb = r("SquareRadical", kae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fae = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], u1 = r("SquareScissors", fae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
], h1 = r("SquareSigma", mae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], p1 = r("SquareSlash", gae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mae = [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], y1 = r("SquareSplitHorizontal", Mae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ae = [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], k1 = r("SquareSplitVertical", _ae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bae = [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
], ab = r("SquareSquare", bae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lae = [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
], ob = r("SquareStack", Lae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xae = [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
], f1 = r("SquareTerminal", xae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eae = [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], m1 = r("SquareUserRound", Eae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
], g1 = r("SquareUser", vae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], M1 = r("SquareX", Aae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], rb = r("Square", Iae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tae = [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
], ib = r("Squircle", Tae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nae = [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
], cb = r("Squirrel", Nae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cae = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
], sb = r("Stamp", Cae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wae = [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
], lb = r("StarHalf", wae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sae = [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], db = r("StarOff", Sae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rae = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], ub = r("Star", Rae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dae = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
], hb = r("StepBack", Dae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oae = [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
], pb = r("StepForward", Oae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pae = [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
], yb = r("Stethoscope", Pae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hae = [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
], kb = r("Sticker", Hae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bae = [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
], fb = r("StickyNote", Bae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fae = [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
], mb = r("Store", Fae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ae = [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
], gb = r("StretchHorizontal", $ae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uae = [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
], Mb = r("StretchVertical", Uae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qae = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], _b = r("Strikethrough", qae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zae = [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
], bb = r("Subscript", zae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jae = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
], Lb = r("SunDim", jae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vae = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
], xb = r("SunMedium", Vae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gae = [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
], Eb = r("SunMoon", Gae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wae = [
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 9a3 3 0 0 0 0 6", key: "gv75dk" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6 1.5-3H22", key: "o5qa3v" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }]
], vb = r("SunSnow", Wae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xae = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
], Ab = r("Sun", Xae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yae = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], Ib = r("Sunrise", Yae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kae = [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], Tb = r("Sunset", Kae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zae = [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
], Nb = r("Superscript", Zae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qae = [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
], Cb = r("SwatchBook", Qae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jae = [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
], wb = r("SwissFranc", Jae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eoe = [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
], Sb = r("SwitchCamera", eoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const toe = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
], Rb = r("Sword", toe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const noe = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
], Db = r("Swords", noe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aoe = [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
], Ob = r("Syringe", aoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ooe = [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
], Pb = r("Table2", ooe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const roe = [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], Hb = r("TableCellsMerge", roe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ioe = [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], Bb = r("TableCellsSplit", ioe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const coe = [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
], Fb = r("TableColumnsSplit", coe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const soe = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
], $b = r("TableOfContents", soe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const loe = [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], Ub = r("TableProperties", loe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const doe = [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
], qb = r("TableRowsSplit", doe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uoe = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], zb = r("Table", uoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hoe = [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], jb = r("TabletSmartphone", hoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const poe = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
], Vb = r("Tablet", poe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yoe = [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
], Gb = r("Tablets", yoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const koe = [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
], Wb = r("Tag", koe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const foe = [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
], Xb = r("Tags", foe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const moe = [["path", { d: "M4 4v16", key: "6qkkli" }]], Yb = r("Tally1", moe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const goe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
], Kb = r("Tally2", goe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Moe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
], Zb = r("Tally3", Moe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _oe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
], Qb = r("Tally4", _oe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const boe = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
], Jb = r("Tally5", boe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Loe = [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
], eL = r("Tangent", Loe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xoe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], tL = r("Target", xoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eoe = [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], nL = r("Telescope", Eoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const voe = [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
], aL = r("TentTree", voe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aoe = [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
], oL = r("Tent", Aoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ioe = [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
], rL = r("Terminal", Ioe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Toe = [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
], _1 = r("TestTubeDiagonal", Toe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Noe = [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
], iL = r("TestTube", Noe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Coe = [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
], cL = r("TestTubes", Coe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const woe = [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
], sL = r("TextCursorInput", woe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Soe = [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
], lL = r("TextCursor", Soe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Roe = [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
], dL = r("TextQuote", Roe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Doe = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
], uL = r("TextSearch", Doe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ooe = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
], b1 = r("TextSelect", Ooe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Poe = [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
], hL = r("Text", Poe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hoe = [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
], pL = r("Theater", Hoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Boe = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "M10.585 15H10", key: "4nqulp" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z", key: "yu0u2z" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h2", key: "1bbqgq" }]
], yL = r("ThermometerSnowflake", Boe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Foe = [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
], kL = r("ThermometerSun", Foe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $oe = [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
], fL = r("Thermometer", $oe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uoe = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], mL = r("ThumbsDown", Uoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qoe = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], gL = r("ThumbsUp", qoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zoe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], ML = r("TicketCheck", zoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const joe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], _L = r("TicketMinus", joe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Voe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], bL = r("TicketPercent", Voe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Goe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], LL = r("TicketPlus", Goe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Woe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
], xL = r("TicketSlash", Woe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xoe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], EL = r("TicketX", Xoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yoe = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
], vL = r("Ticket", Yoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Koe = [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], AL = r("TicketsPlane", Koe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zoe = [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], IL = r("Tickets", Zoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qoe = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
], TL = r("TimerOff", Qoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Joe = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
], NL = r("TimerReset", Joe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ere = [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
], CL = r("Timer", ere);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tre = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
], wL = r("ToggleLeft", tre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nre = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
], SL = r("ToggleRight", nre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const are = [
  [
    "path",
    {
      d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
      key: "kc4kqr"
    }
  ],
  ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8", key: "1tqs57" }]
], RL = r("Toilet", are);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ore = [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
], DL = r("Tornado", ore);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rre = [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
], OL = r("Torus", rre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ire = [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
], PL = r("TouchpadOff", ire);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cre = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
], HL = r("Touchpad", cre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sre = [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
], BL = r("TowerControl", sre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lre = [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
], FL = r("ToyBrick", lre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dre = [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
], $L = r("Tractor", dre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ure = [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
], UL = r("TrafficCone", ure);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hre = [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
], qL = r("TrainFrontTunnel", hre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pre = [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
], zL = r("TrainFront", pre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yre = [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
], jL = r("TrainTrack", yre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kre = [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
], L1 = r("TramFront", kre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fre = [
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M14 20h-4", key: "m8m19d" }],
  ["path", { d: "M18 2h4v4", key: "1341mj" }],
  ["path", { d: "m2 2 7.17 7.17", key: "13q8l2" }],
  ["path", { d: "M2 5.355V2h3.357", key: "18136r" }],
  ["path", { d: "m22 2-7.17 7.17", key: "1epvy4" }],
  ["path", { d: "M8 5 5 8", key: "mgbjhz" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], VL = r("Transgender", fre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mre = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
], GL = r("Trash2", mre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gre = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
], WL = r("Trash", gre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mre = [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
], XL = r("TreeDeciduous", Mre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _re = [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
], x1 = r("TreePalm", _re);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bre = [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
], YL = r("TreePine", bre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lre = [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
], KL = r("Trees", Lre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
], ZL = r("Trello", xre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ere = [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
], QL = r("TrendingDown", Ere);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vre = [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
], JL = r("TrendingUpDown", vre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Are = [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
], ex = r("TrendingUp", Are);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ire = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], E1 = r("TriangleAlert", Ire);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tre = [
  ["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013", key: "pltmmw" }],
  ["path", { d: "M14 21h2", key: "v4qezv" }],
  ["path", { d: "m15.874 7.743 1 1.732", key: "10m0iw" }],
  ["path", { d: "m18.849 12.952 1 1.732", key: "zadnam" }],
  ["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824", key: "fvwuk4" }],
  ["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839", key: "1e1kah" }],
  ["path", { d: "m5.136 12.952-1 1.732", key: "1u4ldi" }],
  ["path", { d: "M8 21h2", key: "i9zjee" }],
  ["path", { d: "m8.102 7.743-1 1.732", key: "1zzo4u" }]
], tx = r("TriangleDashed", Tre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nre = [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
], nx = r("TriangleRight", Nre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cre = [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
], ax = r("Triangle", Cre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wre = [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
], ox = r("Trophy", wre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sre = [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], rx = r("Truck", Sre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rre = [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
], ix = r("Turtle", Rre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dre = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], cx = r("TvMinimalPlay", Dre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ore = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], v1 = r("TvMinimal", Ore);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pre = [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
], sx = r("Tv", Pre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hre = [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
], lx = r("Twitch", Hre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bre = [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
], dx = r("Twitter", Bre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fre = [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
], ux = r("TypeOutline", Fre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $re = [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], hx = r("Type", $re);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ure = [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], px = r("UmbrellaOff", Ure);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qre = [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
], yx = r("Umbrella", qre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zre = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
], kx = r("Underline", zre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jre = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
], fx = r("Undo2", jre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vre = [
  ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13", key: "8mp6z9" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }]
], mx = r("UndoDot", Vre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gre = [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
], gx = r("Undo", Gre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wre = [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
], Mx = r("UnfoldHorizontal", Wre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xre = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
], _x = r("UnfoldVertical", Xre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yre = [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
], bx = r("Ungroup", Yre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kre = [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
], A1 = r("University", Kre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zre = [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
], Lx = r("Unlink2", Zre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qre = [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
], xx = r("Unlink", Qre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jre = [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
], Ex = r("Unplug", Jre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e1e = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
], vx = r("Upload", e1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t1e = [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
], Ax = r("Usb", t1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n1e = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
], Ix = r("UserCheck", n1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a1e = [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
], Tx = r("UserCog", a1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o1e = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], Nx = r("UserMinus", o1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r1e = [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
], Cx = r("UserPen", r1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i1e = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], wx = r("UserPlus", i1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c1e = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], I1 = r("UserRoundCheck", c1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s1e = [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
], T1 = r("UserRoundCog", s1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1e = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], N1 = r("UserRoundMinus", l1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d1e = [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
], Sx = r("UserRoundPen", d1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1e = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], C1 = r("UserRoundPlus", u1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h1e = [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
], Rx = r("UserRoundSearch", h1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p1e = [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
], w1 = r("UserRoundX", p1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y1e = [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
], S1 = r("UserRound", y1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k1e = [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
], Dx = r("UserSearch", k1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f1e = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
], Ox = r("UserX", f1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m1e = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], Px = r("User", m1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g1e = [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
], R1 = r("UsersRound", g1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M1e = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
], Hx = r("Users", M1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _1e = [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
], D1 = r("UtensilsCrossed", _1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b1e = [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
], O1 = r("Utensils", b1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L1e = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
], Bx = r("UtilityPole", L1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x1e = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], Fx = r("Variable", x1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E1e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], $x = r("Vault", E1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v1e = [
  ["path", { d: "M16 8q6 0 6-6-6 0-6 6", key: "qsyyc4" }],
  ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3", key: "41m9h7" }],
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }]
], Ux = r("Vegan", v1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A1e = [
  ["path", { d: "M18 11c-1.5 0-2.5.5-3 2", key: "1fod00" }],
  [
    "path",
    {
      d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
      key: "d70hit"
    }
  ],
  ["path", { d: "M6 11c1.5 0 2.5.5 3 2", key: "136fht" }]
], qx = r("VenetianMask", A1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I1e = [
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M17 2h4v4", key: "vhe59" }],
  ["path", { d: "m21 2-5.46 5.46", key: "19kypf" }],
  ["circle", { cx: "12", cy: "11", r: "5", key: "16gxyc" }]
], zx = r("VenusAndMars", I1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T1e = [
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["circle", { cx: "12", cy: "9", r: "6", key: "1nw4tq" }]
], jx = r("Venus", T1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N1e = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Vx = r("VibrateOff", N1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C1e = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
], Gx = r("Vibrate", C1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w1e = [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Wx = r("VideoOff", w1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S1e = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], Xx = r("Video", S1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R1e = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
], Yx = r("Videotape", R1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D1e = [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], Kx = r("View", D1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O1e = [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
], Zx = r("Voicemail", O1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P1e = [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Qx = r("Volleyball", P1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H1e = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
], Jx = r("Volume1", H1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B1e = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
], e9 = r("Volume2", B1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F1e = [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
], t9 = r("VolumeOff", F1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $1e = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
], n9 = r("VolumeX", $1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U1e = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
], a9 = r("Volume", U1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q1e = [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
], o9 = r("Vote", q1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z1e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
], r9 = r("WalletCards", z1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j1e = [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
], P1 = r("WalletMinimal", j1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V1e = [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
], i9 = r("Wallet", V1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G1e = [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
], c9 = r("Wallpaper", G1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W1e = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], H1 = r("WandSparkles", W1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X1e = [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
], s9 = r("Wand", X1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y1e = [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
], l9 = r("Warehouse", Y1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K1e = [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
], d9 = r("WashingMachine", K1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z1e = [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
], u9 = r("Watch", Z1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q1e = [
  ["path", { d: "M19 5a2 2 0 0 0-2 2v11", key: "s41o68" }],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ],
  ["path", { d: "M7 13h10", key: "1rwob1" }],
  ["path", { d: "M7 9h10", key: "12czzb" }],
  ["path", { d: "M9 5a2 2 0 0 0-2 2v11", key: "x0q4gh" }]
], h9 = r("WavesLadder", Q1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J1e = [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
], p9 = r("Waves", J1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eie = [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
], y9 = r("Waypoints", eie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tie = [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
], k9 = r("Webcam", tie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nie = [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], f9 = r("WebhookOff", nie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aie = [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
], m9 = r("Webhook", aie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oie = [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
], g9 = r("Weight", oie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rie = [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], M9 = r("WheatOff", rie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iie = [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
], _9 = r("Wheat", iie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cie = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], b9 = r("WholeWord", cie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sie = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], L9 = r("WifiHigh", sie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lie = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], x9 = r("WifiLow", lie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const die = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], E9 = r("WifiOff", die);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uie = [["path", { d: "M12 20h.01", key: "zekei9" }]], v9 = r("WifiZero", uie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hie = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], A9 = r("Wifi", hie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pie = [
  ["path", { d: "M10 2v8", key: "d4bbey" }],
  ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2", key: "19kp1d" }],
  ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2", key: "19kpjc" }],
  ["path", { d: "m6 6 4 4 4-4", key: "k13n16" }]
], I9 = r("WindArrowDown", pie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yie = [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
], T9 = r("Wind", yie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kie = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], N9 = r("WineOff", kie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fie = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
], C9 = r("Wine", fie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mie = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], w9 = r("Workflow", mie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gie = [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
], S9 = r("Worm", gie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mie = [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
], R9 = r("WrapText", Mie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ie = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
], D9 = r("Wrench", _ie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bie = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], O9 = r("X", bie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lie = [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
], P9 = r("Youtube", Lie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xie = [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], H9 = r("ZapOff", xie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eie = [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
], B9 = r("Zap", Eie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vie = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], F9 = r("ZoomIn", vie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aie = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], $9 = r("ZoomOut", Aie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: Sc,
  AArrowUp: Rc,
  ALargeSmall: Dc,
  Accessibility: Oc,
  Activity: Pc,
  AirVent: Hc,
  Airplay: Bc,
  AlarmClock: $c,
  AlarmClockCheck: ra,
  AlarmClockMinus: ia,
  AlarmClockOff: Fc,
  AlarmClockPlus: ca,
  AlarmSmoke: Uc,
  Album: qc,
  AlignCenter: Vc,
  AlignCenterHorizontal: zc,
  AlignCenterVertical: jc,
  AlignEndHorizontal: Gc,
  AlignEndVertical: Wc,
  AlignHorizontalDistributeCenter: Xc,
  AlignHorizontalDistributeEnd: Yc,
  AlignHorizontalDistributeStart: Kc,
  AlignHorizontalJustifyCenter: Zc,
  AlignHorizontalJustifyEnd: Qc,
  AlignHorizontalJustifyStart: Jc,
  AlignHorizontalSpaceAround: es,
  AlignHorizontalSpaceBetween: ts,
  AlignJustify: ns,
  AlignLeft: as,
  AlignRight: os,
  AlignStartHorizontal: rs,
  AlignStartVertical: is,
  AlignVerticalDistributeCenter: cs,
  AlignVerticalDistributeEnd: ss,
  AlignVerticalDistributeStart: ls,
  AlignVerticalJustifyCenter: ds,
  AlignVerticalJustifyEnd: us,
  AlignVerticalJustifyStart: hs,
  AlignVerticalSpaceAround: ps,
  AlignVerticalSpaceBetween: ys,
  Ambulance: ks,
  Ampersand: fs,
  Ampersands: ms,
  Amphora: gs,
  Anchor: Ms,
  Angry: _s,
  Annoyed: bs,
  Antenna: Ls,
  Anvil: xs,
  Aperture: Es,
  AppWindow: As,
  AppWindowMac: vs,
  Apple: Is,
  Archive: Cs,
  ArchiveRestore: Ts,
  ArchiveX: Ns,
  Armchair: ws,
  ArrowBigDown: Rs,
  ArrowBigDownDash: Ss,
  ArrowBigLeft: Os,
  ArrowBigLeftDash: Ds,
  ArrowBigRight: Hs,
  ArrowBigRightDash: Ps,
  ArrowBigUp: Fs,
  ArrowBigUpDash: Bs,
  ArrowDown: Ys,
  ArrowDown01: $s,
  ArrowDown10: Us,
  ArrowDownAZ: sa,
  ArrowDownFromLine: qs,
  ArrowDownLeft: zs,
  ArrowDownNarrowWide: js,
  ArrowDownRight: Vs,
  ArrowDownToDot: Gs,
  ArrowDownToLine: Ws,
  ArrowDownUp: Xs,
  ArrowDownWideNarrow: la,
  ArrowDownZA: da,
  ArrowLeft: Js,
  ArrowLeftFromLine: Ks,
  ArrowLeftRight: Zs,
  ArrowLeftToLine: Qs,
  ArrowRight: al,
  ArrowRightFromLine: el,
  ArrowRightLeft: tl,
  ArrowRightToLine: nl,
  ArrowUp: pl,
  ArrowUp01: ol,
  ArrowUp10: rl,
  ArrowUpAZ: ua,
  ArrowUpDown: il,
  ArrowUpFromDot: cl,
  ArrowUpFromLine: sl,
  ArrowUpLeft: ll,
  ArrowUpNarrowWide: ha,
  ArrowUpRight: dl,
  ArrowUpToLine: ul,
  ArrowUpWideNarrow: hl,
  ArrowUpZA: pa,
  ArrowsUpFromLine: yl,
  Asterisk: kl,
  AtSign: fl,
  Atom: ml,
  AudioLines: gl,
  AudioWaveform: Ml,
  Award: _l,
  Axe: bl,
  Axis3d: ya,
  Baby: Ll,
  Backpack: xl,
  Badge: Fl,
  BadgeAlert: El,
  BadgeCent: vl,
  BadgeCheck: ka,
  BadgeDollarSign: Al,
  BadgeEuro: Il,
  BadgeHelp: Tl,
  BadgeIndianRupee: Nl,
  BadgeInfo: Cl,
  BadgeJapaneseYen: wl,
  BadgeMinus: Sl,
  BadgePercent: Rl,
  BadgePlus: Dl,
  BadgePoundSterling: Ol,
  BadgeRussianRuble: Pl,
  BadgeSwissFranc: Hl,
  BadgeX: Bl,
  BaggageClaim: $l,
  Ban: Ul,
  Banana: ql,
  Bandage: zl,
  Banknote: jl,
  Barcode: Vl,
  Baseline: Gl,
  Bath: Wl,
  Battery: e0,
  BatteryCharging: Xl,
  BatteryFull: Yl,
  BatteryLow: Kl,
  BatteryMedium: Zl,
  BatteryPlus: Ql,
  BatteryWarning: Jl,
  Beaker: t0,
  Bean: a0,
  BeanOff: n0,
  Bed: i0,
  BedDouble: o0,
  BedSingle: r0,
  Beef: c0,
  Beer: l0,
  BeerOff: s0,
  Bell: f0,
  BellDot: d0,
  BellElectric: u0,
  BellMinus: h0,
  BellOff: p0,
  BellPlus: y0,
  BellRing: k0,
  BetweenHorizontalEnd: fa,
  BetweenHorizontalStart: ma,
  BetweenVerticalEnd: m0,
  BetweenVerticalStart: g0,
  BicepsFlexed: M0,
  Bike: _0,
  Binary: b0,
  Binoculars: L0,
  Biohazard: x0,
  Bird: E0,
  Bitcoin: v0,
  Blend: A0,
  Blinds: I0,
  Blocks: T0,
  Bluetooth: S0,
  BluetoothConnected: N0,
  BluetoothOff: C0,
  BluetoothSearching: w0,
  Bold: R0,
  Bolt: D0,
  Bomb: O0,
  Bone: P0,
  Book: r2,
  BookA: H0,
  BookAudio: B0,
  BookCheck: F0,
  BookCopy: $0,
  BookDashed: ga,
  BookDown: U0,
  BookHeadphones: q0,
  BookHeart: z0,
  BookImage: j0,
  BookKey: V0,
  BookLock: G0,
  BookMarked: W0,
  BookMinus: X0,
  BookOpen: Z0,
  BookOpenCheck: Y0,
  BookOpenText: K0,
  BookPlus: Q0,
  BookText: J0,
  BookType: e2,
  BookUp: n2,
  BookUp2: t2,
  BookUser: a2,
  BookX: o2,
  Bookmark: d2,
  BookmarkCheck: i2,
  BookmarkMinus: c2,
  BookmarkPlus: s2,
  BookmarkX: l2,
  BoomBox: u2,
  Bot: y2,
  BotMessageSquare: h2,
  BotOff: p2,
  Box: k2,
  Boxes: f2,
  Braces: Ma,
  Brackets: m2,
  Brain: _2,
  BrainCircuit: g2,
  BrainCog: M2,
  BrickWall: b2,
  Briefcase: v2,
  BriefcaseBusiness: L2,
  BriefcaseConveyorBelt: x2,
  BriefcaseMedical: E2,
  BringToFront: A2,
  Brush: I2,
  Bug: C2,
  BugOff: T2,
  BugPlay: N2,
  Building: S2,
  Building2: w2,
  Bus: D2,
  BusFront: R2,
  Cable: P2,
  CableCar: O2,
  Cake: B2,
  CakeSlice: H2,
  Calculator: F2,
  Calendar: id,
  Calendar1: $2,
  CalendarArrowDown: U2,
  CalendarArrowUp: q2,
  CalendarCheck: j2,
  CalendarCheck2: z2,
  CalendarClock: V2,
  CalendarCog: G2,
  CalendarDays: W2,
  CalendarFold: X2,
  CalendarHeart: Y2,
  CalendarMinus: Z2,
  CalendarMinus2: K2,
  CalendarOff: Q2,
  CalendarPlus: ed,
  CalendarPlus2: J2,
  CalendarRange: td,
  CalendarSearch: nd,
  CalendarSync: ad,
  CalendarX: rd,
  CalendarX2: od,
  Camera: sd,
  CameraOff: cd,
  Candy: ud,
  CandyCane: ld,
  CandyOff: dd,
  Cannabis: hd,
  Captions: _a,
  CaptionsOff: pd,
  Car: fd,
  CarFront: yd,
  CarTaxiFront: kd,
  Caravan: md,
  Carrot: gd,
  CaseLower: Md,
  CaseSensitive: _d,
  CaseUpper: bd,
  CassetteTape: Ld,
  Cast: xd,
  Castle: Ed,
  Cat: vd,
  Cctv: Ad,
  ChartArea: ba,
  ChartBar: xa,
  ChartBarBig: La,
  ChartBarDecreasing: Id,
  ChartBarIncreasing: Td,
  ChartBarStacked: Nd,
  ChartCandlestick: Ea,
  ChartColumn: Ia,
  ChartColumnBig: va,
  ChartColumnDecreasing: Cd,
  ChartColumnIncreasing: Aa,
  ChartColumnStacked: wd,
  ChartGantt: Sd,
  ChartLine: Ta,
  ChartNetwork: Rd,
  ChartNoAxesColumn: Ca,
  ChartNoAxesColumnDecreasing: Dd,
  ChartNoAxesColumnIncreasing: Na,
  ChartNoAxesCombined: Od,
  ChartNoAxesGantt: wa,
  ChartPie: Sa,
  ChartScatter: Ra,
  ChartSpline: Pd,
  Check: Bd,
  CheckCheck: Hd,
  ChefHat: Fd,
  Cherry: $d,
  ChevronDown: Ud,
  ChevronFirst: qd,
  ChevronLast: zd,
  ChevronLeft: jd,
  ChevronRight: Vd,
  ChevronUp: Gd,
  ChevronsDown: Xd,
  ChevronsDownUp: Wd,
  ChevronsLeft: Zd,
  ChevronsLeftRight: Kd,
  ChevronsLeftRightEllipsis: Yd,
  ChevronsRight: Jd,
  ChevronsRightLeft: Qd,
  ChevronsUp: tu,
  ChevronsUpDown: eu,
  Chrome: nu,
  Church: au,
  Cigarette: ru,
  CigaretteOff: ou,
  Circle: mu,
  CircleAlert: Da,
  CircleArrowDown: Oa,
  CircleArrowLeft: Pa,
  CircleArrowOutDownLeft: Ha,
  CircleArrowOutDownRight: Ba,
  CircleArrowOutUpLeft: Fa,
  CircleArrowOutUpRight: $a,
  CircleArrowRight: Ua,
  CircleArrowUp: qa,
  CircleCheck: ja,
  CircleCheckBig: za,
  CircleChevronDown: Va,
  CircleChevronLeft: Ga,
  CircleChevronRight: Wa,
  CircleChevronUp: Xa,
  CircleDashed: iu,
  CircleDivide: Ya,
  CircleDollarSign: cu,
  CircleDot: lu,
  CircleDotDashed: su,
  CircleEllipsis: du,
  CircleEqual: uu,
  CircleFadingArrowUp: hu,
  CircleFadingPlus: pu,
  CircleGauge: Ka,
  CircleHelp: Za,
  CircleMinus: Qa,
  CircleOff: yu,
  CircleParking: eo,
  CircleParkingOff: Ja,
  CirclePause: to,
  CirclePercent: no,
  CirclePlay: ao,
  CirclePlus: oo,
  CirclePower: ro,
  CircleSlash: ku,
  CircleSlash2: io,
  CircleSmall: fu,
  CircleStop: co,
  CircleUser: lo,
  CircleUserRound: so,
  CircleX: uo,
  CircuitBoard: gu,
  Citrus: Mu,
  Clapperboard: _u,
  Clipboard: Nu,
  ClipboardCheck: bu,
  ClipboardCopy: Lu,
  ClipboardList: xu,
  ClipboardMinus: Eu,
  ClipboardPaste: vu,
  ClipboardPen: po,
  ClipboardPenLine: ho,
  ClipboardPlus: Au,
  ClipboardType: Iu,
  ClipboardX: Tu,
  Clock: Vu,
  Clock1: Cu,
  Clock10: wu,
  Clock11: Su,
  Clock12: Ru,
  Clock2: Du,
  Clock3: Ou,
  Clock4: Pu,
  Clock5: Hu,
  Clock6: Bu,
  Clock7: Fu,
  Clock8: $u,
  Clock9: Uu,
  ClockAlert: qu,
  ClockArrowDown: zu,
  ClockArrowUp: ju,
  Cloud: ih,
  CloudAlert: Gu,
  CloudCog: Wu,
  CloudDownload: yo,
  CloudDrizzle: Xu,
  CloudFog: Yu,
  CloudHail: Ku,
  CloudLightning: Zu,
  CloudMoon: Ju,
  CloudMoonRain: Qu,
  CloudOff: eh,
  CloudRain: nh,
  CloudRainWind: th,
  CloudSnow: ah,
  CloudSun: rh,
  CloudSunRain: oh,
  CloudUpload: ko,
  Cloudy: ch,
  Clover: sh,
  Club: lh,
  Code: dh,
  CodeXml: fo,
  Codepen: uh,
  Codesandbox: hh,
  Coffee: ph,
  Cog: yh,
  Coins: kh,
  Columns2: mo,
  Columns3: go,
  Columns4: fh,
  Combine: mh,
  Command: gh,
  Compass: Mh,
  Component: _h,
  Computer: bh,
  ConciergeBell: Lh,
  Cone: xh,
  Construction: Eh,
  Contact: vh,
  ContactRound: Mo,
  Container: Ah,
  Contrast: Ih,
  Cookie: Th,
  CookingPot: Nh,
  Copy: Oh,
  CopyCheck: Ch,
  CopyMinus: wh,
  CopyPlus: Sh,
  CopySlash: Rh,
  CopyX: Dh,
  Copyleft: Ph,
  Copyright: Hh,
  CornerDownLeft: Bh,
  CornerDownRight: Fh,
  CornerLeftDown: $h,
  CornerLeftUp: Uh,
  CornerRightDown: qh,
  CornerRightUp: zh,
  CornerUpLeft: jh,
  CornerUpRight: Vh,
  Cpu: Gh,
  CreativeCommons: Wh,
  CreditCard: Xh,
  Croissant: Yh,
  Crop: Kh,
  Cross: Zh,
  Crosshair: Qh,
  Crown: Jh,
  Cuboid: ep,
  CupSoda: tp,
  Currency: np,
  Cylinder: ap,
  Dam: op,
  Database: cp,
  DatabaseBackup: rp,
  DatabaseZap: ip,
  Delete: sp,
  Dessert: lp,
  Diameter: dp,
  Diamond: pp,
  DiamondMinus: up,
  DiamondPercent: _o,
  DiamondPlus: hp,
  Dice1: yp,
  Dice2: kp,
  Dice3: fp,
  Dice4: mp,
  Dice5: gp,
  Dice6: Mp,
  Dices: _p,
  Diff: bp,
  Disc: vp,
  Disc2: Lp,
  Disc3: xp,
  DiscAlbum: Ep,
  Divide: Ap,
  Dna: Tp,
  DnaOff: Ip,
  Dock: Np,
  Dog: Cp,
  DollarSign: wp,
  Donut: Sp,
  DoorClosed: Rp,
  DoorOpen: Dp,
  Dot: Op,
  Download: Pp,
  DraftingCompass: Hp,
  Drama: Bp,
  Dribbble: Fp,
  Drill: $p,
  Droplet: qp,
  DropletOff: Up,
  Droplets: zp,
  Drum: jp,
  Drumstick: Vp,
  Dumbbell: Gp,
  Ear: Xp,
  EarOff: Wp,
  Earth: bo,
  EarthLock: Yp,
  Eclipse: Kp,
  Egg: Jp,
  EggFried: Zp,
  EggOff: Qp,
  Ellipsis: xo,
  EllipsisVertical: Lo,
  Equal: ny,
  EqualApproximately: ey,
  EqualNot: ty,
  Eraser: ay,
  EthernetPort: oy,
  Euro: ry,
  Expand: iy,
  ExternalLink: cy,
  Eye: dy,
  EyeClosed: sy,
  EyeOff: ly,
  Facebook: uy,
  Factory: hy,
  Fan: py,
  FastForward: yy,
  Feather: ky,
  Fence: fy,
  FerrisWheel: my,
  Figma: gy,
  File: kk,
  FileArchive: My,
  FileAudio: by,
  FileAudio2: _y,
  FileAxis3d: Eo,
  FileBadge: xy,
  FileBadge2: Ly,
  FileBox: Ey,
  FileChartColumn: Ao,
  FileChartColumnIncreasing: vo,
  FileChartLine: Io,
  FileChartPie: To,
  FileCheck: Ay,
  FileCheck2: vy,
  FileClock: Iy,
  FileCode: Ny,
  FileCode2: Ty,
  FileCog: No,
  FileDiff: Cy,
  FileDigit: wy,
  FileDown: Sy,
  FileHeart: Ry,
  FileImage: Dy,
  FileInput: Oy,
  FileJson: Hy,
  FileJson2: Py,
  FileKey: Fy,
  FileKey2: By,
  FileLock: Uy,
  FileLock2: $y,
  FileMinus: zy,
  FileMinus2: qy,
  FileMusic: jy,
  FileOutput: Vy,
  FilePen: wo,
  FilePenLine: Co,
  FilePlus: Wy,
  FilePlus2: Gy,
  FileQuestion: Xy,
  FileScan: Yy,
  FileSearch: Zy,
  FileSearch2: Ky,
  FileSliders: Qy,
  FileSpreadsheet: Jy,
  FileStack: ek,
  FileSymlink: tk,
  FileTerminal: nk,
  FileText: ak,
  FileType: rk,
  FileType2: ok,
  FileUp: ik,
  FileUser: ck,
  FileVideo: lk,
  FileVideo2: sk,
  FileVolume: uk,
  FileVolume2: dk,
  FileWarning: hk,
  FileX: yk,
  FileX2: pk,
  Files: fk,
  Film: mk,
  Filter: Mk,
  FilterX: gk,
  Fingerprint: _k,
  FireExtinguisher: bk,
  Fish: Ek,
  FishOff: Lk,
  FishSymbol: xk,
  Flag: Tk,
  FlagOff: vk,
  FlagTriangleLeft: Ak,
  FlagTriangleRight: Ik,
  Flame: Ck,
  FlameKindling: Nk,
  Flashlight: Sk,
  FlashlightOff: wk,
  FlaskConical: Dk,
  FlaskConicalOff: Rk,
  FlaskRound: Ok,
  FlipHorizontal: Hk,
  FlipHorizontal2: Pk,
  FlipVertical: Fk,
  FlipVertical2: Bk,
  Flower: Uk,
  Flower2: $k,
  Focus: qk,
  FoldHorizontal: zk,
  FoldVertical: jk,
  Folder: g4,
  FolderArchive: Vk,
  FolderCheck: Gk,
  FolderClock: Wk,
  FolderClosed: Xk,
  FolderCode: Yk,
  FolderCog: So,
  FolderDot: Kk,
  FolderDown: Zk,
  FolderGit: Jk,
  FolderGit2: Qk,
  FolderHeart: e4,
  FolderInput: t4,
  FolderKanban: n4,
  FolderKey: a4,
  FolderLock: o4,
  FolderMinus: r4,
  FolderOpen: c4,
  FolderOpenDot: i4,
  FolderOutput: s4,
  FolderPen: Ro,
  FolderPlus: l4,
  FolderRoot: d4,
  FolderSearch: h4,
  FolderSearch2: u4,
  FolderSymlink: p4,
  FolderSync: y4,
  FolderTree: k4,
  FolderUp: f4,
  FolderX: m4,
  Folders: M4,
  Footprints: _4,
  Forklift: b4,
  Forward: L4,
  Frame: x4,
  Framer: E4,
  Frown: v4,
  Fuel: A4,
  Fullscreen: I4,
  GalleryHorizontal: N4,
  GalleryHorizontalEnd: T4,
  GalleryThumbnails: C4,
  GalleryVertical: S4,
  GalleryVerticalEnd: w4,
  Gamepad: D4,
  Gamepad2: R4,
  Gauge: O4,
  Gavel: P4,
  Gem: H4,
  Ghost: B4,
  Gift: F4,
  GitBranch: U4,
  GitBranchPlus: $4,
  GitCommitHorizontal: Do,
  GitCommitVertical: q4,
  GitCompare: j4,
  GitCompareArrows: z4,
  GitFork: V4,
  GitGraph: G4,
  GitMerge: W4,
  GitPullRequest: J4,
  GitPullRequestArrow: X4,
  GitPullRequestClosed: Y4,
  GitPullRequestCreate: Z4,
  GitPullRequestCreateArrow: K4,
  GitPullRequestDraft: Q4,
  Github: ef,
  Gitlab: tf,
  GlassWater: nf,
  Glasses: af,
  Globe: rf,
  GlobeLock: of,
  Goal: cf,
  Grab: sf,
  GraduationCap: lf,
  Grape: df,
  Grid2x2: Bo,
  Grid2x2Check: Oo,
  Grid2x2Plus: Po,
  Grid2x2X: Ho,
  Grid3x3: un,
  Grip: pf,
  GripHorizontal: uf,
  GripVertical: hf,
  Group: yf,
  Guitar: kf,
  Ham: ff,
  Hammer: mf,
  Hand: Lf,
  HandCoins: gf,
  HandHeart: Mf,
  HandHelping: Fo,
  HandMetal: _f,
  HandPlatter: bf,
  Handshake: xf,
  HardDrive: Af,
  HardDriveDownload: Ef,
  HardDriveUpload: vf,
  HardHat: If,
  Hash: Tf,
  Haze: Nf,
  HdmiPort: Cf,
  Heading: Hf,
  Heading1: wf,
  Heading2: Sf,
  Heading3: Rf,
  Heading4: Df,
  Heading5: Of,
  Heading6: Pf,
  HeadphoneOff: Bf,
  Headphones: Ff,
  Headset: $f,
  Heart: Vf,
  HeartCrack: Uf,
  HeartHandshake: qf,
  HeartOff: zf,
  HeartPulse: jf,
  Heater: Gf,
  Hexagon: Wf,
  Highlighter: Xf,
  History: Yf,
  Hop: Zf,
  HopOff: Kf,
  Hospital: Qf,
  Hotel: Jf,
  Hourglass: e3,
  House: $o,
  HousePlug: t3,
  HousePlus: n3,
  HouseWifi: a3,
  IceCreamBowl: Uo,
  IceCreamCone: qo,
  IdCard: o3,
  Image: h3,
  ImageDown: r3,
  ImageMinus: i3,
  ImageOff: c3,
  ImagePlay: s3,
  ImagePlus: l3,
  ImageUp: d3,
  ImageUpscale: u3,
  Images: p3,
  Import: y3,
  Inbox: k3,
  IndentDecrease: zo,
  IndentIncrease: jo,
  IndianRupee: f3,
  Infinity: m3,
  Info: g3,
  InspectionPanel: M3,
  Instagram: _3,
  Italic: b3,
  IterationCcw: L3,
  IterationCw: x3,
  JapaneseYen: E3,
  Joystick: v3,
  Kanban: A3,
  Key: N3,
  KeyRound: I3,
  KeySquare: T3,
  Keyboard: S3,
  KeyboardMusic: C3,
  KeyboardOff: w3,
  Lamp: B3,
  LampCeiling: R3,
  LampDesk: D3,
  LampFloor: O3,
  LampWallDown: P3,
  LampWallUp: H3,
  LandPlot: F3,
  Landmark: $3,
  Languages: U3,
  Laptop: z3,
  LaptopMinimal: Vo,
  LaptopMinimalCheck: q3,
  Lasso: V3,
  LassoSelect: j3,
  Laugh: G3,
  Layers: Go,
  Layers2: W3,
  LayoutDashboard: X3,
  LayoutGrid: Y3,
  LayoutList: K3,
  LayoutPanelLeft: Z3,
  LayoutPanelTop: Q3,
  LayoutTemplate: J3,
  Leaf: e5,
  LeafyGreen: t5,
  Lectern: n5,
  LetterText: a5,
  Library: r5,
  LibraryBig: o5,
  LifeBuoy: i5,
  Ligature: c5,
  Lightbulb: l5,
  LightbulbOff: s5,
  Link: h5,
  Link2: u5,
  Link2Off: d5,
  Linkedin: p5,
  List: C5,
  ListCheck: y5,
  ListChecks: k5,
  ListCollapse: f5,
  ListEnd: m5,
  ListFilter: M5,
  ListFilterPlus: g5,
  ListMinus: _5,
  ListMusic: b5,
  ListOrdered: L5,
  ListPlus: x5,
  ListRestart: E5,
  ListStart: v5,
  ListTodo: A5,
  ListTree: I5,
  ListVideo: T5,
  ListX: N5,
  Loader: S5,
  LoaderCircle: Wo,
  LoaderPinwheel: w5,
  Locate: O5,
  LocateFixed: R5,
  LocateOff: D5,
  Lock: H5,
  LockKeyhole: P5,
  LockKeyholeOpen: Xo,
  LockOpen: Yo,
  LogIn: B5,
  LogOut: F5,
  Logs: $5,
  Lollipop: U5,
  Luggage: q5,
  Magnet: z5,
  Mail: Q5,
  MailCheck: j5,
  MailMinus: V5,
  MailOpen: G5,
  MailPlus: W5,
  MailQuestion: X5,
  MailSearch: Y5,
  MailWarning: K5,
  MailX: Z5,
  Mailbox: J5,
  Mails: em,
  Map: ym,
  MapPin: um,
  MapPinCheck: nm,
  MapPinCheckInside: tm,
  MapPinHouse: am,
  MapPinMinus: rm,
  MapPinMinusInside: om,
  MapPinOff: im,
  MapPinPlus: sm,
  MapPinPlusInside: cm,
  MapPinX: dm,
  MapPinXInside: lm,
  MapPinned: hm,
  MapPlus: pm,
  Mars: fm,
  MarsStroke: km,
  Martini: mm,
  Maximize: Mm,
  Maximize2: gm,
  Medal: _m,
  Megaphone: Lm,
  MegaphoneOff: bm,
  Meh: xm,
  MemoryStick: Em,
  Menu: vm,
  Merge: Am,
  MessageCircle: Hm,
  MessageCircleCode: Im,
  MessageCircleDashed: Tm,
  MessageCircleHeart: Nm,
  MessageCircleMore: Cm,
  MessageCircleOff: wm,
  MessageCirclePlus: Sm,
  MessageCircleQuestion: Rm,
  MessageCircleReply: Dm,
  MessageCircleWarning: Om,
  MessageCircleX: Pm,
  MessageSquare: Jm,
  MessageSquareCode: Bm,
  MessageSquareDashed: Fm,
  MessageSquareDiff: $m,
  MessageSquareDot: Um,
  MessageSquareHeart: qm,
  MessageSquareLock: zm,
  MessageSquareMore: jm,
  MessageSquareOff: Vm,
  MessageSquarePlus: Gm,
  MessageSquareQuote: Wm,
  MessageSquareReply: Xm,
  MessageSquareShare: Ym,
  MessageSquareText: Km,
  MessageSquareWarning: Zm,
  MessageSquareX: Qm,
  MessagesSquare: e6,
  Mic: n6,
  MicOff: t6,
  MicVocal: Ko,
  Microchip: a6,
  Microscope: o6,
  Microwave: r6,
  Milestone: i6,
  Milk: s6,
  MilkOff: c6,
  Minimize: d6,
  Minimize2: l6,
  Minus: u6,
  Monitor: E6,
  MonitorCheck: h6,
  MonitorCog: p6,
  MonitorDot: y6,
  MonitorDown: k6,
  MonitorOff: f6,
  MonitorPause: m6,
  MonitorPlay: g6,
  MonitorSmartphone: M6,
  MonitorSpeaker: _6,
  MonitorStop: b6,
  MonitorUp: L6,
  MonitorX: x6,
  Moon: A6,
  MoonStar: v6,
  Mountain: T6,
  MountainSnow: I6,
  Mouse: D6,
  MouseOff: N6,
  MousePointer: R6,
  MousePointer2: C6,
  MousePointerBan: w6,
  MousePointerClick: S6,
  Move: W6,
  Move3d: Zo,
  MoveDiagonal: P6,
  MoveDiagonal2: O6,
  MoveDown: F6,
  MoveDownLeft: H6,
  MoveDownRight: B6,
  MoveHorizontal: $6,
  MoveLeft: U6,
  MoveRight: q6,
  MoveUp: V6,
  MoveUpLeft: z6,
  MoveUpRight: j6,
  MoveVertical: G6,
  Music: Z6,
  Music2: X6,
  Music3: Y6,
  Music4: K6,
  Navigation: tg,
  Navigation2: J6,
  Navigation2Off: Q6,
  NavigationOff: eg,
  Network: ng,
  Newspaper: ag,
  Nfc: og,
  NonBinary: rg,
  Notebook: lg,
  NotebookPen: ig,
  NotebookTabs: cg,
  NotebookText: sg,
  NotepadText: ug,
  NotepadTextDashed: dg,
  Nut: pg,
  NutOff: hg,
  Octagon: kg,
  OctagonAlert: Qo,
  OctagonMinus: yg,
  OctagonPause: Jo,
  OctagonX: er,
  Omega: fg,
  Option: mg,
  Orbit: gg,
  Origami: Mg,
  Package: Ig,
  Package2: _g,
  PackageCheck: bg,
  PackageMinus: Lg,
  PackageOpen: xg,
  PackagePlus: Eg,
  PackageSearch: vg,
  PackageX: Ag,
  PaintBucket: Tg,
  PaintRoller: Ng,
  Paintbrush: Cg,
  PaintbrushVertical: tr,
  Palette: wg,
  PanelBottom: Dg,
  PanelBottomClose: Sg,
  PanelBottomDashed: nr,
  PanelBottomOpen: Rg,
  PanelLeft: ir,
  PanelLeftClose: ar,
  PanelLeftDashed: or,
  PanelLeftOpen: rr,
  PanelRight: Hg,
  PanelRightClose: Og,
  PanelRightDashed: cr,
  PanelRightOpen: Pg,
  PanelTop: $g,
  PanelTopClose: Bg,
  PanelTopDashed: sr,
  PanelTopOpen: Fg,
  PanelsLeftBottom: Ug,
  PanelsRightBottom: qg,
  PanelsTopLeft: lr,
  Paperclip: zg,
  Parentheses: jg,
  ParkingMeter: Vg,
  PartyPopper: Gg,
  Pause: Wg,
  PawPrint: Xg,
  PcCase: Yg,
  Pen: ur,
  PenLine: dr,
  PenOff: Kg,
  PenTool: Zg,
  Pencil: t8,
  PencilLine: Qg,
  PencilOff: Jg,
  PencilRuler: e8,
  Pentagon: n8,
  Percent: a8,
  PersonStanding: o8,
  PhilippinePeso: r8,
  Phone: h8,
  PhoneCall: i8,
  PhoneForwarded: c8,
  PhoneIncoming: s8,
  PhoneMissed: l8,
  PhoneOff: d8,
  PhoneOutgoing: u8,
  Pi: p8,
  Piano: y8,
  Pickaxe: k8,
  PictureInPicture: m8,
  PictureInPicture2: f8,
  PiggyBank: g8,
  Pilcrow: b8,
  PilcrowLeft: M8,
  PilcrowRight: _8,
  Pill: x8,
  PillBottle: L8,
  Pin: v8,
  PinOff: E8,
  Pipette: A8,
  Pizza: I8,
  Plane: C8,
  PlaneLanding: T8,
  PlaneTakeoff: N8,
  Play: w8,
  Plug: R8,
  Plug2: S8,
  PlugZap: hr,
  Plus: D8,
  Pocket: P8,
  PocketKnife: O8,
  Podcast: H8,
  Pointer: F8,
  PointerOff: B8,
  Popcorn: $8,
  Popsicle: U8,
  PoundSterling: q8,
  Power: j8,
  PowerOff: z8,
  Presentation: V8,
  Printer: W8,
  PrinterCheck: G8,
  Projector: X8,
  Proportions: Y8,
  Puzzle: K8,
  Pyramid: Z8,
  QrCode: Q8,
  Quote: J8,
  Rabbit: eM,
  Radar: tM,
  Radiation: nM,
  Radical: aM,
  Radio: iM,
  RadioReceiver: oM,
  RadioTower: rM,
  Radius: cM,
  RailSymbol: sM,
  Rainbow: lM,
  Rat: dM,
  Ratio: uM,
  Receipt: _M,
  ReceiptCent: hM,
  ReceiptEuro: pM,
  ReceiptIndianRupee: yM,
  ReceiptJapaneseYen: kM,
  ReceiptPoundSterling: fM,
  ReceiptRussianRuble: mM,
  ReceiptSwissFranc: gM,
  ReceiptText: MM,
  RectangleEllipsis: pr,
  RectangleHorizontal: bM,
  RectangleVertical: LM,
  Recycle: xM,
  Redo: AM,
  Redo2: EM,
  RedoDot: vM,
  RefreshCcw: TM,
  RefreshCcwDot: IM,
  RefreshCw: CM,
  RefreshCwOff: NM,
  Refrigerator: wM,
  Regex: SM,
  RemoveFormatting: RM,
  Repeat: PM,
  Repeat1: DM,
  Repeat2: OM,
  Replace: BM,
  ReplaceAll: HM,
  Reply: $M,
  ReplyAll: FM,
  Rewind: UM,
  Ribbon: qM,
  Rocket: zM,
  RockingChair: jM,
  RollerCoaster: VM,
  Rotate3d: yr,
  RotateCcw: WM,
  RotateCcwSquare: GM,
  RotateCw: YM,
  RotateCwSquare: XM,
  Route: ZM,
  RouteOff: KM,
  Router: QM,
  Rows2: kr,
  Rows3: fr,
  Rows4: JM,
  Rss: e_,
  Ruler: t_,
  RussianRuble: n_,
  Sailboat: a_,
  Salad: o_,
  Sandwich: r_,
  Satellite: c_,
  SatelliteDish: i_,
  Save: d_,
  SaveAll: s_,
  SaveOff: l_,
  Scale: u_,
  Scale3d: mr,
  Scaling: h_,
  Scan: b_,
  ScanBarcode: p_,
  ScanEye: y_,
  ScanFace: k_,
  ScanHeart: f_,
  ScanLine: m_,
  ScanQrCode: g_,
  ScanSearch: M_,
  ScanText: __,
  School: L_,
  Scissors: E_,
  ScissorsLineDashed: x_,
  ScreenShare: A_,
  ScreenShareOff: v_,
  Scroll: T_,
  ScrollText: I_,
  Search: R_,
  SearchCheck: N_,
  SearchCode: C_,
  SearchSlash: w_,
  SearchX: S_,
  Section: D_,
  Send: P_,
  SendHorizontal: gr,
  SendToBack: O_,
  SeparatorHorizontal: H_,
  SeparatorVertical: B_,
  Server: q_,
  ServerCog: F_,
  ServerCrash: $_,
  ServerOff: U_,
  Settings: j_,
  Settings2: z_,
  Shapes: V_,
  Share: W_,
  Share2: G_,
  Sheet: X_,
  Shell: Y_,
  Shield: r7,
  ShieldAlert: K_,
  ShieldBan: Z_,
  ShieldCheck: Q_,
  ShieldEllipsis: J_,
  ShieldHalf: e7,
  ShieldMinus: t7,
  ShieldOff: n7,
  ShieldPlus: a7,
  ShieldQuestion: o7,
  ShieldX: Mr,
  Ship: c7,
  ShipWheel: i7,
  Shirt: s7,
  ShoppingBag: l7,
  ShoppingBasket: d7,
  ShoppingCart: u7,
  Shovel: h7,
  ShowerHead: p7,
  Shrink: y7,
  Shrub: k7,
  Shuffle: f7,
  Sigma: m7,
  Signal: L7,
  SignalHigh: g7,
  SignalLow: M7,
  SignalMedium: _7,
  SignalZero: b7,
  Signature: x7,
  Signpost: v7,
  SignpostBig: E7,
  Siren: A7,
  SkipBack: I7,
  SkipForward: T7,
  Skull: N7,
  Slack: C7,
  Slash: w7,
  Slice: S7,
  SlidersHorizontal: R7,
  SlidersVertical: _r,
  Smartphone: P7,
  SmartphoneCharging: D7,
  SmartphoneNfc: O7,
  Smile: B7,
  SmilePlus: H7,
  Snail: F7,
  Snowflake: $7,
  Sofa: U7,
  Soup: q7,
  Space: z7,
  Spade: j7,
  Sparkle: V7,
  Sparkles: br,
  Speaker: G7,
  Speech: W7,
  SpellCheck: Y7,
  SpellCheck2: X7,
  Spline: K7,
  Split: Z7,
  SprayCan: Q7,
  Sprout: J7,
  Square: rb,
  SquareActivity: Lr,
  SquareArrowDown: vr,
  SquareArrowDownLeft: xr,
  SquareArrowDownRight: Er,
  SquareArrowLeft: Ar,
  SquareArrowOutDownLeft: Ir,
  SquareArrowOutDownRight: Tr,
  SquareArrowOutUpLeft: Nr,
  SquareArrowOutUpRight: Cr,
  SquareArrowRight: wr,
  SquareArrowUp: Dr,
  SquareArrowUpLeft: Sr,
  SquareArrowUpRight: Rr,
  SquareAsterisk: Or,
  SquareBottomDashedScissors: Pr,
  SquareChartGantt: hn,
  SquareCheck: Br,
  SquareCheckBig: Hr,
  SquareChevronDown: Fr,
  SquareChevronLeft: $r,
  SquareChevronRight: Ur,
  SquareChevronUp: qr,
  SquareCode: zr,
  SquareDashed: Gr,
  SquareDashedBottom: tb,
  SquareDashedBottomCode: eb,
  SquareDashedKanban: jr,
  SquareDashedMousePointer: Vr,
  SquareDivide: Wr,
  SquareDot: Xr,
  SquareEqual: Yr,
  SquareFunction: Kr,
  SquareKanban: Zr,
  SquareLibrary: Qr,
  SquareM: Jr,
  SquareMenu: e1,
  SquareMinus: t1,
  SquareMousePointer: n1,
  SquareParking: o1,
  SquareParkingOff: a1,
  SquarePen: Pt,
  SquarePercent: r1,
  SquarePi: i1,
  SquarePilcrow: c1,
  SquarePlay: s1,
  SquarePlus: l1,
  SquarePower: d1,
  SquareRadical: nb,
  SquareScissors: u1,
  SquareSigma: h1,
  SquareSlash: p1,
  SquareSplitHorizontal: y1,
  SquareSplitVertical: k1,
  SquareSquare: ab,
  SquareStack: ob,
  SquareTerminal: f1,
  SquareUser: g1,
  SquareUserRound: m1,
  SquareX: M1,
  Squircle: ib,
  Squirrel: cb,
  Stamp: sb,
  Star: ub,
  StarHalf: lb,
  StarOff: db,
  StepBack: hb,
  StepForward: pb,
  Stethoscope: yb,
  Sticker: kb,
  StickyNote: fb,
  Store: mb,
  StretchHorizontal: gb,
  StretchVertical: Mb,
  Strikethrough: _b,
  Subscript: bb,
  Sun: Ab,
  SunDim: Lb,
  SunMedium: xb,
  SunMoon: Eb,
  SunSnow: vb,
  Sunrise: Ib,
  Sunset: Tb,
  Superscript: Nb,
  SwatchBook: Cb,
  SwissFranc: wb,
  SwitchCamera: Sb,
  Sword: Rb,
  Swords: Db,
  Syringe: Ob,
  Table: zb,
  Table2: Pb,
  TableCellsMerge: Hb,
  TableCellsSplit: Bb,
  TableColumnsSplit: Fb,
  TableOfContents: $b,
  TableProperties: Ub,
  TableRowsSplit: qb,
  Tablet: Vb,
  TabletSmartphone: jb,
  Tablets: Gb,
  Tag: Wb,
  Tags: Xb,
  Tally1: Yb,
  Tally2: Kb,
  Tally3: Zb,
  Tally4: Qb,
  Tally5: Jb,
  Tangent: eL,
  Target: tL,
  Telescope: nL,
  Tent: oL,
  TentTree: aL,
  Terminal: rL,
  TestTube: iL,
  TestTubeDiagonal: _1,
  TestTubes: cL,
  Text: hL,
  TextCursor: lL,
  TextCursorInput: sL,
  TextQuote: dL,
  TextSearch: uL,
  TextSelect: b1,
  Theater: pL,
  Thermometer: fL,
  ThermometerSnowflake: yL,
  ThermometerSun: kL,
  ThumbsDown: mL,
  ThumbsUp: gL,
  Ticket: vL,
  TicketCheck: ML,
  TicketMinus: _L,
  TicketPercent: bL,
  TicketPlus: LL,
  TicketSlash: xL,
  TicketX: EL,
  Tickets: IL,
  TicketsPlane: AL,
  Timer: CL,
  TimerOff: TL,
  TimerReset: NL,
  ToggleLeft: wL,
  ToggleRight: SL,
  Toilet: RL,
  Tornado: DL,
  Torus: OL,
  Touchpad: HL,
  TouchpadOff: PL,
  TowerControl: BL,
  ToyBrick: FL,
  Tractor: $L,
  TrafficCone: UL,
  TrainFront: zL,
  TrainFrontTunnel: qL,
  TrainTrack: jL,
  TramFront: L1,
  Transgender: VL,
  Trash: WL,
  Trash2: GL,
  TreeDeciduous: XL,
  TreePalm: x1,
  TreePine: YL,
  Trees: KL,
  Trello: ZL,
  TrendingDown: QL,
  TrendingUp: ex,
  TrendingUpDown: JL,
  Triangle: ax,
  TriangleAlert: E1,
  TriangleDashed: tx,
  TriangleRight: nx,
  Trophy: ox,
  Truck: rx,
  Turtle: ix,
  Tv: sx,
  TvMinimal: v1,
  TvMinimalPlay: cx,
  Twitch: lx,
  Twitter: dx,
  Type: hx,
  TypeOutline: ux,
  Umbrella: yx,
  UmbrellaOff: px,
  Underline: kx,
  Undo: gx,
  Undo2: fx,
  UndoDot: mx,
  UnfoldHorizontal: Mx,
  UnfoldVertical: _x,
  Ungroup: bx,
  University: A1,
  Unlink: xx,
  Unlink2: Lx,
  Unplug: Ex,
  Upload: vx,
  Usb: Ax,
  User: Px,
  UserCheck: Ix,
  UserCog: Tx,
  UserMinus: Nx,
  UserPen: Cx,
  UserPlus: wx,
  UserRound: S1,
  UserRoundCheck: I1,
  UserRoundCog: T1,
  UserRoundMinus: N1,
  UserRoundPen: Sx,
  UserRoundPlus: C1,
  UserRoundSearch: Rx,
  UserRoundX: w1,
  UserSearch: Dx,
  UserX: Ox,
  Users: Hx,
  UsersRound: R1,
  Utensils: O1,
  UtensilsCrossed: D1,
  UtilityPole: Bx,
  Variable: Fx,
  Vault: $x,
  Vegan: Ux,
  VenetianMask: qx,
  Venus: jx,
  VenusAndMars: zx,
  Vibrate: Gx,
  VibrateOff: Vx,
  Video: Xx,
  VideoOff: Wx,
  Videotape: Yx,
  View: Kx,
  Voicemail: Zx,
  Volleyball: Qx,
  Volume: a9,
  Volume1: Jx,
  Volume2: e9,
  VolumeOff: t9,
  VolumeX: n9,
  Vote: o9,
  Wallet: i9,
  WalletCards: r9,
  WalletMinimal: P1,
  Wallpaper: c9,
  Wand: s9,
  WandSparkles: H1,
  Warehouse: l9,
  WashingMachine: d9,
  Watch: u9,
  Waves: p9,
  WavesLadder: h9,
  Waypoints: y9,
  Webcam: k9,
  Webhook: m9,
  WebhookOff: f9,
  Weight: g9,
  Wheat: _9,
  WheatOff: M9,
  WholeWord: b9,
  Wifi: A9,
  WifiHigh: L9,
  WifiLow: x9,
  WifiOff: E9,
  WifiZero: v9,
  Wind: T9,
  WindArrowDown: I9,
  Wine: C9,
  WineOff: N9,
  Workflow: w9,
  Worm: S9,
  WrapText: R9,
  Wrench: D9,
  X: O9,
  Youtube: P9,
  Zap: B9,
  ZapOff: H9,
  ZoomIn: F9,
  ZoomOut: $9
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: Sc,
  AArrowDownIcon: Sc,
  AArrowUp: Rc,
  AArrowUpIcon: Rc,
  ALargeSmall: Dc,
  ALargeSmallIcon: Dc,
  Accessibility: Oc,
  AccessibilityIcon: Oc,
  Activity: Pc,
  ActivityIcon: Pc,
  ActivitySquare: Lr,
  ActivitySquareIcon: Lr,
  AirVent: Hc,
  AirVentIcon: Hc,
  Airplay: Bc,
  AirplayIcon: Bc,
  AlarmCheck: ra,
  AlarmCheckIcon: ra,
  AlarmClock: $c,
  AlarmClockCheck: ra,
  AlarmClockCheckIcon: ra,
  AlarmClockIcon: $c,
  AlarmClockMinus: ia,
  AlarmClockMinusIcon: ia,
  AlarmClockOff: Fc,
  AlarmClockOffIcon: Fc,
  AlarmClockPlus: ca,
  AlarmClockPlusIcon: ca,
  AlarmMinus: ia,
  AlarmMinusIcon: ia,
  AlarmPlus: ca,
  AlarmPlusIcon: ca,
  AlarmSmoke: Uc,
  AlarmSmokeIcon: Uc,
  Album: qc,
  AlbumIcon: qc,
  AlertCircle: Da,
  AlertCircleIcon: Da,
  AlertOctagon: Qo,
  AlertOctagonIcon: Qo,
  AlertTriangle: E1,
  AlertTriangleIcon: E1,
  AlignCenter: Vc,
  AlignCenterHorizontal: zc,
  AlignCenterHorizontalIcon: zc,
  AlignCenterIcon: Vc,
  AlignCenterVertical: jc,
  AlignCenterVerticalIcon: jc,
  AlignEndHorizontal: Gc,
  AlignEndHorizontalIcon: Gc,
  AlignEndVertical: Wc,
  AlignEndVerticalIcon: Wc,
  AlignHorizontalDistributeCenter: Xc,
  AlignHorizontalDistributeCenterIcon: Xc,
  AlignHorizontalDistributeEnd: Yc,
  AlignHorizontalDistributeEndIcon: Yc,
  AlignHorizontalDistributeStart: Kc,
  AlignHorizontalDistributeStartIcon: Kc,
  AlignHorizontalJustifyCenter: Zc,
  AlignHorizontalJustifyCenterIcon: Zc,
  AlignHorizontalJustifyEnd: Qc,
  AlignHorizontalJustifyEndIcon: Qc,
  AlignHorizontalJustifyStart: Jc,
  AlignHorizontalJustifyStartIcon: Jc,
  AlignHorizontalSpaceAround: es,
  AlignHorizontalSpaceAroundIcon: es,
  AlignHorizontalSpaceBetween: ts,
  AlignHorizontalSpaceBetweenIcon: ts,
  AlignJustify: ns,
  AlignJustifyIcon: ns,
  AlignLeft: as,
  AlignLeftIcon: as,
  AlignRight: os,
  AlignRightIcon: os,
  AlignStartHorizontal: rs,
  AlignStartHorizontalIcon: rs,
  AlignStartVertical: is,
  AlignStartVerticalIcon: is,
  AlignVerticalDistributeCenter: cs,
  AlignVerticalDistributeCenterIcon: cs,
  AlignVerticalDistributeEnd: ss,
  AlignVerticalDistributeEndIcon: ss,
  AlignVerticalDistributeStart: ls,
  AlignVerticalDistributeStartIcon: ls,
  AlignVerticalJustifyCenter: ds,
  AlignVerticalJustifyCenterIcon: ds,
  AlignVerticalJustifyEnd: us,
  AlignVerticalJustifyEndIcon: us,
  AlignVerticalJustifyStart: hs,
  AlignVerticalJustifyStartIcon: hs,
  AlignVerticalSpaceAround: ps,
  AlignVerticalSpaceAroundIcon: ps,
  AlignVerticalSpaceBetween: ys,
  AlignVerticalSpaceBetweenIcon: ys,
  Ambulance: ks,
  AmbulanceIcon: ks,
  Ampersand: fs,
  AmpersandIcon: fs,
  Ampersands: ms,
  AmpersandsIcon: ms,
  Amphora: gs,
  AmphoraIcon: gs,
  Anchor: Ms,
  AnchorIcon: Ms,
  Angry: _s,
  AngryIcon: _s,
  Annoyed: bs,
  AnnoyedIcon: bs,
  Antenna: Ls,
  AntennaIcon: Ls,
  Anvil: xs,
  AnvilIcon: xs,
  Aperture: Es,
  ApertureIcon: Es,
  AppWindow: As,
  AppWindowIcon: As,
  AppWindowMac: vs,
  AppWindowMacIcon: vs,
  Apple: Is,
  AppleIcon: Is,
  Archive: Cs,
  ArchiveIcon: Cs,
  ArchiveRestore: Ts,
  ArchiveRestoreIcon: Ts,
  ArchiveX: Ns,
  ArchiveXIcon: Ns,
  AreaChart: ba,
  AreaChartIcon: ba,
  Armchair: ws,
  ArmchairIcon: ws,
  ArrowBigDown: Rs,
  ArrowBigDownDash: Ss,
  ArrowBigDownDashIcon: Ss,
  ArrowBigDownIcon: Rs,
  ArrowBigLeft: Os,
  ArrowBigLeftDash: Ds,
  ArrowBigLeftDashIcon: Ds,
  ArrowBigLeftIcon: Os,
  ArrowBigRight: Hs,
  ArrowBigRightDash: Ps,
  ArrowBigRightDashIcon: Ps,
  ArrowBigRightIcon: Hs,
  ArrowBigUp: Fs,
  ArrowBigUpDash: Bs,
  ArrowBigUpDashIcon: Bs,
  ArrowBigUpIcon: Fs,
  ArrowDown: Ys,
  ArrowDown01: $s,
  ArrowDown01Icon: $s,
  ArrowDown10: Us,
  ArrowDown10Icon: Us,
  ArrowDownAZ: sa,
  ArrowDownAZIcon: sa,
  ArrowDownAz: sa,
  ArrowDownAzIcon: sa,
  ArrowDownCircle: Oa,
  ArrowDownCircleIcon: Oa,
  ArrowDownFromLine: qs,
  ArrowDownFromLineIcon: qs,
  ArrowDownIcon: Ys,
  ArrowDownLeft: zs,
  ArrowDownLeftFromCircle: Ha,
  ArrowDownLeftFromCircleIcon: Ha,
  ArrowDownLeftFromSquare: Ir,
  ArrowDownLeftFromSquareIcon: Ir,
  ArrowDownLeftIcon: zs,
  ArrowDownLeftSquare: xr,
  ArrowDownLeftSquareIcon: xr,
  ArrowDownNarrowWide: js,
  ArrowDownNarrowWideIcon: js,
  ArrowDownRight: Vs,
  ArrowDownRightFromCircle: Ba,
  ArrowDownRightFromCircleIcon: Ba,
  ArrowDownRightFromSquare: Tr,
  ArrowDownRightFromSquareIcon: Tr,
  ArrowDownRightIcon: Vs,
  ArrowDownRightSquare: Er,
  ArrowDownRightSquareIcon: Er,
  ArrowDownSquare: vr,
  ArrowDownSquareIcon: vr,
  ArrowDownToDot: Gs,
  ArrowDownToDotIcon: Gs,
  ArrowDownToLine: Ws,
  ArrowDownToLineIcon: Ws,
  ArrowDownUp: Xs,
  ArrowDownUpIcon: Xs,
  ArrowDownWideNarrow: la,
  ArrowDownWideNarrowIcon: la,
  ArrowDownZA: da,
  ArrowDownZAIcon: da,
  ArrowDownZa: da,
  ArrowDownZaIcon: da,
  ArrowLeft: Js,
  ArrowLeftCircle: Pa,
  ArrowLeftCircleIcon: Pa,
  ArrowLeftFromLine: Ks,
  ArrowLeftFromLineIcon: Ks,
  ArrowLeftIcon: Js,
  ArrowLeftRight: Zs,
  ArrowLeftRightIcon: Zs,
  ArrowLeftSquare: Ar,
  ArrowLeftSquareIcon: Ar,
  ArrowLeftToLine: Qs,
  ArrowLeftToLineIcon: Qs,
  ArrowRight: al,
  ArrowRightCircle: Ua,
  ArrowRightCircleIcon: Ua,
  ArrowRightFromLine: el,
  ArrowRightFromLineIcon: el,
  ArrowRightIcon: al,
  ArrowRightLeft: tl,
  ArrowRightLeftIcon: tl,
  ArrowRightSquare: wr,
  ArrowRightSquareIcon: wr,
  ArrowRightToLine: nl,
  ArrowRightToLineIcon: nl,
  ArrowUp: pl,
  ArrowUp01: ol,
  ArrowUp01Icon: ol,
  ArrowUp10: rl,
  ArrowUp10Icon: rl,
  ArrowUpAZ: ua,
  ArrowUpAZIcon: ua,
  ArrowUpAz: ua,
  ArrowUpAzIcon: ua,
  ArrowUpCircle: qa,
  ArrowUpCircleIcon: qa,
  ArrowUpDown: il,
  ArrowUpDownIcon: il,
  ArrowUpFromDot: cl,
  ArrowUpFromDotIcon: cl,
  ArrowUpFromLine: sl,
  ArrowUpFromLineIcon: sl,
  ArrowUpIcon: pl,
  ArrowUpLeft: ll,
  ArrowUpLeftFromCircle: Fa,
  ArrowUpLeftFromCircleIcon: Fa,
  ArrowUpLeftFromSquare: Nr,
  ArrowUpLeftFromSquareIcon: Nr,
  ArrowUpLeftIcon: ll,
  ArrowUpLeftSquare: Sr,
  ArrowUpLeftSquareIcon: Sr,
  ArrowUpNarrowWide: ha,
  ArrowUpNarrowWideIcon: ha,
  ArrowUpRight: dl,
  ArrowUpRightFromCircle: $a,
  ArrowUpRightFromCircleIcon: $a,
  ArrowUpRightFromSquare: Cr,
  ArrowUpRightFromSquareIcon: Cr,
  ArrowUpRightIcon: dl,
  ArrowUpRightSquare: Rr,
  ArrowUpRightSquareIcon: Rr,
  ArrowUpSquare: Dr,
  ArrowUpSquareIcon: Dr,
  ArrowUpToLine: ul,
  ArrowUpToLineIcon: ul,
  ArrowUpWideNarrow: hl,
  ArrowUpWideNarrowIcon: hl,
  ArrowUpZA: pa,
  ArrowUpZAIcon: pa,
  ArrowUpZa: pa,
  ArrowUpZaIcon: pa,
  ArrowsUpFromLine: yl,
  ArrowsUpFromLineIcon: yl,
  Asterisk: kl,
  AsteriskIcon: kl,
  AsteriskSquare: Or,
  AsteriskSquareIcon: Or,
  AtSign: fl,
  AtSignIcon: fl,
  Atom: ml,
  AtomIcon: ml,
  AudioLines: gl,
  AudioLinesIcon: gl,
  AudioWaveform: Ml,
  AudioWaveformIcon: Ml,
  Award: _l,
  AwardIcon: _l,
  Axe: bl,
  AxeIcon: bl,
  Axis3D: ya,
  Axis3DIcon: ya,
  Axis3d: ya,
  Axis3dIcon: ya,
  Baby: Ll,
  BabyIcon: Ll,
  Backpack: xl,
  BackpackIcon: xl,
  Badge: Fl,
  BadgeAlert: El,
  BadgeAlertIcon: El,
  BadgeCent: vl,
  BadgeCentIcon: vl,
  BadgeCheck: ka,
  BadgeCheckIcon: ka,
  BadgeDollarSign: Al,
  BadgeDollarSignIcon: Al,
  BadgeEuro: Il,
  BadgeEuroIcon: Il,
  BadgeHelp: Tl,
  BadgeHelpIcon: Tl,
  BadgeIcon: Fl,
  BadgeIndianRupee: Nl,
  BadgeIndianRupeeIcon: Nl,
  BadgeInfo: Cl,
  BadgeInfoIcon: Cl,
  BadgeJapaneseYen: wl,
  BadgeJapaneseYenIcon: wl,
  BadgeMinus: Sl,
  BadgeMinusIcon: Sl,
  BadgePercent: Rl,
  BadgePercentIcon: Rl,
  BadgePlus: Dl,
  BadgePlusIcon: Dl,
  BadgePoundSterling: Ol,
  BadgePoundSterlingIcon: Ol,
  BadgeRussianRuble: Pl,
  BadgeRussianRubleIcon: Pl,
  BadgeSwissFranc: Hl,
  BadgeSwissFrancIcon: Hl,
  BadgeX: Bl,
  BadgeXIcon: Bl,
  BaggageClaim: $l,
  BaggageClaimIcon: $l,
  Ban: Ul,
  BanIcon: Ul,
  Banana: ql,
  BananaIcon: ql,
  Bandage: zl,
  BandageIcon: zl,
  Banknote: jl,
  BanknoteIcon: jl,
  BarChart: Na,
  BarChart2: Ca,
  BarChart2Icon: Ca,
  BarChart3: Ia,
  BarChart3Icon: Ia,
  BarChart4: Aa,
  BarChart4Icon: Aa,
  BarChartBig: va,
  BarChartBigIcon: va,
  BarChartHorizontal: xa,
  BarChartHorizontalBig: La,
  BarChartHorizontalBigIcon: La,
  BarChartHorizontalIcon: xa,
  BarChartIcon: Na,
  Barcode: Vl,
  BarcodeIcon: Vl,
  Baseline: Gl,
  BaselineIcon: Gl,
  Bath: Wl,
  BathIcon: Wl,
  Battery: e0,
  BatteryCharging: Xl,
  BatteryChargingIcon: Xl,
  BatteryFull: Yl,
  BatteryFullIcon: Yl,
  BatteryIcon: e0,
  BatteryLow: Kl,
  BatteryLowIcon: Kl,
  BatteryMedium: Zl,
  BatteryMediumIcon: Zl,
  BatteryPlus: Ql,
  BatteryPlusIcon: Ql,
  BatteryWarning: Jl,
  BatteryWarningIcon: Jl,
  Beaker: t0,
  BeakerIcon: t0,
  Bean: a0,
  BeanIcon: a0,
  BeanOff: n0,
  BeanOffIcon: n0,
  Bed: i0,
  BedDouble: o0,
  BedDoubleIcon: o0,
  BedIcon: i0,
  BedSingle: r0,
  BedSingleIcon: r0,
  Beef: c0,
  BeefIcon: c0,
  Beer: l0,
  BeerIcon: l0,
  BeerOff: s0,
  BeerOffIcon: s0,
  Bell: f0,
  BellDot: d0,
  BellDotIcon: d0,
  BellElectric: u0,
  BellElectricIcon: u0,
  BellIcon: f0,
  BellMinus: h0,
  BellMinusIcon: h0,
  BellOff: p0,
  BellOffIcon: p0,
  BellPlus: y0,
  BellPlusIcon: y0,
  BellRing: k0,
  BellRingIcon: k0,
  BetweenHorizonalEnd: fa,
  BetweenHorizonalEndIcon: fa,
  BetweenHorizonalStart: ma,
  BetweenHorizonalStartIcon: ma,
  BetweenHorizontalEnd: fa,
  BetweenHorizontalEndIcon: fa,
  BetweenHorizontalStart: ma,
  BetweenHorizontalStartIcon: ma,
  BetweenVerticalEnd: m0,
  BetweenVerticalEndIcon: m0,
  BetweenVerticalStart: g0,
  BetweenVerticalStartIcon: g0,
  BicepsFlexed: M0,
  BicepsFlexedIcon: M0,
  Bike: _0,
  BikeIcon: _0,
  Binary: b0,
  BinaryIcon: b0,
  Binoculars: L0,
  BinocularsIcon: L0,
  Biohazard: x0,
  BiohazardIcon: x0,
  Bird: E0,
  BirdIcon: E0,
  Bitcoin: v0,
  BitcoinIcon: v0,
  Blend: A0,
  BlendIcon: A0,
  Blinds: I0,
  BlindsIcon: I0,
  Blocks: T0,
  BlocksIcon: T0,
  Bluetooth: S0,
  BluetoothConnected: N0,
  BluetoothConnectedIcon: N0,
  BluetoothIcon: S0,
  BluetoothOff: C0,
  BluetoothOffIcon: C0,
  BluetoothSearching: w0,
  BluetoothSearchingIcon: w0,
  Bold: R0,
  BoldIcon: R0,
  Bolt: D0,
  BoltIcon: D0,
  Bomb: O0,
  BombIcon: O0,
  Bone: P0,
  BoneIcon: P0,
  Book: r2,
  BookA: H0,
  BookAIcon: H0,
  BookAudio: B0,
  BookAudioIcon: B0,
  BookCheck: F0,
  BookCheckIcon: F0,
  BookCopy: $0,
  BookCopyIcon: $0,
  BookDashed: ga,
  BookDashedIcon: ga,
  BookDown: U0,
  BookDownIcon: U0,
  BookHeadphones: q0,
  BookHeadphonesIcon: q0,
  BookHeart: z0,
  BookHeartIcon: z0,
  BookIcon: r2,
  BookImage: j0,
  BookImageIcon: j0,
  BookKey: V0,
  BookKeyIcon: V0,
  BookLock: G0,
  BookLockIcon: G0,
  BookMarked: W0,
  BookMarkedIcon: W0,
  BookMinus: X0,
  BookMinusIcon: X0,
  BookOpen: Z0,
  BookOpenCheck: Y0,
  BookOpenCheckIcon: Y0,
  BookOpenIcon: Z0,
  BookOpenText: K0,
  BookOpenTextIcon: K0,
  BookPlus: Q0,
  BookPlusIcon: Q0,
  BookTemplate: ga,
  BookTemplateIcon: ga,
  BookText: J0,
  BookTextIcon: J0,
  BookType: e2,
  BookTypeIcon: e2,
  BookUp: n2,
  BookUp2: t2,
  BookUp2Icon: t2,
  BookUpIcon: n2,
  BookUser: a2,
  BookUserIcon: a2,
  BookX: o2,
  BookXIcon: o2,
  Bookmark: d2,
  BookmarkCheck: i2,
  BookmarkCheckIcon: i2,
  BookmarkIcon: d2,
  BookmarkMinus: c2,
  BookmarkMinusIcon: c2,
  BookmarkPlus: s2,
  BookmarkPlusIcon: s2,
  BookmarkX: l2,
  BookmarkXIcon: l2,
  BoomBox: u2,
  BoomBoxIcon: u2,
  Bot: y2,
  BotIcon: y2,
  BotMessageSquare: h2,
  BotMessageSquareIcon: h2,
  BotOff: p2,
  BotOffIcon: p2,
  Box: k2,
  BoxIcon: k2,
  BoxSelect: Gr,
  BoxSelectIcon: Gr,
  Boxes: f2,
  BoxesIcon: f2,
  Braces: Ma,
  BracesIcon: Ma,
  Brackets: m2,
  BracketsIcon: m2,
  Brain: _2,
  BrainCircuit: g2,
  BrainCircuitIcon: g2,
  BrainCog: M2,
  BrainCogIcon: M2,
  BrainIcon: _2,
  BrickWall: b2,
  BrickWallIcon: b2,
  Briefcase: v2,
  BriefcaseBusiness: L2,
  BriefcaseBusinessIcon: L2,
  BriefcaseConveyorBelt: x2,
  BriefcaseConveyorBeltIcon: x2,
  BriefcaseIcon: v2,
  BriefcaseMedical: E2,
  BriefcaseMedicalIcon: E2,
  BringToFront: A2,
  BringToFrontIcon: A2,
  Brush: I2,
  BrushIcon: I2,
  Bug: C2,
  BugIcon: C2,
  BugOff: T2,
  BugOffIcon: T2,
  BugPlay: N2,
  BugPlayIcon: N2,
  Building: S2,
  Building2: w2,
  Building2Icon: w2,
  BuildingIcon: S2,
  Bus: D2,
  BusFront: R2,
  BusFrontIcon: R2,
  BusIcon: D2,
  Cable: P2,
  CableCar: O2,
  CableCarIcon: O2,
  CableIcon: P2,
  Cake: B2,
  CakeIcon: B2,
  CakeSlice: H2,
  CakeSliceIcon: H2,
  Calculator: F2,
  CalculatorIcon: F2,
  Calendar: id,
  Calendar1: $2,
  Calendar1Icon: $2,
  CalendarArrowDown: U2,
  CalendarArrowDownIcon: U2,
  CalendarArrowUp: q2,
  CalendarArrowUpIcon: q2,
  CalendarCheck: j2,
  CalendarCheck2: z2,
  CalendarCheck2Icon: z2,
  CalendarCheckIcon: j2,
  CalendarClock: V2,
  CalendarClockIcon: V2,
  CalendarCog: G2,
  CalendarCogIcon: G2,
  CalendarDays: W2,
  CalendarDaysIcon: W2,
  CalendarFold: X2,
  CalendarFoldIcon: X2,
  CalendarHeart: Y2,
  CalendarHeartIcon: Y2,
  CalendarIcon: id,
  CalendarMinus: Z2,
  CalendarMinus2: K2,
  CalendarMinus2Icon: K2,
  CalendarMinusIcon: Z2,
  CalendarOff: Q2,
  CalendarOffIcon: Q2,
  CalendarPlus: ed,
  CalendarPlus2: J2,
  CalendarPlus2Icon: J2,
  CalendarPlusIcon: ed,
  CalendarRange: td,
  CalendarRangeIcon: td,
  CalendarSearch: nd,
  CalendarSearchIcon: nd,
  CalendarSync: ad,
  CalendarSyncIcon: ad,
  CalendarX: rd,
  CalendarX2: od,
  CalendarX2Icon: od,
  CalendarXIcon: rd,
  Camera: sd,
  CameraIcon: sd,
  CameraOff: cd,
  CameraOffIcon: cd,
  CandlestickChart: Ea,
  CandlestickChartIcon: Ea,
  Candy: ud,
  CandyCane: ld,
  CandyCaneIcon: ld,
  CandyIcon: ud,
  CandyOff: dd,
  CandyOffIcon: dd,
  Cannabis: hd,
  CannabisIcon: hd,
  Captions: _a,
  CaptionsIcon: _a,
  CaptionsOff: pd,
  CaptionsOffIcon: pd,
  Car: fd,
  CarFront: yd,
  CarFrontIcon: yd,
  CarIcon: fd,
  CarTaxiFront: kd,
  CarTaxiFrontIcon: kd,
  Caravan: md,
  CaravanIcon: md,
  Carrot: gd,
  CarrotIcon: gd,
  CaseLower: Md,
  CaseLowerIcon: Md,
  CaseSensitive: _d,
  CaseSensitiveIcon: _d,
  CaseUpper: bd,
  CaseUpperIcon: bd,
  CassetteTape: Ld,
  CassetteTapeIcon: Ld,
  Cast: xd,
  CastIcon: xd,
  Castle: Ed,
  CastleIcon: Ed,
  Cat: vd,
  CatIcon: vd,
  Cctv: Ad,
  CctvIcon: Ad,
  ChartArea: ba,
  ChartAreaIcon: ba,
  ChartBar: xa,
  ChartBarBig: La,
  ChartBarBigIcon: La,
  ChartBarDecreasing: Id,
  ChartBarDecreasingIcon: Id,
  ChartBarIcon: xa,
  ChartBarIncreasing: Td,
  ChartBarIncreasingIcon: Td,
  ChartBarStacked: Nd,
  ChartBarStackedIcon: Nd,
  ChartCandlestick: Ea,
  ChartCandlestickIcon: Ea,
  ChartColumn: Ia,
  ChartColumnBig: va,
  ChartColumnBigIcon: va,
  ChartColumnDecreasing: Cd,
  ChartColumnDecreasingIcon: Cd,
  ChartColumnIcon: Ia,
  ChartColumnIncreasing: Aa,
  ChartColumnIncreasingIcon: Aa,
  ChartColumnStacked: wd,
  ChartColumnStackedIcon: wd,
  ChartGantt: Sd,
  ChartGanttIcon: Sd,
  ChartLine: Ta,
  ChartLineIcon: Ta,
  ChartNetwork: Rd,
  ChartNetworkIcon: Rd,
  ChartNoAxesColumn: Ca,
  ChartNoAxesColumnDecreasing: Dd,
  ChartNoAxesColumnDecreasingIcon: Dd,
  ChartNoAxesColumnIcon: Ca,
  ChartNoAxesColumnIncreasing: Na,
  ChartNoAxesColumnIncreasingIcon: Na,
  ChartNoAxesCombined: Od,
  ChartNoAxesCombinedIcon: Od,
  ChartNoAxesGantt: wa,
  ChartNoAxesGanttIcon: wa,
  ChartPie: Sa,
  ChartPieIcon: Sa,
  ChartScatter: Ra,
  ChartScatterIcon: Ra,
  ChartSpline: Pd,
  ChartSplineIcon: Pd,
  Check: Bd,
  CheckCheck: Hd,
  CheckCheckIcon: Hd,
  CheckCircle: za,
  CheckCircle2: ja,
  CheckCircle2Icon: ja,
  CheckCircleIcon: za,
  CheckIcon: Bd,
  CheckSquare: Hr,
  CheckSquare2: Br,
  CheckSquare2Icon: Br,
  CheckSquareIcon: Hr,
  ChefHat: Fd,
  ChefHatIcon: Fd,
  Cherry: $d,
  CherryIcon: $d,
  ChevronDown: Ud,
  ChevronDownCircle: Va,
  ChevronDownCircleIcon: Va,
  ChevronDownIcon: Ud,
  ChevronDownSquare: Fr,
  ChevronDownSquareIcon: Fr,
  ChevronFirst: qd,
  ChevronFirstIcon: qd,
  ChevronLast: zd,
  ChevronLastIcon: zd,
  ChevronLeft: jd,
  ChevronLeftCircle: Ga,
  ChevronLeftCircleIcon: Ga,
  ChevronLeftIcon: jd,
  ChevronLeftSquare: $r,
  ChevronLeftSquareIcon: $r,
  ChevronRight: Vd,
  ChevronRightCircle: Wa,
  ChevronRightCircleIcon: Wa,
  ChevronRightIcon: Vd,
  ChevronRightSquare: Ur,
  ChevronRightSquareIcon: Ur,
  ChevronUp: Gd,
  ChevronUpCircle: Xa,
  ChevronUpCircleIcon: Xa,
  ChevronUpIcon: Gd,
  ChevronUpSquare: qr,
  ChevronUpSquareIcon: qr,
  ChevronsDown: Xd,
  ChevronsDownIcon: Xd,
  ChevronsDownUp: Wd,
  ChevronsDownUpIcon: Wd,
  ChevronsLeft: Zd,
  ChevronsLeftIcon: Zd,
  ChevronsLeftRight: Kd,
  ChevronsLeftRightEllipsis: Yd,
  ChevronsLeftRightEllipsisIcon: Yd,
  ChevronsLeftRightIcon: Kd,
  ChevronsRight: Jd,
  ChevronsRightIcon: Jd,
  ChevronsRightLeft: Qd,
  ChevronsRightLeftIcon: Qd,
  ChevronsUp: tu,
  ChevronsUpDown: eu,
  ChevronsUpDownIcon: eu,
  ChevronsUpIcon: tu,
  Chrome: nu,
  ChromeIcon: nu,
  Church: au,
  ChurchIcon: au,
  Cigarette: ru,
  CigaretteIcon: ru,
  CigaretteOff: ou,
  CigaretteOffIcon: ou,
  Circle: mu,
  CircleAlert: Da,
  CircleAlertIcon: Da,
  CircleArrowDown: Oa,
  CircleArrowDownIcon: Oa,
  CircleArrowLeft: Pa,
  CircleArrowLeftIcon: Pa,
  CircleArrowOutDownLeft: Ha,
  CircleArrowOutDownLeftIcon: Ha,
  CircleArrowOutDownRight: Ba,
  CircleArrowOutDownRightIcon: Ba,
  CircleArrowOutUpLeft: Fa,
  CircleArrowOutUpLeftIcon: Fa,
  CircleArrowOutUpRight: $a,
  CircleArrowOutUpRightIcon: $a,
  CircleArrowRight: Ua,
  CircleArrowRightIcon: Ua,
  CircleArrowUp: qa,
  CircleArrowUpIcon: qa,
  CircleCheck: ja,
  CircleCheckBig: za,
  CircleCheckBigIcon: za,
  CircleCheckIcon: ja,
  CircleChevronDown: Va,
  CircleChevronDownIcon: Va,
  CircleChevronLeft: Ga,
  CircleChevronLeftIcon: Ga,
  CircleChevronRight: Wa,
  CircleChevronRightIcon: Wa,
  CircleChevronUp: Xa,
  CircleChevronUpIcon: Xa,
  CircleDashed: iu,
  CircleDashedIcon: iu,
  CircleDivide: Ya,
  CircleDivideIcon: Ya,
  CircleDollarSign: cu,
  CircleDollarSignIcon: cu,
  CircleDot: lu,
  CircleDotDashed: su,
  CircleDotDashedIcon: su,
  CircleDotIcon: lu,
  CircleEllipsis: du,
  CircleEllipsisIcon: du,
  CircleEqual: uu,
  CircleEqualIcon: uu,
  CircleFadingArrowUp: hu,
  CircleFadingArrowUpIcon: hu,
  CircleFadingPlus: pu,
  CircleFadingPlusIcon: pu,
  CircleGauge: Ka,
  CircleGaugeIcon: Ka,
  CircleHelp: Za,
  CircleHelpIcon: Za,
  CircleIcon: mu,
  CircleMinus: Qa,
  CircleMinusIcon: Qa,
  CircleOff: yu,
  CircleOffIcon: yu,
  CircleParking: eo,
  CircleParkingIcon: eo,
  CircleParkingOff: Ja,
  CircleParkingOffIcon: Ja,
  CirclePause: to,
  CirclePauseIcon: to,
  CirclePercent: no,
  CirclePercentIcon: no,
  CirclePlay: ao,
  CirclePlayIcon: ao,
  CirclePlus: oo,
  CirclePlusIcon: oo,
  CirclePower: ro,
  CirclePowerIcon: ro,
  CircleSlash: ku,
  CircleSlash2: io,
  CircleSlash2Icon: io,
  CircleSlashIcon: ku,
  CircleSlashed: io,
  CircleSlashedIcon: io,
  CircleSmall: fu,
  CircleSmallIcon: fu,
  CircleStop: co,
  CircleStopIcon: co,
  CircleUser: lo,
  CircleUserIcon: lo,
  CircleUserRound: so,
  CircleUserRoundIcon: so,
  CircleX: uo,
  CircleXIcon: uo,
  CircuitBoard: gu,
  CircuitBoardIcon: gu,
  Citrus: Mu,
  CitrusIcon: Mu,
  Clapperboard: _u,
  ClapperboardIcon: _u,
  Clipboard: Nu,
  ClipboardCheck: bu,
  ClipboardCheckIcon: bu,
  ClipboardCopy: Lu,
  ClipboardCopyIcon: Lu,
  ClipboardEdit: po,
  ClipboardEditIcon: po,
  ClipboardIcon: Nu,
  ClipboardList: xu,
  ClipboardListIcon: xu,
  ClipboardMinus: Eu,
  ClipboardMinusIcon: Eu,
  ClipboardPaste: vu,
  ClipboardPasteIcon: vu,
  ClipboardPen: po,
  ClipboardPenIcon: po,
  ClipboardPenLine: ho,
  ClipboardPenLineIcon: ho,
  ClipboardPlus: Au,
  ClipboardPlusIcon: Au,
  ClipboardSignature: ho,
  ClipboardSignatureIcon: ho,
  ClipboardType: Iu,
  ClipboardTypeIcon: Iu,
  ClipboardX: Tu,
  ClipboardXIcon: Tu,
  Clock: Vu,
  Clock1: Cu,
  Clock10: wu,
  Clock10Icon: wu,
  Clock11: Su,
  Clock11Icon: Su,
  Clock12: Ru,
  Clock12Icon: Ru,
  Clock1Icon: Cu,
  Clock2: Du,
  Clock2Icon: Du,
  Clock3: Ou,
  Clock3Icon: Ou,
  Clock4: Pu,
  Clock4Icon: Pu,
  Clock5: Hu,
  Clock5Icon: Hu,
  Clock6: Bu,
  Clock6Icon: Bu,
  Clock7: Fu,
  Clock7Icon: Fu,
  Clock8: $u,
  Clock8Icon: $u,
  Clock9: Uu,
  Clock9Icon: Uu,
  ClockAlert: qu,
  ClockAlertIcon: qu,
  ClockArrowDown: zu,
  ClockArrowDownIcon: zu,
  ClockArrowUp: ju,
  ClockArrowUpIcon: ju,
  ClockIcon: Vu,
  Cloud: ih,
  CloudAlert: Gu,
  CloudAlertIcon: Gu,
  CloudCog: Wu,
  CloudCogIcon: Wu,
  CloudDownload: yo,
  CloudDownloadIcon: yo,
  CloudDrizzle: Xu,
  CloudDrizzleIcon: Xu,
  CloudFog: Yu,
  CloudFogIcon: Yu,
  CloudHail: Ku,
  CloudHailIcon: Ku,
  CloudIcon: ih,
  CloudLightning: Zu,
  CloudLightningIcon: Zu,
  CloudMoon: Ju,
  CloudMoonIcon: Ju,
  CloudMoonRain: Qu,
  CloudMoonRainIcon: Qu,
  CloudOff: eh,
  CloudOffIcon: eh,
  CloudRain: nh,
  CloudRainIcon: nh,
  CloudRainWind: th,
  CloudRainWindIcon: th,
  CloudSnow: ah,
  CloudSnowIcon: ah,
  CloudSun: rh,
  CloudSunIcon: rh,
  CloudSunRain: oh,
  CloudSunRainIcon: oh,
  CloudUpload: ko,
  CloudUploadIcon: ko,
  Cloudy: ch,
  CloudyIcon: ch,
  Clover: sh,
  CloverIcon: sh,
  Club: lh,
  ClubIcon: lh,
  Code: dh,
  Code2: fo,
  Code2Icon: fo,
  CodeIcon: dh,
  CodeSquare: zr,
  CodeSquareIcon: zr,
  CodeXml: fo,
  CodeXmlIcon: fo,
  Codepen: uh,
  CodepenIcon: uh,
  Codesandbox: hh,
  CodesandboxIcon: hh,
  Coffee: ph,
  CoffeeIcon: ph,
  Cog: yh,
  CogIcon: yh,
  Coins: kh,
  CoinsIcon: kh,
  Columns: mo,
  Columns2: mo,
  Columns2Icon: mo,
  Columns3: go,
  Columns3Icon: go,
  Columns4: fh,
  Columns4Icon: fh,
  ColumnsIcon: mo,
  Combine: mh,
  CombineIcon: mh,
  Command: gh,
  CommandIcon: gh,
  Compass: Mh,
  CompassIcon: Mh,
  Component: _h,
  ComponentIcon: _h,
  Computer: bh,
  ComputerIcon: bh,
  ConciergeBell: Lh,
  ConciergeBellIcon: Lh,
  Cone: xh,
  ConeIcon: xh,
  Construction: Eh,
  ConstructionIcon: Eh,
  Contact: vh,
  Contact2: Mo,
  Contact2Icon: Mo,
  ContactIcon: vh,
  ContactRound: Mo,
  ContactRoundIcon: Mo,
  Container: Ah,
  ContainerIcon: Ah,
  Contrast: Ih,
  ContrastIcon: Ih,
  Cookie: Th,
  CookieIcon: Th,
  CookingPot: Nh,
  CookingPotIcon: Nh,
  Copy: Oh,
  CopyCheck: Ch,
  CopyCheckIcon: Ch,
  CopyIcon: Oh,
  CopyMinus: wh,
  CopyMinusIcon: wh,
  CopyPlus: Sh,
  CopyPlusIcon: Sh,
  CopySlash: Rh,
  CopySlashIcon: Rh,
  CopyX: Dh,
  CopyXIcon: Dh,
  Copyleft: Ph,
  CopyleftIcon: Ph,
  Copyright: Hh,
  CopyrightIcon: Hh,
  CornerDownLeft: Bh,
  CornerDownLeftIcon: Bh,
  CornerDownRight: Fh,
  CornerDownRightIcon: Fh,
  CornerLeftDown: $h,
  CornerLeftDownIcon: $h,
  CornerLeftUp: Uh,
  CornerLeftUpIcon: Uh,
  CornerRightDown: qh,
  CornerRightDownIcon: qh,
  CornerRightUp: zh,
  CornerRightUpIcon: zh,
  CornerUpLeft: jh,
  CornerUpLeftIcon: jh,
  CornerUpRight: Vh,
  CornerUpRightIcon: Vh,
  Cpu: Gh,
  CpuIcon: Gh,
  CreativeCommons: Wh,
  CreativeCommonsIcon: Wh,
  CreditCard: Xh,
  CreditCardIcon: Xh,
  Croissant: Yh,
  CroissantIcon: Yh,
  Crop: Kh,
  CropIcon: Kh,
  Cross: Zh,
  CrossIcon: Zh,
  Crosshair: Qh,
  CrosshairIcon: Qh,
  Crown: Jh,
  CrownIcon: Jh,
  Cuboid: ep,
  CuboidIcon: ep,
  CupSoda: tp,
  CupSodaIcon: tp,
  CurlyBraces: Ma,
  CurlyBracesIcon: Ma,
  Currency: np,
  CurrencyIcon: np,
  Cylinder: ap,
  CylinderIcon: ap,
  Dam: op,
  DamIcon: op,
  Database: cp,
  DatabaseBackup: rp,
  DatabaseBackupIcon: rp,
  DatabaseIcon: cp,
  DatabaseZap: ip,
  DatabaseZapIcon: ip,
  Delete: sp,
  DeleteIcon: sp,
  Dessert: lp,
  DessertIcon: lp,
  Diameter: dp,
  DiameterIcon: dp,
  Diamond: pp,
  DiamondIcon: pp,
  DiamondMinus: up,
  DiamondMinusIcon: up,
  DiamondPercent: _o,
  DiamondPercentIcon: _o,
  DiamondPlus: hp,
  DiamondPlusIcon: hp,
  Dice1: yp,
  Dice1Icon: yp,
  Dice2: kp,
  Dice2Icon: kp,
  Dice3: fp,
  Dice3Icon: fp,
  Dice4: mp,
  Dice4Icon: mp,
  Dice5: gp,
  Dice5Icon: gp,
  Dice6: Mp,
  Dice6Icon: Mp,
  Dices: _p,
  DicesIcon: _p,
  Diff: bp,
  DiffIcon: bp,
  Disc: vp,
  Disc2: Lp,
  Disc2Icon: Lp,
  Disc3: xp,
  Disc3Icon: xp,
  DiscAlbum: Ep,
  DiscAlbumIcon: Ep,
  DiscIcon: vp,
  Divide: Ap,
  DivideCircle: Ya,
  DivideCircleIcon: Ya,
  DivideIcon: Ap,
  DivideSquare: Wr,
  DivideSquareIcon: Wr,
  Dna: Tp,
  DnaIcon: Tp,
  DnaOff: Ip,
  DnaOffIcon: Ip,
  Dock: Np,
  DockIcon: Np,
  Dog: Cp,
  DogIcon: Cp,
  DollarSign: wp,
  DollarSignIcon: wp,
  Donut: Sp,
  DonutIcon: Sp,
  DoorClosed: Rp,
  DoorClosedIcon: Rp,
  DoorOpen: Dp,
  DoorOpenIcon: Dp,
  Dot: Op,
  DotIcon: Op,
  DotSquare: Xr,
  DotSquareIcon: Xr,
  Download: Pp,
  DownloadCloud: yo,
  DownloadCloudIcon: yo,
  DownloadIcon: Pp,
  DraftingCompass: Hp,
  DraftingCompassIcon: Hp,
  Drama: Bp,
  DramaIcon: Bp,
  Dribbble: Fp,
  DribbbleIcon: Fp,
  Drill: $p,
  DrillIcon: $p,
  Droplet: qp,
  DropletIcon: qp,
  DropletOff: Up,
  DropletOffIcon: Up,
  Droplets: zp,
  DropletsIcon: zp,
  Drum: jp,
  DrumIcon: jp,
  Drumstick: Vp,
  DrumstickIcon: Vp,
  Dumbbell: Gp,
  DumbbellIcon: Gp,
  Ear: Xp,
  EarIcon: Xp,
  EarOff: Wp,
  EarOffIcon: Wp,
  Earth: bo,
  EarthIcon: bo,
  EarthLock: Yp,
  EarthLockIcon: Yp,
  Eclipse: Kp,
  EclipseIcon: Kp,
  Edit: Pt,
  Edit2: ur,
  Edit2Icon: ur,
  Edit3: dr,
  Edit3Icon: dr,
  EditIcon: Pt,
  Egg: Jp,
  EggFried: Zp,
  EggFriedIcon: Zp,
  EggIcon: Jp,
  EggOff: Qp,
  EggOffIcon: Qp,
  Ellipsis: xo,
  EllipsisIcon: xo,
  EllipsisVertical: Lo,
  EllipsisVerticalIcon: Lo,
  Equal: ny,
  EqualApproximately: ey,
  EqualApproximatelyIcon: ey,
  EqualIcon: ny,
  EqualNot: ty,
  EqualNotIcon: ty,
  EqualSquare: Yr,
  EqualSquareIcon: Yr,
  Eraser: ay,
  EraserIcon: ay,
  EthernetPort: oy,
  EthernetPortIcon: oy,
  Euro: ry,
  EuroIcon: ry,
  Expand: iy,
  ExpandIcon: iy,
  ExternalLink: cy,
  ExternalLinkIcon: cy,
  Eye: dy,
  EyeClosed: sy,
  EyeClosedIcon: sy,
  EyeIcon: dy,
  EyeOff: ly,
  EyeOffIcon: ly,
  Facebook: uy,
  FacebookIcon: uy,
  Factory: hy,
  FactoryIcon: hy,
  Fan: py,
  FanIcon: py,
  FastForward: yy,
  FastForwardIcon: yy,
  Feather: ky,
  FeatherIcon: ky,
  Fence: fy,
  FenceIcon: fy,
  FerrisWheel: my,
  FerrisWheelIcon: my,
  Figma: gy,
  FigmaIcon: gy,
  File: kk,
  FileArchive: My,
  FileArchiveIcon: My,
  FileAudio: by,
  FileAudio2: _y,
  FileAudio2Icon: _y,
  FileAudioIcon: by,
  FileAxis3D: Eo,
  FileAxis3DIcon: Eo,
  FileAxis3d: Eo,
  FileAxis3dIcon: Eo,
  FileBadge: xy,
  FileBadge2: Ly,
  FileBadge2Icon: Ly,
  FileBadgeIcon: xy,
  FileBarChart: vo,
  FileBarChart2: Ao,
  FileBarChart2Icon: Ao,
  FileBarChartIcon: vo,
  FileBox: Ey,
  FileBoxIcon: Ey,
  FileChartColumn: Ao,
  FileChartColumnIcon: Ao,
  FileChartColumnIncreasing: vo,
  FileChartColumnIncreasingIcon: vo,
  FileChartLine: Io,
  FileChartLineIcon: Io,
  FileChartPie: To,
  FileChartPieIcon: To,
  FileCheck: Ay,
  FileCheck2: vy,
  FileCheck2Icon: vy,
  FileCheckIcon: Ay,
  FileClock: Iy,
  FileClockIcon: Iy,
  FileCode: Ny,
  FileCode2: Ty,
  FileCode2Icon: Ty,
  FileCodeIcon: Ny,
  FileCog: No,
  FileCog2: No,
  FileCog2Icon: No,
  FileCogIcon: No,
  FileDiff: Cy,
  FileDiffIcon: Cy,
  FileDigit: wy,
  FileDigitIcon: wy,
  FileDown: Sy,
  FileDownIcon: Sy,
  FileEdit: wo,
  FileEditIcon: wo,
  FileHeart: Ry,
  FileHeartIcon: Ry,
  FileIcon: kk,
  FileImage: Dy,
  FileImageIcon: Dy,
  FileInput: Oy,
  FileInputIcon: Oy,
  FileJson: Hy,
  FileJson2: Py,
  FileJson2Icon: Py,
  FileJsonIcon: Hy,
  FileKey: Fy,
  FileKey2: By,
  FileKey2Icon: By,
  FileKeyIcon: Fy,
  FileLineChart: Io,
  FileLineChartIcon: Io,
  FileLock: Uy,
  FileLock2: $y,
  FileLock2Icon: $y,
  FileLockIcon: Uy,
  FileMinus: zy,
  FileMinus2: qy,
  FileMinus2Icon: qy,
  FileMinusIcon: zy,
  FileMusic: jy,
  FileMusicIcon: jy,
  FileOutput: Vy,
  FileOutputIcon: Vy,
  FilePen: wo,
  FilePenIcon: wo,
  FilePenLine: Co,
  FilePenLineIcon: Co,
  FilePieChart: To,
  FilePieChartIcon: To,
  FilePlus: Wy,
  FilePlus2: Gy,
  FilePlus2Icon: Gy,
  FilePlusIcon: Wy,
  FileQuestion: Xy,
  FileQuestionIcon: Xy,
  FileScan: Yy,
  FileScanIcon: Yy,
  FileSearch: Zy,
  FileSearch2: Ky,
  FileSearch2Icon: Ky,
  FileSearchIcon: Zy,
  FileSignature: Co,
  FileSignatureIcon: Co,
  FileSliders: Qy,
  FileSlidersIcon: Qy,
  FileSpreadsheet: Jy,
  FileSpreadsheetIcon: Jy,
  FileStack: ek,
  FileStackIcon: ek,
  FileSymlink: tk,
  FileSymlinkIcon: tk,
  FileTerminal: nk,
  FileTerminalIcon: nk,
  FileText: ak,
  FileTextIcon: ak,
  FileType: rk,
  FileType2: ok,
  FileType2Icon: ok,
  FileTypeIcon: rk,
  FileUp: ik,
  FileUpIcon: ik,
  FileUser: ck,
  FileUserIcon: ck,
  FileVideo: lk,
  FileVideo2: sk,
  FileVideo2Icon: sk,
  FileVideoIcon: lk,
  FileVolume: uk,
  FileVolume2: dk,
  FileVolume2Icon: dk,
  FileVolumeIcon: uk,
  FileWarning: hk,
  FileWarningIcon: hk,
  FileX: yk,
  FileX2: pk,
  FileX2Icon: pk,
  FileXIcon: yk,
  Files: fk,
  FilesIcon: fk,
  Film: mk,
  FilmIcon: mk,
  Filter: Mk,
  FilterIcon: Mk,
  FilterX: gk,
  FilterXIcon: gk,
  Fingerprint: _k,
  FingerprintIcon: _k,
  FireExtinguisher: bk,
  FireExtinguisherIcon: bk,
  Fish: Ek,
  FishIcon: Ek,
  FishOff: Lk,
  FishOffIcon: Lk,
  FishSymbol: xk,
  FishSymbolIcon: xk,
  Flag: Tk,
  FlagIcon: Tk,
  FlagOff: vk,
  FlagOffIcon: vk,
  FlagTriangleLeft: Ak,
  FlagTriangleLeftIcon: Ak,
  FlagTriangleRight: Ik,
  FlagTriangleRightIcon: Ik,
  Flame: Ck,
  FlameIcon: Ck,
  FlameKindling: Nk,
  FlameKindlingIcon: Nk,
  Flashlight: Sk,
  FlashlightIcon: Sk,
  FlashlightOff: wk,
  FlashlightOffIcon: wk,
  FlaskConical: Dk,
  FlaskConicalIcon: Dk,
  FlaskConicalOff: Rk,
  FlaskConicalOffIcon: Rk,
  FlaskRound: Ok,
  FlaskRoundIcon: Ok,
  FlipHorizontal: Hk,
  FlipHorizontal2: Pk,
  FlipHorizontal2Icon: Pk,
  FlipHorizontalIcon: Hk,
  FlipVertical: Fk,
  FlipVertical2: Bk,
  FlipVertical2Icon: Bk,
  FlipVerticalIcon: Fk,
  Flower: Uk,
  Flower2: $k,
  Flower2Icon: $k,
  FlowerIcon: Uk,
  Focus: qk,
  FocusIcon: qk,
  FoldHorizontal: zk,
  FoldHorizontalIcon: zk,
  FoldVertical: jk,
  FoldVerticalIcon: jk,
  Folder: g4,
  FolderArchive: Vk,
  FolderArchiveIcon: Vk,
  FolderCheck: Gk,
  FolderCheckIcon: Gk,
  FolderClock: Wk,
  FolderClockIcon: Wk,
  FolderClosed: Xk,
  FolderClosedIcon: Xk,
  FolderCode: Yk,
  FolderCodeIcon: Yk,
  FolderCog: So,
  FolderCog2: So,
  FolderCog2Icon: So,
  FolderCogIcon: So,
  FolderDot: Kk,
  FolderDotIcon: Kk,
  FolderDown: Zk,
  FolderDownIcon: Zk,
  FolderEdit: Ro,
  FolderEditIcon: Ro,
  FolderGit: Jk,
  FolderGit2: Qk,
  FolderGit2Icon: Qk,
  FolderGitIcon: Jk,
  FolderHeart: e4,
  FolderHeartIcon: e4,
  FolderIcon: g4,
  FolderInput: t4,
  FolderInputIcon: t4,
  FolderKanban: n4,
  FolderKanbanIcon: n4,
  FolderKey: a4,
  FolderKeyIcon: a4,
  FolderLock: o4,
  FolderLockIcon: o4,
  FolderMinus: r4,
  FolderMinusIcon: r4,
  FolderOpen: c4,
  FolderOpenDot: i4,
  FolderOpenDotIcon: i4,
  FolderOpenIcon: c4,
  FolderOutput: s4,
  FolderOutputIcon: s4,
  FolderPen: Ro,
  FolderPenIcon: Ro,
  FolderPlus: l4,
  FolderPlusIcon: l4,
  FolderRoot: d4,
  FolderRootIcon: d4,
  FolderSearch: h4,
  FolderSearch2: u4,
  FolderSearch2Icon: u4,
  FolderSearchIcon: h4,
  FolderSymlink: p4,
  FolderSymlinkIcon: p4,
  FolderSync: y4,
  FolderSyncIcon: y4,
  FolderTree: k4,
  FolderTreeIcon: k4,
  FolderUp: f4,
  FolderUpIcon: f4,
  FolderX: m4,
  FolderXIcon: m4,
  Folders: M4,
  FoldersIcon: M4,
  Footprints: _4,
  FootprintsIcon: _4,
  ForkKnife: O1,
  ForkKnifeCrossed: D1,
  ForkKnifeCrossedIcon: D1,
  ForkKnifeIcon: O1,
  Forklift: b4,
  ForkliftIcon: b4,
  FormInput: pr,
  FormInputIcon: pr,
  Forward: L4,
  ForwardIcon: L4,
  Frame: x4,
  FrameIcon: x4,
  Framer: E4,
  FramerIcon: E4,
  Frown: v4,
  FrownIcon: v4,
  Fuel: A4,
  FuelIcon: A4,
  Fullscreen: I4,
  FullscreenIcon: I4,
  FunctionSquare: Kr,
  FunctionSquareIcon: Kr,
  GalleryHorizontal: N4,
  GalleryHorizontalEnd: T4,
  GalleryHorizontalEndIcon: T4,
  GalleryHorizontalIcon: N4,
  GalleryThumbnails: C4,
  GalleryThumbnailsIcon: C4,
  GalleryVertical: S4,
  GalleryVerticalEnd: w4,
  GalleryVerticalEndIcon: w4,
  GalleryVerticalIcon: S4,
  Gamepad: D4,
  Gamepad2: R4,
  Gamepad2Icon: R4,
  GamepadIcon: D4,
  GanttChart: wa,
  GanttChartIcon: wa,
  GanttChartSquare: hn,
  GanttChartSquareIcon: hn,
  Gauge: O4,
  GaugeCircle: Ka,
  GaugeCircleIcon: Ka,
  GaugeIcon: O4,
  Gavel: P4,
  GavelIcon: P4,
  Gem: H4,
  GemIcon: H4,
  Ghost: B4,
  GhostIcon: B4,
  Gift: F4,
  GiftIcon: F4,
  GitBranch: U4,
  GitBranchIcon: U4,
  GitBranchPlus: $4,
  GitBranchPlusIcon: $4,
  GitCommit: Do,
  GitCommitHorizontal: Do,
  GitCommitHorizontalIcon: Do,
  GitCommitIcon: Do,
  GitCommitVertical: q4,
  GitCommitVerticalIcon: q4,
  GitCompare: j4,
  GitCompareArrows: z4,
  GitCompareArrowsIcon: z4,
  GitCompareIcon: j4,
  GitFork: V4,
  GitForkIcon: V4,
  GitGraph: G4,
  GitGraphIcon: G4,
  GitMerge: W4,
  GitMergeIcon: W4,
  GitPullRequest: J4,
  GitPullRequestArrow: X4,
  GitPullRequestArrowIcon: X4,
  GitPullRequestClosed: Y4,
  GitPullRequestClosedIcon: Y4,
  GitPullRequestCreate: Z4,
  GitPullRequestCreateArrow: K4,
  GitPullRequestCreateArrowIcon: K4,
  GitPullRequestCreateIcon: Z4,
  GitPullRequestDraft: Q4,
  GitPullRequestDraftIcon: Q4,
  GitPullRequestIcon: J4,
  Github: ef,
  GithubIcon: ef,
  Gitlab: tf,
  GitlabIcon: tf,
  GlassWater: nf,
  GlassWaterIcon: nf,
  Glasses: af,
  GlassesIcon: af,
  Globe: rf,
  Globe2: bo,
  Globe2Icon: bo,
  GlobeIcon: rf,
  GlobeLock: of,
  GlobeLockIcon: of,
  Goal: cf,
  GoalIcon: cf,
  Grab: sf,
  GrabIcon: sf,
  GraduationCap: lf,
  GraduationCapIcon: lf,
  Grape: df,
  GrapeIcon: df,
  Grid: un,
  Grid2X2: Bo,
  Grid2X2Check: Oo,
  Grid2X2CheckIcon: Oo,
  Grid2X2Icon: Bo,
  Grid2X2Plus: Po,
  Grid2X2PlusIcon: Po,
  Grid2X2X: Ho,
  Grid2X2XIcon: Ho,
  Grid2x2: Bo,
  Grid2x2Check: Oo,
  Grid2x2CheckIcon: Oo,
  Grid2x2Icon: Bo,
  Grid2x2Plus: Po,
  Grid2x2PlusIcon: Po,
  Grid2x2X: Ho,
  Grid2x2XIcon: Ho,
  Grid3X3: un,
  Grid3X3Icon: un,
  Grid3x3: un,
  Grid3x3Icon: un,
  GridIcon: un,
  Grip: pf,
  GripHorizontal: uf,
  GripHorizontalIcon: uf,
  GripIcon: pf,
  GripVertical: hf,
  GripVerticalIcon: hf,
  Group: yf,
  GroupIcon: yf,
  Guitar: kf,
  GuitarIcon: kf,
  Ham: ff,
  HamIcon: ff,
  Hammer: mf,
  HammerIcon: mf,
  Hand: Lf,
  HandCoins: gf,
  HandCoinsIcon: gf,
  HandHeart: Mf,
  HandHeartIcon: Mf,
  HandHelping: Fo,
  HandHelpingIcon: Fo,
  HandIcon: Lf,
  HandMetal: _f,
  HandMetalIcon: _f,
  HandPlatter: bf,
  HandPlatterIcon: bf,
  Handshake: xf,
  HandshakeIcon: xf,
  HardDrive: Af,
  HardDriveDownload: Ef,
  HardDriveDownloadIcon: Ef,
  HardDriveIcon: Af,
  HardDriveUpload: vf,
  HardDriveUploadIcon: vf,
  HardHat: If,
  HardHatIcon: If,
  Hash: Tf,
  HashIcon: Tf,
  Haze: Nf,
  HazeIcon: Nf,
  HdmiPort: Cf,
  HdmiPortIcon: Cf,
  Heading: Hf,
  Heading1: wf,
  Heading1Icon: wf,
  Heading2: Sf,
  Heading2Icon: Sf,
  Heading3: Rf,
  Heading3Icon: Rf,
  Heading4: Df,
  Heading4Icon: Df,
  Heading5: Of,
  Heading5Icon: Of,
  Heading6: Pf,
  Heading6Icon: Pf,
  HeadingIcon: Hf,
  HeadphoneOff: Bf,
  HeadphoneOffIcon: Bf,
  Headphones: Ff,
  HeadphonesIcon: Ff,
  Headset: $f,
  HeadsetIcon: $f,
  Heart: Vf,
  HeartCrack: Uf,
  HeartCrackIcon: Uf,
  HeartHandshake: qf,
  HeartHandshakeIcon: qf,
  HeartIcon: Vf,
  HeartOff: zf,
  HeartOffIcon: zf,
  HeartPulse: jf,
  HeartPulseIcon: jf,
  Heater: Gf,
  HeaterIcon: Gf,
  HelpCircle: Za,
  HelpCircleIcon: Za,
  HelpingHand: Fo,
  HelpingHandIcon: Fo,
  Hexagon: Wf,
  HexagonIcon: Wf,
  Highlighter: Xf,
  HighlighterIcon: Xf,
  History: Yf,
  HistoryIcon: Yf,
  Home: $o,
  HomeIcon: $o,
  Hop: Zf,
  HopIcon: Zf,
  HopOff: Kf,
  HopOffIcon: Kf,
  Hospital: Qf,
  HospitalIcon: Qf,
  Hotel: Jf,
  HotelIcon: Jf,
  Hourglass: e3,
  HourglassIcon: e3,
  House: $o,
  HouseIcon: $o,
  HousePlug: t3,
  HousePlugIcon: t3,
  HousePlus: n3,
  HousePlusIcon: n3,
  HouseWifi: a3,
  HouseWifiIcon: a3,
  IceCream: qo,
  IceCream2: Uo,
  IceCream2Icon: Uo,
  IceCreamBowl: Uo,
  IceCreamBowlIcon: Uo,
  IceCreamCone: qo,
  IceCreamConeIcon: qo,
  IceCreamIcon: qo,
  Icon: JT,
  IdCard: o3,
  IdCardIcon: o3,
  Image: h3,
  ImageDown: r3,
  ImageDownIcon: r3,
  ImageIcon: h3,
  ImageMinus: i3,
  ImageMinusIcon: i3,
  ImageOff: c3,
  ImageOffIcon: c3,
  ImagePlay: s3,
  ImagePlayIcon: s3,
  ImagePlus: l3,
  ImagePlusIcon: l3,
  ImageUp: d3,
  ImageUpIcon: d3,
  ImageUpscale: u3,
  ImageUpscaleIcon: u3,
  Images: p3,
  ImagesIcon: p3,
  Import: y3,
  ImportIcon: y3,
  Inbox: k3,
  InboxIcon: k3,
  Indent: jo,
  IndentDecrease: zo,
  IndentDecreaseIcon: zo,
  IndentIcon: jo,
  IndentIncrease: jo,
  IndentIncreaseIcon: jo,
  IndianRupee: f3,
  IndianRupeeIcon: f3,
  Infinity: m3,
  InfinityIcon: m3,
  Info: g3,
  InfoIcon: g3,
  Inspect: n1,
  InspectIcon: n1,
  InspectionPanel: M3,
  InspectionPanelIcon: M3,
  Instagram: _3,
  InstagramIcon: _3,
  Italic: b3,
  ItalicIcon: b3,
  IterationCcw: L3,
  IterationCcwIcon: L3,
  IterationCw: x3,
  IterationCwIcon: x3,
  JapaneseYen: E3,
  JapaneseYenIcon: E3,
  Joystick: v3,
  JoystickIcon: v3,
  Kanban: A3,
  KanbanIcon: A3,
  KanbanSquare: Zr,
  KanbanSquareDashed: jr,
  KanbanSquareDashedIcon: jr,
  KanbanSquareIcon: Zr,
  Key: N3,
  KeyIcon: N3,
  KeyRound: I3,
  KeyRoundIcon: I3,
  KeySquare: T3,
  KeySquareIcon: T3,
  Keyboard: S3,
  KeyboardIcon: S3,
  KeyboardMusic: C3,
  KeyboardMusicIcon: C3,
  KeyboardOff: w3,
  KeyboardOffIcon: w3,
  Lamp: B3,
  LampCeiling: R3,
  LampCeilingIcon: R3,
  LampDesk: D3,
  LampDeskIcon: D3,
  LampFloor: O3,
  LampFloorIcon: O3,
  LampIcon: B3,
  LampWallDown: P3,
  LampWallDownIcon: P3,
  LampWallUp: H3,
  LampWallUpIcon: H3,
  LandPlot: F3,
  LandPlotIcon: F3,
  Landmark: $3,
  LandmarkIcon: $3,
  Languages: U3,
  LanguagesIcon: U3,
  Laptop: z3,
  Laptop2: Vo,
  Laptop2Icon: Vo,
  LaptopIcon: z3,
  LaptopMinimal: Vo,
  LaptopMinimalCheck: q3,
  LaptopMinimalCheckIcon: q3,
  LaptopMinimalIcon: Vo,
  Lasso: V3,
  LassoIcon: V3,
  LassoSelect: j3,
  LassoSelectIcon: j3,
  Laugh: G3,
  LaughIcon: G3,
  Layers: Go,
  Layers2: W3,
  Layers2Icon: W3,
  Layers3: Go,
  Layers3Icon: Go,
  LayersIcon: Go,
  Layout: lr,
  LayoutDashboard: X3,
  LayoutDashboardIcon: X3,
  LayoutGrid: Y3,
  LayoutGridIcon: Y3,
  LayoutIcon: lr,
  LayoutList: K3,
  LayoutListIcon: K3,
  LayoutPanelLeft: Z3,
  LayoutPanelLeftIcon: Z3,
  LayoutPanelTop: Q3,
  LayoutPanelTopIcon: Q3,
  LayoutTemplate: J3,
  LayoutTemplateIcon: J3,
  Leaf: e5,
  LeafIcon: e5,
  LeafyGreen: t5,
  LeafyGreenIcon: t5,
  Lectern: n5,
  LecternIcon: n5,
  LetterText: a5,
  LetterTextIcon: a5,
  Library: r5,
  LibraryBig: o5,
  LibraryBigIcon: o5,
  LibraryIcon: r5,
  LibrarySquare: Qr,
  LibrarySquareIcon: Qr,
  LifeBuoy: i5,
  LifeBuoyIcon: i5,
  Ligature: c5,
  LigatureIcon: c5,
  Lightbulb: l5,
  LightbulbIcon: l5,
  LightbulbOff: s5,
  LightbulbOffIcon: s5,
  LineChart: Ta,
  LineChartIcon: Ta,
  Link: h5,
  Link2: u5,
  Link2Icon: u5,
  Link2Off: d5,
  Link2OffIcon: d5,
  LinkIcon: h5,
  Linkedin: p5,
  LinkedinIcon: p5,
  List: C5,
  ListCheck: y5,
  ListCheckIcon: y5,
  ListChecks: k5,
  ListChecksIcon: k5,
  ListCollapse: f5,
  ListCollapseIcon: f5,
  ListEnd: m5,
  ListEndIcon: m5,
  ListFilter: M5,
  ListFilterIcon: M5,
  ListFilterPlus: g5,
  ListFilterPlusIcon: g5,
  ListIcon: C5,
  ListMinus: _5,
  ListMinusIcon: _5,
  ListMusic: b5,
  ListMusicIcon: b5,
  ListOrdered: L5,
  ListOrderedIcon: L5,
  ListPlus: x5,
  ListPlusIcon: x5,
  ListRestart: E5,
  ListRestartIcon: E5,
  ListStart: v5,
  ListStartIcon: v5,
  ListTodo: A5,
  ListTodoIcon: A5,
  ListTree: I5,
  ListTreeIcon: I5,
  ListVideo: T5,
  ListVideoIcon: T5,
  ListX: N5,
  ListXIcon: N5,
  Loader: S5,
  Loader2: Wo,
  Loader2Icon: Wo,
  LoaderCircle: Wo,
  LoaderCircleIcon: Wo,
  LoaderIcon: S5,
  LoaderPinwheel: w5,
  LoaderPinwheelIcon: w5,
  Locate: O5,
  LocateFixed: R5,
  LocateFixedIcon: R5,
  LocateIcon: O5,
  LocateOff: D5,
  LocateOffIcon: D5,
  Lock: H5,
  LockIcon: H5,
  LockKeyhole: P5,
  LockKeyholeIcon: P5,
  LockKeyholeOpen: Xo,
  LockKeyholeOpenIcon: Xo,
  LockOpen: Yo,
  LockOpenIcon: Yo,
  LogIn: B5,
  LogInIcon: B5,
  LogOut: F5,
  LogOutIcon: F5,
  Logs: $5,
  LogsIcon: $5,
  Lollipop: U5,
  LollipopIcon: U5,
  LucideAArrowDown: Sc,
  LucideAArrowUp: Rc,
  LucideALargeSmall: Dc,
  LucideAccessibility: Oc,
  LucideActivity: Pc,
  LucideActivitySquare: Lr,
  LucideAirVent: Hc,
  LucideAirplay: Bc,
  LucideAlarmCheck: ra,
  LucideAlarmClock: $c,
  LucideAlarmClockCheck: ra,
  LucideAlarmClockMinus: ia,
  LucideAlarmClockOff: Fc,
  LucideAlarmClockPlus: ca,
  LucideAlarmMinus: ia,
  LucideAlarmPlus: ca,
  LucideAlarmSmoke: Uc,
  LucideAlbum: qc,
  LucideAlertCircle: Da,
  LucideAlertOctagon: Qo,
  LucideAlertTriangle: E1,
  LucideAlignCenter: Vc,
  LucideAlignCenterHorizontal: zc,
  LucideAlignCenterVertical: jc,
  LucideAlignEndHorizontal: Gc,
  LucideAlignEndVertical: Wc,
  LucideAlignHorizontalDistributeCenter: Xc,
  LucideAlignHorizontalDistributeEnd: Yc,
  LucideAlignHorizontalDistributeStart: Kc,
  LucideAlignHorizontalJustifyCenter: Zc,
  LucideAlignHorizontalJustifyEnd: Qc,
  LucideAlignHorizontalJustifyStart: Jc,
  LucideAlignHorizontalSpaceAround: es,
  LucideAlignHorizontalSpaceBetween: ts,
  LucideAlignJustify: ns,
  LucideAlignLeft: as,
  LucideAlignRight: os,
  LucideAlignStartHorizontal: rs,
  LucideAlignStartVertical: is,
  LucideAlignVerticalDistributeCenter: cs,
  LucideAlignVerticalDistributeEnd: ss,
  LucideAlignVerticalDistributeStart: ls,
  LucideAlignVerticalJustifyCenter: ds,
  LucideAlignVerticalJustifyEnd: us,
  LucideAlignVerticalJustifyStart: hs,
  LucideAlignVerticalSpaceAround: ps,
  LucideAlignVerticalSpaceBetween: ys,
  LucideAmbulance: ks,
  LucideAmpersand: fs,
  LucideAmpersands: ms,
  LucideAmphora: gs,
  LucideAnchor: Ms,
  LucideAngry: _s,
  LucideAnnoyed: bs,
  LucideAntenna: Ls,
  LucideAnvil: xs,
  LucideAperture: Es,
  LucideAppWindow: As,
  LucideAppWindowMac: vs,
  LucideApple: Is,
  LucideArchive: Cs,
  LucideArchiveRestore: Ts,
  LucideArchiveX: Ns,
  LucideAreaChart: ba,
  LucideArmchair: ws,
  LucideArrowBigDown: Rs,
  LucideArrowBigDownDash: Ss,
  LucideArrowBigLeft: Os,
  LucideArrowBigLeftDash: Ds,
  LucideArrowBigRight: Hs,
  LucideArrowBigRightDash: Ps,
  LucideArrowBigUp: Fs,
  LucideArrowBigUpDash: Bs,
  LucideArrowDown: Ys,
  LucideArrowDown01: $s,
  LucideArrowDown10: Us,
  LucideArrowDownAZ: sa,
  LucideArrowDownAz: sa,
  LucideArrowDownCircle: Oa,
  LucideArrowDownFromLine: qs,
  LucideArrowDownLeft: zs,
  LucideArrowDownLeftFromCircle: Ha,
  LucideArrowDownLeftFromSquare: Ir,
  LucideArrowDownLeftSquare: xr,
  LucideArrowDownNarrowWide: js,
  LucideArrowDownRight: Vs,
  LucideArrowDownRightFromCircle: Ba,
  LucideArrowDownRightFromSquare: Tr,
  LucideArrowDownRightSquare: Er,
  LucideArrowDownSquare: vr,
  LucideArrowDownToDot: Gs,
  LucideArrowDownToLine: Ws,
  LucideArrowDownUp: Xs,
  LucideArrowDownWideNarrow: la,
  LucideArrowDownZA: da,
  LucideArrowDownZa: da,
  LucideArrowLeft: Js,
  LucideArrowLeftCircle: Pa,
  LucideArrowLeftFromLine: Ks,
  LucideArrowLeftRight: Zs,
  LucideArrowLeftSquare: Ar,
  LucideArrowLeftToLine: Qs,
  LucideArrowRight: al,
  LucideArrowRightCircle: Ua,
  LucideArrowRightFromLine: el,
  LucideArrowRightLeft: tl,
  LucideArrowRightSquare: wr,
  LucideArrowRightToLine: nl,
  LucideArrowUp: pl,
  LucideArrowUp01: ol,
  LucideArrowUp10: rl,
  LucideArrowUpAZ: ua,
  LucideArrowUpAz: ua,
  LucideArrowUpCircle: qa,
  LucideArrowUpDown: il,
  LucideArrowUpFromDot: cl,
  LucideArrowUpFromLine: sl,
  LucideArrowUpLeft: ll,
  LucideArrowUpLeftFromCircle: Fa,
  LucideArrowUpLeftFromSquare: Nr,
  LucideArrowUpLeftSquare: Sr,
  LucideArrowUpNarrowWide: ha,
  LucideArrowUpRight: dl,
  LucideArrowUpRightFromCircle: $a,
  LucideArrowUpRightFromSquare: Cr,
  LucideArrowUpRightSquare: Rr,
  LucideArrowUpSquare: Dr,
  LucideArrowUpToLine: ul,
  LucideArrowUpWideNarrow: hl,
  LucideArrowUpZA: pa,
  LucideArrowUpZa: pa,
  LucideArrowsUpFromLine: yl,
  LucideAsterisk: kl,
  LucideAsteriskSquare: Or,
  LucideAtSign: fl,
  LucideAtom: ml,
  LucideAudioLines: gl,
  LucideAudioWaveform: Ml,
  LucideAward: _l,
  LucideAxe: bl,
  LucideAxis3D: ya,
  LucideAxis3d: ya,
  LucideBaby: Ll,
  LucideBackpack: xl,
  LucideBadge: Fl,
  LucideBadgeAlert: El,
  LucideBadgeCent: vl,
  LucideBadgeCheck: ka,
  LucideBadgeDollarSign: Al,
  LucideBadgeEuro: Il,
  LucideBadgeHelp: Tl,
  LucideBadgeIndianRupee: Nl,
  LucideBadgeInfo: Cl,
  LucideBadgeJapaneseYen: wl,
  LucideBadgeMinus: Sl,
  LucideBadgePercent: Rl,
  LucideBadgePlus: Dl,
  LucideBadgePoundSterling: Ol,
  LucideBadgeRussianRuble: Pl,
  LucideBadgeSwissFranc: Hl,
  LucideBadgeX: Bl,
  LucideBaggageClaim: $l,
  LucideBan: Ul,
  LucideBanana: ql,
  LucideBandage: zl,
  LucideBanknote: jl,
  LucideBarChart: Na,
  LucideBarChart2: Ca,
  LucideBarChart3: Ia,
  LucideBarChart4: Aa,
  LucideBarChartBig: va,
  LucideBarChartHorizontal: xa,
  LucideBarChartHorizontalBig: La,
  LucideBarcode: Vl,
  LucideBaseline: Gl,
  LucideBath: Wl,
  LucideBattery: e0,
  LucideBatteryCharging: Xl,
  LucideBatteryFull: Yl,
  LucideBatteryLow: Kl,
  LucideBatteryMedium: Zl,
  LucideBatteryPlus: Ql,
  LucideBatteryWarning: Jl,
  LucideBeaker: t0,
  LucideBean: a0,
  LucideBeanOff: n0,
  LucideBed: i0,
  LucideBedDouble: o0,
  LucideBedSingle: r0,
  LucideBeef: c0,
  LucideBeer: l0,
  LucideBeerOff: s0,
  LucideBell: f0,
  LucideBellDot: d0,
  LucideBellElectric: u0,
  LucideBellMinus: h0,
  LucideBellOff: p0,
  LucideBellPlus: y0,
  LucideBellRing: k0,
  LucideBetweenHorizonalEnd: fa,
  LucideBetweenHorizonalStart: ma,
  LucideBetweenHorizontalEnd: fa,
  LucideBetweenHorizontalStart: ma,
  LucideBetweenVerticalEnd: m0,
  LucideBetweenVerticalStart: g0,
  LucideBicepsFlexed: M0,
  LucideBike: _0,
  LucideBinary: b0,
  LucideBinoculars: L0,
  LucideBiohazard: x0,
  LucideBird: E0,
  LucideBitcoin: v0,
  LucideBlend: A0,
  LucideBlinds: I0,
  LucideBlocks: T0,
  LucideBluetooth: S0,
  LucideBluetoothConnected: N0,
  LucideBluetoothOff: C0,
  LucideBluetoothSearching: w0,
  LucideBold: R0,
  LucideBolt: D0,
  LucideBomb: O0,
  LucideBone: P0,
  LucideBook: r2,
  LucideBookA: H0,
  LucideBookAudio: B0,
  LucideBookCheck: F0,
  LucideBookCopy: $0,
  LucideBookDashed: ga,
  LucideBookDown: U0,
  LucideBookHeadphones: q0,
  LucideBookHeart: z0,
  LucideBookImage: j0,
  LucideBookKey: V0,
  LucideBookLock: G0,
  LucideBookMarked: W0,
  LucideBookMinus: X0,
  LucideBookOpen: Z0,
  LucideBookOpenCheck: Y0,
  LucideBookOpenText: K0,
  LucideBookPlus: Q0,
  LucideBookTemplate: ga,
  LucideBookText: J0,
  LucideBookType: e2,
  LucideBookUp: n2,
  LucideBookUp2: t2,
  LucideBookUser: a2,
  LucideBookX: o2,
  LucideBookmark: d2,
  LucideBookmarkCheck: i2,
  LucideBookmarkMinus: c2,
  LucideBookmarkPlus: s2,
  LucideBookmarkX: l2,
  LucideBoomBox: u2,
  LucideBot: y2,
  LucideBotMessageSquare: h2,
  LucideBotOff: p2,
  LucideBox: k2,
  LucideBoxSelect: Gr,
  LucideBoxes: f2,
  LucideBraces: Ma,
  LucideBrackets: m2,
  LucideBrain: _2,
  LucideBrainCircuit: g2,
  LucideBrainCog: M2,
  LucideBrickWall: b2,
  LucideBriefcase: v2,
  LucideBriefcaseBusiness: L2,
  LucideBriefcaseConveyorBelt: x2,
  LucideBriefcaseMedical: E2,
  LucideBringToFront: A2,
  LucideBrush: I2,
  LucideBug: C2,
  LucideBugOff: T2,
  LucideBugPlay: N2,
  LucideBuilding: S2,
  LucideBuilding2: w2,
  LucideBus: D2,
  LucideBusFront: R2,
  LucideCable: P2,
  LucideCableCar: O2,
  LucideCake: B2,
  LucideCakeSlice: H2,
  LucideCalculator: F2,
  LucideCalendar: id,
  LucideCalendar1: $2,
  LucideCalendarArrowDown: U2,
  LucideCalendarArrowUp: q2,
  LucideCalendarCheck: j2,
  LucideCalendarCheck2: z2,
  LucideCalendarClock: V2,
  LucideCalendarCog: G2,
  LucideCalendarDays: W2,
  LucideCalendarFold: X2,
  LucideCalendarHeart: Y2,
  LucideCalendarMinus: Z2,
  LucideCalendarMinus2: K2,
  LucideCalendarOff: Q2,
  LucideCalendarPlus: ed,
  LucideCalendarPlus2: J2,
  LucideCalendarRange: td,
  LucideCalendarSearch: nd,
  LucideCalendarSync: ad,
  LucideCalendarX: rd,
  LucideCalendarX2: od,
  LucideCamera: sd,
  LucideCameraOff: cd,
  LucideCandlestickChart: Ea,
  LucideCandy: ud,
  LucideCandyCane: ld,
  LucideCandyOff: dd,
  LucideCannabis: hd,
  LucideCaptions: _a,
  LucideCaptionsOff: pd,
  LucideCar: fd,
  LucideCarFront: yd,
  LucideCarTaxiFront: kd,
  LucideCaravan: md,
  LucideCarrot: gd,
  LucideCaseLower: Md,
  LucideCaseSensitive: _d,
  LucideCaseUpper: bd,
  LucideCassetteTape: Ld,
  LucideCast: xd,
  LucideCastle: Ed,
  LucideCat: vd,
  LucideCctv: Ad,
  LucideChartArea: ba,
  LucideChartBar: xa,
  LucideChartBarBig: La,
  LucideChartBarDecreasing: Id,
  LucideChartBarIncreasing: Td,
  LucideChartBarStacked: Nd,
  LucideChartCandlestick: Ea,
  LucideChartColumn: Ia,
  LucideChartColumnBig: va,
  LucideChartColumnDecreasing: Cd,
  LucideChartColumnIncreasing: Aa,
  LucideChartColumnStacked: wd,
  LucideChartGantt: Sd,
  LucideChartLine: Ta,
  LucideChartNetwork: Rd,
  LucideChartNoAxesColumn: Ca,
  LucideChartNoAxesColumnDecreasing: Dd,
  LucideChartNoAxesColumnIncreasing: Na,
  LucideChartNoAxesCombined: Od,
  LucideChartNoAxesGantt: wa,
  LucideChartPie: Sa,
  LucideChartScatter: Ra,
  LucideChartSpline: Pd,
  LucideCheck: Bd,
  LucideCheckCheck: Hd,
  LucideCheckCircle: za,
  LucideCheckCircle2: ja,
  LucideCheckSquare: Hr,
  LucideCheckSquare2: Br,
  LucideChefHat: Fd,
  LucideCherry: $d,
  LucideChevronDown: Ud,
  LucideChevronDownCircle: Va,
  LucideChevronDownSquare: Fr,
  LucideChevronFirst: qd,
  LucideChevronLast: zd,
  LucideChevronLeft: jd,
  LucideChevronLeftCircle: Ga,
  LucideChevronLeftSquare: $r,
  LucideChevronRight: Vd,
  LucideChevronRightCircle: Wa,
  LucideChevronRightSquare: Ur,
  LucideChevronUp: Gd,
  LucideChevronUpCircle: Xa,
  LucideChevronUpSquare: qr,
  LucideChevronsDown: Xd,
  LucideChevronsDownUp: Wd,
  LucideChevronsLeft: Zd,
  LucideChevronsLeftRight: Kd,
  LucideChevronsLeftRightEllipsis: Yd,
  LucideChevronsRight: Jd,
  LucideChevronsRightLeft: Qd,
  LucideChevronsUp: tu,
  LucideChevronsUpDown: eu,
  LucideChrome: nu,
  LucideChurch: au,
  LucideCigarette: ru,
  LucideCigaretteOff: ou,
  LucideCircle: mu,
  LucideCircleAlert: Da,
  LucideCircleArrowDown: Oa,
  LucideCircleArrowLeft: Pa,
  LucideCircleArrowOutDownLeft: Ha,
  LucideCircleArrowOutDownRight: Ba,
  LucideCircleArrowOutUpLeft: Fa,
  LucideCircleArrowOutUpRight: $a,
  LucideCircleArrowRight: Ua,
  LucideCircleArrowUp: qa,
  LucideCircleCheck: ja,
  LucideCircleCheckBig: za,
  LucideCircleChevronDown: Va,
  LucideCircleChevronLeft: Ga,
  LucideCircleChevronRight: Wa,
  LucideCircleChevronUp: Xa,
  LucideCircleDashed: iu,
  LucideCircleDivide: Ya,
  LucideCircleDollarSign: cu,
  LucideCircleDot: lu,
  LucideCircleDotDashed: su,
  LucideCircleEllipsis: du,
  LucideCircleEqual: uu,
  LucideCircleFadingArrowUp: hu,
  LucideCircleFadingPlus: pu,
  LucideCircleGauge: Ka,
  LucideCircleHelp: Za,
  LucideCircleMinus: Qa,
  LucideCircleOff: yu,
  LucideCircleParking: eo,
  LucideCircleParkingOff: Ja,
  LucideCirclePause: to,
  LucideCirclePercent: no,
  LucideCirclePlay: ao,
  LucideCirclePlus: oo,
  LucideCirclePower: ro,
  LucideCircleSlash: ku,
  LucideCircleSlash2: io,
  LucideCircleSlashed: io,
  LucideCircleSmall: fu,
  LucideCircleStop: co,
  LucideCircleUser: lo,
  LucideCircleUserRound: so,
  LucideCircleX: uo,
  LucideCircuitBoard: gu,
  LucideCitrus: Mu,
  LucideClapperboard: _u,
  LucideClipboard: Nu,
  LucideClipboardCheck: bu,
  LucideClipboardCopy: Lu,
  LucideClipboardEdit: po,
  LucideClipboardList: xu,
  LucideClipboardMinus: Eu,
  LucideClipboardPaste: vu,
  LucideClipboardPen: po,
  LucideClipboardPenLine: ho,
  LucideClipboardPlus: Au,
  LucideClipboardSignature: ho,
  LucideClipboardType: Iu,
  LucideClipboardX: Tu,
  LucideClock: Vu,
  LucideClock1: Cu,
  LucideClock10: wu,
  LucideClock11: Su,
  LucideClock12: Ru,
  LucideClock2: Du,
  LucideClock3: Ou,
  LucideClock4: Pu,
  LucideClock5: Hu,
  LucideClock6: Bu,
  LucideClock7: Fu,
  LucideClock8: $u,
  LucideClock9: Uu,
  LucideClockAlert: qu,
  LucideClockArrowDown: zu,
  LucideClockArrowUp: ju,
  LucideCloud: ih,
  LucideCloudAlert: Gu,
  LucideCloudCog: Wu,
  LucideCloudDownload: yo,
  LucideCloudDrizzle: Xu,
  LucideCloudFog: Yu,
  LucideCloudHail: Ku,
  LucideCloudLightning: Zu,
  LucideCloudMoon: Ju,
  LucideCloudMoonRain: Qu,
  LucideCloudOff: eh,
  LucideCloudRain: nh,
  LucideCloudRainWind: th,
  LucideCloudSnow: ah,
  LucideCloudSun: rh,
  LucideCloudSunRain: oh,
  LucideCloudUpload: ko,
  LucideCloudy: ch,
  LucideClover: sh,
  LucideClub: lh,
  LucideCode: dh,
  LucideCode2: fo,
  LucideCodeSquare: zr,
  LucideCodeXml: fo,
  LucideCodepen: uh,
  LucideCodesandbox: hh,
  LucideCoffee: ph,
  LucideCog: yh,
  LucideCoins: kh,
  LucideColumns: mo,
  LucideColumns2: mo,
  LucideColumns3: go,
  LucideColumns4: fh,
  LucideCombine: mh,
  LucideCommand: gh,
  LucideCompass: Mh,
  LucideComponent: _h,
  LucideComputer: bh,
  LucideConciergeBell: Lh,
  LucideCone: xh,
  LucideConstruction: Eh,
  LucideContact: vh,
  LucideContact2: Mo,
  LucideContactRound: Mo,
  LucideContainer: Ah,
  LucideContrast: Ih,
  LucideCookie: Th,
  LucideCookingPot: Nh,
  LucideCopy: Oh,
  LucideCopyCheck: Ch,
  LucideCopyMinus: wh,
  LucideCopyPlus: Sh,
  LucideCopySlash: Rh,
  LucideCopyX: Dh,
  LucideCopyleft: Ph,
  LucideCopyright: Hh,
  LucideCornerDownLeft: Bh,
  LucideCornerDownRight: Fh,
  LucideCornerLeftDown: $h,
  LucideCornerLeftUp: Uh,
  LucideCornerRightDown: qh,
  LucideCornerRightUp: zh,
  LucideCornerUpLeft: jh,
  LucideCornerUpRight: Vh,
  LucideCpu: Gh,
  LucideCreativeCommons: Wh,
  LucideCreditCard: Xh,
  LucideCroissant: Yh,
  LucideCrop: Kh,
  LucideCross: Zh,
  LucideCrosshair: Qh,
  LucideCrown: Jh,
  LucideCuboid: ep,
  LucideCupSoda: tp,
  LucideCurlyBraces: Ma,
  LucideCurrency: np,
  LucideCylinder: ap,
  LucideDam: op,
  LucideDatabase: cp,
  LucideDatabaseBackup: rp,
  LucideDatabaseZap: ip,
  LucideDelete: sp,
  LucideDessert: lp,
  LucideDiameter: dp,
  LucideDiamond: pp,
  LucideDiamondMinus: up,
  LucideDiamondPercent: _o,
  LucideDiamondPlus: hp,
  LucideDice1: yp,
  LucideDice2: kp,
  LucideDice3: fp,
  LucideDice4: mp,
  LucideDice5: gp,
  LucideDice6: Mp,
  LucideDices: _p,
  LucideDiff: bp,
  LucideDisc: vp,
  LucideDisc2: Lp,
  LucideDisc3: xp,
  LucideDiscAlbum: Ep,
  LucideDivide: Ap,
  LucideDivideCircle: Ya,
  LucideDivideSquare: Wr,
  LucideDna: Tp,
  LucideDnaOff: Ip,
  LucideDock: Np,
  LucideDog: Cp,
  LucideDollarSign: wp,
  LucideDonut: Sp,
  LucideDoorClosed: Rp,
  LucideDoorOpen: Dp,
  LucideDot: Op,
  LucideDotSquare: Xr,
  LucideDownload: Pp,
  LucideDownloadCloud: yo,
  LucideDraftingCompass: Hp,
  LucideDrama: Bp,
  LucideDribbble: Fp,
  LucideDrill: $p,
  LucideDroplet: qp,
  LucideDropletOff: Up,
  LucideDroplets: zp,
  LucideDrum: jp,
  LucideDrumstick: Vp,
  LucideDumbbell: Gp,
  LucideEar: Xp,
  LucideEarOff: Wp,
  LucideEarth: bo,
  LucideEarthLock: Yp,
  LucideEclipse: Kp,
  LucideEdit: Pt,
  LucideEdit2: ur,
  LucideEdit3: dr,
  LucideEgg: Jp,
  LucideEggFried: Zp,
  LucideEggOff: Qp,
  LucideEllipsis: xo,
  LucideEllipsisVertical: Lo,
  LucideEqual: ny,
  LucideEqualApproximately: ey,
  LucideEqualNot: ty,
  LucideEqualSquare: Yr,
  LucideEraser: ay,
  LucideEthernetPort: oy,
  LucideEuro: ry,
  LucideExpand: iy,
  LucideExternalLink: cy,
  LucideEye: dy,
  LucideEyeClosed: sy,
  LucideEyeOff: ly,
  LucideFacebook: uy,
  LucideFactory: hy,
  LucideFan: py,
  LucideFastForward: yy,
  LucideFeather: ky,
  LucideFence: fy,
  LucideFerrisWheel: my,
  LucideFigma: gy,
  LucideFile: kk,
  LucideFileArchive: My,
  LucideFileAudio: by,
  LucideFileAudio2: _y,
  LucideFileAxis3D: Eo,
  LucideFileAxis3d: Eo,
  LucideFileBadge: xy,
  LucideFileBadge2: Ly,
  LucideFileBarChart: vo,
  LucideFileBarChart2: Ao,
  LucideFileBox: Ey,
  LucideFileChartColumn: Ao,
  LucideFileChartColumnIncreasing: vo,
  LucideFileChartLine: Io,
  LucideFileChartPie: To,
  LucideFileCheck: Ay,
  LucideFileCheck2: vy,
  LucideFileClock: Iy,
  LucideFileCode: Ny,
  LucideFileCode2: Ty,
  LucideFileCog: No,
  LucideFileCog2: No,
  LucideFileDiff: Cy,
  LucideFileDigit: wy,
  LucideFileDown: Sy,
  LucideFileEdit: wo,
  LucideFileHeart: Ry,
  LucideFileImage: Dy,
  LucideFileInput: Oy,
  LucideFileJson: Hy,
  LucideFileJson2: Py,
  LucideFileKey: Fy,
  LucideFileKey2: By,
  LucideFileLineChart: Io,
  LucideFileLock: Uy,
  LucideFileLock2: $y,
  LucideFileMinus: zy,
  LucideFileMinus2: qy,
  LucideFileMusic: jy,
  LucideFileOutput: Vy,
  LucideFilePen: wo,
  LucideFilePenLine: Co,
  LucideFilePieChart: To,
  LucideFilePlus: Wy,
  LucideFilePlus2: Gy,
  LucideFileQuestion: Xy,
  LucideFileScan: Yy,
  LucideFileSearch: Zy,
  LucideFileSearch2: Ky,
  LucideFileSignature: Co,
  LucideFileSliders: Qy,
  LucideFileSpreadsheet: Jy,
  LucideFileStack: ek,
  LucideFileSymlink: tk,
  LucideFileTerminal: nk,
  LucideFileText: ak,
  LucideFileType: rk,
  LucideFileType2: ok,
  LucideFileUp: ik,
  LucideFileUser: ck,
  LucideFileVideo: lk,
  LucideFileVideo2: sk,
  LucideFileVolume: uk,
  LucideFileVolume2: dk,
  LucideFileWarning: hk,
  LucideFileX: yk,
  LucideFileX2: pk,
  LucideFiles: fk,
  LucideFilm: mk,
  LucideFilter: Mk,
  LucideFilterX: gk,
  LucideFingerprint: _k,
  LucideFireExtinguisher: bk,
  LucideFish: Ek,
  LucideFishOff: Lk,
  LucideFishSymbol: xk,
  LucideFlag: Tk,
  LucideFlagOff: vk,
  LucideFlagTriangleLeft: Ak,
  LucideFlagTriangleRight: Ik,
  LucideFlame: Ck,
  LucideFlameKindling: Nk,
  LucideFlashlight: Sk,
  LucideFlashlightOff: wk,
  LucideFlaskConical: Dk,
  LucideFlaskConicalOff: Rk,
  LucideFlaskRound: Ok,
  LucideFlipHorizontal: Hk,
  LucideFlipHorizontal2: Pk,
  LucideFlipVertical: Fk,
  LucideFlipVertical2: Bk,
  LucideFlower: Uk,
  LucideFlower2: $k,
  LucideFocus: qk,
  LucideFoldHorizontal: zk,
  LucideFoldVertical: jk,
  LucideFolder: g4,
  LucideFolderArchive: Vk,
  LucideFolderCheck: Gk,
  LucideFolderClock: Wk,
  LucideFolderClosed: Xk,
  LucideFolderCode: Yk,
  LucideFolderCog: So,
  LucideFolderCog2: So,
  LucideFolderDot: Kk,
  LucideFolderDown: Zk,
  LucideFolderEdit: Ro,
  LucideFolderGit: Jk,
  LucideFolderGit2: Qk,
  LucideFolderHeart: e4,
  LucideFolderInput: t4,
  LucideFolderKanban: n4,
  LucideFolderKey: a4,
  LucideFolderLock: o4,
  LucideFolderMinus: r4,
  LucideFolderOpen: c4,
  LucideFolderOpenDot: i4,
  LucideFolderOutput: s4,
  LucideFolderPen: Ro,
  LucideFolderPlus: l4,
  LucideFolderRoot: d4,
  LucideFolderSearch: h4,
  LucideFolderSearch2: u4,
  LucideFolderSymlink: p4,
  LucideFolderSync: y4,
  LucideFolderTree: k4,
  LucideFolderUp: f4,
  LucideFolderX: m4,
  LucideFolders: M4,
  LucideFootprints: _4,
  LucideForkKnife: O1,
  LucideForkKnifeCrossed: D1,
  LucideForklift: b4,
  LucideFormInput: pr,
  LucideForward: L4,
  LucideFrame: x4,
  LucideFramer: E4,
  LucideFrown: v4,
  LucideFuel: A4,
  LucideFullscreen: I4,
  LucideFunctionSquare: Kr,
  LucideGalleryHorizontal: N4,
  LucideGalleryHorizontalEnd: T4,
  LucideGalleryThumbnails: C4,
  LucideGalleryVertical: S4,
  LucideGalleryVerticalEnd: w4,
  LucideGamepad: D4,
  LucideGamepad2: R4,
  LucideGanttChart: wa,
  LucideGanttChartSquare: hn,
  LucideGauge: O4,
  LucideGaugeCircle: Ka,
  LucideGavel: P4,
  LucideGem: H4,
  LucideGhost: B4,
  LucideGift: F4,
  LucideGitBranch: U4,
  LucideGitBranchPlus: $4,
  LucideGitCommit: Do,
  LucideGitCommitHorizontal: Do,
  LucideGitCommitVertical: q4,
  LucideGitCompare: j4,
  LucideGitCompareArrows: z4,
  LucideGitFork: V4,
  LucideGitGraph: G4,
  LucideGitMerge: W4,
  LucideGitPullRequest: J4,
  LucideGitPullRequestArrow: X4,
  LucideGitPullRequestClosed: Y4,
  LucideGitPullRequestCreate: Z4,
  LucideGitPullRequestCreateArrow: K4,
  LucideGitPullRequestDraft: Q4,
  LucideGithub: ef,
  LucideGitlab: tf,
  LucideGlassWater: nf,
  LucideGlasses: af,
  LucideGlobe: rf,
  LucideGlobe2: bo,
  LucideGlobeLock: of,
  LucideGoal: cf,
  LucideGrab: sf,
  LucideGraduationCap: lf,
  LucideGrape: df,
  LucideGrid: un,
  LucideGrid2X2: Bo,
  LucideGrid2X2Check: Oo,
  LucideGrid2X2Plus: Po,
  LucideGrid2X2X: Ho,
  LucideGrid2x2: Bo,
  LucideGrid2x2Check: Oo,
  LucideGrid2x2Plus: Po,
  LucideGrid2x2X: Ho,
  LucideGrid3X3: un,
  LucideGrid3x3: un,
  LucideGrip: pf,
  LucideGripHorizontal: uf,
  LucideGripVertical: hf,
  LucideGroup: yf,
  LucideGuitar: kf,
  LucideHam: ff,
  LucideHammer: mf,
  LucideHand: Lf,
  LucideHandCoins: gf,
  LucideHandHeart: Mf,
  LucideHandHelping: Fo,
  LucideHandMetal: _f,
  LucideHandPlatter: bf,
  LucideHandshake: xf,
  LucideHardDrive: Af,
  LucideHardDriveDownload: Ef,
  LucideHardDriveUpload: vf,
  LucideHardHat: If,
  LucideHash: Tf,
  LucideHaze: Nf,
  LucideHdmiPort: Cf,
  LucideHeading: Hf,
  LucideHeading1: wf,
  LucideHeading2: Sf,
  LucideHeading3: Rf,
  LucideHeading4: Df,
  LucideHeading5: Of,
  LucideHeading6: Pf,
  LucideHeadphoneOff: Bf,
  LucideHeadphones: Ff,
  LucideHeadset: $f,
  LucideHeart: Vf,
  LucideHeartCrack: Uf,
  LucideHeartHandshake: qf,
  LucideHeartOff: zf,
  LucideHeartPulse: jf,
  LucideHeater: Gf,
  LucideHelpCircle: Za,
  LucideHelpingHand: Fo,
  LucideHexagon: Wf,
  LucideHighlighter: Xf,
  LucideHistory: Yf,
  LucideHome: $o,
  LucideHop: Zf,
  LucideHopOff: Kf,
  LucideHospital: Qf,
  LucideHotel: Jf,
  LucideHourglass: e3,
  LucideHouse: $o,
  LucideHousePlug: t3,
  LucideHousePlus: n3,
  LucideHouseWifi: a3,
  LucideIceCream: qo,
  LucideIceCream2: Uo,
  LucideIceCreamBowl: Uo,
  LucideIceCreamCone: qo,
  LucideIdCard: o3,
  LucideImage: h3,
  LucideImageDown: r3,
  LucideImageMinus: i3,
  LucideImageOff: c3,
  LucideImagePlay: s3,
  LucideImagePlus: l3,
  LucideImageUp: d3,
  LucideImageUpscale: u3,
  LucideImages: p3,
  LucideImport: y3,
  LucideInbox: k3,
  LucideIndent: jo,
  LucideIndentDecrease: zo,
  LucideIndentIncrease: jo,
  LucideIndianRupee: f3,
  LucideInfinity: m3,
  LucideInfo: g3,
  LucideInspect: n1,
  LucideInspectionPanel: M3,
  LucideInstagram: _3,
  LucideItalic: b3,
  LucideIterationCcw: L3,
  LucideIterationCw: x3,
  LucideJapaneseYen: E3,
  LucideJoystick: v3,
  LucideKanban: A3,
  LucideKanbanSquare: Zr,
  LucideKanbanSquareDashed: jr,
  LucideKey: N3,
  LucideKeyRound: I3,
  LucideKeySquare: T3,
  LucideKeyboard: S3,
  LucideKeyboardMusic: C3,
  LucideKeyboardOff: w3,
  LucideLamp: B3,
  LucideLampCeiling: R3,
  LucideLampDesk: D3,
  LucideLampFloor: O3,
  LucideLampWallDown: P3,
  LucideLampWallUp: H3,
  LucideLandPlot: F3,
  LucideLandmark: $3,
  LucideLanguages: U3,
  LucideLaptop: z3,
  LucideLaptop2: Vo,
  LucideLaptopMinimal: Vo,
  LucideLaptopMinimalCheck: q3,
  LucideLasso: V3,
  LucideLassoSelect: j3,
  LucideLaugh: G3,
  LucideLayers: Go,
  LucideLayers2: W3,
  LucideLayers3: Go,
  LucideLayout: lr,
  LucideLayoutDashboard: X3,
  LucideLayoutGrid: Y3,
  LucideLayoutList: K3,
  LucideLayoutPanelLeft: Z3,
  LucideLayoutPanelTop: Q3,
  LucideLayoutTemplate: J3,
  LucideLeaf: e5,
  LucideLeafyGreen: t5,
  LucideLectern: n5,
  LucideLetterText: a5,
  LucideLibrary: r5,
  LucideLibraryBig: o5,
  LucideLibrarySquare: Qr,
  LucideLifeBuoy: i5,
  LucideLigature: c5,
  LucideLightbulb: l5,
  LucideLightbulbOff: s5,
  LucideLineChart: Ta,
  LucideLink: h5,
  LucideLink2: u5,
  LucideLink2Off: d5,
  LucideLinkedin: p5,
  LucideList: C5,
  LucideListCheck: y5,
  LucideListChecks: k5,
  LucideListCollapse: f5,
  LucideListEnd: m5,
  LucideListFilter: M5,
  LucideListFilterPlus: g5,
  LucideListMinus: _5,
  LucideListMusic: b5,
  LucideListOrdered: L5,
  LucideListPlus: x5,
  LucideListRestart: E5,
  LucideListStart: v5,
  LucideListTodo: A5,
  LucideListTree: I5,
  LucideListVideo: T5,
  LucideListX: N5,
  LucideLoader: S5,
  LucideLoader2: Wo,
  LucideLoaderCircle: Wo,
  LucideLoaderPinwheel: w5,
  LucideLocate: O5,
  LucideLocateFixed: R5,
  LucideLocateOff: D5,
  LucideLock: H5,
  LucideLockKeyhole: P5,
  LucideLockKeyholeOpen: Xo,
  LucideLockOpen: Yo,
  LucideLogIn: B5,
  LucideLogOut: F5,
  LucideLogs: $5,
  LucideLollipop: U5,
  LucideLuggage: q5,
  LucideMSquare: Jr,
  LucideMagnet: z5,
  LucideMail: Q5,
  LucideMailCheck: j5,
  LucideMailMinus: V5,
  LucideMailOpen: G5,
  LucideMailPlus: W5,
  LucideMailQuestion: X5,
  LucideMailSearch: Y5,
  LucideMailWarning: K5,
  LucideMailX: Z5,
  LucideMailbox: J5,
  LucideMails: em,
  LucideMap: ym,
  LucideMapPin: um,
  LucideMapPinCheck: nm,
  LucideMapPinCheckInside: tm,
  LucideMapPinHouse: am,
  LucideMapPinMinus: rm,
  LucideMapPinMinusInside: om,
  LucideMapPinOff: im,
  LucideMapPinPlus: sm,
  LucideMapPinPlusInside: cm,
  LucideMapPinX: dm,
  LucideMapPinXInside: lm,
  LucideMapPinned: hm,
  LucideMapPlus: pm,
  LucideMars: fm,
  LucideMarsStroke: km,
  LucideMartini: mm,
  LucideMaximize: Mm,
  LucideMaximize2: gm,
  LucideMedal: _m,
  LucideMegaphone: Lm,
  LucideMegaphoneOff: bm,
  LucideMeh: xm,
  LucideMemoryStick: Em,
  LucideMenu: vm,
  LucideMenuSquare: e1,
  LucideMerge: Am,
  LucideMessageCircle: Hm,
  LucideMessageCircleCode: Im,
  LucideMessageCircleDashed: Tm,
  LucideMessageCircleHeart: Nm,
  LucideMessageCircleMore: Cm,
  LucideMessageCircleOff: wm,
  LucideMessageCirclePlus: Sm,
  LucideMessageCircleQuestion: Rm,
  LucideMessageCircleReply: Dm,
  LucideMessageCircleWarning: Om,
  LucideMessageCircleX: Pm,
  LucideMessageSquare: Jm,
  LucideMessageSquareCode: Bm,
  LucideMessageSquareDashed: Fm,
  LucideMessageSquareDiff: $m,
  LucideMessageSquareDot: Um,
  LucideMessageSquareHeart: qm,
  LucideMessageSquareLock: zm,
  LucideMessageSquareMore: jm,
  LucideMessageSquareOff: Vm,
  LucideMessageSquarePlus: Gm,
  LucideMessageSquareQuote: Wm,
  LucideMessageSquareReply: Xm,
  LucideMessageSquareShare: Ym,
  LucideMessageSquareText: Km,
  LucideMessageSquareWarning: Zm,
  LucideMessageSquareX: Qm,
  LucideMessagesSquare: e6,
  LucideMic: n6,
  LucideMic2: Ko,
  LucideMicOff: t6,
  LucideMicVocal: Ko,
  LucideMicrochip: a6,
  LucideMicroscope: o6,
  LucideMicrowave: r6,
  LucideMilestone: i6,
  LucideMilk: s6,
  LucideMilkOff: c6,
  LucideMinimize: d6,
  LucideMinimize2: l6,
  LucideMinus: u6,
  LucideMinusCircle: Qa,
  LucideMinusSquare: t1,
  LucideMonitor: E6,
  LucideMonitorCheck: h6,
  LucideMonitorCog: p6,
  LucideMonitorDot: y6,
  LucideMonitorDown: k6,
  LucideMonitorOff: f6,
  LucideMonitorPause: m6,
  LucideMonitorPlay: g6,
  LucideMonitorSmartphone: M6,
  LucideMonitorSpeaker: _6,
  LucideMonitorStop: b6,
  LucideMonitorUp: L6,
  LucideMonitorX: x6,
  LucideMoon: A6,
  LucideMoonStar: v6,
  LucideMoreHorizontal: xo,
  LucideMoreVertical: Lo,
  LucideMountain: T6,
  LucideMountainSnow: I6,
  LucideMouse: D6,
  LucideMouseOff: N6,
  LucideMousePointer: R6,
  LucideMousePointer2: C6,
  LucideMousePointerBan: w6,
  LucideMousePointerClick: S6,
  LucideMousePointerSquareDashed: Vr,
  LucideMove: W6,
  LucideMove3D: Zo,
  LucideMove3d: Zo,
  LucideMoveDiagonal: P6,
  LucideMoveDiagonal2: O6,
  LucideMoveDown: F6,
  LucideMoveDownLeft: H6,
  LucideMoveDownRight: B6,
  LucideMoveHorizontal: $6,
  LucideMoveLeft: U6,
  LucideMoveRight: q6,
  LucideMoveUp: V6,
  LucideMoveUpLeft: z6,
  LucideMoveUpRight: j6,
  LucideMoveVertical: G6,
  LucideMusic: Z6,
  LucideMusic2: X6,
  LucideMusic3: Y6,
  LucideMusic4: K6,
  LucideNavigation: tg,
  LucideNavigation2: J6,
  LucideNavigation2Off: Q6,
  LucideNavigationOff: eg,
  LucideNetwork: ng,
  LucideNewspaper: ag,
  LucideNfc: og,
  LucideNonBinary: rg,
  LucideNotebook: lg,
  LucideNotebookPen: ig,
  LucideNotebookTabs: cg,
  LucideNotebookText: sg,
  LucideNotepadText: ug,
  LucideNotepadTextDashed: dg,
  LucideNut: pg,
  LucideNutOff: hg,
  LucideOctagon: kg,
  LucideOctagonAlert: Qo,
  LucideOctagonMinus: yg,
  LucideOctagonPause: Jo,
  LucideOctagonX: er,
  LucideOmega: fg,
  LucideOption: mg,
  LucideOrbit: gg,
  LucideOrigami: Mg,
  LucideOutdent: zo,
  LucidePackage: Ig,
  LucidePackage2: _g,
  LucidePackageCheck: bg,
  LucidePackageMinus: Lg,
  LucidePackageOpen: xg,
  LucidePackagePlus: Eg,
  LucidePackageSearch: vg,
  LucidePackageX: Ag,
  LucidePaintBucket: Tg,
  LucidePaintRoller: Ng,
  LucidePaintbrush: Cg,
  LucidePaintbrush2: tr,
  LucidePaintbrushVertical: tr,
  LucidePalette: wg,
  LucidePalmtree: x1,
  LucidePanelBottom: Dg,
  LucidePanelBottomClose: Sg,
  LucidePanelBottomDashed: nr,
  LucidePanelBottomInactive: nr,
  LucidePanelBottomOpen: Rg,
  LucidePanelLeft: ir,
  LucidePanelLeftClose: ar,
  LucidePanelLeftDashed: or,
  LucidePanelLeftInactive: or,
  LucidePanelLeftOpen: rr,
  LucidePanelRight: Hg,
  LucidePanelRightClose: Og,
  LucidePanelRightDashed: cr,
  LucidePanelRightInactive: cr,
  LucidePanelRightOpen: Pg,
  LucidePanelTop: $g,
  LucidePanelTopClose: Bg,
  LucidePanelTopDashed: sr,
  LucidePanelTopInactive: sr,
  LucidePanelTopOpen: Fg,
  LucidePanelsLeftBottom: Ug,
  LucidePanelsLeftRight: go,
  LucidePanelsRightBottom: qg,
  LucidePanelsTopBottom: fr,
  LucidePanelsTopLeft: lr,
  LucidePaperclip: zg,
  LucideParentheses: jg,
  LucideParkingCircle: eo,
  LucideParkingCircleOff: Ja,
  LucideParkingMeter: Vg,
  LucideParkingSquare: o1,
  LucideParkingSquareOff: a1,
  LucidePartyPopper: Gg,
  LucidePause: Wg,
  LucidePauseCircle: to,
  LucidePauseOctagon: Jo,
  LucidePawPrint: Xg,
  LucidePcCase: Yg,
  LucidePen: ur,
  LucidePenBox: Pt,
  LucidePenLine: dr,
  LucidePenOff: Kg,
  LucidePenSquare: Pt,
  LucidePenTool: Zg,
  LucidePencil: t8,
  LucidePencilLine: Qg,
  LucidePencilOff: Jg,
  LucidePencilRuler: e8,
  LucidePentagon: n8,
  LucidePercent: a8,
  LucidePercentCircle: no,
  LucidePercentDiamond: _o,
  LucidePercentSquare: r1,
  LucidePersonStanding: o8,
  LucidePhilippinePeso: r8,
  LucidePhone: h8,
  LucidePhoneCall: i8,
  LucidePhoneForwarded: c8,
  LucidePhoneIncoming: s8,
  LucidePhoneMissed: l8,
  LucidePhoneOff: d8,
  LucidePhoneOutgoing: u8,
  LucidePi: p8,
  LucidePiSquare: i1,
  LucidePiano: y8,
  LucidePickaxe: k8,
  LucidePictureInPicture: m8,
  LucidePictureInPicture2: f8,
  LucidePieChart: Sa,
  LucidePiggyBank: g8,
  LucidePilcrow: b8,
  LucidePilcrowLeft: M8,
  LucidePilcrowRight: _8,
  LucidePilcrowSquare: c1,
  LucidePill: x8,
  LucidePillBottle: L8,
  LucidePin: v8,
  LucidePinOff: E8,
  LucidePipette: A8,
  LucidePizza: I8,
  LucidePlane: C8,
  LucidePlaneLanding: T8,
  LucidePlaneTakeoff: N8,
  LucidePlay: w8,
  LucidePlayCircle: ao,
  LucidePlaySquare: s1,
  LucidePlug: R8,
  LucidePlug2: S8,
  LucidePlugZap: hr,
  LucidePlugZap2: hr,
  LucidePlus: D8,
  LucidePlusCircle: oo,
  LucidePlusSquare: l1,
  LucidePocket: P8,
  LucidePocketKnife: O8,
  LucidePodcast: H8,
  LucidePointer: F8,
  LucidePointerOff: B8,
  LucidePopcorn: $8,
  LucidePopsicle: U8,
  LucidePoundSterling: q8,
  LucidePower: j8,
  LucidePowerCircle: ro,
  LucidePowerOff: z8,
  LucidePowerSquare: d1,
  LucidePresentation: V8,
  LucidePrinter: W8,
  LucidePrinterCheck: G8,
  LucideProjector: X8,
  LucideProportions: Y8,
  LucidePuzzle: K8,
  LucidePyramid: Z8,
  LucideQrCode: Q8,
  LucideQuote: J8,
  LucideRabbit: eM,
  LucideRadar: tM,
  LucideRadiation: nM,
  LucideRadical: aM,
  LucideRadio: iM,
  LucideRadioReceiver: oM,
  LucideRadioTower: rM,
  LucideRadius: cM,
  LucideRailSymbol: sM,
  LucideRainbow: lM,
  LucideRat: dM,
  LucideRatio: uM,
  LucideReceipt: _M,
  LucideReceiptCent: hM,
  LucideReceiptEuro: pM,
  LucideReceiptIndianRupee: yM,
  LucideReceiptJapaneseYen: kM,
  LucideReceiptPoundSterling: fM,
  LucideReceiptRussianRuble: mM,
  LucideReceiptSwissFranc: gM,
  LucideReceiptText: MM,
  LucideRectangleEllipsis: pr,
  LucideRectangleHorizontal: bM,
  LucideRectangleVertical: LM,
  LucideRecycle: xM,
  LucideRedo: AM,
  LucideRedo2: EM,
  LucideRedoDot: vM,
  LucideRefreshCcw: TM,
  LucideRefreshCcwDot: IM,
  LucideRefreshCw: CM,
  LucideRefreshCwOff: NM,
  LucideRefrigerator: wM,
  LucideRegex: SM,
  LucideRemoveFormatting: RM,
  LucideRepeat: PM,
  LucideRepeat1: DM,
  LucideRepeat2: OM,
  LucideReplace: BM,
  LucideReplaceAll: HM,
  LucideReply: $M,
  LucideReplyAll: FM,
  LucideRewind: UM,
  LucideRibbon: qM,
  LucideRocket: zM,
  LucideRockingChair: jM,
  LucideRollerCoaster: VM,
  LucideRotate3D: yr,
  LucideRotate3d: yr,
  LucideRotateCcw: WM,
  LucideRotateCcwSquare: GM,
  LucideRotateCw: YM,
  LucideRotateCwSquare: XM,
  LucideRoute: ZM,
  LucideRouteOff: KM,
  LucideRouter: QM,
  LucideRows: kr,
  LucideRows2: kr,
  LucideRows3: fr,
  LucideRows4: JM,
  LucideRss: e_,
  LucideRuler: t_,
  LucideRussianRuble: n_,
  LucideSailboat: a_,
  LucideSalad: o_,
  LucideSandwich: r_,
  LucideSatellite: c_,
  LucideSatelliteDish: i_,
  LucideSave: d_,
  LucideSaveAll: s_,
  LucideSaveOff: l_,
  LucideScale: u_,
  LucideScale3D: mr,
  LucideScale3d: mr,
  LucideScaling: h_,
  LucideScan: b_,
  LucideScanBarcode: p_,
  LucideScanEye: y_,
  LucideScanFace: k_,
  LucideScanHeart: f_,
  LucideScanLine: m_,
  LucideScanQrCode: g_,
  LucideScanSearch: M_,
  LucideScanText: __,
  LucideScatterChart: Ra,
  LucideSchool: L_,
  LucideSchool2: A1,
  LucideScissors: E_,
  LucideScissorsLineDashed: x_,
  LucideScissorsSquare: u1,
  LucideScissorsSquareDashedBottom: Pr,
  LucideScreenShare: A_,
  LucideScreenShareOff: v_,
  LucideScroll: T_,
  LucideScrollText: I_,
  LucideSearch: R_,
  LucideSearchCheck: N_,
  LucideSearchCode: C_,
  LucideSearchSlash: w_,
  LucideSearchX: S_,
  LucideSection: D_,
  LucideSend: P_,
  LucideSendHorizonal: gr,
  LucideSendHorizontal: gr,
  LucideSendToBack: O_,
  LucideSeparatorHorizontal: H_,
  LucideSeparatorVertical: B_,
  LucideServer: q_,
  LucideServerCog: F_,
  LucideServerCrash: $_,
  LucideServerOff: U_,
  LucideSettings: j_,
  LucideSettings2: z_,
  LucideShapes: V_,
  LucideShare: W_,
  LucideShare2: G_,
  LucideSheet: X_,
  LucideShell: Y_,
  LucideShield: r7,
  LucideShieldAlert: K_,
  LucideShieldBan: Z_,
  LucideShieldCheck: Q_,
  LucideShieldClose: Mr,
  LucideShieldEllipsis: J_,
  LucideShieldHalf: e7,
  LucideShieldMinus: t7,
  LucideShieldOff: n7,
  LucideShieldPlus: a7,
  LucideShieldQuestion: o7,
  LucideShieldX: Mr,
  LucideShip: c7,
  LucideShipWheel: i7,
  LucideShirt: s7,
  LucideShoppingBag: l7,
  LucideShoppingBasket: d7,
  LucideShoppingCart: u7,
  LucideShovel: h7,
  LucideShowerHead: p7,
  LucideShrink: y7,
  LucideShrub: k7,
  LucideShuffle: f7,
  LucideSidebar: ir,
  LucideSidebarClose: ar,
  LucideSidebarOpen: rr,
  LucideSigma: m7,
  LucideSigmaSquare: h1,
  LucideSignal: L7,
  LucideSignalHigh: g7,
  LucideSignalLow: M7,
  LucideSignalMedium: _7,
  LucideSignalZero: b7,
  LucideSignature: x7,
  LucideSignpost: v7,
  LucideSignpostBig: E7,
  LucideSiren: A7,
  LucideSkipBack: I7,
  LucideSkipForward: T7,
  LucideSkull: N7,
  LucideSlack: C7,
  LucideSlash: w7,
  LucideSlashSquare: p1,
  LucideSlice: S7,
  LucideSliders: _r,
  LucideSlidersHorizontal: R7,
  LucideSlidersVertical: _r,
  LucideSmartphone: P7,
  LucideSmartphoneCharging: D7,
  LucideSmartphoneNfc: O7,
  LucideSmile: B7,
  LucideSmilePlus: H7,
  LucideSnail: F7,
  LucideSnowflake: $7,
  LucideSofa: U7,
  LucideSortAsc: ha,
  LucideSortDesc: la,
  LucideSoup: q7,
  LucideSpace: z7,
  LucideSpade: j7,
  LucideSparkle: V7,
  LucideSparkles: br,
  LucideSpeaker: G7,
  LucideSpeech: W7,
  LucideSpellCheck: Y7,
  LucideSpellCheck2: X7,
  LucideSpline: K7,
  LucideSplit: Z7,
  LucideSplitSquareHorizontal: y1,
  LucideSplitSquareVertical: k1,
  LucideSprayCan: Q7,
  LucideSprout: J7,
  LucideSquare: rb,
  LucideSquareActivity: Lr,
  LucideSquareArrowDown: vr,
  LucideSquareArrowDownLeft: xr,
  LucideSquareArrowDownRight: Er,
  LucideSquareArrowLeft: Ar,
  LucideSquareArrowOutDownLeft: Ir,
  LucideSquareArrowOutDownRight: Tr,
  LucideSquareArrowOutUpLeft: Nr,
  LucideSquareArrowOutUpRight: Cr,
  LucideSquareArrowRight: wr,
  LucideSquareArrowUp: Dr,
  LucideSquareArrowUpLeft: Sr,
  LucideSquareArrowUpRight: Rr,
  LucideSquareAsterisk: Or,
  LucideSquareBottomDashedScissors: Pr,
  LucideSquareChartGantt: hn,
  LucideSquareCheck: Br,
  LucideSquareCheckBig: Hr,
  LucideSquareChevronDown: Fr,
  LucideSquareChevronLeft: $r,
  LucideSquareChevronRight: Ur,
  LucideSquareChevronUp: qr,
  LucideSquareCode: zr,
  LucideSquareDashed: Gr,
  LucideSquareDashedBottom: tb,
  LucideSquareDashedBottomCode: eb,
  LucideSquareDashedKanban: jr,
  LucideSquareDashedMousePointer: Vr,
  LucideSquareDivide: Wr,
  LucideSquareDot: Xr,
  LucideSquareEqual: Yr,
  LucideSquareFunction: Kr,
  LucideSquareGanttChart: hn,
  LucideSquareKanban: Zr,
  LucideSquareLibrary: Qr,
  LucideSquareM: Jr,
  LucideSquareMenu: e1,
  LucideSquareMinus: t1,
  LucideSquareMousePointer: n1,
  LucideSquareParking: o1,
  LucideSquareParkingOff: a1,
  LucideSquarePen: Pt,
  LucideSquarePercent: r1,
  LucideSquarePi: i1,
  LucideSquarePilcrow: c1,
  LucideSquarePlay: s1,
  LucideSquarePlus: l1,
  LucideSquarePower: d1,
  LucideSquareRadical: nb,
  LucideSquareScissors: u1,
  LucideSquareSigma: h1,
  LucideSquareSlash: p1,
  LucideSquareSplitHorizontal: y1,
  LucideSquareSplitVertical: k1,
  LucideSquareSquare: ab,
  LucideSquareStack: ob,
  LucideSquareTerminal: f1,
  LucideSquareUser: g1,
  LucideSquareUserRound: m1,
  LucideSquareX: M1,
  LucideSquircle: ib,
  LucideSquirrel: cb,
  LucideStamp: sb,
  LucideStar: ub,
  LucideStarHalf: lb,
  LucideStarOff: db,
  LucideStars: br,
  LucideStepBack: hb,
  LucideStepForward: pb,
  LucideStethoscope: yb,
  LucideSticker: kb,
  LucideStickyNote: fb,
  LucideStopCircle: co,
  LucideStore: mb,
  LucideStretchHorizontal: gb,
  LucideStretchVertical: Mb,
  LucideStrikethrough: _b,
  LucideSubscript: bb,
  LucideSubtitles: _a,
  LucideSun: Ab,
  LucideSunDim: Lb,
  LucideSunMedium: xb,
  LucideSunMoon: Eb,
  LucideSunSnow: vb,
  LucideSunrise: Ib,
  LucideSunset: Tb,
  LucideSuperscript: Nb,
  LucideSwatchBook: Cb,
  LucideSwissFranc: wb,
  LucideSwitchCamera: Sb,
  LucideSword: Rb,
  LucideSwords: Db,
  LucideSyringe: Ob,
  LucideTable: zb,
  LucideTable2: Pb,
  LucideTableCellsMerge: Hb,
  LucideTableCellsSplit: Bb,
  LucideTableColumnsSplit: Fb,
  LucideTableOfContents: $b,
  LucideTableProperties: Ub,
  LucideTableRowsSplit: qb,
  LucideTablet: Vb,
  LucideTabletSmartphone: jb,
  LucideTablets: Gb,
  LucideTag: Wb,
  LucideTags: Xb,
  LucideTally1: Yb,
  LucideTally2: Kb,
  LucideTally3: Zb,
  LucideTally4: Qb,
  LucideTally5: Jb,
  LucideTangent: eL,
  LucideTarget: tL,
  LucideTelescope: nL,
  LucideTent: oL,
  LucideTentTree: aL,
  LucideTerminal: rL,
  LucideTerminalSquare: f1,
  LucideTestTube: iL,
  LucideTestTube2: _1,
  LucideTestTubeDiagonal: _1,
  LucideTestTubes: cL,
  LucideText: hL,
  LucideTextCursor: lL,
  LucideTextCursorInput: sL,
  LucideTextQuote: dL,
  LucideTextSearch: uL,
  LucideTextSelect: b1,
  LucideTextSelection: b1,
  LucideTheater: pL,
  LucideThermometer: fL,
  LucideThermometerSnowflake: yL,
  LucideThermometerSun: kL,
  LucideThumbsDown: mL,
  LucideThumbsUp: gL,
  LucideTicket: vL,
  LucideTicketCheck: ML,
  LucideTicketMinus: _L,
  LucideTicketPercent: bL,
  LucideTicketPlus: LL,
  LucideTicketSlash: xL,
  LucideTicketX: EL,
  LucideTickets: IL,
  LucideTicketsPlane: AL,
  LucideTimer: CL,
  LucideTimerOff: TL,
  LucideTimerReset: NL,
  LucideToggleLeft: wL,
  LucideToggleRight: SL,
  LucideToilet: RL,
  LucideTornado: DL,
  LucideTorus: OL,
  LucideTouchpad: HL,
  LucideTouchpadOff: PL,
  LucideTowerControl: BL,
  LucideToyBrick: FL,
  LucideTractor: $L,
  LucideTrafficCone: UL,
  LucideTrain: L1,
  LucideTrainFront: zL,
  LucideTrainFrontTunnel: qL,
  LucideTrainTrack: jL,
  LucideTramFront: L1,
  LucideTransgender: VL,
  LucideTrash: WL,
  LucideTrash2: GL,
  LucideTreeDeciduous: XL,
  LucideTreePalm: x1,
  LucideTreePine: YL,
  LucideTrees: KL,
  LucideTrello: ZL,
  LucideTrendingDown: QL,
  LucideTrendingUp: ex,
  LucideTrendingUpDown: JL,
  LucideTriangle: ax,
  LucideTriangleAlert: E1,
  LucideTriangleDashed: tx,
  LucideTriangleRight: nx,
  LucideTrophy: ox,
  LucideTruck: rx,
  LucideTurtle: ix,
  LucideTv: sx,
  LucideTv2: v1,
  LucideTvMinimal: v1,
  LucideTvMinimalPlay: cx,
  LucideTwitch: lx,
  LucideTwitter: dx,
  LucideType: hx,
  LucideTypeOutline: ux,
  LucideUmbrella: yx,
  LucideUmbrellaOff: px,
  LucideUnderline: kx,
  LucideUndo: gx,
  LucideUndo2: fx,
  LucideUndoDot: mx,
  LucideUnfoldHorizontal: Mx,
  LucideUnfoldVertical: _x,
  LucideUngroup: bx,
  LucideUniversity: A1,
  LucideUnlink: xx,
  LucideUnlink2: Lx,
  LucideUnlock: Yo,
  LucideUnlockKeyhole: Xo,
  LucideUnplug: Ex,
  LucideUpload: vx,
  LucideUploadCloud: ko,
  LucideUsb: Ax,
  LucideUser: Px,
  LucideUser2: S1,
  LucideUserCheck: Ix,
  LucideUserCheck2: I1,
  LucideUserCircle: lo,
  LucideUserCircle2: so,
  LucideUserCog: Tx,
  LucideUserCog2: T1,
  LucideUserMinus: Nx,
  LucideUserMinus2: N1,
  LucideUserPen: Cx,
  LucideUserPlus: wx,
  LucideUserPlus2: C1,
  LucideUserRound: S1,
  LucideUserRoundCheck: I1,
  LucideUserRoundCog: T1,
  LucideUserRoundMinus: N1,
  LucideUserRoundPen: Sx,
  LucideUserRoundPlus: C1,
  LucideUserRoundSearch: Rx,
  LucideUserRoundX: w1,
  LucideUserSearch: Dx,
  LucideUserSquare: g1,
  LucideUserSquare2: m1,
  LucideUserX: Ox,
  LucideUserX2: w1,
  LucideUsers: Hx,
  LucideUsers2: R1,
  LucideUsersRound: R1,
  LucideUtensils: O1,
  LucideUtensilsCrossed: D1,
  LucideUtilityPole: Bx,
  LucideVariable: Fx,
  LucideVault: $x,
  LucideVegan: Ux,
  LucideVenetianMask: qx,
  LucideVenus: jx,
  LucideVenusAndMars: zx,
  LucideVerified: ka,
  LucideVibrate: Gx,
  LucideVibrateOff: Vx,
  LucideVideo: Xx,
  LucideVideoOff: Wx,
  LucideVideotape: Yx,
  LucideView: Kx,
  LucideVoicemail: Zx,
  LucideVolleyball: Qx,
  LucideVolume: a9,
  LucideVolume1: Jx,
  LucideVolume2: e9,
  LucideVolumeOff: t9,
  LucideVolumeX: n9,
  LucideVote: o9,
  LucideWallet: i9,
  LucideWallet2: P1,
  LucideWalletCards: r9,
  LucideWalletMinimal: P1,
  LucideWallpaper: c9,
  LucideWand: s9,
  LucideWand2: H1,
  LucideWandSparkles: H1,
  LucideWarehouse: l9,
  LucideWashingMachine: d9,
  LucideWatch: u9,
  LucideWaves: p9,
  LucideWavesLadder: h9,
  LucideWaypoints: y9,
  LucideWebcam: k9,
  LucideWebhook: m9,
  LucideWebhookOff: f9,
  LucideWeight: g9,
  LucideWheat: _9,
  LucideWheatOff: M9,
  LucideWholeWord: b9,
  LucideWifi: A9,
  LucideWifiHigh: L9,
  LucideWifiLow: x9,
  LucideWifiOff: E9,
  LucideWifiZero: v9,
  LucideWind: T9,
  LucideWindArrowDown: I9,
  LucideWine: C9,
  LucideWineOff: N9,
  LucideWorkflow: w9,
  LucideWorm: S9,
  LucideWrapText: R9,
  LucideWrench: D9,
  LucideX: O9,
  LucideXCircle: uo,
  LucideXOctagon: er,
  LucideXSquare: M1,
  LucideYoutube: P9,
  LucideZap: B9,
  LucideZapOff: H9,
  LucideZoomIn: F9,
  LucideZoomOut: $9,
  Luggage: q5,
  LuggageIcon: q5,
  MSquare: Jr,
  MSquareIcon: Jr,
  Magnet: z5,
  MagnetIcon: z5,
  Mail: Q5,
  MailCheck: j5,
  MailCheckIcon: j5,
  MailIcon: Q5,
  MailMinus: V5,
  MailMinusIcon: V5,
  MailOpen: G5,
  MailOpenIcon: G5,
  MailPlus: W5,
  MailPlusIcon: W5,
  MailQuestion: X5,
  MailQuestionIcon: X5,
  MailSearch: Y5,
  MailSearchIcon: Y5,
  MailWarning: K5,
  MailWarningIcon: K5,
  MailX: Z5,
  MailXIcon: Z5,
  Mailbox: J5,
  MailboxIcon: J5,
  Mails: em,
  MailsIcon: em,
  Map: ym,
  MapIcon: ym,
  MapPin: um,
  MapPinCheck: nm,
  MapPinCheckIcon: nm,
  MapPinCheckInside: tm,
  MapPinCheckInsideIcon: tm,
  MapPinHouse: am,
  MapPinHouseIcon: am,
  MapPinIcon: um,
  MapPinMinus: rm,
  MapPinMinusIcon: rm,
  MapPinMinusInside: om,
  MapPinMinusInsideIcon: om,
  MapPinOff: im,
  MapPinOffIcon: im,
  MapPinPlus: sm,
  MapPinPlusIcon: sm,
  MapPinPlusInside: cm,
  MapPinPlusInsideIcon: cm,
  MapPinX: dm,
  MapPinXIcon: dm,
  MapPinXInside: lm,
  MapPinXInsideIcon: lm,
  MapPinned: hm,
  MapPinnedIcon: hm,
  MapPlus: pm,
  MapPlusIcon: pm,
  Mars: fm,
  MarsIcon: fm,
  MarsStroke: km,
  MarsStrokeIcon: km,
  Martini: mm,
  MartiniIcon: mm,
  Maximize: Mm,
  Maximize2: gm,
  Maximize2Icon: gm,
  MaximizeIcon: Mm,
  Medal: _m,
  MedalIcon: _m,
  Megaphone: Lm,
  MegaphoneIcon: Lm,
  MegaphoneOff: bm,
  MegaphoneOffIcon: bm,
  Meh: xm,
  MehIcon: xm,
  MemoryStick: Em,
  MemoryStickIcon: Em,
  Menu: vm,
  MenuIcon: vm,
  MenuSquare: e1,
  MenuSquareIcon: e1,
  Merge: Am,
  MergeIcon: Am,
  MessageCircle: Hm,
  MessageCircleCode: Im,
  MessageCircleCodeIcon: Im,
  MessageCircleDashed: Tm,
  MessageCircleDashedIcon: Tm,
  MessageCircleHeart: Nm,
  MessageCircleHeartIcon: Nm,
  MessageCircleIcon: Hm,
  MessageCircleMore: Cm,
  MessageCircleMoreIcon: Cm,
  MessageCircleOff: wm,
  MessageCircleOffIcon: wm,
  MessageCirclePlus: Sm,
  MessageCirclePlusIcon: Sm,
  MessageCircleQuestion: Rm,
  MessageCircleQuestionIcon: Rm,
  MessageCircleReply: Dm,
  MessageCircleReplyIcon: Dm,
  MessageCircleWarning: Om,
  MessageCircleWarningIcon: Om,
  MessageCircleX: Pm,
  MessageCircleXIcon: Pm,
  MessageSquare: Jm,
  MessageSquareCode: Bm,
  MessageSquareCodeIcon: Bm,
  MessageSquareDashed: Fm,
  MessageSquareDashedIcon: Fm,
  MessageSquareDiff: $m,
  MessageSquareDiffIcon: $m,
  MessageSquareDot: Um,
  MessageSquareDotIcon: Um,
  MessageSquareHeart: qm,
  MessageSquareHeartIcon: qm,
  MessageSquareIcon: Jm,
  MessageSquareLock: zm,
  MessageSquareLockIcon: zm,
  MessageSquareMore: jm,
  MessageSquareMoreIcon: jm,
  MessageSquareOff: Vm,
  MessageSquareOffIcon: Vm,
  MessageSquarePlus: Gm,
  MessageSquarePlusIcon: Gm,
  MessageSquareQuote: Wm,
  MessageSquareQuoteIcon: Wm,
  MessageSquareReply: Xm,
  MessageSquareReplyIcon: Xm,
  MessageSquareShare: Ym,
  MessageSquareShareIcon: Ym,
  MessageSquareText: Km,
  MessageSquareTextIcon: Km,
  MessageSquareWarning: Zm,
  MessageSquareWarningIcon: Zm,
  MessageSquareX: Qm,
  MessageSquareXIcon: Qm,
  MessagesSquare: e6,
  MessagesSquareIcon: e6,
  Mic: n6,
  Mic2: Ko,
  Mic2Icon: Ko,
  MicIcon: n6,
  MicOff: t6,
  MicOffIcon: t6,
  MicVocal: Ko,
  MicVocalIcon: Ko,
  Microchip: a6,
  MicrochipIcon: a6,
  Microscope: o6,
  MicroscopeIcon: o6,
  Microwave: r6,
  MicrowaveIcon: r6,
  Milestone: i6,
  MilestoneIcon: i6,
  Milk: s6,
  MilkIcon: s6,
  MilkOff: c6,
  MilkOffIcon: c6,
  Minimize: d6,
  Minimize2: l6,
  Minimize2Icon: l6,
  MinimizeIcon: d6,
  Minus: u6,
  MinusCircle: Qa,
  MinusCircleIcon: Qa,
  MinusIcon: u6,
  MinusSquare: t1,
  MinusSquareIcon: t1,
  Monitor: E6,
  MonitorCheck: h6,
  MonitorCheckIcon: h6,
  MonitorCog: p6,
  MonitorCogIcon: p6,
  MonitorDot: y6,
  MonitorDotIcon: y6,
  MonitorDown: k6,
  MonitorDownIcon: k6,
  MonitorIcon: E6,
  MonitorOff: f6,
  MonitorOffIcon: f6,
  MonitorPause: m6,
  MonitorPauseIcon: m6,
  MonitorPlay: g6,
  MonitorPlayIcon: g6,
  MonitorSmartphone: M6,
  MonitorSmartphoneIcon: M6,
  MonitorSpeaker: _6,
  MonitorSpeakerIcon: _6,
  MonitorStop: b6,
  MonitorStopIcon: b6,
  MonitorUp: L6,
  MonitorUpIcon: L6,
  MonitorX: x6,
  MonitorXIcon: x6,
  Moon: A6,
  MoonIcon: A6,
  MoonStar: v6,
  MoonStarIcon: v6,
  MoreHorizontal: xo,
  MoreHorizontalIcon: xo,
  MoreVertical: Lo,
  MoreVerticalIcon: Lo,
  Mountain: T6,
  MountainIcon: T6,
  MountainSnow: I6,
  MountainSnowIcon: I6,
  Mouse: D6,
  MouseIcon: D6,
  MouseOff: N6,
  MouseOffIcon: N6,
  MousePointer: R6,
  MousePointer2: C6,
  MousePointer2Icon: C6,
  MousePointerBan: w6,
  MousePointerBanIcon: w6,
  MousePointerClick: S6,
  MousePointerClickIcon: S6,
  MousePointerIcon: R6,
  MousePointerSquareDashed: Vr,
  MousePointerSquareDashedIcon: Vr,
  Move: W6,
  Move3D: Zo,
  Move3DIcon: Zo,
  Move3d: Zo,
  Move3dIcon: Zo,
  MoveDiagonal: P6,
  MoveDiagonal2: O6,
  MoveDiagonal2Icon: O6,
  MoveDiagonalIcon: P6,
  MoveDown: F6,
  MoveDownIcon: F6,
  MoveDownLeft: H6,
  MoveDownLeftIcon: H6,
  MoveDownRight: B6,
  MoveDownRightIcon: B6,
  MoveHorizontal: $6,
  MoveHorizontalIcon: $6,
  MoveIcon: W6,
  MoveLeft: U6,
  MoveLeftIcon: U6,
  MoveRight: q6,
  MoveRightIcon: q6,
  MoveUp: V6,
  MoveUpIcon: V6,
  MoveUpLeft: z6,
  MoveUpLeftIcon: z6,
  MoveUpRight: j6,
  MoveUpRightIcon: j6,
  MoveVertical: G6,
  MoveVerticalIcon: G6,
  Music: Z6,
  Music2: X6,
  Music2Icon: X6,
  Music3: Y6,
  Music3Icon: Y6,
  Music4: K6,
  Music4Icon: K6,
  MusicIcon: Z6,
  Navigation: tg,
  Navigation2: J6,
  Navigation2Icon: J6,
  Navigation2Off: Q6,
  Navigation2OffIcon: Q6,
  NavigationIcon: tg,
  NavigationOff: eg,
  NavigationOffIcon: eg,
  Network: ng,
  NetworkIcon: ng,
  Newspaper: ag,
  NewspaperIcon: ag,
  Nfc: og,
  NfcIcon: og,
  NonBinary: rg,
  NonBinaryIcon: rg,
  Notebook: lg,
  NotebookIcon: lg,
  NotebookPen: ig,
  NotebookPenIcon: ig,
  NotebookTabs: cg,
  NotebookTabsIcon: cg,
  NotebookText: sg,
  NotebookTextIcon: sg,
  NotepadText: ug,
  NotepadTextDashed: dg,
  NotepadTextDashedIcon: dg,
  NotepadTextIcon: ug,
  Nut: pg,
  NutIcon: pg,
  NutOff: hg,
  NutOffIcon: hg,
  Octagon: kg,
  OctagonAlert: Qo,
  OctagonAlertIcon: Qo,
  OctagonIcon: kg,
  OctagonMinus: yg,
  OctagonMinusIcon: yg,
  OctagonPause: Jo,
  OctagonPauseIcon: Jo,
  OctagonX: er,
  OctagonXIcon: er,
  Omega: fg,
  OmegaIcon: fg,
  Option: mg,
  OptionIcon: mg,
  Orbit: gg,
  OrbitIcon: gg,
  Origami: Mg,
  OrigamiIcon: Mg,
  Outdent: zo,
  OutdentIcon: zo,
  Package: Ig,
  Package2: _g,
  Package2Icon: _g,
  PackageCheck: bg,
  PackageCheckIcon: bg,
  PackageIcon: Ig,
  PackageMinus: Lg,
  PackageMinusIcon: Lg,
  PackageOpen: xg,
  PackageOpenIcon: xg,
  PackagePlus: Eg,
  PackagePlusIcon: Eg,
  PackageSearch: vg,
  PackageSearchIcon: vg,
  PackageX: Ag,
  PackageXIcon: Ag,
  PaintBucket: Tg,
  PaintBucketIcon: Tg,
  PaintRoller: Ng,
  PaintRollerIcon: Ng,
  Paintbrush: Cg,
  Paintbrush2: tr,
  Paintbrush2Icon: tr,
  PaintbrushIcon: Cg,
  PaintbrushVertical: tr,
  PaintbrushVerticalIcon: tr,
  Palette: wg,
  PaletteIcon: wg,
  Palmtree: x1,
  PalmtreeIcon: x1,
  PanelBottom: Dg,
  PanelBottomClose: Sg,
  PanelBottomCloseIcon: Sg,
  PanelBottomDashed: nr,
  PanelBottomDashedIcon: nr,
  PanelBottomIcon: Dg,
  PanelBottomInactive: nr,
  PanelBottomInactiveIcon: nr,
  PanelBottomOpen: Rg,
  PanelBottomOpenIcon: Rg,
  PanelLeft: ir,
  PanelLeftClose: ar,
  PanelLeftCloseIcon: ar,
  PanelLeftDashed: or,
  PanelLeftDashedIcon: or,
  PanelLeftIcon: ir,
  PanelLeftInactive: or,
  PanelLeftInactiveIcon: or,
  PanelLeftOpen: rr,
  PanelLeftOpenIcon: rr,
  PanelRight: Hg,
  PanelRightClose: Og,
  PanelRightCloseIcon: Og,
  PanelRightDashed: cr,
  PanelRightDashedIcon: cr,
  PanelRightIcon: Hg,
  PanelRightInactive: cr,
  PanelRightInactiveIcon: cr,
  PanelRightOpen: Pg,
  PanelRightOpenIcon: Pg,
  PanelTop: $g,
  PanelTopClose: Bg,
  PanelTopCloseIcon: Bg,
  PanelTopDashed: sr,
  PanelTopDashedIcon: sr,
  PanelTopIcon: $g,
  PanelTopInactive: sr,
  PanelTopInactiveIcon: sr,
  PanelTopOpen: Fg,
  PanelTopOpenIcon: Fg,
  PanelsLeftBottom: Ug,
  PanelsLeftBottomIcon: Ug,
  PanelsLeftRight: go,
  PanelsLeftRightIcon: go,
  PanelsRightBottom: qg,
  PanelsRightBottomIcon: qg,
  PanelsTopBottom: fr,
  PanelsTopBottomIcon: fr,
  PanelsTopLeft: lr,
  PanelsTopLeftIcon: lr,
  Paperclip: zg,
  PaperclipIcon: zg,
  Parentheses: jg,
  ParenthesesIcon: jg,
  ParkingCircle: eo,
  ParkingCircleIcon: eo,
  ParkingCircleOff: Ja,
  ParkingCircleOffIcon: Ja,
  ParkingMeter: Vg,
  ParkingMeterIcon: Vg,
  ParkingSquare: o1,
  ParkingSquareIcon: o1,
  ParkingSquareOff: a1,
  ParkingSquareOffIcon: a1,
  PartyPopper: Gg,
  PartyPopperIcon: Gg,
  Pause: Wg,
  PauseCircle: to,
  PauseCircleIcon: to,
  PauseIcon: Wg,
  PauseOctagon: Jo,
  PauseOctagonIcon: Jo,
  PawPrint: Xg,
  PawPrintIcon: Xg,
  PcCase: Yg,
  PcCaseIcon: Yg,
  Pen: ur,
  PenBox: Pt,
  PenBoxIcon: Pt,
  PenIcon: ur,
  PenLine: dr,
  PenLineIcon: dr,
  PenOff: Kg,
  PenOffIcon: Kg,
  PenSquare: Pt,
  PenSquareIcon: Pt,
  PenTool: Zg,
  PenToolIcon: Zg,
  Pencil: t8,
  PencilIcon: t8,
  PencilLine: Qg,
  PencilLineIcon: Qg,
  PencilOff: Jg,
  PencilOffIcon: Jg,
  PencilRuler: e8,
  PencilRulerIcon: e8,
  Pentagon: n8,
  PentagonIcon: n8,
  Percent: a8,
  PercentCircle: no,
  PercentCircleIcon: no,
  PercentDiamond: _o,
  PercentDiamondIcon: _o,
  PercentIcon: a8,
  PercentSquare: r1,
  PercentSquareIcon: r1,
  PersonStanding: o8,
  PersonStandingIcon: o8,
  PhilippinePeso: r8,
  PhilippinePesoIcon: r8,
  Phone: h8,
  PhoneCall: i8,
  PhoneCallIcon: i8,
  PhoneForwarded: c8,
  PhoneForwardedIcon: c8,
  PhoneIcon: h8,
  PhoneIncoming: s8,
  PhoneIncomingIcon: s8,
  PhoneMissed: l8,
  PhoneMissedIcon: l8,
  PhoneOff: d8,
  PhoneOffIcon: d8,
  PhoneOutgoing: u8,
  PhoneOutgoingIcon: u8,
  Pi: p8,
  PiIcon: p8,
  PiSquare: i1,
  PiSquareIcon: i1,
  Piano: y8,
  PianoIcon: y8,
  Pickaxe: k8,
  PickaxeIcon: k8,
  PictureInPicture: m8,
  PictureInPicture2: f8,
  PictureInPicture2Icon: f8,
  PictureInPictureIcon: m8,
  PieChart: Sa,
  PieChartIcon: Sa,
  PiggyBank: g8,
  PiggyBankIcon: g8,
  Pilcrow: b8,
  PilcrowIcon: b8,
  PilcrowLeft: M8,
  PilcrowLeftIcon: M8,
  PilcrowRight: _8,
  PilcrowRightIcon: _8,
  PilcrowSquare: c1,
  PilcrowSquareIcon: c1,
  Pill: x8,
  PillBottle: L8,
  PillBottleIcon: L8,
  PillIcon: x8,
  Pin: v8,
  PinIcon: v8,
  PinOff: E8,
  PinOffIcon: E8,
  Pipette: A8,
  PipetteIcon: A8,
  Pizza: I8,
  PizzaIcon: I8,
  Plane: C8,
  PlaneIcon: C8,
  PlaneLanding: T8,
  PlaneLandingIcon: T8,
  PlaneTakeoff: N8,
  PlaneTakeoffIcon: N8,
  Play: w8,
  PlayCircle: ao,
  PlayCircleIcon: ao,
  PlayIcon: w8,
  PlaySquare: s1,
  PlaySquareIcon: s1,
  Plug: R8,
  Plug2: S8,
  Plug2Icon: S8,
  PlugIcon: R8,
  PlugZap: hr,
  PlugZap2: hr,
  PlugZap2Icon: hr,
  PlugZapIcon: hr,
  Plus: D8,
  PlusCircle: oo,
  PlusCircleIcon: oo,
  PlusIcon: D8,
  PlusSquare: l1,
  PlusSquareIcon: l1,
  Pocket: P8,
  PocketIcon: P8,
  PocketKnife: O8,
  PocketKnifeIcon: O8,
  Podcast: H8,
  PodcastIcon: H8,
  Pointer: F8,
  PointerIcon: F8,
  PointerOff: B8,
  PointerOffIcon: B8,
  Popcorn: $8,
  PopcornIcon: $8,
  Popsicle: U8,
  PopsicleIcon: U8,
  PoundSterling: q8,
  PoundSterlingIcon: q8,
  Power: j8,
  PowerCircle: ro,
  PowerCircleIcon: ro,
  PowerIcon: j8,
  PowerOff: z8,
  PowerOffIcon: z8,
  PowerSquare: d1,
  PowerSquareIcon: d1,
  Presentation: V8,
  PresentationIcon: V8,
  Printer: W8,
  PrinterCheck: G8,
  PrinterCheckIcon: G8,
  PrinterIcon: W8,
  Projector: X8,
  ProjectorIcon: X8,
  Proportions: Y8,
  ProportionsIcon: Y8,
  Puzzle: K8,
  PuzzleIcon: K8,
  Pyramid: Z8,
  PyramidIcon: Z8,
  QrCode: Q8,
  QrCodeIcon: Q8,
  Quote: J8,
  QuoteIcon: J8,
  Rabbit: eM,
  RabbitIcon: eM,
  Radar: tM,
  RadarIcon: tM,
  Radiation: nM,
  RadiationIcon: nM,
  Radical: aM,
  RadicalIcon: aM,
  Radio: iM,
  RadioIcon: iM,
  RadioReceiver: oM,
  RadioReceiverIcon: oM,
  RadioTower: rM,
  RadioTowerIcon: rM,
  Radius: cM,
  RadiusIcon: cM,
  RailSymbol: sM,
  RailSymbolIcon: sM,
  Rainbow: lM,
  RainbowIcon: lM,
  Rat: dM,
  RatIcon: dM,
  Ratio: uM,
  RatioIcon: uM,
  Receipt: _M,
  ReceiptCent: hM,
  ReceiptCentIcon: hM,
  ReceiptEuro: pM,
  ReceiptEuroIcon: pM,
  ReceiptIcon: _M,
  ReceiptIndianRupee: yM,
  ReceiptIndianRupeeIcon: yM,
  ReceiptJapaneseYen: kM,
  ReceiptJapaneseYenIcon: kM,
  ReceiptPoundSterling: fM,
  ReceiptPoundSterlingIcon: fM,
  ReceiptRussianRuble: mM,
  ReceiptRussianRubleIcon: mM,
  ReceiptSwissFranc: gM,
  ReceiptSwissFrancIcon: gM,
  ReceiptText: MM,
  ReceiptTextIcon: MM,
  RectangleEllipsis: pr,
  RectangleEllipsisIcon: pr,
  RectangleHorizontal: bM,
  RectangleHorizontalIcon: bM,
  RectangleVertical: LM,
  RectangleVerticalIcon: LM,
  Recycle: xM,
  RecycleIcon: xM,
  Redo: AM,
  Redo2: EM,
  Redo2Icon: EM,
  RedoDot: vM,
  RedoDotIcon: vM,
  RedoIcon: AM,
  RefreshCcw: TM,
  RefreshCcwDot: IM,
  RefreshCcwDotIcon: IM,
  RefreshCcwIcon: TM,
  RefreshCw: CM,
  RefreshCwIcon: CM,
  RefreshCwOff: NM,
  RefreshCwOffIcon: NM,
  Refrigerator: wM,
  RefrigeratorIcon: wM,
  Regex: SM,
  RegexIcon: SM,
  RemoveFormatting: RM,
  RemoveFormattingIcon: RM,
  Repeat: PM,
  Repeat1: DM,
  Repeat1Icon: DM,
  Repeat2: OM,
  Repeat2Icon: OM,
  RepeatIcon: PM,
  Replace: BM,
  ReplaceAll: HM,
  ReplaceAllIcon: HM,
  ReplaceIcon: BM,
  Reply: $M,
  ReplyAll: FM,
  ReplyAllIcon: FM,
  ReplyIcon: $M,
  Rewind: UM,
  RewindIcon: UM,
  Ribbon: qM,
  RibbonIcon: qM,
  Rocket: zM,
  RocketIcon: zM,
  RockingChair: jM,
  RockingChairIcon: jM,
  RollerCoaster: VM,
  RollerCoasterIcon: VM,
  Rotate3D: yr,
  Rotate3DIcon: yr,
  Rotate3d: yr,
  Rotate3dIcon: yr,
  RotateCcw: WM,
  RotateCcwIcon: WM,
  RotateCcwSquare: GM,
  RotateCcwSquareIcon: GM,
  RotateCw: YM,
  RotateCwIcon: YM,
  RotateCwSquare: XM,
  RotateCwSquareIcon: XM,
  Route: ZM,
  RouteIcon: ZM,
  RouteOff: KM,
  RouteOffIcon: KM,
  Router: QM,
  RouterIcon: QM,
  Rows: kr,
  Rows2: kr,
  Rows2Icon: kr,
  Rows3: fr,
  Rows3Icon: fr,
  Rows4: JM,
  Rows4Icon: JM,
  RowsIcon: kr,
  Rss: e_,
  RssIcon: e_,
  Ruler: t_,
  RulerIcon: t_,
  RussianRuble: n_,
  RussianRubleIcon: n_,
  Sailboat: a_,
  SailboatIcon: a_,
  Salad: o_,
  SaladIcon: o_,
  Sandwich: r_,
  SandwichIcon: r_,
  Satellite: c_,
  SatelliteDish: i_,
  SatelliteDishIcon: i_,
  SatelliteIcon: c_,
  Save: d_,
  SaveAll: s_,
  SaveAllIcon: s_,
  SaveIcon: d_,
  SaveOff: l_,
  SaveOffIcon: l_,
  Scale: u_,
  Scale3D: mr,
  Scale3DIcon: mr,
  Scale3d: mr,
  Scale3dIcon: mr,
  ScaleIcon: u_,
  Scaling: h_,
  ScalingIcon: h_,
  Scan: b_,
  ScanBarcode: p_,
  ScanBarcodeIcon: p_,
  ScanEye: y_,
  ScanEyeIcon: y_,
  ScanFace: k_,
  ScanFaceIcon: k_,
  ScanHeart: f_,
  ScanHeartIcon: f_,
  ScanIcon: b_,
  ScanLine: m_,
  ScanLineIcon: m_,
  ScanQrCode: g_,
  ScanQrCodeIcon: g_,
  ScanSearch: M_,
  ScanSearchIcon: M_,
  ScanText: __,
  ScanTextIcon: __,
  ScatterChart: Ra,
  ScatterChartIcon: Ra,
  School: L_,
  School2: A1,
  School2Icon: A1,
  SchoolIcon: L_,
  Scissors: E_,
  ScissorsIcon: E_,
  ScissorsLineDashed: x_,
  ScissorsLineDashedIcon: x_,
  ScissorsSquare: u1,
  ScissorsSquareDashedBottom: Pr,
  ScissorsSquareDashedBottomIcon: Pr,
  ScissorsSquareIcon: u1,
  ScreenShare: A_,
  ScreenShareIcon: A_,
  ScreenShareOff: v_,
  ScreenShareOffIcon: v_,
  Scroll: T_,
  ScrollIcon: T_,
  ScrollText: I_,
  ScrollTextIcon: I_,
  Search: R_,
  SearchCheck: N_,
  SearchCheckIcon: N_,
  SearchCode: C_,
  SearchCodeIcon: C_,
  SearchIcon: R_,
  SearchSlash: w_,
  SearchSlashIcon: w_,
  SearchX: S_,
  SearchXIcon: S_,
  Section: D_,
  SectionIcon: D_,
  Send: P_,
  SendHorizonal: gr,
  SendHorizonalIcon: gr,
  SendHorizontal: gr,
  SendHorizontalIcon: gr,
  SendIcon: P_,
  SendToBack: O_,
  SendToBackIcon: O_,
  SeparatorHorizontal: H_,
  SeparatorHorizontalIcon: H_,
  SeparatorVertical: B_,
  SeparatorVerticalIcon: B_,
  Server: q_,
  ServerCog: F_,
  ServerCogIcon: F_,
  ServerCrash: $_,
  ServerCrashIcon: $_,
  ServerIcon: q_,
  ServerOff: U_,
  ServerOffIcon: U_,
  Settings: j_,
  Settings2: z_,
  Settings2Icon: z_,
  SettingsIcon: j_,
  Shapes: V_,
  ShapesIcon: V_,
  Share: W_,
  Share2: G_,
  Share2Icon: G_,
  ShareIcon: W_,
  Sheet: X_,
  SheetIcon: X_,
  Shell: Y_,
  ShellIcon: Y_,
  Shield: r7,
  ShieldAlert: K_,
  ShieldAlertIcon: K_,
  ShieldBan: Z_,
  ShieldBanIcon: Z_,
  ShieldCheck: Q_,
  ShieldCheckIcon: Q_,
  ShieldClose: Mr,
  ShieldCloseIcon: Mr,
  ShieldEllipsis: J_,
  ShieldEllipsisIcon: J_,
  ShieldHalf: e7,
  ShieldHalfIcon: e7,
  ShieldIcon: r7,
  ShieldMinus: t7,
  ShieldMinusIcon: t7,
  ShieldOff: n7,
  ShieldOffIcon: n7,
  ShieldPlus: a7,
  ShieldPlusIcon: a7,
  ShieldQuestion: o7,
  ShieldQuestionIcon: o7,
  ShieldX: Mr,
  ShieldXIcon: Mr,
  Ship: c7,
  ShipIcon: c7,
  ShipWheel: i7,
  ShipWheelIcon: i7,
  Shirt: s7,
  ShirtIcon: s7,
  ShoppingBag: l7,
  ShoppingBagIcon: l7,
  ShoppingBasket: d7,
  ShoppingBasketIcon: d7,
  ShoppingCart: u7,
  ShoppingCartIcon: u7,
  Shovel: h7,
  ShovelIcon: h7,
  ShowerHead: p7,
  ShowerHeadIcon: p7,
  Shrink: y7,
  ShrinkIcon: y7,
  Shrub: k7,
  ShrubIcon: k7,
  Shuffle: f7,
  ShuffleIcon: f7,
  Sidebar: ir,
  SidebarClose: ar,
  SidebarCloseIcon: ar,
  SidebarIcon: ir,
  SidebarOpen: rr,
  SidebarOpenIcon: rr,
  Sigma: m7,
  SigmaIcon: m7,
  SigmaSquare: h1,
  SigmaSquareIcon: h1,
  Signal: L7,
  SignalHigh: g7,
  SignalHighIcon: g7,
  SignalIcon: L7,
  SignalLow: M7,
  SignalLowIcon: M7,
  SignalMedium: _7,
  SignalMediumIcon: _7,
  SignalZero: b7,
  SignalZeroIcon: b7,
  Signature: x7,
  SignatureIcon: x7,
  Signpost: v7,
  SignpostBig: E7,
  SignpostBigIcon: E7,
  SignpostIcon: v7,
  Siren: A7,
  SirenIcon: A7,
  SkipBack: I7,
  SkipBackIcon: I7,
  SkipForward: T7,
  SkipForwardIcon: T7,
  Skull: N7,
  SkullIcon: N7,
  Slack: C7,
  SlackIcon: C7,
  Slash: w7,
  SlashIcon: w7,
  SlashSquare: p1,
  SlashSquareIcon: p1,
  Slice: S7,
  SliceIcon: S7,
  Sliders: _r,
  SlidersHorizontal: R7,
  SlidersHorizontalIcon: R7,
  SlidersIcon: _r,
  SlidersVertical: _r,
  SlidersVerticalIcon: _r,
  Smartphone: P7,
  SmartphoneCharging: D7,
  SmartphoneChargingIcon: D7,
  SmartphoneIcon: P7,
  SmartphoneNfc: O7,
  SmartphoneNfcIcon: O7,
  Smile: B7,
  SmileIcon: B7,
  SmilePlus: H7,
  SmilePlusIcon: H7,
  Snail: F7,
  SnailIcon: F7,
  Snowflake: $7,
  SnowflakeIcon: $7,
  Sofa: U7,
  SofaIcon: U7,
  SortAsc: ha,
  SortAscIcon: ha,
  SortDesc: la,
  SortDescIcon: la,
  Soup: q7,
  SoupIcon: q7,
  Space: z7,
  SpaceIcon: z7,
  Spade: j7,
  SpadeIcon: j7,
  Sparkle: V7,
  SparkleIcon: V7,
  Sparkles: br,
  SparklesIcon: br,
  Speaker: G7,
  SpeakerIcon: G7,
  Speech: W7,
  SpeechIcon: W7,
  SpellCheck: Y7,
  SpellCheck2: X7,
  SpellCheck2Icon: X7,
  SpellCheckIcon: Y7,
  Spline: K7,
  SplineIcon: K7,
  Split: Z7,
  SplitIcon: Z7,
  SplitSquareHorizontal: y1,
  SplitSquareHorizontalIcon: y1,
  SplitSquareVertical: k1,
  SplitSquareVerticalIcon: k1,
  SprayCan: Q7,
  SprayCanIcon: Q7,
  Sprout: J7,
  SproutIcon: J7,
  Square: rb,
  SquareActivity: Lr,
  SquareActivityIcon: Lr,
  SquareArrowDown: vr,
  SquareArrowDownIcon: vr,
  SquareArrowDownLeft: xr,
  SquareArrowDownLeftIcon: xr,
  SquareArrowDownRight: Er,
  SquareArrowDownRightIcon: Er,
  SquareArrowLeft: Ar,
  SquareArrowLeftIcon: Ar,
  SquareArrowOutDownLeft: Ir,
  SquareArrowOutDownLeftIcon: Ir,
  SquareArrowOutDownRight: Tr,
  SquareArrowOutDownRightIcon: Tr,
  SquareArrowOutUpLeft: Nr,
  SquareArrowOutUpLeftIcon: Nr,
  SquareArrowOutUpRight: Cr,
  SquareArrowOutUpRightIcon: Cr,
  SquareArrowRight: wr,
  SquareArrowRightIcon: wr,
  SquareArrowUp: Dr,
  SquareArrowUpIcon: Dr,
  SquareArrowUpLeft: Sr,
  SquareArrowUpLeftIcon: Sr,
  SquareArrowUpRight: Rr,
  SquareArrowUpRightIcon: Rr,
  SquareAsterisk: Or,
  SquareAsteriskIcon: Or,
  SquareBottomDashedScissors: Pr,
  SquareBottomDashedScissorsIcon: Pr,
  SquareChartGantt: hn,
  SquareChartGanttIcon: hn,
  SquareCheck: Br,
  SquareCheckBig: Hr,
  SquareCheckBigIcon: Hr,
  SquareCheckIcon: Br,
  SquareChevronDown: Fr,
  SquareChevronDownIcon: Fr,
  SquareChevronLeft: $r,
  SquareChevronLeftIcon: $r,
  SquareChevronRight: Ur,
  SquareChevronRightIcon: Ur,
  SquareChevronUp: qr,
  SquareChevronUpIcon: qr,
  SquareCode: zr,
  SquareCodeIcon: zr,
  SquareDashed: Gr,
  SquareDashedBottom: tb,
  SquareDashedBottomCode: eb,
  SquareDashedBottomCodeIcon: eb,
  SquareDashedBottomIcon: tb,
  SquareDashedIcon: Gr,
  SquareDashedKanban: jr,
  SquareDashedKanbanIcon: jr,
  SquareDashedMousePointer: Vr,
  SquareDashedMousePointerIcon: Vr,
  SquareDivide: Wr,
  SquareDivideIcon: Wr,
  SquareDot: Xr,
  SquareDotIcon: Xr,
  SquareEqual: Yr,
  SquareEqualIcon: Yr,
  SquareFunction: Kr,
  SquareFunctionIcon: Kr,
  SquareGanttChart: hn,
  SquareGanttChartIcon: hn,
  SquareIcon: rb,
  SquareKanban: Zr,
  SquareKanbanIcon: Zr,
  SquareLibrary: Qr,
  SquareLibraryIcon: Qr,
  SquareM: Jr,
  SquareMIcon: Jr,
  SquareMenu: e1,
  SquareMenuIcon: e1,
  SquareMinus: t1,
  SquareMinusIcon: t1,
  SquareMousePointer: n1,
  SquareMousePointerIcon: n1,
  SquareParking: o1,
  SquareParkingIcon: o1,
  SquareParkingOff: a1,
  SquareParkingOffIcon: a1,
  SquarePen: Pt,
  SquarePenIcon: Pt,
  SquarePercent: r1,
  SquarePercentIcon: r1,
  SquarePi: i1,
  SquarePiIcon: i1,
  SquarePilcrow: c1,
  SquarePilcrowIcon: c1,
  SquarePlay: s1,
  SquarePlayIcon: s1,
  SquarePlus: l1,
  SquarePlusIcon: l1,
  SquarePower: d1,
  SquarePowerIcon: d1,
  SquareRadical: nb,
  SquareRadicalIcon: nb,
  SquareScissors: u1,
  SquareScissorsIcon: u1,
  SquareSigma: h1,
  SquareSigmaIcon: h1,
  SquareSlash: p1,
  SquareSlashIcon: p1,
  SquareSplitHorizontal: y1,
  SquareSplitHorizontalIcon: y1,
  SquareSplitVertical: k1,
  SquareSplitVerticalIcon: k1,
  SquareSquare: ab,
  SquareSquareIcon: ab,
  SquareStack: ob,
  SquareStackIcon: ob,
  SquareTerminal: f1,
  SquareTerminalIcon: f1,
  SquareUser: g1,
  SquareUserIcon: g1,
  SquareUserRound: m1,
  SquareUserRoundIcon: m1,
  SquareX: M1,
  SquareXIcon: M1,
  Squircle: ib,
  SquircleIcon: ib,
  Squirrel: cb,
  SquirrelIcon: cb,
  Stamp: sb,
  StampIcon: sb,
  Star: ub,
  StarHalf: lb,
  StarHalfIcon: lb,
  StarIcon: ub,
  StarOff: db,
  StarOffIcon: db,
  Stars: br,
  StarsIcon: br,
  StepBack: hb,
  StepBackIcon: hb,
  StepForward: pb,
  StepForwardIcon: pb,
  Stethoscope: yb,
  StethoscopeIcon: yb,
  Sticker: kb,
  StickerIcon: kb,
  StickyNote: fb,
  StickyNoteIcon: fb,
  StopCircle: co,
  StopCircleIcon: co,
  Store: mb,
  StoreIcon: mb,
  StretchHorizontal: gb,
  StretchHorizontalIcon: gb,
  StretchVertical: Mb,
  StretchVerticalIcon: Mb,
  Strikethrough: _b,
  StrikethroughIcon: _b,
  Subscript: bb,
  SubscriptIcon: bb,
  Subtitles: _a,
  SubtitlesIcon: _a,
  Sun: Ab,
  SunDim: Lb,
  SunDimIcon: Lb,
  SunIcon: Ab,
  SunMedium: xb,
  SunMediumIcon: xb,
  SunMoon: Eb,
  SunMoonIcon: Eb,
  SunSnow: vb,
  SunSnowIcon: vb,
  Sunrise: Ib,
  SunriseIcon: Ib,
  Sunset: Tb,
  SunsetIcon: Tb,
  Superscript: Nb,
  SuperscriptIcon: Nb,
  SwatchBook: Cb,
  SwatchBookIcon: Cb,
  SwissFranc: wb,
  SwissFrancIcon: wb,
  SwitchCamera: Sb,
  SwitchCameraIcon: Sb,
  Sword: Rb,
  SwordIcon: Rb,
  Swords: Db,
  SwordsIcon: Db,
  Syringe: Ob,
  SyringeIcon: Ob,
  Table: zb,
  Table2: Pb,
  Table2Icon: Pb,
  TableCellsMerge: Hb,
  TableCellsMergeIcon: Hb,
  TableCellsSplit: Bb,
  TableCellsSplitIcon: Bb,
  TableColumnsSplit: Fb,
  TableColumnsSplitIcon: Fb,
  TableIcon: zb,
  TableOfContents: $b,
  TableOfContentsIcon: $b,
  TableProperties: Ub,
  TablePropertiesIcon: Ub,
  TableRowsSplit: qb,
  TableRowsSplitIcon: qb,
  Tablet: Vb,
  TabletIcon: Vb,
  TabletSmartphone: jb,
  TabletSmartphoneIcon: jb,
  Tablets: Gb,
  TabletsIcon: Gb,
  Tag: Wb,
  TagIcon: Wb,
  Tags: Xb,
  TagsIcon: Xb,
  Tally1: Yb,
  Tally1Icon: Yb,
  Tally2: Kb,
  Tally2Icon: Kb,
  Tally3: Zb,
  Tally3Icon: Zb,
  Tally4: Qb,
  Tally4Icon: Qb,
  Tally5: Jb,
  Tally5Icon: Jb,
  Tangent: eL,
  TangentIcon: eL,
  Target: tL,
  TargetIcon: tL,
  Telescope: nL,
  TelescopeIcon: nL,
  Tent: oL,
  TentIcon: oL,
  TentTree: aL,
  TentTreeIcon: aL,
  Terminal: rL,
  TerminalIcon: rL,
  TerminalSquare: f1,
  TerminalSquareIcon: f1,
  TestTube: iL,
  TestTube2: _1,
  TestTube2Icon: _1,
  TestTubeDiagonal: _1,
  TestTubeDiagonalIcon: _1,
  TestTubeIcon: iL,
  TestTubes: cL,
  TestTubesIcon: cL,
  Text: hL,
  TextCursor: lL,
  TextCursorIcon: lL,
  TextCursorInput: sL,
  TextCursorInputIcon: sL,
  TextIcon: hL,
  TextQuote: dL,
  TextQuoteIcon: dL,
  TextSearch: uL,
  TextSearchIcon: uL,
  TextSelect: b1,
  TextSelectIcon: b1,
  TextSelection: b1,
  TextSelectionIcon: b1,
  Theater: pL,
  TheaterIcon: pL,
  Thermometer: fL,
  ThermometerIcon: fL,
  ThermometerSnowflake: yL,
  ThermometerSnowflakeIcon: yL,
  ThermometerSun: kL,
  ThermometerSunIcon: kL,
  ThumbsDown: mL,
  ThumbsDownIcon: mL,
  ThumbsUp: gL,
  ThumbsUpIcon: gL,
  Ticket: vL,
  TicketCheck: ML,
  TicketCheckIcon: ML,
  TicketIcon: vL,
  TicketMinus: _L,
  TicketMinusIcon: _L,
  TicketPercent: bL,
  TicketPercentIcon: bL,
  TicketPlus: LL,
  TicketPlusIcon: LL,
  TicketSlash: xL,
  TicketSlashIcon: xL,
  TicketX: EL,
  TicketXIcon: EL,
  Tickets: IL,
  TicketsIcon: IL,
  TicketsPlane: AL,
  TicketsPlaneIcon: AL,
  Timer: CL,
  TimerIcon: CL,
  TimerOff: TL,
  TimerOffIcon: TL,
  TimerReset: NL,
  TimerResetIcon: NL,
  ToggleLeft: wL,
  ToggleLeftIcon: wL,
  ToggleRight: SL,
  ToggleRightIcon: SL,
  Toilet: RL,
  ToiletIcon: RL,
  Tornado: DL,
  TornadoIcon: DL,
  Torus: OL,
  TorusIcon: OL,
  Touchpad: HL,
  TouchpadIcon: HL,
  TouchpadOff: PL,
  TouchpadOffIcon: PL,
  TowerControl: BL,
  TowerControlIcon: BL,
  ToyBrick: FL,
  ToyBrickIcon: FL,
  Tractor: $L,
  TractorIcon: $L,
  TrafficCone: UL,
  TrafficConeIcon: UL,
  Train: L1,
  TrainFront: zL,
  TrainFrontIcon: zL,
  TrainFrontTunnel: qL,
  TrainFrontTunnelIcon: qL,
  TrainIcon: L1,
  TrainTrack: jL,
  TrainTrackIcon: jL,
  TramFront: L1,
  TramFrontIcon: L1,
  Transgender: VL,
  TransgenderIcon: VL,
  Trash: WL,
  Trash2: GL,
  Trash2Icon: GL,
  TrashIcon: WL,
  TreeDeciduous: XL,
  TreeDeciduousIcon: XL,
  TreePalm: x1,
  TreePalmIcon: x1,
  TreePine: YL,
  TreePineIcon: YL,
  Trees: KL,
  TreesIcon: KL,
  Trello: ZL,
  TrelloIcon: ZL,
  TrendingDown: QL,
  TrendingDownIcon: QL,
  TrendingUp: ex,
  TrendingUpDown: JL,
  TrendingUpDownIcon: JL,
  TrendingUpIcon: ex,
  Triangle: ax,
  TriangleAlert: E1,
  TriangleAlertIcon: E1,
  TriangleDashed: tx,
  TriangleDashedIcon: tx,
  TriangleIcon: ax,
  TriangleRight: nx,
  TriangleRightIcon: nx,
  Trophy: ox,
  TrophyIcon: ox,
  Truck: rx,
  TruckIcon: rx,
  Turtle: ix,
  TurtleIcon: ix,
  Tv: sx,
  Tv2: v1,
  Tv2Icon: v1,
  TvIcon: sx,
  TvMinimal: v1,
  TvMinimalIcon: v1,
  TvMinimalPlay: cx,
  TvMinimalPlayIcon: cx,
  Twitch: lx,
  TwitchIcon: lx,
  Twitter: dx,
  TwitterIcon: dx,
  Type: hx,
  TypeIcon: hx,
  TypeOutline: ux,
  TypeOutlineIcon: ux,
  Umbrella: yx,
  UmbrellaIcon: yx,
  UmbrellaOff: px,
  UmbrellaOffIcon: px,
  Underline: kx,
  UnderlineIcon: kx,
  Undo: gx,
  Undo2: fx,
  Undo2Icon: fx,
  UndoDot: mx,
  UndoDotIcon: mx,
  UndoIcon: gx,
  UnfoldHorizontal: Mx,
  UnfoldHorizontalIcon: Mx,
  UnfoldVertical: _x,
  UnfoldVerticalIcon: _x,
  Ungroup: bx,
  UngroupIcon: bx,
  University: A1,
  UniversityIcon: A1,
  Unlink: xx,
  Unlink2: Lx,
  Unlink2Icon: Lx,
  UnlinkIcon: xx,
  Unlock: Yo,
  UnlockIcon: Yo,
  UnlockKeyhole: Xo,
  UnlockKeyholeIcon: Xo,
  Unplug: Ex,
  UnplugIcon: Ex,
  Upload: vx,
  UploadCloud: ko,
  UploadCloudIcon: ko,
  UploadIcon: vx,
  Usb: Ax,
  UsbIcon: Ax,
  User: Px,
  User2: S1,
  User2Icon: S1,
  UserCheck: Ix,
  UserCheck2: I1,
  UserCheck2Icon: I1,
  UserCheckIcon: Ix,
  UserCircle: lo,
  UserCircle2: so,
  UserCircle2Icon: so,
  UserCircleIcon: lo,
  UserCog: Tx,
  UserCog2: T1,
  UserCog2Icon: T1,
  UserCogIcon: Tx,
  UserIcon: Px,
  UserMinus: Nx,
  UserMinus2: N1,
  UserMinus2Icon: N1,
  UserMinusIcon: Nx,
  UserPen: Cx,
  UserPenIcon: Cx,
  UserPlus: wx,
  UserPlus2: C1,
  UserPlus2Icon: C1,
  UserPlusIcon: wx,
  UserRound: S1,
  UserRoundCheck: I1,
  UserRoundCheckIcon: I1,
  UserRoundCog: T1,
  UserRoundCogIcon: T1,
  UserRoundIcon: S1,
  UserRoundMinus: N1,
  UserRoundMinusIcon: N1,
  UserRoundPen: Sx,
  UserRoundPenIcon: Sx,
  UserRoundPlus: C1,
  UserRoundPlusIcon: C1,
  UserRoundSearch: Rx,
  UserRoundSearchIcon: Rx,
  UserRoundX: w1,
  UserRoundXIcon: w1,
  UserSearch: Dx,
  UserSearchIcon: Dx,
  UserSquare: g1,
  UserSquare2: m1,
  UserSquare2Icon: m1,
  UserSquareIcon: g1,
  UserX: Ox,
  UserX2: w1,
  UserX2Icon: w1,
  UserXIcon: Ox,
  Users: Hx,
  Users2: R1,
  Users2Icon: R1,
  UsersIcon: Hx,
  UsersRound: R1,
  UsersRoundIcon: R1,
  Utensils: O1,
  UtensilsCrossed: D1,
  UtensilsCrossedIcon: D1,
  UtensilsIcon: O1,
  UtilityPole: Bx,
  UtilityPoleIcon: Bx,
  Variable: Fx,
  VariableIcon: Fx,
  Vault: $x,
  VaultIcon: $x,
  Vegan: Ux,
  VeganIcon: Ux,
  VenetianMask: qx,
  VenetianMaskIcon: qx,
  Venus: jx,
  VenusAndMars: zx,
  VenusAndMarsIcon: zx,
  VenusIcon: jx,
  Verified: ka,
  VerifiedIcon: ka,
  Vibrate: Gx,
  VibrateIcon: Gx,
  VibrateOff: Vx,
  VibrateOffIcon: Vx,
  Video: Xx,
  VideoIcon: Xx,
  VideoOff: Wx,
  VideoOffIcon: Wx,
  Videotape: Yx,
  VideotapeIcon: Yx,
  View: Kx,
  ViewIcon: Kx,
  Voicemail: Zx,
  VoicemailIcon: Zx,
  Volleyball: Qx,
  VolleyballIcon: Qx,
  Volume: a9,
  Volume1: Jx,
  Volume1Icon: Jx,
  Volume2: e9,
  Volume2Icon: e9,
  VolumeIcon: a9,
  VolumeOff: t9,
  VolumeOffIcon: t9,
  VolumeX: n9,
  VolumeXIcon: n9,
  Vote: o9,
  VoteIcon: o9,
  Wallet: i9,
  Wallet2: P1,
  Wallet2Icon: P1,
  WalletCards: r9,
  WalletCardsIcon: r9,
  WalletIcon: i9,
  WalletMinimal: P1,
  WalletMinimalIcon: P1,
  Wallpaper: c9,
  WallpaperIcon: c9,
  Wand: s9,
  Wand2: H1,
  Wand2Icon: H1,
  WandIcon: s9,
  WandSparkles: H1,
  WandSparklesIcon: H1,
  Warehouse: l9,
  WarehouseIcon: l9,
  WashingMachine: d9,
  WashingMachineIcon: d9,
  Watch: u9,
  WatchIcon: u9,
  Waves: p9,
  WavesIcon: p9,
  WavesLadder: h9,
  WavesLadderIcon: h9,
  Waypoints: y9,
  WaypointsIcon: y9,
  Webcam: k9,
  WebcamIcon: k9,
  Webhook: m9,
  WebhookIcon: m9,
  WebhookOff: f9,
  WebhookOffIcon: f9,
  Weight: g9,
  WeightIcon: g9,
  Wheat: _9,
  WheatIcon: _9,
  WheatOff: M9,
  WheatOffIcon: M9,
  WholeWord: b9,
  WholeWordIcon: b9,
  Wifi: A9,
  WifiHigh: L9,
  WifiHighIcon: L9,
  WifiIcon: A9,
  WifiLow: x9,
  WifiLowIcon: x9,
  WifiOff: E9,
  WifiOffIcon: E9,
  WifiZero: v9,
  WifiZeroIcon: v9,
  Wind: T9,
  WindArrowDown: I9,
  WindArrowDownIcon: I9,
  WindIcon: T9,
  Wine: C9,
  WineIcon: C9,
  WineOff: N9,
  WineOffIcon: N9,
  Workflow: w9,
  WorkflowIcon: w9,
  Worm: S9,
  WormIcon: S9,
  WrapText: R9,
  WrapTextIcon: R9,
  Wrench: D9,
  WrenchIcon: D9,
  X: O9,
  XCircle: uo,
  XCircleIcon: uo,
  XIcon: O9,
  XOctagon: er,
  XOctagonIcon: er,
  XSquare: M1,
  XSquareIcon: M1,
  Youtube: P9,
  YoutubeIcon: P9,
  Zap: B9,
  ZapIcon: B9,
  ZapOff: H9,
  ZapOffIcon: H9,
  ZoomIn: F9,
  ZoomInIcon: F9,
  ZoomOut: $9,
  ZoomOutIcon: $9,
  createLucideIcon: r,
  icons: Iie
}, Symbol.toStringTag, { value: "Module" }));
function Nie({ name: e, ...t }) {
  const n = Tie[e];
  return n ? /* @__PURE__ */ p(n, { ...t }) : (console.warn(`Icon "${e}" not found`), null);
}
const Cie = {
  [ye.XSMALL]: 12,
  [ye.SMALL]: 16,
  [ye.MEDIUM]: 20,
  [ye.LARGE]: 24,
  [ye.XLARGE]: 28
}, wie = ({
  icon: e,
  size: t = ye.MEDIUM,
  color: n = "currentColor",
  className: a = ""
}) => {
  const o = `
    inline-flex items-center justify-center
    ${a}
  `.trim();
  return /* @__PURE__ */ p(
    Nie,
    {
      name: e,
      className: o,
      size: Cie[t],
      color: n
    }
  );
}, oe = he.memo(wie), Sie = /^(label|paragraph|heading|mobile-heading|display)-/, eN = ["sm", "md", "lg", "xl"], tN = (e) => Sie.test(e), Rie = pc({
  extend: {
    theme: {
      spacing: eN
    },
    classGroups: {
      "font-size": [{ text: [tN] }]
    }
  }
}), Die = pc({
  extend: {
    theme: {
      spacing: eN
    },
    classGroups: {
      "font-size": [{ text: [tN] }],
      "font-weight": [{ font: ["regular"] }],
      "text-decoration-skip-ink": [{ "text-decoration-skip-ink": ["none"] }],
      "text-underline-position": [{ "text-underline-position": ["from-font"] }]
    }
  }
}), Oie = (e, t, n) => {
  const a = n(t), o = new Set(a.split(" "));
  return [...e.split(/\s+/).filter((c) => c && !o.has(c)).filter((c) => n(`${c} ${a}`).split(" ").includes(c)), a].join(" ");
}, Pie = ({ base: e, override: t, mode: n = "override", typography: a = !1 }) => {
  const o = a ? Die : Rie;
  if (n === "all")
    return o(wn(e, t));
  const i = wn(e), c = wn(t);
  return c.trim() ? Oie(i, c, o) : i;
}, Hie = (e) => {
  const t = {
    // Label variants
    [x.LABEL_LARGE_REGULAR]: "text-label-lg font-regular",
    [x.LABEL_LARGE_MEDIUM]: "text-label-lg font-medium",
    [x.LABEL_LARGE_BOLD]: "text-label-lg font-bold",
    [x.LABEL_MEDIUM_REGULAR]: "text-label-md font-regular",
    [x.LABEL_MEDIUM_MEDIUM]: "text-label-md font-medium",
    [x.LABEL_MEDIUM_BOLD]: "text-label-md font-bold",
    [x.LABEL_XSMALL_REGULAR]: "text-label-xs font-regular",
    [x.LABEL_XSMALL_BOLD]: "text-label-xs font-bold",
    [x.LABEL_XSMALL_MEDIUM]: "text-label-xs font-medium",
    [x.LABEL_SMALL_REGULAR]: "text-label-sm font-regular",
    [x.LABEL_SMALL_MEDIUM]: "text-label-sm font-medium",
    [x.LABEL_SMALL_BOLD]: "text-label-sm font-bold",
    // Paragraph variants
    [x.PARAGRAPH_LARGE_REGULAR]: "text-paragraph-lg font-regular",
    [x.PARAGRAPH_LARGE_BOLD]: "text-paragraph-lg font-bold",
    [x.PARAGRAPH_LARGE_MEDIUM]: "text-paragraph-lg font-medium",
    [x.PARAGRAPH_MEDIUM_REGULAR]: "text-paragraph-md font-regular",
    [x.PARAGRAPH_MEDIUM_BOLD]: "text-paragraph-md font-bold",
    [x.PARAGRAPH_MEDIUM_MEDIUM]: "text-paragraph-md font-medium",
    [x.PARAGRAPH_SMALL_REGULAR]: "text-paragraph-sm font-regular",
    [x.PARAGRAPH_SMALL_BOLD]: "text-paragraph-sm font-bold",
    [x.PARAGRAPH_SMALL_MEDIUM]: "text-paragraph-sm font-medium",
    [x.PARAGRAPH_XSMALL_REGULAR]: "text-paragraph-xs font-regular",
    [x.PARAGRAPH_XSMALL_MEDIUM]: "text-paragraph-xs font-medium",
    [x.PARAGRAPH_XSMALL_BOLD]: "text-paragraph-xs font-bold",
    // Heading variants
    [x.HEADING_LARGE_BLACK]: "text-heading-lg font-black",
    [x.HEADING_LARGE_BOLD]: "text-heading-lg font-bold",
    [x.HEADING_LARGE_MEDIUM]: "text-heading-lg font-medium",
    [x.HEADING_LARGE_REGULAR]: "text-heading-lg font-regular",
    [x.HEADING_SMALL_BLACK]: "text-heading-sm font-black",
    [x.HEADING_SMALL_BOLD]: "text-heading-sm font-bold",
    [x.HEADING_SMALL_MEDIUM]: "text-heading-sm font-medium",
    [x.HEADING_SMALL_REGULAR]: "text-heading-sm font-regular",
    [x.HEADING_6_BLACK]: "text-heading-6 font-black",
    [x.HEADING_6_BOLD]: "text-heading-6 font-bold",
    [x.HEADING_6_MEDIUM]: "text-heading-6 font-medium",
    [x.HEADING_6_REGULAR]: "text-heading-6 font-regular",
    [x.HEADING_5_BLACK]: "text-heading-5 font-black",
    [x.HEADING_5_BOLD]: "text-heading-5 font-bold",
    [x.HEADING_5_MEDIUM]: "text-heading-5 font-medium",
    [x.HEADING_5_REGULAR]: "text-heading-5 font-regular",
    [x.HEADING_4_BLACK]: "text-heading-4 font-black",
    [x.HEADING_4_BOLD]: "text-heading-4 font-bold",
    [x.HEADING_4_MEDIUM]: "text-heading-4 font-medium",
    [x.HEADING_4_REGULAR]: "text-heading-4 font-regular",
    [x.HEADING_3_BLACK]: "text-heading-3 font-black",
    [x.HEADING_3_BOLD]: "text-heading-3 font-bold",
    [x.HEADING_3_MEDIUM]: "text-heading-3 font-medium",
    [x.HEADING_3_REGULAR]: "text-heading-3 font-regular",
    [x.HEADING_2_BLACK]: "text-heading-2 font-black",
    [x.HEADING_2_BOLD]: "text-heading-2 font-bold",
    [x.HEADING_2_MEDIUM]: "text-heading-2 font-medium",
    [x.HEADING_2_REGULAR]: "text-heading-2 font-regular",
    [x.HEADING_1_BLACK]: "text-heading-1 font-black",
    [x.HEADING_1_BOLD]: "text-heading-1 font-bold",
    [x.HEADING_1_MEDIUM]: "text-heading-1 font-medium",
    [x.HEADING_1_REGULAR]: "text-heading-1 font-regular",
    // Mobile Heading variants
    [x.MOBILE_HEADING_6_BLACK]: "text-mobile-heading-6 font-black",
    [x.MOBILE_HEADING_6_BOLD]: "text-mobile-heading-6 font-bold",
    [x.MOBILE_HEADING_6_MEDIUM]: "text-mobile-heading-6 font-medium",
    [x.MOBILE_HEADING_6_REGULAR]: "text-mobile-heading-6 font-regular",
    [x.MOBILE_HEADING_5_BLACK]: "text-mobile-heading-5 font-black",
    [x.MOBILE_HEADING_5_BOLD]: "text-mobile-heading-5 font-bold",
    [x.MOBILE_HEADING_5_MEDIUM]: "text-mobile-heading-5 font-medium",
    [x.MOBILE_HEADING_5_REGULAR]: "text-mobile-heading-5 font-regular",
    [x.MOBILE_HEADING_4_BLACK]: "text-mobile-heading-4 font-black",
    [x.MOBILE_HEADING_4_BOLD]: "text-mobile-heading-4 font-bold",
    [x.MOBILE_HEADING_4_MEDIUM]: "text-mobile-heading-4 font-medium",
    [x.MOBILE_HEADING_4_REGULAR]: "text-mobile-heading-4 font-regular",
    [x.MOBILE_HEADING_3_BLACK]: "text-mobile-heading-3 font-black",
    [x.MOBILE_HEADING_3_BOLD]: "text-mobile-heading-3 font-bold",
    [x.MOBILE_HEADING_3_MEDIUM]: "text-mobile-heading-3 font-medium",
    [x.MOBILE_HEADING_3_REGULAR]: "text-mobile-heading-3 font-regular",
    [x.MOBILE_HEADING_2_BLACK]: "text-mobile-heading-2 font-black",
    [x.MOBILE_HEADING_2_BOLD]: "text-mobile-heading-2 font-bold",
    [x.MOBILE_HEADING_2_MEDIUM]: "text-mobile-heading-2 font-medium",
    [x.MOBILE_HEADING_2_REGULAR]: "text-mobile-heading-2 font-regular",
    [x.MOBILE_HEADING_1_BLACK]: "text-mobile-heading-1 font-black",
    [x.MOBILE_HEADING_1_BOLD]: "text-mobile-heading-1 font-bold",
    [x.MOBILE_HEADING_1_MEDIUM]: "text-mobile-heading-1 font-medium",
    [x.MOBILE_HEADING_1_REGULAR]: "text-mobile-heading-1 font-regular",
    // Desktop Heading variants
    [x.DISPLAY_LARGE_BLACK]: "text-display-lg font-black",
    [x.DISPLAY_LARGE_BOLD]: "text-display-lg font-bold",
    [x.DISPLAY_LARGE_MEDIUM]: "text-display-lg font-medium",
    [x.DISPLAY_LARGE_REGULAR]: "text-display-lg font-regular",
    [x.DISPLAY_SMALL_BLACK]: "text-display-sm font-black",
    [x.DISPLAY_SMALL_BOLD]: "text-display-sm font-bold",
    [x.DISPLAY_SMALL_MEDIUM]: "text-display-sm font-medium",
    [x.DISPLAY_SMALL_REGULAR]: "text-display-sm font-regular"
  };
  return t[e] || t[x.PARAGRAPH_MEDIUM_REGULAR];
};
function Bie({ variant: e = x.PARAGRAPH_MEDIUM_REGULAR, as: t, children: n, centered: a, className: o = "", color: i, ...c }, s) {
  const l = "font-sans text-decoration-skip-ink-none text-underline-position-from-font", u = Hie(e);
  let h = "";
  i === av.ERROR ? h = "text-red-9" : i === av.SUCCESS && (h = "text-green-9 dark:text-green-10");
  const f = Pie({
    base: [l, u, a ? "text-center" : "text-left", h],
    override: o,
    typography: !0
  }), y = t || "p";
  return he.createElement(y, { ref: s, className: f, ...c }, n);
}
const q = he.forwardRef(Bie), Fie = ({
  isOpen: e,
  title: t,
  disabled: n = !1,
  onClick: a,
  className: o = ""
}) => /* @__PURE__ */ C(
  "button",
  {
    type: "button",
    className: P(
      "w-full flex items-center justify-between transition-all duration-200 px-0  py-lg  border-b border-solid border-gray-7",
      n ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
      o
    ),
    onClick: a,
    disabled: n,
    "aria-expanded": e,
    "aria-disabled": n,
    children: [
      /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_MEDIUM, className: P(e ? "text-gray-12" : "text-gray-10"), children: t }),
      /* @__PURE__ */ p(oe, { icon: e ? R.CHEVRON_UP : R.CHEVRON_DOWN })
    ]
  }
), $ie = ({
  children: e
}) => /* @__PURE__ */ p("div", { className: "overflow-auto transition-all duration-200 max-h-screen", children: e }), Uie = ({
  item: e,
  isOpen: t,
  onToggle: n
}) => {
  const a = () => {
    e.disabled || n(e.id);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      className: P(
        "flex flex-col gap-lg transition-all duration-200",
        e.className
      ),
      children: [
        /* @__PURE__ */ p(
          Fie,
          {
            isOpen: t,
            title: e.title,
            disabled: e.disabled,
            onClick: a
          }
        ),
        t && /* @__PURE__ */ p($ie, { children: e.content })
      ]
    }
  );
}, lge = ({
  items: e,
  allowMultiple: t = !1,
  defaultOpenItems: n = [],
  onToggle: a,
  className: o = ""
}) => {
  const [i, c] = ae(n), s = Q(
    (l) => {
      const u = i.includes(l);
      let h;
      t ? u ? h = i.filter((k) => k !== l) : h = [...i, l] : h = u ? [] : [l], c(h), a == null || a(l, !u);
    },
    [i, t, a]
  );
  return /* @__PURE__ */ p("div", { className: P("w-full", o), children: e.map((l) => /* @__PURE__ */ p(
    Uie,
    {
      item: l,
      isOpen: i.includes(l.id),
      onToggle: s
    },
    l.id
  )) });
};
var U9 = /* @__PURE__ */ ((e) => (e.CTA = "CTA", e.Dismiss = "Dismiss", e.ContainerCTA = "ContainerCTA", e))(U9 || {});
const qie = {
  [Ue.XSMALL]: {
    size: "w-[13px] h-[13px]",
    extraStyle: "border-[2px]"
  },
  [Ue.SMALL]: { size: "w-4 h-4", extraStyle: "border-[3px]" },
  [Ue.MEDIUM]: { size: "w-5 h-5", extraStyle: "border-[3px]" },
  [Ue.LARGE]: { size: "w-6 h-6", extraStyle: "border-[4px]" },
  [Ue.XLARGE]: { size: "w-11  h-11", extraStyle: "border-[7px]" }
}, Rn = ({
  variant: e = W1.DEFAULT,
  size: t = Ue.MEDIUM,
  className: n = ""
}) => {
  const a = qie[t], o = `${a.size} ${a.extraStyle}`;
  return e === W1.PRIMARY ? /* @__PURE__ */ p(
    oe,
    {
      icon: R.LOADER,
      className: P("animate-spin", n, a == null ? void 0 : a.size)
    }
  ) : /* @__PURE__ */ p(
    "div",
    {
      className: `
        inline-block animate-spin rounded-full
        border-primary-200
        border-r-blue-9
        dark:border-blue-1
        dark:border-r-blue-9
        motion-reduce:animate-[spin_1.5s_linear_infinite] border-solid
        ${o}
        ${n}
      `.trim(),
      role: "status",
      children: /* @__PURE__ */ p("span", { className: "sr-only", children: "Loading..." })
    }
  );
}, nN = {
  // 20px is below the WCAG 2.2 AA 24x24 minimum target size: use only in dense,
  // non-primary contexts, or leave enough spacing around it.
  [_e.XSMALL]: {
    button: "px-1 text-xs h-[20px]",
    icon: "w-3 h-3",
    spinner: Ue.XSMALL,
    text: x.LABEL_XSMALL_MEDIUM
  },
  [_e.SMALL_MINUS]: {
    button: "px-1.5 text-xs h-[24px]",
    icon: "w-3.5 h-3.5",
    spinner: Ue.XSMALL,
    text: x.LABEL_XSMALL_MEDIUM
  },
  [_e.SMALL]: {
    button: "px-2 text-sm h-[28px]",
    icon: "w-4 h-4",
    spinner: Ue.SMALL,
    text: x.LABEL_SMALL_MEDIUM
  },
  [_e.SMALL_PLUS]: {
    button: "px-2.5 text-sm h-[32px]",
    icon: "w-[18px] h-[18px]",
    spinner: Ue.SMALL,
    text: x.LABEL_SMALL_MEDIUM
  },
  [_e.MEDIUM]: {
    button: "px-[13px] text-base h-[36px]",
    icon: "w-5 h-5",
    spinner: Ue.MEDIUM,
    text: x.LABEL_MEDIUM_MEDIUM
  },
  [_e.LARGE]: {
    button: "px-lg text-lg h-[44px]",
    icon: "w-6 h-6",
    spinner: Ue.LARGE,
    text: x.LABEL_LARGE_MEDIUM
  }
}, zie = "bg-transparent border-1 border-solid border-gray-5 dark:border-gray-8 text-red-9 hover:bg-red-9/10 active:bg-red-9/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-7", jie = ({ loading: e, spinnerVariant: t }) => {
  if (e)
    switch (t) {
      case W1.DEFAULT:
        return "opacity-70 cursor-wait";
      case W1.PRIMARY:
        return "cursor-wait";
      default:
        return "";
    }
}, Vie = {
  [we.SQUARE]: "rounded-default",
  [we.PILL]: "rounded-full"
}, Gie = (e, t = ft.DEFAULT) => {
  if (e === J.OUTLINED_DANGER)
    return zie;
  if (t === ft.DEFAULT)
    return {
      [J.CONTAINED]: "bg-blue-10 border-bg-blue-10 text-white hover:bg-blue-10 border-1 border-solid border-transparent hover:border-blue-11 active:bg-blue-5 active:border-blue-8 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-6 disabled:border-none disabled:bg-blue-10",
      [J.SECONDARY]: "bg-gray-5 hover:bg-gray-6 dark:active:bg-gray-9 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10  disabled:border-none disabled:bg-gray-5",
      [J.OUTLINED]: "bg-transparent border-1 border-solid border-gray-5 text-black dark:border-gray-8 dark:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-7",
      [J.TEXT]: "bg-transparent border-transparent text-black dark:text-white hover:bg-gray-1 dark:hover:bg-gray-4 hover:border-transparent dark:active:bg-gray-3 active:border-1 active:border-solid active:border-gray-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-7",
      [J.INVERSE]: "text-white dark:text-gray-1 bg-black dark:bg-white active:bg-gray-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 dark:active:bg-blue-11 disabled:!bg-gray-5 disabled:text-black dark:disabled:text-white",
      [J.TRANSPARENT]: "bg-transparent text-black dark:text-white",
      [J.DARK]: "bg-gray-12 dark:bg-gray-5 text-white hover:bg-gray-11 dark:hover:bg-gray-6 active:bg-gray-10 dark:active:bg-gray-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 disabled:opacity-50"
    }[e];
  if (t === ft.ERROR)
    return {
      [J.CONTAINED]: "bg-red-9 text-white hover:bg-red-8 active:bg-red-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-red-500 hover:bg-red-500/10 active:bg-red-500/20",
      [J.TEXT]: "text-red-500 hover:bg-red-500/10 active:bg-red-500/20",
      [J.INVERSE]: "text-white dark:text-gray-1 bg-black dark:bg-white active:bg-gray-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 dark:active:bg-blue-11 disabled:!bg-gray-5 disabled:text-black dark:disabled:text-white",
      [J.TRANSPARENT]: "text-black dark:text-white bg-transparent hover:bg-red-500/10 active:bg-red-500/20",
      [J.DARK]: "bg-gray-12 dark:bg-gray-5 text-white hover:bg-gray-11 dark:hover:bg-gray-6 active:bg-gray-10 dark:active:bg-gray-4 disabled:opacity-50"
    }[e];
  if (t === ft.ALERT)
    return {
      [J.CONTAINED]: "bg-yellow-9 border-yellow-9 text-white hover:bg-yellow-8 active:bg-yellow-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-yellow-500 hover:bg-yellow-500/10 active:bg-yellow-500/20",
      [J.TEXT]: "text-black dark:text-white hover:bg-yellow-500/10 active:bg-yellow-500/20",
      [J.INVERSE]: "text-white dark:text-gray-1 bg-black dark:bg-white active:bg-gray-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 dark:active:bg-blue-11 disabled:!bg-gray-5 disabled:text-black dark:disabled:text-white",
      [J.TRANSPARENT]: "text-black dark:text-white bg-transparent hover:bg-yellow-500/10 active:bg-yellow-500/20",
      [J.DARK]: "bg-gray-12 dark:bg-gray-5 text-white hover:bg-gray-11 dark:hover:bg-gray-6 active:bg-gray-10 dark:active:bg-gray-4 disabled:opacity-50"
    }[e];
  if (t === ft.SUCCESS)
    return {
      [J.CONTAINED]: "bg-green-6 border-green-6 text-white hover:bg-green-8 active:bg-green-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-green-500 hover:bg-green-500/10 active:bg-green-500/20",
      [J.TEXT]: "text-green-500 hover:bg-green-500/10 active:bg-green-500/20",
      [J.INVERSE]: "text-white dark:text-gray-1 bg-black dark:bg-white active:bg-gray-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 dark:active:bg-blue-11 disabled:!bg-gray-5 disabled:text-black dark:disabled:text-white",
      [J.TRANSPARENT]: "text-black dark:text-white bg-transparent hover:bg-green-500/10 active:bg-green-500/20",
      [J.DARK]: "bg-gray-12 dark:bg-gray-5 text-white hover:bg-gray-11 dark:hover:bg-gray-6 active:bg-gray-10 dark:active:bg-gray-4 disabled:opacity-50"
    }[e];
}, Wie = ({ size: e, variant: t, iconStart: n, iconEnd: a, children: o, loading: i, spinnerVariant: c, loadingWithText: s, classNames: l }) => {
  const u = nN[e], h = (u == null ? void 0 : u.text) ?? x.LABEL_MEDIUM_MEDIUM, k = `${u.icon} ${l == null ? void 0 : l.icon}`;
  return /* @__PURE__ */ C(at, { children: [
    i ? /* @__PURE__ */ p(
      Rn,
      {
        size: u == null ? void 0 : u.spinner,
        className: P(
          l == null ? void 0 : l.spinner,
          t === J.CONTAINED && "!border-primary-200 !border-r-transparent",
          !s && "absolute"
        ),
        variant: c
      }
    ) : null,
    n ? /* @__PURE__ */ p(oe, { icon: n, className: k }) : null,
    o ? /* @__PURE__ */ p(q, { variant: h, className: wn("whitespace-nowrap", l == null ? void 0 : l.text, i && !s && "invisible"), children: o }) : null,
    a ? /* @__PURE__ */ p(oe, { icon: a, className: k }) : null
  ] });
}, Xie = ({
  shape: e,
  size: t,
  variant: n,
  color: a,
  disabled: o,
  loading: i,
  spinnerVariant: c,
  shouldDisablePointerEvents: s
}) => {
  const l = "relative inline-flex items-center justify-center font-medium transition-all duration-200 gap-2", u = Gie(n, a), h = nN[t], k = Vie[e], f = o ? "opacity-50 cursor-not-allowed" : "cursor-pointer", y = jie({ loading: i, spinnerVariant: c });
  return `
    ${l}
    ${u}
    ${h.button}
    ${k}
    ${f}
    ${y}
    ${s ? "pointer-events-none" : ""}
  `.trim().replace(/\s+/g, " ");
}, Yie = ({
  isNativeButton: e,
  isDisabled: t,
  type: n
}) => e ? { type: n, disabled: t } : { "aria-disabled": t || void 0 }, Kie = {
  icon: "",
  text: "",
  spinner: ""
}, nt = ({
  // eslint-disable-next-line @typescript-eslint/naming-convention -- polymorphic JSX element alias must be PascalCase
  as: e = "button",
  shape: t = we.SQUARE,
  size: n = _e.MEDIUM,
  variant: a = J.CONTAINED,
  color: o = ft.DEFAULT,
  iconStart: i,
  iconEnd: c,
  children: s,
  disabled: l = !1,
  loading: u = !1,
  spinnerVariant: h = W1.DEFAULT,
  className: k = "",
  classNames: f = Kie,
  type: y = "button",
  loadingWithText: m = !0,
  ...g
}) => {
  const _ = e === "button", L = l || u, N = Xie({
    shape: t,
    size: n,
    variant: a,
    color: o,
    disabled: l,
    loading: u,
    spinnerVariant: h,
    shouldDisablePointerEvents: !_ && L
  }), I = Yie({ isNativeButton: _, isDisabled: L, type: y });
  return /* @__PURE__ */ p(e, { ...I, className: P(N, k), ...g, children: /* @__PURE__ */ p(
    Wie,
    {
      size: n,
      variant: a,
      iconStart: i,
      iconEnd: c,
      loading: u,
      spinnerVariant: h,
      loadingWithText: m,
      classNames: f,
      children: s
    }
  ) });
}, Zie = "bg-transparent border-1 border-solid border-gray-5 dark:border-gray-8 text-red-9 hover:bg-red-9/10 active:bg-red-9/20", Qie = (e, t = ft.DEFAULT) => {
  if (e === J.OUTLINED_DANGER)
    return Zie;
  if (t === ft.DEFAULT)
    return {
      [J.CONTAINED]: "bg-blue-10 border-bg-blue-10 text-white hover:bg-blue-10 hover:border-solid hover:border-1 hover:border-blue-11 active:bg-blue-5 active:border-blue-8 disabled:border-none disabled:bg-blue-10",
      [J.SECONDARY]: "bg-gray-5 hover:bg-gray-6 dark:active:bg-gray-9  disabled:border-none disabled:bg-gray-5",
      [J.OUTLINED]: "text-black dark:text-white bg-transparent border-1 border-solid border-gray-5 dark:border-gray-8",
      [J.TEXT]: "bg-transparent border-transparent text-black dark:text-white hover:bg-gray-1 dark:hover:bg-gray-4 hover:border-transparent dark:active:bg-gray-3 active:border-1 active:border-solid active:border-gray-4",
      [J.INVERSE]: "bg-black dark:bg-white active:bg-gray-10 text-white dark:active:bg-blue-11 dark:text-gray-1 disabled:!bg-gray-5 disabled:text-black dark:disabled:text-white",
      [J.TRANSPARENT]: "bg-transparent text-black dark:text-white"
    }[e];
  if (t === ft.ERROR)
    return {
      [J.CONTAINED]: "bg-red-9 text-white hover:bg-red-8 active:bg-red-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-red-500 hover:bg-red-500/10 active:bg-red-500/20",
      [J.TEXT]: "text-red-500 hover:bg-red-500/10 active:bg-red-500/20",
      [J.INVERSE]: "bg-white text-red-500 hover:bg-gray-50 active:bg-gray-100",
      [J.TRANSPARENT]: "bg-transparent text-red-500 hover:bg-red-500/10 active:bg-red-500/20"
    }[e];
  if (t === ft.ALERT)
    return {
      [J.CONTAINED]: "bg-yellow-9 border-yellow-9 text-white hover:bg-yellow-8 active:bg-yellow-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-yellow-500 hover:bg-yellow-500/10 active:bg-yellow-500/20",
      [J.TEXT]: "text-yellow-500 hover:bg-yellow-500/10 active:bg-yellow-500/20",
      [J.INVERSE]: "bg-white text-yellow-500 hover:bg-gray-50 active:bg-gray-100",
      [J.TRANSPARENT]: "bg-transparent text-yellow-500 hover:bg-yellow-500/10 active:bg-yellow-500/20"
    }[e];
  if (t === ft.SUCCESS)
    return {
      [J.CONTAINED]: "bg-green-9 dark:bg-green-7 border-green-9 text-white hover:bg-green-8 active:bg-green-7",
      [J.OUTLINED]: "text-black dark:text-white border-2 border-green-500 hover:bg-green-500/10 active:bg-green-500/20",
      [J.TEXT]: "text-green-500 hover:bg-green-500/10 active:bg-green-500/20",
      [J.INVERSE]: "bg-white text-green-500 hover:bg-gray-50 active:bg-gray-100",
      [J.TRANSPARENT]: "bg-transparent text-green-500 hover:bg-green-500/10 active:bg-green-500/20"
    }[e];
}, aN = {
  [_e.XSMALL]: {
    button: "w-5 h-5",
    // 20px
    icon: "w-3 h-3",
    // 12px icon
    spinner: Ue.XSMALL
  },
  [_e.SMALL_MINUS]: {
    button: "w-6 h-6",
    // 24px
    icon: "w-3.5 h-3.5",
    // 14px icon
    spinner: Ue.XSMALL
  },
  [_e.SMALL]: {
    button: "w-7 h-7",
    // 28px
    icon: "w-4 h-4",
    // 16px icon
    spinner: Ue.SMALL
  },
  [_e.SMALL_PLUS]: {
    button: "w-8 h-8",
    // 32px
    icon: "w-[18px] h-[18px]",
    // 18px icon
    spinner: Ue.SMALL
  },
  [_e.MEDIUM]: {
    button: "w-9 h-9",
    // 36px
    icon: "w-5 h-5",
    // 20px icon
    spinner: Ue.MEDIUM
  },
  [_e.LARGE]: {
    button: "w-11 h-11",
    // 44px
    icon: "w-6 h-6",
    // 24px icon
    spinner: Ue.LARGE
  }
}, Jie = ({ variant: e, color: t, size: n, shape: a, loading: o, disabled: i }) => {
  let c = "inline-flex items-center justify-center transition-all duration-200 rounded-full";
  a === we.SQUARE && (c += " rounded-md");
  const s = Qie(e, t), l = aN[n], u = i ? "opacity-60 cursor-not-allowed" : "cursor-pointer", h = o ? "opacity-70 cursor-wait" : "";
  return `
    ${c}
    ${s}
    ${l.button}
    ${u}
    ${h}
  `.trim().replace(/\s+/g, " ");
}, ece = ({ icon: e, iconColor: t, loading: n, loaderSize: a, classNames: o, variant: i, size: c }) => {
  const s = aN[c];
  return n ? /* @__PURE__ */ p(
    Rn,
    {
      size: a || (s == null ? void 0 : s.spinner),
      className: `${o == null ? void 0 : o.spinner} ${i === J.CONTAINED ? "!border-primary-200 !border-r-transparent" : ""}`
    }
  ) : /* @__PURE__ */ p(oe, { icon: e, className: `${s.icon} ${o == null ? void 0 : o.icon}`, color: t || "currentColor" });
}, tce = { spinner: "", icon: "" }, wt = ({
  variant: e = J.CONTAINED,
  color: t = ft.DEFAULT,
  size: n = _e.SMALL,
  shape: a = we.PILL,
  icon: o,
  iconColor: i,
  loading: c,
  disabled: s,
  loaderSize: l,
  className: u = "",
  classNames: h = tce,
  type: k = "button",
  ...f
}) => {
  const { "aria-label": y } = f, m = Jie({ variant: e, color: t, size: n, shape: a, loading: c, disabled: s });
  return /* @__PURE__ */ p(
    "button",
    {
      className: P(m, u),
      disabled: s || c,
      "aria-label": y ?? `${o}-button`,
      type: k,
      ...f,
      children: /* @__PURE__ */ p(
        ece,
        {
          icon: o,
          iconColor: i,
          loading: c,
          loaderSize: l,
          classNames: h,
          variant: e,
          size: n
        }
      )
    }
  );
}, nce = {
  [z1.DEFAULT]: {
    container: "bg-blue-1 border-blue-7",
    title: "text-blue-12",
    description: "text-blue-11",
    icon: "text-blue-9"
  },
  [z1.ALERT]: {
    container: "bg-yellow-2 border-yellow-7",
    title: "text-yellow-12",
    description: "text-yellow-11",
    icon: "text-yellow-9"
  },
  [z1.ERROR]: {
    container: "bg-red-1 border-red-7",
    title: "text-red-12",
    description: "text-red-11",
    icon: "text-red-9"
  }
};
function dge({
  visible: e = !1,
  variant: t = z1.DEFAULT,
  title: n,
  description: a,
  actionTitle: o,
  actionHandler: i,
  isDismissable: c = !0,
  ...s
}) {
  if (!e) return null;
  let l = ft.DEFAULT;
  t === z1.ALERT ? l = ft.ALERT : t === z1.ERROR && (l = ft.ERROR);
  const u = nce[t], h = (k, f) => {
    k == null || k.stopPropagation(), i == null || i(f);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      "data-role": "alertbox",
      className: `
        flex justify-between items-center w-full
        py-3 px-4 gap-2.5 rounded
        border border-solid
        ${u.container}
      `.trim(),
      onClick: (k) => h == null ? void 0 : h(k, U9.ContainerCTA),
      ...s,
      children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2.5 flex-shrink", children: [
          /* @__PURE__ */ p(
            oe,
            {
              icon: R.INFO,
              className: `min-w-4 h-4 ${u.icon}`
            }
          ),
          /* @__PURE__ */ C("div", { className: "flex-shrink", children: [
            n && /* @__PURE__ */ p(
              q,
              {
                variant: x.PARAGRAPH_SMALL_REGULAR,
                className: u.title,
                children: n
              }
            ),
            a && /* @__PURE__ */ p(
              q,
              {
                variant: x.PARAGRAPH_XSMALL_REGULAR,
                className: `opacity-70 ${u.description}`,
                children: a
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "flex gap-2.5", children: [
          o && /* @__PURE__ */ p(
            nt,
            {
              size: _e.SMALL,
              variant: J.CONTAINED,
              color: l,
              onClick: (k) => h(k, U9.CTA),
              children: o
            }
          ),
          c && /* @__PURE__ */ p(
            wt,
            {
              className: "text-blue-12",
              icon: R.CLOSE,
              variant: J.TRANSPARENT,
              onClick: (k) => h(k, U9.Dismiss),
              "aria-label": "close"
            }
          )
        ] })
      ]
    }
  );
}
const Hv = {
  [dt.XSMALL]: {
    container: "h-[15px] px-1",
    text: x.LABEL_SMALL_REGULAR,
    icon: "min-w-3 h-3"
  },
  [dt.SMALL]: {
    container: "h-[24px] px-3",
    text: x.LABEL_SMALL_REGULAR,
    icon: "min-w-4 h-4"
  },
  [dt.MEDIUM]: {
    container: "h-[32px] px-3.5",
    text: x.LABEL_MEDIUM_REGULAR,
    icon: "min-w-4 h-4"
  }
}, Bv = {
  [Ze.DEFAULT]: {
    container: "bg-gray-6 border-0 dark:bg-gray-6 dark:border-0",
    text: "text-gray-12 dark:text-white",
    icon: "text-gray-12 dark:text-gray-12"
  },
  [Ze.ACTIVE]: {
    container: "bg-blue-9 border-primary-200 dark:bg-blue-9 dark:border-primary-700",
    text: "text-gray-1 dark:text-gray-12",
    icon: "text-gray-1 dark:text-gray-12"
  },
  [Ze.CONTRAST]: {
    container: "bg-blue-9 border-transparent",
    text: "text-white",
    icon: "text-white"
  },
  [Ze.OUTLINED]: {
    container: "bg-transparent border border-solid border-gray-7",
    text: "text-blue-12",
    icon: "text-blue-12"
  },
  [Ze.SOFT_SUCCESS]: {
    container: "bg-green-9/20 border-transparent",
    text: "text-green-10",
    icon: "text-green-10"
  },
  [Ze.SOFT_PURPLE]: {
    container: "bg-purple-9/20 border-transparent",
    text: "text-purple-10",
    icon: "text-purple-10"
  },
  [Ze.SOFT_NEUTRAL]: {
    container: "bg-gray-4 border-transparent",
    text: "text-gray-12 dark:text-white",
    icon: "text-gray-12"
  }
}, ace = {
  [we.SQUARE]: "rounded",
  [we.PILL]: "rounded-full"
}, SE = {
  [Ze.OUTLINED]: {
    [ac.SUCCESS]: "border-green-9 dark:border-green-10",
    [ac.ERROR]: "border-red-9 dark:border-red-9"
  }
}, oce = ({ shape: e, variant: t, size: n, color: a, disabled: o, className: i }) => {
  var c;
  return P(
    "inline-flex items-center border transition-colors duration-200 w-fit gap-1",
    Hv[n].container,
    Bv[t].container,
    ace[e],
    ((c = SE == null ? void 0 : SE[t]) == null ? void 0 : c[a]) || "",
    o ? "cursor-not-allowed opacity-50" : "cursor-pointer",
    i
  );
}, rce = ({ size: e, variant: t, loading: n, iconStart: a, children: o, classNames: i }) => {
  if (n)
    return /* @__PURE__ */ p(Rn, { size: Ue.SMALL });
  const c = Hv[e], s = Bv[t];
  return /* @__PURE__ */ C(at, { children: [
    a ? /* @__PURE__ */ p(oe, { icon: a, className: P(c.icon, s.icon, i.iconStart) }) : null,
    o ? /* @__PURE__ */ p(q, { as: "span", variant: c.text, className: wn(s.text, i.text), children: o }) : null
  ] });
}, ice = ({ size: e, variant: t, classNames: n }) => P(Hv[e].icon, Bv[t].icon, n.iconEnd), cce = {}, Vt = ({
  shape: e = we.PILL,
  variant: t = Ze.DEFAULT,
  size: n = dt.MEDIUM,
  iconStart: a,
  iconEnd: o,
  disabled: i = !1,
  loading: c = !1,
  children: s,
  className: l = "",
  classNames: u = cce,
  type: h = "button",
  color: k,
  onIconEndClick: f,
  iconEndAriaLabel: y,
  "data-testid": m,
  ...g
}) => {
  const _ = oce({ shape: e, variant: t, size: n, color: k, disabled: i, className: l }), L = ice({ size: n, variant: t, classNames: u }), N = !c && !!o, I = /* @__PURE__ */ p(rce, { size: n, variant: t, loading: c, iconStart: a, classNames: u, children: s });
  return f ? /* @__PURE__ */ C("div", { className: _, "data-testid": m, children: [
    I,
    N ? /* @__PURE__ */ p(
      "button",
      {
        type: "button",
        disabled: i,
        "aria-label": y,
        onClick: f,
        className: "inline-flex items-center justify-center",
        children: /* @__PURE__ */ p(oe, { icon: o, className: L })
      }
    ) : null
  ] }) : /* @__PURE__ */ C("button", { disabled: i, className: _, type: h, "data-testid": m, ...g, children: [
    I,
    N ? /* @__PURE__ */ p(oe, { icon: o, className: L }) : null
  ] });
}, sce = {
  INCLUDE: "include",
  EXCLUDE: "exclude"
}, lce = "−", dce = { iconEnd: "h-3 w-3 min-w-3 text-gray-12", text: "text-[13px] leading-4" }, uce = {
  iconEnd: "h-3 w-3 min-w-3 text-gray-11",
  text: "text-[13px] leading-4 text-gray-11"
}, uge = ({
  label: e,
  variant: t,
  onRemove: n,
  removeAriaLabel: a,
  excludedPrefix: o = lce,
  "data-testid": i = "AppliedFilterChip"
}) => {
  const c = t === sce.EXCLUDE, s = c ? /* @__PURE__ */ C("span", { className: "flex items-center gap-1", children: [
    /* @__PURE__ */ p("span", { className: "text-gray-10", children: o }),
    /* @__PURE__ */ p("span", { className: "text-gray-11", children: e })
  ] }) : e;
  return /* @__PURE__ */ p(
    Vt,
    {
      "aria-label": a,
      className: P(
        "h-6 shrink-0 whitespace-nowrap gap-1 rounded-xl px-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gray-8 dark:focus-visible:outline-gray-9",
        c ? "border-gray-7 bg-transparent dark:border-gray-8" : "bg-gray-5 dark:bg-gray-5"
      ),
      classNames: c ? uce : dce,
      "data-testid": i,
      iconEnd: R.CLOSE,
      onClick: n,
      shape: we.SQUARE,
      size: dt.SMALL,
      variant: c ? Ze.OUTLINED : Ze.DEFAULT,
      children: s
    }
  );
}, hce = ({ children: e, onClick: t, "data-testid": n }) => /* @__PURE__ */ p(
  "button",
  {
    className: "m-0 border-0 bg-transparent p-0 cursor-pointer shrink-0 whitespace-nowrap text-[13px] font-medium leading-5 text-blue-10 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-gray-8 dark:focus-visible:outline-gray-9",
    "data-testid": n ?? "AppliedFilters-ClearAll",
    onClick: t,
    type: "button",
    children: e
  }
), pce = ({ "data-testid": e }) => /* @__PURE__ */ p(
  "div",
  {
    "aria-orientation": "vertical",
    className: "h-[18px] w-px shrink-0 bg-gray-7 dark:bg-gray-8",
    "data-testid": e ?? "AppliedFilters-Divider",
    role: "separator"
  }
), yce = ({ children: e, "data-testid": t }) => /* @__PURE__ */ p(
  q,
  {
    as: "span",
    className: "shrink-0 whitespace-nowrap text-sm font-semibold leading-5 text-gray-12",
    "data-testid": t ?? "AppliedFilters-ResultCount",
    variant: x.LABEL_MEDIUM_MEDIUM,
    children: e
  }
), RE = {
  RESULT_COUNT: "ResultCount",
  DIVIDER: "Divider",
  CLEAR_ALL: "ClearAll"
}, kce = ({ children: e, className: t, "data-testid": n = "AppliedFilters" }) => /* @__PURE__ */ p("div", { className: P("[container-type:inline-size] min-w-0 flex-1", t), "data-testid": n, children: /* @__PURE__ */ p(
  "div",
  {
    className: "flex min-h-7 flex-nowrap items-center gap-1.5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [@container(min-width:48rem)]:flex-wrap",
    "data-testid": `${n}-Row`,
    children: e
  }
) }), hge = Object.assign(kce, {
  [RE.RESULT_COUNT]: yce,
  [RE.DIVIDER]: pce,
  [RE.CLEAR_ALL]: hce
}), fce = {
  [Xt.XSMALL]: {
    container: "w-5 h-5",
    // 20px
    icon: "w-3 h-3",
    // 12px
    text: x.LABEL_XSMALL_REGULAR
    // 10px
  },
  [Xt.SMALL]: {
    container: "w-7 h-7",
    // 28px
    icon: "w-4 h-4",
    // 16px
    text: x.LABEL_SMALL_REGULAR
    // 12px
  },
  [Xt.MEDIUM]: {
    container: "w-9 h-9",
    // 36px n
    icon: "w-5 h-5",
    // 20px
    text: x.LABEL_LARGE_REGULAR
    // 16px
  },
  [Xt.LARGE]: {
    container: "w-11 h-11",
    // 44px
    icon: "w-6 h-6",
    // 24px
    text: x.HEADING_6_REGULAR
    // 20px
  },
  [Xt.XLARGE]: {
    container: "w-[52px] h-[52px]",
    icon: "w-7 h-7",
    // 28px,
    text: x.HEADING_5_REGULAR
    // 24px
  }
}, bi = ({
  src: e = "",
  name: t = "",
  icon: n,
  size: a = Xt.MEDIUM,
  blurred: o = !1,
  onClick: i,
  className: c = "",
  classNames: s = {
    base: "",
    avatar: "",
    icon: "",
    name: ""
  },
  shape: l = G1.ROUNDED,
  imageProps: u = {}
}) => {
  const h = fce[a], k = l === G1.SQUARE ? "rounded-md" : "rounded-full", f = P(
    `
    inline-flex items-center justify-center
    text-white 
    overflow-hidden`,
    e ? "bg-transparent" : "bg-blue-9",
    i && "cursor-pointer hover:opacity-80",
    h.container,
    c,
    s.base,
    k
  );
  return /* @__PURE__ */ p(i ? "button" : "div", { onClick: i, className: f, children: (() => {
    if (e)
      return /* @__PURE__ */ p(
        "img",
        {
          src: e,
          alt: t || "avatar",
          className: P(
            "h-full w-full object-cover",
            k,
            o && "blur-sm",
            s.avatar
          ),
          ...u
        }
      );
    if (n)
      return /* @__PURE__ */ p(
        oe,
        {
          icon: n,
          className: `${h.icon} ${s.icon}`
        }
      );
    if (t)
      return /* @__PURE__ */ p(q, { variant: h.text, className: s.name, children: t.length >= 3 ? t.substring(0, 3) : t });
  })() });
}, oN = ({
  avatarSrc: e,
  name: t,
  creatorUsername: n,
  editable: a = !1,
  onRemove: o,
  hasError: i = !1,
  className: c = "",
  classNames: s = {}
}) => {
  const l = () => {
    o && a && o();
  }, u = n ? n.startsWith("@") ? n : `@${n}` : void 0;
  return /* @__PURE__ */ p(
    nt,
    {
      iconEnd: a ? R.CLOSE : void 0,
      variant: J.OUTLINED,
      size: _e.MEDIUM,
      "aria-label": t,
      onClick: a ? l : void 0,
      className: P(
        i && "border-solid !border-red-9 dark:!border-red-10",
        !a && "cursor-default",
        c,
        s.button,
        "py-6"
      ),
      children: /* @__PURE__ */ C("span", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ p(
          bi,
          {
            shape: G1.SQUARE,
            src: e,
            name: t,
            size: Xt.SMALL,
            className: P("h-7 w-7", s.avatar)
          }
        ),
        /* @__PURE__ */ C("span", { className: "flex flex-col items-start gap-[2px]", children: [
          /* @__PURE__ */ p(
            q,
            {
              variant: x.LABEL_MEDIUM_MEDIUM,
              className: P("text-gray-12 dark:text-white", s.text),
              children: t
            }
          ),
          u && /* @__PURE__ */ p(
            q,
            {
              variant: x.LABEL_SMALL_REGULAR,
              className: "text-gray-10 dark:text-gray-10",
              children: u
            }
          )
        ] })
      ] })
    }
  );
};
oN.displayName = "AvatarChip";
he.memo(oN);
const mce = (e = Bt.DEFAULT, t = Yn.DEFAULT, n) => {
  const a = {
    [Yn.DEFAULT]: {
      container: "min-h-5 px-sm gap-1",
      dot: "w-1.5 h-1.5",
      text: x.LABEL_SMALL_MEDIUM
    },
    [Yn.SMALL]: {
      container: "min-h-4 px-1 gap-1",
      dot: "w-1.5 h-1.5",
      text: x.LABEL_SMALL_MEDIUM
    }
  }[t] || {
    container: "",
    dot: "",
    text: ""
  };
  if (e === Bt.COLORED)
    return {
      ...a,
      container: a.container + " bg-blue-1 border-none text-blue-10",
      dot: a.dot + " bg-blue-10",
      text: a.text
    };
  let o = {};
  if (e === Bt.DEFAULT ? o = {
    container: a.container + " bg-gray-5 border-none text-gray-12",
    dot: a.dot + " bg-gray-10",
    text: a.text
  } : e === Bt.OUTLINED && (o = {
    container: a.container + " bg-transparent border-gray-5 dark:border-gray-8 text-gray-12",
    dot: a.dot + " bg-gray-10",
    text: a.text
  }), n && (e === Bt.DEFAULT || e === Bt.OUTLINED)) {
    const i = e === Bt.DEFAULT ? {
      [jt.ERROR]: {
        container: "bg-red-9 border-red-9 text-white dark:bg-red-5 dark:border-red-5",
        dot: "bg-white",
        text: a.text
      },
      [jt.WARNING]: {
        container: "bg-yellow-9 border-yellow-9 dark:bg-yellow-6 dark:border-yellow-6 text-white",
        dot: "bg-white"
      },
      [jt.SUCCESS]: {
        container: "bg-green-9 border-green-9 dark:bg-green-5 dark:border-green-5 text-white",
        dot: "bg-white"
      },
      [jt.INFO]: {
        container: "bg-blue-7 border-blue-7 text-white dark:bg-blue-6 dark:border-blue-6",
        dot: "bg-white"
      }
    } : {
      [jt.ERROR]: {
        container: "text-red-9 bg-red-2 border-red-9 dark:bg-red-1 dark:border-red-5",
        dot: "bg-red-9"
      },
      [jt.WARNING]: {
        container: "text-yellow-9 bg-yellow-2 border-yellow-9 dark:text-yellow-9 dark:border-yellow-4",
        dot: "bg-yellow-9"
      },
      [jt.SUCCESS]: {
        container: "text-green-9 bg-green-2 border-green-4 dark:text-green-7 dark:bg-green-2 dark:border-green-4",
        dot: "bg-green-9"
      },
      [jt.INFO]: {
        container: "text-blue-10 bg-blue-2 border-blue-10 dark:border-blue-5",
        dot: "bg-blue-10"
      }
    };
    return {
      ...a,
      ...o,
      container: a.container + " " + i[n].container,
      dot: a.dot + " " + i[n].dot,
      text: a.text || o.text
    };
  }
  return {
    ...a,
    ...o
  };
}, ki = ({
  variant: e = Bt.DEFAULT,
  size: t = Yn.DEFAULT,
  showDot: n = !0,
  className: a,
  classNames: o,
  children: i,
  color: c,
  ...s
}) => {
  const l = mce(e, t, c);
  return /* @__PURE__ */ p(
    "div",
    {
      ...s,
      className: P("flex items-center border border-solid rounded-[3px] cursor-default", l.container, o == null ? void 0 : o.container, a),
      children: typeof i == "string" ? /* @__PURE__ */ C(at, { children: [
        n ? /* @__PURE__ */ p("div", { className: P("rounded-full", l.dot, o == null ? void 0 : o.dot) }) : null,
        /* @__PURE__ */ p(q, { variant: l.text, className: o == null ? void 0 : o.text, children: i })
      ] }) : i
    }
  );
}, Kt = ({
  blurRadius: e = 0,
  className: t = "",
  alt: n = "",
  ...a
}) => /* @__PURE__ */ p(
  "img",
  {
    alt: n,
    ...a,
    className: `
        object-cover
        ${t}
      `.trim(),
    style: {
      filter: e > 0 ? `blur(${e}px)` : void 0
    }
  }
), Nn = {
  xxs: "(max-width: 374px)",
  xs: "(max-width: 425px)",
  sm: "(max-width: 767px)",
  md: "(min-width: 768px) and (max-width: 991px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1560px)",
  portrait: "(orientation: portrait)",
  landscape: "(orientation: landscape)"
}, gce = () => typeof window > "u" ? !1 : navigator.maxTouchPoints > 0 || window.matchMedia("(pointer: coarse)").matches || window.matchMedia("(hover: none)").matches, Mce = () => {
  var a;
  if (typeof window > "u") return !1;
  const e = (a = navigator.userAgent) == null ? void 0 : a.toLowerCase(), t = e.includes("android") && e.includes("wv"), n = (e.includes("iphone") || e.includes("ipad")) && !e.includes("safari");
  return t || n;
};
let q9 = {
  xxs: !1,
  xs: !1,
  sm: !1,
  md: !1,
  lg: !1,
  xl: !1,
  hoverNone: !1,
  isPortrait: !1,
  isLandscape: !1,
  isMobileApp: !1
};
const K9 = /* @__PURE__ */ new Set(), _ce = () => ({
  xxs: window.matchMedia(Nn.xxs).matches,
  xs: window.matchMedia(Nn.xs).matches,
  sm: window.matchMedia(Nn.sm).matches,
  md: window.matchMedia(Nn.md).matches,
  lg: window.matchMedia(Nn.lg).matches,
  xl: window.matchMedia(Nn.xl).matches,
  isPortrait: window.matchMedia(Nn.portrait).matches,
  isLandscape: window.matchMedia(Nn.landscape).matches,
  isMobileApp: Mce(),
  hoverNone: gce()
}), xA = () => {
  const e = _ce();
  JSON.stringify(q9) !== JSON.stringify(e) && (q9 = e, K9.forEach((t) => t(q9)));
};
typeof window < "u" && (K9.size === 0 && (Object.values(Nn).forEach((t) => {
  window.matchMedia(t).addEventListener("change", xA);
}), xA()));
function Dn() {
  const [e, t] = ae(q9);
  return le(() => (K9.add(t), () => {
    K9.delete(t);
  }), []), {
    ...e,
    isMobileSmall: e.xxs,
    isMobileMedium: e.xs,
    isMobile: e.sm,
    isTablet: e.md,
    isDesktop: e.lg,
    isWider: e.xl
  };
}
const Yt = {
  BottomStart: "bottom-start",
  BottomEnd: "bottom-end",
  TopStart: "top-start",
  TopEnd: "top-end"
};
var Vi = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Both = "both", e))(Vi || {});
const Z9 = 4, ic = 16, bce = (e) => e === Yt.TopStart || e === Yt.TopEnd;
function rN({
  triggerRect: e,
  placement: t,
  dropdownHeight: n,
  canFlip: a = !0,
  viewportHeight: o
}) {
  const i = e.top - ic - Z9, c = o - e.bottom - ic - Z9, s = bce(t) ? "top" : "bottom", l = s === "top" ? i : c, u = s === "top" ? c : i, h = n !== void 0 && n > 0;
  return a && h && l < n && u >= n ? { side: s === "top" ? "bottom" : "top", availableHeight: u } : { side: s, availableHeight: l };
}
const EA = 16, Lce = ({
  dropdownScrollHeight: e,
  dropdownScrollWidth: t,
  triggerRect: n,
  placement: a,
  canFlip: o = !1,
  viewportHeight: i,
  viewportWidth: c
}) => {
  const { availableHeight: s } = rN({
    triggerRect: n,
    placement: a,
    dropdownHeight: e,
    canFlip: o,
    viewportHeight: i
  }), u = a === Yt.BottomEnd || a === Yt.TopEnd ? n.right - EA : c - n.left - EA;
  return {
    maxHeight: e > s ? s : void 0,
    maxWidth: t > u ? u : void 0
  };
}, iN = ({
  isOpen: e,
  onOpenChange: t,
  closeOnClickOutside: n = !0,
  closeOnScroll: a = !0,
  closeOnAncestorScroll: o = !1,
  placement: i = "bottom-end",
  isPortaled: c = !1
} = {}) => {
  const [s, l] = ae(!1), [u, h] = ae(void 0), [k, f] = ae(void 0), [y, m] = ae(null), g = fe(null), _ = fe(null), L = e !== void 0, N = L ? e : s, I = Q(
    (O) => {
      if (L) {
        t == null || t(O);
        return;
      }
      l(O);
    },
    [L, t]
  ), S = Q((O) => {
    _.current = O, m((A) => A === O ? A : O);
  }, []);
  return le(() => {
    const O = (B) => {
      var j, G;
      if (!n)
        return;
      const z = B.target;
      (j = g.current) != null && j.contains(z) || (G = _.current) != null && G.contains(z) || I(!1);
    }, A = (B) => {
      var j;
      if (!a || !N)
        return;
      const z = B.target;
      (j = _.current) != null && j.contains(z) || o && g.current !== null && !z.contains(g.current) || I(!1);
    };
    return N && (document.addEventListener("mousedown", O), document.addEventListener("scroll", A, o)), () => {
      document.removeEventListener("mousedown", O), document.removeEventListener("scroll", A, o);
    };
  }, [o, n, a, I, N]), Sn(() => {
    if (!N) {
      h(void 0), f(void 0);
      return;
    }
    const O = _.current, A = g.current;
    if (O === null || A === null)
      return;
    const B = () => {
      const z = Lce({
        dropdownScrollHeight: O.scrollHeight,
        dropdownScrollWidth: O.scrollWidth,
        triggerRect: A.getBoundingClientRect(),
        placement: i,
        canFlip: c,
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth
      });
      h(z.maxHeight), f(z.maxWidth);
    };
    return B(), window.addEventListener("resize", B), () => window.removeEventListener("resize", B);
  }, [N, c, i, y]), {
    isDropdownOpen: N,
    handleOpenChange: I,
    containerRef: g,
    dropdownRef: S,
    dropdownNode: y,
    maxHeight: u,
    maxWidth: k
  };
};
var xt = /* @__PURE__ */ ((e) => (e.TOP_LEFT = "topLeft", e.TOP_CENTER = "topCenter", e.TOP_RIGHT = "topRight", e.MIDDLE_LEFT = "middleLeft", e.MIDDLE_CENTER = "middleCenter", e.MIDDLE_RIGHT = "middleRight", e.BOTTOM_LEFT = "bottomLeft", e.BOTTOM_CENTER = "bottomCenter", e.BOTTOM_RIGHT = "bottomRight", e))(xt || {}), Ke = /* @__PURE__ */ ((e) => (e.TOP_LEFT = "topLeft", e.TOP_CENTER = "topCenter", e.TOP_RIGHT = "topRight", e.MIDDLE_LEFT = "middleLeft", e.MIDDLE_RIGHT = "middleRight", e.BOTTOM_LEFT = "bottomLeft", e.BOTTOM_CENTER = "bottomCenter", e.BOTTOM_RIGHT = "bottomRight", e))(Ke || {}), Gi = /* @__PURE__ */ ((e) => (e.TOP = "Top", e.MIDDLE = "Middle", e.BOTTOM = "Bottom", e))(Gi || {}), z9 = /* @__PURE__ */ ((e) => (e.LEFT = "Left", e.RIGHT = "Right", e))(z9 || {});
const DE = (e, t) => t.map((a) => {
  const o = (e == null ? void 0 : e.filter((i) => i.placement === a)) || [];
  return o.length > 0 ? o : [{ placement: a }];
}), xce = (e) => {
  const t = Object.values(Ke), n = e == null ? void 0 : e.map((h) => ({
    ...h,
    placement: h.placement || Ke.BOTTOM_LEFT
  })), a = n == null ? void 0 : n.slice().sort(
    (h, k) => t.indexOf(h.placement) - t.indexOf(k.placement)
  ), o = [
    Ke.TOP_LEFT,
    Ke.TOP_CENTER,
    Ke.TOP_RIGHT
  ], i = [
    Ke.MIDDLE_LEFT,
    Ke.MIDDLE_RIGHT
  ], c = [
    Ke.BOTTOM_LEFT,
    Ke.BOTTOM_CENTER,
    Ke.BOTTOM_RIGHT
  ], s = DE(
    a == null ? void 0 : a.filter((h) => o.includes(h.placement)),
    o
  ), l = DE(
    a == null ? void 0 : a.filter(
      (h) => i.includes(h.placement)
    ),
    i
  ), u = DE(
    a == null ? void 0 : a.filter(
      (h) => c.includes(h.placement)
    ),
    c
  );
  return { topActions: s, middleActions: l, bottomActions: u };
}, Ece = (e, t) => ({
  backgroundColor: e == null ? void 0 : e.backgroundColor,
  ...t && {
    backgroundColor: e == null ? void 0 : e.hoverBackgroundColor
  }
}), vce = (e, t) => ({
  color: (t ? e == null ? void 0 : e.hoverColor : e == null ? void 0 : e.color) || "#ffffff",
  fontSize: (e == null ? void 0 : e.fontSize) || 14,
  fontWeight: (e == null ? void 0 : e.fontWeight) || 500
}), ov = {
  [Ke.TOP_CENTER]: "self-center",
  [Ke.BOTTOM_CENTER]: "self-center",
  [Ke.TOP_RIGHT]: "self-end",
  [Ke.BOTTOM_RIGHT]: "self-end",
  [Ke.TOP_LEFT]: "self-start",
  [Ke.BOTTOM_LEFT]: "self-start"
}, vA = {
  [xt.TOP_CENTER]: "text-center",
  [xt.MIDDLE_CENTER]: "text-center",
  [xt.BOTTOM_CENTER]: "text-center",
  [xt.TOP_RIGHT]: "text-right",
  [xt.MIDDLE_RIGHT]: "text-right",
  [xt.BOTTOM_RIGHT]: "text-right"
}, Ace = {
  [xt.TOP_CENTER]: "items-center",
  [xt.TOP_RIGHT]: "items-end",
  [xt.MIDDLE_LEFT]: "justify-center",
  [xt.MIDDLE_CENTER]: "justify-center items-center",
  [xt.MIDDLE_RIGHT]: "justify-center items-end",
  [xt.BOTTOM_LEFT]: "justify-end",
  [xt.BOTTOM_CENTER]: "justify-end items-center",
  [xt.BOTTOM_RIGHT]: "justify-end items-end"
}, Ice = (e) => e.stopPropagation(), Tce = ({
  action: e,
  isHovered: t,
  onHoverIn: n,
  onHoverOut: a,
  style: o
}) => {
  if (!(e != null && e.label))
    return /* @__PURE__ */ p("div", {});
  const i = Ece(e, t), c = vce(e, t), s = ov[e == null ? void 0 : e.placement] || "";
  return /* @__PURE__ */ p("div", { style: o, onMouseEnter: n, onMouseLeave: a, onClick: Ice, children: /* @__PURE__ */ p(
    nt,
    {
      className: `${s} h-auto py-2 px-4 whitespace-nowrap shadow-md bg-white/[0.19]`,
      classNames: { text: "leading-none" },
      variant: J.TRANSPARENT,
      shape: (e == null ? void 0 : e.shape) || we.PILL,
      style: i,
      onClick: e == null ? void 0 : e.onClick,
      children: /* @__PURE__ */ p("span", { style: c, children: e == null ? void 0 : e.label })
    }
  ) });
}, Ec = he.memo(Tce), Nce = ({
  backgroundImageUrl: e,
  additionalImage: t,
  title: n,
  description: a,
  actions: o,
  contentPlacement: i,
  className: c,
  variant: s,
  backgroundColor: l,
  classNames: u = {
    content: "",
    additionalImage: ""
  },
  onBannerClick: h
}) => {
  var j, G, $, H;
  const { url: k, direction: f } = t || {}, y = s === Y9.POP_UP, { isDesktop: m } = Dn(), [g, _] = ae(null), { topActions: L, middleActions: N, bottomActions: I } = xce(o), S = N.flat(), O = m ? k && f === z9.LEFT ? 12 : 24 : 12, A = m ? k && f === z9.RIGHT ? 12 : 24 : 12, B = (j = L == null ? void 0 : L.flat()) == null ? void 0 : j.filter((ee) => ee == null ? void 0 : ee.label), z = (G = I == null ? void 0 : I.flat()) == null ? void 0 : G.filter((ee) => ee == null ? void 0 : ee.label);
  return /* @__PURE__ */ p("div", { className: P("relative w-full h-full", h && "cursor-pointer"), onClick: h, children: /* @__PURE__ */ C("div", { className: "w-full h-full", style: { backgroundColor: l || "transparent" }, children: [
    e && /* @__PURE__ */ p(
      Kt,
      {
        src: e || "/placeholder.svg",
        alt: (n == null ? void 0 : n.label) || (a == null ? void 0 : a.label) || "banner",
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    ),
    /* @__PURE__ */ C("div", { className: `flex relative z-10 h-full ${f === z9.RIGHT ? "flex-row-reverse" : ""}`, children: [
      k && /* @__PURE__ */ p(
        Kt,
        {
          src: k || "/placeholder.svg",
          alt: "Additional",
          className: `${m ? "h-[190px] w-[190px]" : "h-[240px] w-[160px]"} object-contain ${y ? "h-full" : ""} ${u == null ? void 0 : u.additionalImage}`
        }
      ),
      /* @__PURE__ */ C(
        "div",
        {
          className: `flex gap-[18px] min-w-0 ${m ? "h-[190px]" : "h-[240px]"} grow shrink py-6 ${y ? "!h-full" : ""} ${c}`,
          style: {
            paddingLeft: O,
            paddingRight: A
          },
          children: [
            (($ = S[0]) == null ? void 0 : $.label) && /* @__PURE__ */ p("div", { className: "flex justify-center items-center", children: /* @__PURE__ */ p(
              Ec,
              {
                action: S[0],
                isHovered: g === Ke.MIDDLE_LEFT,
                onHoverIn: () => _(Ke.MIDDLE_LEFT),
                onHoverOut: () => _(null)
              }
            ) }),
            /* @__PURE__ */ C("div", { className: "flex flex-col grow shrink gap-2 justify-between h-full", children: [
              (B == null ? void 0 : B.length) > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between items-center gap-md w-full flex-wrap", children: L == null ? void 0 : L.map((ee, Y) => {
                var U;
                return /* @__PURE__ */ p(
                  "div",
                  {
                    className: `flex flex-wrap flex-shrink gap-md ${ov[(U = ee == null ? void 0 : ee[0]) == null ? void 0 : U.placement] || ""}`,
                    children: ee.map(
                      (Z, te) => Z != null && Z.label ? /* @__PURE__ */ p(
                        Ec,
                        {
                          action: Z,
                          isHovered: g === `${te}_${Gi.TOP}`,
                          onHoverIn: () => _(`${te}_${Gi.TOP}`),
                          onHoverOut: () => _(null)
                        },
                        te
                      ) : null
                    )
                  },
                  Y
                );
              }) }),
              /* @__PURE__ */ p("div", { className: `flex flex-col grow shrink ${Ace[i] || ""}`, children: /* @__PURE__ */ p("div", { className: `flex flex-col shrink gap-lg max-w-[700px] ${u == null ? void 0 : u.content}`, children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-md", children: [
                (n == null ? void 0 : n.label) && /* @__PURE__ */ p(
                  q,
                  {
                    className: `[text-shadow:rgba(0,0,0,0.15)_-1px_1px_10px] text-white font-bold ${vA[i] || ""}`,
                    variant: x.HEADING_5_BOLD,
                    style: {
                      ...(n == null ? void 0 : n.color) && { color: n == null ? void 0 : n.color },
                      ...(n == null ? void 0 : n.fontSize) && {
                        fontSize: n == null ? void 0 : n.fontSize,
                        lineHeight: "normal"
                      },
                      ...(n == null ? void 0 : n.fontWeight) && {
                        fontWeight: n == null ? void 0 : n.fontWeight
                      }
                    },
                    children: n == null ? void 0 : n.label
                  }
                ),
                (a == null ? void 0 : a.label) && /* @__PURE__ */ p(
                  q,
                  {
                    className: `[text-shadow:rgba(0,0,0,0.15)_-1px_1px_10px] text-white whitespace-pre-line ${vA[i] || ""}`,
                    variant: x.LABEL_SMALL_REGULAR,
                    style: {
                      ...(a == null ? void 0 : a.color) && {
                        color: a == null ? void 0 : a.color
                      },
                      ...(a == null ? void 0 : a.fontSize) && {
                        fontSize: a == null ? void 0 : a.fontSize,
                        lineHeight: "normal"
                      },
                      ...(a == null ? void 0 : a.fontWeight) && {
                        fontWeight: a == null ? void 0 : a.fontWeight
                      }
                    },
                    children: a == null ? void 0 : a.label
                  }
                )
              ] }) }) }),
              (z == null ? void 0 : z.length) > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between items-center gap-md w-full flex-wrap", children: I == null ? void 0 : I.map((ee, Y) => {
                var U;
                return /* @__PURE__ */ p("div", { className: `flex flex-wrap flex-shrink gap-md ${ov[(U = ee == null ? void 0 : ee[0]) == null ? void 0 : U.placement] || ""}`, children: ee.map(
                  (Z, te) => Z != null && Z.label ? /* @__PURE__ */ p(
                    Ec,
                    {
                      action: Z,
                      isHovered: g === `${te}_${Gi.BOTTOM}`,
                      onHoverIn: () => _(`${te}_${Gi.BOTTOM}`),
                      onHoverOut: () => _(null)
                    },
                    te
                  ) : null
                ) }, Y);
              }) })
            ] }),
            ((H = S[1]) == null ? void 0 : H.label) && /* @__PURE__ */ p("div", { className: "flex justify-center items-center", children: /* @__PURE__ */ p(
              Ec,
              {
                action: S[1],
                isHovered: g === Ke.MIDDLE_RIGHT,
                onHoverIn: () => _(Ke.MIDDLE_RIGHT),
                onHoverOut: () => _(null)
              }
            ) })
          ]
        }
      )
    ] })
  ] }) });
}, AA = he.memo(Nce), Cce = ({
  onOpenChange: e,
  children: t,
  autoplay: n = !0,
  autoplayInterval: a = 3e3,
  showDots: o = !0,
  loop: i = !0,
  className: c = "",
  classNames: s = {
    dots: ""
  }
}) => {
  var B, z;
  const l = he.Children.toArray(t), [u, h] = ae(0), k = ((z = (B = t == null ? void 0 : t[u]) == null ? void 0 : B.props) == null ? void 0 : z.closable) || !1, f = fe(!1), [y, m] = ae(!1), [g, _] = ae(0), L = fe(null), N = fe(null);
  le(() => {
    const j = () => {
      N.current && _(N.current.offsetWidth);
    };
    return j(), window.addEventListener("resize", j), () => window.removeEventListener("resize", j);
  }, []);
  const I = (j) => {
    LA({
      index: j ?? u + 1,
      setIndex: h,
      containerWidth: g,
      scrollContainerRef: L,
      loop: i,
      items: l
    });
  };
  le(() => {
    let j;
    return n && !y && g > 0 && (j = setInterval(() => {
      I();
    }, typeof a == "function" ? a(u) : a || 3e3)), () => clearInterval(j);
  }, [
    n,
    a,
    u,
    LA,
    y,
    g,
    L == null ? void 0 : L.current,
    i,
    l
  ]);
  const S = (j) => {
    if (f.current && g > 0) {
      const G = j.currentTarget.scrollLeft, $ = Math.round(G / g);
      $ !== u && h($);
    }
  }, O = () => {
    f.current = !0, m(!0);
  }, A = () => {
    setTimeout(() => {
      f.current = !1, m(!1);
    }, 150);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      ref: N,
      className: `relative rounded-xl overflow-hidden flex flex-col grow ${c}`,
      children: [
        k && /* @__PURE__ */ p(
          wt,
          {
            icon: R.CLOSE,
            variant: J.TRANSPARENT,
            size: _e.MEDIUM,
            className: "absolute top-0 right-0 z-50 text-white",
            onClick: () => e(!1)
          }
        ),
        /* @__PURE__ */ p(
          "div",
          {
            ref: L,
            className: "flex overflow-x-auto snap-x snap-mandatory scrollbar-hide grow",
            style: {
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none"
            },
            onScroll: S,
            onTouchStart: O,
            onTouchEnd: A,
            onMouseDown: O,
            onMouseUp: A,
            onMouseLeave: A,
            children: l.map((j, G) => /* @__PURE__ */ p(
              "div",
              {
                className: "flex-shrink-0 w-full snap-center",
                style: { scrollSnapAlign: "center" },
                children: j
              },
              G
            ))
          }
        ),
        o && /* @__PURE__ */ p("div", { className: "absolute bottom-4 left-0 right-0 flex justify-center items-center space-x-2 z-10", children: l.map((j, G) => /* @__PURE__ */ p(
          "button",
          {
            onClick: ($) => {
              $ == null || $.stopPropagation(), I(G);
            },
            className: `h-2 rounded-full transition-all duration-300 ${u === G ? "w-5 bg-white" : "w-2 bg-white/50"} ${s == null ? void 0 : s.dots}`,
            "aria-label": `Go to slide ${G + 1}`
          },
          G
        )) })
      ]
    }
  );
}, wce = he.memo(Cce), Sce = ({ variant: e, onOpenChange: t, data: n }) => {
  if (!(n != null && n.length)) return null;
  if ((n == null ? void 0 : n.length) == 1) {
    const o = n[0], { closable: i } = n[0];
    return /* @__PURE__ */ C("div", { className: "grow rounded-[12px] relative overflow-hidden", children: [
      /* @__PURE__ */ p(AA, { variant: e, ...o }),
      i && /* @__PURE__ */ p(
        wt,
        {
          icon: R.CLOSE,
          variant: J.TRANSPARENT,
          size: _e.MEDIUM,
          className: "absolute top-0 right-0 z-50 text-white",
          onClick: () => t(!1)
        }
      )
    ] });
  }
  return /* @__PURE__ */ p(
    wce,
    {
      autoplay: !0,
      showDots: !0,
      loop: !0,
      onOpenChange: t,
      autoplayInterval: (o) => {
        const i = n[o];
        return xS(i == null ? void 0 : i.transitionTime);
      },
      children: n == null ? void 0 : n.map((o, i) => /* @__PURE__ */ p(AA, { variant: e, ...o }, i))
    }
  );
}, cN = he.memo(Sce), mn = ({
  id: e = "",
  className: t = "",
  children: n,
  to: a,
  onPress: o,
  target: i = "_self",
  ...c
}) => /* @__PURE__ */ p(
  jT,
  {
    id: e,
    onClick: (l) => {
      l == null || l.stopPropagation(), o == null || o();
    },
    className: `no-underline text-inherit flex-shrink-1 flex-grow-0 ${t}`,
    to: a || "#",
    target: i,
    "aria-label": `link-${a}`,
    ...c,
    children: n
  }
), Rce = ({
  title: e = "",
  description: t = "",
  secondaryDescription: n = "",
  actions: a = [],
  defaultOpen: o = !1,
  open: i = void 0,
  onOpenChange: c = () => {
  },
  children: s,
  trigger: l,
  loading: u = !1,
  size: h = pn.SMALL,
  variant: k = ZT.PLAIN,
  hideCloseButton: f,
  verticalButtons: y = !1,
  backdrop: m = "transparent",
  className: g = "",
  classNames: _ = {
    title: "",
    content: "",
    close: "",
    backdrop: "",
    titleInfo: "",
    actions: ""
  },
  dismissable: L = !0,
  closeOnActions: N = !0,
  titleInfo: I = null,
  prevAction: S = null,
  middleAction: O = null,
  nextAction: A = null,
  ...B
}) => {
  const [z, j] = he.useState(o), G = i !== void 0, $ = G ? i : z, H = Q(
    (Y) => {
      !Y && !L || (G || j(Y), c(Y));
    },
    [G, c, L]
  );
  le(() => {
    const Y = document.documentElement.scrollHeight > window.innerHeight, U = window.innerWidth - document.documentElement.clientWidth;
    return Y && $ ? (document.body.style.overflow = "hidden", document.body.style.paddingRight = `${U}px`) : (document.body.style.overflow = "", document.body.style.paddingRight = ""), () => {
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [$]);
  const ee = {
    [pn.XSMALL]: "w-[328px]",
    [pn.SMALL]: "w-[400px] max-w-[90vw] max-h-[600px] [@media(max-height:620px)]:max-h-[90%]",
    [pn.MEDIUM]: "w-full h-full md:h-auto md:max-w-[600px]",
    [pn.LARGE]: "w-[500px] max-h-[700px] [@media(max-height:720px)]:max-h-[90%]",
    [pn.XLARGE]: "w-[800px] max-h-[900px] [@media(max-height:920px)]:max-h-[90%]",
    [pn.FULLSCREEN]: "!size-full max-w-full max-h-full rounded-none",
    [pn.Free]: "w-full max-w-[400px] max-h-unset !p-0 *:!px-0"
  };
  return !$ && !l ? null : sE(
    /* @__PURE__ */ C(at, { children: [
      l && /* @__PURE__ */ p("div", { onClick: () => H(!0), children: l }),
      $ && /* @__PURE__ */ C(at, { children: [
        /* @__PURE__ */ p(
          "div",
          {
            className: P(
              "fixed inset-0 bg-black/30 z-[900000]",
              m === "blur" ? "backdrop-blur-sm" : "",
              _ == null ? void 0 : _.backdrop
            ),
            onClick: () => H(!1)
          }
        ),
        /* @__PURE__ */ C(
          "div",
          {
            className: P(
              "fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
              "z-[900000] max-w-[90vw] bg-white dark:!bg-gray-3 rounded-lg flex flex-col max-h-[600px] py-lg gap-lg",
              ee[h],
              g
            ),
            ...B,
            children: [
              !f && /* @__PURE__ */ p(
                wt,
                {
                  variant: J.OUTLINED,
                  onClick: () => H(!1),
                  icon: R.CLOSE,
                  className: P(
                    "absolute top-lg right-lg z-10",
                    _ == null ? void 0 : _.close
                  )
                }
              ),
              u ? /* @__PURE__ */ p("div", { className: "flex items-center justify-center h-full px-lg", children: /* @__PURE__ */ p(Rn, { size: Ue.MEDIUM }) }) : /* @__PURE__ */ C(at, { children: [
                (e || t || n || S || O || A) && /* @__PURE__ */ C("div", { className: "flex flex-col gap-lg px-lg w-full", children: [
                  (S || O || A) && /* @__PURE__ */ C("div", { className: "flex justify-between", children: [
                    S && /* @__PURE__ */ p("div", { className: "flex justify-start", children: /* @__PURE__ */ p(nt, { ...S }) }),
                    O && /* @__PURE__ */ p("div", { className: "flex justify-center", children: O }),
                    A && /* @__PURE__ */ p("div", { className: "flex justify-end", children: /* @__PURE__ */ p(nt, { ...A }) })
                  ] }),
                  e && /* @__PURE__ */ p(
                    "div",
                    {
                      className: `flex w-full ${f ? "" : "pr-[28px]"}`,
                      children: /* @__PURE__ */ C("div", { className: "flex items-center gap-md", children: [
                        typeof e == "string" ? /* @__PURE__ */ p(
                          q,
                          {
                            variant: x.HEADING_6_BOLD,
                            className: P("grow", _ == null ? void 0 : _.title),
                            children: e
                          }
                        ) : e,
                        typeof I == "string" ? /* @__PURE__ */ p(mn, { to: I, target: "_blank", children: /* @__PURE__ */ p(
                          oe,
                          {
                            icon: R.INFO,
                            size: ye.SMALL,
                            className: P(
                              "text-gray-10",
                              _ == null ? void 0 : _.titleInfo
                            )
                          }
                        ) }) : I
                      ] })
                    }
                  ),
                  (t || n) && /* @__PURE__ */ C("div", { className: P(!f && !e && "pr-7"), children: [
                    t && /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_REGULAR, children: t }),
                    n && /* @__PURE__ */ p(
                      q,
                      {
                        variant: x.LABEL_SMALL_REGULAR,
                        className: "text-gray-10",
                        children: n
                      }
                    )
                  ] })
                ] }),
                s && /* @__PURE__ */ p(
                  "div",
                  {
                    className: P(
                      "overflow-y-auto overflow-x-hidden grow flex flex-col gap-lg px-lg",
                      _ == null ? void 0 : _.content
                    ),
                    children: s
                  }
                ),
                Array.isArray(a) ? a.length > 0 && /* @__PURE__ */ p(
                  "div",
                  {
                    className: P(
                      "flex gap-sm px-lg",
                      y ? "flex-col" : "justify-end",
                      _ == null ? void 0 : _.actions
                    ),
                    children: a.map((Y, U) => {
                      const { className: Z, label: te, ...re } = Y || {};
                      return /* @__PURE__ */ p(
                        nt,
                        {
                          onClick: (ue) => {
                            Y.onPress(ue), N && H(!1);
                          },
                          className: P(
                            y && "w-full",
                            Z
                          ),
                          "aria-label": te,
                          ...re,
                          children: te
                        },
                        U
                      );
                    })
                  }
                ) : a && /* @__PURE__ */ p(
                  "div",
                  {
                    className: P("flex flex-col gap-sm px-lg", _ == null ? void 0 : _.actions),
                    children: a
                  }
                )
              ] })
            ]
          }
        )
      ] })
    ] }),
    document.body
  );
}, Dce = (e) => {
  const { open: t, onOpenChange: n, ...a } = e;
  return /* @__PURE__ */ p(
    Rce,
    {
      open: t,
      onOpenChange: n,
      size: pn.Free,
      hideCloseButton: !0,
      className: "!w-[600px] h-[400px]",
      children: /* @__PURE__ */ p(cN, { ...a, onOpenChange: n })
    }
  );
}, Oce = he.memo(Dce), Pce = (e) => {
  const { variant: t = Y9.TOP } = e;
  return t === Y9.POP_UP ? /* @__PURE__ */ p(Oce, { ...e }) : /* @__PURE__ */ p(cN, { ...e });
}, pge = he.memo(Pce), IA = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/x8AAwMB/6X8nXkAAAAASUVORK5CYII=", Hce = (e) => e === Yt.TopStart || e === Yt.BottomStart, Bce = ({
  triggerRect: e,
  placement: t,
  dropdownWidth: n,
  viewportWidth: a
}) => {
  const o = Math.max(ic, a - n - ic);
  return Hce(t) ? { left: Math.min(e.left, o) } : { right: Math.min(a - e.right, o) };
}, Fce = ({
  triggerRect: e,
  placement: t,
  dropdownWidth: n,
  dropdownHeight: a,
  viewportWidth: o,
  viewportHeight: i
}) => {
  const c = Bce({ triggerRect: e, placement: t, dropdownWidth: n, viewportWidth: o }), s = o - 2 * ic, { side: l } = rN({ triggerRect: e, placement: t, dropdownHeight: a, viewportHeight: i });
  return l === "top" ? {
    bottom: i - e.top + Z9,
    ...c,
    maxWidth: s
  } : {
    top: e.bottom + Z9,
    ...c,
    maxWidth: s
  };
}, $ce = ({
  children: e,
  listItems: t,
  placement: n = Yt.BottomEnd,
  isOpen: a,
  onOpenChange: o,
  className: i,
  classNames: c,
  closeMenuOnSelect: s = !0,
  DropDownMenuStyles: l,
  isListLoading: u = !1,
  isPortaled: h = !1
}) => {
  const [k, f] = ae(null), { isDropdownOpen: y, handleOpenChange: m, containerRef: g, dropdownRef: _, dropdownNode: L, maxHeight: N, maxWidth: I } = iN({
    isOpen: a,
    onOpenChange: o,
    closeOnClickOutside: !0,
    closeOnScroll: s,
    closeOnAncestorScroll: h,
    placement: n,
    isPortaled: h
  });
  Sn(() => {
    if (!h || !y) {
      f(null);
      return;
    }
    const A = () => {
      const B = g.current;
      B !== null && f(
        Fce({
          triggerRect: B.getBoundingClientRect(),
          placement: n,
          dropdownWidth: (L == null ? void 0 : L.scrollWidth) ?? 0,
          // Drives the flip to the opposite side when the preferred one cannot fit the panel.
          dropdownHeight: (L == null ? void 0 : L.offsetHeight) ?? 0,
          viewportWidth: window.innerWidth,
          viewportHeight: window.innerHeight
        })
      );
    };
    return A(), window.addEventListener("resize", A), window.addEventListener("scroll", A, !0), () => {
      window.removeEventListener("resize", A), window.removeEventListener("scroll", A, !0);
    };
  }, [g, L, y, h, n]);
  const O = y ? /* @__PURE__ */ C(
    "div",
    {
      ref: _,
      className: P(
        "w-max bg-white dark:bg-gray-5 rounded-[10px] border border-gray-4 py-sm",
        // Portaled panels are siblings of whatever opened them under document.body, so they need to clear
        // the tallest thing that can host a menu: Modal sits at z-[900000], and a dropdown opened from
        // inside the image modal's sidebar would otherwise render behind its opaque panel. Matches the
        // value Tooltip already uses for the same reason.
        h ? "fixed z-[1000000]" : P("absolute z-[100]", (() => {
          switch (n) {
            case Yt.BottomStart:
              return "-left-24 top-full mt-1";
            case Yt.BottomEnd:
              return "right-0 top-full mt-1";
            case Yt.TopStart:
              return "left-0 bottom-full mb-1";
            case Yt.TopEnd:
              return "right-0 bottom-full mb-1";
            default:
              return "left-0 top-full mt-1";
          }
        })()),
        N !== void 0 && "overflow-y-auto",
        I !== void 0 && "overflow-x-hidden",
        i
      ),
      style: {
        boxShadow: "0px 6px 24px 0px rgba(0, 0, 0, 0.18)",
        maxHeight: N,
        maxWidth: I,
        ...h && k === null ? { visibility: "hidden" } : {},
        ...h && k !== null ? k : {},
        ...l
      },
      children: [
        u ? /* @__PURE__ */ p("div", { className: "flex items-center justify-center px-lg py-md min-w-[120px]", children: /* @__PURE__ */ p(Rn, { size: Ue.MEDIUM }) }) : null,
        !u && t.map((A) => {
          const {
            className: B,
            classNames: z,
            label: j,
            description: G,
            icon: $,
            onPress: H,
            isHidden: ee,
            isDisabled: Y,
            divider: U,
            to: Z,
            replace: te,
            target: re = "_self",
            text: ue,
            heading: E,
            loading: ve,
            type: be = "button",
            value: T
          } = A || {};
          return ee ? null : /* @__PURE__ */ C(
            Z ? mn : "button",
            {
              type: be,
              to: Z,
              replace: te,
              target: re,
              value: T,
              "data-testid": A.dataTestId,
              onClick: (ht) => {
                ht.stopPropagation(), s && m(!1), H == null || H();
              },
              disabled: Y,
              className: P(
                "w-full px-lg flex items-center gap-lg text-left",
                E ? "bg-gray-2 dark:bg-gray-4 text-gray-8 dark:text-gray-10 py-1" : "bg-transparent text-black dark:text-white py-md",
                (U === Vi.Top || U === Vi.Both) && "border-0 border-t border-solid border-gray-8",
                (U === Vi.Bottom || U === Vi.Both) && "border-0 border-b border-solid border-gray-8",
                Y ? "opacity-50 cursor-not-allowed" : !E && "hover:bg-gray-6 cursor-pointer",
                B,
                z == null ? void 0 : z.base
              ),
              "aria-label": j,
              children: [
                ve ? /* @__PURE__ */ p(Rn, {}) : null,
                !ve && $ ? /* @__PURE__ */ p(oe, { icon: $, className: P(c == null ? void 0 : c.itemsIcon, z == null ? void 0 : z.icon) }) : null,
                /* @__PURE__ */ C("div", { className: "flex flex-col gap-1 flex-1", children: [
                  /* @__PURE__ */ p(
                    q,
                    {
                      variant: E ? x.LABEL_MEDIUM_MEDIUM : x.PARAGRAPH_MEDIUM_REGULAR,
                      className: P("whitespace-nowrap", c == null ? void 0 : c.itemsLabel, z == null ? void 0 : z.label),
                      children: ue || j
                    }
                  ),
                  G ? /* @__PURE__ */ p(
                    q,
                    {
                      variant: x.PARAGRAPH_SMALL_REGULAR,
                      className: P("text-gray-8 dark:text-gray-10 w-0 min-w-full", c == null ? void 0 : c.itemsDescription, z == null ? void 0 : z.description),
                      children: G
                    }
                  ) : null
                ] })
              ]
            },
            j
          );
        })
      ]
    }
  ) : null;
  return /* @__PURE__ */ C("div", { ref: g, className: "relative", children: [
    /* @__PURE__ */ p(
      "div",
      {
        onClick: (A) => {
          A.preventDefault(), A.stopPropagation(), m(!y);
        },
        children: e
      }
    ),
    h && O !== null ? sE(O, document.body) : O
  ] });
}, lE = he.memo($ce), TA = ({ lorebookAttached: e, lorebookLabel: t }) => e ? /* @__PURE__ */ p(
  "span",
  {
    role: "img",
    "aria-label": "lorebook",
    title: t,
    className: "inline-flex h-[15px] w-fit items-center rounded bg-yellow-8 px-1 text-white",
    children: /* @__PURE__ */ p(oe, { icon: R.BOOK_TEXT, size: ye.XSMALL })
  }
) : null, fi = Math.min, j1 = Math.max, Q9 = Math.round, vc = Math.floor, gn = (e) => ({
  x: e,
  y: e
}), Uce = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function rv(e, t, n) {
  return j1(e, fi(t, n));
}
function yc(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function X1(e) {
  return e.split("-")[0];
}
function kc(e) {
  return e.split("-")[1];
}
function sN(e) {
  return e === "x" ? "y" : "x";
}
function Fv(e) {
  return e === "y" ? "height" : "width";
}
function Gn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function $v(e) {
  return sN(Gn(e));
}
function qce(e, t, n) {
  n === void 0 && (n = !1);
  const a = kc(e), o = $v(e), i = Fv(o);
  let c = o === "x" ? a === (n ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (c = J9(c)), [c, J9(c)];
}
function zce(e) {
  const t = J9(e);
  return [iv(e), t, iv(t)];
}
function iv(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const NA = ["left", "right"], CA = ["right", "left"], jce = ["top", "bottom"], Vce = ["bottom", "top"];
function Gce(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? CA : NA : t ? NA : CA;
    case "left":
    case "right":
      return t ? jce : Vce;
    default:
      return [];
  }
}
function Wce(e, t, n, a) {
  const o = kc(e);
  let i = Gce(X1(e), n === "start", a);
  return o && (i = i.map((c) => c + "-" + o), t && (i = i.concat(i.map(iv)))), i;
}
function J9(e) {
  const t = X1(e);
  return Uce[t] + e.slice(t.length);
}
function Xce(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function lN(e) {
  return typeof e != "number" ? Xce(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function eE(e) {
  const {
    x: t,
    y: n,
    width: a,
    height: o
  } = e;
  return {
    width: a,
    height: o,
    top: n,
    left: t,
    right: t + a,
    bottom: n + o,
    x: t,
    y: n
  };
}
function wA(e, t, n) {
  let {
    reference: a,
    floating: o
  } = e;
  const i = Gn(t), c = $v(t), s = Fv(c), l = X1(t), u = i === "y", h = a.x + a.width / 2 - o.width / 2, k = a.y + a.height / 2 - o.height / 2, f = a[s] / 2 - o[s] / 2;
  let y;
  switch (l) {
    case "top":
      y = {
        x: h,
        y: a.y - o.height
      };
      break;
    case "bottom":
      y = {
        x: h,
        y: a.y + a.height
      };
      break;
    case "right":
      y = {
        x: a.x + a.width,
        y: k
      };
      break;
    case "left":
      y = {
        x: a.x - o.width,
        y: k
      };
      break;
    default:
      y = {
        x: a.x,
        y: a.y
      };
  }
  switch (kc(t)) {
    case "start":
      y[c] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      y[c] += f * (n && u ? -1 : 1);
      break;
  }
  return y;
}
async function Yce(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: a,
    y: o,
    platform: i,
    rects: c,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: k = "floating",
    altBoundary: f = !1,
    padding: y = 0
  } = yc(t, e), m = lN(y), _ = s[f ? k === "floating" ? "reference" : "floating" : k], L = eE(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(_))) == null || n ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: h,
    strategy: l
  })), N = k === "floating" ? {
    x: a,
    y: o,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, I = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), S = await (i.isElement == null ? void 0 : i.isElement(I)) ? await (i.getScale == null ? void 0 : i.getScale(I)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = eE(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: N,
    offsetParent: I,
    strategy: l
  }) : N);
  return {
    top: (L.top - O.top + m.top) / S.y,
    bottom: (O.bottom - L.bottom + m.bottom) / S.y,
    left: (L.left - O.left + m.left) / S.x,
    right: (O.right - L.right + m.right) / S.x
  };
}
const Kce = 50, Zce = async (e, t, n) => {
  const {
    placement: a = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: c
  } = n, s = c.detectOverflow ? c : {
    ...c,
    detectOverflow: Yce
  }, l = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let u = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: h,
    y: k
  } = wA(u, a, l), f = a, y = 0;
  const m = {};
  for (let g = 0; g < i.length; g++) {
    const _ = i[g];
    if (!_)
      continue;
    const {
      name: L,
      fn: N
    } = _, {
      x: I,
      y: S,
      data: O,
      reset: A
    } = await N({
      x: h,
      y: k,
      initialPlacement: a,
      placement: f,
      strategy: o,
      middlewareData: m,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    h = I ?? h, k = S ?? k, m[L] = {
      ...m[L],
      ...O
    }, A && y < Kce && (y++, typeof A == "object" && (A.placement && (f = A.placement), A.rects && (u = A.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: h,
      y: k
    } = wA(u, f, l)), g = -1);
  }
  return {
    x: h,
    y: k,
    placement: f,
    strategy: o,
    middlewareData: m
  };
}, Qce = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: a,
      placement: o,
      rects: i,
      platform: c,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: h = 0
    } = yc(e, t) || {};
    if (u == null)
      return {};
    const k = lN(h), f = {
      x: n,
      y: a
    }, y = $v(o), m = Fv(y), g = await c.getDimensions(u), _ = y === "y", L = _ ? "top" : "left", N = _ ? "bottom" : "right", I = _ ? "clientHeight" : "clientWidth", S = i.reference[m] + i.reference[y] - f[y] - i.floating[m], O = f[y] - i.reference[y], A = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(u));
    let B = A ? A[I] : 0;
    (!B || !await (c.isElement == null ? void 0 : c.isElement(A))) && (B = s.floating[I] || i.floating[m]);
    const z = S / 2 - O / 2, j = B / 2 - g[m] / 2 - 1, G = fi(k[L], j), $ = fi(k[N], j), H = G, ee = B - g[m] - $, Y = B / 2 - g[m] / 2 + z, U = rv(H, Y, ee), Z = !l.arrow && kc(o) != null && Y !== U && i.reference[m] / 2 - (Y < H ? G : $) - g[m] / 2 < 0, te = Z ? Y < H ? Y - H : Y - ee : 0;
    return {
      [y]: f[y] + te,
      data: {
        [y]: U,
        centerOffset: Y - U - te,
        ...Z && {
          alignmentOffset: te
        }
      },
      reset: Z
    };
  }
}), Jce = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, a;
      const {
        placement: o,
        middlewareData: i,
        rects: c,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: h = !0,
        crossAxis: k = !0,
        fallbackPlacements: f,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ..._
      } = yc(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const L = X1(o), N = Gn(s), I = X1(s) === s, S = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), O = f || (I || !g ? [J9(s)] : zce(s)), A = m !== "none";
      !f && A && O.push(...Wce(s, g, m, S));
      const B = [s, ...O], z = await l.detectOverflow(t, _), j = [];
      let G = ((a = i.flip) == null ? void 0 : a.overflows) || [];
      if (h && j.push(z[L]), k) {
        const Y = qce(o, c, S);
        j.push(z[Y[0]], z[Y[1]]);
      }
      if (G = [...G, {
        placement: o,
        overflows: j
      }], !j.every((Y) => Y <= 0)) {
        var $, H;
        const Y = ((($ = i.flip) == null ? void 0 : $.index) || 0) + 1, U = B[Y];
        if (U && (!(k === "alignment" ? N !== Gn(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        G.every((re) => Gn(re.placement) === N ? re.overflows[0] > 0 : !0)))
          return {
            data: {
              index: Y,
              overflows: G
            },
            reset: {
              placement: U
            }
          };
        let Z = (H = G.filter((te) => te.overflows[0] <= 0).sort((te, re) => te.overflows[1] - re.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!Z)
          switch (y) {
            case "bestFit": {
              var ee;
              const te = (ee = G.filter((re) => {
                if (A) {
                  const ue = Gn(re.placement);
                  return ue === N || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ue === "y";
                }
                return !0;
              }).map((re) => [re.placement, re.overflows.filter((ue) => ue > 0).reduce((ue, E) => ue + E, 0)]).sort((re, ue) => re[1] - ue[1])[0]) == null ? void 0 : ee[0];
              te && (Z = te);
              break;
            }
            case "initialPlacement":
              Z = s;
              break;
          }
        if (o !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
}, ese = /* @__PURE__ */ new Set(["left", "top"]);
async function tse(e, t) {
  const {
    placement: n,
    platform: a,
    elements: o
  } = e, i = await (a.isRTL == null ? void 0 : a.isRTL(o.floating)), c = X1(n), s = kc(n), l = Gn(n) === "y", u = ese.has(c) ? -1 : 1, h = i && l ? -1 : 1, k = yc(t, e);
  let {
    mainAxis: f,
    crossAxis: y,
    alignmentAxis: m
  } = typeof k == "number" ? {
    mainAxis: k,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: k.mainAxis || 0,
    crossAxis: k.crossAxis || 0,
    alignmentAxis: k.alignmentAxis
  };
  return s && typeof m == "number" && (y = s === "end" ? m * -1 : m), l ? {
    x: y * h,
    y: f * u
  } : {
    x: f * u,
    y: y * h
  };
}
const nse = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, a;
      const {
        x: o,
        y: i,
        placement: c,
        middlewareData: s
      } = t, l = await tse(t, e);
      return c === ((n = s.offset) == null ? void 0 : n.placement) && (a = s.arrow) != null && a.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: c
        }
      };
    }
  };
}, ase = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: a,
        placement: o,
        platform: i
      } = t, {
        mainAxis: c = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (L) => {
            let {
              x: N,
              y: I
            } = L;
            return {
              x: N,
              y: I
            };
          }
        },
        ...u
      } = yc(e, t), h = {
        x: n,
        y: a
      }, k = await i.detectOverflow(t, u), f = Gn(X1(o)), y = sN(f);
      let m = h[y], g = h[f];
      if (c) {
        const L = y === "y" ? "top" : "left", N = y === "y" ? "bottom" : "right", I = m + k[L], S = m - k[N];
        m = rv(I, m, S);
      }
      if (s) {
        const L = f === "y" ? "top" : "left", N = f === "y" ? "bottom" : "right", I = g + k[L], S = g - k[N];
        g = rv(I, g, S);
      }
      const _ = l.fn({
        ...t,
        [y]: m,
        [f]: g
      });
      return {
        ..._,
        data: {
          x: _.x - n,
          y: _.y - a,
          enabled: {
            [y]: c,
            [f]: s
          }
        }
      };
    }
  };
};
function dE() {
  return typeof window < "u";
}
function Li(e) {
  return dN(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $t(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function _n(e) {
  var t;
  return (t = (dN(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function dN(e) {
  return dE() ? e instanceof Node || e instanceof $t(e).Node : !1;
}
function an(e) {
  return dE() ? e instanceof Element || e instanceof $t(e).Element : !1;
}
function On(e) {
  return dE() ? e instanceof HTMLElement || e instanceof $t(e).HTMLElement : !1;
}
function SA(e) {
  return !dE() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof $t(e).ShadowRoot;
}
function fc(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: a,
    display: o
  } = on(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + n) && o !== "inline" && o !== "contents";
}
function ose(e) {
  return /^(table|td|th)$/.test(Li(e));
}
function uE(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const rse = /transform|translate|scale|rotate|perspective|filter/, ise = /paint|layout|strict|content/, ta = (e) => !!e && e !== "none";
let OE;
function Uv(e) {
  const t = an(e) ? on(e) : e;
  return ta(t.transform) || ta(t.translate) || ta(t.scale) || ta(t.rotate) || ta(t.perspective) || !qv() && (ta(t.backdropFilter) || ta(t.filter)) || rse.test(t.willChange || "") || ise.test(t.contain || "");
}
function cse(e) {
  let t = Kn(e);
  for (; On(t) && !mi(t); ) {
    if (Uv(t))
      return t;
    if (uE(t))
      return null;
    t = Kn(t);
  }
  return null;
}
function qv() {
  return OE == null && (OE = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), OE;
}
function mi(e) {
  return /^(html|body|#document)$/.test(Li(e));
}
function on(e) {
  return $t(e).getComputedStyle(e);
}
function hE(e) {
  return an(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Kn(e) {
  if (Li(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    SA(e) && e.host || // Fallback.
    _n(e)
  );
  return SA(t) ? t.host : t;
}
function uN(e) {
  const t = Kn(e);
  return mi(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : On(t) && fc(t) ? t : uN(t);
}
function cc(e, t, n) {
  var a;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = uN(e), i = o === ((a = e.ownerDocument) == null ? void 0 : a.body), c = $t(o);
  if (i) {
    const s = cv(c);
    return t.concat(c, c.visualViewport || [], fc(o) ? o : [], s && n ? cc(s) : []);
  } else
    return t.concat(o, cc(o, [], n));
}
function cv(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hN(e) {
  const t = on(e);
  let n = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const o = On(e), i = o ? e.offsetWidth : n, c = o ? e.offsetHeight : a, s = Q9(n) !== i || Q9(a) !== c;
  return s && (n = i, a = c), {
    width: n,
    height: a,
    $: s
  };
}
function zv(e) {
  return an(e) ? e : e.contextElement;
}
function ui(e) {
  const t = zv(e);
  if (!On(t))
    return gn(1);
  const n = t.getBoundingClientRect(), {
    width: a,
    height: o,
    $: i
  } = hN(t);
  let c = (i ? Q9(n.width) : n.width) / a, s = (i ? Q9(n.height) : n.height) / o;
  return (!c || !Number.isFinite(c)) && (c = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: c,
    y: s
  };
}
const sse = /* @__PURE__ */ gn(0);
function pN(e) {
  const t = $t(e);
  return !qv() || !t.visualViewport ? sse : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function lse(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== $t(e) ? !1 : t;
}
function Y1(e, t, n, a) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = zv(e);
  let c = gn(1);
  t && (a ? an(a) && (c = ui(a)) : c = ui(e));
  const s = lse(i, n, a) ? pN(i) : gn(0);
  let l = (o.left + s.x) / c.x, u = (o.top + s.y) / c.y, h = o.width / c.x, k = o.height / c.y;
  if (i) {
    const f = $t(i), y = a && an(a) ? $t(a) : a;
    let m = f, g = cv(m);
    for (; g && a && y !== m; ) {
      const _ = ui(g), L = g.getBoundingClientRect(), N = on(g), I = L.left + (g.clientLeft + parseFloat(N.paddingLeft)) * _.x, S = L.top + (g.clientTop + parseFloat(N.paddingTop)) * _.y;
      l *= _.x, u *= _.y, h *= _.x, k *= _.y, l += I, u += S, m = $t(g), g = cv(m);
    }
  }
  return eE({
    width: h,
    height: k,
    x: l,
    y: u
  });
}
function pE(e, t) {
  const n = hE(e).scrollLeft;
  return t ? t.left + n : Y1(_n(e)).left + n;
}
function yN(e, t) {
  const n = e.getBoundingClientRect(), a = n.left + t.scrollLeft - pE(e, n), o = n.top + t.scrollTop;
  return {
    x: a,
    y: o
  };
}
function dse(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: a,
    strategy: o
  } = e;
  const i = o === "fixed", c = _n(a), s = t ? uE(t.floating) : !1;
  if (a === c || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = gn(1);
  const h = gn(0), k = On(a);
  if ((k || !k && !i) && ((Li(a) !== "body" || fc(c)) && (l = hE(a)), k)) {
    const y = Y1(a);
    u = ui(a), h.x = y.x + a.clientLeft, h.y = y.y + a.clientTop;
  }
  const f = c && !k && !i ? yN(c, l) : gn(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + h.x + f.x,
    y: n.y * u.y - l.scrollTop * u.y + h.y + f.y
  };
}
function use(e) {
  return Array.from(e.getClientRects());
}
function hse(e) {
  const t = _n(e), n = hE(e), a = e.ownerDocument.body, o = j1(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), i = j1(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let c = -n.scrollLeft + pE(e);
  const s = -n.scrollTop;
  return on(a).direction === "rtl" && (c += j1(t.clientWidth, a.clientWidth) - o), {
    width: o,
    height: i,
    x: c,
    y: s
  };
}
const RA = 25;
function pse(e, t) {
  const n = $t(e), a = _n(e), o = n.visualViewport;
  let i = a.clientWidth, c = a.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, c = o.height;
    const h = qv();
    (!h || h && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  const u = pE(a);
  if (u <= 0) {
    const h = a.ownerDocument, k = h.body, f = getComputedStyle(k), y = h.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, m = Math.abs(a.clientWidth - k.clientWidth - y);
    m <= RA && (i -= m);
  } else u <= RA && (i += u);
  return {
    width: i,
    height: c,
    x: s,
    y: l
  };
}
function yse(e, t) {
  const n = Y1(e, !0, t === "fixed"), a = n.top + e.clientTop, o = n.left + e.clientLeft, i = On(e) ? ui(e) : gn(1), c = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, u = a * i.y;
  return {
    width: c,
    height: s,
    x: l,
    y: u
  };
}
function DA(e, t, n) {
  let a;
  if (t === "viewport")
    a = pse(e, n);
  else if (t === "document")
    a = hse(_n(e));
  else if (an(t))
    a = yse(t, n);
  else {
    const o = pN(e);
    a = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return eE(a);
}
function kN(e, t) {
  const n = Kn(e);
  return n === t || !an(n) || mi(n) ? !1 : on(n).position === "fixed" || kN(n, t);
}
function kse(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let a = cc(e, [], !1).filter((s) => an(s) && Li(s) !== "body"), o = null;
  const i = on(e).position === "fixed";
  let c = i ? Kn(e) : e;
  for (; an(c) && !mi(c); ) {
    const s = on(c), l = Uv(c);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || fc(c) && !l && kN(e, c)) ? a = a.filter((h) => h !== c) : o = s, c = Kn(c);
  }
  return t.set(e, a), a;
}
function fse(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: a,
    strategy: o
  } = e;
  const c = [...n === "clippingAncestors" ? uE(t) ? [] : kse(t, this._c) : [].concat(n), a], s = DA(t, c[0], o);
  let l = s.top, u = s.right, h = s.bottom, k = s.left;
  for (let f = 1; f < c.length; f++) {
    const y = DA(t, c[f], o);
    l = j1(y.top, l), u = fi(y.right, u), h = fi(y.bottom, h), k = j1(y.left, k);
  }
  return {
    width: u - k,
    height: h - l,
    x: k,
    y: l
  };
}
function mse(e) {
  const {
    width: t,
    height: n
  } = hN(e);
  return {
    width: t,
    height: n
  };
}
function gse(e, t, n) {
  const a = On(t), o = _n(t), i = n === "fixed", c = Y1(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = gn(0);
  function u() {
    l.x = pE(o);
  }
  if (a || !a && !i)
    if ((Li(t) !== "body" || fc(o)) && (s = hE(t)), a) {
      const y = Y1(t, !0, i, t);
      l.x = y.x + t.clientLeft, l.y = y.y + t.clientTop;
    } else o && u();
  i && !a && o && u();
  const h = o && !a && !i ? yN(o, s) : gn(0), k = c.left + s.scrollLeft - l.x - h.x, f = c.top + s.scrollTop - l.y - h.y;
  return {
    x: k,
    y: f,
    width: c.width,
    height: c.height
  };
}
function PE(e) {
  return on(e).position === "static";
}
function OA(e, t) {
  if (!On(e) || on(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return _n(e) === n && (n = n.ownerDocument.body), n;
}
function fN(e, t) {
  const n = $t(e);
  if (uE(e))
    return n;
  if (!On(e)) {
    let o = Kn(e);
    for (; o && !mi(o); ) {
      if (an(o) && !PE(o))
        return o;
      o = Kn(o);
    }
    return n;
  }
  let a = OA(e, t);
  for (; a && ose(a) && PE(a); )
    a = OA(a, t);
  return a && mi(a) && PE(a) && !Uv(a) ? n : a || cse(e) || n;
}
const Mse = async function(e) {
  const t = this.getOffsetParent || fN, n = this.getDimensions, a = await n(e.floating);
  return {
    reference: gse(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function _se(e) {
  return on(e).direction === "rtl";
}
const bse = {
  convertOffsetParentRelativeRectToViewportRelativeRect: dse,
  getDocumentElement: _n,
  getClippingRect: fse,
  getOffsetParent: fN,
  getElementRects: Mse,
  getClientRects: use,
  getDimensions: mse,
  getScale: ui,
  isElement: an,
  isRTL: _se
};
function mN(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Lse(e, t) {
  let n = null, a;
  const o = _n(e);
  function i() {
    var s;
    clearTimeout(a), (s = n) == null || s.disconnect(), n = null;
  }
  function c(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const u = e.getBoundingClientRect(), {
      left: h,
      top: k,
      width: f,
      height: y
    } = u;
    if (s || t(), !f || !y)
      return;
    const m = vc(k), g = vc(o.clientWidth - (h + f)), _ = vc(o.clientHeight - (k + y)), L = vc(h), I = {
      rootMargin: -m + "px " + -g + "px " + -_ + "px " + -L + "px",
      threshold: j1(0, fi(1, l)) || 1
    };
    let S = !0;
    function O(A) {
      const B = A[0].intersectionRatio;
      if (B !== l) {
        if (!S)
          return c();
        B ? c(!1, B) : a = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      B === 1 && !mN(u, e.getBoundingClientRect()) && c(), S = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...I,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, I);
    }
    n.observe(e);
  }
  return c(!0), i;
}
function xse(e, t, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = a, u = zv(e), h = o || i ? [...u ? cc(u) : [], ...t ? cc(t) : []] : [];
  h.forEach((L) => {
    o && L.addEventListener("scroll", n, {
      passive: !0
    }), i && L.addEventListener("resize", n);
  });
  const k = u && s ? Lse(u, n) : null;
  let f = -1, y = null;
  c && (y = new ResizeObserver((L) => {
    let [N] = L;
    N && N.target === u && y && t && (y.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var I;
      (I = y) == null || I.observe(t);
    })), n();
  }), u && !l && y.observe(u), t && y.observe(t));
  let m, g = l ? Y1(e) : null;
  l && _();
  function _() {
    const L = Y1(e);
    g && !mN(g, L) && n(), g = L, m = requestAnimationFrame(_);
  }
  return n(), () => {
    var L;
    h.forEach((N) => {
      o && N.removeEventListener("scroll", n), i && N.removeEventListener("resize", n);
    }), k == null || k(), (L = y) == null || L.disconnect(), y = null, l && cancelAnimationFrame(m);
  };
}
const Ese = nse, vse = ase, Ase = Jce, Ise = Qce, PA = (e, t, n) => {
  const a = /* @__PURE__ */ new Map(), o = {
    platform: bse,
    ...n
  }, i = {
    ...o.platform,
    _c: a
  };
  return Zce(e, t, {
    ...o,
    platform: i
  });
};
var Wn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gN = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", c = 0; c < arguments.length; c++) {
        var s = arguments[c];
        s && (i = o(i, a(s)));
      }
      return i;
    }
    function a(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var c = "";
      for (var s in i)
        t.call(i, s) && i[s] && (c = o(c, s));
      return c;
    }
    function o(i, c) {
      return c ? i ? i + " " + c : i + c : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(gN);
var Tse = gN.exports;
const j9 = /* @__PURE__ */ yE(Tse);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const Nse = "react-tooltip-core-styles", Cse = "react-tooltip-base-styles", HA = { core: !1, base: !1 };
function BA({ css: e, id: t = Cse, type: n = "base", ref: a }) {
  var o, i;
  if (!e || typeof document > "u" || HA[n] || n === "core" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = Nse), a || (a = {});
  const { insertAt: c } = a;
  if (document.getElementById(t)) return;
  const s = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = t, l.type = "text/css", c === "top" && s.firstChild ? s.insertBefore(l, s.firstChild) : s.appendChild(l), l.styleSheet ? l.styleSheet.cssText = e : l.appendChild(document.createTextNode(e)), HA[n] = !0;
}
const FA = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: a = "top", offset: o = 10, strategy: i = "absolute", middlewares: c = [Ese(Number(o)), Ase({ fallbackAxisSideDirection: "start" }), vse({ padding: 5 })], border: s, arrowSize: l = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: a };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: a };
  const u = c;
  return n ? (u.push(Ise({ element: n, padding: 5 })), PA(e, t, { placement: a, strategy: i, middleware: u }).then(({ x: h, y: k, placement: f, middlewareData: y }) => {
    var m, g;
    const _ = { left: `${h}px`, top: `${k}px`, border: s }, { x: L, y: N } = (m = y.arrow) !== null && m !== void 0 ? m : { x: 0, y: 0 }, I = (g = { top: "bottom", right: "left", bottom: "top", left: "right" }[f.split("-")[0]]) !== null && g !== void 0 ? g : "bottom", S = s && { borderBottom: s, borderRight: s };
    let O = 0;
    if (s) {
      const A = `${s}`.match(/(\d+)px/);
      O = A != null && A[1] ? Number(A[1]) : 1;
    }
    return { tooltipStyles: _, tooltipArrowStyles: { left: L != null ? `${L}px` : "", top: N != null ? `${N}px` : "", right: "", bottom: "", ...S, [I]: `-${l / 2 + O - 1}px` }, place: f };
  })) : PA(e, t, { placement: "bottom", strategy: i, middleware: u }).then(({ x: h, y: k, placement: f }) => ({ tooltipStyles: { left: `${h}px`, top: `${k}px` }, tooltipArrowStyles: {}, place: f }));
}, $A = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), UA = (e, t, n) => {
  let a = null;
  const o = function(...i) {
    const c = () => {
      a = null;
    };
    !a && (e.apply(this, i), a = setTimeout(c, t));
  };
  return o.cancel = () => {
    a && (clearTimeout(a), a = null);
  }, o;
}, qA = (e) => e !== null && !Array.isArray(e) && typeof e == "object", sv = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((o, i) => sv(o, t[i]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!qA(e) || !qA(t)) return e === t;
  const n = Object.keys(e), a = Object.keys(t);
  return n.length === a.length && n.every((o) => sv(e[o], t[o]));
}, wse = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const a = t.getPropertyValue(n);
    return a === "auto" || a === "scroll";
  });
}, zA = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (wse(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Sse = typeof window < "u" ? Sn : le, zt = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, Rse = "DEFAULT_TOOLTIP_ID", Dse = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, Ose = Ov({ getTooltipData: () => Dse });
function MN(e = Rse) {
  return Dv(Ose).getTooltipData(e);
}
var na = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", content: "core-styles-module_content__BRKdB", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Ac = { tooltip: "styles-module_tooltip__mnnfp", content: "styles-module_content__ydYdI", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const Pse = ({ forwardRef: e, id: t, className: n, classNameArrow: a, variant: o = "dark", anchorId: i, anchorSelect: c, place: s = "top", offset: l = 10, events: u = ["hover"], openOnClick: h = !1, positionStrategy: k = "absolute", middlewares: f, wrapper: y, delayShow: m = 0, delayHide: g = 0, float: _ = !1, hidden: L = !1, noArrow: N = !1, clickable: I = !1, closeOnEsc: S = !1, closeOnScroll: O = !1, closeOnResize: A = !1, openEvents: B, closeEvents: z, globalCloseEvents: j, imperativeModeOnly: G, style: $, position: H, afterShow: ee, afterHide: Y, disableTooltip: U, content: Z, contentWrapperRef: te, isOpen: re, defaultIsOpen: ue = !1, setIsOpen: E, previousActiveAnchor: ve, activeAnchor: be, setActiveAnchor: T, border: Xe, opacity: ht, arrowColor: qe, arrowSize: vt = 8, role: At = "tooltip" }) => {
  var ot;
  const Ge = fe(null), Rt = fe(null), pt = fe(null), Ut = fe(null), Zt = fe(null), [Dt, cn] = ae({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [et, Qt] = ae(!1), [Jt, Ot] = ae(!1), [Oe, sn] = ae(null), Pn = fe(!1), en = fe(null), { anchorRefs: Ln, setActiveAnchor: F } = MN(t), K = fe(!1), [ie, ke] = ae([]), Le = fe(!1), Ye = h || u.includes("click"), _t = Ye || (B == null ? void 0 : B.click) || (B == null ? void 0 : B.dblclick) || (B == null ? void 0 : B.mousedown), rt = B ? { ...B } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !B && Ye && Object.assign(rt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const yt = z ? { ...z } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !z && Ye && Object.assign(yt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const He = j ? { ...j } : { escape: S || !1, scroll: O || !1, resize: A || !1, clickOutsideAnchor: _t || !1 };
  G && (Object.assign(rt, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(yt, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(He, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), Sse(() => (Le.current = !0, () => {
    Le.current = !1;
  }), []);
  const Te = (ne) => {
    Le.current && (ne && Ot(!0), setTimeout(() => {
      Le.current && (E == null || E(ne), re === void 0 && Qt(ne));
    }, 10));
  };
  le(() => {
    if (t) {
      if (et) {
        de(ve);
        const se = ne(be), De = [.../* @__PURE__ */ new Set([...se, t])].filter(Boolean).join(" ");
        be == null || be.setAttribute("aria-describedby", De);
      } else de(be);
      return () => {
        de(be), de(ve);
      };
    }
    function ne(se) {
      var De;
      return ((De = se == null ? void 0 : se.getAttribute("aria-describedby")) === null || De === void 0 ? void 0 : De.split(" ")) || [];
    }
    function de(se) {
      const De = ne(se).filter((ct) => ct !== t);
      De.length ? se == null || se.setAttribute("aria-describedby", De.join(" ")) : se == null || se.removeAttribute("aria-describedby");
    }
  }, [be, et, t, ve]), le(() => {
    if (re === void 0) return () => null;
    re && Ot(!0);
    const ne = setTimeout(() => {
      Qt(re);
    }, 10);
    return () => {
      clearTimeout(ne);
    };
  }, [re]), le(() => {
    if (et !== Pn.current) if (zt(Zt), Pn.current = et, et) ee == null || ee();
    else {
      const ne = ((de) => {
        const se = de.match(/^([\d.]+)(ms|s)$/);
        if (!se) return 0;
        const [, De, ct] = se;
        return Number(De) * (ct === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Zt.current = setTimeout(() => {
        Ot(!1), sn(null), Y == null || Y();
      }, ne + 25);
    }
  }, [et]);
  const bt = (ne) => {
    cn((de) => sv(de, ne) ? de : ne);
  }, it = (ne = m) => {
    zt(pt), Jt ? Te(!0) : pt.current = setTimeout(() => {
      Te(!0);
    }, ne);
  }, xn = (ne = g) => {
    zt(Ut), Ut.current = setTimeout(() => {
      K.current || Te(!1);
    }, ne);
  }, Hn = (ne) => {
    var de;
    if (!ne) return;
    const se = (de = ne.currentTarget) !== null && de !== void 0 ? de : ne.target;
    if (!(se != null && se.isConnected)) return T(null), void F({ current: null });
    m ? it() : Te(!0), T(se), F({ current: se }), zt(Ut);
  }, En = () => {
    I ? xn(g || 100) : g ? xn() : Te(!1), zt(pt);
  }, vn = ({ x: ne, y: de }) => {
    var se;
    const De = { getBoundingClientRect: () => ({ x: ne, y: de, width: 0, height: 0, top: de, left: ne, right: ne, bottom: de }) };
    FA({ place: (se = Oe == null ? void 0 : Oe.place) !== null && se !== void 0 ? se : s, offset: l, elementReference: De, tooltipReference: Ge.current, tooltipArrowReference: Rt.current, strategy: k, middlewares: f, border: Xe, arrowSize: vt }).then((ct) => {
      bt(ct);
    });
  }, An = (ne) => {
    if (!ne) return;
    const de = ne, se = { x: de.clientX, y: de.clientY };
    vn(se), en.current = se;
  }, Bn = (ne) => {
    var de;
    if (!et) return;
    const se = ne.target;
    se.isConnected && (!((de = Ge.current) === null || de === void 0) && de.contains(se) || [document.querySelector(`[id='${i}']`), ...ie].some((De) => De == null ? void 0 : De.contains(se)) || (Te(!1), zt(pt)));
  }, Pe = UA(Hn, 50), Ae = UA(En, 50), Ie = (ne) => {
    Ae.cancel(), Pe(ne);
  }, ce = () => {
    Pe.cancel(), Ae();
  }, Ee = Q(() => {
    var ne, de;
    const se = (ne = Oe == null ? void 0 : Oe.position) !== null && ne !== void 0 ? ne : H;
    se ? vn(se) : _ ? en.current && vn(en.current) : be != null && be.isConnected && FA({ place: (de = Oe == null ? void 0 : Oe.place) !== null && de !== void 0 ? de : s, offset: l, elementReference: be, tooltipReference: Ge.current, tooltipArrowReference: Rt.current, strategy: k, middlewares: f, border: Xe, arrowSize: vt }).then((De) => {
      Le.current && bt(De);
    });
  }, [et, be, Z, $, s, Oe == null ? void 0 : Oe.place, l, k, H, Oe == null ? void 0 : Oe.position, _, vt]);
  le(() => {
    var ne, de;
    const se = new Set(Ln);
    ie.forEach((Se) => {
      U != null && U(Se) || se.add({ current: Se });
    });
    const De = document.querySelector(`[id='${i}']`);
    De && !(U != null && U(De)) && se.add({ current: De });
    const ct = () => {
      Te(!1);
    }, ln = zA(be), dn = zA(Ge.current);
    He.scroll && (window.addEventListener("scroll", ct), ln == null || ln.addEventListener("scroll", ct), dn == null || dn.addEventListener("scroll", ct));
    let Lt = null;
    He.resize ? window.addEventListener("resize", ct) : be && Ge.current && (Lt = xse(be, Ge.current, Ee, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const qt = (Se) => {
      Se.key === "Escape" && Te(!1);
    };
    He.escape && window.addEventListener("keydown", qt), He.clickOutsideAnchor && window.addEventListener("click", Bn);
    const ze = [], ti = (Se) => !!(Se != null && Se.target && (be != null && be.contains(Se.target))), Rw = (Se) => {
      et && ti(Se) || Hn(Se);
    }, Dw = (Se) => {
      et && ti(Se) && En();
    }, kA = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], fA = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(rt).forEach(([Se, In]) => {
      In && (kA.includes(Se) ? ze.push({ event: Se, listener: Ie }) : fA.includes(Se) && ze.push({ event: Se, listener: Rw }));
    }), Object.entries(yt).forEach(([Se, In]) => {
      In && (kA.includes(Se) ? ze.push({ event: Se, listener: ce }) : fA.includes(Se) && ze.push({ event: Se, listener: Dw }));
    }), _ && ze.push({ event: "pointermove", listener: An });
    const mA = () => {
      K.current = !0;
    }, gA = () => {
      K.current = !1, En();
    }, MA = I && (yt.mouseout || yt.mouseleave);
    return MA && ((ne = Ge.current) === null || ne === void 0 || ne.addEventListener("mouseover", mA), (de = Ge.current) === null || de === void 0 || de.addEventListener("mouseout", gA)), ze.forEach(({ event: Se, listener: In }) => {
      se.forEach((NE) => {
        var wi;
        (wi = NE.current) === null || wi === void 0 || wi.addEventListener(Se, In);
      });
    }), () => {
      var Se, In;
      He.scroll && (window.removeEventListener("scroll", ct), ln == null || ln.removeEventListener("scroll", ct), dn == null || dn.removeEventListener("scroll", ct)), He.resize ? window.removeEventListener("resize", ct) : Lt == null || Lt(), He.clickOutsideAnchor && window.removeEventListener("click", Bn), He.escape && window.removeEventListener("keydown", qt), MA && ((Se = Ge.current) === null || Se === void 0 || Se.removeEventListener("mouseover", mA), (In = Ge.current) === null || In === void 0 || In.removeEventListener("mouseout", gA)), ze.forEach(({ event: NE, listener: wi }) => {
        se.forEach((Ow) => {
          var CE;
          (CE = Ow.current) === null || CE === void 0 || CE.removeEventListener(NE, wi);
        });
      });
    };
  }, [be, Ee, Jt, Ln, ie, B, z, j, Ye, m, g]), le(() => {
    var ne, de;
    let se = (de = (ne = Oe == null ? void 0 : Oe.anchorSelect) !== null && ne !== void 0 ? ne : c) !== null && de !== void 0 ? de : "";
    !se && t && (se = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const De = new MutationObserver((ct) => {
      const ln = [], dn = [];
      ct.forEach((Lt) => {
        if (Lt.type === "attributes" && Lt.attributeName === "data-tooltip-id" && (Lt.target.getAttribute("data-tooltip-id") === t ? ln.push(Lt.target) : Lt.oldValue === t && dn.push(Lt.target)), Lt.type === "childList") {
          if (be) {
            const qt = [...Lt.removedNodes].filter((ze) => ze.nodeType === 1);
            if (se) try {
              dn.push(...qt.filter((ze) => ze.matches(se))), dn.push(...qt.flatMap((ze) => [...ze.querySelectorAll(se)]));
            } catch {
            }
            qt.some((ze) => {
              var ti;
              return !!(!((ti = ze == null ? void 0 : ze.contains) === null || ti === void 0) && ti.call(ze, be)) && (Ot(!1), Te(!1), T(null), zt(pt), zt(Ut), !0);
            });
          }
          if (se) try {
            const qt = [...Lt.addedNodes].filter((ze) => ze.nodeType === 1);
            ln.push(...qt.filter((ze) => ze.matches(se))), ln.push(...qt.flatMap((ze) => [...ze.querySelectorAll(se)]));
          } catch {
          }
        }
      }), (ln.length || dn.length) && ke((Lt) => [...Lt.filter((qt) => !dn.includes(qt)), ...ln]);
    });
    return De.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      De.disconnect();
    };
  }, [t, c, Oe == null ? void 0 : Oe.anchorSelect, be]), le(() => {
    Ee();
  }, [Ee]), le(() => {
    if (!(te != null && te.current)) return () => null;
    const ne = new ResizeObserver(() => {
      setTimeout(() => Ee());
    });
    return ne.observe(te.current), () => {
      ne.disconnect();
    };
  }, [Z, te == null ? void 0 : te.current]), le(() => {
    var ne;
    const de = document.querySelector(`[id='${i}']`), se = [...ie, de];
    be && se.includes(be) || T((ne = ie[0]) !== null && ne !== void 0 ? ne : de);
  }, [i, ie, be]), le(() => (ue && Te(!0), () => {
    zt(pt), zt(Ut);
  }), []), le(() => {
    var ne;
    let de = (ne = Oe == null ? void 0 : Oe.anchorSelect) !== null && ne !== void 0 ? ne : c;
    if (!de && t && (de = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), de) try {
      const se = Array.from(document.querySelectorAll(de));
      ke(se);
    } catch {
      ke([]);
    }
  }, [t, c, Oe == null ? void 0 : Oe.anchorSelect]), le(() => {
    pt.current && (zt(pt), it(m));
  }, [m]);
  const kt = (ot = Oe == null ? void 0 : Oe.content) !== null && ot !== void 0 ? ot : Z, ea = et && Object.keys(Dt.tooltipStyles).length > 0;
  return Pw(e, () => ({ open: (ne) => {
    if (ne != null && ne.anchorSelect) try {
      document.querySelector(ne.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${ne.anchorSelect}" is not a valid CSS selector`);
    }
    sn(ne ?? null), ne != null && ne.delay ? it(ne.delay) : Te(!0);
  }, close: (ne) => {
    ne != null && ne.delay ? xn(ne.delay) : Te(!1);
  }, activeAnchor: be, place: Dt.place, isOpen: !!(Jt && !L && kt && ea) })), Jt && !L && kt ? he.createElement(y, { id: t, role: At, className: j9("react-tooltip", na.tooltip, Ac.tooltip, Ac[o], n, `react-tooltip__place-${Dt.place}`, na[ea ? "show" : "closing"], ea ? "react-tooltip__show" : "react-tooltip__closing", k === "fixed" && na.fixed, I && na.clickable), onTransitionEnd: (ne) => {
    zt(Zt), et || ne.propertyName !== "opacity" || (Ot(!1), sn(null), Y == null || Y());
  }, style: { ...$, ...Dt.tooltipStyles, opacity: ht !== void 0 && ea ? ht : void 0 }, ref: Ge }, he.createElement(y, { className: j9("react-tooltip-content-wrapper", na.content, Ac.content) }, kt), he.createElement(y, { className: j9("react-tooltip-arrow", na.arrow, Ac.arrow, a, N && na.noArrow), style: { ...Dt.tooltipArrowStyles, background: qe ? `linear-gradient(to right bottom, transparent 50%, ${qe} 50%)` : void 0, "--rt-arrow-size": `${vt}px` }, ref: Rt })) : null;
}, Hse = ({ content: e }) => he.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), Bse = he.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: a, html: o, render: i, className: c, classNameArrow: s, variant: l = "dark", place: u = "top", offset: h = 10, wrapper: k = "div", children: f = null, events: y = ["hover"], openOnClick: m = !1, positionStrategy: g = "absolute", middlewares: _, delayShow: L = 0, delayHide: N = 0, float: I = !1, hidden: S = !1, noArrow: O = !1, clickable: A = !1, closeOnEsc: B = !1, closeOnScroll: z = !1, closeOnResize: j = !1, openEvents: G, closeEvents: $, globalCloseEvents: H, imperativeModeOnly: ee = !1, style: Y, position: U, isOpen: Z, defaultIsOpen: te = !1, disableStyleInjection: re = !1, border: ue, opacity: E, arrowColor: ve, arrowSize: be, setIsOpen: T, afterShow: Xe, afterHide: ht, disableTooltip: qe, role: vt = "tooltip" }, At) => {
  const [ot, Ge] = ae(a), [Rt, pt] = ae(o), [Ut, Zt] = ae(u), [Dt, cn] = ae(l), [et, Qt] = ae(h), [Jt, Ot] = ae(L), [Oe, sn] = ae(N), [Pn, en] = ae(I), [Ln, F] = ae(S), [K, ie] = ae(k), [ke, Le] = ae(y), [Ye, _t] = ae(g), [rt, yt] = ae(null), [He, Te] = ae(null), bt = fe(null), it = fe(re), { anchorRefs: xn, activeAnchor: Hn } = MN(e), En = (Ae) => Ae == null ? void 0 : Ae.getAttributeNames().reduce((Ie, ce) => {
    var Ee;
    return ce.startsWith("data-tooltip-") && (Ie[ce.replace(/^data-tooltip-/, "")] = (Ee = Ae == null ? void 0 : Ae.getAttribute(ce)) !== null && Ee !== void 0 ? Ee : null), Ie;
  }, {}), vn = (Ae) => {
    const Ie = { place: (ce) => {
      var Ee;
      Zt((Ee = ce) !== null && Ee !== void 0 ? Ee : u);
    }, content: (ce) => {
      Ge(ce ?? a);
    }, html: (ce) => {
      pt(ce ?? o);
    }, variant: (ce) => {
      var Ee;
      cn((Ee = ce) !== null && Ee !== void 0 ? Ee : l);
    }, offset: (ce) => {
      Qt(ce === null ? h : Number(ce));
    }, wrapper: (ce) => {
      var Ee;
      ie((Ee = ce) !== null && Ee !== void 0 ? Ee : k);
    }, events: (ce) => {
      const Ee = ce == null ? void 0 : ce.split(" ");
      Le(Ee ?? y);
    }, "position-strategy": (ce) => {
      var Ee;
      _t((Ee = ce) !== null && Ee !== void 0 ? Ee : g);
    }, "delay-show": (ce) => {
      Ot(ce === null ? L : Number(ce));
    }, "delay-hide": (ce) => {
      sn(ce === null ? N : Number(ce));
    }, float: (ce) => {
      en(ce === null ? I : ce === "true");
    }, hidden: (ce) => {
      F(ce === null ? S : ce === "true");
    }, "class-name": (ce) => {
      yt(ce);
    } };
    Object.values(Ie).forEach((ce) => ce(null)), Object.entries(Ae).forEach(([ce, Ee]) => {
      var kt;
      (kt = Ie[ce]) === null || kt === void 0 || kt.call(Ie, Ee);
    });
  };
  le(() => {
    Ge(a);
  }, [a]), le(() => {
    pt(o);
  }, [o]), le(() => {
    Zt(u);
  }, [u]), le(() => {
    cn(l);
  }, [l]), le(() => {
    Qt(h);
  }, [h]), le(() => {
    Ot(L);
  }, [L]), le(() => {
    sn(N);
  }, [N]), le(() => {
    en(I);
  }, [I]), le(() => {
    F(S);
  }, [S]), le(() => {
    _t(g);
  }, [g]), le(() => {
    it.current !== re && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [re]), le(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: re === "core", disableBase: re } }));
  }, []), le(() => {
    var Ae;
    const Ie = new Set(xn);
    let ce = n;
    if (!ce && e && (ce = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), ce) try {
      document.querySelectorAll(ce).forEach((de) => {
        Ie.add({ current: de });
      });
    } catch {
      console.warn(`[react-tooltip] "${ce}" is not a valid CSS selector`);
    }
    const Ee = document.querySelector(`[id='${t}']`);
    if (Ee && Ie.add({ current: Ee }), !Ie.size) return () => null;
    const kt = (Ae = He ?? Ee) !== null && Ae !== void 0 ? Ae : Hn.current, ea = new MutationObserver((de) => {
      de.forEach((se) => {
        var De;
        if (!kt || se.type !== "attributes" || !(!((De = se.attributeName) === null || De === void 0) && De.startsWith("data-tooltip-"))) return;
        const ct = En(kt);
        vn(ct);
      });
    }), ne = { attributes: !0, childList: !1, subtree: !1 };
    if (kt) {
      const de = En(kt);
      vn(de), ea.observe(kt, ne);
    }
    return () => {
      ea.disconnect();
    };
  }, [xn, Hn, He, t, n]), le(() => {
    Y != null && Y.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), ue && !$A("border", `${ue}`) && console.warn(`[react-tooltip] "${ue}" is not a valid \`border\`.`), Y != null && Y.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), E && !$A("opacity", `${E}`) && console.warn(`[react-tooltip] "${E}" is not a valid \`opacity\`.`);
  }, []);
  let An = f;
  const Bn = fe(null);
  if (i) {
    const Ae = i({ content: (He == null ? void 0 : He.getAttribute("data-tooltip-content")) || ot || null, activeAnchor: He });
    An = Ae ? he.createElement("div", { ref: Bn, className: "react-tooltip-content-wrapper" }, Ae) : null;
  } else ot && (An = ot);
  Rt && (An = he.createElement(Hse, { content: Rt }));
  const Pe = { forwardRef: At, id: e, anchorId: t, anchorSelect: n, className: j9(c, rt), classNameArrow: s, content: An, contentWrapperRef: Bn, place: Ut, variant: Dt, offset: et, wrapper: K, events: ke, openOnClick: m, positionStrategy: Ye, middlewares: _, delayShow: Jt, delayHide: Oe, float: Pn, hidden: Ln, noArrow: O, clickable: A, closeOnEsc: B, closeOnScroll: z, closeOnResize: j, openEvents: G, closeEvents: $, globalCloseEvents: H, imperativeModeOnly: ee, style: Y, position: U, isOpen: Z, defaultIsOpen: te, border: ue, opacity: E, arrowColor: ve, arrowSize: be, setIsOpen: T, afterShow: Xe, afterHide: ht, disableTooltip: qe, activeAnchor: He, previousActiveAnchor: bt.current, setActiveAnchor: (Ae) => {
    Te((Ie) => (Ae != null && Ae.isSameNode(Ie) || (bt.current = Ie), Ae));
  }, role: vt };
  return he.createElement(Pse, { ...Pe });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || BA({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1;-webkit-backface-visibility:hidden;backface-visibility:hidden}.core-styles-module_content__BRKdB{position:relative;z-index:1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || BA({ css: `
.styles-module_tooltip__mnnfp{border-radius:3px;font-size:90%;width:max-content}.styles-module_content__ydYdI{background:inherit;border-radius:inherit;padding:8px 16px}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const Fse = Bse, $se = { zIndex: 1e6 }, Use = ({ visible: e = !0, title: t = "", children: n, placement: a = tt.TOP, className: o = "", offset: i = 8 }) => {
  const { hoverNone: c } = Dn(), s = zT();
  if (!e || !t) return n;
  const l = (h) => {
    switch (h) {
      case tt.TOP:
        return "top";
      case tt.BOTTOM:
        return "bottom";
      case tt.LEFT:
        return "left";
      case tt.RIGHT:
        return "right";
      default:
        return "top";
    }
  }, u = /* @__PURE__ */ p(
    Fse,
    {
      id: s,
      offset: i,
      className: `!px-2.5 !py-1.5 !rounded-[9px] !bg-black !transition-opacity max-w-[250px] !duration-300 [overflow-wrap:anywhere] whitespace-normal ${o}`,
      style: $se,
      border: "1px solid #474747",
      opacity: 1,
      delayShow: 50,
      delayHide: 50,
      float: !1,
      openOnClick: c
    }
  );
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p(
      "div",
      {
        "data-tooltip-id": s,
        "data-tooltip-max-width": "200px",
        "data-tooltip-content": t,
        "data-tooltip-place": l(a),
        "data-tooltip-float": !1,
        className: "inline-flex max-w-full",
        children: n
      }
    ),
    typeof document > "u" ? u : sE(u, document.body)
  ] });
}, Nt = he.memo(Use), qse = ({
  characterMessageNumber: e
}) => e ? /* @__PURE__ */ C("div", { className: "flex items-center gap-0.5", children: [
  /* @__PURE__ */ p(oe, { icon: R.MESSAGE, size: ye.XSMALL }),
  /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, children: typeof e == "number" && Bw(e) || e })
] }) : null, _N = he.memo(qse), zse = ({
  characterRatingScore: e
}) => e ? /* @__PURE__ */ C("div", { className: "flex items-center gap-0.5", children: [
  /* @__PURE__ */ p(oe, { icon: R.LIKE, size: ye.XSMALL }),
  /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, children: typeof e == "number" && `${Math.round(e * 100)}%` || e })
] }) : null, bN = he.memo(zse), jse = ({
  characterTokensCount: e
}) => e ? /* @__PURE__ */ C("div", { className: "flex items-center gap-0.5", children: [
  /* @__PURE__ */ p(oe, { icon: R.BLOCKS, size: ye.XSMALL }),
  /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, children: e })
] }) : null, LN = he.memo(jse), Vse = ({
  isLiked: e,
  onPressHandler: t,
  isDisabled: n
}) => {
  const [a, o] = ae(e);
  return /* @__PURE__ */ p(
    "button",
    {
      className: `
        p-1.5 rounded-full
        bg-black/[.47] backdrop-blur-sm
        cursor-pointer
        disabled:opacity-50 disabled:cursor-not-allowed
        w-7 h-7
        flex items-center justify-center
      `,
      disabled: n,
      onClick: async (i) => {
        i.stopPropagation(), o((c) => !c);
        try {
          await t(i);
        } catch (c) {
          console.log(c), o((s) => !s);
        }
      },
      "aria-label": a ? "unfavorite" : "favorite",
      children: /* @__PURE__ */ p(
        oe,
        {
          icon: R.FAVORITE,
          className: `
          w-5 h-5
          ${a ? "text-red-9 fill-red-9" : "text-white fill-transparent"}
        `
        }
      )
    }
  );
}, Gse = he.memo(Vse), Wse = ({
  isHidden: e,
  isDisabled: t,
  isDefinitionVisible: n
}) => e ? null : /* @__PURE__ */ p(
  "div",
  {
    className: `
        cursor-pointer
        p-1.5 rounded-full
        backdrop-blur-sm
        w-7 h-7
        flex items-center justify-center
        ${n ? "bg-purple-9/[.47]" : "bg-black/[.47]"}
        ${t ? "opacity-50 cursor-not-allowed" : ""}
      `,
    children: /* @__PURE__ */ p(oe, { icon: R.INFO, className: "w-5 h-5 text-white" })
  }
), Xse = he.memo(Wse);
var Re = /* @__PURE__ */ ((e) => (e.SHARE = "Share", e.BLOCK = "Block", e.REPORT = "Report", e.FAVORITE = "Favorite", e.INFO = "Info", e.CHAT = "Chat", e.CREATOR = "Creator", e.DRAFTS = "Drafts", e.DRAFT = "Draft", e))(Re || {}), Ne = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.PUBLIC = "Public", e.PRIVATE = "Private", e.UNLISTED = "Unlisted", e.RECOMMENDED = "Recommended", e.ACTION = "Action", e.REVIEW = "Review", e.NEEDS_REVIEW = "Needs Review", e.DRAFTS = "Drafts", e.DRAFT = "Draft", e.DRAFT_ACTION_REQUIRED = "DraftActionRequired", e.UNDER_MANUAL_REVIEW = "UnderManualReview", e))(Ne || {}), qn = /* @__PURE__ */ ((e) => (e.HORIZONTAL = "horizontal", e.VERTICAL = "vertical", e))(qn || {}), lv = /* @__PURE__ */ ((e) => (e.TAGS = "tags", e.STATUS = "status", e))(lv || {});
const Yse = {
  [Ne.RECOMMENDED]: "For You",
  [Ne.ACTION]: "Action Required",
  [Ne.REVIEW]: "Under Review",
  [Ne.NEEDS_REVIEW]: "Needs Review",
  [Ne.DRAFT_ACTION_REQUIRED]: "Action Required",
  [Ne.UNDER_MANUAL_REVIEW]: "Under Manual Review"
}, Kse = {
  [Ne.REVIEW]: {
    bg: "bg-yellow-8",
    border: "border-yellow-8 hover:border-yellow-8 dark:hover:border-yellow-8"
  },
  [Ne.NEEDS_REVIEW]: {
    bg: "bg-blue-8",
    border: "border-blue-8 hover:border-blue-8 dark:hover:border-blue-8"
  },
  [Ne.ACTION]: {
    bg: "bg-red-8",
    border: "border-red-8 hover:border-red-8 dark:hover:border-red-8"
  },
  [Ne.UNDER_MANUAL_REVIEW]: {
    bg: "bg-red-8",
    border: "border-red-8 hover:border-red-8 dark:hover:border-red-8"
  },
  [Ne.RECOMMENDED]: {
    bg: "bg-purple-9",
    border: ""
  },
  [Ne.DRAFT_ACTION_REQUIRED]: {
    bg: "bg-red-8",
    border: "border-red-8 hover:border-red-8 dark:hover:border-red-8"
  }
}, ni = {
  [Ne.PUBLIC]: {
    title: "Public",
    className: "!bg-green-5",
    icon: R.EARTH
  },
  [Ne.PRIVATE]: {
    title: "Private",
    icon: R.LOCK
  },
  [Ne.UNLISTED]: {
    title: "Unlisted",
    icon: R.LINK
  },
  [Ne.ACTION]: {
    title: "Action",
    icon: R.INFO
  },
  [Ne.REVIEW]: {
    title: "Review",
    icon: R.SEARCH
  },
  [Ne.DRAFT]: {
    title: "Draft",
    icon: R.FILE
  },
  [Ne.DRAFT_ACTION_REQUIRED]: [
    {
      title: "Draft",
      icon: R.FILE
    },
    {
      title: "Action",
      icon: R.INFO
    }
  ]
}, jA = ({ to: e, onPress: t, ariaLabel: n, className: a, title: o, style: i, children: c }) => {
  const s = Q(
    (l) => {
      l.stopPropagation(), t();
    },
    [t]
  );
  return e ? /* @__PURE__ */ p(mn, { to: e, onPress: t, "aria-label": n, className: a, title: o, style: i, children: c }) : /* @__PURE__ */ p(
    "button",
    {
      type: "button",
      onClick: s,
      "aria-label": n,
      className: P("appearance-none border-0 bg-transparent p-0 text-left text-inherit cursor-pointer", a),
      title: o,
      style: i,
      children: c
    }
  );
}, Zse = ({
  characterInfo: e,
  variant: t = Ne.DEFAULT,
  maxWidth: n,
  characterCardActionsHandler: a = () => null,
  characterCardActionsState: o = {
    [Re.SHARE]: { isDisabled: !1, isHidden: !1 },
    [Re.BLOCK]: { isDisabled: !1, isHidden: !1 },
    [Re.REPORT]: { isDisabled: !1, isHidden: !1 },
    [Re.FAVORITE]: {
      isDisabled: !1,
      isHidden: !1,
      isLiked: !1
    },
    [Re.INFO]: { isDisabled: !1, isHidden: !1 },
    [Re.CHAT]: { isDisabled: !1, isHidden: !1 },
    [Re.CREATOR]: { isDisabled: !1, isHidden: !1 }
  },
  atCenter: i = !1,
  dropdownMenuActions: c,
  orientation: s = qn.VERTICAL,
  membersCount: l = 1,
  displayMode: u = lv.TAGS,
  isFlexibleHeight: h = !1,
  isDropdownPortaled: k = !1,
  dropdownPlacement: f = Yt.BottomEnd
}) => {
  var _t, rt, yt, He, Te, bt, it, xn, Hn, En, vn, An, Bn;
  const { hoverNone: y } = Dn(), m = fe(null), [g, _] = ae(40), L = g >= 32 ? "line-clamp-2" : "line-clamp-3", N = t === Ne.DRAFT, I = t === Ne.DRAFTS, S = [Ne.DEFAULT, Ne.RECOMMENDED].includes(t), O = g >= 32 ? 40 : 60, A = !y, B = fe(!1), z = fe(null), j = fe(null), {
    characterId: G,
    characterName: $,
    characterCreatorUserName: H,
    characterTitle: ee,
    characterTags: Y,
    characterMessageNumber: U,
    characterRatingScore: Z,
    characterTokensCount: te,
    characterAvatarUrl: re,
    characterDefinitionVisible: ue,
    characterImageGen: E,
    creatorPagePath: ve,
    chatPagePath: be,
    chatbotProfilePagePath: T,
    characterAvatarBlur: Xe,
    characterLikeLabel: ht,
    characterInfoLabel: qe,
    characterImageGenLabel: vt,
    characterDraftCount: At = 0,
    characterDraftImages: ot,
    draftsPagePath: Ge,
    draftPagePath: Rt,
    characterAicq: pt,
    entriesCount: Ut,
    lorebookAttached: Zt,
    lorebookLabel: Dt,
    hasVoice: cn,
    //change this variabele after BE done
    variantLabel: et,
    statusBadgeLabel: Qt,
    draftsCountLabel: Jt,
    groupCountLabel: Ot = "Participant count"
  } = e, Oe = c || [
    {
      label: "Share",
      icon: R.EXTERNAL_LINK,
      onPress: () => a(Re.SHARE, G),
      isDisabled: (_t = o[Re.SHARE]) == null ? void 0 : _t.isDisabled,
      isHidden: (rt = o[Re.SHARE]) == null ? void 0 : rt.isHidden
    },
    {
      label: "Report",
      icon: R.FLAG,
      onPress: () => a(Re.REPORT, G),
      isDisabled: (yt = o[Re.REPORT]) == null ? void 0 : yt.isDisabled,
      isHidden: (He = o[Re.REPORT]) == null ? void 0 : He.isHidden
    },
    {
      label: "Block Creator",
      icon: R.USER_CANCEL,
      onPress: () => a(Re.BLOCK, G),
      isDisabled: (Te = o[Re.BLOCK]) == null ? void 0 : Te.isDisabled,
      isHidden: (bt = o[Re.BLOCK]) == null ? void 0 : bt.isHidden
    }
  ], sn = !((it = o[Re.FAVORITE]) != null && it.isHidden), Pn = !((xn = o[Re.INFO]) != null && xn.isHidden), en = et || Yse[t], Ln = (Pe, Ae) => {
    var Ie;
    return ((Ie = Kse[Pe]) == null ? void 0 : Ie[Ae]) ?? "";
  }, F = () => {
    const Pe = ni == null ? void 0 : ni[t];
    return Pe ? (Array.isArray(Pe) ? Pe : [Pe]).map((Ie, ce) => {
      var kt;
      const Ee = (Array.isArray(Qt) ? Qt[ce] : Qt) || (Ie == null ? void 0 : Ie.title);
      return /* @__PURE__ */ p(
        Vt,
        {
          iconStart: Ie == null ? void 0 : Ie.icon,
          shape: we.SQUARE,
          size: dt.XSMALL,
          className: `cursor-default ${(kt = ni == null ? void 0 : ni[t]) == null ? void 0 : kt.className}`,
          classNames: {
            text: "line-clamp-1"
          },
          "aria-label": Ee,
          children: Ee
        },
        ce
      );
    }) : null;
  }, K = () => {
    const Pe = z.current;
    if (!Pe) return;
    const Ae = Pe.scrollHeight - Pe.clientHeight;
    if (Ae <= 0) return;
    let Ie = 0;
    const ce = () => {
      Ie >= Ae || !B.current || (Ie += 0.5, Pe.scrollTop = Ie, j.current = requestAnimationFrame(ce));
    };
    B.current || (B.current = !0, j.current = requestAnimationFrame(ce));
  }, ie = () => {
    j.current && B.current && (cancelAnimationFrame(j.current), j.current = null, B.current = !1, z.current && (z.current.scrollTop = 0));
  };
  le(() => (m.current && _(m.current.clientHeight), () => ie()), []), le(() => {
    !A && z.current && (i ? K() : ie());
  }, [i, A, z.current]);
  const ke = () => {
    if (t === Ne.UNDER_MANUAL_REVIEW)
      return !1;
    t === Ne.DRAFT ? a(Re.DRAFT, G) : a(Re.CHAT, G);
  }, Le = t === Ne.DRAFT ? `edit-${$}` : `chat-with-${$}`, Ye = be || Rt;
  return I ? /* @__PURE__ */ p(
    mn,
    {
      to: Ge,
      onPress: () => a(Re.DRAFTS, G),
      className: "aspect-square",
      "aria-label": "drafts",
      children: /* @__PURE__ */ C(
        "div",
        {
          className: "rounded-xl bg-gray-3 overflow-hidden cursor-pointer hover:bg-gray-4 border-1 border-solid border-gray-6 hover:border-gray-7/50 dark:hover:border-gray-8",
          style: { maxWidth: n },
          children: [
            /* @__PURE__ */ p("div", { className: "grid grid-cols-2 aspect-square", children: (Hn = Array.from({ length: 4 })) == null ? void 0 : Hn.map((Pe, Ae) => {
              const Ie = ot == null ? void 0 : ot[Ae];
              return Ie ? /* @__PURE__ */ p(Kt, { src: Ie, className: "size-full" }, Ae) : /* @__PURE__ */ p("div", { className: "grid place-items-center bg-gray-5", children: /* @__PURE__ */ p(oe, { icon: R.USER, className: "size-12 text-gray-6" }) }, Ae);
            }) }),
            /* @__PURE__ */ p("div", { className: "h-[180px] grid place-items-center", children: /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_BOLD, children: Jt || `Drafts (${At})` }) })
          ]
        }
      )
    }
  ) : /* @__PURE__ */ C(
    "div",
    {
      style: { maxWidth: n },
      className: P(
        `relative group rounded-xl
        bg-gray-3 hover:bg-gray-4
        border-1 border-solid border-gray-6 hover:border-gray-7/50 dark:hover:border-gray-8
        flex w-full`,
        s === qn.HORIZONTAL ? "flex-row h-[156px]" : "flex-col",
        Ln(t, "border")
      ),
      onMouseEnter: A ? K : void 0,
      onMouseLeave: A ? ie : void 0,
      children: [
        /* @__PURE__ */ C("div", { className: "relative aspect-square", children: [
          /* @__PURE__ */ p(
            jA,
            {
              className: "relative w-full flex aspect-square",
              to: Ye,
              onPress: ke,
              ariaLabel: Le,
              children: /* @__PURE__ */ C(
                "div",
                {
                  className: P(
                    "overflow-hidden relative flex items-center justify-center aspect-square",
                    s === qn.HORIZONTAL ? "rounded-l-[.7rem]" : "rounded-t-[0.70rem]"
                  ),
                  style: { wordBreak: "break-all" },
                  children: [
                    N && !re ? /* @__PURE__ */ p("div", { className: "aspect-square bg-gray-4 w-full" }) : /* @__PURE__ */ p(
                      Kt,
                      {
                        src: re,
                        alt: $,
                        loading: "lazy",
                        className: P(
                          "w-full h-full aspect-square",
                          pt ? "grayscale cursor-not-allowed" : "",
                          (t === Ne.ACTION || t === Ne.REVIEW) && "rounded-t-[0.60rem]",
                          Xe ? "filter blur-md" : ""
                        ),
                        style: { wordBreak: "break-all" },
                        blurRadius: Xe ? 20 : null,
                        onError: (Pe) => {
                          const Ae = Pe.target;
                          Ae.src !== IA && (Ae.src = IA);
                        }
                      }
                    ),
                    Xe ? /* @__PURE__ */ p(oe, { icon: R.EYE_OFF, size: ye.XLARGE, className: "absolute z-10" }) : null
                  ]
                }
              )
            }
          ),
          !N && !I && /* @__PURE__ */ p(
            "div",
            {
              className: P(
                "absolute inset-0 bg-gradient-to-t from-transparent to-black/50  h-[40px] ",
                s === qn.HORIZONTAL ? "rounded-l-xl" : "rounded-xl"
              )
            }
          ),
          sn ? /* @__PURE__ */ p("div", { className: "absolute top-[6px] left-2", children: /* @__PURE__ */ p(Nt, { title: ht, placement: tt.TOP, children: /* @__PURE__ */ p("div", { className: "p-0.5", children: /* @__PURE__ */ p(
            Gse,
            {
              isLiked: (En = o[Re.FAVORITE]) == null ? void 0 : En.isLiked,
              onPressHandler: (Pe) => {
                Pe == null || Pe.preventDefault(), a(Re.FAVORITE, G);
              },
              isDisabled: (vn = o[Re.FAVORITE]) == null ? void 0 : vn.isDisabled
            }
          ) }) }) }) : null,
          Pn ? /* @__PURE__ */ p("div", { className: "absolute top-[6px] right-2", children: /* @__PURE__ */ p(Nt, { title: qe, placement: tt.TOP, children: /* @__PURE__ */ p(
            mn,
            {
              to: T,
              onPress: () => a(Re.INFO, G),
              "aria-label": "character-info",
              children: /* @__PURE__ */ p("div", { className: "p-0.5", children: /* @__PURE__ */ p(
                Xse,
                {
                  isDisabled: (An = o[Re.INFO]) == null ? void 0 : An.isDisabled,
                  isHidden: (Bn = o[Re.INFO]) == null ? void 0 : Bn.isHidden,
                  isDefinitionVisible: ue
                }
              ) })
            }
          ) }) }) : null,
          en ? /* @__PURE__ */ p("div", { className: "w-full flex justify-center", children: /* @__PURE__ */ p("div", { className: "absolute z-10 bottom-0 max-w-full", children: /* @__PURE__ */ p(
            "div",
            {
              className: P(
                "py-1 rounded-t-[3px] min-h-5 min-w-20 flex justify-center items-center",
                t === Ne.UNDER_MANUAL_REVIEW ? "px-3" : "px-4",
                Ln(t, "bg")
              ),
              children: /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_MEDIUM, className: "text-white text-center", children: en })
            }
          ) }) }) : null
        ] }),
        /* @__PURE__ */ C(
          "div",
          {
            className: P(
              "px-2 py-3 flex flex-col gap-2 min-w-0",
              s === qn.HORIZONTAL && "h-[156px]",
              s !== qn.HORIZONTAL && !h && "h-[180px]",
              !h && "grow"
            ),
            children: [
              /* @__PURE__ */ C("div", { className: "flex items-center justify-between gap-2 w-full min-w-0", children: [
                /* @__PURE__ */ C("div", { className: P("min-w-0 flex-1 flex flex-col justify-between", (!!H || !h) && "h-10"), children: [
                  /* @__PURE__ */ p("div", { className: "min-w-0 flex-1 overflow-hidden", children: /* @__PURE__ */ p(
                    jA,
                    {
                      className: "block max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-12 dark:text-white text-sm md:text-lg font-semibold",
                      to: Ye,
                      onPress: ke,
                      title: $,
                      style: { maxWidth: "100%" },
                      ariaLabel: Le,
                      children: $
                    }
                  ) }),
                  /* @__PURE__ */ C("div", { className: "flex items-center gap-sm", children: [
                    H ? /* @__PURE__ */ p(
                      mn,
                      {
                        to: ve,
                        onPress: () => a(Re.CREATOR, G),
                        "aria-label": "creator",
                        className: "min-w-0 max-w-full",
                        children: /* @__PURE__ */ C(
                          q,
                          {
                            variant: x.LABEL_SMALL_REGULAR,
                            className: `block overflow-hidden text-ellipsis whitespace-nowrap ${pt ? "text-gray-10" : "text-blue-10"}`,
                            style: { maxWidth: "100%" },
                            title: `@${H}`,
                            children: [
                              "@",
                              H
                            ]
                          }
                        )
                      }
                    ) : null,
                    !!Ut && /* @__PURE__ */ C(q, { variant: x.LABEL_SMALL_REGULAR, className: "flex items-center gap-0.5 text-gray-10", children: [
                      /* @__PURE__ */ p(oe, { icon: R.BOOK, size: ye.XSMALL, className: "mr-0.5" }),
                      Ut
                    ] })
                  ] })
                ] }),
                Oe.length > 0 ? /* @__PURE__ */ p(lE, { listItems: Oe, placement: f, isPortaled: k, children: /* @__PURE__ */ p(oe, { icon: R.THREE_DOTS, className: "w-5 h-5 text-gray-10 hover:text-gray-12 cursor-pointer flex-shrink-0" }) }) : null
              ] }),
              /* @__PURE__ */ p(
                "div",
                {
                  ref: z,
                  className: P(
                    "relative scrollbar-hide min-h-10",
                    L,
                    !h && "grow shrink",
                    A && "group-hover:line-clamp-none",
                    i && "line-clamp-none",
                    "!overflow-y-auto"
                  ),
                  style: { maxHeight: O },
                  children: /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: N && !ee ? "text-gray-10" : "text-gray-12", children: ee || N && "Add description" })
                }
              ),
              /* @__PURE__ */ C("div", { className: P("flex flex-col gap-2", !h && "mt-auto"), children: [
                !S && l < 2 ? /* @__PURE__ */ C("div", { ref: m, className: "flex flex-row gap-md", children: [
                  cn ? /* @__PURE__ */ p(
                    Vt,
                    {
                      size: dt.XSMALL,
                      shape: we.SQUARE,
                      iconStart: R.AUDIO,
                      "aria-label": "voice",
                      variant: Ze.CONTRAST,
                      className: "py-2 cursor-default bg-yellow-9"
                    }
                  ) : null,
                  /* @__PURE__ */ p(TA, { lorebookAttached: !!Zt, lorebookLabel: Dt || "" }),
                  F()
                ] }) : /* @__PURE__ */ C(
                  "div",
                  {
                    ref: m,
                    className: `flex flex-wrap items-center gap-1 ${s === qn.HORIZONTAL ? "max-h-4" : "max-h-9"} overflow-hidden`,
                    children: [
                      cn ? /* @__PURE__ */ p(
                        Vt,
                        {
                          size: dt.XSMALL,
                          shape: we.SQUARE,
                          iconStart: R.AUDIO,
                          "aria-label": "voice",
                          variant: Ze.CONTRAST,
                          className: "py-2 cursor-default bg-yellow-9"
                        }
                      ) : null,
                      E ? /* @__PURE__ */ p(Nt, { title: vt, children: /* @__PURE__ */ p(
                        Vt,
                        {
                          size: dt.XSMALL,
                          shape: we.SQUARE,
                          iconStart: R.IMAGE_PLUS,
                          "aria-label": "image-gen",
                          variant: Ze.CONTRAST,
                          className: "py-2 cursor-default bg-purple-8"
                        }
                      ) }) : null,
                      /* @__PURE__ */ p(TA, { lorebookAttached: !!Zt, lorebookLabel: Dt || "" }),
                      l > 1 && /* @__PURE__ */ p(Nt, { title: Ot, children: /* @__PURE__ */ p(
                        Vt,
                        {
                          shape: we.SQUARE,
                          iconStart: R.USERS,
                          size: dt.XSMALL,
                          variant: Ze.CONTRAST,
                          className: "py-2 cursor-default",
                          children: l
                        }
                      ) }),
                      u === lv.STATUS ? /* @__PURE__ */ p("div", { className: "flex flex-row gap-md", children: F() }) : Y == null ? void 0 : Y.map((Pe) => /* @__PURE__ */ p(Vt, { className: "rounded-[3px] !cursor-default", size: dt.XSMALL, shape: we.SQUARE, "aria-label": Pe, children: Pe }, Pe))
                    ]
                  }
                ),
                /* @__PURE__ */ C("div", { className: "flex items-center gap-2 justify-between text-gray-10", children: [
                  /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ p(_N, { characterMessageNumber: U }),
                    /* @__PURE__ */ p(bN, { characterRatingScore: Z })
                  ] }),
                  /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ p(LN, { characterTokensCount: te }) })
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
};
he.memo(Zse);
const VA = {
  [me.SMALL]: {
    container: "h-4 w-4 gap-3 rounded-sm",
    icon: "w-3 h-3",
    text: x.LABEL_SMALL_REGULAR
  },
  [me.MEDIUM]: {
    container: "h-5 w-5 gap-3 rounded-md",
    icon: "w-3.5 h-3.5",
    text: x.LABEL_MEDIUM_REGULAR
  },
  [me.LARGE]: {
    container: "h-6 w-6 gap-4 rounded-md",
    icon: "w-4 h-4",
    text: x.LABEL_LARGE_REGULAR
  }
}, GA = {
  [rc.DEFAULT]: {
    base: "appearance-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 disabled:border-gray-8 transition-colors duration-200",
    checked: "bg-blue-10 ",
    unchecked: " bg-gray-2 dark:bg-gray-4 border border-solid border-gray-8 dark:border-gray-9",
    indeterminate: "bg-gray-12 hover:bg-gray-12 border-gray-11 active:bg-gray-1 active:border-gray-4"
  },
  [rc.DEFAULT_OUTLINED]: {
    base: "appearance-none rounded-sm border border-solid hover:bg-blue-2 hover:border-blue-4 active:bg-blue-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10  cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-transparent disabled:border-gray-8 transition-colors duration-200",
    checked: "bg-blue-2 border-blue-5 hover:border-blue-5",
    unchecked: "border-gray-8 active:border-gray-9",
    indeterminate: "bg-gray-12 hover:bg-gray-12 border-gray-11 active:bg-gray-1 active:border-gray-4"
  }
}, Qse = ({
  size: e = me.SMALL,
  variant: t = rc.DEFAULT,
  label: n = null,
  onChange: a = () => null,
  labelPosition: o = F1.END,
  checked: i,
  readonly: c = !1,
  disabled: s = !1,
  className: l = "",
  wrapperClassName: u = "",
  icon: h = R.CHECK,
  classNames: k,
  indeterminate: f = !1,
  id: y = "",
  ...m
}) => {
  const [g, _] = ae(!!i), L = i !== void 0, N = L ? i : g, I = zT(), S = y || I, O = Q(
    (G) => {
      var $;
      !c && !L && _(($ = G == null ? void 0 : G.target) == null ? void 0 : $.checked), a(G);
    },
    [c, L, a]
  ), A = VA[e] || VA[me.MEDIUM], B = GA[t] || GA[rc.DEFAULT], z = `select-none ${s ? "opacity-50 cursor-not-allowed" : "text-gray-12"}`, j = Q(() => n ? /* @__PURE__ */ p(q, { as: "span", variant: A == null ? void 0 : A.text, className: z, children: n }) : null, [n, z, A == null ? void 0 : A.text]);
  return /* @__PURE__ */ C(
    "div",
    {
      className: `
        inline-flex gap-md 
        ${o === F1.START ? "flex-row-reverse" : "flex-row"}
        ${u}
      `,
      children: [
        /* @__PURE__ */ C("div", { className: P("relative flex items-center group mt-[1px]", A == null ? void 0 : A.container), children: [
          /* @__PURE__ */ p(
            "input",
            {
              id: S,
              type: "checkbox",
              checked: N,
              onChange: O,
              disabled: s || c,
              className: P(
                B.base,
                A == null ? void 0 : A.container,
                f && (B == null ? void 0 : B.indeterminate),
                N ? B == null ? void 0 : B.checked : B == null ? void 0 : B.unchecked,
                l
              ),
              ...m
            }
          ),
          N || f ? /* @__PURE__ */ p(
            oe,
            {
              icon: h,
              className: P(
                "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none text-white",
                f && "text-black group-active:text-white",
                A == null ? void 0 : A.icon,
                k == null ? void 0 : k.icon
              )
            }
          ) : null
        ] }),
        n ? /* @__PURE__ */ p("label", { htmlFor: S, className: "disabled:cursor-not-allowed cursor-pointer", children: j() }) : null
      ]
    }
  );
}, gi = he.memo(Qse);
var Jse = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.BIG = "big", e))(Jse || {});
const ele = 2, tle = {
  small: {
    title: x.LABEL_MEDIUM_MEDIUM,
    count: x.LABEL_MEDIUM_MEDIUM
  },
  big: {
    title: x.HEADING_5_BOLD,
    count: x.HEADING_5_REGULAR
  }
}, yge = ({
  title: e,
  currentCount: t,
  maxCount: n = 10,
  size: a = "small",
  className: o = "",
  classNames: i = {}
}) => {
  const c = a === "big", s = tle[a], l = "text-gray-12 dark:text-white", u = c ? "leading-6 tracking-[-0.48px]" : "", h = t > n || t < ele, k = c ? s.count : s.title;
  return /* @__PURE__ */ C(
    "div",
    {
      className: P(
        "flex items-baseline gap-1",
        o,
        i.container
      ),
      children: [
        /* @__PURE__ */ p(
          q,
          {
            variant: s.title,
            className: P(l, u, i.title),
            children: e
          }
        ),
        /* @__PURE__ */ C(
          q,
          {
            className: P(l, u, i.title),
            variant: k,
            children: [
              "(",
              t,
              "/",
              n,
              ")"
            ]
          }
        ),
        h && /* @__PURE__ */ p(
          q,
          {
            variant: k,
            className: P("text-red-10", i.error),
            children: "*"
          }
        )
      ]
    }
  );
}, kE = he.memo(function() {
  return /* @__PURE__ */ p(
    oe,
    {
      icon: R.MOVE_RIGHT,
      size: ye.XSMALL,
      className: "text-gray-10",
      "aria-hidden": !0
    }
  );
}), nle = {
  added: "text-green-10",
  removed: "text-red-9",
  modified: "text-yellow-9"
};
function ale({ oldCount: e, changes: t }) {
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p("div", { className: "flex-1 min-w-0 text-label-sm text-gray-12", children: e ?? "" }),
    /* @__PURE__ */ p(kE, {}),
    /* @__PURE__ */ p("div", { className: "flex-1 min-w-0 text-label-sm flex flex-wrap gap-x-2 gap-y-0.5", "data-testid": "ChangeSummaryContent", children: t.map((n) => /* @__PURE__ */ p("span", { className: nle[n.tone], children: n.label }, n.label)) })
  ] });
}
const ole = he.memo(ale), rle = ({ oldImageUrl: e, newImageUrl: t }) => {
  const n = "overflow-hidden flex-shrink-0 object-cover";
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p("div", { className: "flex-1", children: /* @__PURE__ */ p(
      "div",
      {
        className: P(
          n,
          "w-11 h-11 rounded-md"
        ),
        children: /* @__PURE__ */ p(
          Kt,
          {
            src: e,
            alt: "Previous version",
            className: "w-full h-full object-cover"
          }
        )
      }
    ) }),
    /* @__PURE__ */ p(kE, {}),
    /* @__PURE__ */ p("div", { className: "flex-1", children: /* @__PURE__ */ p(
      "div",
      {
        className: P(
          n,
          "flex-1 w-11 h-11 rounded-md border-2 border-yellow-9"
        ),
        children: /* @__PURE__ */ p(
          Kt,
          {
            src: t,
            alt: "New version",
            className: "w-full h-full object-cover"
          }
        )
      }
    ) })
  ] });
}, ile = he.memo(rle);
class fE {
  diff(t, n, a = {}) {
    let o;
    typeof a == "function" ? (o = a, a = {}) : "callback" in a && (o = a.callback);
    const i = this.castInput(t, a), c = this.castInput(n, a), s = this.removeEmpty(this.tokenize(i, a)), l = this.removeEmpty(this.tokenize(c, a));
    return this.diffWithOptionsObj(s, l, a, o);
  }
  diffWithOptionsObj(t, n, a, o) {
    var i;
    const c = (N) => {
      if (N = this.postProcess(N, a), o) {
        setTimeout(function() {
          o(N);
        }, 0);
        return;
      } else
        return N;
    }, s = n.length, l = t.length;
    let u = 1, h = s + l;
    a.maxEditLength != null && (h = Math.min(h, a.maxEditLength));
    const k = (i = a.timeout) !== null && i !== void 0 ? i : 1 / 0, f = Date.now() + k, y = [{ oldPos: -1, lastComponent: void 0 }];
    let m = this.extractCommon(y[0], n, t, 0, a);
    if (y[0].oldPos + 1 >= l && m + 1 >= s)
      return c(this.buildValues(y[0].lastComponent, n, t));
    let g = -1 / 0, _ = 1 / 0;
    const L = () => {
      for (let N = Math.max(g, -u); N <= Math.min(_, u); N += 2) {
        let I;
        const S = y[N - 1], O = y[N + 1];
        S && (y[N - 1] = void 0);
        let A = !1;
        if (O) {
          const z = O.oldPos - N;
          A = O && 0 <= z && z < s;
        }
        const B = S && S.oldPos + 1 < l;
        if (!A && !B) {
          y[N] = void 0;
          continue;
        }
        if (!B || A && S.oldPos < O.oldPos ? I = this.addToPath(O, !0, !1, 0, a) : I = this.addToPath(S, !1, !0, 1, a), m = this.extractCommon(I, n, t, N, a), I.oldPos + 1 >= l && m + 1 >= s)
          return c(this.buildValues(I.lastComponent, n, t)) || !0;
        y[N] = I, I.oldPos + 1 >= l && (_ = Math.min(_, N - 1)), m + 1 >= s && (g = Math.max(g, N + 1));
      }
      u++;
    };
    if (o)
      (function N() {
        setTimeout(function() {
          if (u > h || Date.now() > f)
            return o(void 0);
          L() || N();
        }, 0);
      })();
    else
      for (; u <= h && Date.now() <= f; ) {
        const N = L();
        if (N)
          return N;
      }
  }
  addToPath(t, n, a, o, i) {
    const c = t.lastComponent;
    return c && !i.oneChangePerToken && c.added === n && c.removed === a ? {
      oldPos: t.oldPos + o,
      lastComponent: { count: c.count + 1, added: n, removed: a, previousComponent: c.previousComponent }
    } : {
      oldPos: t.oldPos + o,
      lastComponent: { count: 1, added: n, removed: a, previousComponent: c }
    };
  }
  extractCommon(t, n, a, o, i) {
    const c = n.length, s = a.length;
    let l = t.oldPos, u = l - o, h = 0;
    for (; u + 1 < c && l + 1 < s && this.equals(a[l + 1], n[u + 1], i); )
      u++, l++, h++, i.oneChangePerToken && (t.lastComponent = { count: 1, previousComponent: t.lastComponent, added: !1, removed: !1 });
    return h && !i.oneChangePerToken && (t.lastComponent = { count: h, previousComponent: t.lastComponent, added: !1, removed: !1 }), t.oldPos = l, u;
  }
  equals(t, n, a) {
    return a.comparator ? a.comparator(t, n) : t === n || !!a.ignoreCase && t.toLowerCase() === n.toLowerCase();
  }
  removeEmpty(t) {
    const n = [];
    for (let a = 0; a < t.length; a++)
      t[a] && n.push(t[a]);
    return n;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  castInput(t, n) {
    return t;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tokenize(t, n) {
    return Array.from(t);
  }
  join(t) {
    return t.join("");
  }
  postProcess(t, n) {
    return t;
  }
  get useLongestToken() {
    return !1;
  }
  buildValues(t, n, a) {
    const o = [];
    let i;
    for (; t; )
      o.push(t), i = t.previousComponent, delete t.previousComponent, t = i;
    o.reverse();
    const c = o.length;
    let s = 0, l = 0, u = 0;
    for (; s < c; s++) {
      const h = o[s];
      if (h.removed)
        h.value = this.join(a.slice(u, u + h.count)), u += h.count;
      else {
        if (!h.added && this.useLongestToken) {
          let k = n.slice(l, l + h.count);
          k = k.map(function(f, y) {
            const m = a[u + y];
            return m.length > f.length ? m : f;
          }), h.value = this.join(k);
        } else
          h.value = this.join(n.slice(l, l + h.count));
        l += h.count, h.added || (u += h.count);
      }
    }
    return o;
  }
}
class cle extends fE {
}
const sle = new cle();
function lle(e, t, n) {
  return sle.diff(e, t, n);
}
function WA(e, t) {
  let n;
  for (n = 0; n < e.length && n < t.length; n++)
    if (e[n] != t[n])
      return e.slice(0, n);
  return e.slice(0, n);
}
function XA(e, t) {
  let n;
  if (!e || !t || e[e.length - 1] != t[t.length - 1])
    return "";
  for (n = 0; n < e.length && n < t.length; n++)
    if (e[e.length - (n + 1)] != t[t.length - (n + 1)])
      return e.slice(-n);
  return e.slice(-n);
}
function dv(e, t, n) {
  if (e.slice(0, t.length) != t)
    throw Error(`string ${JSON.stringify(e)} doesn't start with prefix ${JSON.stringify(t)}; this is a bug`);
  return n + e.slice(t.length);
}
function uv(e, t, n) {
  if (!t)
    return e + n;
  if (e.slice(-t.length) != t)
    throw Error(`string ${JSON.stringify(e)} doesn't end with suffix ${JSON.stringify(t)}; this is a bug`);
  return e.slice(0, -t.length) + n;
}
function Di(e, t) {
  return dv(e, t, "");
}
function Ic(e, t) {
  return uv(e, t, "");
}
function YA(e, t) {
  return t.slice(0, dle(e, t));
}
function dle(e, t) {
  let n = 0;
  e.length > t.length && (n = e.length - t.length);
  let a = t.length;
  e.length < t.length && (a = e.length);
  const o = Array(a);
  let i = 0;
  o[0] = 0;
  for (let c = 1; c < a; c++) {
    for (t[c] == t[i] ? o[c] = o[i] : o[c] = i; i > 0 && t[c] != t[i]; )
      i = o[i];
    t[c] == t[i] && i++;
  }
  i = 0;
  for (let c = n; c < e.length; c++) {
    for (; i > 0 && e[c] != t[i]; )
      i = o[i];
    e[c] == t[i] && i++;
  }
  return i;
}
function xN(e, t) {
  const n = [];
  for (const a of Array.from(t.segment(e))) {
    const o = a.segment;
    n.length && /\s/.test(n[n.length - 1]) && /\s/.test(o) ? n[n.length - 1] += o : n.push(o);
  }
  return n;
}
function hv(e, t) {
  if (t)
    return Xi(e, t)[1];
  let n;
  for (n = e.length - 1; n >= 0 && e[n].match(/\s/); n--)
    ;
  return e.substring(n + 1);
}
function ri(e, t) {
  if (t)
    return Xi(e, t)[0];
  const n = e.match(/^\s*/);
  return n ? n[0] : "";
}
function Xi(e, t) {
  if (!t)
    return [ri(e), hv(e)];
  if (t.resolvedOptions().granularity != "word")
    throw new Error('The segmenter passed must have a granularity of "word"');
  const n = xN(e, t), a = n[0], o = n[n.length - 1], i = /\s/.test(a) ? a : "", c = /\s/.test(o) ? o : "";
  return [i, c];
}
const KA = "a-zA-Z0-9_\\u{AD}\\u{C0}-\\u{D6}\\u{D8}-\\u{F6}\\u{F8}-\\u{2C6}\\u{2C8}-\\u{2D7}\\u{2DE}-\\u{2FF}\\u{1E00}-\\u{1EFF}", ule = new RegExp(`[${KA}]+|\\s+|[^${KA}]`, "ug");
class hle extends fE {
  equals(t, n, a) {
    return a.ignoreCase && (t = t.toLowerCase(), n = n.toLowerCase()), t.trim() === n.trim();
  }
  tokenize(t, n = {}) {
    let a;
    if (n.intlSegmenter) {
      const c = n.intlSegmenter;
      if (c.resolvedOptions().granularity != "word")
        throw new Error('The segmenter passed must have a granularity of "word"');
      a = xN(t, c);
    } else
      a = t.match(ule) || [];
    const o = [];
    let i = null;
    return a.forEach((c) => {
      /\s/.test(c) ? i == null ? o.push(c) : o.push(o.pop() + c) : i != null && /\s/.test(i) ? o[o.length - 1] == i ? o.push(o.pop() + c) : o.push(i + c) : o.push(c), i = c;
    }), o;
  }
  join(t) {
    return t.map((n, a) => a == 0 ? n : n.replace(/^\s+/, "")).join("");
  }
  postProcess(t, n) {
    if (!t || n.oneChangePerToken)
      return t;
    let a = null, o = null, i = null;
    return t.forEach((c) => {
      c.added ? o = c : c.removed ? i = c : ((o || i) && ZA(a, i, o, c, n.intlSegmenter), a = c, o = null, i = null);
    }), (o || i) && ZA(a, i, o, null, n.intlSegmenter), t;
  }
}
const ple = new hle();
function yle(e, t, n) {
  return ple.diff(e, t, n);
}
function ZA(e, t, n, a, o) {
  if (t && n) {
    const [i, c] = Xi(t.value, o), [s, l] = Xi(n.value, o);
    if (e) {
      const u = WA(i, s);
      e.value = uv(e.value, s, u), t.value = Di(t.value, u), n.value = Di(n.value, u);
    }
    if (a) {
      const u = XA(c, l);
      a.value = dv(a.value, l, u), t.value = Ic(t.value, u), n.value = Ic(n.value, u);
    }
  } else if (n) {
    if (e) {
      const i = ri(n.value, o);
      n.value = n.value.substring(i.length);
    }
    if (a) {
      const i = ri(a.value, o);
      a.value = a.value.substring(i.length);
    }
  } else if (e && a) {
    const i = ri(a.value, o), [c, s] = Xi(t.value, o), l = WA(i, c);
    t.value = Di(t.value, l);
    const u = XA(Di(i, l), s);
    t.value = Ic(t.value, u), a.value = dv(a.value, i, u), e.value = uv(e.value, i, i.slice(0, i.length - u.length));
  } else if (a) {
    const i = ri(a.value, o), c = hv(t.value, o), s = YA(c, i);
    t.value = Ic(t.value, s);
  } else if (e) {
    const i = hv(e.value, o), c = ri(t.value, o), s = YA(i, c);
    t.value = Di(t.value, s);
  }
}
class kle extends fE {
  constructor() {
    super(...arguments), this.tokenize = gle;
  }
  equals(t, n, a) {
    return a.ignoreWhitespace ? ((!a.newlineIsToken || !t.includes(`
`)) && (t = t.trim()), (!a.newlineIsToken || !n.includes(`
`)) && (n = n.trim())) : a.ignoreNewlineAtEof && !a.newlineIsToken && (t.endsWith(`
`) && (t = t.slice(0, -1)), n.endsWith(`
`) && (n = n.slice(0, -1))), super.equals(t, n, a);
  }
}
const fle = new kle();
function mle(e, t, n) {
  return fle.diff(e, t, n);
}
function gle(e, t) {
  t.stripTrailingCr && (e = e.replace(/\r\n/g, `
`));
  const n = [], a = e.split(/(\n|\r\n)/);
  a[a.length - 1] || a.pop();
  for (let o = 0; o < a.length; o++) {
    const i = a[o];
    o % 2 && !t.newlineIsToken ? n[n.length - 1] += i : n.push(i);
  }
  return n;
}
class Mle extends fE {
  tokenize(t) {
    return t.slice();
  }
  join(t) {
    return t;
  }
  removeEmpty(t) {
    return t;
  }
}
const _le = new Mle();
function ble(e, t, n) {
  return _le.diff(e, t, n);
}
function EN({ oldTags: e, newTags: t }) {
  return ble(e, t);
}
function Lle({
  oldTags: e,
  newTags: t
}) {
  const n = EN({ oldTags: e, newTags: t }), a = n.filter((i) => i.removed).flatMap((i) => i.value), o = n.filter((i) => i.added).flatMap((i) => i.value);
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p("div", { className: "flex-1 min-w-0 text-label-sm text-gray-12", children: e.join(", ") }),
    /* @__PURE__ */ p(kE, {}),
    /* @__PURE__ */ C("div", { className: "flex-1 min-w-0 text-label-sm text-gray-12 flex flex-wrap gap-x-2 gap-y-0.5", children: [
      a.map((i) => /* @__PURE__ */ C("span", { className: "text-red-9", children: [
        "- ",
        i
      ] }, `removed-${i}`)),
      o.map((i) => /* @__PURE__ */ C("span", { className: "text-green-10", children: [
        "+ ",
        i
      ] }, `added-${i}`))
    ] })
  ] });
}
const xle = he.memo(Lle);
function QA(e) {
  return typeof e == "string" ? e : "";
}
function vN({ oldText: e, newText: t, compareType: n }) {
  const a = QA(e), o = QA(t);
  switch (n) {
    case di.CHARS:
      return lle(a, o);
    case di.LINES:
      return mle(a, o);
    case di.WORDS:
    default:
      return yle(a, o);
  }
}
function Ele({ oldText: e, newText: t }) {
  const n = Ve(() => vN({ oldText: e, newText: t, compareType: di.WORDS }), [e, t]);
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p("div", { className: "flex-1 min-w-0 text-label-sm text-gray-12", children: e }),
    /* @__PURE__ */ p(kE, {}),
    /* @__PURE__ */ p("div", { className: "flex-1 min-w-0 text-label-sm text-gray-12", children: n.map((a, o) => a.added ? /* @__PURE__ */ p("span", { className: "text-green-10 break-words", children: a.value }, o) : a.removed ? /* @__PURE__ */ p("span", { className: "text-red-9 line-through", children: a.value }, o) : /* @__PURE__ */ p("span", { children: a.value }, o)) })
  ] });
}
const vle = he.memo(Ele), Ale = ({ className: e, fieldDiffs: t = [], needsReview: n = [] }) => {
  const a = (t == null ? void 0 : t.length) + (n == null ? void 0 : n.length);
  return /* @__PURE__ */ C("div", { className: P("flex flex-col w-full rounded-md border border-gray-8 bg-gray-5 p-sm gap-md", e), "data-testid": "DetailDiff", children: [
    /* @__PURE__ */ C(q, { variant: x.LABEL_SMALL_MEDIUM, className: "text-yellow-9 uppercase tracking-wide", children: [
      a,
      " FIELDS CHANGED"
    ] }),
    t && t.length > 0 ? /* @__PURE__ */ p("div", { className: "flex flex-col gap-sm", children: t == null ? void 0 : t.map((o, i) => {
      var c;
      return /* @__PURE__ */ C("div", { className: "flex items-center gap-md", children: [
        /* @__PURE__ */ p("div", { className: "min-w-20 flex-shrink-0 flex items-center", children: /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-black dark:text-white break-words", children: o.label }) }),
        /* @__PURE__ */ C("div", { className: "flex-1 min-w-0 flex items-center gap-md", children: [
          o != null && o.oldImageUrl ? /* @__PURE__ */ p(ile, { oldImageUrl: o.oldImageUrl, newImageUrl: o.newImageUrl }) : null,
          o != null && o.oldTags ? /* @__PURE__ */ p(xle, { oldTags: o.oldTags, newTags: o.newTags, "data-testid": "TagDiffContent" }) : null,
          (o == null ? void 0 : o.oldText) !== void 0 ? /* @__PURE__ */ p(vle, { oldText: o.oldText, newText: o.newText }) : null,
          (c = o == null ? void 0 : o.changes) != null && c.length ? /* @__PURE__ */ p(ole, { oldCount: o.oldCount, changes: o.changes }) : null
        ] })
      ] }, `${o.label}-${i}`);
    }) }) : null,
    n && n.length > 0 ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-sm", children: [
      /* @__PURE__ */ p(q, { variant: x.LABEL_XSMALL_REGULAR, className: "text-gray-10 uppercase tracking-wide", children: "REVIEW BELOW" }),
      /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-sm", children: n.map((o) => {
        const i = /* @__PURE__ */ p(ki, { variant: Bt.OUTLINED, color: jt.WARNING, showDot: !1, children: o });
        return /* @__PURE__ */ p(he.Fragment, { children: i }, o);
      }) }),
      /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: "text-gray-12", children: "These fields have text changes that need direct review — differences can't be summarized." })
    ] }) : null
  ] });
}, kge = he.memo(Ale), Ile = 0.3, Tle = 0.5;
function Nle({ isEnabled: e, onDismiss: t }) {
  const [n, a] = ae(0), o = fe(null);
  le(() => {
    e || a(0);
  }, [e]);
  const i = Q(
    (l) => {
      if (!e)
        return;
      const u = l.currentTarget.closest("[data-drawer-panel]");
      o.current = { startY: l.clientY, startTime: l.timeStamp, panelHeight: (u == null ? void 0 : u.getBoundingClientRect().height) ?? 0 }, l.currentTarget.setPointerCapture(l.pointerId);
    },
    [e]
  ), c = Q((l) => {
    if (o.current === null)
      return;
    const u = Math.max(0, l.clientY - o.current.startY);
    a(u);
  }, []), s = Q(
    (l) => {
      const u = o.current;
      if (o.current = null, u === null)
        return;
      const h = Math.max(0, l.clientY - u.startY), k = Math.max(1, l.timeStamp - u.startTime), f = h / k;
      if ((u.panelHeight > 0 ? h / u.panelHeight : 0) >= Ile || f >= Tle) {
        t();
        return;
      }
      a(0);
    },
    [t]
  );
  return {
    dragOffsetPx: n,
    handlers: { onPointerDown: i, onPointerMove: c, onPointerUp: s }
  };
}
const Cle = "left-0 right-0 bottom-0 w-full max-h-[85vh] rounded-t-2xl", wle = "top-0 h-full w-[250px]", Sle = "bg-gray-3", Rle = "bg-white dark:bg-gray-4", Dle = 400;
function Ole(e) {
  return e === tt.BOTTOM ? "translate-y-full" : e === tt.LEFT ? "-translate-x-full" : "translate-x-full";
}
function Ple(e) {
  return e === tt.BOTTOM ? "" : e === tt.LEFT ? "left-0" : "right-0";
}
function Hle(e, t) {
  return t <= 0 ? e : { ...e, transform: `translateY(${t}px)`, transition: "none" };
}
function Ble(e, t) {
  return e ? `fixed inset-0 z-[100000] ${t}` : "contents";
}
function Fle({ testId: e, isAnimating: t, onClose: n, className: a }) {
  return /* @__PURE__ */ p(
    "div",
    {
      className: `fixed inset-0 bg-black/50 transition-opacity duration-400 ${t ? "opacity-100" : "opacity-0 pointer-events-none"} ${a}`,
      onClick: n,
      "data-testid": e ? `${e}-Overlay` : void 0
    }
  );
}
function $le({ testId: e, handlers: t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      className: "flex shrink-0 touch-none justify-center pb-2 pt-3",
      "aria-hidden": "true",
      onPointerDown: t.onPointerDown,
      onPointerMove: t.onPointerMove,
      onPointerUp: t.onPointerUp,
      onPointerCancel: t.onPointerUp,
      "data-testid": e ? `${e}-DragHandle` : void 0,
      children: /* @__PURE__ */ p("div", { className: "h-1 w-9 rounded-full bg-gray-9" })
    }
  );
}
const mE = ({
  open: e = !1,
  onOpenChange: t,
  children: n,
  position: a = tt.LEFT,
  className: o,
  classNames: i,
  style: c,
  isPortaled: s = !1,
  "data-testid": l
}) => {
  const [u, h] = ae(e), [k, f] = ae(e), y = a === tt.BOTTOM;
  le(() => {
    if (e) {
      f(!0), h(!0);
      return;
    }
    h(!1);
    const O = setTimeout(() => {
      f(!1);
    }, Dle);
    return () => {
      clearTimeout(O);
    };
  }, [e]);
  const m = Q(() => t(!1), [t]), { dragOffsetPx: g, handlers: _ } = Nle({ isEnabled: y && u, onDismiss: m }), L = Ole(a), N = y ? "translate-y-0" : "translate-x-0", I = Hle(c, g), S = /* @__PURE__ */ C("div", { className: Ble(k, i == null ? void 0 : i.base), "data-testid": l, children: [
    k ? /* @__PURE__ */ p(Fle, { testId: l, isAnimating: u, onClose: m, className: i == null ? void 0 : i.overlay }) : null,
    /* @__PURE__ */ C(
      "div",
      {
        className: `
          flex flex-col fixed shadow-lg
          ${y ? Sle : Rle}
          transform transition-transform duration-400
          ${u ? N : L}
          ${y ? Cle : wle}
          ${Ple(a)}
          ${o}
          ${i == null ? void 0 : i.drawer}
        `,
        style: I,
        inert: !k,
        "data-drawer-panel": "",
        "data-testid": l ? `${l}-Panel` : void 0,
        children: [
          y ? /* @__PURE__ */ p($le, { testId: l, handlers: _ }) : null,
          y ? /* @__PURE__ */ p("div", { className: "min-h-0 flex-1 overflow-y-auto", children: n }) : n
        ]
      }
    )
  ] });
  return s ? sE(S, document.body) : S;
}, fge = ({
  children: e,
  content: t,
  placement: n = "bottom-end",
  isOpen: a,
  onOpenChange: o,
  className: i,
  closeOnClickOutside: c = !0,
  closeOnScroll: s = !0
}) => {
  const {
    isDropdownOpen: l,
    handleOpenChange: u,
    containerRef: h,
    dropdownRef: k,
    maxHeight: f,
    maxWidth: y
  } = iN({
    isOpen: a,
    onOpenChange: o,
    closeOnClickOutside: c,
    closeOnScroll: s,
    placement: n
  });
  return /* @__PURE__ */ C("div", { ref: h, className: "relative", children: [
    /* @__PURE__ */ p(
      "div",
      {
        onClick: (g) => {
          g.stopPropagation(), u(!l);
        },
        children: e
      }
    ),
    l && /* @__PURE__ */ p(
      "div",
      {
        ref: k,
        className: P(
          "absolute w-max z-[100] bg-white dark:bg-gray-5 rounded-[10px] border border-gray-4",
          f !== void 0 && "overflow-y-auto",
          y !== void 0 && "overflow-x-hidden",
          (() => {
            switch (n) {
              case "bottom-start":
                return "left-0 top-full mt-1";
              case "bottom-end":
                return "right-0 top-full mt-1";
              case "top-start":
                return "left-0 bottom-full mb-1";
              case "top-end":
                return "right-0 bottom-full mb-1";
              default:
                return "left-0 top-full mt-1";
            }
          })(),
          i
        ),
        style: {
          boxShadow: "0px 6px 24px 0px rgba(0, 0, 0, 0.18)",
          maxHeight: f,
          maxWidth: y
        },
        children: t
      }
    )
  ] });
}, AN = ({
  error: e = !1,
  errorMessage: t = "",
  helperText: n = "",
  maxLength: a = 0,
  showMaxLengthLabel: o = !0,
  count: i = 0,
  countLabel: c = ""
}) => {
  const s = e && t ? t : n, l = a > 0 && o || i > 0 || c.length > 0;
  return s.length > 0 || l;
}, jv = ({
  helperText: e = "",
  error: t = !1,
  errorMessage: n,
  maxLength: a = 0,
  countLabel: o = "",
  count: i = 0,
  characterLength: c = 0,
  showMaxLengthLabel: s = !0
}) => {
  if (!n && !e && !a && !i && !o)
    return null;
  const l = [];
  return a > 0 && s && l.push(`${c}/${a}`), i > 0 && l.push(i.toString()), o && l.push(o), /* @__PURE__ */ C("div", { className: "flex justify-between", children: [
    (n || e) && /* @__PURE__ */ p(
      q,
      {
        variant: x.LABEL_SMALL_REGULAR,
        className: `${t ? "text-red-9" : "text-gray-11"}`,
        children: t && n ? n : e
      }
    ),
    !!l.length && /* @__PURE__ */ p(
      q,
      {
        variant: x.LABEL_SMALL_REGULAR,
        className: "ml-auto max-w-max text-gray-10 whitespace-nowrap",
        children: l.join(" ")
      }
    )
  ] });
}, Ule = {
  [me.XSMALL]: {
    label: x.LABEL_MEDIUM_REGULAR,
    description: x.LABEL_XSMALL_REGULAR
  },
  [me.SMALL]: {
    label: x.LABEL_LARGE_MEDIUM,
    description: x.LABEL_SMALL_REGULAR
  },
  [me.MEDIUM]: {
    label: x.LABEL_LARGE_MEDIUM,
    description: x.LABEL_SMALL_REGULAR
  }
}, Vv = ({
  label: e,
  description: t,
  labelRightElement: n,
  fieldInfoLink: a,
  fieldInfoLinkTarget: o,
  size: i,
  required: c,
  tooltipLabel: s
}) => {
  if (!e && !t && !n)
    return null;
  const l = Ule[i];
  return /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
    e || t ? /* @__PURE__ */ C("div", { children: [
      e ? /* @__PURE__ */ C("div", { className: "flex gap-1 items-center", children: [
        /* @__PURE__ */ p(q, { variant: l.label, className: "block", children: e }),
        c ? /* @__PURE__ */ p(q, { className: "text-red-10", children: "*" }) : null,
        a ? /* @__PURE__ */ p(jT, { target: o || "_blank", to: a, className: "flex flex-row items-center", children: /* @__PURE__ */ p(oe, { icon: R.INFO, size: ye.SMALL, className: "text-gray-10" }) }) : null,
        s ? /* @__PURE__ */ p(Nt, { title: s, placement: tt.TOP, children: /* @__PURE__ */ p(oe, { icon: R.INFO, size: ye.SMALL, className: "text-gray-10" }) }) : null
      ] }) : null,
      t ? /* @__PURE__ */ p(q, { variant: l.description, className: "text-gray-11", children: t }) : null
    ] }) : null,
    n ? /* @__PURE__ */ p("div", { className: "flex items-center gap-2 ml-auto", children: n }) : null
  ] });
};
var gE = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.EDITOR = "Editor", e))(gE || {});
const qle = {
  size: me.MEDIUM,
  variant: gE.DEFAULT,
  isClearable: !1,
  placeholder: "Enter something",
  error: !1,
  disabled: !1,
  width: "100%",
  label: "",
  description: "",
  helperText: "",
  className: "",
  errorMessage: "",
  loading: !1,
  required: !1,
  countLabel: "",
  count: 0,
  labelRightElement: null,
  showMaxLengthLabel: !0,
  tooltipLabel: "",
  readOnly: !1
}, zle = (e) => {
  const t = { ...e };
  return Object.entries(qle).forEach(([n, a]) => {
    t[n] === void 0 && (t[n] = a);
  }), t;
}, jle = /^(label|paragraph|heading|mobile-heading|display)-/, Vle = ["sm", "md", "lg", "xl"], Gle = (e) => jle.test(e), Wle = pc({
  extend: {
    theme: {
      spacing: Vle
    },
    classGroups: {
      "font-size": [{ text: [Gle] }]
    }
  }
}), sc = (...e) => Wle(wn(e)), Xle = {
  [me.XSMALL]: { container: "min-h-8", input: "text-sm" },
  [me.SMALL]: { container: "min-h-9", input: "text-label-lg" },
  [me.MEDIUM]: { container: "min-h-11", input: "text-label-lg" }
}, Yle = "flex items-center px-2.5", Kle = "rounded-md transition-colors duration-200 flex-shrink flex-wrap gap-sm py-sm", Zle = "ring-2 ring-red-9 ring-inset", Qle = "ring-2 ring-blue-10 ring-inset", Jle = "ring-1 ring-gray-7 dark:ring-gray-8 ring-inset", e0e = "bg-gray-4 !ring-gray-4", t0e = "flex-grow h-full bg-transparent", n0e = "text-gray-12 placeholder:text-gray-10 focus:outline-none", a0e = "flex items-center flex-wrap gap-sm min-h-[38px] px-3 py-1 rounded-[8px] border border-solid bg-gray-3 transition-colors duration-200 flex-shrink", o0e = "border-red-9", r0e = "border-blue-10", i0e = "border-gray-8", c0e = "bg-gray-4 border-gray-4", s0e = "flex-grow h-full min-w-0 bg-transparent text-sm text-gray-12 placeholder:text-gray-11 focus:outline-none", IN = "opacity-50 cursor-not-allowed", TN = "pr-10", NN = ({
  error: e,
  isFocused: t,
  classNames: n
}) => e ? n.error : t ? n.focused : n.idle, CN = ({ disabled: e, readOnly: t }) => e ? "cursor-not-allowed" : t ? "cursor-default" : "", l0e = ({
  error: e,
  isFocused: t,
  disabled: n,
  readOnly: a,
  isMultiSelect: o,
  isClearable: i,
  className: c,
  inputClassName: s
}) => ({
  container: sc(
    a0e,
    NN({
      error: e,
      isFocused: t,
      classNames: { error: o0e, focused: r0e, idle: i0e }
    }),
    n ? IN : "",
    a ? c0e : "",
    a && !n ? "cursor-default" : "",
    o && i ? TN : "",
    c
  ),
  input: sc(s0e, CN({ disabled: n, readOnly: a }), s)
}), d0e = ({
  size: e,
  error: t,
  isFocused: n,
  disabled: a,
  readOnly: o,
  isMultiSelect: i,
  isClearable: c,
  className: s,
  inputClassName: l
}) => {
  const u = Xle[e];
  return {
    container: sc(
      Yle,
      u.container,
      NN({
        error: t,
        isFocused: n,
        classNames: { error: Zle, focused: Qle, idle: Jle }
      }),
      a ? IN : "",
      o ? e0e : "",
      o && !a ? "cursor-default" : "",
      Kle,
      i && c ? TN : "",
      s
    ),
    input: sc(
      t0e,
      u.input,
      n0e,
      CN({ disabled: a, readOnly: o }),
      l
    )
  };
}, u0e = (e) => e.variant === gE.EDITOR ? l0e(e) : d0e(e), h0e = ({ icon: e, size: t, isClearable: n, isMultiSelect: a, hasValue: o, error: i, loading: c, disabled: s, className: l, onClear: u }) => !e && !n && !c ? null : /* @__PURE__ */ p(
  wt,
  {
    icon: e,
    variant: J.TRANSPARENT,
    size: t,
    type: "button",
    onClick: u,
    className: P(
      "size-auto",
      a ? "absolute top-6 right-2.5 transform -translate-y-1/2" : "",
      !n || !o || i ? "cursor-default" : void 0,
      l
    ),
    loading: c,
    disabled: s,
    "aria-label": n ? "clear" : "end-icon"
  }
), p0e = ({ value: e, index: t, disabled: n, onPressSelected: a }) => {
  const o = Q(() => a == null ? void 0 : a(e, t), [a, e, t]);
  return /* @__PURE__ */ p(Vt, { iconEnd: R.CLOSE, onClick: o, disabled: n, className: n ? "!opacity-100" : "", children: e });
}, y0e = ({ disabled: e, onFocus: t, onBlur: n }) => {
  const [a, o] = ae(!1), i = Q(
    (s) => {
      e || (t == null || t(s), o(!0));
    },
    [e, t]
  ), c = Q(
    (s) => {
      e || (n == null || n(s), o(!1));
    },
    [e, n]
  );
  return { stateIsFocused: a, handleFocus: i, handleBlur: c };
}, k0e = {
  [me.XSMALL]: {
    icon: ye.SMALL,
    button: _e.SMALL
  },
  [me.SMALL]: {
    icon: ye.MEDIUM,
    button: _e.MEDIUM
  },
  [me.MEDIUM]: {
    icon: ye.MEDIUM,
    button: _e.MEDIUM
  }
}, f0e = {}, m0e = ({
  size: e,
  variant: t,
  isClearable: n,
  onClear: a,
  onFocus: o,
  onBlur: i,
  placeholder: c,
  error: s,
  disabled: l,
  iconEnd: u,
  iconStart: h,
  className: k,
  loading: f,
  focused: y,
  readOnly: m,
  maxLength: g,
  selected: _,
  onPressSelected: L,
  classNames: N,
  currentInputValue: I,
  onValueChange: S,
  onInputChange: O,
  ...A
}) => {
  const B = fe(null), { stateIsFocused: z, handleFocus: j, handleBlur: G } = y0e({ disabled: l, onFocus: o, onBlur: i }), { input: $ = "", iconStart: H = "", iconEnd: ee } = N || f0e, Y = Array.isArray(_), U = Y && _.length > 0, Z = U || !!I, te = k0e[e], re = u0e({
    variant: t,
    size: e,
    error: s,
    isFocused: !!(y || z),
    disabled: l,
    readOnly: m,
    isMultiSelect: Y,
    isClearable: n,
    className: k,
    inputClassName: $
  }), ue = Q(() => {
    var E;
    n && (a == null || a(), S(""), (E = B.current) == null || E.focus());
  }, [n, a, S]);
  return /* @__PURE__ */ C("div", { className: re.container, "data-testid": "Input-Container", children: [
    h ? /* @__PURE__ */ p(oe, { icon: h, className: sc(te.icon, "mr-2.5", H) }) : null,
    U ? _.map((E, ve) => /* @__PURE__ */ p(p0e, { value: E, index: ve, disabled: l, onPressSelected: L }, `${ve}-${E}`)) : null,
    /* @__PURE__ */ p(
      "input",
      {
        ref: B,
        value: I,
        onChange: O,
        placeholder: U ? void 0 : c,
        disabled: l,
        readOnly: m,
        className: re.input,
        maxLength: g,
        ...A,
        onFocus: j,
        onBlur: G
      }
    ),
    /* @__PURE__ */ p(
      h0e,
      {
        icon: n && Z ? R.CLOSE : u,
        size: te.button,
        isClearable: n,
        isMultiSelect: Y,
        hasValue: Z,
        error: s,
        loading: f,
        disabled: l,
        className: ee || "",
        onClear: ue
      }
    )
  ] });
}, Oi = (e) => (e ?? 0) > 0, g0e = ({ value: e, debounceTimeout: t, onChange: n }) => {
  const [a, o] = ae(e || ""), i = e !== void 0, c = Oi(t), s = i && !c ? e ?? "" : a, l = fe(null), u = fe(s || ""), h = Q(() => {
    l.current && (clearTimeout(l.current), l.current = null);
  }, []);
  le(() => {
    i && Oi(t) && (o(e || ""), h(), u.current = e || "");
  }, [e, i, t, h]);
  const k = Q(
    (y) => {
      if ((!i || Oi(t)) && o(y), !Oi(t)) {
        h(), n == null || n(y);
        return;
      }
      u.current = y, l.current && clearTimeout(l.current), l.current = setTimeout(() => {
        n == null || n(u.current);
      }, t);
    },
    [i, t, n, h]
  ), f = Q(
    (y) => {
      k(y.target.value);
    },
    [k]
  );
  return le(() => {
    Oi(t) || h();
  }, [t, h]), le(() => () => {
    l.current && clearTimeout(l.current);
  }, []), { currentInputValue: s, handleValueChange: k, handleInputChange: f };
}, xi = (e) => {
  const {
    width: t,
    label: n,
    description: a,
    labelRightElement: o,
    required: i,
    fieldInfoLink: c,
    fieldInfoLinkTarget: s,
    tooltipLabel: l,
    helperText: u,
    errorMessage: h,
    count: k,
    countLabel: f,
    showMaxLengthLabel: y,
    hideEmptyFooter: m,
    maxSelectionLength: g,
    value: _,
    debounceTimeout: L,
    onChange: N,
    ...I
  } = zle(e), { size: S, readOnly: O, error: A, maxLength: B, selected: z } = I, { currentInputValue: j, handleValueChange: G, handleInputChange: $ } = g0e({ value: _, debounceTimeout: L, onChange: N }), H = Array.isArray(z), ee = H ? z.length : j.trim().length, Y = H ? g : B, U = !O && (!m || AN({ error: A, errorMessage: h, helperText: u, maxLength: Y, showMaxLengthLabel: y, count: k, countLabel: f })), Z = Ve(() => ({ maxWidth: t }), [t]);
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-1.5 w-full flex-shrink", style: Z, children: [
    /* @__PURE__ */ p(
      Vv,
      {
        label: n,
        description: O ? "" : a,
        labelRightElement: O ? null : o,
        size: S,
        required: O ? !1 : i,
        fieldInfoLink: c,
        fieldInfoLinkTarget: s,
        tooltipLabel: O ? "" : l
      }
    ),
    /* @__PURE__ */ p(m0e, { ...I, currentInputValue: j, onValueChange: G, onInputChange: $ }),
    U ? /* @__PURE__ */ p(
      jv,
      {
        error: A,
        errorMessage: h,
        helperText: u,
        maxLength: Y,
        count: k,
        countLabel: f,
        characterLength: ee,
        showMaxLengthLabel: y
      }
    ) : null
  ] });
};
xi.displayName = "Input";
const M0e = (e) => e.filter((t) => t.variant && t.variant !== ut.DEFAULT).length, wN = Ov(null);
function Ei() {
  const e = Dv(wN);
  if (e === null)
    throw new Error("Filter context must be used inside the Filter component or its subtree");
  return e;
}
const _0e = ({ children: e, value: t }) => /* @__PURE__ */ p(wN.Provider, { value: t, children: e });
var nn = /* @__PURE__ */ ((e) => (e.RESET = "Reset", e.INCLUDE = "Include", e.EXCLUDE = "Exclude", e))(nn || {});
function b0e({
  variant: e = ut.DEFAULT,
  label: t = "",
  value: n = "",
  count: a = null,
  subtitle: o,
  actionHandler: i = () => null,
  excludable: c = !1,
  className: s = "",
  ...l
}) {
  const u = e === ut.DEFAULT, h = e === ut.INCLUDE, k = e === ut.EXCLUDE, f = o !== void 0, y = () => {
    const _ = e === ut.EXCLUDE ? nn.EXCLUDE : nn.INCLUDE;
    i(_, n);
  }, m = () => {
    i(nn.INCLUDE, n);
  }, g = () => {
    i(nn.EXCLUDE, n);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      onClick: y,
      className: P("flex justify-between px-2.5 py-[3px] cursor-pointer transition-colors duration-200 gap-1", s, !u && "bg-gray-6"),
      ...l,
      children: [
        /* @__PURE__ */ C("div", { className: "flex gap-2 flex-shrink", children: [
          /* @__PURE__ */ p(Nt, { title: "Include", visible: u, children: /* @__PURE__ */ p(
            gi,
            {
              id: `include_${n}`,
              size: me.SMALL,
              checked: h,
              className: `flex items-center ${h && "!bg-blue-2 !border-blue-5"} ${k && "!bg-gray-4 !border-gray-7/20 dark:!border-gray-6/10 dark:!bg-gray-4"} ${u && "!bg-gray-3 !border-gray-7/30 dark:!border-gray-6"}`,
              classNames: {
                icon: "!text-black dark:!text-white"
              },
              wrapperClassName: "mt-1",
              disabled: k,
              icon: R.PLUS,
              onChange: m,
              onClick: (_) => _ == null ? void 0 : _.stopPropagation()
            }
          ) }),
          /* @__PURE__ */ C("div", { className: f ? "flex flex-col cursor-pointer select-none" : "flex gap-1 cursor-pointer select-none ", children: [
            /* @__PURE__ */ p(
              q,
              {
                as: "label",
                htmlFor: k ? `exclude_${n}` : `include_${n}`,
                variant: x.LABEL_LARGE_REGULAR,
                className: "text-gray-900 dark:text-white flex-shrink ",
                children: t
              }
            ),
            f ? /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-10 dark:text-gray-12/80", children: o }) : null
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "flex gap-sm pt-1", children: [
          u && a !== null ? /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-10 dark:text-gray-12/80 italic align-bottom whitespace-nowrap", children: a }) : null,
          c ? /* @__PURE__ */ p(Nt, { title: "Exclude", visible: u, children: /* @__PURE__ */ p(
            gi,
            {
              id: `exclude_${n}`,
              size: me.SMALL,
              checked: k,
              className: `flex items-center ${k && "!bg-red-2 !border-red-5"} ${u && "!bg-gray-6/80 !border-gray-6/10"} ${h && "!bg-gray-7/10 !border-gray-6/10"}`,
              classNames: {
                icon: `${(u || h) && "!text-black/40 dark:!text-white"} ${k && "!text-black dark:!text-white"} ${h && "opacity-50 dark:opacity-30"} `
              },
              disabled: h,
              icon: R.MINUS,
              onChange: g,
              indeterminate: !0,
              onClick: (_) => _ == null ? void 0 : _.stopPropagation()
            }
          ) }) : null
        ] })
      ]
    }
  );
}
const L0e = 300, x0e = "Filter", E0e = { width: "100%" }, v0e = ({ children: e }) => {
  const { expanded: t, setExpanded: n, testIdPrefix: a } = Ei(), o = Q(
    (c) => {
      c.target.closest("[data-role='reset']") || n(!t);
    },
    [t, n]
  ), i = Q(
    (c) => {
      if (c.key === "Enter" || c.key === " ") {
        if (c.target.closest("[data-role='reset']")) return;
        c.preventDefault(), n(!t);
      }
    },
    [t, n]
  );
  return /* @__PURE__ */ p("div", { className: "flex justify-between items-center bg-gray-5 ", children: /* @__PURE__ */ p(
    "div",
    {
      role: "button",
      "data-testid": `${a}-Header`,
      tabIndex: 0,
      className: "bg-transparent border-none flex justify-between p-2.5 cursor-pointer",
      style: E0e,
      onClick: o,
      onKeyDown: i,
      children: e
    }
  ) });
}, A0e = () => {
  const { expanded: e, allItems: t, testIdPrefix: n } = Ei(), a = Ve(() => M0e(t), [t]);
  return e || a === 0 ? null : /* @__PURE__ */ p(ki, { variant: Bt.COLORED, size: Yn.SMALL, showDot: !1, "data-testid": `${n}-CountPill`, children: String(a) });
}, I0e = ({ children: e }) => {
  const { expanded: t } = Ei();
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-2 cursor-pointer", children: [
    /* @__PURE__ */ p(
      wt,
      {
        size: _e.MEDIUM,
        className: "w-auto h-auto",
        variant: J.TRANSPARENT,
        icon: t ? R.CHEVRON_DOWN : R.CHEVRON_RIGHT
      }
    ),
    /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_MEDIUM_MEDIUM, className: "text-gray-900 dark:text-white grow-1", children: e }),
    /* @__PURE__ */ p(A0e, {})
  ] });
}, T0e = ({ children: e, alwaysShow: t = !1 }) => {
  const { setSearchedItem: n, actionHandler: a, filteredItems: o } = Ei(), i = o.some((s) => s.variant && s.variant !== ut.DEFAULT), c = Q(() => {
    n(""), a(nn.RESET, "");
  }, [a, n]);
  return !t && !i ? null : /* @__PURE__ */ p("span", { className: "contents", children: /* @__PURE__ */ p("button", { "data-role": "reset", onClick: c, className: "text-sm text-blue-10 cursor-pointer bg-transparent", children: /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, children: e }) }) });
}, N0e = ({ children: e }) => {
  const { searchedItem: t, handleSearch: n, expanded: a } = Ei();
  return a ? /* @__PURE__ */ p("div", { className: "p-2.5", children: /* @__PURE__ */ p(
    xi,
    {
      value: t,
      debounceTimeout: L0e,
      isClearable: !!t,
      onChange: n,
      size: me.XSMALL,
      placeholder: e
    }
  ) }) : null;
}, C0e = ({ hasExclude: e = !1 }) => {
  const { expanded: t, filteredItems: n, actionHandler: a } = Ei();
  return t ? /* @__PURE__ */ p("div", { className: "overflow-y-auto overflow-x-hidden filterscroll", children: n.map((o, i) => /* @__PURE__ */ p(
    b0e,
    {
      label: o.label,
      value: o.value,
      count: o.count,
      subtitle: o.subtitle,
      variant: o.variant,
      actionHandler: a,
      excludable: e
    },
    `${o.value}_${o.variant}_${i}`
  )) }) : null;
};
function mc({ data: e = [], actionHandler: t = () => null, style: n, isOpen: a = !1, children: o, dataTestId: i = "" }) {
  const [c, s] = ae(""), [l, u] = ae(a), h = i || x0e, k = Ve(
    () => e == null ? void 0 : e.filter((g) => {
      var _, L;
      return (L = (_ = g == null ? void 0 : g.label) == null ? void 0 : _.toLowerCase()) == null ? void 0 : L.includes(c == null ? void 0 : c.toLowerCase());
    }),
    [e, c]
  ), f = Q((g) => {
    s(g);
  }, []), y = Ve(
    () => ({
      searchedItem: c,
      setSearchedItem: s,
      expanded: l,
      setExpanded: u,
      actionHandler: t,
      handleSearch: f,
      testIdPrefix: h,
      filteredItems: k,
      allItems: e
    }),
    [c, l, t, f, h, k, e]
  ), m = Ve(() => ({ ...n }), [n]);
  return /* @__PURE__ */ p("div", { style: m, className: "min-h-0 min-w-0 max-h-[520px] flex flex-col", "data-testid": i, children: /* @__PURE__ */ p("div", { className: "border border-solid border-gray-7/40 dark:border-gray-8 rounded-md flex-shrink h-full flex flex-col overflow-hidden", children: /* @__PURE__ */ p(_0e, { value: y, children: o }) }) });
}
mc.Title = Object.assign(I0e, { __fKey: "FilterTitle" });
mc.Header = Object.assign(v0e, { __fKey: "FilterHeader" });
mc.Reset = Object.assign(T0e, { __fKey: "FilterReset" });
mc.Search = Object.assign(N0e, { __fKey: "FilterSearch" });
mc.Body = Object.assign(C0e, { __fKey: "FilterBody" });
const mge = ({
  count: e,
  countAriaLabel: t,
  isActive: n = !1,
  onClick: a,
  "aria-label": o,
  "aria-controls": i,
  "data-testid": c = "FilterToggleButton"
}) => {
  const s = he.useId(), l = P(
    "h-[38px] w-[46px] !rounded-[7px] border border-gray-7 p-0 dark:border-gray-8",
    n ? "outline outline-[1.5px] outline-gray-8 dark:outline-gray-9" : ""
  );
  return /* @__PURE__ */ C("span", { className: "relative inline-flex", "data-testid": c, children: [
    /* @__PURE__ */ p(
      wt,
      {
        "aria-label": o,
        "aria-expanded": n,
        "aria-controls": i,
        "aria-describedby": e > 0 && t !== void 0 ? s : void 0,
        className: l,
        "data-testid": `${c}-Button`,
        icon: R.SLIDER_VERTICAL,
        onClick: a,
        shape: we.SQUARE,
        size: _e.MEDIUM,
        variant: J.OUTLINED
      }
    ),
    e > 0 && t !== void 0 ? /* @__PURE__ */ p("span", { className: "sr-only", "data-testid": `${c}-CountDescription`, id: s, children: t }) : null,
    e > 0 ? /* @__PURE__ */ p(
      "span",
      {
        "aria-hidden": "true",
        className: "pointer-events-none absolute -right-[7px] -top-[7px] flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-gray-12 px-1 text-[11px] font-semibold leading-[18px] text-gray-1",
        "data-testid": `${c}-CountBadge`,
        children: e
      }
    ) : null
  ] });
}, hi = (e) => {
  const t = e ?? ut.DEFAULT, n = t === ut.INCLUDE, a = t === ut.EXCLUDE;
  return {
    variant: t,
    isIncluded: n,
    isExcluded: a,
    isSelected: n || a
  };
}, SN = Ov(void 0), Zn = () => {
  const e = Dv(SN);
  if (!e)
    throw new Error("FilterV2 components must be used within FilterV2");
  return e;
}, JA = {
  excluded: { icon: "!text-white" },
  default: { icon: "!text-gray-10" }
}, w0e = ({ value: e, label: t, variant: n, optionTestId: a, "data-testid": o }) => {
  const { actionHandler: i, getExcludeAriaLabel: c } = Zn(), { isExcluded: s, isIncluded: l } = hi(n), u = c(t), h = Q(() => {
    i(nn.EXCLUDE, e);
  }, [i, e]), k = Q((f) => {
    f.stopPropagation();
  }, []);
  return /* @__PURE__ */ p("span", { className: "shrink-0", "data-testid": o ?? `${a}-ExcludeToggle`, children: /* @__PURE__ */ p(
    gi,
    {
      "aria-label": u,
      checked: s,
      className: `flex items-center ${s ? "!bg-red-9 !border-red-9" : "!bg-transparent !border-gray-7 dark:!border-gray-8"}`,
      classNames: s ? JA.excluded : JA.default,
      "data-testid": `${a}-Exclude`,
      disabled: l,
      icon: R.MINUS,
      id: `${a}-Exclude`,
      indeterminate: !0,
      onChange: h,
      onClick: k,
      size: me.SMALL
    }
  ) });
}, S0e = {
  icon: "!text-white"
}, R0e = ({ option: e, hasExclude: t = !1, "data-testid": n }) => {
  const { actionHandler: a, getIncludeAriaLabel: o, testId: i } = Zn(), { variant: c, isIncluded: s, isExcluded: l, isSelected: u } = hi(e.variant), h = n ?? `${i}-Option-${e.value}`, k = o(e.label), f = Q(() => {
    a(l ? nn.EXCLUDE : nn.INCLUDE, e.value);
  }, [a, l, e.value]), y = Q((_) => {
    _.stopPropagation();
  }, []), m = Q(() => {
    a(nn.INCLUDE, e.value);
  }, [a, e.value]), g = e.subtitle ? /* @__PURE__ */ C("span", { className: "flex min-w-0 flex-col", children: [
    /* @__PURE__ */ p(q, { as: "span", className: "text-[15px] font-semibold leading-[18px] text-gray-12", variant: x.LABEL_MEDIUM_MEDIUM, children: e.label }),
    /* @__PURE__ */ p(q, { as: "span", className: "whitespace-nowrap text-[11px] font-normal leading-[14px] text-gray-10", variant: x.LABEL_SMALL_REGULAR, children: e.subtitle })
  ] }) : /* @__PURE__ */ p(q, { as: "span", className: "text-[14px] font-normal leading-5 text-gray-12", variant: x.PARAGRAPH_MEDIUM_REGULAR, children: e.label });
  return /* @__PURE__ */ C(
    "div",
    {
      className: P(
        "flex cursor-pointer items-center justify-between gap-2.5 hover:bg-gray-6 active:outline active:outline-1 active:outline-gray-8 dark:active:outline-gray-9",
        e.subtitle ? "items-start px-2 py-[3px]" : "px-2.5 py-[5.5px]",
        u ? "bg-gray-6 dark:bg-gray-5" : "",
        e.className
      ),
      "data-testid": h,
      onClick: f,
      children: [
        /* @__PURE__ */ C("div", { className: P("flex min-w-0 flex-1", e.subtitle ? "items-start gap-2" : "items-center gap-2.5"), children: [
          /* @__PURE__ */ p(
            gi,
            {
              "aria-label": k,
              checked: s,
              className: `flex items-center ${s ? "!bg-blue-10 !border-blue-10" : ""} ${l ? "!bg-gray-5 !border-transparent dark:!border-transparent dark:!bg-gray-7" : ""} ${u ? "" : "!bg-gray-5 !border-transparent dark:!border-transparent dark:!bg-gray-7"}`,
              classNames: S0e,
              "data-testid": `${h}-Include`,
              disabled: l,
              icon: R.CHECK,
              id: `${h}-Include`,
              onChange: m,
              onClick: y,
              size: me.SMALL
            }
          ),
          g
        ] }),
        /* @__PURE__ */ C("div", { className: "flex shrink-0 items-center gap-2", children: [
          !u && e.count !== null ? /* @__PURE__ */ p(
            q,
            {
              as: "span",
              className: "text-[11px] font-normal italic leading-[14px] text-gray-10",
              "data-testid": `${h}-Count`,
              variant: x.LABEL_SMALL_REGULAR,
              children: e.count
            }
          ) : null,
          t ? /* @__PURE__ */ p(w0e, { label: e.label, optionTestId: h, value: e.value, variant: c }) : null
        ] })
      ]
    }
  );
}, D0e = (e, { floatSelected: t = !0, search: n = "" } = {}) => {
  const a = n.trim().toLocaleLowerCase(), o = a ? e.filter((l) => l.label.toLocaleLowerCase().includes(a)) : e;
  if (!t)
    return o;
  const i = o.filter((l) => hi(l.variant).isExcluded), c = o.filter((l) => hi(l.variant).isIncluded), s = o.filter((l) => !hi(l.variant).isSelected);
  return [...i, ...c, ...s];
}, O0e = ({
  hasExclude: e = !1,
  className: t,
  floatSelected: n = !0,
  emptySearchText: a,
  "data-testid": o,
  children: i
}) => {
  const { items: c, isOpen: s, search: l, testId: u } = Zn(), h = Ve(() => D0e(c, { floatSelected: n, search: l }), [c, n, l]), k = !!(a && l.trim() && h.length === 0), f = Ve(
    () => h.map((y) => /* @__PURE__ */ p(R0e, { hasExclude: e, option: y }, y.value)),
    [e, h]
  );
  return s ? /* @__PURE__ */ C("div", { className: P("filter-v2-scrollbar overflow-auto pb-1.5 pt-1", t), "data-testid": o ?? `${u}-Body`, children: [
    i,
    k ? /* @__PURE__ */ p("p", { className: "px-2.5 py-[5.5px] text-[11px] font-normal leading-[14px] text-gray-10", "data-testid": `${u}-EmptySearch`, role: "status", children: a }) : null,
    f
  ] }) : null;
}, RN = (e) => e.filter((t) => hi(t.variant).isSelected).length, P0e = ({ "data-testid": e }) => {
  const { items: t, testId: n } = Zn(), a = RN(t);
  return a === 0 ? null : /* @__PURE__ */ C(
    q,
    {
      as: "span",
      className: "text-xs font-normal leading-4 text-gray-11",
      "data-testid": e ?? `${n}-Count`,
      variant: x.LABEL_SMALL_REGULAR,
      children: [
        "(",
        a,
        ")"
      ]
    }
  );
}, H0e = ({ children: e, "data-testid": t }) => {
  const { isOpen: n, onOpenChange: a, testId: o } = Zn(), i = Q(() => a(!n), [n, a]), c = Q(
    (s) => {
      s.key !== "Enter" && s.key !== " " || (s.preventDefault(), a(!n));
    },
    [n, a]
  );
  return /* @__PURE__ */ C(
    "div",
    {
      "aria-expanded": n,
      className: "flex h-[34px] w-full shrink-0 cursor-pointer items-center gap-2 bg-gray-5 px-2.5 text-left",
      "data-testid": t ?? `${o}-Header`,
      onClick: i,
      onKeyDown: c,
      role: "button",
      tabIndex: 0,
      children: [
        /* @__PURE__ */ p(oe, { className: `h-4 w-4 shrink-0 transition-transform ${n ? "rotate-90" : ""}`, icon: R.CHEVRON_RIGHT }),
        /* @__PURE__ */ p("div", { className: "flex min-w-0 flex-1 items-center gap-1", children: e })
      ]
    }
  );
}, B0e = ({ alwaysShow: e = !1, children: t, "data-testid": n }) => {
  const { actionHandler: a, items: o, setSearch: i, testId: c } = Zn(), s = RN(o), l = Q(
    (h) => {
      h.stopPropagation(), i(""), a(nn.RESET, "");
    },
    [a, i]
  ), u = Q((h) => {
    h.stopPropagation();
  }, []);
  return !e && s === 0 ? null : /* @__PURE__ */ p(
    "button",
    {
      className: "m-0 shrink-0 border-0 bg-transparent p-0 cursor-pointer ml-auto text-[11px] font-medium leading-4 text-blue-10",
      "data-testid": n ?? `${c}-Reset`,
      onClick: l,
      onKeyDown: u,
      type: "button",
      children: t
    }
  );
}, F0e = {
  input: "text-[13px] leading-5"
}, $0e = ({ placeholder: e = "", "aria-label": t, "data-testid": n }) => {
  const { isOpen: a, search: o, setSearch: i, testId: c } = Zn();
  return a ? /* @__PURE__ */ p("div", { className: "px-2.5 pb-1 pt-1.5", "data-testid": n ?? `${c}-Search`, children: /* @__PURE__ */ p(
    xi,
    {
      className: "h-[35px] min-h-[35px] rounded-[5px] border-gray-7 bg-transparent dark:border-gray-8",
      classNames: F0e,
      "data-testid": `${c}-SearchInput`,
      hideEmptyFooter: !0,
      onChange: i,
      "aria-label": t,
      placeholder: e,
      size: me.SMALL,
      value: o,
      variant: gE.EDITOR
    }
  ) }) : null;
}, U0e = ({ children: e, "data-testid": t }) => {
  const { testId: n } = Zn();
  return /* @__PURE__ */ p(
    q,
    {
      as: "span",
      className: "text-[13px] font-medium leading-4 text-gray-12",
      "data-testid": t ?? `${n}-Title`,
      variant: x.LABEL_MEDIUM_MEDIUM,
      children: e
    }
  );
}, eI = {
  OPEN: "open",
  CLOSED: "closed"
}, ai = {
  HEADER: "Header",
  TITLE: "Title",
  COUNT: "Count",
  RESET: "Reset",
  SEARCH: "Search",
  BODY: "Body"
}, q0e = (e) => {
  const {
    actionHandler: t,
    items: n,
    className: a,
    getIncludeAriaLabel: o,
    getExcludeAriaLabel: i,
    defaultOpen: c = !1,
    isOpen: s,
    onOpenChange: l,
    "data-testid": u = "FilterV2",
    children: h
  } = e, [k, f] = ae(c), [y, m] = ae(""), g = s !== void 0, _ = g ? s : k, L = Q(
    (I) => {
      g || f(I), l == null || l(I);
    },
    [g, l]
  ), N = Ve(
    () => ({
      actionHandler: t,
      getIncludeAriaLabel: o,
      getExcludeAriaLabel: i,
      items: n,
      isOpen: _,
      onOpenChange: L,
      search: y,
      setSearch: m,
      testId: u
    }),
    [t, o, i, n, L, _, y, u]
  );
  return /* @__PURE__ */ p(SN.Provider, { value: N, children: /* @__PURE__ */ p(
    "div",
    {
      className: P(
        "shrink-0 overflow-hidden rounded-[7px] border-[0.5px] border-solid border-gray-7 bg-gray-1 dark:border-gray-8 dark:bg-gray-3",
        a
      ),
      "data-state": _ ? eI.OPEN : eI.CLOSED,
      "data-testid": u,
      children: h
    }
  ) });
}, gge = Object.assign(q0e, {
  [ai.HEADER]: H0e,
  [ai.TITLE]: U0e,
  [ai.COUNT]: P0e,
  [ai.RESET]: B0e,
  [ai.SEARCH]: $0e,
  [ai.BODY]: O0e
}), Mge = ({ className: e, "data-testid": t = "FilterV2Panel", children: n, ...a }) => /* @__PURE__ */ p(
  "div",
  {
    className: P("flex w-[260px] shrink-0 flex-col gap-3 overflow-y-auto pb-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", e),
    "data-testid": t,
    ...a,
    children: n
  }
), _ge = ({ avatarData: e = [], avatarSize: t }) => {
  if (e.length == 0)
    return null;
  const { isMobileMedium: n, isMobileSmall: a } = Dn();
  let o = 10;
  n && (o = 7), a && (o = 5);
  const i = e.length - o, c = i > 0;
  return /* @__PURE__ */ C("div", { className: "flex flex-1 justify-center items-center isolate", children: [
    e.slice(0, o).map(({ url: s, alt: l }, u) => /* @__PURE__ */ p(
      "div",
      {
        title: l,
        className: "border-2 border-solid border-gray-2 dark:borer-black rounded-[12px] overflow-hidden bg-black leading-none block box-border",
        style: {
          marginLeft: u === 0 ? 0 : -16,
          zIndex: -u
        },
        children: /* @__PURE__ */ p(
          bi,
          {
            src: s,
            size: t,
            shape: G1.SQUARE,
            className: "block",
            name: l
          }
        )
      },
      `${s}-${u}`
    )),
    c && /* @__PURE__ */ p(
      "div",
      {
        className: "grid items-center rounded-[9px] relative h-[52px] w-[64px]",
        style: {
          zIndex: 10,
          marginLeft: -16
        },
        children: /* @__PURE__ */ C(q, { centered: !0, children: [
          "+",
          i
        ] })
      }
    )
  ] });
}, DN = ({
  avatar: e,
  title: t,
  subtitle: n,
  description: a,
  action: o,
  className: i = "",
  classNames: c = {}
}) => /* @__PURE__ */ C(
  "div",
  {
    className: P(
      "flex gap-2.5 items-start w-full",
      i,
      c.container
    ),
    children: [
      /* @__PURE__ */ p(
        bi,
        {
          shape: G1.SQUARE,
          src: e,
          name: t && typeof t == "string" ? t : "",
          size: Xt.LARGE,
          className: P("h-12 w-12 shrink-0", c.avatar)
        }
      ),
      /* @__PURE__ */ C("div", { className: P("flex flex-col flex-1 min-w-0", c.content), children: [
        /* @__PURE__ */ C(
          q,
          {
            variant: x.LABEL_MEDIUM_BOLD,
            className: P(
              "leading-normal truncate",
              c.title
            ),
            children: [
              typeof t == "string" ? /* @__PURE__ */ p("span", { className: "text-gray-12 dark:text-white", children: t }) : t,
              n && /* @__PURE__ */ p("span", { className: P("font-normal text-xs text-blue-9 dark:text-blue-8 ml-2", c.subtitle), children: n })
            ]
          }
        ),
        a && /* @__PURE__ */ p(
          q,
          {
            variant: x.LABEL_SMALL_REGULAR,
            className: P(
              "text-gray-11 dark:text-gray-10 leading-[20px] line-clamp-2",
              c.description
            ),
            children: a
          }
        )
      ] }),
      o && /* @__PURE__ */ p("div", { className: P("shrink-0 ml-auto", c.action), children: o })
    ]
  }
);
DN.displayName = "HorizontalListItem";
he.memo(DN);
const z0e = ({ oldImageUrl: e, newImageUrl: t, onClickOldImage: n, onClickNewImage: a }) => {
  const o = "overflow-hidden flex-shrink-0 object-cover";
  return /* @__PURE__ */ C("div", { className: "flex items-center justify-start gap-sm", "data-testid": "ImageDiffSmall", children: [
    e && /* @__PURE__ */ p(
      "div",
      {
        className: P(
          o,
          "w-11 h-11 rounded-md ",
          n ? "cursor-zoom-in" : ""
        ),
        ...n ? { onClick: n } : {},
        children: /* @__PURE__ */ p(Kt, { src: e, alt: "Previous version", className: "w-full h-full object-cover" })
      }
    ),
    !!e && !!t && /* @__PURE__ */ p(oe, { icon: R.MOVE_RIGHT, className: "flex items-center justify-center flex-shrink-0 text-gray-11", "aria-hidden": !0 }),
    t && /* @__PURE__ */ p(
      "div",
      {
        className: P(
          o,
          "w-11 h-11 rounded-md border-2 border-yellow-9",
          a ? "cursor-zoom-in" : ""
        ),
        ...a ? { onClick: a } : {},
        children: /* @__PURE__ */ p(Kt, { src: t, alt: "New version", className: "w-full h-full object-cover" })
      }
    )
  ] });
}, j0e = ({ oldImageUrl: e, newImageUrl: t, onClickOldImage: n, onClickNewImage: a }) => {
  const o = "overflow-hidden flex-shrink-0 object-cover";
  return /* @__PURE__ */ C("div", { className: "flex items-center justify-start gap-lg", "data-testid": "ImageDiffLarge", children: [
    e && /* @__PURE__ */ C("div", { className: "flex flex-col items-start gap-2", children: [
      /* @__PURE__ */ p(ki, { showDot: !1, children: "PUBLISHED" }),
      /* @__PURE__ */ p("div", { className: P(o, "w-[144px] h-[144px]", n ? "cursor-zoom-in" : ""), ...n ? { onClick: n } : {}, children: /* @__PURE__ */ p(Kt, { src: e, alt: "Published version", className: "w-full h-full object-cover" }) })
    ] }),
    !!e && !!t && /* @__PURE__ */ p(oe, { icon: R.MOVE_RIGHT, className: "flex items-center justify-center flex-shrink-0 text-gray-11", "aria-hidden": !0 }),
    t && /* @__PURE__ */ C("div", { className: "flex flex-col items-start gap-2", children: [
      /* @__PURE__ */ p(ki, { variant: Bt.OUTLINED, color: jt.WARNING, showDot: !1, children: "SUBMITTED" }),
      /* @__PURE__ */ p(
        "div",
        {
          className: P(
            o,
            "w-[144px] h-[144px] border-2 border-yellow-9",
            a ? "cursor-zoom-in" : ""
          ),
          ...a ? { onClick: a } : {},
          children: /* @__PURE__ */ p(Kt, { src: t, alt: "Submitted version", className: "w-full h-full object-cover" })
        }
      )
    ] })
  ] });
}, ON = {
  [We.SMALL]: "p-sm",
  [We.MEDIUM]: "p-md"
}, V0e = {
  [We.SMALL]: "gap-sm",
  [We.MEDIUM]: "gap-md"
}, PN = {
  [We.SMALL]: "gap-1",
  [We.MEDIUM]: "gap-sm"
}, G0e = {
  [We.SMALL]: x.LABEL_SMALL_REGULAR,
  [We.MEDIUM]: x.LABEL_LARGE_REGULAR
}, W0e = {
  [We.SMALL]: x.LABEL_SMALL_MEDIUM,
  [We.MEDIUM]: x.LABEL_LARGE_MEDIUM
}, X0e = {
  [We.SMALL]: "text-label-sm",
  [We.MEDIUM]: "text-label-lg"
}, Y0e = {
  [We.SMALL]: dt.SMALL,
  [We.MEDIUM]: dt.MEDIUM
}, K0e = {
  [We.SMALL]: "overflow-hidden max-h-[3em]",
  [We.MEDIUM]: "overflow-hidden max-h-[4.5em]"
}, Z0e = ({ label: e, description: t, optional: n = !1, variant: a, isBadgeHidden: o = !1, size: i = We.MEDIUM }) => {
  const c = !!e || !!t, s = !o && a != null && a !== Et.BASIC, l = i === We.SMALL;
  return !c && !s ? null : /* @__PURE__ */ C("div", { "data-testid": "DiffHeader", className: P("flex flex-col", l ? "gap-1" : "gap-sm"), children: [
    c ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
      e ? /* @__PURE__ */ C("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ p(q, { variant: W0e[i], className: "block", children: n ? `${e} (Optional)` : e }),
        a === Et.SUBMITTED && /* @__PURE__ */ p("div", { className: P("rounded-full bg-yellow-9 inline-block", l ? "w-1 h-1" : "w-1.5 h-1.5") })
      ] }) : null,
      t ? /* @__PURE__ */ p(q, { variant: l ? x.LABEL_XSMALL_REGULAR : x.LABEL_SMALL_REGULAR, className: "text-gray-11", children: t }) : null
    ] }) : null,
    s && a === Et.SUBMITTED ? /* @__PURE__ */ p(ki, { variant: Bt.OUTLINED, color: jt.WARNING, showDot: !1, size: Yn.SMALL, className: "w-fit", children: "SUBMITTED" }) : null,
    s && a === Et.PUBLISHED ? /* @__PURE__ */ p(ki, { showDot: !1, size: Yn.SMALL, className: "w-fit", children: "PUBLISHED" }) : null
  ] });
}, Gv = he.memo(Z0e), Q0e = "small", J0e = ({
  className: e,
  oldImageUrl: t,
  newImageUrl: n,
  size: a = Q0e,
  label: o,
  description: i,
  optional: c,
  onClickOldImage: s,
  onClickNewImage: l
}) => {
  const u = a === "large";
  return /* @__PURE__ */ C(
    "div",
    {
      className: P("flex flex-col w-full flex-shrink gap-sm", e),
      "data-testid": "ImageDiff",
      children: [
        u && /* @__PURE__ */ p(Gv, { label: o, description: i, optional: c }),
        u ? /* @__PURE__ */ p(j0e, { oldImageUrl: t, newImageUrl: n, onClickOldImage: s, onClickNewImage: l }) : /* @__PURE__ */ p(z0e, { oldImageUrl: t, newImageUrl: n, onClickOldImage: s, onClickNewImage: l })
      ]
    }
  );
}, bge = he.memo(J0e);
function e2e({
  title: e,
  description: t,
  buttonText: n = "Okay",
  onClick: a,
  classNames: o
}) {
  return /* @__PURE__ */ C("div", { className: P("flex flex-col gap-lg items-center max-w-56", o == null ? void 0 : o.container), children: [
    /* @__PURE__ */ C("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ p(q, { variant: x.HEADING_6_BOLD, className: P("text-blue-12 text-center", o == null ? void 0 : o.title), children: e }),
      /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_REGULAR, className: P("text-blue-12 text-center", o == null ? void 0 : o.description), children: t })
    ] }),
    n && a && /* @__PURE__ */ p(
      nt,
      {
        size: _e.LARGE,
        onClick: a,
        "aria-label": "accept",
        className: P(o == null ? void 0 : o.button),
        children: n
      }
    )
  ] });
}
function t2e({
  isLoading: e,
  title: t,
  description: n,
  buttonText: a,
  onClick: o
}) {
  return /* @__PURE__ */ p("div", { className: "flex flex-col justify-center items-center", children: e ? /* @__PURE__ */ p(Rn, { size: Ue.LARGE }) : /* @__PURE__ */ p(
    e2e,
    {
      title: t,
      description: n,
      onClick: o,
      buttonText: a
    }
  ) });
}
const Lge = mt(t2e), tI = 3, n2e = "bg-gray-5", a2e = "text-gray-12 bg-gray-5", o2e = [], r2e = `w-full
        flex items-start justify-between
        rounded-lg
        cursor-pointer   
        transition-colors duration-200 bg-transparent
      `, i2e = {
  [me.SMALL]: {
    container: "h-8 gap-1.5 px-md",
    label: x.LABEL_SMALL_REGULAR,
    subLabel: x.LABEL_XSMALL_REGULAR,
    tags: x.LABEL_XSMALL_REGULAR,
    icon: "w-4 h-4"
  },
  [me.MEDIUM]: {
    container: "min-h-11 gap-2 py-md px-[13px]",
    label: x.LABEL_MEDIUM_REGULAR,
    subLabel: x.LABEL_SMALL_REGULAR,
    tags: x.LABEL_SMALL_REGULAR,
    icon: "w-5 h-5"
  },
  [me.LARGE]: {
    container: "min-h-[60px] gap-md p-md",
    label: x.LABEL_LARGE_REGULAR,
    subLabel: x.LABEL_MEDIUM_REGULAR,
    tags: x.LABEL_MEDIUM_REGULAR,
    icon: "w-5 h-5"
  }
}, c2e = {
  [oc.DEFAULT]: {
    container: "border border-solid border-transparent"
  },
  [oc.BORDERED]: {
    container: "border border-solid border-gray-6"
  }
};
function s2e() {
}
function l2e(e) {
  const t = {
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis"
  };
  return t.WebkitBoxOrient = "vertical", t.WebkitLineClamp = e, t;
}
function d2e(e) {
  const t = SS[e];
  return "className" in t && t.className ? t.className : n2e;
}
function HN({ icon: e, className: t }) {
  return /* @__PURE__ */ p(oe, { icon: e, className: t });
}
function BN({ action: e }) {
  const t = Q(
    (n) => {
      var a;
      n.stopPropagation(), (a = e.onClick) == null || a.call(e, n);
    },
    [e]
  );
  return /* @__PURE__ */ p(nt, { ...e, size: e.size || _e.SMALL, onClick: t, children: e.children });
}
function u2e({ status: e }) {
  return /* @__PURE__ */ p("div", { className: P("rounded-full w-[6px] h-[6px] mt-sm", d2e(e)) });
}
function h2e({ badge: e, textVariant: t }) {
  const n = vS[e];
  return /* @__PURE__ */ p("div", { className: P("rounded-[7px] h-5 px-sm flex items-center shrink-0 whitespace-nowrap", (n == null ? void 0 : n.className) || a2e), children: /* @__PURE__ */ p(q, { variant: t, className: "leading-none", children: (n == null ? void 0 : n.text) || e }) });
}
function p2e({ languageTag: e, textVariant: t }) {
  return /* @__PURE__ */ p("div", { className: "rounded-[7px] h-5 px-sm flex items-center shrink-0 bg-gray-4", children: /* @__PURE__ */ p(q, { variant: t, className: "leading-none", children: e }) });
}
function y2e({ tags: e, textVariant: t }) {
  const n = e.slice(0, tI), a = e.length - tI, o = a > 0;
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-1", children: [
    /* @__PURE__ */ p(q, { variant: t, className: "text-gray-11 line-clamp-1", children: n.join(", ") }),
    o ? /* @__PURE__ */ C(q, { variant: t, className: "text-gray-11", children: [
      "+",
      a
    ] }) : null
  ] });
}
function k2e({ subLabel: e, textVariant: t, maxLines: n, shouldShowTooltip: a }) {
  const o = Ve(() => {
    if (typeof n == "number")
      return l2e(n);
  }, [n]), i = /* @__PURE__ */ p(q, { variant: t, className: "break-words [overflow-wrap:anywhere]", style: o, children: e });
  return /* @__PURE__ */ p("div", { className: "w-full text-left", children: a ? /* @__PURE__ */ p(Nt, { title: e, children: i }) : i });
}
function f2e({
  startIcon: e,
  startAction: t,
  status: n,
  label: a,
  badge: o,
  languageTag: i,
  tags: c,
  subLabel: s,
  subLabelMaxLines: l,
  shouldShowSubLabelTooltip: u,
  currentSize: h
}) {
  const k = c.length > 0, f = !!s;
  return /* @__PURE__ */ C("div", { className: "flex items-start gap-md flex-1", children: [
    e ? /* @__PURE__ */ p(HN, { icon: e, className: h.icon }) : null,
    t ? /* @__PURE__ */ p(BN, { action: t }) : null,
    n ? /* @__PURE__ */ p(u2e, { status: n }) : null,
    /* @__PURE__ */ C("div", { className: "flex flex-col min-w-0 flex-1 gap-0.5", children: [
      /* @__PURE__ */ C("div", { className: "flex gap-2 w-full", children: [
        /* @__PURE__ */ p(Nt, { title: a, children: /* @__PURE__ */ p(q, { variant: h.label, className: "text-gray-12 line-clamp-1", children: a }) }),
        o ? /* @__PURE__ */ p(h2e, { badge: o, textVariant: h.tags }) : null,
        i ? /* @__PURE__ */ p(p2e, { languageTag: i, textVariant: h.tags }) : null
      ] }),
      k ? /* @__PURE__ */ p(y2e, { tags: c, textVariant: h.tags }) : null,
      f ? /* @__PURE__ */ p(
        k2e,
        {
          subLabel: s,
          textVariant: h.subLabel,
          maxLines: l,
          shouldShowTooltip: u
        }
      ) : null
    ] })
  ] });
}
function m2e({ endIcon: e, endAction: t, iconClassName: n }) {
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-md", children: [
    e ? /* @__PURE__ */ p(HN, { icon: e, className: n }) : null,
    t ? /* @__PURE__ */ p(BN, { action: t }) : null
  ] });
}
function g2e({
  className: e,
  variantContainerClassName: t,
  sizeContainerClassName: n,
  isActive: a,
  isVariantBordered: o
}) {
  return P(
    r2e,
    t,
    n,
    e,
    a ? "bg-gray-4" : "hover:bg-gray-4",
    o && a ? "border-gray-9" : void 0,
    o ? "hover:border-gray-9" : void 0
  );
}
const xge = ({
  variant: e = oc.DEFAULT,
  endIcon: t,
  startIcon: n,
  label: a,
  status: o,
  badge: i,
  startAction: c,
  endAction: s,
  size: l = me.MEDIUM,
  subLabel: u = "",
  active: h = !1,
  onClick: k = s2e,
  className: f = "",
  tags: y = o2e,
  languageTag: m,
  subLabelMaxLines: g,
  showSubLabelTooltip: _ = !0
}) => {
  const L = i2e[l], N = c2e[e], I = e === oc.BORDERED;
  return /* @__PURE__ */ C(
    "button",
    {
      type: "button",
      onClick: k,
      className: g2e({
        className: f,
        variantContainerClassName: N == null ? void 0 : N.container,
        sizeContainerClassName: L.container,
        isActive: h,
        isVariantBordered: I
      }),
      children: [
        /* @__PURE__ */ p(
          f2e,
          {
            startIcon: n,
            startAction: c,
            status: o,
            label: a,
            badge: i,
            languageTag: m,
            tags: y,
            subLabel: u,
            subLabelMaxLines: g,
            shouldShowSubLabelTooltip: _,
            currentSize: L
          }
        ),
        /* @__PURE__ */ p(m2e, { endIcon: t, endAction: s, iconClassName: L.icon })
      ]
    }
  );
}, Ege = ({
  onClick: e,
  isSelected: t = !1,
  className: n = "",
  variant: a = "default",
  avatarUrl: o,
  isPrivate: i,
  isBlurred: c = !1,
  numEntries: s = 0,
  creatorUsername: l = "",
  description: u = "",
  name: h = "",
  id: k = "",
  characterRatingScore: f = 0,
  characterMessageNumber: y = 0,
  characterTokensCount: m = 0,
  dataTestId: g
}) => {
  const [_, L] = ae(!1);
  le(() => {
    L(!1);
  }, [o]);
  const N = o && !_, I = !o || _;
  return a === "attached" ? /* @__PURE__ */ C("div", { "data-testid": g, className: `flex min-w-[300px] max-w-[500px] overflow-hidden rounded-[12px] bg-gray-3 ${n}`, children: [
    /* @__PURE__ */ C("div", { className: "relative h-[129px] w-[129px] flex-none bg-gray-5", children: [
      i ? /* @__PURE__ */ p("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-black/40", children: /* @__PURE__ */ p(oe, { icon: R.LOCK, size: ye.MEDIUM, className: "text-white" }) }) : null,
      N ? /* @__PURE__ */ p(
        "img",
        {
          src: o,
          alt: h,
          className: `size-full object-cover ${c ? "blur-md" : ""}`,
          onError: () => L(!0)
        }
      ) : /* @__PURE__ */ p("div", { className: "flex size-full items-center justify-center text-gray-11", children: /* @__PURE__ */ p(oe, { icon: R.BOOK_TEXT, size: ye.LARGE }) })
    ] }),
    /* @__PURE__ */ C("div", { className: "flex min-w-0 flex-1 flex-col overflow-hidden px-[7px] py-[10px]", children: [
      /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_BOLD, className: "truncate pr-6 text-gray-12", children: h }),
      /* @__PURE__ */ C("div", { className: "flex min-w-0 items-center gap-2 overflow-hidden", children: [
        l ? /* @__PURE__ */ C(q, { variant: x.LABEL_SMALL_REGULAR, as: "span", className: "truncate text-blue-9", children: [
          "@",
          l
        ] }) : null,
        /* @__PURE__ */ C("div", { className: "flex flex-none items-center gap-1 text-gray-10", children: [
          /* @__PURE__ */ p(oe, { icon: R.BOOK_TEXT, size: ye.XSMALL }),
          /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, as: "span", children: s })
        ] })
      ] }),
      u ? /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: "mt-1 line-clamp-3 text-gray-12", children: u }) : null
    ] })
  ] }) : /* @__PURE__ */ C(
    "div",
    {
      "data-testid": g,
      onClick: () => e == null ? void 0 : e(),
      className: `flex w-full relative group rounded-md
      bg-gray-3
      p-md
      gap-md
      border-1 border-solid
      text-gray-12 dark:text-white ${t ? "border-blue-10" : "border-gray-6"}
      ${a === "default" ? "cursor-pointer hover:bg-gray-4 hover:border-gray-9/50 dark:hover:border-gray-8" : ""}
      ${n}`,
      children: [
        i ? /* @__PURE__ */ p("div", { className: "mt-md ml-md absolute inset-0 flex items-center justify-center pointer-events-none z-10 h-16 w-16", children: /* @__PURE__ */ p("div", { className: "rounded-full bg-black/50 w-9 h-9 flex items-center justify-center", children: /* @__PURE__ */ p(oe, { icon: R.LOCK, size: ye.MEDIUM, className: "text-white opacity-90" }) }) }) : null,
        N ? /* @__PURE__ */ p(
          "img",
          {
            src: o,
            alt: h,
            className: `h-16 w-16 rounded-md object-cover flex-shrink-0 ${c ? "blur-md" : ""}`,
            onError: () => {
              L(!0);
            }
          }
        ) : null,
        I ? /* @__PURE__ */ p("div", { className: "lorebook-avatar-fallback h-16 w-16 rounded-md flex-shrink-0 bg-gray-7 flex items-center justify-center", "aria-label": h }) : null,
        /* @__PURE__ */ C("div", { className: "flex flex-col flex-1 gap-0.5 text-gray-11 min-w-0", children: [
          /* @__PURE__ */ C("div", { className: "flex items-center justify-between gap-2 min-w-0", children: [
            /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_BOLD, className: "truncate text-gray-12 min-w-0", children: h }),
            e && k ? /* @__PURE__ */ p(
              "input",
              {
                id: `radio_${k}`,
                type: "radio",
                name: "lorebook",
                checked: t,
                className: `
                appearance-none border-[1px] dark:border-none border-gray-10 border-solid rounded-full bg-gray-5 dark:bg-gray-9 cursor-pointer 
                w-[16px] h-[16px] flex-shrink-0
                focus:ring-2 focus:ring-offset-2 focus:dark:ring-offset-black focus:ring-blue-10
                checked:box-content dark:checked:box-content checked:border-solid dark:checked:border-solid checked:border-[5px] checked:border-blue-10 dark:checked:border-blue-10 checked:bg-white dark:checked:bg-white checked:size-[6px] checked:dark:size-[6px]
              `
              }
            ) : null
          ] }),
          l || s || f || y || m ? /* @__PURE__ */ C("div", { className: "flex items-center gap-sm", children: [
            l ? /* @__PURE__ */ C(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-blue-600", children: [
              "@",
              l
            ] }) : null,
            s ? /* @__PURE__ */ C("div", { className: "flex items-center gap-0.5", children: [
              /* @__PURE__ */ p(oe, { icon: R.BOOK, size: ye.XSMALL }),
              /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, children: s })
            ] }) : null,
            f ? /* @__PURE__ */ p(bN, { characterRatingScore: f }) : null,
            y ? /* @__PURE__ */ p(_N, { characterMessageNumber: y }) : null,
            m ? /* @__PURE__ */ p(LN, { characterTokensCount: m }) : null
          ] }) : null,
          u ? /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: "line-clamp-3 break-words", children: u }) : null
        ] })
      ]
    }
  );
};
function nI(e) {
  const t = [], n = String(e || "");
  let a = n.indexOf(","), o = 0, i = !1;
  for (; !i; ) {
    a === -1 && (a = n.length, i = !0);
    const c = n.slice(o, a).trim();
    (c || !i) && t.push(c), o = a + 1, a = n.indexOf(",", o);
  }
  return t;
}
function FN(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const M2e = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, _2e = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, b2e = {};
function aI(e, t) {
  return (b2e.jsx ? _2e : M2e).test(e);
}
const L2e = /[ \t\n\f\r]/g;
function x2e(e) {
  return typeof e == "object" ? e.type === "text" ? oI(e.value) : !1 : oI(e);
}
function oI(e) {
  return e.replace(L2e, "") === "";
}
class gc {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, a) {
    this.normal = n, this.property = t, a && (this.space = a);
  }
}
gc.prototype.normal = {};
gc.prototype.property = {};
gc.prototype.space = void 0;
function $N(e, t) {
  const n = {}, a = {};
  for (const o of e)
    Object.assign(n, o.property), Object.assign(a, o.normal);
  return new gc(n, a, t);
}
function lc(e) {
  return e.toLowerCase();
}
class St {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
St.prototype.attribute = "";
St.prototype.booleanish = !1;
St.prototype.boolean = !1;
St.prototype.commaOrSpaceSeparated = !1;
St.prototype.commaSeparated = !1;
St.prototype.defined = !1;
St.prototype.mustUseProperty = !1;
St.prototype.number = !1;
St.prototype.overloadedBoolean = !1;
St.prototype.property = "";
St.prototype.spaceSeparated = !1;
St.prototype.space = void 0;
let E2e = 0;
const Me = J1(), Je = J1(), pv = J1(), X = J1(), Be = J1(), pi = J1(), Ht = J1();
function J1() {
  return 2 ** ++E2e;
}
const yv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Me,
  booleanish: Je,
  commaOrSpaceSeparated: Ht,
  commaSeparated: pi,
  number: X,
  overloadedBoolean: pv,
  spaceSeparated: Be
}, Symbol.toStringTag, { value: "Module" })), HE = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(yv)
);
class Wv extends St {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, a, o) {
    let i = -1;
    if (super(t, n), rI(this, "space", o), typeof a == "number")
      for (; ++i < HE.length; ) {
        const c = HE[i];
        rI(this, HE[i], (a & yv[c]) === yv[c]);
      }
  }
}
Wv.prototype.defined = !0;
function rI(e, t, n) {
  n && (e[t] = n);
}
function vi(e) {
  const t = {}, n = {};
  for (const [a, o] of Object.entries(e.properties)) {
    const i = new Wv(
      a,
      e.transform(e.attributes || {}, a),
      o,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(a) && (i.mustUseProperty = !0), t[a] = i, n[lc(a)] = a, n[lc(i.attribute)] = a;
  }
  return new gc(t, n, e.space);
}
const UN = vi({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Je,
    ariaAutoComplete: null,
    ariaBusy: Je,
    ariaChecked: Je,
    ariaColCount: X,
    ariaColIndex: X,
    ariaColSpan: X,
    ariaControls: Be,
    ariaCurrent: null,
    ariaDescribedBy: Be,
    ariaDetails: null,
    ariaDisabled: Je,
    ariaDropEffect: Be,
    ariaErrorMessage: null,
    ariaExpanded: Je,
    ariaFlowTo: Be,
    ariaGrabbed: Je,
    ariaHasPopup: null,
    ariaHidden: Je,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Be,
    ariaLevel: X,
    ariaLive: null,
    ariaModal: Je,
    ariaMultiLine: Je,
    ariaMultiSelectable: Je,
    ariaOrientation: null,
    ariaOwns: Be,
    ariaPlaceholder: null,
    ariaPosInSet: X,
    ariaPressed: Je,
    ariaReadOnly: Je,
    ariaRelevant: null,
    ariaRequired: Je,
    ariaRoleDescription: Be,
    ariaRowCount: X,
    ariaRowIndex: X,
    ariaRowSpan: X,
    ariaSelected: Je,
    ariaSetSize: X,
    ariaSort: null,
    ariaValueMax: X,
    ariaValueMin: X,
    ariaValueNow: X,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function qN(e, t) {
  return t in e ? e[t] : t;
}
function zN(e, t) {
  return qN(e, t.toLowerCase());
}
const v2e = vi({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: pi,
    acceptCharset: Be,
    accessKey: Be,
    action: null,
    allow: null,
    allowFullScreen: Me,
    allowPaymentRequest: Me,
    allowUserMedia: Me,
    alt: null,
    as: null,
    async: Me,
    autoCapitalize: null,
    autoComplete: Be,
    autoFocus: Me,
    autoPlay: Me,
    blocking: Be,
    capture: null,
    charSet: null,
    checked: Me,
    cite: null,
    className: Be,
    cols: X,
    colSpan: null,
    content: null,
    contentEditable: Je,
    controls: Me,
    controlsList: Be,
    coords: X | pi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Me,
    defer: Me,
    dir: null,
    dirName: null,
    disabled: Me,
    download: pv,
    draggable: Je,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Me,
    formTarget: null,
    headers: Be,
    height: X,
    hidden: pv,
    high: X,
    href: null,
    hrefLang: null,
    htmlFor: Be,
    httpEquiv: Be,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Me,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Me,
    itemId: null,
    itemProp: Be,
    itemRef: Be,
    itemScope: Me,
    itemType: Be,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Me,
    low: X,
    manifest: null,
    max: null,
    maxLength: X,
    media: null,
    method: null,
    min: null,
    minLength: X,
    multiple: Me,
    muted: Me,
    name: null,
    nonce: null,
    noModule: Me,
    noValidate: Me,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Me,
    optimum: X,
    pattern: null,
    ping: Be,
    placeholder: null,
    playsInline: Me,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Me,
    referrerPolicy: null,
    rel: Be,
    required: Me,
    reversed: Me,
    rows: X,
    rowSpan: X,
    sandbox: Be,
    scope: null,
    scoped: Me,
    seamless: Me,
    selected: Me,
    shadowRootClonable: Me,
    shadowRootDelegatesFocus: Me,
    shadowRootMode: null,
    shape: null,
    size: X,
    sizes: null,
    slot: null,
    span: X,
    spellCheck: Je,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: X,
    step: null,
    style: null,
    tabIndex: X,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Me,
    useMap: null,
    value: Je,
    width: X,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Be,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: X,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: X,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Me,
    // Lists. Use CSS to reduce space between items instead
    declare: Me,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: X,
    // `<img>` and `<object>`
    leftMargin: X,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: X,
    // `<body>`
    marginWidth: X,
    // `<body>`
    noResize: Me,
    // `<frame>`
    noHref: Me,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Me,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Me,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: X,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Je,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: X,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: X,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Me,
    disableRemotePlayback: Me,
    prefix: null,
    property: null,
    results: X,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: zN
}), A2e = vi({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Ht,
    accentHeight: X,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: X,
    amplitude: X,
    arabicForm: null,
    ascent: X,
    attributeName: null,
    attributeType: null,
    azimuth: X,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: X,
    by: null,
    calcMode: null,
    capHeight: X,
    className: Be,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: X,
    diffuseConstant: X,
    direction: null,
    display: null,
    dur: null,
    divisor: X,
    dominantBaseline: null,
    download: Me,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: X,
    enableBackground: null,
    end: null,
    event: null,
    exponent: X,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: X,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: pi,
    g2: pi,
    glyphName: pi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: X,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: X,
    horizOriginX: X,
    horizOriginY: X,
    id: null,
    ideographic: X,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: X,
    k: X,
    k1: X,
    k2: X,
    k3: X,
    k4: X,
    kernelMatrix: Ht,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: X,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: X,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: X,
    overlineThickness: X,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: X,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Be,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: X,
    pointsAtY: X,
    pointsAtZ: X,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Ht,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Ht,
    rev: Ht,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Ht,
    requiredFeatures: Ht,
    requiredFonts: Ht,
    requiredFormats: Ht,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: X,
    specularExponent: X,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: X,
    strikethroughThickness: X,
    string: null,
    stroke: null,
    strokeDashArray: Ht,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: X,
    strokeOpacity: X,
    strokeWidth: null,
    style: null,
    surfaceScale: X,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Ht,
    tabIndex: X,
    tableValues: null,
    target: null,
    targetX: X,
    targetY: X,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Ht,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: X,
    underlineThickness: X,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: X,
    values: null,
    vAlphabetic: X,
    vMathematical: X,
    vectorEffect: null,
    vHanging: X,
    vIdeographic: X,
    version: null,
    vertAdvY: X,
    vertOriginX: X,
    vertOriginY: X,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: X,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: qN
}), jN = vi({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), VN = vi({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: zN
}), GN = vi({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), I2e = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, T2e = /[A-Z]/g, iI = /-[a-z]/g, N2e = /^data[-\w.:]+$/i;
function ME(e, t) {
  const n = lc(t);
  let a = t, o = St;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && N2e.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(iI, w2e);
      a = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!iI.test(i)) {
        let c = i.replace(T2e, C2e);
        c.charAt(0) !== "-" && (c = "-" + c), t = "data" + c;
      }
    }
    o = Wv;
  }
  return new o(a, t);
}
function C2e(e) {
  return "-" + e.toLowerCase();
}
function w2e(e) {
  return e.charAt(1).toUpperCase();
}
const Mc = $N([UN, v2e, jN, VN, GN], "html"), Qn = $N([UN, A2e, jN, VN, GN], "svg");
function cI(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function WN(e) {
  return e.join(" ").trim();
}
var Xv = {}, sI = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, S2e = /\n/g, R2e = /^\s*/, D2e = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, O2e = /^:\s*/, P2e = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, H2e = /^[;\s]*/, B2e = /^\s+|\s+$/g, F2e = `
`, lI = "/", dI = "*", B1 = "", $2e = "comment", U2e = "declaration";
function q2e(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, a = 1;
  function o(m) {
    var g = m.match(S2e);
    g && (n += g.length);
    var _ = m.lastIndexOf(F2e);
    a = ~_ ? m.length - _ : a + m.length;
  }
  function i() {
    var m = { line: n, column: a };
    return function(g) {
      return g.position = new c(m), u(), g;
    };
  }
  function c(m) {
    this.start = m, this.end = { line: n, column: a }, this.source = t.source;
  }
  c.prototype.content = e;
  function s(m) {
    var g = new Error(
      t.source + ":" + n + ":" + a + ": " + m
    );
    if (g.reason = m, g.filename = t.source, g.line = n, g.column = a, g.source = e, !t.silent) throw g;
  }
  function l(m) {
    var g = m.exec(e);
    if (g) {
      var _ = g[0];
      return o(_), e = e.slice(_.length), g;
    }
  }
  function u() {
    l(R2e);
  }
  function h(m) {
    var g;
    for (m = m || []; g = k(); )
      g !== !1 && m.push(g);
    return m;
  }
  function k() {
    var m = i();
    if (!(lI != e.charAt(0) || dI != e.charAt(1))) {
      for (var g = 2; B1 != e.charAt(g) && (dI != e.charAt(g) || lI != e.charAt(g + 1)); )
        ++g;
      if (g += 2, B1 === e.charAt(g - 1))
        return s("End of comment missing");
      var _ = e.slice(2, g - 2);
      return a += 2, o(_), e = e.slice(g), a += 2, m({
        type: $2e,
        comment: _
      });
    }
  }
  function f() {
    var m = i(), g = l(D2e);
    if (g) {
      if (k(), !l(O2e)) return s("property missing ':'");
      var _ = l(P2e), L = m({
        type: U2e,
        property: uI(g[0].replace(sI, B1)),
        value: _ ? uI(_[0].replace(sI, B1)) : B1
      });
      return l(H2e), L;
    }
  }
  function y() {
    var m = [];
    h(m);
    for (var g; g = f(); )
      g !== !1 && (m.push(g), h(m));
    return m;
  }
  return u(), y();
}
function uI(e) {
  return e ? e.replace(B2e, B1) : B1;
}
var z2e = q2e, j2e = Wn && Wn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xv, "__esModule", { value: !0 });
Xv.default = G2e;
const V2e = j2e(z2e);
function G2e(e, t) {
  let n = null;
  if (!e || typeof e != "string")
    return n;
  const a = (0, V2e.default)(e), o = typeof t == "function";
  return a.forEach((i) => {
    if (i.type !== "declaration")
      return;
    const { property: c, value: s } = i;
    o ? t(c, s, i) : s && (n = n || {}, n[c] = s);
  }), n;
}
var _E = {};
Object.defineProperty(_E, "__esModule", { value: !0 });
_E.camelCase = void 0;
var W2e = /^--[a-zA-Z0-9_-]+$/, X2e = /-([a-z])/g, Y2e = /^[^-]+$/, K2e = /^-(webkit|moz|ms|o|khtml)-/, Z2e = /^-(ms)-/, Q2e = function(e) {
  return !e || Y2e.test(e) || W2e.test(e);
}, J2e = function(e, t) {
  return t.toUpperCase();
}, hI = function(e, t) {
  return "".concat(t, "-");
}, ede = function(e, t) {
  return t === void 0 && (t = {}), Q2e(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Z2e, hI) : e = e.replace(K2e, hI), e.replace(X2e, J2e));
};
_E.camelCase = ede;
var tde = Wn && Wn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, nde = tde(Xv), ade = _E;
function kv(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, nde.default)(e, function(a, o) {
    a && o && (n[(0, ade.camelCase)(a, t)] = o);
  }), n;
}
kv.default = kv;
var ode = kv;
const rde = /* @__PURE__ */ yE(ode), bE = XN("end"), bn = XN("start");
function XN(e) {
  return t;
  function t(n) {
    const a = n && n.position && n.position[e] || {};
    if (typeof a.line == "number" && a.line > 0 && typeof a.column == "number" && a.column > 0)
      return {
        line: a.line,
        column: a.column,
        offset: typeof a.offset == "number" && a.offset > -1 ? a.offset : void 0
      };
  }
}
function YN(e) {
  const t = bn(e), n = bE(e);
  if (t && n)
    return { start: t, end: n };
}
function Yi(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? pI(e.position) : "start" in e || "end" in e ? pI(e) : "line" in e || "column" in e ? fv(e) : "";
}
function fv(e) {
  return yI(e && e.line) + ":" + yI(e && e.column);
}
function pI(e) {
  return fv(e && e.start) + "-" + fv(e && e.end);
}
function yI(e) {
  return e && typeof e == "number" ? e : 1;
}
class gt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, a) {
    super(), typeof n == "string" && (a = n, n = void 0);
    let o = "", i = {}, c = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? o = t : !i.cause && t && (c = !0, o = t.message, i.cause = t), !i.ruleId && !i.source && typeof a == "string") {
      const l = a.indexOf(":");
      l === -1 ? i.ruleId = a : (i.source = a.slice(0, l), i.ruleId = a.slice(l + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const l = i.ancestors[i.ancestors.length - 1];
      l && (i.place = l.position);
    }
    const s = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file = "", this.message = o, this.line = s ? s.line : void 0, this.name = Yi(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = c && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
gt.prototype.file = "";
gt.prototype.name = "";
gt.prototype.reason = "";
gt.prototype.message = "";
gt.prototype.stack = "";
gt.prototype.column = void 0;
gt.prototype.line = void 0;
gt.prototype.ancestors = void 0;
gt.prototype.cause = void 0;
gt.prototype.fatal = void 0;
gt.prototype.place = void 0;
gt.prototype.ruleId = void 0;
gt.prototype.source = void 0;
const Yv = {}.hasOwnProperty, ide = /* @__PURE__ */ new Map(), cde = /[A-Z]/g, sde = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), lde = /* @__PURE__ */ new Set(["td", "th"]), KN = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function dde(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let a;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    a = gde(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    a = mde(n, t.jsx, t.jsxs);
  }
  const o = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: a,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Qn : Mc,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = ZN(o, e, void 0);
  return i && typeof i != "string" ? i : o.create(
    e,
    o.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function ZN(e, t, n) {
  if (t.type === "element")
    return ude(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return hde(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return yde(e, t, n);
  if (t.type === "mdxjsEsm")
    return pde(e, t);
  if (t.type === "root")
    return kde(e, t, n);
  if (t.type === "text")
    return fde(e, t);
}
function ude(e, t, n) {
  const a = e.schema;
  let o = a;
  t.tagName.toLowerCase() === "svg" && a.space === "html" && (o = Qn, e.schema = o), e.ancestors.push(t);
  const i = JN(e, t.tagName, !1), c = Mde(e, t);
  let s = Zv(e, t);
  return sde.has(t.tagName) && (s = s.filter(function(l) {
    return typeof l == "string" ? !x2e(l) : !0;
  })), QN(e, c, i, t), Kv(c, s), e.ancestors.pop(), e.schema = a, e.create(t, i, c, n);
}
function hde(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const a = t.data.estree.body[0];
    return a.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(a.expression);
  }
  dc(e, t.position);
}
function pde(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  dc(e, t.position);
}
function yde(e, t, n) {
  const a = e.schema;
  let o = a;
  t.name === "svg" && a.space === "html" && (o = Qn, e.schema = o), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : JN(e, t.name, !0), c = _de(e, t), s = Zv(e, t);
  return QN(e, c, i, t), Kv(c, s), e.ancestors.pop(), e.schema = a, e.create(t, i, c, n);
}
function kde(e, t, n) {
  const a = {};
  return Kv(a, Zv(e, t)), e.create(t, e.Fragment, a, n);
}
function fde(e, t) {
  return t.value;
}
function QN(e, t, n, a) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = a);
}
function Kv(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function mde(e, t, n) {
  return a;
  function a(o, i, c, s) {
    const u = Array.isArray(c.children) ? n : t;
    return s ? u(i, c, s) : u(i, c);
  }
}
function gde(e, t) {
  return n;
  function n(a, o, i, c) {
    const s = Array.isArray(i.children), l = bn(a);
    return t(
      o,
      i,
      c,
      s,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: e,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function Mde(e, t) {
  const n = {};
  let a, o;
  for (o in t.properties)
    if (o !== "children" && Yv.call(t.properties, o)) {
      const i = bde(e, o, t.properties[o]);
      if (i) {
        const [c, s] = i;
        e.tableCellAlignToStyle && c === "align" && typeof s == "string" && lde.has(t.tagName) ? a = s : n[c] = s;
      }
    }
  if (a) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = a;
  }
  return n;
}
function _de(e, t) {
  const n = {};
  for (const a of t.attributes)
    if (a.type === "mdxJsxExpressionAttribute")
      if (a.data && a.data.estree && e.evaluater) {
        const i = a.data.estree.body[0];
        i.type;
        const c = i.expression;
        c.type;
        const s = c.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        dc(e, t.position);
    else {
      const o = a.name;
      let i;
      if (a.value && typeof a.value == "object")
        if (a.value.data && a.value.data.estree && e.evaluater) {
          const s = a.value.data.estree.body[0];
          s.type, i = e.evaluater.evaluateExpression(s.expression);
        } else
          dc(e, t.position);
      else
        i = a.value === null ? !0 : a.value;
      n[o] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function Zv(e, t) {
  const n = [];
  let a = -1;
  const o = e.passKeys ? /* @__PURE__ */ new Map() : ide;
  for (; ++a < t.children.length; ) {
    const i = t.children[a];
    let c;
    if (e.passKeys) {
      const l = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (l) {
        const u = o.get(l) || 0;
        c = l + "-" + u, o.set(l, u + 1);
      }
    }
    const s = ZN(e, i, c);
    s !== void 0 && n.push(s);
  }
  return n;
}
function bde(e, t, n) {
  const a = ME(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = a.commaSeparated ? FN(n) : WN(n)), a.property === "style") {
      let o = typeof n == "object" ? n : Lde(e, String(n));
      return e.stylePropertyNameCase === "css" && (o = xde(o)), ["style", o];
    }
    return [
      e.elementAttributeNameCase === "react" && a.space ? I2e[a.property] || a.property : a.attribute,
      n
    ];
  }
}
function Lde(e, t) {
  try {
    return rde(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const a = (
      /** @type {Error} */
      n
    ), o = new gt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: a,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw o.file = e.filePath || void 0, o.url = KN + "#cannot-parse-style-attribute", o;
  }
}
function JN(e, t, n) {
  let a;
  if (!n)
    a = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const o = t.split(".");
    let i = -1, c;
    for (; ++i < o.length; ) {
      const s = aI(o[i]) ? { type: "Identifier", name: o[i] } : { type: "Literal", value: o[i] };
      c = c ? {
        type: "MemberExpression",
        object: c,
        property: s,
        computed: !!(i && s.type === "Literal"),
        optional: !1
      } : s;
    }
    a = c;
  } else
    a = aI(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (a.type === "Literal") {
    const o = (
      /** @type {string | number} */
      a.value
    );
    return Yv.call(e.components, o) ? e.components[o] : o;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(a);
  dc(e);
}
function dc(e, t) {
  const n = new gt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = KN + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function xde(e) {
  const t = {};
  let n;
  for (n in e)
    Yv.call(e, n) && (t[Ede(n)] = e[n]);
  return t;
}
function Ede(e) {
  let t = e.replace(cde, vde);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function vde(e) {
  return "-" + e.toLowerCase();
}
const BE = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, Ade = {};
function Ide(e, t) {
  const n = Ade, a = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, o = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return eC(e, a, o);
}
function eC(e, t, n) {
  if (Tde(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return kI(e.children, t, n);
  }
  return Array.isArray(e) ? kI(e, t, n) : "";
}
function kI(e, t, n) {
  const a = [];
  let o = -1;
  for (; ++o < e.length; )
    a[o] = eC(e[o], t, n);
  return a.join("");
}
function Tde(e) {
  return !!(e && typeof e == "object");
}
const fI = document.createElement("i");
function Qv(e) {
  const t = "&" + e + ";";
  fI.innerHTML = t;
  const n = fI.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Mn(e, t, n, a) {
  const o = e.length;
  let i = 0, c;
  if (t < 0 ? t = -t > o ? 0 : o + t : t = t > o ? o : t, n = n > 0 ? n : 0, a.length < 1e4)
    c = Array.from(a), c.unshift(t, n), e.splice(...c);
  else
    for (n && e.splice(t, n); i < a.length; )
      c = a.slice(i, i + 1e4), c.unshift(t, 0), e.splice(...c), i += 1e4, t += 1e4;
}
function Gt(e, t) {
  return e.length > 0 ? (Mn(e, e.length, 0, t), e) : t;
}
const mI = {}.hasOwnProperty;
function Nde(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Cde(t, e[n]);
  return t;
}
function Cde(e, t) {
  let n;
  for (n in t) {
    const o = (mI.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let c;
    if (i)
      for (c in i) {
        mI.call(o, c) || (o[c] = []);
        const s = i[c];
        wde(
          // @ts-expect-error Looks like a list.
          o[c],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function wde(e, t) {
  let n = -1;
  const a = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : a).push(t[n]);
  Mn(e, 0, 0, a);
}
function tC(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function yi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const fn = Jn(/[A-Za-z]/), Ft = Jn(/[\dA-Za-z]/), Sde = Jn(/[#-'*+\--9=?A-Z^-~]/);
function mv(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const gv = Jn(/\d/), Rde = Jn(/[\dA-Fa-f]/), Dde = Jn(/[!-/:-@[-`{-~]/);
function pe(e) {
  return e !== null && e < -2;
}
function Ct(e) {
  return e !== null && (e < 0 || e === 32);
}
function Ce(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ode = Jn(new RegExp("\\p{P}|\\p{S}", "u")), Pde = Jn(/\s/);
function Jn(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Ai(e) {
  const t = [];
  let n = -1, a = 0, o = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let c = "";
    if (i === 37 && Ft(e.charCodeAt(n + 1)) && Ft(e.charCodeAt(n + 2)))
      o = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (c = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const s = e.charCodeAt(n + 1);
      i < 56320 && s > 56319 && s < 57344 ? (c = String.fromCharCode(i, s), o = 1) : c = "�";
    } else
      c = String.fromCharCode(i);
    c && (t.push(e.slice(a, n), encodeURIComponent(c)), a = n + o + 1, c = ""), o && (n += o, o = 0);
  }
  return t.join("") + e.slice(a);
}
function Fe(e, t, n, a) {
  const o = a ? a - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return c;
  function c(l) {
    return Ce(l) ? (e.enter(n), s(l)) : t(l);
  }
  function s(l) {
    return Ce(l) && i++ < o ? (e.consume(l), s) : (e.exit(n), t(l));
  }
}
const Hde = {
  tokenize: Bde
};
function Bde(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, a, o);
  let n;
  return t;
  function a(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Fe(e, t, "linePrefix");
  }
  function o(s) {
    return e.enter("paragraph"), i(s);
  }
  function i(s) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, c(s);
  }
  function c(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return pe(s) ? (e.consume(s), e.exit("chunkText"), i) : (e.consume(s), c);
  }
}
const Fde = {
  tokenize: $de
}, gI = {
  tokenize: Ude
};
function $de(e) {
  const t = this, n = [];
  let a = 0, o, i, c;
  return s;
  function s(I) {
    if (a < n.length) {
      const S = n[a];
      return t.containerState = S[1], e.attempt(S[0].continuation, l, u)(I);
    }
    return u(I);
  }
  function l(I) {
    if (a++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, o && N();
      const S = t.events.length;
      let O = S, A;
      for (; O--; )
        if (t.events[O][0] === "exit" && t.events[O][1].type === "chunkFlow") {
          A = t.events[O][1].end;
          break;
        }
      L(a);
      let B = S;
      for (; B < t.events.length; )
        t.events[B][1].end = {
          ...A
        }, B++;
      return Mn(t.events, O + 1, 0, t.events.slice(S)), t.events.length = B, u(I);
    }
    return s(I);
  }
  function u(I) {
    if (a === n.length) {
      if (!o)
        return f(I);
      if (o.currentConstruct && o.currentConstruct.concrete)
        return m(I);
      t.interrupt = !!(o.currentConstruct && !o._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(gI, h, k)(I);
  }
  function h(I) {
    return o && N(), L(a), f(I);
  }
  function k(I) {
    return t.parser.lazy[t.now().line] = a !== n.length, c = t.now().offset, m(I);
  }
  function f(I) {
    return t.containerState = {}, e.attempt(gI, y, m)(I);
  }
  function y(I) {
    return a++, n.push([t.currentConstruct, t.containerState]), f(I);
  }
  function m(I) {
    if (I === null) {
      o && N(), L(0), e.consume(I);
      return;
    }
    return o = o || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: o,
      contentType: "flow",
      previous: i
    }), g(I);
  }
  function g(I) {
    if (I === null) {
      _(e.exit("chunkFlow"), !0), L(0), e.consume(I);
      return;
    }
    return pe(I) ? (e.consume(I), _(e.exit("chunkFlow")), a = 0, t.interrupt = void 0, s) : (e.consume(I), g);
  }
  function _(I, S) {
    const O = t.sliceStream(I);
    if (S && O.push(null), I.previous = i, i && (i.next = I), i = I, o.defineSkip(I.start), o.write(O), t.parser.lazy[I.start.line]) {
      let A = o.events.length;
      for (; A--; )
        if (
          // The token starts before the line ending…
          o.events[A][1].start.offset < c && // …and either is not ended yet…
          (!o.events[A][1].end || // …or ends after it.
          o.events[A][1].end.offset > c)
        )
          return;
      const B = t.events.length;
      let z = B, j, G;
      for (; z--; )
        if (t.events[z][0] === "exit" && t.events[z][1].type === "chunkFlow") {
          if (j) {
            G = t.events[z][1].end;
            break;
          }
          j = !0;
        }
      for (L(a), A = B; A < t.events.length; )
        t.events[A][1].end = {
          ...G
        }, A++;
      Mn(t.events, z + 1, 0, t.events.slice(B)), t.events.length = A;
    }
  }
  function L(I) {
    let S = n.length;
    for (; S-- > I; ) {
      const O = n[S];
      t.containerState = O[1], O[0].exit.call(t, e);
    }
    n.length = I;
  }
  function N() {
    o.write([null]), i = void 0, o = void 0, t.containerState._closeFlow = void 0;
  }
}
function Ude(e, t, n) {
  return Fe(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function MI(e) {
  if (e === null || Ct(e) || Pde(e))
    return 1;
  if (Ode(e))
    return 2;
}
function Jv(e, t, n) {
  const a = [];
  let o = -1;
  for (; ++o < e.length; ) {
    const i = e[o].resolveAll;
    i && !a.includes(i) && (t = i(t, n), a.push(i));
  }
  return t;
}
const Mv = {
  name: "attention",
  resolveAll: qde,
  tokenize: zde
};
function qde(e, t) {
  let n = -1, a, o, i, c, s, l, u, h;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (a = n; a--; )
        if (e[a][0] === "exit" && e[a][1].type === "attentionSequence" && e[a][1]._open && // If the markers are the same:
        t.sliceSerialize(e[a][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[a][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[a][1].end.offset - e[a][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[a][1].end.offset - e[a][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const k = {
            ...e[a][1].end
          }, f = {
            ...e[n][1].start
          };
          _I(k, -l), _I(f, l), c = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: k,
            end: {
              ...e[a][1].end
            }
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: f
          }, i = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[a][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, o = {
            type: l > 1 ? "strong" : "emphasis",
            start: {
              ...c.start
            },
            end: {
              ...s.end
            }
          }, e[a][1].end = {
            ...c.start
          }, e[n][1].start = {
            ...s.end
          }, u = [], e[a][1].end.offset - e[a][1].start.offset && (u = Gt(u, [["enter", e[a][1], t], ["exit", e[a][1], t]])), u = Gt(u, [["enter", o, t], ["enter", c, t], ["exit", c, t], ["enter", i, t]]), u = Gt(u, Jv(t.parser.constructs.insideSpan.null, e.slice(a + 1, n), t)), u = Gt(u, [["exit", i, t], ["enter", s, t], ["exit", s, t], ["exit", o, t]]), e[n][1].end.offset - e[n][1].start.offset ? (h = 2, u = Gt(u, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : h = 0, Mn(e, a - 1, n - a + 3, u), n = a + u.length - h - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function zde(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, a = this.previous, o = MI(a);
  let i;
  return c;
  function c(l) {
    return i = l, e.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === i)
      return e.consume(l), s;
    const u = e.exit("attentionSequence"), h = MI(l), k = !h || h === 2 && o || n.includes(l), f = !o || o === 2 && h || n.includes(a);
    return u._open = !!(i === 42 ? k : k && (o || !f)), u._close = !!(i === 42 ? f : f && (h || !k)), t(l);
  }
}
function _I(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const jde = {
  name: "autolink",
  tokenize: Vde
};
function Vde(e, t, n) {
  let a = 0;
  return o;
  function o(y) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(y) {
    return fn(y) ? (e.consume(y), c) : y === 64 ? n(y) : u(y);
  }
  function c(y) {
    return y === 43 || y === 45 || y === 46 || Ft(y) ? (a = 1, s(y)) : u(y);
  }
  function s(y) {
    return y === 58 ? (e.consume(y), a = 0, l) : (y === 43 || y === 45 || y === 46 || Ft(y)) && a++ < 32 ? (e.consume(y), s) : (a = 0, u(y));
  }
  function l(y) {
    return y === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), t) : y === null || y === 32 || y === 60 || mv(y) ? n(y) : (e.consume(y), l);
  }
  function u(y) {
    return y === 64 ? (e.consume(y), h) : Sde(y) ? (e.consume(y), u) : n(y);
  }
  function h(y) {
    return Ft(y) ? k(y) : n(y);
  }
  function k(y) {
    return y === 46 ? (e.consume(y), a = 0, h) : y === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(y);
  }
  function f(y) {
    if ((y === 45 || Ft(y)) && a++ < 63) {
      const m = y === 45 ? f : k;
      return e.consume(y), m;
    }
    return n(y);
  }
}
const LE = {
  partial: !0,
  tokenize: Gde
};
function Gde(e, t, n) {
  return a;
  function a(i) {
    return Ce(i) ? Fe(e, o, "linePrefix")(i) : o(i);
  }
  function o(i) {
    return i === null || pe(i) ? t(i) : n(i);
  }
}
const nC = {
  continuation: {
    tokenize: Xde
  },
  exit: Yde,
  name: "blockQuote",
  tokenize: Wde
};
function Wde(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    if (c === 62) {
      const s = a.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(c), e.exit("blockQuoteMarker"), i;
    }
    return n(c);
  }
  function i(c) {
    return Ce(c) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(c), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(c));
  }
}
function Xde(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return Ce(c) ? Fe(e, i, "linePrefix", a.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(c) : i(c);
  }
  function i(c) {
    return e.attempt(nC, t, n)(c);
  }
}
function Yde(e) {
  e.exit("blockQuote");
}
const aC = {
  name: "characterEscape",
  tokenize: Kde
};
function Kde(e, t, n) {
  return a;
  function a(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), o;
  }
  function o(i) {
    return Dde(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const oC = {
  name: "characterReference",
  tokenize: Zde
};
function Zde(e, t, n) {
  const a = this;
  let o = 0, i, c;
  return s;
  function s(k) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(k), e.exit("characterReferenceMarker"), l;
  }
  function l(k) {
    return k === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(k), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), i = 31, c = Ft, h(k));
  }
  function u(k) {
    return k === 88 || k === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(k), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, c = Rde, h) : (e.enter("characterReferenceValue"), i = 7, c = gv, h(k));
  }
  function h(k) {
    if (k === 59 && o) {
      const f = e.exit("characterReferenceValue");
      return c === Ft && !Qv(a.sliceSerialize(f)) ? n(k) : (e.enter("characterReferenceMarker"), e.consume(k), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return c(k) && o++ < i ? (e.consume(k), h) : n(k);
  }
}
const bI = {
  partial: !0,
  tokenize: Jde
}, LI = {
  concrete: !0,
  name: "codeFenced",
  tokenize: Qde
};
function Qde(e, t, n) {
  const a = this, o = {
    partial: !0,
    tokenize: O
  };
  let i = 0, c = 0, s;
  return l;
  function l(A) {
    return u(A);
  }
  function u(A) {
    const B = a.events[a.events.length - 1];
    return i = B && B[1].type === "linePrefix" ? B[2].sliceSerialize(B[1], !0).length : 0, s = A, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), h(A);
  }
  function h(A) {
    return A === s ? (c++, e.consume(A), h) : c < 3 ? n(A) : (e.exit("codeFencedFenceSequence"), Ce(A) ? Fe(e, k, "whitespace")(A) : k(A));
  }
  function k(A) {
    return A === null || pe(A) ? (e.exit("codeFencedFence"), a.interrupt ? t(A) : e.check(bI, g, S)(A)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(A));
  }
  function f(A) {
    return A === null || pe(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), k(A)) : Ce(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Fe(e, y, "whitespace")(A)) : A === 96 && A === s ? n(A) : (e.consume(A), f);
  }
  function y(A) {
    return A === null || pe(A) ? k(A) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), m(A));
  }
  function m(A) {
    return A === null || pe(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), k(A)) : A === 96 && A === s ? n(A) : (e.consume(A), m);
  }
  function g(A) {
    return e.attempt(o, S, _)(A);
  }
  function _(A) {
    return e.enter("lineEnding"), e.consume(A), e.exit("lineEnding"), L;
  }
  function L(A) {
    return i > 0 && Ce(A) ? Fe(e, N, "linePrefix", i + 1)(A) : N(A);
  }
  function N(A) {
    return A === null || pe(A) ? e.check(bI, g, S)(A) : (e.enter("codeFlowValue"), I(A));
  }
  function I(A) {
    return A === null || pe(A) ? (e.exit("codeFlowValue"), N(A)) : (e.consume(A), I);
  }
  function S(A) {
    return e.exit("codeFenced"), t(A);
  }
  function O(A, B, z) {
    let j = 0;
    return G;
    function G(U) {
      return A.enter("lineEnding"), A.consume(U), A.exit("lineEnding"), $;
    }
    function $(U) {
      return A.enter("codeFencedFence"), Ce(U) ? Fe(A, H, "linePrefix", a.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(U) : H(U);
    }
    function H(U) {
      return U === s ? (A.enter("codeFencedFenceSequence"), ee(U)) : z(U);
    }
    function ee(U) {
      return U === s ? (j++, A.consume(U), ee) : j >= c ? (A.exit("codeFencedFenceSequence"), Ce(U) ? Fe(A, Y, "whitespace")(U) : Y(U)) : z(U);
    }
    function Y(U) {
      return U === null || pe(U) ? (A.exit("codeFencedFence"), B(U)) : z(U);
    }
  }
}
function Jde(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return c === null ? n(c) : (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), i);
  }
  function i(c) {
    return a.parser.lazy[a.now().line] ? n(c) : t(c);
  }
}
const FE = {
  name: "codeIndented",
  tokenize: tue
}, eue = {
  partial: !0,
  tokenize: nue
};
function tue(e, t, n) {
  const a = this;
  return o;
  function o(u) {
    return e.enter("codeIndented"), Fe(e, i, "linePrefix", 5)(u);
  }
  function i(u) {
    const h = a.events[a.events.length - 1];
    return h && h[1].type === "linePrefix" && h[2].sliceSerialize(h[1], !0).length >= 4 ? c(u) : n(u);
  }
  function c(u) {
    return u === null ? l(u) : pe(u) ? e.attempt(eue, c, l)(u) : (e.enter("codeFlowValue"), s(u));
  }
  function s(u) {
    return u === null || pe(u) ? (e.exit("codeFlowValue"), c(u)) : (e.consume(u), s);
  }
  function l(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function nue(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return a.parser.lazy[a.now().line] ? n(c) : pe(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), o) : Fe(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const s = a.events[a.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(c) : pe(c) ? o(c) : n(c);
  }
}
const aue = {
  name: "codeText",
  previous: rue,
  resolve: oue,
  tokenize: iue
};
function oue(e) {
  let t = e.length - 4, n = 3, a, o;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (a = n; ++a < t; )
      if (e[a][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (a = n - 1, t++; ++a <= t; )
    o === void 0 ? a !== t && e[a][1].type !== "lineEnding" && (o = a) : (a === t || e[a][1].type === "lineEnding") && (e[o][1].type = "codeTextData", a !== o + 2 && (e[o][1].end = e[a - 1][1].end, e.splice(o + 2, a - o - 2), t -= a - o - 2, a = o + 2), o = void 0);
  return e;
}
function rue(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function iue(e, t, n) {
  let a = 0, o, i;
  return c;
  function c(k) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(k);
  }
  function s(k) {
    return k === 96 ? (e.consume(k), a++, s) : (e.exit("codeTextSequence"), l(k));
  }
  function l(k) {
    return k === null ? n(k) : k === 32 ? (e.enter("space"), e.consume(k), e.exit("space"), l) : k === 96 ? (i = e.enter("codeTextSequence"), o = 0, h(k)) : pe(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(k));
  }
  function u(k) {
    return k === null || k === 32 || k === 96 || pe(k) ? (e.exit("codeTextData"), l(k)) : (e.consume(k), u);
  }
  function h(k) {
    return k === 96 ? (e.consume(k), o++, h) : o === a ? (e.exit("codeTextSequence"), e.exit("codeText"), t(k)) : (i.type = "codeTextData", u(k));
  }
}
class cue {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const a = n ?? Number.POSITIVE_INFINITY;
    return a < this.left.length ? this.left.slice(t, a) : t > this.left.length ? this.right.slice(this.right.length - a + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - a + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, a) {
    const o = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - o, Number.POSITIVE_INFINITY);
    return a && Pi(this.left, a), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Pi(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Pi(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Pi(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Pi(this.left, n.reverse());
      }
  }
}
function Pi(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function rC(e) {
  const t = {};
  let n = -1, a, o, i, c, s, l, u;
  const h = new cue(e);
  for (; ++n < h.length; ) {
    for (; n in t; )
      n = t[n];
    if (a = h.get(n), n && a[1].type === "chunkFlow" && h.get(n - 1)[1].type === "listItemPrefix" && (l = a[1]._tokenizer.events, i = 0, i < l.length && l[i][1].type === "lineEndingBlank" && (i += 2), i < l.length && l[i][1].type === "content"))
      for (; ++i < l.length && l[i][1].type !== "content"; )
        l[i][1].type === "chunkText" && (l[i][1]._isInFirstContentOfListItem = !0, i++);
    if (a[0] === "enter")
      a[1].contentType && (Object.assign(t, sue(h, n)), n = t[n], u = !0);
    else if (a[1]._container) {
      for (i = n, o = void 0; i--; )
        if (c = h.get(i), c[1].type === "lineEnding" || c[1].type === "lineEndingBlank")
          c[0] === "enter" && (o && (h.get(o)[1].type = "lineEndingBlank"), c[1].type = "lineEnding", o = i);
        else if (!(c[1].type === "linePrefix" || c[1].type === "listItemIndent")) break;
      o && (a[1].end = {
        ...h.get(o)[1].start
      }, s = h.slice(o, n), s.unshift(a), h.splice(o, n - o + 1, s));
    }
  }
  return Mn(e, 0, Number.POSITIVE_INFINITY, h.slice(0)), !u;
}
function sue(e, t) {
  const n = e.get(t)[1], a = e.get(t)[2];
  let o = t - 1;
  const i = [];
  let c = n._tokenizer;
  c || (c = a.parser[n.contentType](n.start), n._contentTypeTextTrailing && (c._contentTypeTextTrailing = !0));
  const s = c.events, l = [], u = {};
  let h, k, f = -1, y = n, m = 0, g = 0;
  const _ = [g];
  for (; y; ) {
    for (; e.get(++o)[1] !== y; )
      ;
    i.push(o), y._tokenizer || (h = a.sliceStream(y), y.next || h.push(null), k && c.defineSkip(y.start), y._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = !0), c.write(h), y._isInFirstContentOfListItem && (c._gfmTasklistFirstContentOfListItem = void 0)), k = y, y = y.next;
  }
  for (y = n; ++f < s.length; )
    // Find a void token that includes a break.
    s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (g = f + 1, _.push(g), y._tokenizer = void 0, y.previous = void 0, y = y.next);
  for (c.events = [], y ? (y._tokenizer = void 0, y.previous = void 0) : _.pop(), f = _.length; f--; ) {
    const L = s.slice(_[f], _[f + 1]), N = i.pop();
    l.push([N, N + L.length - 1]), e.splice(N, 2, L);
  }
  for (l.reverse(), f = -1; ++f < l.length; )
    u[m + l[f][0]] = m + l[f][1], m += l[f][1] - l[f][0] - 1;
  return u;
}
const lue = {
  resolve: uue,
  tokenize: hue
}, due = {
  partial: !0,
  tokenize: pue
};
function uue(e) {
  return rC(e), e;
}
function hue(e, t) {
  let n;
  return a;
  function a(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), o(s);
  }
  function o(s) {
    return s === null ? i(s) : pe(s) ? e.check(due, c, i)(s) : (e.consume(s), o);
  }
  function i(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function c(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, o;
  }
}
function pue(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), Fe(e, i, "linePrefix");
  }
  function i(c) {
    if (c === null || pe(c))
      return n(c);
    const s = a.events[a.events.length - 1];
    return !a.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(c) : e.interrupt(a.parser.constructs.flow, n, t)(c);
  }
}
function iC(e, t, n, a, o, i, c, s, l) {
  const u = l || Number.POSITIVE_INFINITY;
  let h = 0;
  return k;
  function k(L) {
    return L === 60 ? (e.enter(a), e.enter(o), e.enter(i), e.consume(L), e.exit(i), f) : L === null || L === 32 || L === 41 || mv(L) ? n(L) : (e.enter(a), e.enter(c), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), g(L));
  }
  function f(L) {
    return L === 62 ? (e.enter(i), e.consume(L), e.exit(i), e.exit(o), e.exit(a), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), y(L));
  }
  function y(L) {
    return L === 62 ? (e.exit("chunkString"), e.exit(s), f(L)) : L === null || L === 60 || pe(L) ? n(L) : (e.consume(L), L === 92 ? m : y);
  }
  function m(L) {
    return L === 60 || L === 62 || L === 92 ? (e.consume(L), y) : y(L);
  }
  function g(L) {
    return !h && (L === null || L === 41 || Ct(L)) ? (e.exit("chunkString"), e.exit(s), e.exit(c), e.exit(a), t(L)) : h < u && L === 40 ? (e.consume(L), h++, g) : L === 41 ? (e.consume(L), h--, g) : L === null || L === 32 || L === 40 || mv(L) ? n(L) : (e.consume(L), L === 92 ? _ : g);
  }
  function _(L) {
    return L === 40 || L === 41 || L === 92 ? (e.consume(L), g) : g(L);
  }
}
function cC(e, t, n, a, o, i) {
  const c = this;
  let s = 0, l;
  return u;
  function u(y) {
    return e.enter(a), e.enter(o), e.consume(y), e.exit(o), e.enter(i), h;
  }
  function h(y) {
    return s > 999 || y === null || y === 91 || y === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    y === 94 && !s && "_hiddenFootnoteSupport" in c.parser.constructs ? n(y) : y === 93 ? (e.exit(i), e.enter(o), e.consume(y), e.exit(o), e.exit(a), t) : pe(y) ? (e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), h) : (e.enter("chunkString", {
      contentType: "string"
    }), k(y));
  }
  function k(y) {
    return y === null || y === 91 || y === 93 || pe(y) || s++ > 999 ? (e.exit("chunkString"), h(y)) : (e.consume(y), l || (l = !Ce(y)), y === 92 ? f : k);
  }
  function f(y) {
    return y === 91 || y === 92 || y === 93 ? (e.consume(y), s++, k) : k(y);
  }
}
function sC(e, t, n, a, o, i) {
  let c;
  return s;
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(a), e.enter(o), e.consume(f), e.exit(o), c = f === 40 ? 41 : f, l) : n(f);
  }
  function l(f) {
    return f === c ? (e.enter(o), e.consume(f), e.exit(o), e.exit(a), t) : (e.enter(i), u(f));
  }
  function u(f) {
    return f === c ? (e.exit(i), l(c)) : f === null ? n(f) : pe(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), Fe(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), h(f));
  }
  function h(f) {
    return f === c || f === null || pe(f) ? (e.exit("chunkString"), u(f)) : (e.consume(f), f === 92 ? k : h);
  }
  function k(f) {
    return f === c || f === 92 ? (e.consume(f), h) : h(f);
  }
}
function Ki(e, t) {
  let n;
  return a;
  function a(o) {
    return pe(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n = !0, a) : Ce(o) ? Fe(e, a, n ? "linePrefix" : "lineSuffix")(o) : t(o);
  }
}
const yue = {
  name: "definition",
  tokenize: fue
}, kue = {
  partial: !0,
  tokenize: mue
};
function fue(e, t, n) {
  const a = this;
  let o;
  return i;
  function i(y) {
    return e.enter("definition"), c(y);
  }
  function c(y) {
    return cC.call(
      a,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(y);
  }
  function s(y) {
    return o = yi(a.sliceSerialize(a.events[a.events.length - 1][1]).slice(1, -1)), y === 58 ? (e.enter("definitionMarker"), e.consume(y), e.exit("definitionMarker"), l) : n(y);
  }
  function l(y) {
    return Ct(y) ? Ki(e, u)(y) : u(y);
  }
  function u(y) {
    return iC(
      e,
      h,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(y);
  }
  function h(y) {
    return e.attempt(kue, k, k)(y);
  }
  function k(y) {
    return Ce(y) ? Fe(e, f, "whitespace")(y) : f(y);
  }
  function f(y) {
    return y === null || pe(y) ? (e.exit("definition"), a.parser.defined.push(o), t(y)) : n(y);
  }
}
function mue(e, t, n) {
  return a;
  function a(s) {
    return Ct(s) ? Ki(e, o)(s) : n(s);
  }
  function o(s) {
    return sC(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function i(s) {
    return Ce(s) ? Fe(e, c, "whitespace")(s) : c(s);
  }
  function c(s) {
    return s === null || pe(s) ? t(s) : n(s);
  }
}
const gue = {
  name: "hardBreakEscape",
  tokenize: Mue
};
function Mue(e, t, n) {
  return a;
  function a(i) {
    return e.enter("hardBreakEscape"), e.consume(i), o;
  }
  function o(i) {
    return pe(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const _ue = {
  name: "headingAtx",
  resolve: bue,
  tokenize: Lue
};
function bue(e, t) {
  let n = e.length - 2, a = 3, o, i;
  return e[a][1].type === "whitespace" && (a += 2), n - 2 > a && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (a === n - 1 || n - 4 > a && e[n - 2][1].type === "whitespace") && (n -= a + 1 === n ? 2 : 4), n > a && (o = {
    type: "atxHeadingText",
    start: e[a][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[a][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Mn(e, a, n - a + 1, [["enter", o, t], ["enter", i, t], ["exit", i, t], ["exit", o, t]])), e;
}
function Lue(e, t, n) {
  let a = 0;
  return o;
  function o(h) {
    return e.enter("atxHeading"), i(h);
  }
  function i(h) {
    return e.enter("atxHeadingSequence"), c(h);
  }
  function c(h) {
    return h === 35 && a++ < 6 ? (e.consume(h), c) : h === null || Ct(h) ? (e.exit("atxHeadingSequence"), s(h)) : n(h);
  }
  function s(h) {
    return h === 35 ? (e.enter("atxHeadingSequence"), l(h)) : h === null || pe(h) ? (e.exit("atxHeading"), t(h)) : Ce(h) ? Fe(e, s, "whitespace")(h) : (e.enter("atxHeadingText"), u(h));
  }
  function l(h) {
    return h === 35 ? (e.consume(h), l) : (e.exit("atxHeadingSequence"), s(h));
  }
  function u(h) {
    return h === null || h === 35 || Ct(h) ? (e.exit("atxHeadingText"), s(h)) : (e.consume(h), u);
  }
}
const xue = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], xI = ["pre", "script", "style", "textarea"], Eue = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Iue,
  tokenize: Tue
}, vue = {
  partial: !0,
  tokenize: Cue
}, Aue = {
  partial: !0,
  tokenize: Nue
};
function Iue(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Tue(e, t, n) {
  const a = this;
  let o, i, c, s, l;
  return u;
  function u(T) {
    return h(T);
  }
  function h(T) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(T), k;
  }
  function k(T) {
    return T === 33 ? (e.consume(T), f) : T === 47 ? (e.consume(T), i = !0, g) : T === 63 ? (e.consume(T), o = 3, a.interrupt ? t : E) : fn(T) ? (e.consume(T), c = String.fromCharCode(T), _) : n(T);
  }
  function f(T) {
    return T === 45 ? (e.consume(T), o = 2, y) : T === 91 ? (e.consume(T), o = 5, s = 0, m) : fn(T) ? (e.consume(T), o = 4, a.interrupt ? t : E) : n(T);
  }
  function y(T) {
    return T === 45 ? (e.consume(T), a.interrupt ? t : E) : n(T);
  }
  function m(T) {
    const Xe = "CDATA[";
    return T === Xe.charCodeAt(s++) ? (e.consume(T), s === Xe.length ? a.interrupt ? t : H : m) : n(T);
  }
  function g(T) {
    return fn(T) ? (e.consume(T), c = String.fromCharCode(T), _) : n(T);
  }
  function _(T) {
    if (T === null || T === 47 || T === 62 || Ct(T)) {
      const Xe = T === 47, ht = c.toLowerCase();
      return !Xe && !i && xI.includes(ht) ? (o = 1, a.interrupt ? t(T) : H(T)) : xue.includes(c.toLowerCase()) ? (o = 6, Xe ? (e.consume(T), L) : a.interrupt ? t(T) : H(T)) : (o = 7, a.interrupt && !a.parser.lazy[a.now().line] ? n(T) : i ? N(T) : I(T));
    }
    return T === 45 || Ft(T) ? (e.consume(T), c += String.fromCharCode(T), _) : n(T);
  }
  function L(T) {
    return T === 62 ? (e.consume(T), a.interrupt ? t : H) : n(T);
  }
  function N(T) {
    return Ce(T) ? (e.consume(T), N) : G(T);
  }
  function I(T) {
    return T === 47 ? (e.consume(T), G) : T === 58 || T === 95 || fn(T) ? (e.consume(T), S) : Ce(T) ? (e.consume(T), I) : G(T);
  }
  function S(T) {
    return T === 45 || T === 46 || T === 58 || T === 95 || Ft(T) ? (e.consume(T), S) : O(T);
  }
  function O(T) {
    return T === 61 ? (e.consume(T), A) : Ce(T) ? (e.consume(T), O) : I(T);
  }
  function A(T) {
    return T === null || T === 60 || T === 61 || T === 62 || T === 96 ? n(T) : T === 34 || T === 39 ? (e.consume(T), l = T, B) : Ce(T) ? (e.consume(T), A) : z(T);
  }
  function B(T) {
    return T === l ? (e.consume(T), l = null, j) : T === null || pe(T) ? n(T) : (e.consume(T), B);
  }
  function z(T) {
    return T === null || T === 34 || T === 39 || T === 47 || T === 60 || T === 61 || T === 62 || T === 96 || Ct(T) ? O(T) : (e.consume(T), z);
  }
  function j(T) {
    return T === 47 || T === 62 || Ce(T) ? I(T) : n(T);
  }
  function G(T) {
    return T === 62 ? (e.consume(T), $) : n(T);
  }
  function $(T) {
    return T === null || pe(T) ? H(T) : Ce(T) ? (e.consume(T), $) : n(T);
  }
  function H(T) {
    return T === 45 && o === 2 ? (e.consume(T), Z) : T === 60 && o === 1 ? (e.consume(T), te) : T === 62 && o === 4 ? (e.consume(T), ve) : T === 63 && o === 3 ? (e.consume(T), E) : T === 93 && o === 5 ? (e.consume(T), ue) : pe(T) && (o === 6 || o === 7) ? (e.exit("htmlFlowData"), e.check(vue, be, ee)(T)) : T === null || pe(T) ? (e.exit("htmlFlowData"), ee(T)) : (e.consume(T), H);
  }
  function ee(T) {
    return e.check(Aue, Y, be)(T);
  }
  function Y(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), U;
  }
  function U(T) {
    return T === null || pe(T) ? ee(T) : (e.enter("htmlFlowData"), H(T));
  }
  function Z(T) {
    return T === 45 ? (e.consume(T), E) : H(T);
  }
  function te(T) {
    return T === 47 ? (e.consume(T), c = "", re) : H(T);
  }
  function re(T) {
    if (T === 62) {
      const Xe = c.toLowerCase();
      return xI.includes(Xe) ? (e.consume(T), ve) : H(T);
    }
    return fn(T) && c.length < 8 ? (e.consume(T), c += String.fromCharCode(T), re) : H(T);
  }
  function ue(T) {
    return T === 93 ? (e.consume(T), E) : H(T);
  }
  function E(T) {
    return T === 62 ? (e.consume(T), ve) : T === 45 && o === 2 ? (e.consume(T), E) : H(T);
  }
  function ve(T) {
    return T === null || pe(T) ? (e.exit("htmlFlowData"), be(T)) : (e.consume(T), ve);
  }
  function be(T) {
    return e.exit("htmlFlow"), t(T);
  }
}
function Nue(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return pe(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), i) : n(c);
  }
  function i(c) {
    return a.parser.lazy[a.now().line] ? n(c) : t(c);
  }
}
function Cue(e, t, n) {
  return a;
  function a(o) {
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), e.attempt(LE, t, n);
  }
}
const wue = {
  name: "htmlText",
  tokenize: Sue
};
function Sue(e, t, n) {
  const a = this;
  let o, i, c;
  return s;
  function s(E) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(E), l;
  }
  function l(E) {
    return E === 33 ? (e.consume(E), u) : E === 47 ? (e.consume(E), O) : E === 63 ? (e.consume(E), I) : fn(E) ? (e.consume(E), z) : n(E);
  }
  function u(E) {
    return E === 45 ? (e.consume(E), h) : E === 91 ? (e.consume(E), i = 0, m) : fn(E) ? (e.consume(E), N) : n(E);
  }
  function h(E) {
    return E === 45 ? (e.consume(E), y) : n(E);
  }
  function k(E) {
    return E === null ? n(E) : E === 45 ? (e.consume(E), f) : pe(E) ? (c = k, te(E)) : (e.consume(E), k);
  }
  function f(E) {
    return E === 45 ? (e.consume(E), y) : k(E);
  }
  function y(E) {
    return E === 62 ? Z(E) : E === 45 ? f(E) : k(E);
  }
  function m(E) {
    const ve = "CDATA[";
    return E === ve.charCodeAt(i++) ? (e.consume(E), i === ve.length ? g : m) : n(E);
  }
  function g(E) {
    return E === null ? n(E) : E === 93 ? (e.consume(E), _) : pe(E) ? (c = g, te(E)) : (e.consume(E), g);
  }
  function _(E) {
    return E === 93 ? (e.consume(E), L) : g(E);
  }
  function L(E) {
    return E === 62 ? Z(E) : E === 93 ? (e.consume(E), L) : g(E);
  }
  function N(E) {
    return E === null || E === 62 ? Z(E) : pe(E) ? (c = N, te(E)) : (e.consume(E), N);
  }
  function I(E) {
    return E === null ? n(E) : E === 63 ? (e.consume(E), S) : pe(E) ? (c = I, te(E)) : (e.consume(E), I);
  }
  function S(E) {
    return E === 62 ? Z(E) : I(E);
  }
  function O(E) {
    return fn(E) ? (e.consume(E), A) : n(E);
  }
  function A(E) {
    return E === 45 || Ft(E) ? (e.consume(E), A) : B(E);
  }
  function B(E) {
    return pe(E) ? (c = B, te(E)) : Ce(E) ? (e.consume(E), B) : Z(E);
  }
  function z(E) {
    return E === 45 || Ft(E) ? (e.consume(E), z) : E === 47 || E === 62 || Ct(E) ? j(E) : n(E);
  }
  function j(E) {
    return E === 47 ? (e.consume(E), Z) : E === 58 || E === 95 || fn(E) ? (e.consume(E), G) : pe(E) ? (c = j, te(E)) : Ce(E) ? (e.consume(E), j) : Z(E);
  }
  function G(E) {
    return E === 45 || E === 46 || E === 58 || E === 95 || Ft(E) ? (e.consume(E), G) : $(E);
  }
  function $(E) {
    return E === 61 ? (e.consume(E), H) : pe(E) ? (c = $, te(E)) : Ce(E) ? (e.consume(E), $) : j(E);
  }
  function H(E) {
    return E === null || E === 60 || E === 61 || E === 62 || E === 96 ? n(E) : E === 34 || E === 39 ? (e.consume(E), o = E, ee) : pe(E) ? (c = H, te(E)) : Ce(E) ? (e.consume(E), H) : (e.consume(E), Y);
  }
  function ee(E) {
    return E === o ? (e.consume(E), o = void 0, U) : E === null ? n(E) : pe(E) ? (c = ee, te(E)) : (e.consume(E), ee);
  }
  function Y(E) {
    return E === null || E === 34 || E === 39 || E === 60 || E === 61 || E === 96 ? n(E) : E === 47 || E === 62 || Ct(E) ? j(E) : (e.consume(E), Y);
  }
  function U(E) {
    return E === 47 || E === 62 || Ct(E) ? j(E) : n(E);
  }
  function Z(E) {
    return E === 62 ? (e.consume(E), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(E);
  }
  function te(E) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), re;
  }
  function re(E) {
    return Ce(E) ? Fe(e, ue, "linePrefix", a.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(E) : ue(E);
  }
  function ue(E) {
    return e.enter("htmlTextData"), c(E);
  }
}
const eA = {
  name: "labelEnd",
  resolveAll: Pue,
  resolveTo: Hue,
  tokenize: Bue
}, Rue = {
  tokenize: Fue
}, Due = {
  tokenize: $ue
}, Oue = {
  tokenize: Uue
};
function Pue(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const a = e[t][1];
    if (n.push(e[t]), a.type === "labelImage" || a.type === "labelLink" || a.type === "labelEnd") {
      const o = a.type === "labelImage" ? 4 : 2;
      a.type = "data", t += o;
    }
  }
  return e.length !== n.length && Mn(e, 0, e.length, n), e;
}
function Hue(e, t) {
  let n = e.length, a = 0, o, i, c, s;
  for (; n--; )
    if (o = e[n][1], i) {
      if (o.type === "link" || o.type === "labelLink" && o._inactive)
        break;
      e[n][0] === "enter" && o.type === "labelLink" && (o._inactive = !0);
    } else if (c) {
      if (e[n][0] === "enter" && (o.type === "labelImage" || o.type === "labelLink") && !o._balanced && (i = n, o.type !== "labelLink")) {
        a = 2;
        break;
      }
    } else o.type === "labelEnd" && (c = n);
  const l = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[c][1].end
    }
  }, h = {
    type: "labelText",
    start: {
      ...e[i + a + 2][1].end
    },
    end: {
      ...e[c - 2][1].start
    }
  };
  return s = [["enter", l, t], ["enter", u, t]], s = Gt(s, e.slice(i + 1, i + a + 3)), s = Gt(s, [["enter", h, t]]), s = Gt(s, Jv(t.parser.constructs.insideSpan.null, e.slice(i + a + 4, c - 3), t)), s = Gt(s, [["exit", h, t], e[c - 2], e[c - 1], ["exit", u, t]]), s = Gt(s, e.slice(c + 1)), s = Gt(s, [["exit", l, t]]), Mn(e, i, e.length, s), e;
}
function Bue(e, t, n) {
  const a = this;
  let o = a.events.length, i, c;
  for (; o--; )
    if ((a.events[o][1].type === "labelImage" || a.events[o][1].type === "labelLink") && !a.events[o][1]._balanced) {
      i = a.events[o][1];
      break;
    }
  return s;
  function s(f) {
    return i ? i._inactive ? k(f) : (c = a.parser.defined.includes(yi(a.sliceSerialize({
      start: i.end,
      end: a.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(f);
  }
  function l(f) {
    return f === 40 ? e.attempt(Rue, h, c ? h : k)(f) : f === 91 ? e.attempt(Due, h, c ? u : k)(f) : c ? h(f) : k(f);
  }
  function u(f) {
    return e.attempt(Oue, h, k)(f);
  }
  function h(f) {
    return t(f);
  }
  function k(f) {
    return i._balanced = !0, n(f);
  }
}
function Fue(e, t, n) {
  return a;
  function a(k) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(k), e.exit("resourceMarker"), o;
  }
  function o(k) {
    return Ct(k) ? Ki(e, i)(k) : i(k);
  }
  function i(k) {
    return k === 41 ? h(k) : iC(e, c, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(k);
  }
  function c(k) {
    return Ct(k) ? Ki(e, l)(k) : h(k);
  }
  function s(k) {
    return n(k);
  }
  function l(k) {
    return k === 34 || k === 39 || k === 40 ? sC(e, u, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(k) : h(k);
  }
  function u(k) {
    return Ct(k) ? Ki(e, h)(k) : h(k);
  }
  function h(k) {
    return k === 41 ? (e.enter("resourceMarker"), e.consume(k), e.exit("resourceMarker"), e.exit("resource"), t) : n(k);
  }
}
function $ue(e, t, n) {
  const a = this;
  return o;
  function o(s) {
    return cC.call(a, e, i, c, "reference", "referenceMarker", "referenceString")(s);
  }
  function i(s) {
    return a.parser.defined.includes(yi(a.sliceSerialize(a.events[a.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function c(s) {
    return n(s);
  }
}
function Uue(e, t, n) {
  return a;
  function a(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), o;
  }
  function o(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const que = {
  name: "labelStartImage",
  resolveAll: eA.resolveAll,
  tokenize: zue
};
function zue(e, t, n) {
  const a = this;
  return o;
  function o(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), i;
  }
  function i(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), c) : n(s);
  }
  function c(s) {
    return s === 94 && "_hiddenFootnoteSupport" in a.parser.constructs ? n(s) : t(s);
  }
}
const jue = {
  name: "labelStartLink",
  resolveAll: eA.resolveAll,
  tokenize: Vue
};
function Vue(e, t, n) {
  const a = this;
  return o;
  function o(c) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(c), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(c) {
    return c === 94 && "_hiddenFootnoteSupport" in a.parser.constructs ? n(c) : t(c);
  }
}
const $E = {
  name: "lineEnding",
  tokenize: Gue
};
function Gue(e, t) {
  return n;
  function n(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Fe(e, t, "linePrefix");
  }
}
const V9 = {
  name: "thematicBreak",
  tokenize: Wue
};
function Wue(e, t, n) {
  let a = 0, o;
  return i;
  function i(u) {
    return e.enter("thematicBreak"), c(u);
  }
  function c(u) {
    return o = u, s(u);
  }
  function s(u) {
    return u === o ? (e.enter("thematicBreakSequence"), l(u)) : a >= 3 && (u === null || pe(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function l(u) {
    return u === o ? (e.consume(u), a++, l) : (e.exit("thematicBreakSequence"), Ce(u) ? Fe(e, s, "whitespace")(u) : s(u));
  }
}
const Tt = {
  continuation: {
    tokenize: Zue
  },
  exit: Jue,
  name: "list",
  tokenize: Kue
}, Xue = {
  partial: !0,
  tokenize: ehe
}, Yue = {
  partial: !0,
  tokenize: Que
};
function Kue(e, t, n) {
  const a = this, o = a.events[a.events.length - 1];
  let i = o && o[1].type === "linePrefix" ? o[2].sliceSerialize(o[1], !0).length : 0, c = 0;
  return s;
  function s(y) {
    const m = a.containerState.type || (y === 42 || y === 43 || y === 45 ? "listUnordered" : "listOrdered");
    if (m === "listUnordered" ? !a.containerState.marker || y === a.containerState.marker : gv(y)) {
      if (a.containerState.type || (a.containerState.type = m, e.enter(m, {
        _container: !0
      })), m === "listUnordered")
        return e.enter("listItemPrefix"), y === 42 || y === 45 ? e.check(V9, n, u)(y) : u(y);
      if (!a.interrupt || y === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(y);
    }
    return n(y);
  }
  function l(y) {
    return gv(y) && ++c < 10 ? (e.consume(y), l) : (!a.interrupt || c < 2) && (a.containerState.marker ? y === a.containerState.marker : y === 41 || y === 46) ? (e.exit("listItemValue"), u(y)) : n(y);
  }
  function u(y) {
    return e.enter("listItemMarker"), e.consume(y), e.exit("listItemMarker"), a.containerState.marker = a.containerState.marker || y, e.check(
      LE,
      // Can’t be empty when interrupting.
      a.interrupt ? n : h,
      e.attempt(Xue, f, k)
    );
  }
  function h(y) {
    return a.containerState.initialBlankLine = !0, i++, f(y);
  }
  function k(y) {
    return Ce(y) ? (e.enter("listItemPrefixWhitespace"), e.consume(y), e.exit("listItemPrefixWhitespace"), f) : n(y);
  }
  function f(y) {
    return a.containerState.size = i + a.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(y);
  }
}
function Zue(e, t, n) {
  const a = this;
  return a.containerState._closeFlow = void 0, e.check(LE, o, i);
  function o(s) {
    return a.containerState.furtherBlankLines = a.containerState.furtherBlankLines || a.containerState.initialBlankLine, Fe(e, t, "listItemIndent", a.containerState.size + 1)(s);
  }
  function i(s) {
    return a.containerState.furtherBlankLines || !Ce(s) ? (a.containerState.furtherBlankLines = void 0, a.containerState.initialBlankLine = void 0, c(s)) : (a.containerState.furtherBlankLines = void 0, a.containerState.initialBlankLine = void 0, e.attempt(Yue, t, c)(s));
  }
  function c(s) {
    return a.containerState._closeFlow = !0, a.interrupt = void 0, Fe(e, e.attempt(Tt, t, n), "linePrefix", a.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function Que(e, t, n) {
  const a = this;
  return Fe(e, o, "listItemIndent", a.containerState.size + 1);
  function o(i) {
    const c = a.events[a.events.length - 1];
    return c && c[1].type === "listItemIndent" && c[2].sliceSerialize(c[1], !0).length === a.containerState.size ? t(i) : n(i);
  }
}
function Jue(e) {
  e.exit(this.containerState.type);
}
function ehe(e, t, n) {
  const a = this;
  return Fe(e, o, "listItemPrefixWhitespace", a.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function o(i) {
    const c = a.events[a.events.length - 1];
    return !Ce(i) && c && c[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const EI = {
  name: "setextUnderline",
  resolveTo: the,
  tokenize: nhe
};
function the(e, t) {
  let n = e.length, a, o, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        a = n;
        break;
      }
      e[n][1].type === "paragraph" && (o = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const c = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[o][1].type = "setextHeadingText", i ? (e.splice(o, 0, ["enter", c, t]), e.splice(i + 1, 0, ["exit", e[a][1], t]), e[a][1].end = {
    ...e[i][1].end
  }) : e[a][1] = c, e.push(["exit", c, t]), e;
}
function nhe(e, t, n) {
  const a = this;
  let o;
  return i;
  function i(u) {
    let h = a.events.length, k;
    for (; h--; )
      if (a.events[h][1].type !== "lineEnding" && a.events[h][1].type !== "linePrefix" && a.events[h][1].type !== "content") {
        k = a.events[h][1].type === "paragraph";
        break;
      }
    return !a.parser.lazy[a.now().line] && (a.interrupt || k) ? (e.enter("setextHeadingLine"), o = u, c(u)) : n(u);
  }
  function c(u) {
    return e.enter("setextHeadingLineSequence"), s(u);
  }
  function s(u) {
    return u === o ? (e.consume(u), s) : (e.exit("setextHeadingLineSequence"), Ce(u) ? Fe(e, l, "lineSuffix")(u) : l(u));
  }
  function l(u) {
    return u === null || pe(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const ahe = {
  tokenize: ohe
};
function ohe(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    LE,
    a,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, o, Fe(e, e.attempt(this.parser.constructs.flow, o, e.attempt(lue, o)), "linePrefix"))
  );
  return n;
  function a(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function o(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const rhe = {
  resolveAll: dC()
}, ihe = lC("string"), che = lC("text");
function lC(e) {
  return {
    resolveAll: dC(e === "text" ? she : void 0),
    tokenize: t
  };
  function t(n) {
    const a = this, o = this.parser.constructs[e], i = n.attempt(o, c, s);
    return c;
    function c(h) {
      return u(h) ? i(h) : s(h);
    }
    function s(h) {
      if (h === null) {
        n.consume(h);
        return;
      }
      return n.enter("data"), n.consume(h), l;
    }
    function l(h) {
      return u(h) ? (n.exit("data"), i(h)) : (n.consume(h), l);
    }
    function u(h) {
      if (h === null)
        return !0;
      const k = o[h];
      let f = -1;
      if (k)
        for (; ++f < k.length; ) {
          const y = k[f];
          if (!y.previous || y.previous.call(a, a.previous))
            return !0;
        }
      return !1;
    }
  }
}
function dC(e) {
  return t;
  function t(n, a) {
    let o = -1, i;
    for (; ++o <= n.length; )
      i === void 0 ? n[o] && n[o][1].type === "data" && (i = o, o++) : (!n[o] || n[o][1].type !== "data") && (o !== i + 2 && (n[i][1].end = n[o - 1][1].end, n.splice(i + 2, o - i - 2), o = i + 2), i = void 0);
    return e ? e(n, a) : n;
  }
}
function she(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const a = e[n - 1][1], o = t.sliceStream(a);
      let i = o.length, c = -1, s = 0, l;
      for (; i--; ) {
        const u = o[i];
        if (typeof u == "string") {
          for (c = u.length; u.charCodeAt(c - 1) === 32; )
            s++, c--;
          if (c) break;
          c = -1;
        } else if (u === -2)
          l = !0, s++;
        else if (u !== -1) {
          i++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (s = 0), s) {
        const u = {
          type: n === e.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? c : a.start._bufferIndex + c,
            _index: a.start._index + i,
            line: a.end.line,
            column: a.end.column - s,
            offset: a.end.offset - s
          },
          end: {
            ...a.end
          }
        };
        a.end = {
          ...u.start
        }, a.start.offset === a.end.offset ? Object.assign(a, u) : (e.splice(n, 0, ["enter", u, t], ["exit", u, t]), n += 2);
      }
      n++;
    }
  return e;
}
const lhe = {
  42: Tt,
  43: Tt,
  45: Tt,
  48: Tt,
  49: Tt,
  50: Tt,
  51: Tt,
  52: Tt,
  53: Tt,
  54: Tt,
  55: Tt,
  56: Tt,
  57: Tt,
  62: nC
}, dhe = {
  91: yue
}, uhe = {
  [-2]: FE,
  [-1]: FE,
  32: FE
}, hhe = {
  35: _ue,
  42: V9,
  45: [EI, V9],
  60: Eue,
  61: EI,
  95: V9,
  96: LI,
  126: LI
}, phe = {
  38: oC,
  92: aC
}, yhe = {
  [-5]: $E,
  [-4]: $E,
  [-3]: $E,
  33: que,
  38: oC,
  42: Mv,
  60: [jde, wue],
  91: jue,
  92: [gue, aC],
  93: eA,
  95: Mv,
  96: aue
}, khe = {
  null: [Mv, rhe]
}, fhe = {
  null: [42, 95]
}, mhe = {
  null: []
}, ghe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: fhe,
  contentInitial: dhe,
  disable: mhe,
  document: lhe,
  flow: hhe,
  flowInitial: uhe,
  insideSpan: khe,
  string: phe,
  text: yhe
}, Symbol.toStringTag, { value: "Module" }));
function Mhe(e, t, n) {
  let a = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const o = {}, i = [];
  let c = [], s = [];
  const l = {
    attempt: B(O),
    check: B(A),
    consume: N,
    enter: I,
    exit: S,
    interrupt: B(A, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: g,
    events: [],
    now: m,
    parser: e,
    previous: null,
    sliceSerialize: f,
    sliceStream: y,
    write: k
  };
  let h = t.tokenize.call(u, l);
  return t.resolveAll && i.push(t), u;
  function k($) {
    return c = Gt(c, $), _(), c[c.length - 1] !== null ? [] : (z(t, 0), u.events = Jv(i, u.events, u), u.events);
  }
  function f($, H) {
    return bhe(y($), H);
  }
  function y($) {
    return _he(c, $);
  }
  function m() {
    const {
      _bufferIndex: $,
      _index: H,
      line: ee,
      column: Y,
      offset: U
    } = a;
    return {
      _bufferIndex: $,
      _index: H,
      line: ee,
      column: Y,
      offset: U
    };
  }
  function g($) {
    o[$.line] = $.column, G();
  }
  function _() {
    let $;
    for (; a._index < c.length; ) {
      const H = c[a._index];
      if (typeof H == "string")
        for ($ = a._index, a._bufferIndex < 0 && (a._bufferIndex = 0); a._index === $ && a._bufferIndex < H.length; )
          L(H.charCodeAt(a._bufferIndex));
      else
        L(H);
    }
  }
  function L($) {
    h = h($);
  }
  function N($) {
    pe($) ? (a.line++, a.column = 1, a.offset += $ === -3 ? 2 : 1, G()) : $ !== -1 && (a.column++, a.offset++), a._bufferIndex < 0 ? a._index++ : (a._bufferIndex++, a._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    c[a._index].length && (a._bufferIndex = -1, a._index++)), u.previous = $;
  }
  function I($, H) {
    const ee = H || {};
    return ee.type = $, ee.start = m(), u.events.push(["enter", ee, u]), s.push(ee), ee;
  }
  function S($) {
    const H = s.pop();
    return H.end = m(), u.events.push(["exit", H, u]), H;
  }
  function O($, H) {
    z($, H.from);
  }
  function A($, H) {
    H.restore();
  }
  function B($, H) {
    return ee;
    function ee(Y, U, Z) {
      let te, re, ue, E;
      return Array.isArray(Y) ? (
        /* c8 ignore next 1 */
        be(Y)
      ) : "tokenize" in Y ? (
        // Looks like a construct.
        be([
          /** @type {Construct} */
          Y
        ])
      ) : ve(Y);
      function ve(qe) {
        return vt;
        function vt(At) {
          const ot = At !== null && qe[At], Ge = At !== null && qe.null, Rt = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ot) ? ot : ot ? [ot] : [],
            ...Array.isArray(Ge) ? Ge : Ge ? [Ge] : []
          ];
          return be(Rt)(At);
        }
      }
      function be(qe) {
        return te = qe, re = 0, qe.length === 0 ? Z : T(qe[re]);
      }
      function T(qe) {
        return vt;
        function vt(At) {
          return E = j(), ue = qe, qe.partial || (u.currentConstruct = qe), qe.name && u.parser.constructs.disable.null.includes(qe.name) ? ht() : qe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(u), H) : u,
            l,
            Xe,
            ht
          )(At);
        }
      }
      function Xe(qe) {
        return $(ue, E), U;
      }
      function ht(qe) {
        return E.restore(), ++re < te.length ? T(te[re]) : Z;
      }
    }
  }
  function z($, H) {
    $.resolveAll && !i.includes($) && i.push($), $.resolve && Mn(u.events, H, u.events.length - H, $.resolve(u.events.slice(H), u)), $.resolveTo && (u.events = $.resolveTo(u.events, u));
  }
  function j() {
    const $ = m(), H = u.previous, ee = u.currentConstruct, Y = u.events.length, U = Array.from(s);
    return {
      from: Y,
      restore: Z
    };
    function Z() {
      a = $, u.previous = H, u.currentConstruct = ee, u.events.length = Y, s = U, G();
    }
  }
  function G() {
    a.line in o && a.column < 2 && (a.column = o[a.line], a.offset += o[a.line] - 1);
  }
}
function _he(e, t) {
  const n = t.start._index, a = t.start._bufferIndex, o = t.end._index, i = t.end._bufferIndex;
  let c;
  if (n === o)
    c = [e[n].slice(a, i)];
  else {
    if (c = e.slice(n, o), a > -1) {
      const s = c[0];
      typeof s == "string" ? c[0] = s.slice(a) : c.shift();
    }
    i > 0 && c.push(e[o].slice(0, i));
  }
  return c;
}
function bhe(e, t) {
  let n = -1;
  const a = [];
  let o;
  for (; ++n < e.length; ) {
    const i = e[n];
    let c;
    if (typeof i == "string")
      c = i;
    else switch (i) {
      case -5: {
        c = "\r";
        break;
      }
      case -4: {
        c = `
`;
        break;
      }
      case -3: {
        c = `\r
`;
        break;
      }
      case -2: {
        c = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && o) continue;
        c = " ";
        break;
      }
      default:
        c = String.fromCharCode(i);
    }
    o = i === -2, a.push(c);
  }
  return a.join("");
}
function Lhe(e) {
  const a = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Nde([ghe, ...(e || {}).extensions || []])
    ),
    content: o(Hde),
    defined: [],
    document: o(Fde),
    flow: o(ahe),
    lazy: {},
    string: o(ihe),
    text: o(che)
  };
  return a;
  function o(i) {
    return c;
    function c(s) {
      return Mhe(a, i, s);
    }
  }
}
function xhe(e) {
  for (; !rC(e); )
    ;
  return e;
}
const vI = /[\0\t\n\r]/g;
function Ehe() {
  let e = 1, t = "", n = !0, a;
  return o;
  function o(i, c, s) {
    const l = [];
    let u, h, k, f, y;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(c || void 0).decode(i)), k = 0, t = "", n && (i.charCodeAt(0) === 65279 && k++, n = void 0); k < i.length; ) {
      if (vI.lastIndex = k, u = vI.exec(i), f = u && u.index !== void 0 ? u.index : i.length, y = i.charCodeAt(f), !u) {
        t = i.slice(k);
        break;
      }
      if (y === 10 && k === f && a)
        l.push(-3), a = void 0;
      else
        switch (a && (l.push(-5), a = void 0), k < f && (l.push(i.slice(k, f)), e += f - k), y) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (h = Math.ceil(e / 4) * 4, l.push(-2); e++ < h; ) l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            a = !0, e = 1;
        }
      k = f + 1;
    }
    return s && (a && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const vhe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Ahe(e) {
  return e.replace(vhe, Ihe);
}
function Ihe(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const o = n.charCodeAt(1), i = o === 120 || o === 88;
    return tC(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Qv(n) || e;
}
const uC = {}.hasOwnProperty;
function The(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), Nhe(n)(xhe(Lhe(n).document().write(Ehe()(e, t, !0))));
}
function Nhe(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(Jt),
      autolinkProtocol: j,
      autolinkEmail: j,
      atxHeading: i(Dt),
      blockQuote: i(Ge),
      characterEscape: j,
      characterReference: j,
      codeFenced: i(Rt),
      codeFencedFenceInfo: c,
      codeFencedFenceMeta: c,
      codeIndented: i(Rt, c),
      codeText: i(pt, c),
      codeTextData: j,
      data: j,
      codeFlowValue: j,
      definition: i(Ut),
      definitionDestinationString: c,
      definitionLabelString: c,
      definitionTitleString: c,
      emphasis: i(Zt),
      hardBreakEscape: i(cn),
      hardBreakTrailing: i(cn),
      htmlFlow: i(et, c),
      htmlFlowData: j,
      htmlText: i(et, c),
      htmlTextData: j,
      image: i(Qt),
      label: c,
      link: i(Jt),
      listItem: i(Oe),
      listItemValue: f,
      listOrdered: i(Ot, k),
      listUnordered: i(Ot),
      paragraph: i(sn),
      reference: T,
      referenceString: c,
      resourceDestinationString: c,
      resourceTitleString: c,
      setextHeading: i(Dt),
      strong: i(Pn),
      thematicBreak: i(Ln)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: O,
      autolink: l(),
      autolinkEmail: ot,
      autolinkProtocol: At,
      blockQuote: l(),
      characterEscapeValue: G,
      characterReferenceMarkerHexadecimal: ht,
      characterReferenceMarkerNumeric: ht,
      characterReferenceValue: qe,
      characterReference: vt,
      codeFenced: l(_),
      codeFencedFence: g,
      codeFencedFenceInfo: y,
      codeFencedFenceMeta: m,
      codeFlowValue: G,
      codeIndented: l(L),
      codeText: l(U),
      codeTextData: G,
      data: G,
      definition: l(),
      definitionDestinationString: S,
      definitionLabelString: N,
      definitionTitleString: I,
      emphasis: l(),
      hardBreakEscape: l(H),
      hardBreakTrailing: l(H),
      htmlFlow: l(ee),
      htmlFlowData: G,
      htmlText: l(Y),
      htmlTextData: G,
      image: l(te),
      label: ue,
      labelText: re,
      lineEnding: $,
      link: l(Z),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: Xe,
      resourceDestinationString: E,
      resourceTitleString: ve,
      resource: be,
      setextHeading: l(z),
      setextHeadingLineSequence: B,
      setextHeadingText: A,
      strong: l(),
      thematicBreak: l()
    }
  };
  hC(t, (e || {}).mdastExtensions || []);
  const n = {};
  return a;
  function a(F) {
    let K = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [K],
      tokenStack: [],
      config: t,
      enter: s,
      exit: u,
      buffer: c,
      resume: h,
      data: n
    }, ke = [];
    let Le = -1;
    for (; ++Le < F.length; )
      if (F[Le][1].type === "listOrdered" || F[Le][1].type === "listUnordered")
        if (F[Le][0] === "enter")
          ke.push(Le);
        else {
          const Ye = ke.pop();
          Le = o(F, Ye, Le);
        }
    for (Le = -1; ++Le < F.length; ) {
      const Ye = t[F[Le][0]];
      uC.call(Ye, F[Le][1].type) && Ye[F[Le][1].type].call(Object.assign({
        sliceSerialize: F[Le][2].sliceSerialize
      }, ie), F[Le][1]);
    }
    if (ie.tokenStack.length > 0) {
      const Ye = ie.tokenStack[ie.tokenStack.length - 1];
      (Ye[1] || AI).call(ie, void 0, Ye[0]);
    }
    for (K.position = {
      start: Un(F.length > 0 ? F[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Un(F.length > 0 ? F[F.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Le = -1; ++Le < t.transforms.length; )
      K = t.transforms[Le](K) || K;
    return K;
  }
  function o(F, K, ie) {
    let ke = K - 1, Le = -1, Ye = !1, _t, rt, yt, He;
    for (; ++ke <= ie; ) {
      const Te = F[ke];
      switch (Te[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Te[0] === "enter" ? Le++ : Le--, He = void 0;
          break;
        }
        case "lineEndingBlank": {
          Te[0] === "enter" && (_t && !He && !Le && !yt && (yt = ke), He = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          He = void 0;
      }
      if (!Le && Te[0] === "enter" && Te[1].type === "listItemPrefix" || Le === -1 && Te[0] === "exit" && (Te[1].type === "listUnordered" || Te[1].type === "listOrdered")) {
        if (_t) {
          let bt = ke;
          for (rt = void 0; bt--; ) {
            const it = F[bt];
            if (it[1].type === "lineEnding" || it[1].type === "lineEndingBlank") {
              if (it[0] === "exit") continue;
              rt && (F[rt][1].type = "lineEndingBlank", Ye = !0), it[1].type = "lineEnding", rt = bt;
            } else if (!(it[1].type === "linePrefix" || it[1].type === "blockQuotePrefix" || it[1].type === "blockQuotePrefixWhitespace" || it[1].type === "blockQuoteMarker" || it[1].type === "listItemIndent")) break;
          }
          yt && (!rt || yt < rt) && (_t._spread = !0), _t.end = Object.assign({}, rt ? F[rt][1].start : Te[1].end), F.splice(rt || ke, 0, ["exit", _t, Te[2]]), ke++, ie++;
        }
        if (Te[1].type === "listItemPrefix") {
          const bt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Te[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          _t = bt, F.splice(ke, 0, ["enter", bt, Te[2]]), ke++, ie++, yt = void 0, He = !0;
        }
      }
    }
    return F[K][1]._spread = Ye, ie;
  }
  function i(F, K) {
    return ie;
    function ie(ke) {
      s.call(this, F(ke), ke), K && K.call(this, ke);
    }
  }
  function c() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(F, K, ie) {
    this.stack[this.stack.length - 1].children.push(F), this.stack.push(F), this.tokenStack.push([K, ie || void 0]), F.position = {
      start: Un(K.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(F) {
    return K;
    function K(ie) {
      F && F.call(this, ie), u.call(this, ie);
    }
  }
  function u(F, K) {
    const ie = this.stack.pop(), ke = this.tokenStack.pop();
    if (ke)
      ke[0].type !== F.type && (K ? K.call(this, F, ke[0]) : (ke[1] || AI).call(this, F, ke[0]));
    else throw new Error("Cannot close `" + F.type + "` (" + Yi({
      start: F.start,
      end: F.end
    }) + "): it’s not open");
    ie.position.end = Un(F.end);
  }
  function h() {
    return Ide(this.stack.pop());
  }
  function k() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(F) {
    if (this.data.expectingFirstListItemValue) {
      const K = this.stack[this.stack.length - 2];
      K.start = Number.parseInt(this.sliceSerialize(F), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function y() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.lang = F;
  }
  function m() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.meta = F;
  }
  function g() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function _() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = F.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function L() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = F.replace(/(\r?\n|\r)$/g, "");
  }
  function N(F) {
    const K = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = K, ie.identifier = yi(this.sliceSerialize(F)).toLowerCase();
  }
  function I() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.title = F;
  }
  function S() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.url = F;
  }
  function O(F) {
    const K = this.stack[this.stack.length - 1];
    if (!K.depth) {
      const ie = this.sliceSerialize(F).length;
      K.depth = ie;
    }
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(F) {
    const K = this.stack[this.stack.length - 1];
    K.depth = this.sliceSerialize(F).codePointAt(0) === 61 ? 1 : 2;
  }
  function z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function j(F) {
    const ie = this.stack[this.stack.length - 1].children;
    let ke = ie[ie.length - 1];
    (!ke || ke.type !== "text") && (ke = en(), ke.position = {
      start: Un(F.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(ke)), this.stack.push(ke);
  }
  function G(F) {
    const K = this.stack.pop();
    K.value += this.sliceSerialize(F), K.position.end = Un(F.end);
  }
  function $(F) {
    const K = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = K.children[K.children.length - 1];
      ie.position.end = Un(F.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(K.type) && (j.call(this, F), G.call(this, F));
  }
  function H() {
    this.data.atHardBreak = !0;
  }
  function ee() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = F;
  }
  function Y() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = F;
  }
  function U() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = F;
  }
  function Z() {
    const F = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      F.type += "Reference", F.referenceType = K, delete F.url, delete F.title;
    } else
      delete F.identifier, delete F.label;
    this.data.referenceType = void 0;
  }
  function te() {
    const F = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      F.type += "Reference", F.referenceType = K, delete F.url, delete F.title;
    } else
      delete F.identifier, delete F.label;
    this.data.referenceType = void 0;
  }
  function re(F) {
    const K = this.sliceSerialize(F), ie = this.stack[this.stack.length - 2];
    ie.label = Ahe(K), ie.identifier = yi(K).toLowerCase();
  }
  function ue() {
    const F = this.stack[this.stack.length - 1], K = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const ke = F.children;
      ie.children = ke;
    } else
      ie.alt = K;
  }
  function E() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.url = F;
  }
  function ve() {
    const F = this.resume(), K = this.stack[this.stack.length - 1];
    K.title = F;
  }
  function be() {
    this.data.inReference = void 0;
  }
  function T() {
    this.data.referenceType = "collapsed";
  }
  function Xe(F) {
    const K = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = K, ie.identifier = yi(this.sliceSerialize(F)).toLowerCase(), this.data.referenceType = "full";
  }
  function ht(F) {
    this.data.characterReferenceType = F.type;
  }
  function qe(F) {
    const K = this.sliceSerialize(F), ie = this.data.characterReferenceType;
    let ke;
    ie ? (ke = tC(K, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ke = Qv(K);
    const Le = this.stack[this.stack.length - 1];
    Le.value += ke;
  }
  function vt(F) {
    const K = this.stack.pop();
    K.position.end = Un(F.end);
  }
  function At(F) {
    G.call(this, F);
    const K = this.stack[this.stack.length - 1];
    K.url = this.sliceSerialize(F);
  }
  function ot(F) {
    G.call(this, F);
    const K = this.stack[this.stack.length - 1];
    K.url = "mailto:" + this.sliceSerialize(F);
  }
  function Ge() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Rt() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function pt() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ut() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Zt() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Dt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function cn() {
    return {
      type: "break"
    };
  }
  function et() {
    return {
      type: "html",
      value: ""
    };
  }
  function Qt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Jt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ot(F) {
    return {
      type: "list",
      ordered: F.type === "listOrdered",
      start: null,
      spread: F._spread,
      children: []
    };
  }
  function Oe(F) {
    return {
      type: "listItem",
      spread: F._spread,
      checked: null,
      children: []
    };
  }
  function sn() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Pn() {
    return {
      type: "strong",
      children: []
    };
  }
  function en() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ln() {
    return {
      type: "thematicBreak"
    };
  }
}
function Un(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function hC(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const a = t[n];
    Array.isArray(a) ? hC(e, a) : Che(e, a);
  }
}
function Che(e, t) {
  let n;
  for (n in t)
    if (uC.call(t, n))
      switch (n) {
        case "canContainEols": {
          const a = t[n];
          a && e[n].push(...a);
          break;
        }
        case "transforms": {
          const a = t[n];
          a && e[n].push(...a);
          break;
        }
        case "enter":
        case "exit": {
          const a = t[n];
          a && Object.assign(e[n], a);
          break;
        }
      }
}
function AI(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Yi({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Yi({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Yi({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function whe(e) {
  const t = this;
  t.parser = n;
  function n(a) {
    return The(a, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function She(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Rhe(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function Dhe(e, t) {
  const n = t.value ? t.value + `
` : "", a = {}, o = t.lang ? t.lang.split(/\s+/) : [];
  o.length > 0 && (a.className = ["language-" + o[0]]);
  let i = {
    type: "element",
    tagName: "code",
    properties: a,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function Ohe(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Phe(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Hhe(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", a = String(t.identifier).toUpperCase(), o = Ai(a.toLowerCase()), i = e.footnoteOrder.indexOf(a);
  let c, s = e.footnoteCounts.get(a);
  s === void 0 ? (s = 0, e.footnoteOrder.push(a), c = e.footnoteOrder.length) : c = i + 1, s += 1, e.footnoteCounts.set(a, s);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + o,
      id: n + "fnref-" + o + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(c) }]
  };
  e.patch(t, l);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function Bhe(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Fhe(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function pC(e, t) {
  const n = t.referenceType;
  let a = "]";
  if (n === "collapsed" ? a += "[]" : n === "full" && (a += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + a }];
  const o = e.all(t), i = o[0];
  i && i.type === "text" ? i.value = "[" + i.value : o.unshift({ type: "text", value: "[" });
  const c = o[o.length - 1];
  return c && c.type === "text" ? c.value += a : o.push({ type: "text", value: a }), o;
}
function $he(e, t) {
  const n = String(t.identifier).toUpperCase(), a = e.definitionById.get(n);
  if (!a)
    return pC(e, t);
  const o = { src: Ai(a.url || ""), alt: t.alt };
  a.title !== null && a.title !== void 0 && (o.title = a.title);
  const i = { type: "element", tagName: "img", properties: o, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function Uhe(e, t) {
  const n = { src: Ai(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const a = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function qhe(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const a = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, a), e.applyData(t, a);
}
function zhe(e, t) {
  const n = String(t.identifier).toUpperCase(), a = e.definitionById.get(n);
  if (!a)
    return pC(e, t);
  const o = { href: Ai(a.url || "") };
  a.title !== null && a.title !== void 0 && (o.title = a.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: o,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function jhe(e, t) {
  const n = { href: Ai(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function Vhe(e, t, n) {
  const a = e.all(t), o = n ? Ghe(n) : yC(t), i = {}, c = [];
  if (typeof t.checked == "boolean") {
    const h = a[0];
    let k;
    h && h.type === "element" && h.tagName === "p" ? k = h : (k = { type: "element", tagName: "p", properties: {}, children: [] }, a.unshift(k)), k.children.length > 0 && k.children.unshift({ type: "text", value: " " }), k.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < a.length; ) {
    const h = a[s];
    (o || s !== 0 || h.type !== "element" || h.tagName !== "p") && c.push({ type: "text", value: `
` }), h.type === "element" && h.tagName === "p" && !o ? c.push(...h.children) : c.push(h);
  }
  const l = a[a.length - 1];
  l && (o || l.type !== "element" || l.tagName !== "p") && c.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: i, children: c };
  return e.patch(t, u), e.applyData(t, u);
}
function Ghe(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let a = -1;
    for (; !t && ++a < n.length; )
      t = yC(n[a]);
  }
  return t;
}
function yC(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Whe(e, t) {
  const n = {}, a = e.all(t);
  let o = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++o < a.length; ) {
    const c = a[o];
    if (c.type === "element" && c.tagName === "li" && c.properties && Array.isArray(c.properties.className) && c.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(a, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Xhe(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Yhe(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Khe(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Zhe(e, t) {
  const n = e.all(t), a = n.shift(), o = [];
  if (a) {
    const c = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([a], !0)
    };
    e.patch(t.children[0], c), o.push(c);
  }
  if (n.length > 0) {
    const c = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = bn(t.children[1]), l = bE(t.children[t.children.length - 1]);
    s && l && (c.position = { start: s, end: l }), o.push(c);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(o, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Qhe(e, t, n) {
  const a = n ? n.children : void 0, i = (a ? a.indexOf(t) : 1) === 0 ? "th" : "td", c = n && n.type === "table" ? n.align : void 0, s = c ? c.length : t.children.length;
  let l = -1;
  const u = [];
  for (; ++l < s; ) {
    const k = t.children[l], f = {}, y = c ? c[l] : void 0;
    y && (f.align = y);
    let m = { type: "element", tagName: i, properties: f, children: [] };
    k && (m.children = e.all(k), e.patch(k, m), m = e.applyData(k, m)), u.push(m);
  }
  const h = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, h), e.applyData(t, h);
}
function Jhe(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const II = 9, TI = 32;
function epe(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let a = n.exec(t), o = 0;
  const i = [];
  for (; a; )
    i.push(
      NI(t.slice(o, a.index), o > 0, !0),
      a[0]
    ), o = a.index + a[0].length, a = n.exec(t);
  return i.push(NI(t.slice(o), o > 0, !1)), i.join("");
}
function NI(e, t, n) {
  let a = 0, o = e.length;
  if (t) {
    let i = e.codePointAt(a);
    for (; i === II || i === TI; )
      a++, i = e.codePointAt(a);
  }
  if (n) {
    let i = e.codePointAt(o - 1);
    for (; i === II || i === TI; )
      o--, i = e.codePointAt(o - 1);
  }
  return o > a ? e.slice(a, o) : "";
}
function tpe(e, t) {
  const n = { type: "text", value: epe(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function npe(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const ape = {
  blockquote: She,
  break: Rhe,
  code: Dhe,
  delete: Ohe,
  emphasis: Phe,
  footnoteReference: Hhe,
  heading: Bhe,
  html: Fhe,
  imageReference: $he,
  image: Uhe,
  inlineCode: qhe,
  linkReference: zhe,
  link: jhe,
  listItem: Vhe,
  list: Whe,
  paragraph: Xhe,
  // @ts-expect-error: root is different, but hard to type.
  root: Yhe,
  strong: Khe,
  table: Zhe,
  tableCell: Jhe,
  tableRow: Qhe,
  text: tpe,
  thematicBreak: npe,
  toml: Tc,
  yaml: Tc,
  definition: Tc,
  footnoteDefinition: Tc
};
function Tc() {
}
const kC = -1, xE = 0, Zi = 1, tE = 2, tA = 3, nA = 4, aA = 5, oA = 6, fC = 7, mC = 8, ope = typeof self == "object" ? self : globalThis, CI = (e, t) => {
  switch (e) {
    case "Function":
    case "SharedWorker":
    case "Worker":
    case "eval":
    case "setInterval":
    case "setTimeout":
      throw new TypeError("unable to deserialize " + e);
  }
  return new ope[e](t);
}, rpe = (e, t) => {
  const n = (o, i) => (e.set(i, o), o), a = (o) => {
    if (e.has(o))
      return e.get(o);
    const [i, c] = t[o];
    switch (i) {
      case xE:
      case kC:
        return n(c, o);
      case Zi: {
        const s = n([], o);
        for (const l of c)
          s.push(a(l));
        return s;
      }
      case tE: {
        const s = n({}, o);
        for (const [l, u] of c)
          s[a(l)] = a(u);
        return s;
      }
      case tA:
        return n(new Date(c), o);
      case nA: {
        const { source: s, flags: l } = c;
        return n(new RegExp(s, l), o);
      }
      case aA: {
        const s = n(/* @__PURE__ */ new Map(), o);
        for (const [l, u] of c)
          s.set(a(l), a(u));
        return s;
      }
      case oA: {
        const s = n(/* @__PURE__ */ new Set(), o);
        for (const l of c)
          s.add(a(l));
        return s;
      }
      case fC: {
        const { name: s, message: l } = c;
        return n(CI(s, l), o);
      }
      case mC:
        return n(BigInt(c), o);
      case "BigInt":
        return n(Object(BigInt(c)), o);
      case "ArrayBuffer":
        return n(new Uint8Array(c).buffer, c);
      case "DataView": {
        const { buffer: s } = new Uint8Array(c);
        return n(new DataView(s), c);
      }
    }
    return n(CI(i, c), o);
  };
  return a;
}, wI = (e) => rpe(/* @__PURE__ */ new Map(), e)(0), oi = "", { toString: ipe } = {}, { keys: cpe } = Object, Hi = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [xE, t];
  const n = ipe.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Zi, oi];
    case "Object":
      return [tE, oi];
    case "Date":
      return [tA, oi];
    case "RegExp":
      return [nA, oi];
    case "Map":
      return [aA, oi];
    case "Set":
      return [oA, oi];
    case "DataView":
      return [Zi, n];
  }
  return n.includes("Array") ? [Zi, n] : n.includes("Error") ? [fC, n] : [tE, n];
}, Nc = ([e, t]) => e === xE && (t === "function" || t === "symbol"), spe = (e, t, n, a) => {
  const o = (c, s) => {
    const l = a.push(c) - 1;
    return n.set(s, l), l;
  }, i = (c) => {
    if (n.has(c))
      return n.get(c);
    let [s, l] = Hi(c);
    switch (s) {
      case xE: {
        let h = c;
        switch (l) {
          case "bigint":
            s = mC, h = c.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + l);
            h = null;
            break;
          case "undefined":
            return o([kC], c);
        }
        return o([s, h], c);
      }
      case Zi: {
        if (l) {
          let f = c;
          return l === "DataView" ? f = new Uint8Array(c.buffer) : l === "ArrayBuffer" && (f = new Uint8Array(c)), o([l, [...f]], c);
        }
        const h = [], k = o([s, h], c);
        for (const f of c)
          h.push(i(f));
        return k;
      }
      case tE: {
        if (l)
          switch (l) {
            case "BigInt":
              return o([l, c.toString()], c);
            case "Boolean":
            case "Number":
            case "String":
              return o([l, c.valueOf()], c);
          }
        if (t && "toJSON" in c)
          return i(c.toJSON());
        const h = [], k = o([s, h], c);
        for (const f of cpe(c))
          (e || !Nc(Hi(c[f]))) && h.push([i(f), i(c[f])]);
        return k;
      }
      case tA:
        return o([s, c.toISOString()], c);
      case nA: {
        const { source: h, flags: k } = c;
        return o([s, { source: h, flags: k }], c);
      }
      case aA: {
        const h = [], k = o([s, h], c);
        for (const [f, y] of c)
          (e || !(Nc(Hi(f)) || Nc(Hi(y)))) && h.push([i(f), i(y)]);
        return k;
      }
      case oA: {
        const h = [], k = o([s, h], c);
        for (const f of c)
          (e || !Nc(Hi(f))) && h.push(i(f));
        return k;
      }
    }
    const { message: u } = c;
    return o([s, { name: l, message: u }], c);
  };
  return i;
}, SI = (e, { json: t, lossy: n } = {}) => {
  const a = [];
  return spe(!(t || n), !!t, /* @__PURE__ */ new Map(), a)(e), a;
}, K1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? wI(SI(e, t)) : structuredClone(e)
) : (e, t) => wI(SI(e, t));
function lpe(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function dpe(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function upe(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || lpe, a = e.options.footnoteBackLabel || dpe, o = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", c = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let l = -1;
  for (; ++l < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[l]
    );
    if (!u)
      continue;
    const h = e.all(u), k = String(u.identifier).toUpperCase(), f = Ai(k.toLowerCase());
    let y = 0;
    const m = [], g = e.footnoteCounts.get(k);
    for (; g !== void 0 && ++y <= g; ) {
      m.length > 0 && m.push({ type: "text", value: " " });
      let N = typeof n == "string" ? n : n(l, y);
      typeof N == "string" && (N = { type: "text", value: N }), m.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (y > 1 ? "-" + y : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof a == "string" ? a : a(l, y),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(N) ? N : [N]
      });
    }
    const _ = h[h.length - 1];
    if (_ && _.type === "element" && _.tagName === "p") {
      const N = _.children[_.children.length - 1];
      N && N.type === "text" ? N.value += " " : _.children.push({ type: "text", value: " " }), _.children.push(...m);
    } else
      h.push(...m);
    const L = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(h, !0)
    };
    e.patch(u, L), s.push(L);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...K1(c),
            id: "footnote-label"
          },
          children: [{ type: "text", value: o }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const gC = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return kpe;
    if (typeof e == "function")
      return EE(e);
    if (typeof e == "object")
      return Array.isArray(e) ? hpe(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        ppe(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return ype(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function hpe(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = gC(e[n]);
  return EE(a);
  function a(...o) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, o)) return !0;
    return !1;
  }
}
function ppe(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return EE(n);
  function n(a) {
    const o = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      a
    );
    let i;
    for (i in e)
      if (o[i] !== t[i]) return !1;
    return !0;
  }
}
function ype(e) {
  return EE(t);
  function t(n) {
    return n && n.type === e;
  }
}
function EE(e) {
  return t;
  function t(n, a, o) {
    return !!(fpe(n) && e.call(
      this,
      n,
      typeof a == "number" ? a : void 0,
      o || void 0
    ));
  }
}
function kpe() {
  return !0;
}
function fpe(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const MC = [], mpe = !0, RI = !1, gpe = "skip";
function Mpe(e, t, n, a) {
  let o;
  typeof t == "function" && typeof n != "function" ? (a = n, n = t) : o = t;
  const i = gC(o), c = a ? -1 : 1;
  s(e, void 0, [])();
  function s(l, u, h) {
    const k = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof k.type == "string") {
      const y = (
        // `hast`
        typeof k.tagName == "string" ? k.tagName : (
          // `xast`
          typeof k.name == "string" ? k.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (l.type + (y ? "<" + y + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let y = MC, m, g, _;
      if ((!t || i(l, u, h[h.length - 1] || void 0)) && (y = _pe(n(l, h)), y[0] === RI))
        return y;
      if ("children" in l && l.children) {
        const L = (
          /** @type {UnistParent} */
          l
        );
        if (L.children && y[0] !== gpe)
          for (g = (a ? L.children.length : -1) + c, _ = h.concat(L); g > -1 && g < L.children.length; ) {
            const N = L.children[g];
            if (m = s(N, g, _)(), m[0] === RI)
              return m;
            g = typeof m[1] == "number" ? m[1] : g + c;
          }
      }
      return y;
    }
  }
}
function _pe(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [mpe, e] : e == null ? MC : [e];
}
function rA(e, t, n, a) {
  let o, i, c;
  typeof t == "function" && typeof n != "function" ? (i = void 0, c = t, o = n) : (i = t, c = n, o = a), Mpe(e, i, s, o);
  function s(l, u) {
    const h = u[u.length - 1], k = h ? h.children.indexOf(l) : void 0;
    return c(l, k, h);
  }
}
const _v = {}.hasOwnProperty, bpe = {};
function Lpe(e, t) {
  const n = t || bpe, a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), c = { ...ape, ...n.handlers }, s = {
    all: u,
    applyData: Epe,
    definitionById: a,
    footnoteById: o,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: c,
    one: l,
    options: n,
    patch: xpe,
    wrap: Ape
  };
  return rA(e, function(h) {
    if (h.type === "definition" || h.type === "footnoteDefinition") {
      const k = h.type === "definition" ? a : o, f = String(h.identifier).toUpperCase();
      k.has(f) || k.set(f, h);
    }
  }), s;
  function l(h, k) {
    const f = h.type, y = s.handlers[f];
    if (_v.call(s.handlers, f) && y)
      return y(s, h, k);
    if (s.options.passThrough && s.options.passThrough.includes(f)) {
      if ("children" in h) {
        const { children: g, ..._ } = h, L = K1(_);
        return L.children = s.all(h), L;
      }
      return K1(h);
    }
    return (s.options.unknownHandler || vpe)(s, h, k);
  }
  function u(h) {
    const k = [];
    if ("children" in h) {
      const f = h.children;
      let y = -1;
      for (; ++y < f.length; ) {
        const m = s.one(f[y], h);
        if (m) {
          if (y && f[y - 1].type === "break" && (!Array.isArray(m) && m.type === "text" && (m.value = DI(m.value)), !Array.isArray(m) && m.type === "element")) {
            const g = m.children[0];
            g && g.type === "text" && (g.value = DI(g.value));
          }
          Array.isArray(m) ? k.push(...m) : k.push(m);
        }
      }
    }
    return k;
  }
}
function xpe(e, t) {
  e.position && (t.position = YN(e));
}
function Epe(e, t) {
  let n = t;
  if (e && e.data) {
    const a = e.data.hName, o = e.data.hChildren, i = e.data.hProperties;
    if (typeof a == "string")
      if (n.type === "element")
        n.tagName = a;
      else {
        const c = "children" in n ? n.children : [n];
        n = { type: "element", tagName: a, properties: {}, children: c };
      }
    n.type === "element" && i && Object.assign(n.properties, K1(i)), "children" in n && n.children && o !== null && o !== void 0 && (n.children = o);
  }
  return n;
}
function vpe(e, t) {
  const n = t.data || {}, a = "value" in t && !(_v.call(n, "hProperties") || _v.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function Ape(e, t) {
  const n = [];
  let a = -1;
  for (t && n.push({ type: "text", value: `
` }); ++a < e.length; )
    a && n.push({ type: "text", value: `
` }), n.push(e[a]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function DI(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function OI(e, t) {
  const n = Lpe(e, t), a = n.one(e, void 0), o = upe(n), i = Array.isArray(a) ? { type: "root", children: a } : a || { type: "root", children: [] };
  return o && i.children.push({ type: "text", value: `
` }, o), i;
}
function Ipe(e, t) {
  return e && "run" in e ? async function(n, a) {
    const o = (
      /** @type {HastRoot} */
      OI(n, { file: a, ...t })
    );
    await e.run(o, a);
  } : function(n, a) {
    return (
      /** @type {HastRoot} */
      OI(n, { file: a, ...e || t })
    );
  };
}
function PI(e) {
  if (e)
    throw e;
}
var G9 = Object.prototype.hasOwnProperty, _C = Object.prototype.toString, HI = Object.defineProperty, BI = Object.getOwnPropertyDescriptor, FI = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : _C.call(t) === "[object Array]";
}, $I = function(t) {
  if (!t || _C.call(t) !== "[object Object]")
    return !1;
  var n = G9.call(t, "constructor"), a = t.constructor && t.constructor.prototype && G9.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !a)
    return !1;
  var o;
  for (o in t)
    ;
  return typeof o > "u" || G9.call(t, o);
}, UI = function(t, n) {
  HI && n.name === "__proto__" ? HI(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, qI = function(t, n) {
  if (n === "__proto__")
    if (G9.call(t, n)) {
      if (BI)
        return BI(t, n).value;
    } else return;
  return t[n];
}, Tpe = function e() {
  var t, n, a, o, i, c, s = arguments[0], l = 1, u = arguments.length, h = !1;
  for (typeof s == "boolean" && (h = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < u; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        a = qI(s, n), o = qI(t, n), s !== o && (h && o && ($I(o) || (i = FI(o))) ? (i ? (i = !1, c = a && FI(a) ? a : []) : c = a && $I(a) ? a : {}, UI(s, { name: n, newValue: e(h, c, o) })) : typeof o < "u" && UI(s, { name: n, newValue: o }));
  return s;
};
const UE = /* @__PURE__ */ yE(Tpe);
function bv(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Npe() {
  const e = [], t = { run: n, use: a };
  return t;
  function n(...o) {
    let i = -1;
    const c = o.pop();
    if (typeof c != "function")
      throw new TypeError("Expected function as last argument, not " + c);
    s(null, ...o);
    function s(l, ...u) {
      const h = e[++i];
      let k = -1;
      if (l) {
        c(l);
        return;
      }
      for (; ++k < o.length; )
        (u[k] === null || u[k] === void 0) && (u[k] = o[k]);
      o = u, h ? Cpe(h, s)(...u) : c(null, ...u);
    }
  }
  function a(o) {
    if (typeof o != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + o
      );
    return e.push(o), t;
  }
}
function Cpe(e, t) {
  let n;
  return a;
  function a(...c) {
    const s = e.length > c.length;
    let l;
    s && c.push(o);
    try {
      l = e.apply(this, c);
    } catch (u) {
      const h = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw h;
      return o(h);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(i, o) : l instanceof Error ? o(l) : i(l));
  }
  function o(c, ...s) {
    n || (n = !0, t(c, ...s));
  }
  function i(c) {
    o(null, c);
  }
}
const yn = { basename: wpe, dirname: Spe, extname: Rpe, join: Dpe, sep: "/" };
function wpe(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  _c(e);
  let n = 0, a = -1, o = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; o--; )
      if (e.codePointAt(o) === 47) {
        if (i) {
          n = o + 1;
          break;
        }
      } else a < 0 && (i = !0, a = o + 1);
    return a < 0 ? "" : e.slice(n, a);
  }
  if (t === e)
    return "";
  let c = -1, s = t.length - 1;
  for (; o--; )
    if (e.codePointAt(o) === 47) {
      if (i) {
        n = o + 1;
        break;
      }
    } else
      c < 0 && (i = !0, c = o + 1), s > -1 && (e.codePointAt(o) === t.codePointAt(s--) ? s < 0 && (a = o) : (s = -1, a = c));
  return n === a ? a = c : a < 0 && (a = e.length), e.slice(n, a);
}
function Spe(e) {
  if (_c(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, a;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (a) {
        t = n;
        break;
      }
    } else a || (a = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function Rpe(e) {
  _c(e);
  let t = e.length, n = -1, a = 0, o = -1, i = 0, c;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (c) {
        a = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (c = !0, n = t + 1), s === 46 ? o < 0 ? o = t : i !== 1 && (i = 1) : o > -1 && (i = -1);
  }
  return o < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && o === n - 1 && o === a + 1 ? "" : e.slice(o, n);
}
function Dpe(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    _c(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : Ope(n);
}
function Ope(e) {
  _c(e);
  const t = e.codePointAt(0) === 47;
  let n = Ppe(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function Ppe(e, t) {
  let n = "", a = 0, o = -1, i = 0, c = -1, s, l;
  for (; ++c <= e.length; ) {
    if (c < e.length)
      s = e.codePointAt(c);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(o === c - 1 || i === 1)) if (o !== c - 1 && i === 2) {
        if (n.length < 2 || a !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", a = 0) : (n = n.slice(0, l), a = n.length - 1 - n.lastIndexOf("/")), o = c, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", a = 0, o = c, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", a = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(o + 1, c) : n = e.slice(o + 1, c), a = c - o - 1;
      o = c, i = 0;
    } else s === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function _c(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Hpe = { cwd: Bpe };
function Bpe() {
  return "/";
}
function Lv(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function Fpe(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Lv(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return $pe(e);
}
function $pe(e) {
  if (e.hostname !== "") {
    const a = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw a.code = "ERR_INVALID_FILE_URL_HOST", a;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const a = t.codePointAt(n + 2);
      if (a === 70 || a === 102) {
        const o = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw o.code = "ERR_INVALID_FILE_URL_PATH", o;
      }
    }
  return decodeURIComponent(t);
}
const qE = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class bC {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Lv(t) ? n = { path: t } : typeof t == "string" || Upe(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : Hpe.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let a = -1;
    for (; ++a < qE.length; ) {
      const i = qE[a];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let o;
    for (o in n)
      qE.includes(o) || (this[o] = n[o]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? yn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    jE(t, "basename"), zE(t, "basename"), this.path = yn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? yn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    zI(this.basename, "dirname"), this.path = yn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? yn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (zE(t, "extname"), zI(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = yn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Lv(t) && (t = Fpe(t)), jE(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? yn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    jE(t, "stem"), zE(t, "stem"), this.path = yn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, a) {
    const o = this.message(t, n, a);
    throw o.fatal = !0, o;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, a) {
    const o = this.message(t, n, a);
    return o.fatal = void 0, o;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, a) {
    const o = new gt(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      a
    );
    return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function zE(e, t) {
  if (e && e.includes(yn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + yn.sep + "`"
    );
}
function jE(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function zI(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function Upe(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const qpe = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const a = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), o = a[e], i = function() {
      return o.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, a), i;
  }
), zpe = {}.hasOwnProperty;
class iA extends qpe {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Npe();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new iA()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const a = this.attachers[n];
      t.use(...a);
    }
    return t.data(UE(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (WE("data", this.frozen), this.namespace[t] = n, this) : zpe.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (WE("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...a] = this.attachers[this.freezeIndex];
      if (a[0] === !1)
        continue;
      a[0] === !0 && (a[0] = void 0);
      const o = n.call(t, ...a);
      typeof o == "function" && this.transformers.use(o);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Cc(t), a = this.parser || this.Parser;
    return VE("parse", a), a(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const a = this;
    return this.freeze(), VE("process", this.parser || this.Parser), GE("process", this.compiler || this.Compiler), n ? o(void 0, n) : new Promise(o);
    function o(i, c) {
      const s = Cc(t), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        a.parse(s)
      );
      a.run(l, s, function(h, k, f) {
        if (h || !k || !f)
          return u(h);
        const y = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          k
        ), m = a.stringify(y, f);
        Gpe(m) ? f.value = m : f.result = m, u(
          h,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function u(h, k) {
        h || !k ? c(h) : i ? i(k) : n(void 0, k);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, a;
    return this.freeze(), VE("processSync", this.parser || this.Parser), GE("processSync", this.compiler || this.Compiler), this.process(t, o), VI("processSync", "process", n), a;
    function o(i, c) {
      n = !0, PI(i), a = c;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, a) {
    jI(t), this.freeze();
    const o = this.transformers;
    return !a && typeof n == "function" && (a = n, n = void 0), a ? i(void 0, a) : new Promise(i);
    function i(c, s) {
      const l = Cc(n);
      o.run(t, l, u);
      function u(h, k, f) {
        const y = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          k || t
        );
        h ? s(h) : c ? c(y) : a(void 0, y, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let a = !1, o;
    return this.run(t, n, i), VI("runSync", "run", a), o;
    function i(c, s) {
      PI(c), o = s, a = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const a = Cc(n), o = this.compiler || this.Compiler;
    return GE("stringify", o), jI(t), o(t, a);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const a = this.attachers, o = this.namespace;
    if (WE("use", this.frozen), t != null) if (typeof t == "function")
      l(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? s(t) : c(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(u) {
      if (typeof u == "function")
        l(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [h, ...k] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          l(h, k);
        } else
          c(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function c(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(u.plugins), u.settings && (o.settings = UE(!0, o.settings, u.settings));
    }
    function s(u) {
      let h = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++h < u.length; ) {
          const k = u[h];
          i(k);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function l(u, h) {
      let k = -1, f = -1;
      for (; ++k < a.length; )
        if (a[k][0] === u) {
          f = k;
          break;
        }
      if (f === -1)
        a.push([u, ...h]);
      else if (h.length > 0) {
        let [y, ...m] = h;
        const g = a[f][1];
        bv(g) && bv(y) && (y = UE(!0, g, y)), a[f] = [u, y, ...m];
      }
    }
  }
}
const jpe = new iA().freeze();
function VE(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function GE(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function WE(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function jI(e) {
  if (!bv(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function VI(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Cc(e) {
  return Vpe(e) ? e : new bC(e);
}
function Vpe(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Gpe(e) {
  return typeof e == "string" || Wpe(e);
}
function Wpe(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Xpe = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", GI = [], WI = { allowDangerousHtml: !0 }, Ype = /^(https?|ircs?|mailto|xmpp)$/i, Kpe = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Zpe(e) {
  const t = Qpe(e), n = Jpe(e);
  return eye(t.runSync(t.parse(n), n), e);
}
function Qpe(e) {
  const t = e.rehypePlugins || GI, n = e.remarkPlugins || GI, a = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...WI } : WI;
  return jpe().use(whe).use(n).use(Ipe, a).use(t);
}
function Jpe(e) {
  const t = e.children || "", n = new bC();
  return typeof t == "string" && (n.value = t), n;
}
function eye(e, t) {
  const n = t.allowedElements, a = t.allowElement, o = t.components, i = t.disallowedElements, c = t.skipHtml, s = t.unwrapDisallowed, l = t.urlTransform || tye;
  for (const h of Kpe)
    Object.hasOwn(t, h.from) && ("" + h.from + (h.to ? "use `" + h.to + "` instead" : "remove it") + Xpe + h.id, void 0);
  return t.className && (e = {
    type: "element",
    tagName: "div",
    properties: { className: t.className },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      e.type === "root" ? e.children : [e]
    )
  }), rA(e, u), dde(e, {
    Fragment: at,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: o,
    ignoreInvalidStyle: !0,
    jsx: p,
    jsxs: C,
    passKeys: !0,
    passNode: !0
  });
  function u(h, k, f) {
    if (h.type === "raw" && f && typeof k == "number")
      return c ? f.children.splice(k, 1) : f.children[k] = { type: "text", value: h.value }, k;
    if (h.type === "element") {
      let y;
      for (y in BE)
        if (Object.hasOwn(BE, y) && Object.hasOwn(h.properties, y)) {
          const m = h.properties[y], g = BE[y];
          (g === null || g.includes(h.tagName)) && (h.properties[y] = l(String(m || ""), y, h));
        }
    }
    if (h.type === "element") {
      let y = n ? !n.includes(h.tagName) : i ? i.includes(h.tagName) : !1;
      if (!y && a && typeof k == "number" && (y = !a(h, k, f)), y && f && typeof k == "number")
        return s && h.children ? f.children.splice(k, 1, ...h.children) : f.children.splice(k, 1), k;
    }
  }
}
function tye(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), a = e.indexOf("#"), o = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    o !== -1 && t > o || n !== -1 && t > n || a !== -1 && t > a || // It is a protocol, it should be allowed.
    Ype.test(e.slice(0, t)) ? e : ""
  );
}
const XI = /[#.]/g;
function nye(e, t) {
  const n = e || "", a = {};
  let o = 0, i, c;
  for (; o < n.length; ) {
    XI.lastIndex = o;
    const s = XI.exec(n), l = n.slice(o, s ? s.index : n.length);
    l && (i ? i === "#" ? a.id = l : Array.isArray(a.className) ? a.className.push(l) : a.className = [l] : c = l, o += l.length), s && (i = s[0], o++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: c || t || "div",
    properties: a,
    children: []
  };
}
function LC(e, t, n) {
  const a = n ? iye(n) : void 0;
  function o(i, c, ...s) {
    let l;
    if (i == null) {
      l = { type: "root", children: [] };
      const u = (
        /** @type {Child} */
        c
      );
      s.unshift(u);
    } else {
      l = nye(i, t);
      const u = l.tagName.toLowerCase(), h = a ? a.get(u) : void 0;
      if (l.tagName = h || u, aye(c))
        s.unshift(c);
      else
        for (const [k, f] of Object.entries(c))
          oye(e, l.properties, k, f);
    }
    for (const u of s)
      xv(l.children, u);
    return l.type === "element" && l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
  }
  return o;
}
function aye(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), n = Object.keys(e);
  for (const a of n) {
    const o = t[a];
    if (o && typeof o == "object") {
      if (!Array.isArray(o)) return !0;
      const i = (
        /** @type {ReadonlyArray<unknown>} */
        o
      );
      for (const c of i)
        if (typeof c != "number" && typeof c != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function oye(e, t, n, a) {
  const o = ME(e, n);
  let i;
  if (a != null) {
    if (typeof a == "number") {
      if (Number.isNaN(a)) return;
      i = a;
    } else typeof a == "boolean" ? i = a : typeof a == "string" ? o.spaceSeparated ? i = cI(a) : o.commaSeparated ? i = nI(a) : o.commaOrSpaceSeparated ? i = cI(nI(a).join(" ")) : i = YI(o, o.property, a) : Array.isArray(a) ? i = [...a] : i = o.property === "style" ? rye(a) : String(a);
    if (Array.isArray(i)) {
      const c = [];
      for (const s of i)
        c.push(
          /** @type {number | string} */
          YI(o, o.property, s)
        );
      i = c;
    }
    o.property === "className" && Array.isArray(t.className) && (i = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      i
    )), t[o.property] = i;
  }
}
function xv(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const n of t)
      xv(e, n);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? xv(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function YI(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || lc(n) === lc(t)))
      return !0;
  }
  return n;
}
function rye(e) {
  const t = [];
  for (const [n, a] of Object.entries(e))
    t.push([n, a].join(": "));
  return t.join("; ");
}
function iye(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.toLowerCase(), n);
  return t;
}
const cye = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], sye = LC(Mc, "div"), lye = LC(Qn, "g", cye);
function dye(e) {
  const t = String(e), n = [];
  return { toOffset: o, toPoint: a };
  function a(i) {
    if (typeof i == "number" && i > -1 && i <= t.length) {
      let c = 0;
      for (; ; ) {
        let s = n[c];
        if (s === void 0) {
          const l = KI(t, n[c - 1]);
          s = l === -1 ? t.length + 1 : l + 1, n[c] = s;
        }
        if (s > i)
          return {
            line: c + 1,
            column: i - (c > 0 ? n[c - 1] : 0) + 1,
            offset: i
          };
        c++;
      }
    }
  }
  function o(i) {
    if (i && typeof i.line == "number" && typeof i.column == "number" && !Number.isNaN(i.line) && !Number.isNaN(i.column)) {
      for (; n.length < i.line; ) {
        const s = n[n.length - 1], l = KI(t, s), u = l === -1 ? t.length + 1 : l + 1;
        if (s === u) break;
        n.push(u);
      }
      const c = (i.line > 1 ? n[i.line - 2] : 0) + i.column - 1;
      if (c < n[i.line - 1]) return c;
    }
  }
}
function KI(e, t) {
  const n = e.indexOf("\r", t), a = e.indexOf(`
`, t);
  return a === -1 ? n : n === -1 || n + 1 === a ? a : n < a ? n : a;
}
const $1 = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, xC = {}.hasOwnProperty, uye = Object.prototype;
function hye(e, t) {
  const n = t || {};
  return cA(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? Qn : Mc,
      verbose: n.verbose || !1
    },
    e
  );
}
function cA(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const a = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return n = { type: "comment", value: a.data }, W9(e, a, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const a = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), o = "mode" in a ? a.mode === "quirks" || a.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: EC(e, t.childNodes),
        data: { quirksMode: o }
      }, e.file && e.location) {
        const i = String(e.file), c = dye(i), s = c.toPoint(0), l = c.toPoint(i.length);
        n.position = { start: s, end: l };
      }
      return n;
    }
    case "#documentType": {
      const a = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return n = { type: "doctype" }, W9(e, a, n), n;
    }
    case "#text": {
      const a = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return n = { type: "text", value: a.value }, W9(e, a, n), n;
    }
    default:
      return n = pye(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), n;
  }
}
function EC(e, t) {
  let n = -1;
  const a = [];
  for (; ++n < t.length; ) {
    const o = (
      /** @type {RootContent} */
      cA(e, t[n])
    );
    a.push(o);
  }
  return a;
}
function pye(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === $1.svg ? Qn : Mc;
  let a = -1;
  const o = {};
  for (; ++a < t.attrs.length; ) {
    const s = t.attrs[a], l = (s.prefix ? s.prefix + ":" : "") + s.name;
    xC.call(uye, l) || (o[l] = s.value);
  }
  const c = (e.schema.space === "svg" ? lye : sye)(t.tagName, o, EC(e, t.childNodes));
  if (W9(e, t, c), c.tagName === "template") {
    const s = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), l = s.sourceCodeLocation, u = l && l.startTag && ci(l.startTag), h = l && l.endTag && ci(l.endTag), k = (
      /** @type {Root} */
      cA(e, s.content)
    );
    u && h && e.file && (k.position = { start: u.end, end: h.start }), c.content = k;
  }
  return e.schema = n, c;
}
function W9(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const a = yye(e, n, t.sourceCodeLocation);
    a && (e.location = !0, n.position = a);
  }
}
function yye(e, t, n) {
  const a = ci(n);
  if (t.type === "element") {
    const o = t.children[t.children.length - 1];
    if (a && !n.endTag && o && o.position && o.position.end && (a.end = Object.assign({}, o.position.end)), e.verbose) {
      const i = {};
      let c;
      if (n.attrs)
        for (c in n.attrs)
          xC.call(n.attrs, c) && (i[ME(e.schema, c).property] = ci(
            n.attrs[c]
          ));
      n.startTag;
      const s = ci(n.startTag), l = n.endTag ? ci(n.endTag) : void 0, u = { opening: s };
      l && (u.closing = l), u.properties = i, t.data = { position: u };
    }
  }
  return a;
}
function ci(e) {
  const t = ZI({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = ZI({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function ZI(e) {
  return e.line && e.column ? e : void 0;
}
const QI = {}.hasOwnProperty;
function vC(e, t) {
  const n = t || {};
  function a(o, ...i) {
    let c = a.invalid;
    const s = a.handlers;
    if (o && QI.call(o, e)) {
      const l = String(o[e]);
      c = QI.call(s, l) ? s[l] : a.unknown;
    }
    if (c)
      return c.call(this, o, ...i);
  }
  return a.handlers = n.handlers || {}, a.invalid = n.invalid, a.unknown = n.unknown, a;
}
const kye = {}, fye = {}.hasOwnProperty, AC = vC("type", { handlers: { root: gye, element: xye, text: bye, comment: Lye, doctype: _ye } });
function mye(e, t) {
  const a = (t || kye).space;
  return AC(e, a === "svg" ? Qn : Mc);
}
function gye(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = sA(e.children, n, t), Ii(e, n), n;
}
function Mye(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = sA(e.children, n, t), Ii(e, n), n;
}
function _ye(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return Ii(e, t), t;
}
function bye(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return Ii(e, t), t;
}
function Lye(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return Ii(e, t), t;
}
function xye(e, t) {
  const n = t;
  let a = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (a = Qn);
  const o = [];
  let i;
  if (e.properties) {
    for (i in e.properties)
      if (i !== "children" && fye.call(e.properties, i)) {
        const l = Eye(
          a,
          i,
          e.properties[i]
        );
        l && o.push(l);
      }
  }
  const c = a.space, s = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: o,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: $1[c],
    childNodes: [],
    parentNode: null
  };
  return s.childNodes = sA(e.children, s, a), Ii(e, s), e.tagName === "template" && e.content && (s.content = Mye(e.content, a)), s;
}
function Eye(e, t, n) {
  const a = ME(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && a.boolean)
    return;
  Array.isArray(n) && (n = a.commaSeparated ? FN(n) : WN(n));
  const o = {
    name: a.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (a.space && a.space !== "html" && a.space !== "svg") {
    const i = o.name.indexOf(":");
    i < 0 ? o.prefix = "" : (o.name = o.name.slice(i + 1), o.prefix = a.attribute.slice(0, i)), o.namespace = $1[a.space];
  }
  return o;
}
function sA(e, t, n) {
  let a = -1;
  const o = [];
  if (e)
    for (; ++a < e.length; ) {
      const i = AC(e[a], n);
      i.parentNode = t, o.push(i);
    }
  return o;
}
function Ii(e, t) {
  const n = e.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const vye = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Aye = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), je = "�";
var M;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(M || (M = {}));
const It = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function IC(e) {
  return e >= 55296 && e <= 57343;
}
function Iye(e) {
  return e >= 56320 && e <= 57343;
}
function Tye(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function TC(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function NC(e) {
  return e >= 64976 && e <= 65007 || Aye.has(e);
}
var D;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(D || (D = {}));
const Nye = 65536;
class Cye {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Nye, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const { line: a, col: o, offset: i } = this, c = o + n, s = i + n;
    return {
      code: t,
      startLine: a,
      endLine: a,
      startCol: c,
      endCol: c,
      startOffset: s,
      endOffset: s
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (Iye(n))
        return this.pos++, this._addGap(), Tye(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, M.EOF;
    return this._err(D.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(t, this.pos);
    for (let a = 0; a < t.length; a++)
      if ((this.html.charCodeAt(this.pos + a) | 32) !== t.charCodeAt(a))
        return !1;
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, M.EOF;
    const a = this.html.charCodeAt(n);
    return a === M.CARRIAGE_RETURN ? M.LINE_FEED : a;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, M.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === M.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, M.LINE_FEED) : t === M.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, IC(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === M.LINE_FEED || t === M.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    TC(t) ? this._err(D.controlCharacterInInputStream) : NC(t) && this._err(D.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var xe;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(xe || (xe = {}));
function CC(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
}
const wye = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Sye = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function Rye(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = Sye.get(e)) !== null && t !== void 0 ? t : e;
}
var lt;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(lt || (lt = {}));
const Dye = 32;
var Xn;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Xn || (Xn = {}));
function Ev(e) {
  return e >= lt.ZERO && e <= lt.NINE;
}
function Oye(e) {
  return e >= lt.UPPER_A && e <= lt.UPPER_F || e >= lt.LOWER_A && e <= lt.LOWER_F;
}
function Pye(e) {
  return e >= lt.UPPER_A && e <= lt.UPPER_Z || e >= lt.LOWER_A && e <= lt.LOWER_Z || Ev(e);
}
function Hye(e) {
  return e === lt.EQUALS || Pye(e);
}
var st;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(st || (st = {}));
var Cn;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Cn || (Cn = {}));
class Bye {
  constructor(t, n, a) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = a, this.state = st.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Cn.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = st.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case st.EntityStart:
        return t.charCodeAt(n) === lt.NUM ? (this.state = st.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = st.NamedEntity, this.stateNamedEntity(t, n));
      case st.NumericStart:
        return this.stateNumericStart(t, n);
      case st.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case st.NumericHex:
        return this.stateNumericHex(t, n);
      case st.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | Dye) === lt.LOWER_X ? (this.state = st.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = st.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, a, o) {
    if (n !== a) {
      const i = a - n;
      this.result = this.result * Math.pow(o, i) + Number.parseInt(t.substr(n, i), o), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const a = n;
    for (; n < t.length; ) {
      const o = t.charCodeAt(n);
      if (Ev(o) || Oye(o))
        n += 1;
      else
        return this.addToNumericResult(t, a, n, 16), this.emitNumericEntity(o, 3);
    }
    return this.addToNumericResult(t, a, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const a = n;
    for (; n < t.length; ) {
      const o = t.charCodeAt(n);
      if (Ev(o))
        n += 1;
      else
        return this.addToNumericResult(t, a, n, 10), this.emitNumericEntity(o, 2);
    }
    return this.addToNumericResult(t, a, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var a;
    if (this.consumed <= n)
      return (a = this.errors) === null || a === void 0 || a.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === lt.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Cn.Strict)
      return 0;
    return this.emitCodePoint(Rye(this.result), this.consumed), this.errors && (t !== lt.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: a } = this;
    let o = a[this.treeIndex], i = (o & Xn.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const c = t.charCodeAt(n);
      if (this.treeIndex = Fye(a, o, this.treeIndex + Math.max(1, i), c), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Cn.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        Hye(c)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (o = a[this.treeIndex], i = (o & Xn.VALUE_LENGTH) >> 14, i !== 0) {
        if (c === lt.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== Cn.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: a } = this, o = (a[n] & Xn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, o, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, a) {
    const { decodeTree: o } = this;
    return this.emitCodePoint(n === 1 ? o[t] & ~Xn.VALUE_LENGTH : o[t + 1], a), n === 3 && this.emitCodePoint(o[t + 2], a), a;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case st.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Cn.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case st.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case st.NumericHex:
        return this.emitNumericEntity(0, 3);
      case st.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case st.EntityStart:
        return 0;
    }
  }
}
function Fye(e, t, n, a) {
  const o = (t & Xn.BRANCH_LENGTH) >> 7, i = t & Xn.JUMP_TABLE;
  if (o === 0)
    return i !== 0 && a === i ? n : -1;
  if (i) {
    const l = a - i;
    return l < 0 || l >= o ? -1 : e[n + l] - 1;
  }
  let c = n, s = c + o - 1;
  for (; c <= s; ) {
    const l = c + s >>> 1, u = e[l];
    if (u < a)
      c = l + 1;
    else if (u > a)
      s = l - 1;
    else
      return e[l + o];
  }
  return -1;
}
var V;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(V || (V = {}));
var V1;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(V1 || (V1 = {}));
var Wt;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(Wt || (Wt = {}));
var w;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(w || (w = {}));
var d;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(d || (d = {}));
const $ye = /* @__PURE__ */ new Map([
  [w.A, d.A],
  [w.ADDRESS, d.ADDRESS],
  [w.ANNOTATION_XML, d.ANNOTATION_XML],
  [w.APPLET, d.APPLET],
  [w.AREA, d.AREA],
  [w.ARTICLE, d.ARTICLE],
  [w.ASIDE, d.ASIDE],
  [w.B, d.B],
  [w.BASE, d.BASE],
  [w.BASEFONT, d.BASEFONT],
  [w.BGSOUND, d.BGSOUND],
  [w.BIG, d.BIG],
  [w.BLOCKQUOTE, d.BLOCKQUOTE],
  [w.BODY, d.BODY],
  [w.BR, d.BR],
  [w.BUTTON, d.BUTTON],
  [w.CAPTION, d.CAPTION],
  [w.CENTER, d.CENTER],
  [w.CODE, d.CODE],
  [w.COL, d.COL],
  [w.COLGROUP, d.COLGROUP],
  [w.DD, d.DD],
  [w.DESC, d.DESC],
  [w.DETAILS, d.DETAILS],
  [w.DIALOG, d.DIALOG],
  [w.DIR, d.DIR],
  [w.DIV, d.DIV],
  [w.DL, d.DL],
  [w.DT, d.DT],
  [w.EM, d.EM],
  [w.EMBED, d.EMBED],
  [w.FIELDSET, d.FIELDSET],
  [w.FIGCAPTION, d.FIGCAPTION],
  [w.FIGURE, d.FIGURE],
  [w.FONT, d.FONT],
  [w.FOOTER, d.FOOTER],
  [w.FOREIGN_OBJECT, d.FOREIGN_OBJECT],
  [w.FORM, d.FORM],
  [w.FRAME, d.FRAME],
  [w.FRAMESET, d.FRAMESET],
  [w.H1, d.H1],
  [w.H2, d.H2],
  [w.H3, d.H3],
  [w.H4, d.H4],
  [w.H5, d.H5],
  [w.H6, d.H6],
  [w.HEAD, d.HEAD],
  [w.HEADER, d.HEADER],
  [w.HGROUP, d.HGROUP],
  [w.HR, d.HR],
  [w.HTML, d.HTML],
  [w.I, d.I],
  [w.IMG, d.IMG],
  [w.IMAGE, d.IMAGE],
  [w.INPUT, d.INPUT],
  [w.IFRAME, d.IFRAME],
  [w.KEYGEN, d.KEYGEN],
  [w.LABEL, d.LABEL],
  [w.LI, d.LI],
  [w.LINK, d.LINK],
  [w.LISTING, d.LISTING],
  [w.MAIN, d.MAIN],
  [w.MALIGNMARK, d.MALIGNMARK],
  [w.MARQUEE, d.MARQUEE],
  [w.MATH, d.MATH],
  [w.MENU, d.MENU],
  [w.META, d.META],
  [w.MGLYPH, d.MGLYPH],
  [w.MI, d.MI],
  [w.MO, d.MO],
  [w.MN, d.MN],
  [w.MS, d.MS],
  [w.MTEXT, d.MTEXT],
  [w.NAV, d.NAV],
  [w.NOBR, d.NOBR],
  [w.NOFRAMES, d.NOFRAMES],
  [w.NOEMBED, d.NOEMBED],
  [w.NOSCRIPT, d.NOSCRIPT],
  [w.OBJECT, d.OBJECT],
  [w.OL, d.OL],
  [w.OPTGROUP, d.OPTGROUP],
  [w.OPTION, d.OPTION],
  [w.P, d.P],
  [w.PARAM, d.PARAM],
  [w.PLAINTEXT, d.PLAINTEXT],
  [w.PRE, d.PRE],
  [w.RB, d.RB],
  [w.RP, d.RP],
  [w.RT, d.RT],
  [w.RTC, d.RTC],
  [w.RUBY, d.RUBY],
  [w.S, d.S],
  [w.SCRIPT, d.SCRIPT],
  [w.SEARCH, d.SEARCH],
  [w.SECTION, d.SECTION],
  [w.SELECT, d.SELECT],
  [w.SOURCE, d.SOURCE],
  [w.SMALL, d.SMALL],
  [w.SPAN, d.SPAN],
  [w.STRIKE, d.STRIKE],
  [w.STRONG, d.STRONG],
  [w.STYLE, d.STYLE],
  [w.SUB, d.SUB],
  [w.SUMMARY, d.SUMMARY],
  [w.SUP, d.SUP],
  [w.TABLE, d.TABLE],
  [w.TBODY, d.TBODY],
  [w.TEMPLATE, d.TEMPLATE],
  [w.TEXTAREA, d.TEXTAREA],
  [w.TFOOT, d.TFOOT],
  [w.TD, d.TD],
  [w.TH, d.TH],
  [w.THEAD, d.THEAD],
  [w.TITLE, d.TITLE],
  [w.TR, d.TR],
  [w.TRACK, d.TRACK],
  [w.TT, d.TT],
  [w.U, d.U],
  [w.UL, d.UL],
  [w.SVG, d.SVG],
  [w.VAR, d.VAR],
  [w.WBR, d.WBR],
  [w.XMP, d.XMP]
]);
function Ti(e) {
  var t;
  return (t = $ye.get(e)) !== null && t !== void 0 ? t : d.UNKNOWN;
}
const W = d, Uye = {
  [V.HTML]: /* @__PURE__ */ new Set([
    W.ADDRESS,
    W.APPLET,
    W.AREA,
    W.ARTICLE,
    W.ASIDE,
    W.BASE,
    W.BASEFONT,
    W.BGSOUND,
    W.BLOCKQUOTE,
    W.BODY,
    W.BR,
    W.BUTTON,
    W.CAPTION,
    W.CENTER,
    W.COL,
    W.COLGROUP,
    W.DD,
    W.DETAILS,
    W.DIR,
    W.DIV,
    W.DL,
    W.DT,
    W.EMBED,
    W.FIELDSET,
    W.FIGCAPTION,
    W.FIGURE,
    W.FOOTER,
    W.FORM,
    W.FRAME,
    W.FRAMESET,
    W.H1,
    W.H2,
    W.H3,
    W.H4,
    W.H5,
    W.H6,
    W.HEAD,
    W.HEADER,
    W.HGROUP,
    W.HR,
    W.HTML,
    W.IFRAME,
    W.IMG,
    W.INPUT,
    W.LI,
    W.LINK,
    W.LISTING,
    W.MAIN,
    W.MARQUEE,
    W.MENU,
    W.META,
    W.NAV,
    W.NOEMBED,
    W.NOFRAMES,
    W.NOSCRIPT,
    W.OBJECT,
    W.OL,
    W.P,
    W.PARAM,
    W.PLAINTEXT,
    W.PRE,
    W.SCRIPT,
    W.SECTION,
    W.SELECT,
    W.SOURCE,
    W.STYLE,
    W.SUMMARY,
    W.TABLE,
    W.TBODY,
    W.TD,
    W.TEMPLATE,
    W.TEXTAREA,
    W.TFOOT,
    W.TH,
    W.THEAD,
    W.TITLE,
    W.TR,
    W.TRACK,
    W.UL,
    W.WBR,
    W.XMP
  ]),
  [V.MATHML]: /* @__PURE__ */ new Set([W.MI, W.MO, W.MN, W.MS, W.MTEXT, W.ANNOTATION_XML]),
  [V.SVG]: /* @__PURE__ */ new Set([W.TITLE, W.FOREIGN_OBJECT, W.DESC]),
  [V.XLINK]: /* @__PURE__ */ new Set(),
  [V.XML]: /* @__PURE__ */ new Set(),
  [V.XMLNS]: /* @__PURE__ */ new Set()
}, vv = /* @__PURE__ */ new Set([W.H1, W.H2, W.H3, W.H4, W.H5, W.H6]);
w.STYLE, w.SCRIPT, w.XMP, w.IFRAME, w.NOEMBED, w.NOFRAMES, w.PLAINTEXT;
var b;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(b || (b = {}));
const Qe = {
  DATA: b.DATA,
  RCDATA: b.RCDATA,
  RAWTEXT: b.RAWTEXT,
  SCRIPT_DATA: b.SCRIPT_DATA,
  PLAINTEXT: b.PLAINTEXT,
  CDATA_SECTION: b.CDATA_SECTION
};
function qye(e) {
  return e >= M.DIGIT_0 && e <= M.DIGIT_9;
}
function Wi(e) {
  return e >= M.LATIN_CAPITAL_A && e <= M.LATIN_CAPITAL_Z;
}
function zye(e) {
  return e >= M.LATIN_SMALL_A && e <= M.LATIN_SMALL_Z;
}
function zn(e) {
  return zye(e) || Wi(e);
}
function JI(e) {
  return zn(e) || qye(e);
}
function wc(e) {
  return e + 32;
}
function wC(e) {
  return e === M.SPACE || e === M.LINE_FEED || e === M.TABULATION || e === M.FORM_FEED;
}
function eT(e) {
  return wC(e) || e === M.SOLIDUS || e === M.GREATER_THAN_SIGN;
}
function jye(e) {
  return e === M.NULL ? D.nullCharacterReference : e > 1114111 ? D.characterReferenceOutsideUnicodeRange : IC(e) ? D.surrogateCharacterReference : NC(e) ? D.noncharacterCharacterReference : TC(e) || e === M.CARRIAGE_RETURN ? D.controlCharacterReference : null;
}
class Vye {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = b.DATA, this.returnState = b.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new Cye(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new Bye(wye, (a, o) => {
      this.preprocessor.pos = this.entityStartPos + o - 1, this._flushCodePointConsumedAsCharacterReference(a);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(D.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (a) => {
        this._err(D.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + a);
      },
      validateNumericCharacterReference: (a) => {
        const o = jye(a);
        o && this._err(o, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, n = 0) {
    var a, o;
    (o = (a = this.handler).onParseError) === null || o === void 0 || o.call(a, this.preprocessor.getError(t, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, n, a) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || a == null || a();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: xe.START_TAG,
      tagName: "",
      tagID: d.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: xe.END_TAG,
      tagName: "",
      tagID: d.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: xe.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: xe.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const a = this.currentToken;
    if (CC(a, this.currentAttr.name) === null) {
      if (a.attrs.push(this.currentAttr), a.location && this.currentLocation) {
        const o = (t = (n = a.location).attrs) !== null && t !== void 0 ? t : n.attrs = /* @__PURE__ */ Object.create(null);
        o[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(D.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Ti(t.tagName), t.type === xe.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(D.endTagWithAttributes), t.selfClosing && this._err(D.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case xe.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case xe.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case xe.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: xe.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = wC(t) ? xe.WHITESPACE_CHARACTER : t === M.NULL ? xe.NULL_CHARACTER : xe.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(xe.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = b.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Cn.Attribute : Cn.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === b.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === b.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === b.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case b.DATA: {
        this._stateData(t);
        break;
      }
      case b.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case b.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case b.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case b.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case b.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case b.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case b.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case b.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case b.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case b.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case b.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case b.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case b.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case b.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case b.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case b.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case b.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case b.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case b.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case b.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case b.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case b.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case b.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case b.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case b.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case b.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case b.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case b.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case b.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case b.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case b.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case b.COMMENT: {
        this._stateComment(t);
        break;
      }
      case b.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case b.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case b.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case b.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case b.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case b.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case b.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case b.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case b.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case b.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case b.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case b.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case b.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case b.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case b.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case b.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case b.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case b.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case b.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case b.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case b.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case b.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case b.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case b.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case b.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case b.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case b.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case b.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case M.LESS_THAN_SIGN: {
        this.state = b.TAG_OPEN;
        break;
      }
      case M.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case M.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case M.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case M.LESS_THAN_SIGN: {
        this.state = b.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (zn(t))
      this._createStartTagToken(), this.state = b.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case M.EXCLAMATION_MARK: {
          this.state = b.MARKUP_DECLARATION_OPEN;
          break;
        }
        case M.SOLIDUS: {
          this.state = b.END_TAG_OPEN;
          break;
        }
        case M.QUESTION_MARK: {
          this._err(D.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = b.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case M.EOF: {
          this._err(D.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(D.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = b.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (zn(t))
      this._createEndTagToken(), this.state = b.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case M.GREATER_THAN_SIGN: {
          this._err(D.missingEndTagName), this.state = b.DATA;
          break;
        }
        case M.EOF: {
          this._err(D.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(D.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = b.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case M.SOLIDUS: {
        this.state = b.SELF_CLOSING_START_TAG;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.tagName += je;
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Wi(t) ? wc(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === M.SOLIDUS ? this.state = b.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = b.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    zn(t) ? (this.state = b.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = b.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = b.BEFORE_ATTRIBUTE_NAME, !1;
      case M.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = b.SELF_CLOSING_START_TAG, !1;
      case M.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = b.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = b.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === M.SOLIDUS ? this.state = b.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = b.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    zn(t) ? (this.state = b.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = b.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = b.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case M.SOLIDUS: {
        this.state = b.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case M.EXCLAMATION_MARK: {
        this.state = b.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = b.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    zn(t) ? (this.state = b.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = b.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = b.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === M.HYPHEN_MINUS ? (this.state = b.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = b.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === M.HYPHEN_MINUS ? (this.state = b.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = b.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.state = b.SCRIPT_DATA_ESCAPED, this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = b.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.state = b.SCRIPT_DATA_ESCAPED, this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = b.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === M.SOLIDUS ? this.state = b.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : zn(t) ? (this._emitChars("<"), this.state = b.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = b.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    zn(t) ? (this.state = b.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = b.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = b.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(It.SCRIPT, !1) && eT(this.preprocessor.peek(It.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < It.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = b.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case M.LESS_THAN_SIGN: {
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(je);
        break;
      }
      case M.EOF: {
        this._err(D.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === M.SOLIDUS ? (this.state = b.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(It.SCRIPT, !1) && eT(this.preprocessor.peek(It.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < It.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = b.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = b.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.SOLIDUS:
      case M.GREATER_THAN_SIGN:
      case M.EOF: {
        this.state = b.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case M.EQUALS_SIGN: {
        this._err(D.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = b.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = b.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
      case M.SOLIDUS:
      case M.GREATER_THAN_SIGN:
      case M.EOF: {
        this._leaveAttrName(), this.state = b.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case M.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = b.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case M.QUOTATION_MARK:
      case M.APOSTROPHE:
      case M.LESS_THAN_SIGN: {
        this._err(D.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.currentAttr.name += je;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Wi(t) ? wc(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.SOLIDUS: {
        this.state = b.SELF_CLOSING_START_TAG;
        break;
      }
      case M.EQUALS_SIGN: {
        this.state = b.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = b.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.QUOTATION_MARK: {
        this.state = b.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        this.state = b.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.missingAttributeValue), this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = b.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case M.QUOTATION_MARK: {
        this.state = b.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case M.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.currentAttr.value += je;
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case M.APOSTROPHE: {
        this.state = b.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case M.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.currentAttr.value += je;
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this._leaveAttrValue(), this.state = b.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case M.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), this.currentAttr.value += je;
        break;
      }
      case M.QUOTATION_MARK:
      case M.APOSTROPHE:
      case M.LESS_THAN_SIGN:
      case M.EQUALS_SIGN:
      case M.GRAVE_ACCENT: {
        this._err(D.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this._leaveAttrValue(), this.state = b.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case M.SOLIDUS: {
        this._leaveAttrValue(), this.state = b.SELF_CLOSING_START_TAG;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingWhitespaceBetweenAttributes), this.state = b.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case M.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = b.DATA, this.emitCurrentTagToken();
        break;
      }
      case M.EOF: {
        this._err(D.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.unexpectedSolidusInTag), this.state = b.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch (t) {
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentComment(n);
        break;
      }
      case M.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.data += je;
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(It.DASH_DASH, !0) ? (this._createCommentToken(It.DASH_DASH.length + 1), this.state = b.COMMENT_START) : this._consumeSequenceIfMatch(It.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(It.DOCTYPE.length + 1), this.state = b.DOCTYPE) : this._consumeSequenceIfMatch(It.CDATA_START, !0) ? this.inForeignNode ? this.state = b.CDATA_SECTION : (this._err(D.cdataInHtmlContent), this._createCommentToken(It.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = b.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(D.incorrectlyOpenedComment), this._createCommentToken(2), this.state = b.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.COMMENT_START_DASH;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptClosingOfEmptyComment), this.state = b.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.COMMENT_END;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptClosingOfEmptyComment), this.state = b.DATA, this.emitCurrentComment(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const n = this.currentToken;
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.COMMENT_END_DASH;
        break;
      }
      case M.LESS_THAN_SIGN: {
        n.data += "<", this.state = b.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.data += je;
        break;
      }
      case M.EOF: {
        this._err(D.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch (t) {
      case M.EXCLAMATION_MARK: {
        n.data += "!", this.state = b.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case M.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === M.HYPHEN_MINUS ? this.state = b.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = b.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === M.HYPHEN_MINUS ? this.state = b.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = b.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== M.GREATER_THAN_SIGN && t !== M.EOF && this._err(D.nestedComment), this.state = b.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch (t) {
      case M.HYPHEN_MINUS: {
        this.state = b.COMMENT_END;
        break;
      }
      case M.EOF: {
        this._err(D.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch (t) {
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentComment(n);
        break;
      }
      case M.EXCLAMATION_MARK: {
        this.state = b.COMMENT_END_BANG;
        break;
      }
      case M.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case M.EOF: {
        this._err(D.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch (t) {
      case M.HYPHEN_MINUS: {
        n.data += "--!", this.state = b.COMMENT_END_DASH;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.incorrectlyClosedComment), this.state = b.DATA, this.emitCurrentComment(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = b.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.BEFORE_DOCTYPE_NAME;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingWhitespaceBeforeDoctypeName), this.state = b.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Wi(t))
      this._createDoctypeToken(String.fromCharCode(wc(t))), this.state = b.DOCTYPE_NAME;
    else
      switch (t) {
        case M.SPACE:
        case M.LINE_FEED:
        case M.TABULATION:
        case M.FORM_FEED:
          break;
        case M.NULL: {
          this._err(D.unexpectedNullCharacter), this._createDoctypeToken(je), this.state = b.DOCTYPE_NAME;
          break;
        }
        case M.GREATER_THAN_SIGN: {
          this._err(D.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = b.DATA;
          break;
        }
        case M.EOF: {
          this._err(D.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = b.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.AFTER_DOCTYPE_NAME;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.name += je;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Wi(t) ? wc(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(It.PUBLIC, !1) ? this.state = b.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(It.SYSTEM, !1) ? this.state = b.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(D.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case M.QUOTATION_MARK: {
        this._err(D.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = b.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        this._err(D.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = b.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.QUOTATION_MARK: {
        n.publicId = "", this.state = b.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        n.publicId = "", this.state = b.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case M.QUOTATION_MARK: {
        this.state = b.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.publicId += je;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case M.APOSTROPHE: {
        this.state = b.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.publicId += je;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.QUOTATION_MARK: {
        this._err(D.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        this._err(D.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.QUOTATION_MARK: {
        n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED: {
        this.state = b.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case M.QUOTATION_MARK: {
        this._err(D.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        this._err(D.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.QUOTATION_MARK: {
        n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case M.APOSTROPHE: {
        n.systemId = "", this.state = b.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case M.QUOTATION_MARK: {
        this.state = b.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.systemId += je;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case M.APOSTROPHE: {
        this.state = b.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter), n.systemId += je;
        break;
      }
      case M.GREATER_THAN_SIGN: {
        this._err(D.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case M.SPACE:
      case M.LINE_FEED:
      case M.TABULATION:
      case M.FORM_FEED:
        break;
      case M.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.EOF: {
        this._err(D.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(D.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = b.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch (t) {
      case M.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = b.DATA;
        break;
      }
      case M.NULL: {
        this._err(D.unexpectedNullCharacter);
        break;
      }
      case M.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case M.RIGHT_SQUARE_BRACKET: {
        this.state = b.CDATA_SECTION_BRACKET;
        break;
      }
      case M.EOF: {
        this._err(D.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === M.RIGHT_SQUARE_BRACKET ? this.state = b.CDATA_SECTION_END : (this._emitChars("]"), this.state = b.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case M.GREATER_THAN_SIGN: {
        this.state = b.DATA;
        break;
      }
      case M.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = b.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(M.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && JI(this.preprocessor.peek(1)) ? b.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    JI(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === M.SEMICOLON && this._err(D.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const SC = /* @__PURE__ */ new Set([d.DD, d.DT, d.LI, d.OPTGROUP, d.OPTION, d.P, d.RB, d.RP, d.RT, d.RTC]), tT = /* @__PURE__ */ new Set([
  ...SC,
  d.CAPTION,
  d.COLGROUP,
  d.TBODY,
  d.TD,
  d.TFOOT,
  d.TH,
  d.THEAD,
  d.TR
]), nE = /* @__PURE__ */ new Set([
  d.APPLET,
  d.CAPTION,
  d.HTML,
  d.MARQUEE,
  d.OBJECT,
  d.TABLE,
  d.TD,
  d.TEMPLATE,
  d.TH
]), Gye = /* @__PURE__ */ new Set([...nE, d.OL, d.UL]), Wye = /* @__PURE__ */ new Set([...nE, d.BUTTON]), nT = /* @__PURE__ */ new Set([d.ANNOTATION_XML, d.MI, d.MN, d.MO, d.MS, d.MTEXT]), aT = /* @__PURE__ */ new Set([d.DESC, d.FOREIGN_OBJECT, d.TITLE]), Xye = /* @__PURE__ */ new Set([d.TR, d.TEMPLATE, d.HTML]), Yye = /* @__PURE__ */ new Set([d.TBODY, d.TFOOT, d.THEAD, d.TEMPLATE, d.HTML]), Kye = /* @__PURE__ */ new Set([d.TABLE, d.TEMPLATE, d.HTML]), Zye = /* @__PURE__ */ new Set([d.TD, d.TH]);
class Qye {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, a) {
    this.treeAdapter = n, this.handler = a, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = d.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === d.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === V.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const a = this._indexOf(t);
    this.items[a] = n, a === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, a) {
    const o = this._indexOf(t) + 1;
    this.items.splice(o, 0, n), this.tagIDs.splice(o, 0, a), this.stackTop++, o === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, o === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(t, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== V.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const a = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(a, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(vv, V.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Zye, V.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let a = this.stackTop; a >= 0; a--)
      if (t.has(this.tagIDs[a]) && this.treeAdapter.getNamespaceURI(this.items[a]) === n)
        return a;
    return -1;
  }
  clearBackTo(t, n) {
    const a = this._indexOfTagNames(t, n);
    this.shortenToLength(a + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(Kye, V.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(Yye, V.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(Xye, V.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === d.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === d.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, n) {
    for (let a = this.stackTop; a >= 0; a--) {
      const o = this.tagIDs[a];
      switch (this.treeAdapter.getNamespaceURI(this.items[a])) {
        case V.HTML: {
          if (o === t)
            return !0;
          if (n.has(o))
            return !1;
          break;
        }
        case V.SVG: {
          if (aT.has(o))
            return !1;
          break;
        }
        case V.MATHML: {
          if (nT.has(o))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, nE);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, Gye);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, Wye);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case V.HTML: {
          if (vv.has(n))
            return !0;
          if (nE.has(n))
            return !1;
          break;
        }
        case V.SVG: {
          if (aT.has(n))
            return !1;
          break;
        }
        case V.MATHML: {
          if (nT.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === V.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case d.TABLE:
          case d.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === V.HTML)
        switch (this.tagIDs[t]) {
          case d.TBODY:
          case d.THEAD:
          case d.TFOOT:
            return !0;
          case d.TABLE:
          case d.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === V.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case d.OPTION:
          case d.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && SC.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && tT.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && tT.has(this.currentTagId); )
      this.pop();
  }
}
const XE = 3;
var kn;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(kn || (kn = {}));
const oT = { type: kn.Marker };
class Jye {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, n) {
    const a = [], o = n.length, i = this.treeAdapter.getTagName(t), c = this.treeAdapter.getNamespaceURI(t);
    for (let s = 0; s < this.entries.length; s++) {
      const l = this.entries[s];
      if (l.type === kn.Marker)
        break;
      const { element: u } = l;
      if (this.treeAdapter.getTagName(u) === i && this.treeAdapter.getNamespaceURI(u) === c) {
        const h = this.treeAdapter.getAttrList(u);
        h.length === o && a.push({ idx: s, attrs: h });
      }
    }
    return a;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < XE)
      return;
    const n = this.treeAdapter.getAttrList(t), a = this._getNoahArkConditionCandidates(t, n);
    if (a.length < XE)
      return;
    const o = new Map(n.map((c) => [c.name, c.value]));
    let i = 0;
    for (let c = 0; c < a.length; c++) {
      const s = a[c];
      s.attrs.every((l) => o.get(l.name) === l.value) && (i += 1, i >= XE && this.entries.splice(s.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(oT);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: kn.Element,
      element: t,
      token: n
    });
  }
  insertElementAfterBookmark(t, n) {
    const a = this.entries.indexOf(this.bookmark);
    this.entries.splice(a, 0, {
      type: kn.Element,
      element: t,
      token: n
    });
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(oT);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find((a) => a.type === kn.Marker || this.treeAdapter.getTagName(a.element) === t);
    return n && n.type === kn.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find((n) => n.type === kn.Element && n.element === t);
  }
}
const jn = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Wt.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, n) {
    return {
      nodeName: e,
      tagName: e,
      attrs: n,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, n) {
    const a = e.childNodes.indexOf(n);
    e.childNodes.splice(a, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, n, a) {
    const o = e.childNodes.find((i) => i.nodeName === "#documentType");
    if (o)
      o.name = t, o.publicId = n, o.systemId = a;
    else {
      const i = {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: a,
        parentNode: null
      };
      jn.appendChild(e, i);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const n = e.childNodes[e.childNodes.length - 1];
      if (jn.isTextNode(n)) {
        n.value += t;
        return;
      }
    }
    jn.appendChild(e, jn.createTextNode(t));
  },
  insertTextBefore(e, t, n) {
    const a = e.childNodes[e.childNodes.indexOf(n) - 1];
    a && jn.isTextNode(a) ? a.value += t : jn.insertBefore(e, jn.createTextNode(t), n);
  },
  adoptAttributes(e, t) {
    const n = new Set(e.attrs.map((a) => a.name));
    for (let a = 0; a < t.length; a++)
      n.has(t[a].name) || e.attrs.push(t[a]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, RC = "html", eke = "about:legacy-compat", tke = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", DC = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], nke = [
  ...DC,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], ake = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), OC = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], oke = [
  ...OC,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function rT(e, t) {
  return t.some((n) => e.startsWith(n));
}
function rke(e) {
  return e.name === RC && e.publicId === null && (e.systemId === null || e.systemId === eke);
}
function ike(e) {
  if (e.name !== RC)
    return Wt.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === tke)
    return Wt.QUIRKS;
  let { publicId: n } = e;
  if (n !== null) {
    if (n = n.toLowerCase(), ake.has(n))
      return Wt.QUIRKS;
    let a = t === null ? nke : DC;
    if (rT(n, a))
      return Wt.QUIRKS;
    if (a = t === null ? OC : oke, rT(n, a))
      return Wt.LIMITED_QUIRKS;
  }
  return Wt.NO_QUIRKS;
}
const iT = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, cke = "definitionurl", ske = "definitionURL", lke = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), dke = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: V.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: V.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: V.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: V.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: V.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: V.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: V.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: V.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: V.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: V.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: V.XMLNS }]
]), uke = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), hke = /* @__PURE__ */ new Set([
  d.B,
  d.BIG,
  d.BLOCKQUOTE,
  d.BODY,
  d.BR,
  d.CENTER,
  d.CODE,
  d.DD,
  d.DIV,
  d.DL,
  d.DT,
  d.EM,
  d.EMBED,
  d.H1,
  d.H2,
  d.H3,
  d.H4,
  d.H5,
  d.H6,
  d.HEAD,
  d.HR,
  d.I,
  d.IMG,
  d.LI,
  d.LISTING,
  d.MENU,
  d.META,
  d.NOBR,
  d.OL,
  d.P,
  d.PRE,
  d.RUBY,
  d.S,
  d.SMALL,
  d.SPAN,
  d.STRONG,
  d.STRIKE,
  d.SUB,
  d.SUP,
  d.TABLE,
  d.TT,
  d.U,
  d.UL,
  d.VAR
]);
function pke(e) {
  const t = e.tagID;
  return t === d.FONT && e.attrs.some(({ name: a }) => a === V1.COLOR || a === V1.SIZE || a === V1.FACE) || hke.has(t);
}
function PC(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === cke) {
      e.attrs[t].name = ske;
      break;
    }
}
function HC(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = lke.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function lA(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = dke.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function yke(e) {
  const t = uke.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Ti(e.tagName));
}
function kke(e, t) {
  return t === V.MATHML && (e === d.MI || e === d.MO || e === d.MN || e === d.MS || e === d.MTEXT);
}
function fke(e, t, n) {
  if (t === V.MATHML && e === d.ANNOTATION_XML) {
    for (let a = 0; a < n.length; a++)
      if (n[a].name === V1.ENCODING) {
        const o = n[a].value.toLowerCase();
        return o === iT.TEXT_HTML || o === iT.APPLICATION_XML;
      }
  }
  return t === V.SVG && (e === d.FOREIGN_OBJECT || e === d.DESC || e === d.TITLE);
}
function mke(e, t, n, a) {
  return (!a || a === V.HTML) && fke(e, t, n) || (!a || a === V.MATHML) && kke(e, t);
}
const gke = "hidden", Mke = 8, _ke = 3;
var v;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(v || (v = {}));
const bke = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, BC = /* @__PURE__ */ new Set([d.TABLE, d.TBODY, d.TFOOT, d.THEAD, d.TR]), cT = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: jn,
  onParseError: null
};
class sT {
  constructor(t, n, a = null, o = null) {
    this.fragmentContext = a, this.scriptHandler = o, this.currentToken = null, this.stopped = !1, this.insertionMode = v.INITIAL, this.originalInsertionMode = v.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...cT,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new Vye(this.options, this), this.activeFormattingElements = new Jye(this.treeAdapter), this.fragmentContextID = a ? Ti(this.treeAdapter.getTagName(a)) : d.UNKNOWN, this._setContextModes(a ?? this.document, this.fragmentContextID), this.openElements = new Qye(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, n) {
    const a = new this(n);
    return a.tokenizer.write(t, !0), a.document;
  }
  static getFragmentParser(t, n) {
    const a = {
      ...cT,
      ...n
    };
    t ?? (t = a.treeAdapter.createElement(w.TEMPLATE, V.HTML, []));
    const o = a.treeAdapter.createElement("documentmock", V.HTML, []), i = new this(a, o, t);
    return i.fragmentContextID === d.TEMPLATE && i.tmplInsertionModeStack.unshift(v.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  //Errors
  /** @internal */
  _err(t, n, a) {
    var o;
    if (!this.onParseError)
      return;
    const i = (o = t.location) !== null && o !== void 0 ? o : bke, c = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: a ? i.startLine : i.endLine,
      endCol: a ? i.startCol : i.endCol,
      endOffset: a ? i.startOffset : i.endOffset
    };
    this.onParseError(c);
  }
  //Stack events
  /** @internal */
  onItemPush(t, n, a) {
    var o, i;
    (i = (o = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(o, t), a && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  /** @internal */
  onItemPop(t, n) {
    var a, o;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (o = (a = this.treeAdapter).onItemPop) === null || o === void 0 || o.call(a, t, this.openElements.current), n) {
      let i, c;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, c = this.fragmentContextID) : { current: i, currentTagId: c } = this.openElements, this._setContextModes(i, c);
    }
  }
  _setContextModes(t, n) {
    const a = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === V.HTML;
    this.currentNotInHTML = !a, this.tokenizer.inForeignNode = !a && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  /** @protected */
  _switchToTextParsing(t, n) {
    this._insertElement(t, V.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = v.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = v.TEXT, this.originalInsertionMode = v.IN_BODY, this.tokenizer.state = Qe.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === w.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== V.HTML))
      switch (this.fragmentContextID) {
        case d.TITLE:
        case d.TEXTAREA: {
          this.tokenizer.state = Qe.RCDATA;
          break;
        }
        case d.STYLE:
        case d.XMP:
        case d.IFRAME:
        case d.NOEMBED:
        case d.NOFRAMES:
        case d.NOSCRIPT: {
          this.tokenizer.state = Qe.RAWTEXT;
          break;
        }
        case d.SCRIPT: {
          this.tokenizer.state = Qe.SCRIPT_DATA;
          break;
        }
        case d.PLAINTEXT: {
          this.tokenizer.state = Qe.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const n = t.name || "", a = t.publicId || "", o = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, a, o), t.location) {
      const c = this.treeAdapter.getChildNodes(this.document).find((s) => this.treeAdapter.isDocumentTypeNode(s));
      c && this.treeAdapter.setNodeSourceCodeLocation(c, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const a = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, a);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const a = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(a ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, n) {
    const a = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(a, t.location);
  }
  /** @protected */
  _insertElement(t, n) {
    const a = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(a, t.location), this.openElements.push(a, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, n) {
    const a = this.treeAdapter.createElement(t, V.HTML, []);
    this._attachElementToTree(a, null), this.openElements.push(a, n);
  }
  /** @protected */
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, V.HTML, t.attrs), a = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, a), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(w.HTML, V.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, d.HTML);
  }
  /** @protected */
  _appendCommentNode(t, n) {
    const a = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, a), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let n, a;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: a } = this._findFosterParentingLocation(), a ? this.treeAdapter.insertTextBefore(n, t.chars, a) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location)
      return;
    const o = this.treeAdapter.getChildNodes(n), i = a ? o.lastIndexOf(a) : o.length, c = o[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(c)) {
      const { endLine: l, endCol: u, endOffset: h } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(c, { endLine: l, endCol: u, endOffset: h });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(c, t.location);
  }
  /** @protected */
  _adoptNodes(t, n) {
    for (let a = this.treeAdapter.getFirstChild(t); a; a = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(a), this.treeAdapter.appendChild(n, a);
  }
  /** @protected */
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const a = n.location, o = this.treeAdapter.getTagName(t), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === xe.END_TAG && o === n.tagName ? {
          endTag: { ...a },
          endLine: a.endLine,
          endCol: a.endCol,
          endOffset: a.endOffset
        } : {
          endLine: a.startLine,
          endCol: a.startCol,
          endOffset: a.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let n, a;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, a = this.fragmentContextID) : { current: n, currentTagId: a } = this.openElements, t.tagID === d.SVG && this.treeAdapter.getTagName(n) === w.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === V.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === d.MGLYPH || t.tagID === d.MALIGNMARK) && a !== void 0 && !this._isIntegrationPoint(a, n, V.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case xe.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case xe.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case xe.COMMENT: {
        this.onComment(t);
        break;
      }
      case xe.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case xe.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case xe.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case xe.EOF: {
        this.onEof(t);
        break;
      }
      case xe.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, n, a) {
    const o = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return mke(t, o, i, a);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex((o) => o.type === kn.Marker || this.openElements.contains(o.element)), a = n === -1 ? t - 1 : n - 1;
      for (let o = a; o >= 0; o--) {
        const i = this.activeFormattingElements.entries[o];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = v.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(d.P), this.openElements.popUntilTagNamePopped(d.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case d.TR: {
          this.insertionMode = v.IN_ROW;
          return;
        }
        case d.TBODY:
        case d.THEAD:
        case d.TFOOT: {
          this.insertionMode = v.IN_TABLE_BODY;
          return;
        }
        case d.CAPTION: {
          this.insertionMode = v.IN_CAPTION;
          return;
        }
        case d.COLGROUP: {
          this.insertionMode = v.IN_COLUMN_GROUP;
          return;
        }
        case d.TABLE: {
          this.insertionMode = v.IN_TABLE;
          return;
        }
        case d.BODY: {
          this.insertionMode = v.IN_BODY;
          return;
        }
        case d.FRAMESET: {
          this.insertionMode = v.IN_FRAMESET;
          return;
        }
        case d.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case d.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case d.HTML: {
          this.insertionMode = this.headElement ? v.AFTER_HEAD : v.BEFORE_HEAD;
          return;
        }
        case d.TD:
        case d.TH: {
          if (t > 0) {
            this.insertionMode = v.IN_CELL;
            return;
          }
          break;
        }
        case d.HEAD: {
          if (t > 0) {
            this.insertionMode = v.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = v.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const a = this.openElements.tagIDs[n];
        if (a === d.TEMPLATE)
          break;
        if (a === d.TABLE) {
          this.insertionMode = v.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = v.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return BC.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case d.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === V.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case d.TABLE: {
          const a = this.treeAdapter.getParentNode(n);
          return a ? { parent: a, beforeElement: n } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, n) {
    const a = this.treeAdapter.getNamespaceURI(t);
    return Uye[a].has(n);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Z4e(this, t);
      return;
    }
    switch (this.insertionMode) {
      case v.INITIAL: {
        Bi(this, t);
        break;
      }
      case v.BEFORE_HTML: {
        Qi(this, t);
        break;
      }
      case v.BEFORE_HEAD: {
        Ji(this, t);
        break;
      }
      case v.IN_HEAD: {
        ec(this, t);
        break;
      }
      case v.IN_HEAD_NO_SCRIPT: {
        tc(this, t);
        break;
      }
      case v.AFTER_HEAD: {
        nc(this, t);
        break;
      }
      case v.IN_BODY:
      case v.IN_CAPTION:
      case v.IN_CELL:
      case v.IN_TEMPLATE: {
        $C(this, t);
        break;
      }
      case v.TEXT:
      case v.IN_SELECT:
      case v.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case v.IN_TABLE:
      case v.IN_TABLE_BODY:
      case v.IN_ROW: {
        YE(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        GC(this, t);
        break;
      }
      case v.IN_COLUMN_GROUP: {
        aE(this, t);
        break;
      }
      case v.AFTER_BODY: {
        oE(this, t);
        break;
      }
      case v.AFTER_AFTER_BODY: {
        X9(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      K4e(this, t);
      return;
    }
    switch (this.insertionMode) {
      case v.INITIAL: {
        Bi(this, t);
        break;
      }
      case v.BEFORE_HTML: {
        Qi(this, t);
        break;
      }
      case v.BEFORE_HEAD: {
        Ji(this, t);
        break;
      }
      case v.IN_HEAD: {
        ec(this, t);
        break;
      }
      case v.IN_HEAD_NO_SCRIPT: {
        tc(this, t);
        break;
      }
      case v.AFTER_HEAD: {
        nc(this, t);
        break;
      }
      case v.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case v.IN_TABLE:
      case v.IN_TABLE_BODY:
      case v.IN_ROW: {
        YE(this, t);
        break;
      }
      case v.IN_COLUMN_GROUP: {
        aE(this, t);
        break;
      }
      case v.AFTER_BODY: {
        oE(this, t);
        break;
      }
      case v.AFTER_AFTER_BODY: {
        X9(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Av(this, t);
      return;
    }
    switch (this.insertionMode) {
      case v.INITIAL:
      case v.BEFORE_HTML:
      case v.BEFORE_HEAD:
      case v.IN_HEAD:
      case v.IN_HEAD_NO_SCRIPT:
      case v.AFTER_HEAD:
      case v.IN_BODY:
      case v.IN_TABLE:
      case v.IN_CAPTION:
      case v.IN_COLUMN_GROUP:
      case v.IN_TABLE_BODY:
      case v.IN_ROW:
      case v.IN_CELL:
      case v.IN_SELECT:
      case v.IN_SELECT_IN_TABLE:
      case v.IN_TEMPLATE:
      case v.IN_FRAMESET:
      case v.AFTER_FRAMESET: {
        Av(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        Fi(this, t);
        break;
      }
      case v.AFTER_BODY: {
        Tke(this, t);
        break;
      }
      case v.AFTER_AFTER_BODY:
      case v.AFTER_AFTER_FRAMESET: {
        Nke(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case v.INITIAL: {
        Cke(this, t);
        break;
      }
      case v.BEFORE_HEAD:
      case v.IN_HEAD:
      case v.IN_HEAD_NO_SCRIPT:
      case v.AFTER_HEAD: {
        this._err(t, D.misplacedDoctype);
        break;
      }
      case v.IN_TABLE_TEXT: {
        Fi(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, D.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? Q4e(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case v.INITIAL: {
        Bi(this, t);
        break;
      }
      case v.BEFORE_HTML: {
        wke(this, t);
        break;
      }
      case v.BEFORE_HEAD: {
        Rke(this, t);
        break;
      }
      case v.IN_HEAD: {
        rn(this, t);
        break;
      }
      case v.IN_HEAD_NO_SCRIPT: {
        Pke(this, t);
        break;
      }
      case v.AFTER_HEAD: {
        Bke(this, t);
        break;
      }
      case v.IN_BODY: {
        Mt(this, t);
        break;
      }
      case v.IN_TABLE: {
        Mi(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        Fi(this, t);
        break;
      }
      case v.IN_CAPTION: {
        D4e(this, t);
        break;
      }
      case v.IN_COLUMN_GROUP: {
        hA(this, t);
        break;
      }
      case v.IN_TABLE_BODY: {
        IE(this, t);
        break;
      }
      case v.IN_ROW: {
        TE(this, t);
        break;
      }
      case v.IN_CELL: {
        H4e(this, t);
        break;
      }
      case v.IN_SELECT: {
        YC(this, t);
        break;
      }
      case v.IN_SELECT_IN_TABLE: {
        F4e(this, t);
        break;
      }
      case v.IN_TEMPLATE: {
        U4e(this, t);
        break;
      }
      case v.AFTER_BODY: {
        z4e(this, t);
        break;
      }
      case v.IN_FRAMESET: {
        j4e(this, t);
        break;
      }
      case v.AFTER_FRAMESET: {
        G4e(this, t);
        break;
      }
      case v.AFTER_AFTER_BODY: {
        X4e(this, t);
        break;
      }
      case v.AFTER_AFTER_FRAMESET: {
        Y4e(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? J4e(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case v.INITIAL: {
        Bi(this, t);
        break;
      }
      case v.BEFORE_HTML: {
        Ske(this, t);
        break;
      }
      case v.BEFORE_HEAD: {
        Dke(this, t);
        break;
      }
      case v.IN_HEAD: {
        Oke(this, t);
        break;
      }
      case v.IN_HEAD_NO_SCRIPT: {
        Hke(this, t);
        break;
      }
      case v.AFTER_HEAD: {
        Fke(this, t);
        break;
      }
      case v.IN_BODY: {
        AE(this, t);
        break;
      }
      case v.TEXT: {
        E4e(this, t);
        break;
      }
      case v.IN_TABLE: {
        uc(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        Fi(this, t);
        break;
      }
      case v.IN_CAPTION: {
        O4e(this, t);
        break;
      }
      case v.IN_COLUMN_GROUP: {
        P4e(this, t);
        break;
      }
      case v.IN_TABLE_BODY: {
        Iv(this, t);
        break;
      }
      case v.IN_ROW: {
        XC(this, t);
        break;
      }
      case v.IN_CELL: {
        B4e(this, t);
        break;
      }
      case v.IN_SELECT: {
        KC(this, t);
        break;
      }
      case v.IN_SELECT_IN_TABLE: {
        $4e(this, t);
        break;
      }
      case v.IN_TEMPLATE: {
        q4e(this, t);
        break;
      }
      case v.AFTER_BODY: {
        QC(this, t);
        break;
      }
      case v.IN_FRAMESET: {
        V4e(this, t);
        break;
      }
      case v.AFTER_FRAMESET: {
        W4e(this, t);
        break;
      }
      case v.AFTER_AFTER_BODY: {
        X9(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case v.INITIAL: {
        Bi(this, t);
        break;
      }
      case v.BEFORE_HTML: {
        Qi(this, t);
        break;
      }
      case v.BEFORE_HEAD: {
        Ji(this, t);
        break;
      }
      case v.IN_HEAD: {
        ec(this, t);
        break;
      }
      case v.IN_HEAD_NO_SCRIPT: {
        tc(this, t);
        break;
      }
      case v.AFTER_HEAD: {
        nc(this, t);
        break;
      }
      case v.IN_BODY:
      case v.IN_TABLE:
      case v.IN_CAPTION:
      case v.IN_COLUMN_GROUP:
      case v.IN_TABLE_BODY:
      case v.IN_ROW:
      case v.IN_CELL:
      case v.IN_SELECT:
      case v.IN_SELECT_IN_TABLE: {
        jC(this, t);
        break;
      }
      case v.TEXT: {
        v4e(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        Fi(this, t);
        break;
      }
      case v.IN_TEMPLATE: {
        ZC(this, t);
        break;
      }
      case v.AFTER_BODY:
      case v.IN_FRAMESET:
      case v.AFTER_FRAMESET:
      case v.AFTER_AFTER_BODY:
      case v.AFTER_AFTER_FRAMESET: {
        uA(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === M.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case v.IN_HEAD:
      case v.IN_HEAD_NO_SCRIPT:
      case v.AFTER_HEAD:
      case v.TEXT:
      case v.IN_COLUMN_GROUP:
      case v.IN_SELECT:
      case v.IN_SELECT_IN_TABLE:
      case v.IN_FRAMESET:
      case v.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case v.IN_BODY:
      case v.IN_CAPTION:
      case v.IN_CELL:
      case v.IN_TEMPLATE:
      case v.AFTER_BODY:
      case v.AFTER_AFTER_BODY:
      case v.AFTER_AFTER_FRAMESET: {
        FC(this, t);
        break;
      }
      case v.IN_TABLE:
      case v.IN_TABLE_BODY:
      case v.IN_ROW: {
        YE(this, t);
        break;
      }
      case v.IN_TABLE_TEXT: {
        VC(this, t);
        break;
      }
    }
  }
}
function Lke(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : zC(e, t), n;
}
function xke(e, t) {
  let n = null, a = e.openElements.stackTop;
  for (; a >= 0; a--) {
    const o = e.openElements.items[a];
    if (o === t.element)
      break;
    e._isSpecialElement(o, e.openElements.tagIDs[a]) && (n = o);
  }
  return n || (e.openElements.shortenToLength(Math.max(a, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function Eke(e, t, n) {
  let a = t, o = e.openElements.getCommonAncestor(t);
  for (let i = 0, c = o; c !== n; i++, c = o) {
    o = e.openElements.getCommonAncestor(c);
    const s = e.activeFormattingElements.getElementEntry(c), l = s && i >= _ke;
    !s || l ? (l && e.activeFormattingElements.removeEntry(s), e.openElements.remove(c)) : (c = vke(e, s), a === t && (e.activeFormattingElements.bookmark = s), e.treeAdapter.detachNode(a), e.treeAdapter.appendChild(c, a), a = c);
  }
  return a;
}
function vke(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), a = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, a), t.element = a, a;
}
function Ake(e, t, n) {
  const a = e.treeAdapter.getTagName(t), o = Ti(a);
  if (e._isElementCausesFosterParenting(o))
    e._fosterParentElement(n);
  else {
    const i = e.treeAdapter.getNamespaceURI(t);
    o === d.TEMPLATE && i === V.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function Ike(e, t, n) {
  const a = e.treeAdapter.getNamespaceURI(n.element), { token: o } = n, i = e.treeAdapter.createElement(o.tagName, a, o.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, o), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i, o.tagID);
}
function dA(e, t) {
  for (let n = 0; n < Mke; n++) {
    const a = Lke(e, t);
    if (!a)
      break;
    const o = xke(e, a);
    if (!o)
      break;
    e.activeFormattingElements.bookmark = a;
    const i = Eke(e, o, a.element), c = e.openElements.getCommonAncestor(a.element);
    e.treeAdapter.detachNode(i), c && Ake(e, c, i), Ike(e, o, a);
  }
}
function Av(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function Tke(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Nke(e, t) {
  e._appendCommentNode(t, e.document);
}
function uA(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let a = e.openElements.stackTop; a >= n; a--)
      e._setEndLocation(e.openElements.items[a], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const a = e.openElements.items[0], o = e.treeAdapter.getNodeSourceCodeLocation(a);
      if (o && !o.endTag && (e._setEndLocation(a, t), e.openElements.stackTop >= 1)) {
        const i = e.openElements.items[1], c = e.treeAdapter.getNodeSourceCodeLocation(i);
        c && !c.endTag && e._setEndLocation(i, t);
      }
    }
  }
}
function Cke(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Wt.QUIRKS : ike(t);
  rke(t) || e._err(t, D.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = v.BEFORE_HTML;
}
function Bi(e, t) {
  e._err(t, D.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, Wt.QUIRKS), e.insertionMode = v.BEFORE_HTML, e._processToken(t);
}
function wke(e, t) {
  t.tagID === d.HTML ? (e._insertElement(t, V.HTML), e.insertionMode = v.BEFORE_HEAD) : Qi(e, t);
}
function Ske(e, t) {
  const n = t.tagID;
  (n === d.HTML || n === d.HEAD || n === d.BODY || n === d.BR) && Qi(e, t);
}
function Qi(e, t) {
  e._insertFakeRootElement(), e.insertionMode = v.BEFORE_HEAD, e._processToken(t);
}
function Rke(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.HEAD: {
      e._insertElement(t, V.HTML), e.headElement = e.openElements.current, e.insertionMode = v.IN_HEAD;
      break;
    }
    default:
      Ji(e, t);
  }
}
function Dke(e, t) {
  const n = t.tagID;
  n === d.HEAD || n === d.BODY || n === d.HTML || n === d.BR ? Ji(e, t) : e._err(t, D.endTagWithoutMatchingOpenElement);
}
function Ji(e, t) {
  e._insertFakeElement(w.HEAD, d.HEAD), e.headElement = e.openElements.current, e.insertionMode = v.IN_HEAD, e._processToken(t);
}
function rn(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META: {
      e._appendElement(t, V.HTML), t.ackSelfClosing = !0;
      break;
    }
    case d.TITLE: {
      e._switchToTextParsing(t, Qe.RCDATA);
      break;
    }
    case d.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, Qe.RAWTEXT) : (e._insertElement(t, V.HTML), e.insertionMode = v.IN_HEAD_NO_SCRIPT);
      break;
    }
    case d.NOFRAMES:
    case d.STYLE: {
      e._switchToTextParsing(t, Qe.RAWTEXT);
      break;
    }
    case d.SCRIPT: {
      e._switchToTextParsing(t, Qe.SCRIPT_DATA);
      break;
    }
    case d.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = v.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(v.IN_TEMPLATE);
      break;
    }
    case d.HEAD: {
      e._err(t, D.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ec(e, t);
  }
}
function Oke(e, t) {
  switch (t.tagID) {
    case d.HEAD: {
      e.openElements.pop(), e.insertionMode = v.AFTER_HEAD;
      break;
    }
    case d.BODY:
    case d.BR:
    case d.HTML: {
      ec(e, t);
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      e._err(t, D.endTagWithoutMatchingOpenElement);
  }
}
function ei(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== d.TEMPLATE && e._err(t, D.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(d.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, D.endTagWithoutMatchingOpenElement);
}
function ec(e, t) {
  e.openElements.pop(), e.insertionMode = v.AFTER_HEAD, e._processToken(t);
}
function Pke(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.BASEFONT:
    case d.BGSOUND:
    case d.HEAD:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.STYLE: {
      rn(e, t);
      break;
    }
    case d.NOSCRIPT: {
      e._err(t, D.nestedNoscriptInHead);
      break;
    }
    default:
      tc(e, t);
  }
}
function Hke(e, t) {
  switch (t.tagID) {
    case d.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = v.IN_HEAD;
      break;
    }
    case d.BR: {
      tc(e, t);
      break;
    }
    default:
      e._err(t, D.endTagWithoutMatchingOpenElement);
  }
}
function tc(e, t) {
  const n = t.type === xe.EOF ? D.openElementsLeftAfterEof : D.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = v.IN_HEAD, e._processToken(t);
}
function Bke(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.BODY: {
      e._insertElement(t, V.HTML), e.framesetOk = !1, e.insertionMode = v.IN_BODY;
      break;
    }
    case d.FRAMESET: {
      e._insertElement(t, V.HTML), e.insertionMode = v.IN_FRAMESET;
      break;
    }
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.SCRIPT:
    case d.STYLE:
    case d.TEMPLATE:
    case d.TITLE: {
      e._err(t, D.abandonedHeadElementChild), e.openElements.push(e.headElement, d.HEAD), rn(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case d.HEAD: {
      e._err(t, D.misplacedStartTagForHeadElement);
      break;
    }
    default:
      nc(e, t);
  }
}
function Fke(e, t) {
  switch (t.tagID) {
    case d.BODY:
    case d.HTML:
    case d.BR: {
      nc(e, t);
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      e._err(t, D.endTagWithoutMatchingOpenElement);
  }
}
function nc(e, t) {
  e._insertFakeElement(w.BODY, d.BODY), e.insertionMode = v.IN_BODY, vE(e, t);
}
function vE(e, t) {
  switch (t.type) {
    case xe.CHARACTER: {
      $C(e, t);
      break;
    }
    case xe.WHITESPACE_CHARACTER: {
      FC(e, t);
      break;
    }
    case xe.COMMENT: {
      Av(e, t);
      break;
    }
    case xe.START_TAG: {
      Mt(e, t);
      break;
    }
    case xe.END_TAG: {
      AE(e, t);
      break;
    }
    case xe.EOF: {
      jC(e, t);
      break;
    }
  }
}
function FC(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function $C(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function $ke(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Uke(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function qke(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_FRAMESET);
}
function zke(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML);
}
function jke(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && vv.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, V.HTML);
}
function Vke(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function Gke(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML), n || (e.formElement = e.openElements.current));
}
function Wke(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let a = e.openElements.stackTop; a >= 0; a--) {
    const o = e.openElements.tagIDs[a];
    if (n === d.LI && o === d.LI || (n === d.DD || n === d.DT) && (o === d.DD || o === d.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(o), e.openElements.popUntilTagNamePopped(o);
      break;
    }
    if (o !== d.ADDRESS && o !== d.DIV && o !== d.P && e._isSpecialElement(e.openElements.items[a], o))
      break;
  }
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML);
}
function Xke(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML), e.tokenizer.state = Qe.PLAINTEXT;
}
function Yke(e, t) {
  e.openElements.hasInScope(d.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML), e.framesetOk = !1;
}
function Kke(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(w.A);
  n && (dA(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Zke(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Qke(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(d.NOBR) && (dA(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, V.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Jke(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function e4e(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Wt.QUIRKS && e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, V.HTML), e.framesetOk = !1, e.insertionMode = v.IN_TABLE;
}
function UC(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, V.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function qC(e) {
  const t = CC(e, V1.TYPE);
  return t != null && t.toLowerCase() === gke;
}
function t4e(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, V.HTML), qC(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function n4e(e, t) {
  e._appendElement(t, V.HTML), t.ackSelfClosing = !0;
}
function a4e(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._appendElement(t, V.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function o4e(e, t) {
  t.tagName = w.IMG, t.tagID = d.IMG, UC(e, t);
}
function r4e(e, t) {
  e._insertElement(t, V.HTML), e.skipNextNewLine = !0, e.tokenizer.state = Qe.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = v.TEXT;
}
function i4e(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, Qe.RAWTEXT);
}
function c4e(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, Qe.RAWTEXT);
}
function lT(e, t) {
  e._switchToTextParsing(t, Qe.RAWTEXT);
}
function s4e(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === v.IN_TABLE || e.insertionMode === v.IN_CAPTION || e.insertionMode === v.IN_TABLE_BODY || e.insertionMode === v.IN_ROW || e.insertionMode === v.IN_CELL ? v.IN_SELECT_IN_TABLE : v.IN_SELECT;
}
function l4e(e, t) {
  e.openElements.currentTagId === d.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML);
}
function d4e(e, t) {
  e.openElements.hasInScope(d.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, V.HTML);
}
function u4e(e, t) {
  e.openElements.hasInScope(d.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(d.RTC), e._insertElement(t, V.HTML);
}
function h4e(e, t) {
  e._reconstructActiveFormattingElements(), PC(t), lA(t), t.selfClosing ? e._appendElement(t, V.MATHML) : e._insertElement(t, V.MATHML), t.ackSelfClosing = !0;
}
function p4e(e, t) {
  e._reconstructActiveFormattingElements(), HC(t), lA(t), t.selfClosing ? e._appendElement(t, V.SVG) : e._insertElement(t, V.SVG), t.ackSelfClosing = !0;
}
function dT(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, V.HTML);
}
function Mt(e, t) {
  switch (t.tagID) {
    case d.I:
    case d.S:
    case d.B:
    case d.U:
    case d.EM:
    case d.TT:
    case d.BIG:
    case d.CODE:
    case d.FONT:
    case d.SMALL:
    case d.STRIKE:
    case d.STRONG: {
      Zke(e, t);
      break;
    }
    case d.A: {
      Kke(e, t);
      break;
    }
    case d.H1:
    case d.H2:
    case d.H3:
    case d.H4:
    case d.H5:
    case d.H6: {
      jke(e, t);
      break;
    }
    case d.P:
    case d.DL:
    case d.OL:
    case d.UL:
    case d.DIV:
    case d.DIR:
    case d.NAV:
    case d.MAIN:
    case d.MENU:
    case d.ASIDE:
    case d.CENTER:
    case d.FIGURE:
    case d.FOOTER:
    case d.HEADER:
    case d.HGROUP:
    case d.DIALOG:
    case d.DETAILS:
    case d.ADDRESS:
    case d.ARTICLE:
    case d.SEARCH:
    case d.SECTION:
    case d.SUMMARY:
    case d.FIELDSET:
    case d.BLOCKQUOTE:
    case d.FIGCAPTION: {
      zke(e, t);
      break;
    }
    case d.LI:
    case d.DD:
    case d.DT: {
      Wke(e, t);
      break;
    }
    case d.BR:
    case d.IMG:
    case d.WBR:
    case d.AREA:
    case d.EMBED:
    case d.KEYGEN: {
      UC(e, t);
      break;
    }
    case d.HR: {
      a4e(e, t);
      break;
    }
    case d.RB:
    case d.RTC: {
      d4e(e, t);
      break;
    }
    case d.RT:
    case d.RP: {
      u4e(e, t);
      break;
    }
    case d.PRE:
    case d.LISTING: {
      Vke(e, t);
      break;
    }
    case d.XMP: {
      i4e(e, t);
      break;
    }
    case d.SVG: {
      p4e(e, t);
      break;
    }
    case d.HTML: {
      $ke(e, t);
      break;
    }
    case d.BASE:
    case d.LINK:
    case d.META:
    case d.STYLE:
    case d.TITLE:
    case d.SCRIPT:
    case d.BGSOUND:
    case d.BASEFONT:
    case d.TEMPLATE: {
      rn(e, t);
      break;
    }
    case d.BODY: {
      Uke(e, t);
      break;
    }
    case d.FORM: {
      Gke(e, t);
      break;
    }
    case d.NOBR: {
      Qke(e, t);
      break;
    }
    case d.MATH: {
      h4e(e, t);
      break;
    }
    case d.TABLE: {
      e4e(e, t);
      break;
    }
    case d.INPUT: {
      t4e(e, t);
      break;
    }
    case d.PARAM:
    case d.TRACK:
    case d.SOURCE: {
      n4e(e, t);
      break;
    }
    case d.IMAGE: {
      o4e(e, t);
      break;
    }
    case d.BUTTON: {
      Yke(e, t);
      break;
    }
    case d.APPLET:
    case d.OBJECT:
    case d.MARQUEE: {
      Jke(e, t);
      break;
    }
    case d.IFRAME: {
      c4e(e, t);
      break;
    }
    case d.SELECT: {
      s4e(e, t);
      break;
    }
    case d.OPTION:
    case d.OPTGROUP: {
      l4e(e, t);
      break;
    }
    case d.NOEMBED:
    case d.NOFRAMES: {
      lT(e, t);
      break;
    }
    case d.FRAMESET: {
      qke(e, t);
      break;
    }
    case d.TEXTAREA: {
      r4e(e, t);
      break;
    }
    case d.NOSCRIPT: {
      e.options.scriptingEnabled ? lT(e, t) : dT(e, t);
      break;
    }
    case d.PLAINTEXT: {
      Xke(e, t);
      break;
    }
    case d.COL:
    case d.TH:
    case d.TD:
    case d.TR:
    case d.HEAD:
    case d.FRAME:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.CAPTION:
    case d.COLGROUP:
      break;
    default:
      dT(e, t);
  }
}
function y4e(e, t) {
  if (e.openElements.hasInScope(d.BODY) && (e.insertionMode = v.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function k4e(e, t) {
  e.openElements.hasInScope(d.BODY) && (e.insertionMode = v.AFTER_BODY, QC(e, t));
}
function f4e(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function m4e(e) {
  const t = e.openElements.tmplCount > 0, { formElement: n } = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(d.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(d.FORM) : n && e.openElements.remove(n));
}
function g4e(e) {
  e.openElements.hasInButtonScope(d.P) || e._insertFakeElement(w.P, d.P), e._closePElement();
}
function M4e(e) {
  e.openElements.hasInListItemScope(d.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(d.LI), e.openElements.popUntilTagNamePopped(d.LI));
}
function _4e(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function b4e(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function L4e(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function x4e(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(w.BR, d.BR), e.openElements.pop(), e.framesetOk = !1;
}
function zC(e, t) {
  const n = t.tagName, a = t.tagID;
  for (let o = e.openElements.stackTop; o > 0; o--) {
    const i = e.openElements.items[o], c = e.openElements.tagIDs[o];
    if (a === c && (a !== d.UNKNOWN || e.treeAdapter.getTagName(i) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(a), e.openElements.stackTop >= o && e.openElements.shortenToLength(o);
      break;
    }
    if (e._isSpecialElement(i, c))
      break;
  }
}
function AE(e, t) {
  switch (t.tagID) {
    case d.A:
    case d.B:
    case d.I:
    case d.S:
    case d.U:
    case d.EM:
    case d.TT:
    case d.BIG:
    case d.CODE:
    case d.FONT:
    case d.NOBR:
    case d.SMALL:
    case d.STRIKE:
    case d.STRONG: {
      dA(e, t);
      break;
    }
    case d.P: {
      g4e(e);
      break;
    }
    case d.DL:
    case d.UL:
    case d.OL:
    case d.DIR:
    case d.DIV:
    case d.NAV:
    case d.PRE:
    case d.MAIN:
    case d.MENU:
    case d.ASIDE:
    case d.BUTTON:
    case d.CENTER:
    case d.FIGURE:
    case d.FOOTER:
    case d.HEADER:
    case d.HGROUP:
    case d.DIALOG:
    case d.ADDRESS:
    case d.ARTICLE:
    case d.DETAILS:
    case d.SEARCH:
    case d.SECTION:
    case d.SUMMARY:
    case d.LISTING:
    case d.FIELDSET:
    case d.BLOCKQUOTE:
    case d.FIGCAPTION: {
      f4e(e, t);
      break;
    }
    case d.LI: {
      M4e(e);
      break;
    }
    case d.DD:
    case d.DT: {
      _4e(e, t);
      break;
    }
    case d.H1:
    case d.H2:
    case d.H3:
    case d.H4:
    case d.H5:
    case d.H6: {
      b4e(e);
      break;
    }
    case d.BR: {
      x4e(e);
      break;
    }
    case d.BODY: {
      y4e(e, t);
      break;
    }
    case d.HTML: {
      k4e(e, t);
      break;
    }
    case d.FORM: {
      m4e(e);
      break;
    }
    case d.APPLET:
    case d.OBJECT:
    case d.MARQUEE: {
      L4e(e, t);
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      zC(e, t);
  }
}
function jC(e, t) {
  e.tmplInsertionModeStack.length > 0 ? ZC(e, t) : uA(e, t);
}
function E4e(e, t) {
  var n;
  t.tagID === d.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function v4e(e, t) {
  e._err(t, D.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function YE(e, t) {
  if (e.openElements.currentTagId !== void 0 && BC.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = v.IN_TABLE_TEXT, t.type) {
      case xe.CHARACTER: {
        GC(e, t);
        break;
      }
      case xe.WHITESPACE_CHARACTER: {
        VC(e, t);
        break;
      }
    }
  else
    bc(e, t);
}
function A4e(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_CAPTION;
}
function I4e(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_COLUMN_GROUP;
}
function T4e(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.COLGROUP, d.COLGROUP), e.insertionMode = v.IN_COLUMN_GROUP, hA(e, t);
}
function N4e(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_TABLE_BODY;
}
function C4e(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.TBODY, d.TBODY), e.insertionMode = v.IN_TABLE_BODY, IE(e, t);
}
function w4e(e, t) {
  e.openElements.hasInTableScope(d.TABLE) && (e.openElements.popUntilTagNamePopped(d.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function S4e(e, t) {
  qC(t) ? e._appendElement(t, V.HTML) : bc(e, t), t.ackSelfClosing = !0;
}
function R4e(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, V.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function Mi(e, t) {
  switch (t.tagID) {
    case d.TD:
    case d.TH:
    case d.TR: {
      C4e(e, t);
      break;
    }
    case d.STYLE:
    case d.SCRIPT:
    case d.TEMPLATE: {
      rn(e, t);
      break;
    }
    case d.COL: {
      T4e(e, t);
      break;
    }
    case d.FORM: {
      R4e(e, t);
      break;
    }
    case d.TABLE: {
      w4e(e, t);
      break;
    }
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      N4e(e, t);
      break;
    }
    case d.INPUT: {
      S4e(e, t);
      break;
    }
    case d.CAPTION: {
      A4e(e, t);
      break;
    }
    case d.COLGROUP: {
      I4e(e, t);
      break;
    }
    default:
      bc(e, t);
  }
}
function uc(e, t) {
  switch (t.tagID) {
    case d.TABLE: {
      e.openElements.hasInTableScope(d.TABLE) && (e.openElements.popUntilTagNamePopped(d.TABLE), e._resetInsertionMode());
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TBODY:
    case d.TD:
    case d.TFOOT:
    case d.TH:
    case d.THEAD:
    case d.TR:
      break;
    default:
      bc(e, t);
  }
}
function bc(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, vE(e, t), e.fosterParentingEnabled = n;
}
function VC(e, t) {
  e.pendingCharacterTokens.push(t);
}
function GC(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Fi(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      bc(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const WC = /* @__PURE__ */ new Set([d.CAPTION, d.COL, d.COLGROUP, d.TBODY, d.TD, d.TFOOT, d.TH, d.THEAD, d.TR]);
function D4e(e, t) {
  const n = t.tagID;
  WC.has(n) ? e.openElements.hasInTableScope(d.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = v.IN_TABLE, Mi(e, t)) : Mt(e, t);
}
function O4e(e, t) {
  const n = t.tagID;
  switch (n) {
    case d.CAPTION:
    case d.TABLE: {
      e.openElements.hasInTableScope(d.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = v.IN_TABLE, n === d.TABLE && uc(e, t));
      break;
    }
    case d.BODY:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TBODY:
    case d.TD:
    case d.TFOOT:
    case d.TH:
    case d.THEAD:
    case d.TR:
      break;
    default:
      AE(e, t);
  }
}
function hA(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.COL: {
      e._appendElement(t, V.HTML), t.ackSelfClosing = !0;
      break;
    }
    case d.TEMPLATE: {
      rn(e, t);
      break;
    }
    default:
      aE(e, t);
  }
}
function P4e(e, t) {
  switch (t.tagID) {
    case d.COLGROUP: {
      e.openElements.currentTagId === d.COLGROUP && (e.openElements.pop(), e.insertionMode = v.IN_TABLE);
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
    case d.COL:
      break;
    default:
      aE(e, t);
  }
}
function aE(e, t) {
  e.openElements.currentTagId === d.COLGROUP && (e.openElements.pop(), e.insertionMode = v.IN_TABLE, e._processToken(t));
}
function IE(e, t) {
  switch (t.tagID) {
    case d.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_ROW;
      break;
    }
    case d.TH:
    case d.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(w.TR, d.TR), e.insertionMode = v.IN_ROW, TE(e, t);
      break;
    }
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE, Mi(e, t));
      break;
    }
    default:
      Mi(e, t);
  }
}
function Iv(e, t) {
  const n = t.tagID;
  switch (t.tagID) {
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE);
      break;
    }
    case d.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE, uc(e, t));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TD:
    case d.TH:
    case d.TR:
      break;
    default:
      uc(e, t);
  }
}
function TE(e, t) {
  switch (t.tagID) {
    case d.TH:
    case d.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, V.HTML), e.insertionMode = v.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.TR: {
      e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE_BODY, IE(e, t));
      break;
    }
    default:
      Mi(e, t);
  }
}
function XC(e, t) {
  switch (t.tagID) {
    case d.TR: {
      e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE_BODY);
      break;
    }
    case d.TABLE: {
      e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE_BODY, Iv(e, t));
      break;
    }
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(d.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = v.IN_TABLE_BODY, Iv(e, t));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TD:
    case d.TH:
      break;
    default:
      uc(e, t);
  }
}
function H4e(e, t) {
  const n = t.tagID;
  WC.has(n) ? (e.openElements.hasInTableScope(d.TD) || e.openElements.hasInTableScope(d.TH)) && (e._closeTableCell(), TE(e, t)) : Mt(e, t);
}
function B4e(e, t) {
  const n = t.tagID;
  switch (n) {
    case d.TD:
    case d.TH: {
      e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = v.IN_ROW);
      break;
    }
    case d.TABLE:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.TR: {
      e.openElements.hasInTableScope(n) && (e._closeTableCell(), XC(e, t));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
      break;
    default:
      AE(e, t);
  }
}
function YC(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.OPTION: {
      e.openElements.currentTagId === d.OPTION && e.openElements.pop(), e._insertElement(t, V.HTML);
      break;
    }
    case d.OPTGROUP: {
      e.openElements.currentTagId === d.OPTION && e.openElements.pop(), e.openElements.currentTagId === d.OPTGROUP && e.openElements.pop(), e._insertElement(t, V.HTML);
      break;
    }
    case d.HR: {
      e.openElements.currentTagId === d.OPTION && e.openElements.pop(), e.openElements.currentTagId === d.OPTGROUP && e.openElements.pop(), e._appendElement(t, V.HTML), t.ackSelfClosing = !0;
      break;
    }
    case d.INPUT:
    case d.KEYGEN:
    case d.TEXTAREA:
    case d.SELECT: {
      e.openElements.hasInSelectScope(d.SELECT) && (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), t.tagID !== d.SELECT && e._processStartTag(t));
      break;
    }
    case d.SCRIPT:
    case d.TEMPLATE: {
      rn(e, t);
      break;
    }
  }
}
function KC(e, t) {
  switch (t.tagID) {
    case d.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === d.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === d.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === d.OPTGROUP && e.openElements.pop();
      break;
    }
    case d.OPTION: {
      e.openElements.currentTagId === d.OPTION && e.openElements.pop();
      break;
    }
    case d.SELECT: {
      e.openElements.hasInSelectScope(d.SELECT) && (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode());
      break;
    }
    case d.TEMPLATE: {
      ei(e, t);
      break;
    }
  }
}
function F4e(e, t) {
  const n = t.tagID;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : YC(e, t);
}
function $4e(e, t) {
  const n = t.tagID;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : KC(e, t);
}
function U4e(e, t) {
  switch (t.tagID) {
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.SCRIPT:
    case d.STYLE:
    case d.TEMPLATE:
    case d.TITLE: {
      rn(e, t);
      break;
    }
    case d.CAPTION:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      e.tmplInsertionModeStack[0] = v.IN_TABLE, e.insertionMode = v.IN_TABLE, Mi(e, t);
      break;
    }
    case d.COL: {
      e.tmplInsertionModeStack[0] = v.IN_COLUMN_GROUP, e.insertionMode = v.IN_COLUMN_GROUP, hA(e, t);
      break;
    }
    case d.TR: {
      e.tmplInsertionModeStack[0] = v.IN_TABLE_BODY, e.insertionMode = v.IN_TABLE_BODY, IE(e, t);
      break;
    }
    case d.TD:
    case d.TH: {
      e.tmplInsertionModeStack[0] = v.IN_ROW, e.insertionMode = v.IN_ROW, TE(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = v.IN_BODY, e.insertionMode = v.IN_BODY, Mt(e, t);
  }
}
function q4e(e, t) {
  t.tagID === d.TEMPLATE && ei(e, t);
}
function ZC(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(d.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : uA(e, t);
}
function z4e(e, t) {
  t.tagID === d.HTML ? Mt(e, t) : oE(e, t);
}
function QC(e, t) {
  var n;
  if (t.tagID === d.HTML) {
    if (e.fragmentContext || (e.insertionMode = v.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === d.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const a = e.openElements.items[1];
      a && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(a)) === null || n === void 0) && n.endTag) && e._setEndLocation(a, t);
    }
  } else
    oE(e, t);
}
function oE(e, t) {
  e.insertionMode = v.IN_BODY, vE(e, t);
}
function j4e(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.FRAMESET: {
      e._insertElement(t, V.HTML);
      break;
    }
    case d.FRAME: {
      e._appendElement(t, V.HTML), t.ackSelfClosing = !0;
      break;
    }
    case d.NOFRAMES: {
      rn(e, t);
      break;
    }
  }
}
function V4e(e, t) {
  t.tagID === d.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== d.FRAMESET && (e.insertionMode = v.AFTER_FRAMESET));
}
function G4e(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.NOFRAMES: {
      rn(e, t);
      break;
    }
  }
}
function W4e(e, t) {
  t.tagID === d.HTML && (e.insertionMode = v.AFTER_AFTER_FRAMESET);
}
function X4e(e, t) {
  t.tagID === d.HTML ? Mt(e, t) : X9(e, t);
}
function X9(e, t) {
  e.insertionMode = v.IN_BODY, vE(e, t);
}
function Y4e(e, t) {
  switch (t.tagID) {
    case d.HTML: {
      Mt(e, t);
      break;
    }
    case d.NOFRAMES: {
      rn(e, t);
      break;
    }
  }
}
function K4e(e, t) {
  t.chars = je, e._insertCharacters(t);
}
function Z4e(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function JC(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== V.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function Q4e(e, t) {
  if (pke(t))
    JC(e), e._startTagOutsideForeignContent(t);
  else {
    const n = e._getAdjustedCurrentElement(), a = e.treeAdapter.getNamespaceURI(n);
    a === V.MATHML ? PC(t) : a === V.SVG && (yke(t), HC(t)), lA(t), t.selfClosing ? e._appendElement(t, a) : e._insertElement(t, a), t.ackSelfClosing = !0;
  }
}
function J4e(e, t) {
  if (t.tagID === d.P || t.tagID === d.BR) {
    JC(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const a = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(a) === V.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const o = e.treeAdapter.getTagName(a);
    if (o.toLowerCase() === t.tagName) {
      t.tagName = o, e.openElements.shortenToLength(n);
      break;
    }
  }
}
w.AREA, w.BASE, w.BASEFONT, w.BGSOUND, w.BR, w.COL, w.EMBED, w.FRAME, w.HR, w.IMG, w.INPUT, w.KEYGEN, w.LINK, w.META, w.PARAM, w.SOURCE, w.TRACK, w.WBR;
const efe = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, tfe = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), uT = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function ew(e, t) {
  const n = ufe(e), a = vC("type", {
    handlers: { root: nfe, element: afe, text: ofe, comment: nw, doctype: rfe, raw: cfe },
    unknown: sfe
  }), o = {
    parser: n ? new sT(uT) : sT.getFragmentParser(void 0, uT),
    handle(s) {
      a(s, o);
    },
    stitches: !1,
    options: t || {}
  };
  a(e, o), Ni(o, bn());
  const i = n ? o.parser.document : o.parser.getFragment(), c = hye(i, {
    // To do: support `space`?
    file: o.options.file
  });
  return o.stitches && rA(c, "comment", function(s, l, u) {
    const h = (
      /** @type {Stitch} */
      /** @type {unknown} */
      s
    );
    if (h.value.stitch && u && l !== void 0) {
      const k = u.children;
      return k[l] = h.value.stitch, l;
    }
  }), c.type === "root" && c.children.length === 1 && c.children[0].type === e.type ? c.children[0] : c;
}
function tw(e, t) {
  let n = -1;
  if (e)
    for (; ++n < e.length; )
      t.handle(e[n]);
}
function nfe(e, t) {
  tw(e.children, t);
}
function afe(e, t) {
  lfe(e, t), tw(e.children, t), dfe(e, t);
}
function ofe(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {
    type: xe.CHARACTER,
    chars: e.value,
    location: Lc(e)
  };
  Ni(t, bn(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function rfe(e, t) {
  const n = {
    type: xe.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: Lc(e)
  };
  Ni(t, bn(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function ife(e, t) {
  t.stitches = !0;
  const n = hfe(e);
  if ("children" in e && "children" in n) {
    const a = (
      /** @type {Root} */
      ew({ type: "root", children: e.children }, t.options)
    );
    n.children = a.children;
  }
  nw({ type: "comment", value: { stitch: n } }, t);
}
function nw(e, t) {
  const n = e.value, a = {
    type: xe.COMMENT,
    data: n,
    location: Lc(e)
  };
  Ni(t, bn(e)), t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken);
}
function cfe(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, aw(t, bn(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(efe, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function sfe(e, t) {
  const n = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(n.type))
    ife(n, t);
  else {
    let a = "";
    throw tfe.has(n.type) && (a = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + a);
  }
}
function Ni(e, t) {
  aw(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = Qe.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function aw(e, t) {
  if (t && t.offset !== void 0) {
    const n = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function lfe(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === Qe.PLAINTEXT) return;
  Ni(t, bn(e));
  const a = t.parser.openElements.current;
  let o = "namespaceURI" in a ? a.namespaceURI : $1.html;
  o === $1.html && n === "svg" && (o = $1.svg);
  const i = mye(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: o === $1.svg ? "svg" : "html" }
  ), c = {
    type: xe.START_TAG,
    tagName: n,
    tagID: Ti(n),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in i ? i.attrs : [],
    location: Lc(e)
  };
  t.parser.currentToken = c, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function dfe(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && vye.includes(n) || t.parser.tokenizer.state === Qe.PLAINTEXT) return;
  Ni(t, bE(e));
  const a = {
    type: xe.END_TAG,
    tagName: n,
    tagID: Ti(n),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: Lc(e)
  };
  t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  n === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === Qe.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === Qe.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === Qe.SCRIPT_DATA) && (t.parser.tokenizer.state = Qe.DATA);
}
function ufe(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function Lc(e) {
  const t = bn(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = bE(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function hfe(e) {
  return "children" in e ? K1({ ...e, children: [] }) : K1(e);
}
function pfe(e) {
  return function(t, n) {
    return (
      /** @type {Root} */
      ew(t, { ...e, file: n })
    );
  };
}
const aa = ["ariaDescribedBy", "ariaLabel", "ariaLabelledBy"], rE = {
  ancestors: {
    tbody: ["table"],
    td: ["table"],
    th: ["table"],
    thead: ["table"],
    tfoot: ["table"],
    tr: ["table"]
  },
  attributes: {
    a: [
      ...aa,
      // Note: these 3 are used by GFM footnotes, they do work on all links.
      "dataFootnoteBackref",
      "dataFootnoteRef",
      ["className", "data-footnote-backref"],
      "href"
    ],
    blockquote: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `code` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    code: [["className", /^language-./]],
    del: ["cite"],
    div: ["itemScope", "itemType"],
    dl: [...aa],
    // Note: this is used by GFM footnotes.
    h2: [["className", "sr-only"]],
    img: [...aa, "longDesc", "src"],
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    input: [
      ["disabled", !0],
      ["type", "checkbox"]
    ],
    ins: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `li` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    li: [["className", "task-list-item"]],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ol: [...aa, ["className", "contains-task-list"]],
    q: ["cite"],
    section: ["dataFootnotes", ["className", "footnotes"]],
    source: ["srcSet"],
    summary: [...aa],
    table: [...aa],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ul: [...aa, ["className", "contains-task-list"]],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "colSpan",
      "color",
      "cols",
      "compact",
      "coords",
      "dateTime",
      "dir",
      // Note: `disabled` is technically allowed on all elements by GH.
      // But it is useless on everything except `input`.
      // Because `input`s are normally not allowed, but we allow them for
      // checkboxes due to tasklists, we allow `disabled` only there.
      "encType",
      "frame",
      "hSpace",
      "headers",
      "height",
      "hrefLang",
      "htmlFor",
      "id",
      "isMap",
      "itemProp",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rev",
      "rowSpan",
      "rows",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "title",
      "useMap",
      "vAlign",
      "value",
      "width"
    ]
  },
  clobber: ["ariaDescribedBy", "ariaLabelledBy", "id", "name"],
  clobberPrefix: "user-content-",
  protocols: {
    cite: ["http", "https"],
    href: ["http", "https", "irc", "ircs", "mailto", "xmpp"],
    longDesc: ["http", "https"],
    src: ["http", "https"]
  },
  required: {
    input: { disabled: !0, type: "checkbox" }
  },
  strip: ["script"],
  tagNames: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "dd",
    "del",
    "details",
    "div",
    "dl",
    "dt",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    "input",
    "ins",
    "kbd",
    "li",
    "ol",
    "p",
    "picture",
    "pre",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "source",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "tt",
    "ul",
    "var"
  ]
}, Vn = {}.hasOwnProperty;
function yfe(e, t) {
  let n = { type: "root", children: [] };
  const a = {
    schema: t ? { ...rE, ...t } : rE,
    stack: []
  }, o = ow(a, e);
  return o && (Array.isArray(o) ? o.length === 1 ? n = o[0] : n.children = o : n = o), n;
}
function ow(e, t) {
  if (t && typeof t == "object") {
    const n = (
      /** @type {Record<string, Readonly<unknown>>} */
      t
    );
    switch (typeof n.type == "string" ? n.type : "") {
      case "comment":
        return kfe(e, n);
      case "doctype":
        return ffe(e, n);
      case "element":
        return mfe(e, n);
      case "root":
        return gfe(e, n);
      case "text":
        return Mfe(e, n);
    }
  }
}
function kfe(e, t) {
  if (e.schema.allowComments) {
    const n = typeof t.value == "string" ? t.value : "", a = n.indexOf("-->"), i = { type: "comment", value: a < 0 ? n : n.slice(0, a) };
    return xc(i, t), i;
  }
}
function ffe(e, t) {
  if (e.schema.allowDoctypes) {
    const n = { type: "doctype" };
    return xc(n, t), n;
  }
}
function mfe(e, t) {
  const n = typeof t.tagName == "string" ? t.tagName : "";
  e.stack.push(n);
  const a = (
    /** @type {Array<ElementContent>} */
    rw(e, t.children)
  ), o = _fe(e, t.properties);
  e.stack.pop();
  let i = !1;
  if (n && n !== "*" && (!e.schema.tagNames || e.schema.tagNames.includes(n)) && (i = !0, e.schema.ancestors && Vn.call(e.schema.ancestors, n))) {
    const s = e.schema.ancestors[n];
    let l = -1;
    for (i = !1; ++l < s.length; )
      e.stack.includes(s[l]) && (i = !0);
  }
  if (!i)
    return e.schema.strip && !e.schema.strip.includes(n) ? a : void 0;
  const c = {
    type: "element",
    tagName: n,
    properties: o,
    children: a
  };
  return xc(c, t), c;
}
function gfe(e, t) {
  const a = { type: "root", children: (
    /** @type {Array<RootContent>} */
    rw(e, t.children)
  ) };
  return xc(a, t), a;
}
function Mfe(e, t) {
  const a = { type: "text", value: typeof t.value == "string" ? t.value : "" };
  return xc(a, t), a;
}
function rw(e, t) {
  const n = [];
  if (Array.isArray(t)) {
    const a = (
      /** @type {Array<Readonly<unknown>>} */
      t
    );
    let o = -1;
    for (; ++o < a.length; ) {
      const i = ow(e, a[o]);
      i && (Array.isArray(i) ? n.push(...i) : n.push(i));
    }
  }
  return n;
}
function _fe(e, t) {
  const n = e.stack[e.stack.length - 1], a = e.schema.attributes, o = e.schema.required, i = a && Vn.call(a, n) ? a[n] : void 0, c = a && Vn.call(a, "*") ? a["*"] : void 0, s = (
    /** @type {Readonly<Record<string, Readonly<unknown>>>} */
    t && typeof t == "object" ? t : {}
  ), l = {};
  let u;
  for (u in s)
    if (Vn.call(s, u)) {
      const h = s[u];
      let k = hT(
        e,
        pT(i, u),
        u,
        h
      );
      k == null && (k = hT(e, pT(c, u), u, h)), k != null && (l[u] = k);
    }
  if (o && Vn.call(o, n)) {
    const h = o[n];
    for (u in h)
      Vn.call(h, u) && !Vn.call(l, u) && (l[u] = h[u]);
  }
  return l;
}
function hT(e, t, n, a) {
  return t ? Array.isArray(a) ? bfe(e, t, n, a) : iw(e, t, n, a) : void 0;
}
function bfe(e, t, n, a) {
  let o = -1;
  const i = [];
  for (; ++o < a.length; ) {
    const c = iw(e, t, n, a[o]);
    (typeof c == "number" || typeof c == "string") && i.push(c);
  }
  return i;
}
function iw(e, t, n, a) {
  if (!(typeof a != "boolean" && typeof a != "number" && typeof a != "string") && Lfe(e, n, a)) {
    if (typeof t == "object" && t.length > 1) {
      let o = !1, i = 0;
      for (; ++i < t.length; ) {
        const c = t[i];
        if (c && typeof c == "object" && "flags" in c) {
          if (c.test(String(a))) {
            o = !0;
            break;
          }
        } else if (c === a) {
          o = !0;
          break;
        }
      }
      if (!o) return;
    }
    return e.schema.clobber && e.schema.clobberPrefix && e.schema.clobber.includes(n) ? e.schema.clobberPrefix + a : a;
  }
}
function Lfe(e, t, n) {
  const a = e.schema.protocols && Vn.call(e.schema.protocols, t) ? e.schema.protocols[t] : void 0;
  if (!a || a.length === 0)
    return !0;
  const o = String(n), i = o.indexOf(":"), c = o.indexOf("?"), s = o.indexOf("#"), l = o.indexOf("/");
  if (i < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  l > -1 && i > l || c > -1 && i > c || s > -1 && i > s)
    return !0;
  let u = -1;
  for (; ++u < a.length; ) {
    const h = a[u];
    if (i === h.length && o.slice(0, h.length) === h)
      return !0;
  }
  return !1;
}
function xc(e, t) {
  const n = YN(
    // @ts-expect-error: looks like a node.
    t
  );
  t.data && (e.data = K1(t.data)), n && (e.position = n);
}
function pT(e, t) {
  let n, a = -1;
  if (e)
    for (; ++a < e.length; ) {
      const o = e[a], i = typeof o == "string" ? o : o[0];
      if (i === t)
        return o;
      i === "data*" && (n = o);
    }
  if (t.length > 4 && t.slice(0, 4).toLowerCase() === "data")
    return n;
}
function xfe(e) {
  return function(t) {
    return (
      /** @type {Root} */
      yfe(t, e)
    );
  };
}
const cw = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "br",
  "hr",
  "span",
  "div",
  "em",
  "strong",
  "del",
  "q",
  "ul",
  "ol",
  "li",
  "blockquote",
  "code",
  "pre"
], Tv = { ...rE.attributes }, Efe = {
  ...rE,
  tagNames: cw,
  attributes: Tv
}, vfe = ({ tagNames: e = [], attributes: t = {} }) => {
  const n = { ...Tv };
  for (const [a, o] of Object.entries(t))
    n[a] = [...Tv[a] ?? [], ...o];
  return {
    ...Efe,
    // De-duplicated: a caller re-declaring a base tag should not appear twice.
    tagNames: [.../* @__PURE__ */ new Set([...cw, ...e])],
    attributes: n
  };
}, Afe = vfe({
  tagNames: ["quote"],
  attributes: {
    span: [["className", "italic", "text-warning"]]
  }
}), Ife = [pfe, [xfe, Afe]], Tfe = RegExp(/<\/?[a-z][\s\S]*>/i), Nfe = (e) => e.replace(/^[ \t]+/gm, "").replaceAll(/\n/g, `  
`).replaceAll(/\\n/gi, `  
`), Cfe = (e) => Tfe.test(e) ? e.replace(/<[^>]*>/g, "") : e, wfe = (e) => (e = Cfe(e.trim()), e = Fw(e), e = Hw(e, '<span className="italic text-warning">', "</span>"), e = Nfe(e), e), Sfe = ({ children: e }) => /* @__PURE__ */ p("em", { className: "italic leading-6 text-colorAction", children: e }), Rfe = ({ children: e }) => /* @__PURE__ */ p("span", { className: "block my-[8px] leading-6", children: e }), Dfe = ({ children: e }) => /* @__PURE__ */ p("q", { className: "text-colorQuote", children: e }), Ofe = ({ children: e }) => /* @__PURE__ */ p("blockquote", { className: "bg-colorHighlight max-w-max px-1 rounded-md text-black", children: e }), Pfe = {
  em: Sfe,
  p: Rfe,
  blockquote: Dfe,
  code: Ofe
}, Hfe = ({ children: e }) => e ? /* @__PURE__ */ p(Zpe, { rehypePlugins: Ife, components: Pfe, children: wfe(e) }) : null, Bfe = {
  deleted: R.TRASH,
  expired: R.CLOCK,
  banned: R.BAN,
  notFound: R.IMAGE_OFF
}, Ffe = {
  [me.SMALL]: {
    container: "min-h-40 gap-3 p-3",
    icon: "size-8",
    titleVariant: x.LABEL_SMALL_BOLD,
    descriptionVariant: x.LABEL_SMALL_REGULAR
  },
  [me.LARGE]: {
    container: "gap-4 p-8",
    icon: "size-16",
    titleVariant: x.LABEL_LARGE_BOLD,
    descriptionVariant: x.PARAGRAPH_SMALL_REGULAR
  }
}, $fe = ({
  placeholder: e,
  size: t = me.LARGE,
  className: n,
  "data-testid": a = "MediaFileUnavailable"
}) => {
  const o = Ffe[t], i = Bfe[e.kind], c = t === me.SMALL;
  return /* @__PURE__ */ C("div", { "data-testid": a, className: P("flex h-full w-full flex-col items-center justify-center bg-gray-3", o.container, n), children: [
    /* @__PURE__ */ p("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-gray-10", children: /* @__PURE__ */ p(oe, { icon: i, className: o.icon }) }),
    /* @__PURE__ */ C("div", { className: "flex w-full min-w-0 max-w-xs shrink-0 flex-col gap-2", children: [
      /* @__PURE__ */ p(
        q,
        {
          "data-testid": `${a}-Title`,
          variant: o.titleVariant,
          centered: !0,
          className: P("m-0 text-pretty break-words text-gray-12", c && "h-8 shrink-0 line-clamp-2"),
          children: e.title
        }
      ),
      c || e.description ? /* @__PURE__ */ p(
        q,
        {
          "data-testid": `${a}-Description`,
          variant: o.descriptionVariant,
          centered: !0,
          className: P("m-0 max-w-full whitespace-pre-line text-pretty break-words text-gray-11", c && "h-12 shrink-0 line-clamp-3"),
          children: e.description
        }
      ) : null
    ] })
  ] });
}, yT = "flex h-[38px] min-w-0 flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-default border border-solid border-gray-6 bg-gray-3 px-2 text-[13px] font-semibold text-gray-12 transition hover:bg-gray-4 disabled:cursor-default disabled:text-gray-9 disabled:hover:bg-gray-3 dark:text-white dark:disabled:text-gray-9";
function Ufe({ navigation: e, "data-testid": t = "MediaFileDetails" }) {
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-2.5 border-t border-gray-6 px-5 pt-2.5 lg:hidden", "data-testid": `${t}-MobileNavigation`, children: [
    /* @__PURE__ */ C(
      "button",
      {
        type: "button",
        onClick: e.onPrevious,
        disabled: !e.hasPrevious,
        className: yT,
        "data-testid": `${t}-MobilePreviousButton`,
        children: [
          /* @__PURE__ */ p(oe, { icon: R.CHEVRON_LEFT, size: ye.SMALL }),
          /* @__PURE__ */ p("span", { className: "truncate", children: e.previousLabel })
        ]
      }
    ),
    e.positionLabel ? /* @__PURE__ */ p("span", { className: "shrink-0 text-[13px] font-semibold text-gray-12 dark:text-white", "data-testid": `${t}-MobilePosition`, children: e.positionLabel }) : null,
    /* @__PURE__ */ C(
      "button",
      {
        type: "button",
        onClick: e.onNext,
        disabled: !e.hasNext,
        className: yT,
        "data-testid": `${t}-MobileNextButton`,
        children: [
          /* @__PURE__ */ p("span", { className: "truncate", children: e.nextLabel }),
          /* @__PURE__ */ p(oe, { icon: R.CHEVRON_RIGHT, size: ye.SMALL })
        ]
      }
    )
  ] });
}
const qfe = mt(Ufe), kT = "absolute z-10 hidden size-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white transition hover:bg-black/70 disabled:pointer-events-none disabled:opacity-0 lg:flex", zfe = "absolute left-1/2 z-10 hidden -translate-x-1/2 rounded-full bg-black/60 px-3 py-1 text-white lg:block", jfe = "absolute z-10 flex size-12 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white transition hover:bg-black/70 lg:hidden";
function Vfe({ navigation: e, onClose: t, closeLabel: n, styles: a, testId: o }) {
  return /* @__PURE__ */ C(at, { children: [
    e ? /* @__PURE__ */ C(at, { children: [
      /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          onClick: e.onPrevious,
          disabled: !e.hasPrevious,
          "aria-label": e.previousLabel,
          className: kT,
          style: a.previous,
          "data-testid": `${o}-PreviousButton`,
          children: /* @__PURE__ */ p(oe, { icon: R.CHEVRON_LEFT, size: ye.MEDIUM })
        }
      ),
      /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          onClick: e.onNext,
          disabled: !e.hasNext,
          "aria-label": e.nextLabel,
          className: kT,
          style: a.next,
          "data-testid": `${o}-NextButton`,
          children: /* @__PURE__ */ p(oe, { icon: R.CHEVRON_RIGHT, size: ye.MEDIUM })
        }
      ),
      e.positionLabel ? /* @__PURE__ */ p("span", { className: zfe, style: a.position, "data-testid": `${o}-Position`, children: e.positionLabel }) : null
    ] }) : null,
    t ? /* @__PURE__ */ p(
      "button",
      {
        type: "button",
        onClick: t,
        "aria-label": n,
        className: jfe,
        style: a.close,
        "data-testid": `${o}-CloseButton`,
        children: /* @__PURE__ */ p(oe, { icon: R.CLOSE, size: ye.MEDIUM })
      }
    ) : null
  ] });
}
const Gfe = mt(Vfe), fT = { x: 0, bottom: 0, height: 0 };
function Wfe(e, t, n) {
  const [a, o] = ae(fT), i = Q(() => {
    const c = e.current, s = t.current;
    if (!c || !s || s.naturalWidth === 0 || s.naturalHeight === 0) {
      o(fT);
      return;
    }
    const l = Math.min(c.clientWidth / s.naturalWidth, c.clientHeight / s.naturalHeight), u = s.naturalWidth * l, h = s.naturalHeight * l;
    o({
      x: Math.max(0, (c.clientWidth - u) / 2),
      bottom: Math.max(0, c.clientHeight - h),
      height: h
    });
  }, [e, t]);
  return le(() => {
    i();
    const c = e.current;
    if (!c || typeof ResizeObserver > "u")
      return;
    const s = new ResizeObserver(i);
    return s.observe(c), () => s.disconnect();
  }, [i, e, n]), { box: a, measure: i };
}
const Xfe = 24, mT = 16, gT = "h-full w-full overflow-hidden lg:rounded-l-xl", Yfe = "h-full w-full touch-pan-y select-none object-contain object-top";
function Kfe({
  imageUrl: e,
  imageAlt: t,
  isNsfw: n,
  navigation: a,
  onClose: o,
  closeLabel: i,
  "data-testid": c = "MediaFilePreview"
}) {
  const s = fe(null), l = fe(null), { box: u, measure: h } = Wfe(s, l, e), [k, f] = ae("loading");
  Sn(() => {
    const I = l.current;
    if (!(I != null && I.complete)) {
      f("loading");
      return;
    }
    f(I.naturalWidth > 0 ? "loaded" : "failed");
  }, [e]);
  const y = Q(() => {
    f("loaded"), h();
  }, [h]), m = Q(() => f("failed"), []), g = !!e && k !== "failed", _ = g && n, L = Ve(
    () => _ ? { filter: `blur(${Xfe}px)`, transform: "scale(1.08)" } : void 0,
    [_]
  ), N = Ve(() => {
    const I = u.x + mT, S = u.bottom + mT, O = u.height > 0 ? u.height / 2 : "50%";
    return {
      previous: { left: I, top: O },
      next: { right: I, top: O },
      position: { bottom: S },
      close: { right: I, bottom: S }
    };
  }, [u]);
  return /* @__PURE__ */ C(
    "div",
    {
      ref: s,
      className: g ? `relative ${gT}` : `relative flex items-center justify-center bg-gray-5 ${gT}`,
      "data-testid": c,
      children: [
        g ? /* @__PURE__ */ p(
          "img",
          {
            ref: l,
            src: e ?? void 0,
            alt: t,
            draggable: !1,
            decoding: "async",
            onLoad: y,
            onError: m,
            className: Yfe,
            style: L,
            "data-testid": `${c}-Image`
          },
          e
        ) : /* @__PURE__ */ p(oe, { icon: R.IMAGE_OFF, size: ye.LARGE, className: "text-gray-10" }),
        g && k === "loading" ? /* @__PURE__ */ p("div", { className: "absolute inset-0 flex items-center justify-center bg-gray-5", "data-testid": `${c}-Loading`, children: /* @__PURE__ */ p(Rn, { size: Ue.LARGE }) }) : null,
        /* @__PURE__ */ p(Gfe, { navigation: a, onClose: o, closeLabel: i, styles: N, testId: c })
      ]
    }
  );
}
const Zfe = mt(Kfe), Qfe = "flex w-full items-center gap-3 bg-transparent px-4 py-3 text-left text-gray-12 dark:text-white disabled:cursor-not-allowed disabled:opacity-40 [@media(hover:hover)]:enabled:hover:bg-gray-5", Jfe = "text-red-9";
function e3e({
  labels: e,
  isKept: t,
  onCopyLink: n,
  onDownload: a,
  onKeep: o,
  onDelete: i,
  actionsAllowed: c
}) {
  const {
    isKeepAllowed: s = !0,
    isMakePublicAllowed: l = !0,
    isAddToFolderAllowed: u = !0,
    isReportAllowed: h = !0,
    isDeleteAllowed: k = !0
  } = c ?? {};
  return [
    {
      key: "keep",
      icon: t ? R.BOOKMARK_CHECK : R.BOOKMARK,
      label: t ? e.unkeepLabel : e.keepAriaLabel,
      onSelect: o,
      isAllowed: s
    },
    { key: "makePrivate", icon: R.LOCK, label: e.makePrivateLabel, isAllowed: l },
    { key: "copyLink", icon: R.LINK_CHAIN, label: e.copyLink, onSelect: n },
    { key: "download", icon: R.DOWNLOAD, label: e.downloadAriaLabel, onSelect: a },
    { key: "addToFolder", icon: R.FOLDER, label: e.addToFolderLabel, isAllowed: u },
    { key: "report", icon: R.FLAG, label: e.reportLabel, isAllowed: h },
    { key: "delete", icon: R.TRASH, label: e.deleteLabel, onSelect: i, destructive: !0, isAllowed: k }
  ];
}
function t3e({ action: e, testId: t, onClose: n }) {
  const a = e.destructive ? Jfe : void 0, o = Q(() => {
    var i;
    (i = e.onSelect) == null || i.call(e), n();
  }, [e, n]);
  return /* @__PURE__ */ p("li", { children: /* @__PURE__ */ C("button", { type: "button", disabled: !e.onSelect, onClick: o, className: Qfe, "data-testid": `${t}-${e.key}`, children: [
    /* @__PURE__ */ p(oe, { icon: e.icon, size: ye.MEDIUM, className: a }),
    /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_MEDIUM_REGULAR, className: a, children: e.label })
  ] }) });
}
function n3e({
  labels: e,
  isOpen: t,
  onOpenChange: n,
  isKept: a,
  onCopyLink: o,
  onDownload: i,
  onKeep: c,
  onDelete: s,
  actionsAllowed: l,
  "data-testid": u = "MediaFileDetailsActionsSheet"
}) {
  const h = e3e({ labels: e, isKept: a, onCopyLink: o, onDownload: i, onKeep: c, onDelete: s, actionsAllowed: l }).filter((f) => f.isAllowed !== !1).filter((f) => f.key !== "download" || !!i), k = Q(() => n(!1), [n]);
  return (
    // The panel stays mounted while closed, parked a panel-height below its containing block. In the details
    // modal that block is the modal itself, and on desktop the modal stops short of the viewport, so the parked
    // panel would peek out under it. The sheet is a below-md surface, so at md and up it has no box at all.
    /* @__PURE__ */ p(mE, { open: t, onOpenChange: n, position: tt.BOTTOM, classNames: { drawer: "md:hidden" }, "data-testid": u, children: /* @__PURE__ */ p("ul", { className: "flex flex-col py-2", children: h.map((f) => /* @__PURE__ */ p(t3e, { action: f, testId: u, onClose: k }, f.key)) }) })
  );
}
const Nv = {
  icon: "hidden shrink-0 min-[375px]:block max-md:size-4",
  text: "min-w-0 whitespace-normal text-center [overflow-wrap:anywhere] max-md:text-[13px] max-md:leading-tight md:truncate"
}, Z1 = { ...Nv, text: `${Nv.text} md:sr-only` }, a3e = { ...Z1, spinner: Z1.icon }, o3e = {
  icon: `${Z1.icon} text-green-10`,
  text: `${Z1.text} text-green-10`
}, hc = "h-auto min-h-[38px] min-w-0 max-w-full flex-1 basis-0 gap-1 border border-solid border-gray-6 bg-gray-3 px-1 py-1 hover:bg-gray-4 disabled:border-solid disabled:border-gray-6 disabled:bg-gray-3 md:h-[38px] md:min-h-0 md:w-11 md:flex-none md:basis-auto md:px-0 md:py-0 text-gray-12 dark:text-white", r3e = `${hc} border-green-6 bg-green-3 hover:bg-green-4 disabled:border-green-6 disabled:bg-green-3`, i3e = `${hc} opacity-70`;
function c3e({ labels: e, onDownload: t, isDownloading: n, downloadFallbackUrl: a, onOpenDownloadFallback: o }) {
  const i = Q(
    (c) => {
      c.button === 1 && (o == null || o());
    },
    [o]
  );
  return a ? /* @__PURE__ */ p(
    nt,
    {
      as: "a",
      href: a,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: o,
      onAuxClick: i,
      iconStart: R.MOVE_UP_RIGHT,
      variant: J.SECONDARY,
      size: _e.MEDIUM,
      shape: we.SQUARE,
      "aria-label": e.openOriginal,
      className: hc,
      classNames: Z1,
      "data-testid": "MediaFileDetails-OpenOriginal",
      children: e.openOriginal
    }
  ) : !t && !n ? null : /* @__PURE__ */ p(
    nt,
    {
      iconStart: n ? void 0 : R.DOWNLOAD,
      variant: J.SECONDARY,
      size: _e.MEDIUM,
      shape: we.SQUARE,
      "aria-label": e.downloadAriaLabel,
      className: n ? i3e : hc,
      classNames: n ? a3e : Z1,
      loading: n,
      spinnerVariant: W1.PRIMARY,
      "aria-busy": n,
      disabled: !t,
      onClick: t,
      "data-testid": "MediaFileDetails-Download",
      children: e.downloadAriaLabel
    }
  );
}
const MT = "h-auto min-h-[38px] w-[46px] shrink-0 border border-solid border-gray-6 bg-gray-3 hover:bg-gray-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 disabled:border-solid disabled:border-gray-6 disabled:bg-gray-3 text-gray-12 dark:text-white";
function s3e({
  labels: e,
  testId: t,
  isKept: n,
  onCopyLink: a,
  onDownload: o,
  onKeep: i,
  onDelete: c,
  actionsAllowed: s
}) {
  const {
    isKeepAllowed: l = !0,
    isMakePublicAllowed: u = !0,
    isAddToFolderAllowed: h = !0,
    isReportAllowed: k = !0,
    isDeleteAllowed: f = !0
  } = s ?? {};
  return [
    {
      label: n ? e.unkeepLabel : e.keepAriaLabel,
      icon: n ? R.BOOKMARK_CHECK : R.BOOKMARK,
      onPress: i,
      isDisabled: !i,
      isHidden: !l,
      dataTestId: `${t}-MoreMenu-keep`
    },
    {
      label: e.makePrivateLabel,
      icon: R.LOCK,
      isDisabled: !0,
      isHidden: !u,
      dataTestId: `${t}-MoreMenu-makePrivate`
    },
    {
      label: e.copyLink,
      icon: R.LINK_CHAIN,
      onPress: a,
      isDisabled: !a,
      dataTestId: `${t}-MoreMenu-copyLink`
    },
    {
      label: e.downloadAriaLabel,
      icon: R.DOWNLOAD,
      onPress: o,
      isHidden: !o,
      dataTestId: `${t}-MoreMenu-download`
    },
    {
      label: e.addToFolderLabel,
      icon: R.FOLDER,
      isDisabled: !0,
      isHidden: !h,
      dataTestId: `${t}-MoreMenu-addToFolder`
    },
    { label: e.reportLabel, icon: R.FLAG, isDisabled: !0, isHidden: !k, dataTestId: `${t}-MoreMenu-report` },
    {
      label: e.deleteLabel,
      icon: R.TRASH,
      onPress: c,
      isDisabled: !c,
      isHidden: !f,
      dataTestId: `${t}-MoreMenu-delete`
    }
  ];
}
function l3e({
  labels: e,
  isKept: t,
  onCopyLink: n,
  onDownload: a,
  isDownloading: o = !1,
  downloadFallbackUrl: i,
  onOpenDownloadFallback: c,
  onKeep: s,
  onDelete: l,
  actionsAllowed: u,
  "data-testid": h = "MediaFileDetailsActions"
}) {
  const [k, f] = ae(!1), y = Q(() => f(!0), []), m = (u == null ? void 0 : u.isKeepAllowed) !== !1;
  return /* @__PURE__ */ C("div", { className: "flex items-stretch gap-2 md:items-center", "data-testid": h, children: [
    /* @__PURE__ */ p(
      nt,
      {
        variant: J.SECONDARY,
        size: _e.MEDIUM,
        shape: we.SQUARE,
        iconStart: R.LINK_CHAIN,
        className: "h-auto min-h-[38px] min-w-0 max-w-full flex-1 basis-0 gap-1 border border-solid border-gray-6 bg-gray-3 px-1 py-1 hover:bg-gray-4 disabled:border-solid disabled:border-gray-6 disabled:bg-gray-3 md:h-[38px] md:min-h-0 md:basis-auto md:gap-2 md:px-2 md:py-0 text-gray-12 dark:text-white",
        classNames: Nv,
        disabled: !n,
        onClick: n,
        "data-testid": "MediaFileDetails-CopyLink",
        children: e.copyLink
      }
    ),
    /* @__PURE__ */ C("div", { className: "contents md:flex md:flex-none md:items-center md:gap-2", "data-testid": "MediaFileDetails-SecondaryActions", children: [
      /* @__PURE__ */ p(
        c3e,
        {
          labels: e,
          onDownload: a,
          isDownloading: o,
          downloadFallbackUrl: i,
          onOpenDownloadFallback: c
        }
      ),
      m ? /* @__PURE__ */ p(
        nt,
        {
          iconStart: t ? R.BOOKMARK_CHECK : R.BOOKMARK,
          variant: J.SECONDARY,
          size: _e.MEDIUM,
          shape: we.SQUARE,
          "aria-label": t ? e.keptLabel : e.keepAriaLabel,
          "aria-pressed": t,
          className: t ? r3e : hc,
          classNames: t ? o3e : Z1,
          disabled: !s,
          onClick: s,
          "data-testid": "MediaFileDetails-Keep",
          children: t ? e.keptLabel : e.keepAriaLabel
        }
      ) : null,
      /* @__PURE__ */ p(
        wt,
        {
          icon: R.MORE_VERTICAL,
          variant: J.SECONDARY,
          size: _e.MEDIUM,
          shape: we.SQUARE,
          "aria-label": e.moreAriaLabel,
          className: `flex md:hidden ${MT}`,
          onClick: y,
          "data-testid": `${h}-MoreMobile`
        }
      ),
      /* @__PURE__ */ p("div", { className: "hidden md:block", children: /* @__PURE__ */ p(
        lE,
        {
          listItems: s3e({ labels: e, testId: h, isKept: t, onCopyLink: n, onDownload: a, onKeep: s, onDelete: l, actionsAllowed: u }),
          isPortaled: !0,
          children: /* @__PURE__ */ p(
            wt,
            {
              icon: R.MORE_VERTICAL,
              variant: J.SECONDARY,
              size: _e.MEDIUM,
              shape: we.SQUARE,
              "aria-label": e.moreAriaLabel,
              className: MT,
              "data-testid": "MediaFileDetails-More"
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ p(
      n3e,
      {
        labels: e,
        isOpen: k,
        onOpenChange: f,
        isKept: t,
        onCopyLink: n,
        onDownload: a,
        onKeep: s,
        onDelete: l,
        actionsAllowed: u,
        "data-testid": `${h}-Sheet`
      }
    )
  ] });
}
const d3e = mt(l3e), u3e = { text: "!text-gray-10", iconStart: "!text-gray-10" }, h3e = { text: "!text-pink-600", iconStart: "!text-pink-600" }, p3e = { alt: "", draggable: !1 }, y3e = mt(function({
  usedAsCategories: t,
  isNsfw: n = !1,
  labels: a,
  "data-testid": o = "MediaFileCategoryChips"
}) {
  const i = t.map((c) => /* @__PURE__ */ p(
    Vt,
    {
      iconStart: c.icon ?? R.USER,
      size: dt.SMALL,
      shape: we.PILL,
      variant: Ze.DEFAULT,
      className: "cursor-default !bg-transparent px-0",
      classNames: u3e,
      children: c.label
    },
    c.id
  ));
  return /* @__PURE__ */ C("div", { className: "flex flex-wrap items-center gap-3", "data-testid": o, children: [
    i,
    n ? /* @__PURE__ */ p(
      Vt,
      {
        iconStart: R.FLAME,
        size: dt.SMALL,
        shape: we.PILL,
        variant: Ze.DEFAULT,
        className: "cursor-default !bg-transparent px-0",
        classNames: h3e,
        "data-testid": "MediaFileDetails-NsfwChip",
        children: a.nsfw
      }
    ) : null
  ] });
}), sw = mt(function({
  connection: t,
  label: n,
  openCharacterAriaLabel: a,
  onOpenConnection: o,
  onActivateConnection: i,
  "data-testid": c = "MediaFileDetails-OpenCharacter"
}) {
  const s = Q(
    (u) => {
      u.defaultPrevented || (i == null || i(t.id), !(!o || u.metaKey || u.ctrlKey || u.shiftKey || u.altKey || u.button !== 0) && (u.preventDefault(), o(t.id)));
    },
    [t.id, i, o]
  ), l = Q(
    (u) => {
      u.button === 1 && !u.defaultPrevented && (i == null || i(t.id));
    },
    [t.id, i]
  );
  return /* @__PURE__ */ C(
    "a",
    {
      href: t.href,
      "aria-label": `${a}: ${t.name}`,
      onClick: s,
      onAuxClick: l,
      className: "flex items-center gap-3 rounded-2xl bg-gray-3 p-3 text-inherit no-underline transition-colors hover:bg-gray-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-10",
      "data-testid": c,
      children: [
        /* @__PURE__ */ p(
          bi,
          {
            src: t.imageUrl,
            name: t.name,
            icon: R.USER,
            size: Xt.MEDIUM,
            shape: G1.ROUNDED,
            imageProps: p3e,
            className: "h-10 w-10 shrink-0 !rounded-full"
          }
        ),
        /* @__PURE__ */ C("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-10", children: n }),
          /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_BOLD, className: "truncate text-gray-12 dark:text-white", children: t.name })
        ] }),
        /* @__PURE__ */ p(oe, { icon: R.EXTERNAL_LINK, size: ye.SMALL, className: "shrink-0 text-gray-10", "aria-hidden": "true" })
      ]
    }
  );
}), k3e = mt(function({
  connections: t,
  labels: n,
  onOpenConnection: a,
  onActivateConnection: o,
  "data-testid": i = "MediaFileConnectionsCards"
}) {
  if (t.length === 0)
    return null;
  const c = t.map((s) => /* @__PURE__ */ p(
    sw,
    {
      connection: s,
      label: n.avatarOf,
      openCharacterAriaLabel: n.openCharacterAriaLabel,
      onOpenConnection: a,
      onActivateConnection: o
    },
    s.id
  ));
  return /* @__PURE__ */ p("div", { className: "flex flex-col gap-3", "data-testid": i, children: c });
}), f3e = mt(function({
  isPublic: t,
  labels: n,
  "data-testid": a = "MediaFileDetails-VisibilityCallout"
}) {
  return t ? /* @__PURE__ */ C("div", { className: "flex items-center gap-3 rounded-xl border border-solid border-yellow-6/50 bg-yellow-2/50 px-3 py-3", "data-testid": a, children: [
    /* @__PURE__ */ p(oe, { icon: R.GLOBE, size: ye.SMALL, className: "shrink-0 text-yellow-9" }),
    /* @__PURE__ */ C("div", { className: "min-w-0", children: [
      /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_BOLD, className: "text-gray-12 dark:text-white", children: n.visibilityPublic }),
      /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-10", children: n.visibilityPublicDescription })
    ] })
  ] }) : null;
});
function m3e({ icon: e, label: t, value: n, "data-testid": a = "MediaFileMetadataRow" }) {
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-3 py-2", "data-testid": a, children: [
    /* @__PURE__ */ p(oe, { icon: e, size: ye.SMALL, className: "shrink-0 text-gray-10" }),
    /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: "flex-1 text-gray-10", children: t }),
    /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, className: "text-right text-gray-12 dark:text-white", children: n })
  ] });
}
const g3e = mt(m3e);
function M3e({
  content: e,
  labels: t,
  onCopyLink: n,
  onDownload: a,
  isDownloading: o,
  downloadFallbackUrl: i,
  onOpenDownloadFallback: c,
  onKeep: s,
  onDelete: l,
  actionsAllowed: u,
  onOpenConnection: h,
  onActivateConnection: k,
  hasTopDivider: f = !0,
  "data-testid": y = "MediaFileDetailsSidebar"
}) {
  const m = e.metadataRows.map((g) => /* @__PURE__ */ p(g3e, { icon: g.icon, label: g.label, value: g.value }, g.id));
  return /* @__PURE__ */ C(
    "aside",
    {
      className: P(
        "flex min-h-0 w-full shrink-0 flex-col gap-5 border-t border-gray-6 bg-background p-5 lg:h-full lg:w-[350px] lg:max-w-[350px] lg:overflow-y-auto lg:overscroll-contain lg:border-l lg:border-t-0",
        !f && "max-lg:border-t-0"
      ),
      "data-testid": y,
      children: [
        /* @__PURE__ */ p(
          q,
          {
            as: "h2",
            variant: x.LABEL_LARGE_BOLD,
            className: "hidden text-gray-12 dark:text-white lg:block",
            "data-testid": "MediaFileDetails-Heading",
            children: t.title
          }
        ),
        /* @__PURE__ */ p(
          d3e,
          {
            labels: t,
            isKept: e.isKept,
            onCopyLink: n,
            onDownload: a,
            isDownloading: o,
            downloadFallbackUrl: i,
            onOpenDownloadFallback: c,
            onKeep: s,
            onDelete: l,
            actionsAllowed: u
          }
        ),
        /* @__PURE__ */ p(y3e, { usedAsCategories: e.usedAsCategories, isNsfw: e.isNsfw, labels: t }),
        e.primaryCharacter ? /* @__PURE__ */ p(
          sw,
          {
            connection: e.primaryCharacter,
            label: e.primaryCharacter.label,
            openCharacterAriaLabel: t.openCharacterAriaLabel,
            onOpenConnection: h,
            onActivateConnection: k,
            "data-testid": "MediaFileDetails-OpenPrimaryCharacter"
          }
        ) : null,
        /* @__PURE__ */ p(
          k3e,
          {
            connections: e.connections,
            labels: t,
            onOpenConnection: h,
            onActivateConnection: k
          }
        ),
        /* @__PURE__ */ p(f3e, { isPublic: e.isPublic, labels: t }),
        e.prompt ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", "data-testid": "MediaFileDetails-Prompt", children: [
          /* @__PURE__ */ p(q, { variant: x.LABEL_XSMALL_MEDIUM, className: "uppercase text-gray-10", children: t.promptLabel }),
          /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-12 dark:text-white", children: e.prompt })
        ] }) : null,
        /* @__PURE__ */ p("div", { className: "flex flex-col divide-y divide-gray-6 border-t border-gray-6", "data-testid": "MediaFileDetails-MetadataList", children: m })
      ]
    }
  );
}
const _3e = mt(M3e), b3e = "absolute right-4 top-4 z-10 flex size-12 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white transition hover:bg-black/70 lg:hidden";
function KE({ onClose: e, closeLabel: t, testId: n }) {
  return e ? /* @__PURE__ */ p("button", { type: "button", onClick: e, "aria-label": t, className: b3e, "data-testid": `${n}-CloseButton`, children: /* @__PURE__ */ p(oe, { icon: R.CLOSE, size: ye.MEDIUM }) }) : null;
}
function L3e({
  status: e,
  labels: t,
  content: n,
  placeholder: a,
  onCopyLink: o,
  onDownload: i,
  isDownloading: c,
  downloadFallbackUrl: s,
  onOpenDownloadFallback: l,
  onKeep: u,
  onDelete: h,
  actionsAllowed: k,
  onRetry: f,
  onOpenConnection: y,
  onActivateConnection: m,
  navigation: g,
  onClose: _,
  closeLabel: L,
  placeholderClassName: N,
  "data-testid": I = "MediaFileDetails"
}) {
  if (e === "loading")
    return /* @__PURE__ */ C("div", { className: P("relative flex min-h-[50vh] w-full items-center justify-center bg-background", N), "data-testid": I, children: [
      /* @__PURE__ */ p(Rn, { size: Ue.LARGE }),
      /* @__PURE__ */ p(KE, { onClose: _, closeLabel: L, testId: I })
    ] });
  if (e === "error")
    return /* @__PURE__ */ C(
      "div",
      {
        className: P("relative flex min-h-[50vh] w-full flex-col items-center justify-center gap-4 bg-background px-4", N),
        "data-testid": I,
        children: [
          /* @__PURE__ */ p(q, { variant: x.HEADING_SMALL_BOLD, className: "text-gray-12 dark:text-white", children: t.loadFailed }),
          /* @__PURE__ */ p(nt, { variant: J.CONTAINED, size: _e.MEDIUM, onClick: f, "data-testid": "MediaFileDetails-RetryButton", children: t.retry }),
          /* @__PURE__ */ p(KE, { onClose: _, closeLabel: L, testId: I })
        ]
      }
    );
  if (e === "unavailable" || e === "not-found" || !n) {
    const S = a ?? {
      kind: "notFound",
      title: t.notFound,
      description: ""
    };
    return /* @__PURE__ */ C("div", { className: P("relative w-full", N), children: [
      /* @__PURE__ */ p(
        $fe,
        {
          placeholder: S,
          className: "aspect-[3/4] h-auto rounded-xl lg:aspect-auto lg:h-full lg:min-h-[50vh]",
          "data-testid": I
        }
      ),
      /* @__PURE__ */ p(KE, { onClose: _, closeLabel: L, testId: I })
    ] });
  }
  return /* @__PURE__ */ C(
    "div",
    {
      className: "flex h-full min-h-0 w-full max-h-full flex-col overflow-x-hidden overflow-y-auto overscroll-contain bg-background max-lg:h-auto max-lg:max-h-none lg:flex-row lg:items-stretch lg:overflow-hidden",
      "data-testid": I,
      children: [
        /* @__PURE__ */ p("div", { className: "relative min-h-0 min-w-0 overflow-hidden bg-background max-lg:aspect-[640/832] max-lg:shrink-0 lg:h-full lg:flex-1 lg:basis-0", children: /* @__PURE__ */ p(
          Zfe,
          {
            imageUrl: n.imageUrl,
            imageAlt: t.imageAlt,
            isNsfw: n.isBlurred ?? n.isNsfw,
            navigation: g,
            onClose: _,
            closeLabel: L
          }
        ) }),
        g ? /* @__PURE__ */ p(qfe, { navigation: g, "data-testid": I }) : null,
        /* @__PURE__ */ p(
          _3e,
          {
            content: n,
            labels: t,
            onCopyLink: o,
            onDownload: i,
            isDownloading: c,
            downloadFallbackUrl: s,
            onOpenDownloadFallback: l,
            onKeep: u,
            onDelete: h,
            actionsAllowed: k,
            onOpenConnection: y,
            onActivateConnection: m,
            hasTopDivider: !g
          }
        )
      ]
    }
  );
}
const vge = mt(L3e), lw = "flex w-full items-center gap-3 bg-transparent px-4 py-3 text-left disabled:cursor-not-allowed disabled:opacity-40 [@media(hover:hover)]:enabled:hover:bg-gray-5", x3e = `${lw} no-underline text-inherit`, E3e = "text-red-9";
function v3e({
  labels: e,
  isKept: t,
  onCopyLink: n,
  onDownload: a,
  downloadFallbackUrl: o,
  onKeep: i,
  onDelete: c,
  actionsAllowed: s
}) {
  const {
    isKeepAllowed: l = !0,
    isMakePublicAllowed: u = !0,
    isAddToFolderAllowed: h = !0,
    isReportAllowed: k = !0,
    isDeleteAllowed: f = !0
  } = s ?? {};
  return [
    {
      key: "keep",
      icon: t ? R.BOOKMARK_CHECK : R.BOOKMARK,
      label: t ? e.unkeepLabel : e.keepAriaLabel,
      onSelect: i,
      isAllowed: l
    },
    { key: "makePrivate", icon: R.LOCK, label: e.makePrivateLabel, isAllowed: u },
    { key: "copyLink", icon: R.LINK_CHAIN, label: e.copyLink, onSelect: n },
    // After a download could not start the row is a real link to the original, as in the details view.
    o ? { key: "download", icon: R.MOVE_UP_RIGHT, label: e.openOriginalLabel, href: o } : { key: "download", icon: R.DOWNLOAD, label: e.downloadAriaLabel, onSelect: a },
    { key: "addToFolder", icon: R.FOLDER, label: e.addToFolderLabel, isAllowed: h },
    { key: "report", icon: R.FLAG, label: e.reportLabel, isAllowed: k },
    { key: "delete", icon: R.TRASH, label: e.deleteLabel, onSelect: c, destructive: !0, isAllowed: f }
  ];
}
function A3e({ action: e, testId: t, onClose: n }) {
  const a = e.destructive ? E3e : void 0, o = Q(() => {
    var i;
    (i = e.onSelect) == null || i.call(e), n();
  }, [e, n]);
  return e.href ? /* @__PURE__ */ p("li", { children: /* @__PURE__ */ C(
    "a",
    {
      href: e.href,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: n,
      className: x3e,
      "data-testid": `${t}-${e.key}`,
      children: [
        /* @__PURE__ */ p(oe, { icon: e.icon, size: ye.MEDIUM, className: a }),
        /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_MEDIUM_REGULAR, className: a, children: e.label })
      ]
    }
  ) }) : /* @__PURE__ */ p("li", { children: /* @__PURE__ */ C("button", { type: "button", disabled: !e.onSelect, onClick: o, className: lw, "data-testid": `${t}-${e.key}`, children: [
    /* @__PURE__ */ p(oe, { icon: e.icon, size: ye.MEDIUM, className: a }),
    /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_MEDIUM_REGULAR, className: a, children: e.label })
  ] }) });
}
function I3e({
  labels: e,
  isOpen: t,
  onOpenChange: n,
  isKept: a,
  onCopyLink: o,
  onDownload: i,
  downloadFallbackUrl: c,
  onKeep: s,
  onDelete: l,
  actionsAllowed: u,
  "data-testid": h = "MediaFilePreviewActionsSheet"
}) {
  const k = v3e({ labels: e, isKept: a, onCopyLink: o, onDownload: i, downloadFallbackUrl: c, onKeep: s, onDelete: l, actionsAllowed: u }).filter((y) => y.isAllowed !== !1).filter((y) => y.key !== "download" || !!i), f = Q(() => n(!1), [n]);
  return (
    // Portaled: the grid tile wraps each preview in a content-visibility/contain box for off-screen
    // performance, which creates a containing block for `fixed` descendants the same way a transformed
    // Modal panel does. Without a portal the sheet would be clipped to that tile's bounds.
    /* @__PURE__ */ p(mE, { open: t, onOpenChange: n, position: tt.BOTTOM, isPortaled: !0, "data-testid": h, children: /* @__PURE__ */ p("ul", { className: "flex flex-col py-2", children: k.map((y) => /* @__PURE__ */ p(A3e, { action: y, testId: h, onClose: f }, y.key)) }) })
  );
}
const _T = "h-4 w-4 tile-lg:h-5 tile-lg:w-5", bT = "!rounded-md !border-transparent !bg-gray-4 !px-2.5 !py-1 text-label-md font-semibold leading-tight text-gray-12 !whitespace-nowrap [&>.react-tooltip-content-wrapper]:!p-0", LT = "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-default hover:bg-gray-4 hover:ring-1 hover:ring-inset hover:ring-gray-8 tile-lg:h-9 tile-lg:w-9", T3e = ({ testId: e, kindIcon: t, kindLabel: n, isNsfw: a, matureLabel: o }) => (
  // `contents` hands the icons to the parent row, so it spaces them like its own children.
  /* @__PURE__ */ C("div", { className: "contents", children: [
    /* @__PURE__ */ p(Nt, { title: n, className: bT, children: /* @__PURE__ */ p("span", { role: "img", "aria-label": n, "data-testid": `${e}-KindIcon`, className: LT, children: /* @__PURE__ */ p(oe, { icon: t, className: _T }) }) }),
    a ? /* @__PURE__ */ p(Nt, { title: o, className: bT, children: /* @__PURE__ */ p(
      "span",
      {
        role: "img",
        "aria-label": o,
        "data-testid": `${e}-MatureIcon`,
        className: P(LT, "text-pink-600 tile-max-sm:hidden"),
        children: /* @__PURE__ */ p(oe, { icon: R.FLAME, className: _T })
      }
    ) }) : null
  ] })
);
function N3e({
  labels: e,
  testId: t,
  isKept: n,
  onCopyLink: a,
  onDownload: o,
  downloadFallbackUrl: i,
  onKeep: c,
  onDelete: s,
  actionsAllowed: l
}) {
  const u = i ? {
    label: e.openOriginalLabel,
    icon: R.MOVE_UP_RIGHT,
    to: i,
    target: "_blank",
    isHidden: !o,
    dataTestId: `${t}-MoreMenu-download`
  } : {
    label: e.downloadAriaLabel,
    icon: R.DOWNLOAD,
    onPress: o,
    isHidden: !o,
    dataTestId: `${t}-MoreMenu-download`
  }, {
    isKeepAllowed: h = !0,
    isMakePublicAllowed: k = !0,
    isAddToFolderAllowed: f = !0,
    isReportAllowed: y = !0,
    isDeleteAllowed: m = !0
  } = l ?? {};
  return [
    {
      label: n ? e.unkeepLabel : e.keepAriaLabel,
      icon: n ? R.BOOKMARK_CHECK : R.BOOKMARK,
      onPress: c,
      isDisabled: !c,
      isHidden: !h,
      dataTestId: `${t}-MoreMenu-keep`
    },
    {
      label: e.makePrivateLabel,
      icon: R.LOCK,
      isDisabled: !0,
      isHidden: !k,
      dataTestId: `${t}-MoreMenu-makePrivate`
    },
    {
      label: e.copyLink,
      icon: R.LINK_CHAIN,
      onPress: a,
      isDisabled: !a,
      dataTestId: `${t}-MoreMenu-copyLink`
    },
    u,
    {
      label: e.addToFolderLabel,
      icon: R.FOLDER,
      isDisabled: !0,
      isHidden: !f,
      dataTestId: `${t}-MoreMenu-addToFolder`
    },
    { label: e.reportLabel, icon: R.FLAG, isDisabled: !0, isHidden: !y, dataTestId: `${t}-MoreMenu-report` },
    {
      label: e.deleteLabel,
      icon: R.TRASH,
      onPress: s,
      isDisabled: !s,
      isHidden: !m,
      dataTestId: `${t}-MoreMenu-delete`
    }
  ];
}
const Cv = "shrink-0 tile-lg:h-9 tile-lg:w-9", wv = { icon: "text-gray-10 tile-lg:h-5 tile-lg:w-5" }, C3e = "flex min-w-0 flex-1 items-center gap-1 overflow-hidden text-inherit no-underline tile-lg:gap-2", w3e = "shrink-0 tile-lg:h-7 tile-lg:w-7", S3e = (e) => (t) => {
  !e || t.metaKey || t.ctrlKey || t.shiftKey || t.button !== 0 || (t.preventDefault(), e());
};
function R3e({
  testId: e,
  labels: t,
  isKept: n,
  onCopyLink: a,
  onDownload: o,
  downloadFallbackUrl: i,
  onKeep: c,
  onDelete: s,
  actionsAllowed: l,
  onOpenSheet: u
}) {
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ p(
      wt,
      {
        "data-testid": `${e}-MoreMobileButton`,
        icon: R.MORE_VERTICAL,
        variant: J.TEXT,
        size: _e.SMALL,
        shape: we.SQUARE,
        "aria-label": t.moreAriaLabel,
        className: `flex md:hidden ${Cv}`,
        classNames: wv,
        onClick: u
      }
    ),
    /* @__PURE__ */ p("div", { className: "hidden md:block", children: /* @__PURE__ */ p(
      lE,
      {
        listItems: N3e({ labels: t, testId: e, isKept: n, onCopyLink: a, onDownload: o, downloadFallbackUrl: i, onKeep: c, onDelete: s, actionsAllowed: l }),
        isPortaled: !0,
        children: /* @__PURE__ */ p(
          wt,
          {
            "data-testid": `${e}-MoreButton`,
            icon: R.MORE_VERTICAL,
            variant: J.TEXT,
            size: _e.SMALL,
            shape: we.SQUARE,
            "aria-label": t.moreAriaLabel,
            className: Cv,
            classNames: wv
          }
        )
      }
    ) })
  ] });
}
const D3e = ({ testId: e, content: t, noRelationLabel: n, characterHref: a, onOpenCharacter: o }) => t.characterLabel ? /* @__PURE__ */ C(
  "a",
  {
    "data-testid": `${e}-CharacterLink`,
    href: a,
    onClick: S3e(o),
    className: C3e,
    children: [
      /* @__PURE__ */ p(
        bi,
        {
          ...t.characterAvatarUrl ? { src: t.characterAvatarUrl } : { icon: R.BOT },
          size: Xt.XSMALL,
          className: w3e
        }
      ),
      /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_SMALL_MEDIUM, className: "min-w-0 truncate tile-lg:text-label-md", children: t.characterLabel }),
      /* @__PURE__ */ p(oe, { icon: R.EXTERNAL_LINK, className: "h-3.5 w-3.5 shrink-0 tile-max-md:hidden tile-lg:h-4 tile-lg:w-4" })
    ]
  }
) : (
  // Only a file attached to nothing says so; one attached to a persona or profile leaves the place empty.
  /* @__PURE__ */ p("span", { className: "flex min-w-0 flex-1", children: t.isUnattached ? /* @__PURE__ */ p(
    q,
    {
      as: "span",
      "data-testid": `${e}-NoRelation`,
      variant: x.LABEL_SMALL_MEDIUM,
      className: "min-w-0 truncate tile-lg:text-label-md",
      children: n
    }
  ) : null })
), O3e = ({
  testId: e,
  content: t,
  labels: n,
  characterHref: a,
  onOpenCharacter: o,
  onCopyLink: i,
  onDownload: c,
  downloadFallbackUrl: s,
  onKeep: l,
  onDelete: u,
  actionsAllowed: h
}) => {
  const [k, f] = ae(!1), y = Q(() => f(!0), []), m = !!t.isKept;
  return /* @__PURE__ */ C("div", { className: "px-1.5 py-2 tile-lg:px-4 tile-lg:py-3", children: [
    /* @__PURE__ */ C("div", { className: "flex h-7 items-center gap-1 text-gray-10 tile-lg:h-9 tile-lg:gap-2", children: [
      /* @__PURE__ */ p(
        T3e,
        {
          testId: e,
          kindIcon: t.kindIcon,
          kindLabel: t.kindLabel,
          isNsfw: t.isNsfw,
          matureLabel: n.mature
        }
      ),
      /* @__PURE__ */ p(
        D3e,
        {
          testId: e,
          content: t,
          noRelationLabel: n.noRelationLabel,
          characterHref: a,
          onOpenCharacter: o
        }
      ),
      /* @__PURE__ */ C("div", { className: "contents", children: [
        i ? /* @__PURE__ */ p(
          wt,
          {
            "data-testid": `${e}-CopyLinkButton`,
            icon: R.LINK_CHAIN,
            variant: J.TEXT,
            size: _e.SMALL,
            shape: we.SQUARE,
            "aria-label": n.copyLink,
            onClick: i,
            className: Cv,
            classNames: wv
          }
        ) : null,
        /* @__PURE__ */ p(
          R3e,
          {
            testId: e,
            labels: n,
            isKept: m,
            onCopyLink: i,
            onDownload: c,
            downloadFallbackUrl: s,
            onKeep: l,
            onDelete: u,
            actionsAllowed: h,
            onOpenSheet: y
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ p(
      I3e,
      {
        labels: n,
        isOpen: k,
        onOpenChange: f,
        isKept: m,
        onCopyLink: i,
        onDownload: c,
        downloadFallbackUrl: s,
        onKeep: l,
        onDelete: u,
        actionsAllowed: h,
        "data-testid": `${e}-Sheet`
      }
    )
  ] });
}, P3e = 24;
function H3e({
  content: e,
  labels: t,
  characterHref: n,
  onOpen: a,
  onOpenCharacter: o,
  onCopyLink: i,
  onDownload: c,
  downloadFallbackUrl: s,
  onKeep: l,
  onDelete: u,
  actionsAllowed: h,
  "data-testid": k = "MediaFilePreview"
}) {
  const [f, y] = ae(null), m = Q(() => y(e.imageUrl), [e.imageUrl]), g = e.imageUrl !== null && f === e.imageUrl;
  return /* @__PURE__ */ C("article", { "data-testid": k, className: "flex flex-col overflow-hidden rounded-2xl bg-gray-3 text-gray-12 [container-type:inline-size]", children: [
    /* @__PURE__ */ C("div", { className: "relative aspect-[4/5] w-full overflow-hidden bg-gray-5", children: [
      e.imageUrl && !g ? /* @__PURE__ */ p(
        Kt,
        {
          "data-testid": `${k}-Image`,
          src: e.imageUrl,
          alt: t.imageAlt,
          width: e.width,
          height: e.height,
          loading: "lazy",
          blurRadius: e.isBlurred ? P3e : 0,
          className: P("h-full w-full", e.isBlurred && "scale-110"),
          onError: m
        }
      ) : null,
      g ? /* @__PURE__ */ p(
        "div",
        {
          "data-testid": `${k}-ImageUnavailable`,
          role: "img",
          "aria-label": t.imageAlt,
          className: "flex h-full w-full items-center justify-center",
          children: /* @__PURE__ */ p(oe, { icon: R.IMAGE_OFF, size: ye.LARGE, className: "text-gray-10" })
        }
      ) : null,
      a ? /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          "data-testid": `${k}-OpenButton`,
          "aria-label": t.open,
          onClick: a,
          className: "absolute inset-0 cursor-pointer border-0 bg-transparent p-0"
        }
      ) : null
    ] }),
    /* @__PURE__ */ p(
      O3e,
      {
        testId: k,
        content: e,
        labels: t,
        characterHref: n,
        onOpenCharacter: o,
        onCopyLink: i,
        onDownload: c,
        downloadFallbackUrl: s,
        onKeep: l,
        onDelete: u,
        actionsAllowed: h
      }
    )
  ] });
}
const Age = mt(H3e), B3e = { fontWeight: "bolder" }, F3e = [
  {
    label: "No results found",
    text: "No results found",
    onPress: () => {
    }
  }
], $3e = (e, t) => {
  if (!t) return !0;
  if (e != null && e.heading) return !1;
  const n = e == null ? void 0 : e.label, a = typeof n == "string" ? n : String(n ?? ""), o = typeof t == "string" ? t : String(t ?? "");
  return a.toLowerCase().includes(o.toLowerCase());
}, U3e = (e, t) => {
  const n = typeof e == "string" ? e : String(e ?? ""), a = typeof t == "string" ? t : String(t ?? "");
  if (!a) return n;
  const o = n.split(new RegExp(`(${a})`, "i"));
  return o == null ? void 0 : o.map(
    (i, c) => (i == null ? void 0 : i.toLowerCase()) === (a == null ? void 0 : a.toLowerCase()) ? (
      // Leave matched part in regular font
      /* @__PURE__ */ p("span", { children: i }, c)
    ) : (
      // Bold the unmatched part
      /* @__PURE__ */ p("span", { style: B3e, children: i }, c)
    )
  );
}, q3e = ({ filteredOptions: e, search: t, onSelect: n }) => e.length === 0 ? F3e : e.map((a, o) => {
  const { label: i, heading: c, value: s } = a;
  return {
    ...a,
    key: `${i}-${o}`,
    text: t && !c ? U3e(i, t) : i,
    onPress: () => {
      c || n(s);
    }
  };
}), z3e = ({ selectedValues: e, onChange: t, onPressSelected: n, maxSelectionLimit: a, getSelectedLabel: o }) => {
  const i = e !== void 0, [c, s] = ae([]), l = i ? e : c, u = Q(
    (g) => {
      i ? t == null || t(g) : s(g);
    },
    [i, t]
  ), h = Q(
    (g) => {
      const _ = [...l, g], L = a && _.length > a;
      return u(L ? l : _), !L;
    },
    [l, a, u]
  ), k = Q(() => {
    u([]);
  }, [u]), f = Q(
    (g) => {
      u(l == null ? void 0 : l.filter((_) => _ !== g));
    },
    [l, u]
  ), y = Ve(() => o ? l.map((g) => o(g)) : l, [l, o]), m = Q(
    (g, _) => {
      const L = o ? l[_] ?? g : g;
      n ? n(L) : f(L);
    },
    [o, l, n, f]
  );
  return { currentSelected: l, displaySelected: y, handleSelect: h, handleClear: k, handleOnPressSelected: m };
}, j3e = ({ options: e, currentSelected: t, disabled: n, isMenuOpen: a, onOpenChange: o, inputProps: i, onSelectValue: c }) => {
  const [s, l] = ae(""), [u, h] = ae(!1), k = a !== void 0 ? a : u, f = fe(null), y = Q(
    (I) => {
      a !== void 0 ? o == null || o(I) : h(I);
    },
    [a, o]
  );
  le(() => {
    const I = (S) => {
      f.current && !f.current.contains(S.target) && y(!1);
    };
    return document.addEventListener("mousedown", I), () => document.removeEventListener("mousedown", I);
  }, [y]);
  const m = Q(
    (I) => {
      c(I) && l("");
    },
    [c]
  ), g = Ve(
    () => ((e == null ? void 0 : e.filter((I) => !t.includes(I.value))) ?? []).filter((I) => $3e(I, s)),
    [e, t, s]
  ), _ = Q(
    (I) => {
      var O;
      if (I.key !== "Enter") {
        (O = i.onKeyDown) == null || O.call(i, I);
        return;
      }
      if (I.preventDefault(), n || !k || g.length === 0)
        return;
      const S = g.find((A) => !A.heading && !A.isDisabled);
      S && m(S.value);
    },
    [i, n, k, g, m]
  ), L = Ve(
    () => q3e({ filteredOptions: g, search: s, onSelect: m }),
    [g, s, m]
  ), N = Q(() => {
    n || y(!0);
  }, [n, y]);
  return { stateSearch: s, setStateSearch: l, isOpenValue: k, refContainer: f, mappedOptions: L, handleKeyDown: _, handleMenuOpenChange: N };
}, Ige = ({
  options: e,
  placeholder: t = "Select options",
  selectedValues: n,
  onChange: a,
  disabled: o = !1,
  onPressSelected: i,
  maxSelectionLimit: c,
  helperText: s,
  label: l,
  inputProps: u = {},
  closeMenuOnSelect: h = !1,
  isMenuOpen: k,
  onOpenChange: f,
  maxHeight: y = 400,
  classNames: m,
  error: g = !1,
  errorMessage: _ = "",
  getSelectedLabel: L
}) => {
  const { currentSelected: N, displaySelected: I, handleSelect: S, handleClear: O, handleOnPressSelected: A } = z3e({
    selectedValues: n,
    onChange: a,
    onPressSelected: i,
    maxSelectionLimit: c,
    getSelectedLabel: L
  }), { stateSearch: B, setStateSearch: z, isOpenValue: j, refContainer: G, mappedOptions: $, handleKeyDown: H, handleMenuOpenChange: ee } = j3e({
    options: e,
    currentSelected: N,
    disabled: o,
    isMenuOpen: k,
    onOpenChange: f,
    inputProps: u,
    onSelectValue: S
  }), Y = Ve(() => ({ maxHeight: y }), [y]), U = P("!w-full overflow-auto", m == null ? void 0 : m.dropdownMenu), Z = m == null ? void 0 : m.input, te = c ? I.slice(0, c) : I, re = Q(() => {
    O(), z("");
  }, [O, z]);
  return /* @__PURE__ */ p("div", { className: "w-full", ref: G, children: /* @__PURE__ */ p(
    lE,
    {
      isOpen: j,
      onOpenChange: ee,
      listItems: $,
      closeMenuOnSelect: h,
      className: U,
      DropDownMenuStyles: Y,
      children: /* @__PURE__ */ p(
        xi,
        {
          label: l,
          placeholder: t,
          helperText: s,
          maxSelectionLength: c,
          error: g,
          errorMessage: _,
          selected: te,
          isClearable: N.length > 0,
          onClear: re,
          onPressSelected: A,
          disabled: o,
          value: B,
          onChange: z,
          ...u,
          onKeyDown: H,
          classNames: Z
        }
      )
    }
  ) });
};
var V3e = /* @__PURE__ */ ((e) => (e.GOLDEN = "Golden", e.INDIGO = "Indigo", e))(V3e || {});
const G3e = {
  Golden: "bg-yellow-2 text-yellow-9",
  Indigo: "bg-blue-1 text-blue-10"
}, Sv = ({
  id: e = "",
  avatarSrc: t,
  icon: n,
  label: a,
  hideLabel: o = !1,
  active: i = !1,
  hidden: c = !1,
  isSubItem: s = !1,
  to: l = "",
  target: u = "_self",
  onClick: h = () => {
  },
  className: k = "",
  badge: f,
  handleCollapse: y = () => {
  },
  isOpen: m,
  onOpenChange: g,
  ..._
}) => {
  var G, $, H, ee, Y, U;
  const [L, N] = ae(!1), I = m !== void 0 && g !== void 0, S = I ? m : L, O = () => {
    I ? g == null || g(!m) : N(!L);
  };
  if (c)
    return null;
  const A = ((G = _ == null ? void 0 : _.items) == null ? void 0 : G.filter((Z) => !Z.hidden)) ?? [];
  if (((($ = _ == null ? void 0 : _.items) == null ? void 0 : $.length) ?? 0) > 0 && A.length === 0 && !s)
    return null;
  if (A.length === 1 && !s) {
    const [Z] = A;
    return /* @__PURE__ */ p(
      Sv,
      {
        ...Z,
        icon: n ?? Z.icon,
        avatarSrc: t ?? Z.avatarSrc,
        hideLabel: o,
        handleCollapse: y,
        isSubItem: !1
      }
    );
  }
  if (!n && o && !t)
    return null;
  const z = /* @__PURE__ */ C(at, { children: [
    (o && !((H = _ == null ? void 0 : _.items) != null && H.length) || !o) && /* @__PURE__ */ C(
      "button",
      {
        onClick: (Z) => {
          var te;
          (te = _ == null ? void 0 : _.items) != null && te.length && !s && O(), h(Z);
        },
        className: `
          w-full flex items-center gap-2 px-2.5 h-10 justify-between
          rounded-md
          cursor-pointer
          bg-transparent
          text-gray-12 dark:text-gray-12
          ${i ? "bg-gray-4 dark:bg-gray-5" : "hover:bg-gray-4 dark:hover:bg-gray-4"}
          ${k}
        `,
        id: e,
        ..._,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
            s && /* @__PURE__ */ p("div", { className: "w-5 h-4" }),
            !s && t && /* @__PURE__ */ p(bi, { src: t, size: Xt.XSMALL }),
            !s && !t && n && /* @__PURE__ */ p(oe, { icon: n, size: ye.MEDIUM, className: "flex-none" }),
            !o && /* @__PURE__ */ p(
              q,
              {
                variant: i ? x.LABEL_LARGE_MEDIUM : x.LABEL_LARGE_REGULAR,
                className: "truncate",
                children: a
              }
            )
          ] }),
          f && /* @__PURE__ */ p(
            "div",
            {
              className: P(
                "text-xs px-md py-0.5 rounded-sm",
                G3e[
                  f.variant ?? "Indigo"
                  /* INDIGO */
                ]
              ),
              children: f.txt
            }
          ),
          ((ee = _ == null ? void 0 : _.items) == null ? void 0 : ee.length) && /* @__PURE__ */ p("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ p(
            oe,
            {
              icon: S ? R.CHEVRON_UP : R.CHEVRON_DOWN,
              size: ye.MEDIUM,
              className: "flex-none"
            }
          ) })
        ]
      }
    ),
    !o && S && ((Y = _ == null ? void 0 : _.items) == null ? void 0 : Y.map((Z, te) => /* @__PURE__ */ p(Sv, { isSubItem: !0, ...Z }, te))),
    o && ((U = _ == null ? void 0 : _.items) == null ? void 0 : U.length) && /* @__PURE__ */ p(
      wt,
      {
        variant: J.TRANSPARENT,
        icon: n,
        size: _e.MEDIUM,
        className: "flex-none w-10",
        "aria-label": `${a}-dropdown`,
        onClick: () => {
          y(), I ? g == null || g(!0) : N(!0);
        }
      }
    )
  ] }), j = l ? /* @__PURE__ */ p(mn, { to: l, target: u, className: "no-underline", "aria-label": "item", children: z }) : z;
  return o && n ? /* @__PURE__ */ p(Nt, { title: a, placement: tt.RIGHT, children: j }) : j;
}, W3e = ({
  items: e,
  hideLabel: t = !1,
  className: n = "",
  handleCollapse: a = () => {
  }
}) => /* @__PURE__ */ p("div", { className: `flex flex-col w-full py-2.5 px-[7px] ${n}`, children: e == null ? void 0 : e.map((o, i) => /* @__PURE__ */ C("div", { className: "w-full", children: [
  !t && (o == null ? void 0 : o.title) && /* @__PURE__ */ p("div", { className: "flex p-2.5 text-gray-12 dark:text-gray-12", children: /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_BOLD, children: o.title }) }),
  /* @__PURE__ */ p(Sv, { hideLabel: t, handleCollapse: a, ...o })
] }, i)) });
function xT({
  isCollapse: e,
  handleCollapse: t,
  items: n,
  logo: a,
  renderLogo: o,
  hideDesktopMenuToggle: i,
  footerItems: c
}) {
  var u, h, k, f;
  const { isMobile: s } = Dn(), l = !!((u = c == null ? void 0 : c.socials) != null && u.length);
  return /* @__PURE__ */ C(at, { children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: `flex items-center h-[56px] py-4 ${e && i ? "px-0 justify-center" : "px-[17px] md:px-[9px]"} border-solid border-t-0 border-l-0 border-r-0 border-b border-gray-4 dark:border-gray-5`,
        children: [
          !s && !i && /* @__PURE__ */ p(
            wt,
            {
              id: "navigation-button-menu-toggle-desktop",
              variant: J.TEXT,
              shape: we.SQUARE,
              icon: R.MENU,
              size: _e.MEDIUM,
              onClick: () => t(!e),
              "aria-label": "navigation-button-menu-toggle-desktop"
            }
          ),
          o ? o(!!e) : !e && a
        ]
      }
    ),
    /* @__PURE__ */ p("div", { className: `flex flex-col flex-1 no-scrollbar overflow-y-auto ${e && "scrollbar-hide"}`, children: n == null ? void 0 : n.map((y, m) => /* @__PURE__ */ p(
      W3e,
      {
        items: y,
        hideLabel: e,
        handleCollapse: () => t(!e),
        className: m === 0 ? "" : "border-solid border-b-0 border-l-0 border-r-0 border-t border-gray-4 dark:border-gray-5"
      },
      m
    )) }),
    /* @__PURE__ */ C(
      "footer",
      {
        className: `flex flex-col overflow-hidden border-solid border-b-0 border-l-0 border-r-0 border-t border-gray-4 dark:border-gray-5 gap-3 py-2.5 ${e ? "items-center px-[7px]" : "py-2.5 px-[17px] "}`,
        children: [
          (c == null ? void 0 : c.button) && !c.button.hidden && /* @__PURE__ */ p(
            nt,
            {
              variant: c.button.variant,
              onClick: c.button.onPress,
              iconStart: c.button.icon,
              size: _e.LARGE,
              className: "w-full !px-0",
              classNames: {
                icon: "!w-5 !h-5"
              },
              "aria-label": c.button.label,
              children: !e && c.button.label
            }
          ),
          l && /* @__PURE__ */ p(
            "div",
            {
              className: `
          flex
          ${e ? "flex-col" : "flex-row gap-5"}
        `,
              children: (h = c == null ? void 0 : c.socials) == null ? void 0 : h.map((y, m) => {
                const { icon: g, label: _, onClick: L, ...N } = y;
                return /* @__PURE__ */ p(mn, { ...N, onClick: L, to: N.to || "#", "aria-label": _, children: /* @__PURE__ */ p(
                  "div",
                  {
                    id: N.id || "",
                    className: `
                    
                    flex items-center cursor-pointer
                    ${e ? "py-2.5" : ""}
                  `,
                    children: g
                  }
                ) }, m);
              })
            }
          ),
          !e && /* @__PURE__ */ C(at, { children: [
            /* @__PURE__ */ p("div", { className: "flex flex-wrap text-gray-11", children: (k = c == null ? void 0 : c.legals) == null ? void 0 : k.map((y, m) => {
              const { label: g, hidden: _, ...L } = y;
              if (!_)
                return /* @__PURE__ */ p(mn, { className: "py-1 pr-md", "aria-label": g, ...L, children: /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_MEDIUM, children: g }) }, m);
            }) }),
            (c == null ? void 0 : c.trademark) && /* @__PURE__ */ p(q, { variant: x.LABEL_XSMALL_REGULAR, className: "text-gray-10", children: c == null ? void 0 : c.trademark }),
            /* @__PURE__ */ p("div", { className: "flex gap-1.5", children: (f = c == null ? void 0 : c.apps) == null ? void 0 : f.map((y, m) => {
              const { logo: g, width: _, height: L, alt: N, ...I } = y;
              return /* @__PURE__ */ p(mn, { "aria-label": N, ...I, children: /* @__PURE__ */ p(Kt, { src: g, width: _, height: L, alt: `${N} download` }) }, m);
            }) }),
            (c == null ? void 0 : c.versionLabel) && /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_REGULAR, className: "text-gray-10", children: c.versionLabel })
          ] })
        ]
      }
    )
  ] });
}
function Tge({ open: e, onOpenChange: t, ...n }) {
  const { isDesktop: a } = Dn(), [o, i] = ae(!a), c = e !== void 0, s = c ? e : !o;
  le(() => {
    i(!a);
  }, [a]);
  const l = () => {
    c ? t == null || t(!e) : i(!o);
  }, u = a ? s ? 220 : 54 : 220;
  return a ? /* @__PURE__ */ p(
    "nav",
    {
      className: `
        sticky
        h-screen
        z-50
        top-0
        left-0
        text-gray-12 dark:text-gray-12 bg-gray-1 dark:bg-gray-3
        flex flex-col 
        ${o ? "collapsed" : ""}
      `,
      style: {
        width: u
      },
      children: /* @__PURE__ */ p(
        xT,
        {
          isCollapse: !s,
          handleCollapse: l,
          ...n
        }
      )
    }
  ) : /* @__PURE__ */ p(
    mE,
    {
      open: s,
      onOpenChange: l,
      style: { width: u },
      children: /* @__PURE__ */ p(xT, { ...n })
    }
  );
}
const X3e = /^-?\d*$/, Y3e = /^\d*$/, pA = ({ min: e }) => e === void 0 || e < 0, K3e = ({ text: e, bounds: t }) => (pA(t) ? X3e : Y3e).test(e), dw = (e) => {
  if (e === "" || e === "-")
    return null;
  const t = Number.parseInt(e, 10);
  return Number.isSafeInteger(t) ? t : null;
}, Z3e = ({ value: e, bounds: t }) => (t.min === void 0 || e >= t.min) && (t.max === void 0 || e <= t.max), ET = ({ value: e, bounds: t }) => {
  const n = t.min === void 0 ? e : Math.max(t.min, e);
  return t.max === void 0 ? n : Math.min(t.max, n);
}, si = (e) => e === null ? "" : String(e), Q3e = 20, J3e = 10, e5e = (e) => Number.isFinite(e) ? Math.min(Q3e, Math.max(0, Math.trunc(e))) : 0, uw = ({ text: e, bounds: t, decimals: n }) => {
  if (n === 0)
    return K3e({ text: e, bounds: t });
  const a = pA(t) ? "-?" : "";
  return new RegExp(`^${a}\\d*(\\.\\d{0,${n}})?$`).test(e);
}, hw = ({ text: e, decimals: t }) => {
  if (t === 0)
    return dw(e);
  if (e.trim() === "")
    return null;
  const n = Number(e);
  return Number.isFinite(n) && n === Number(n.toFixed(t)) ? n : null;
}, Q1 = ({ value: e, decimals: t }) => Number(e.toFixed(t)), pw = (e) => J3e ** -e, t5e = ({ max: e, decimals: t }) => {
  const n = Q1({ value: e, decimals: t });
  return n > e ? Q1({ value: n - pw(t), decimals: t }) : n;
}, n5e = ({ min: e, decimals: t }) => {
  const n = Q1({ value: e, decimals: t });
  return n < e ? Q1({ value: n + pw(t), decimals: t }) : n;
}, a5e = ({ value: e, bounds: t, decimals: n }) => {
  const a = {
    min: t.min === void 0 ? void 0 : n5e({ min: t.min, decimals: n }),
    max: t.max === void 0 ? void 0 : t5e({ max: t.max, decimals: n })
  };
  return a.min !== void 0 && a.max !== void 0 && a.min > a.max ? Q1({ value: ET({ value: e, bounds: t }), decimals: n }) : ET({ value: Q1({ value: e, decimals: n }), bounds: a });
}, o5e = ({ text: e, decimals: t }) => {
  if (t === 0)
    return dw(e);
  if (e.trim() === "")
    return null;
  const n = Number(e);
  return Number.isFinite(n) ? Q1({ value: n, decimals: t }) : null;
}, r5e = ({ isEditable: e, discardText: t }) => {
  le(() => {
    e || t();
  }, [e, t]);
}, i5e = ({ text: e, value: t, decimals: n }) => {
  const a = hw({ text: e, decimals: n });
  return a !== null && a === t ? e : si(t);
}, c5e = ({
  text: e,
  value: t,
  bounds: n,
  decimals: a
}) => uw({ text: e, bounds: n, decimals: a }) ? e : si(t), s5e = ({ value: e, onChange: t, bounds: n, decimals: a }) => {
  const [o, i] = ae(() => si(e)), c = fe(e);
  le(() => {
    const h = c.current !== e;
    c.current = e, i(
      (k) => h ? i5e({ text: k, value: e, decimals: a }) : c5e({ text: k, value: e, bounds: n, decimals: a })
    );
  }, [e, n, a]);
  const s = Q(
    (h) => {
      if (!uw({ text: h, bounds: n, decimals: a }))
        return;
      i(h);
      const k = hw({ text: h, decimals: a });
      if (h === "") {
        t(null);
        return;
      }
      k !== null && Z3e({ value: k, bounds: n }) && t(k);
    },
    [n, a, t]
  ), l = Q(() => {
    const h = o5e({ text: o, decimals: a });
    if (h === null)
      return i(si(e)), e;
    const k = a5e({ value: h, bounds: n, decimals: a });
    return i(si(k)), k !== e && t(k), k;
  }, [n, a, t, o, e]), u = Q(() => {
    i(si(e));
  }, [e]);
  return { stateText: o, handleTextChange: s, commitText: l, discardText: u };
}, l5e = "Enter", d5e = ({ commitText: e, isEditable: t, onCommit: n, onBlur: a, onKeyDown: o }) => {
  const i = Q(() => {
    if (!t)
      return;
    const l = e();
    n == null || n(l);
  }, [e, t, n]), c = Q(
    (l) => {
      i(), a == null || a(l);
    },
    [i, a]
  ), s = Q(
    (l) => {
      l.key === l5e && !l.nativeEvent.isComposing && i(), o == null || o(l);
    },
    [i, o]
  );
  return { handleBlur: c, handleKeyDown: s };
}, u5e = "-?[0-9]*", h5e = "[0-9]*", p5e = "-?[0-9]*\\.?[0-9]*", y5e = "[0-9]*\\.?[0-9]*", k5e = ({ isSigned: e, hasDecimals: t }) => t ? e ? p5e : y5e : e ? u5e : h5e, f5e = ({
  value: e,
  onChange: t,
  onCommit: n,
  min: a,
  max: o,
  decimals: i = 0,
  onBlur: c,
  onKeyDown: s,
  readOnly: l = !1,
  disabled: u = !1,
  placeholder: h = "",
  "data-testid": k = "NumberInput",
  ...f
}) => {
  const y = Ve(() => ({ min: a, max: o }), [a, o]), m = !l && !u, g = e5e(i), _ = g > 0, { stateText: L, handleTextChange: N, commitText: I, discardText: S } = s5e({ value: e, onChange: t, bounds: y, decimals: g });
  r5e({ isEditable: m, discardText: S });
  const { handleBlur: O, handleKeyDown: A } = d5e({
    commitText: I,
    isEditable: m,
    onCommit: n,
    onBlur: c,
    onKeyDown: s
  });
  return /* @__PURE__ */ p(
    xi,
    {
      ...f,
      type: "text",
      inputMode: _ ? "decimal" : "numeric",
      pattern: k5e({ isSigned: pA(y), hasDecimals: _ }),
      value: L,
      onChange: N,
      onBlur: O,
      onKeyDown: A,
      readOnly: l,
      disabled: u,
      placeholder: h,
      "data-testid": k
    }
  );
}, Nge = mt(f5e);
function Cge({
  count: e,
  page: t,
  disabled: n = !1,
  initialVisiblePageCount: a,
  onChange: o
}) {
  const { isMobile: i } = Dn(), [c, s] = ae(t ?? 1), l = t ?? c, u = a ? Math.min(e, Math.max(a, l + 1)) : e, h = (y) => {
    n || l === y || y >= 1 && y <= e && (o == null || o(y), s(y));
  }, k = (y) => y <= 5 ? Array.from({ length: y }, (m, g) => g + 1) : l <= 2 ? [1, 2, 3, "...", y] : l >= y - 2 ? [1, "...", y - 2, y - 1, y] : [
    1,
    "...",
    l - 1,
    l,
    l + 1,
    "...",
    y
  ], f = (y) => i ? k(y) : y <= 7 ? Array.from({ length: y }, (m, g) => g + 1) : l <= 4 ? [1, 2, 3, 4, 5, "...", y] : l >= y - 3 ? [1, "...", y - 4, y - 3, y - 2, y - 1, y] : [
    1,
    "...",
    l - 1,
    l,
    l + 1,
    "...",
    y
  ];
  return /* @__PURE__ */ C("div", { className: "flex gap-1 select-none", children: [
    /* @__PURE__ */ p(
      nt,
      {
        onClick: () => h(l - 1),
        disabled: n || l === 1,
        iconStart: R.CHEVRON_LEFT,
        variant: J.OUTLINED,
        "aria-label": "previous-page",
        className: "max-mob:!h-8 max-mob:px-0.5",
        classNames: {
          icon: "!size-4"
        }
      }
    ),
    f(u).map((y, m) => {
      const g = l === y;
      return typeof y == "string" ? /* @__PURE__ */ p(
        nt,
        {
          disabled: n,
          variant: J.OUTLINED,
          className: "cursor-default size-9 max-mob:!size-8 max-w-8 max-mob:!w-min max-mob:!px-1.5",
          "aria-label": `page-${y}`,
          children: y
        },
        `${y}-${m}`
      ) : /* @__PURE__ */ p(
        nt,
        {
          onClick: () => h(y),
          disabled: n,
          variant: g ? J.CONTAINED : J.OUTLINED,
          size: _e.MEDIUM,
          className: "size-9 max-mob:size-8",
          "aria-label": `page-${y}`,
          children: y
        },
        y
      );
    }),
    /* @__PURE__ */ p(
      nt,
      {
        onClick: () => h(l + 1),
        disabled: n || l === e,
        iconEnd: R.CHEVRON_RIGHT,
        variant: J.OUTLINED,
        "aria-label": "next-page",
        className: "max-mob:!h-8 max-mob:px-0.5",
        classNames: {
          icon: "!size-4"
        }
      }
    )
  ] });
}
const m5e = 90, g5e = 8, M5e = 100, _5e = 180, b5e = 400, L5e = 0.08, x5e = 0.4, wge = ({
  value: e,
  isActive: t = !1,
  simulatedCap: n = m5e,
  className: a
}) => {
  const o = e !== void 0, [i, c] = ae(0), [s, l] = ae(!1), u = fe(!1), h = (y, m) => {
    if (y >= m) return y;
    const g = m - y;
    return y + Math.max(x5e, g * L5e);
  };
  le(() => {
    if (o) return;
    if (t) {
      u.current = !0, l(!0), c(g5e);
      const m = globalThis.setInterval(() => {
        c((g) => h(g, n));
      }, _5e);
      return () => globalThis.clearInterval(m);
    }
    if (!u.current) return;
    u.current = !1, c(M5e);
    const y = globalThis.setTimeout(() => {
      l(!1), c(0);
    }, b5e);
    return () => globalThis.clearTimeout(y);
  }, [t, o, n]);
  const k = o ? MS(e) : i;
  return (o ? k > 0 : s || i > 0) ? /* @__PURE__ */ p(
    "div",
    {
      className: P(
        "pointer-events-none fixed left-0 right-0 top-0 z-[9999] h-[4px] overflow-hidden",
        a
      ),
      children: /* @__PURE__ */ p(
        "div",
        {
          className: P(
            "h-full origin-left bg-blue-9",
            "transition-[width] duration-400 ease-out"
          ),
          style: { width: `${k}%` }
        }
      )
    }
  ) : null;
}, Sge = ({
  name: e,
  size: t = ji.MEDIUM,
  items: n = [],
  value: a,
  onValueChange: o,
  className: i,
  horizontal: c = !1,
  allowDeselect: s
}) => {
  var _, L;
  const l = {
    [ji.SMALL]: {
      radioIndicator: "w-[14px] h-[14px]",
      checkedRadioIndicator: "checked:size-[4px] checked:dark:size-[4px]",
      labelVariant: x.LABEL_SMALL_REGULAR,
      checkedLabelVariant: x.LABEL_SMALL_MEDIUM
    },
    [ji.MEDIUM]: {
      radioIndicator: "w-[16px] h-[16px]",
      checkedRadioIndicator: "checked:size-[6px] checked:dark:size-[6px]",
      labelVariant: x.LABEL_MEDIUM_REGULAR,
      checkedLabelVariant: x.LABEL_MEDIUM_MEDIUM
    },
    [ji.LARGE]: {
      radioIndicator: "w-[20px] h-[20px]",
      checkedRadioIndicator: "checked:size-[10px] checked:dark:size-[10px]",
      labelVariant: x.LABEL_LARGE_REGULAR,
      checkedLabelVariant: x.LABEL_LARGE_MEDIUM
    }
  }, u = (_ = l[t]) == null ? void 0 : _.radioIndicator, h = (L = l[t]) == null ? void 0 : L.checkedRadioIndicator, k = "appearance-none border-[1px] dark:border-none border-gray-8 border-solid rounded-full bg-gray-5 dark:bg-gray-9 cursor-pointer", f = "focus:ring-2 focus:ring-offset-2 focus:dark:ring-offset-black focus:ring-blue-10", y = `checked:box-content dark:checked:box-content checked:border-solid dark:checked:border-solid checked:border-[5px] checked:border-blue-10 dark:checked:border-blue-10 checked:bg-white dark:checked:bg-white ${h}`, g = `${k} ${u} ${f} ${y} 
  checked:disabled:bg-transparent 
  checked:disabled:border-gray-10 
  disabled:opacity-50 
  disabled:cursor-not-allowed`;
  return /* @__PURE__ */ p(
    "div",
    {
      className: P(
        "flex justify-center gap-4",
        `${c ? "flex-row" : "flex-col"}`,
        i
      ),
      children: n == null ? void 0 : n.map((N, I) => {
        const S = a === (N == null ? void 0 : N.value);
        return /* @__PURE__ */ C("div", { className: "flex items-center min-w-0 space-x-3", children: [
          /* @__PURE__ */ p(
            "input",
            {
              id: `radio_${I}`,
              type: "radio",
              name: e,
              value: N == null ? void 0 : N.value,
              checked: S,
              onChange: (O) => {
                o == null || o(O.target.value);
              },
              onClick: (O) => {
                const A = O.currentTarget.value;
                s && a === A && (O.preventDefault(), o == null || o(null));
              },
              className: P(g, "shrink-0"),
              disabled: (N == null ? void 0 : N.disabled) || !1
            }
          ),
          /* @__PURE__ */ p(
            "label",
            {
              htmlFor: `radio_${I}`,
              className: "cursor-pointer min-w-0 overflow-hidden",
              children: /* @__PURE__ */ p(
                q,
                {
                  variant: S ? l[t].checkedLabelVariant : l[t].labelVariant,
                  className: "truncate block",
                  children: N == null ? void 0 : N.label
                }
              )
            }
          )
        ] }, I);
      })
    }
  );
}, E5e = /* @__PURE__ */ new Set(["ArrowLeft", "ArrowUp"]), v5e = /* @__PURE__ */ new Set(["ArrowRight", "ArrowDown"]), yw = (e) => e.reduce((t, n, a) => n.disabled ? t : [...t, a], []), A5e = (e) => v5e.has(e) ? 1 : E5e.has(e) ? -1 : 0, I5e = ({ position: e, step: t }) => e !== -1 ? e : t > 0 ? -1 : 0, T5e = ({ options: e, value: t, disabled: n }) => {
  if (n)
    return -1;
  const a = e.findIndex((o) => o.value === t && !o.disabled);
  return a >= 0 ? a : yw(e)[0] ?? -1;
}, N5e = ({ options: e, currentIndex: t, key: n }) => {
  const a = yw(e);
  if (a.length === 0)
    return null;
  if (n === "Home")
    return a[0];
  if (n === "End")
    return a[a.length - 1];
  const o = A5e(n);
  if (o === 0)
    return null;
  const c = (I5e({ position: a.indexOf(t), step: o }) + o + a.length) % a.length;
  return a[c];
}, C5e = "inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-[8px] border border-solid px-3 font-semibold transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-10 disabled:cursor-not-allowed disabled:opacity-40", w5e = "border-transparent bg-black text-white dark:bg-white dark:text-gray-1", S5e = "border-gray-8 bg-transparent text-gray-12 enabled:hover:bg-gray-4", R5e = {
  [me.SMALL]: "h-[30px] text-xs",
  [me.MEDIUM]: "h-8 text-[13px]"
}, D5e = ({
  option: e,
  index: t,
  size: n,
  isSelected: a,
  isFocusable: o,
  isDisabled: i,
  onSelect: c,
  "data-testid": s
}) => {
  const l = Q(() => {
    a || c(e.value);
  }, [a, c, e.value]);
  return /* @__PURE__ */ C(
    "button",
    {
      type: "button",
      role: "radio",
      "aria-checked": a,
      "aria-label": e.ariaLabel,
      tabIndex: o ? 0 : -1,
      disabled: i,
      className: P(C5e, R5e[n], a ? w5e : S5e),
      onClick: l,
      "data-testid": s,
      "data-segment-index": t,
      children: [
        e.icon ? /* @__PURE__ */ p(oe, { icon: e.icon, size: ye.SMALL }) : null,
        e.label
      ]
    }
  );
}, O5e = mt(D5e), kw = "data-segment-index", P5e = (e) => {
  if (!(e instanceof HTMLElement))
    return null;
  const t = e.getAttribute(kw);
  return t === null ? null : Number(t);
}, H5e = ({ options: e, value: t, onChange: n }) => Q(
  (a) => {
    var s;
    const o = P5e(a.target);
    if (o === null)
      return;
    const i = N5e({ options: e, currentIndex: o, key: a.key });
    if (i === null)
      return;
    a.preventDefault(), (s = a.currentTarget.querySelector(`[${kw}="${i}"]`)) == null || s.focus();
    const c = e[i].value;
    c !== t && n(c);
  },
  [e, t, n]
), B5e = ({
  options: e,
  value: t,
  onChange: n,
  size: a = me.SMALL,
  disabled: o = !1,
  className: i,
  "aria-label": c,
  "aria-labelledby": s,
  "data-testid": l = "SegmentedControl"
}) => {
  const u = H5e({ options: e, value: t, onChange: n }), h = T5e({ options: e, value: t, disabled: o });
  return /* @__PURE__ */ p(
    "div",
    {
      role: "radiogroup",
      "aria-label": c,
      "aria-labelledby": s,
      "aria-disabled": o || void 0,
      className: P("flex flex-wrap gap-1", i),
      onKeyDown: u,
      "data-testid": l,
      children: e.map((k, f) => /* @__PURE__ */ p(
        O5e,
        {
          option: k,
          index: f,
          size: a,
          isSelected: k.value === t,
          isFocusable: f === h,
          isDisabled: o || !!k.disabled,
          onSelect: n,
          "data-testid": k.testId ?? `${l}-Option-${k.value}`
        },
        k.value
      ))
    }
  );
}, Rge = mt(B5e), Dge = ({
  disabled: e = !1,
  value: t,
  onChange: n,
  min: a = 0,
  max: o = 100,
  step: i = 1,
  showValue: c = !0
}) => {
  const [s, l] = ae(a), [u, h] = ae(!1), k = fe(null), f = fe(null), y = t !== void 0 ? t : s, m = Math.max(a, Math.min(o, y)), g = Math.round((m - a) / i) * i + a, _ = Math.max(
    a,
    Math.min(o, parseFloat(g.toFixed(10)))
  ), L = (_ - a) / (o - a) * 100, N = ($) => {
    const H = Number($.target.value);
    t === void 0 && l(H), n == null || n(H);
  }, I = Q(
    ($) => {
      if (!k.current || e) return;
      const H = k.current.getBoundingClientRect(), ee = Math.max(
        0,
        Math.min(100, ($ - H.left) / H.width * 100)
      ), Y = a + ee / 100 * (o - a), U = Math.round((Y - a) / i) * i + a, Z = Math.max(
        a,
        Math.min(o, parseFloat(U.toFixed(10)))
      );
      t === void 0 && l(Z), n == null || n(Z), k.current.value = Z.toString();
    },
    [e, a, o, i, t, n]
  ), S = ($) => {
    e || ($.preventDefault(), h(!0));
  }, O = ($) => {
    e || ($.preventDefault(), h(!0));
  }, A = Q(
    ($) => {
      !u || e || I($.clientX);
    },
    [u, e, I]
  ), B = Q(
    ($) => {
      !u || e || ($.preventDefault(), $.touches.length > 0 && I($.touches[0].clientX));
    },
    [u, e, I]
  ), z = Q(() => {
    h(!1);
  }, []), j = Q(() => {
    h(!1);
  }, []), G = Q(() => {
    h(!1);
  }, []);
  return le(() => {
    t !== void 0 && y !== _ && f.current !== _ && (f.current = _, n == null || n(_));
  }, [t, y, _, n]), le(() => {
    if (u)
      return document.addEventListener("mousemove", A), document.addEventListener("mouseup", z), document.addEventListener("touchmove", B, { passive: !1 }), document.addEventListener("touchend", j), document.addEventListener("touchcancel", G), () => {
        document.removeEventListener("mousemove", A), document.removeEventListener("mouseup", z), document.removeEventListener("touchmove", B), document.removeEventListener("touchend", j), document.removeEventListener("touchcancel", G);
      };
  }, [
    u,
    A,
    z,
    B,
    j,
    G
  ]), /* @__PURE__ */ C("div", { className: "flex flex-1 items-center gap-3", children: [
    /* @__PURE__ */ C("div", { className: "relative flex-1", children: [
      /* @__PURE__ */ p(
        "input",
        {
          ref: k,
          type: "range",
          min: a,
          max: o,
          step: i,
          value: _,
          onChange: N,
          disabled: e,
          className: P(
            "absolute w-full h-full opacity-0 z-10",
            e ? "cursor-not-allowed" : "cursor-pointer"
          ),
          style: {
            WebkitAppearance: "none",
            appearance: "none",
            background: "transparent"
          }
        }
      ),
      /* @__PURE__ */ C(
        "div",
        {
          className: P(
            "relative h-2 flex items-center rounded-full bg-gray-5 dark:bg-gray-9"
          ),
          children: [
            /* @__PURE__ */ p(
              "div",
              {
                className: P(
                  "h-1 rounded-full",
                  e ? "bg-gray-8 dark:bg-gray-10" : "bg-blue-9"
                ),
                style: { width: `${L}%` }
              }
            ),
            /* @__PURE__ */ p(
              "div",
              {
                className: P(
                  "absolute size-5 rounded-full transform transition-all duration-200 z-20",
                  e ? "bg-gray-8 dark:bg-gray-10 cursor-not-allowed" : P(
                    "bg-blue-10 cursor-pointer",
                    u ? "ring-[10px] ring-blue-9 ring-opacity-40" : "hover:scale-105 hover:shadow-md"
                  )
                ),
                style: {
                  left: `calc(${L}% - 10px)`,
                  transition: u ? "none" : "left 0.1s ease-out",
                  touchAction: "none"
                  // Prevent default touch behaviors
                },
                onMouseDown: S,
                onTouchStart: O
              }
            )
          ]
        }
      )
    ] }),
    c && /* @__PURE__ */ p("div", { className: "w-12 text-right", children: /* @__PURE__ */ p(q, { variant: x.LABEL_LARGE_REGULAR, children: _ }) })
  ] });
}, vT = {
  [ii.SMALL]: {
    container: "h-[19px] w-[35px]",
    thumb: "h-[15px] w-[15px]",
    // Slightly smaller than container height
    thumbOffset: "translate-x-[17px]",
    thumbOffsetUnchecked: "translate-x-[1px]",
    text: x.LABEL_SMALL_REGULAR
  },
  [ii.MEDIUM]: {
    container: "h-[23px] w-[43px]",
    thumb: "h-[19px] w-[19px]",
    // Slightly smaller than container height
    thumbOffset: "translate-x-[21px]",
    thumbOffsetUnchecked: "translate-x-[1px]",
    text: x.LABEL_MEDIUM_REGULAR
  },
  [ii.LARGE]: {
    container: "h-[27px] w-[51px]",
    thumb: "h-[23px] w-[23px]",
    // Slightly smaller than container height
    thumbOffset: "translate-x-[25px]",
    thumbOffsetUnchecked: "translate-x-[1px]",
    text: x.LABEL_LARGE_REGULAR
  },
  [ii.COMPACT]: {
    container: "h-[24px] w-[40px]",
    thumb: "h-[18px] w-[18px]",
    // 3px inset on every side
    thumbOffset: "translate-x-[19px]",
    thumbOffsetUnchecked: "translate-x-[3px]",
    text: x.LABEL_MEDIUM_REGULAR
  }
}, F5e = ({ disabled: e, className: t }) => `inline-flex items-center ${e ? "opacity-50 cursor-not-allowed" : "cursor-pointer"} ${t}`, $5e = ({ container: e, disabled: t, checked: n }) => `relative ${e} rounded-full peer peer-focus-visible:ring-1 peer-focus-visible:ring-blue-10 dark:peer-focus-visible:ring-blue-1 ${t ? "" : "hover:ring-1 hover:ring-blue-10 dark:hover:ring-blue-5"} transition-colors flex items-center ${n ? "bg-blue-10" : "bg-gray-10"}`, U5e = ({ currentSizeStyles: e, checked: t }) => `${e == null ? void 0 : e.thumb} bg-white rounded-full transition-transform duration-200 ease-in-out ${t ? e == null ? void 0 : e.thumbOffset : e == null ? void 0 : e.thumbOffsetUnchecked}`, Oge = ({
  size: e = me.MEDIUM,
  label: t,
  labelPosition: n = F1.END,
  disabled: a = !1,
  checked: o = !1,
  onCheckedChange: i,
  className: c = "",
  ariaLabel: s,
  "data-testid": l = "Switch"
}) => {
  const u = Q(
    (f) => {
      i == null || i(f.target.checked);
    },
    [i]
  ), h = vT[e] ?? vT[ii.MEDIUM], k = t ? /* @__PURE__ */ p(q, { variant: h == null ? void 0 : h.text, className: n === F1.START ? "me-[10px]" : "ms-[10px]", children: t }) : null;
  return /* @__PURE__ */ C("label", { className: F5e({ disabled: a, className: c }), "data-testid": l, children: [
    n === F1.START ? k : null,
    /* @__PURE__ */ p(
      "input",
      {
        type: "checkbox",
        className: "sr-only peer",
        disabled: a,
        checked: o,
        "aria-label": s,
        onChange: u,
        "data-testid": `${l}-Input`
      }
    ),
    /* @__PURE__ */ p("div", { className: $5e({ container: h == null ? void 0 : h.container, disabled: a, checked: o }), "data-testid": `${l}-Track`, children: /* @__PURE__ */ p("span", { className: U5e({ currentSizeStyles: h, checked: o }), "data-testid": `${l}-Thumb` }) }),
    n === F1.END ? k : null
  ] });
}, q5e = /^(label|paragraph|heading|mobile-heading|display)-/, z5e = ["sm", "md", "lg", "xl"], j5e = ["regular"], V5e = (e) => q5e.test(e), G5e = pc({
  extend: {
    theme: {
      spacing: z5e
    },
    classGroups: {
      "font-size": [{ text: [V5e] }],
      "font-weight": [{ font: j5e }],
      "text-decoration-skip-ink": ["text-decoration-skip-ink-none"],
      "text-underline-position": ["text-underline-position-from-font"]
    }
  }
}), Ci = (...e) => G5e(wn(e)), AT = "relative flex h-11 gap-2 overflow-x-scroll scrollbar-hide", IT = "absolute bottom-0 h-0.5 bg-blue-12 transition-all duration-200", W5e = "pointer-events-none absolute bottom-0 left-0 h-px w-full bg-gray-5", TT = "relative cursor-pointer bg-transparent gap-sm flex flex-shrink-0 items-center justify-center transition-colors duration-200 min-w-10", X5e = "text-blue-12", Y5e = "text-gray-11", NT = "opacity-50 cursor-not-allowed", fw = "font-sans text-decoration-skip-ink-none text-underline-position-from-font", K5e = `${fw} text-label-md font-regular text-left`, Z5e = `${fw} text-label-xs font-medium text-left`, mw = "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1.5", gw = "bg-blue-2 text-blue-12", Mw = "bg-gray-5 text-gray-11", Q5e = (e) => e ? Ci(AT, e) : AT, J5e = (e) => e ? Ci(IT, e) : IT, eme = (e) => Ci(W5e, e), tme = ({ isActive: e, isDisabled: t, classNames: n }) => {
  const a = e ? n == null ? void 0 : n.activeTab : void 0, o = e ? X5e : Y5e;
  return !(n != null && n.tab) && !a ? `${TT} ${o} ${t ? NT : ""} ` : Ci(TT, o, t ? NT : void 0, n == null ? void 0 : n.tab, a);
}, nme = ({ isActive: e, classNames: t }) => {
  if (!(t != null && t.count || e && (t != null && t.activeCount)))
    return P(mw, e ? gw : Mw);
}, ame = ({ isActive: e, classNames: t }) => Ci(
  Z5e,
  mw,
  e ? gw : Mw,
  t == null ? void 0 : t.count,
  e ? t == null ? void 0 : t.activeCount : void 0
), ome = (e) => Ci(K5e, e), rme = ({ count: e, isActive: t, classNames: n, "data-testid": a }) => {
  const o = nme({ isActive: t, classNames: n });
  return o !== void 0 ? /* @__PURE__ */ p(q, { as: "span", variant: x.LABEL_XSMALL_MEDIUM, className: o, "data-testid": a, children: e }) : /* @__PURE__ */ p("span", { className: ame({ isActive: t, classNames: n }), "data-testid": a, children: e });
}, ime = ({ label: e, className: t, "data-testid": n }) => t ? /* @__PURE__ */ p("p", { className: ome(t), "data-testid": n, children: e }) : /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, "data-testid": n, children: e }), _w = (e) => typeof e == "number", cme = ({ label: e, count: t, countAriaLabel: n }) => _w(t) ? n ?? `${e} (${t})` : e, sme = ({ tab: e, isActive: t, onTabChange: n, registerTab: a, classNames: o, rootTestId: i }) => {
  var g;
  const { name: c, label: s, disabled: l, status: u, count: h } = e, k = cme(e), f = i ? `${i}-Label-${c}` : void 0, y = Q(
    (_) => {
      a({ name: c, element: _ });
    },
    [c, a]
  ), m = Q(() => {
    n(c);
  }, [c, n]);
  return /* @__PURE__ */ C(
    "button",
    {
      ref: y,
      className: tme({ isActive: t, isDisabled: l, classNames: o }),
      onClick: m,
      disabled: l,
      "aria-pressed": t,
      "aria-label": k,
      "data-testid": `tab-${c}`,
      type: "button",
      children: [
        /* @__PURE__ */ p(ime, { label: s, className: o == null ? void 0 : o.label, "data-testid": f }),
        _w(h) ? /* @__PURE__ */ p(rme, { count: h, isActive: t, classNames: o, "data-testid": `tab-${c}-count` }) : null,
        u ? /* @__PURE__ */ p("div", { className: P("rounded-full w-[6px] h-[6px]", ((g = DS[u]) == null ? void 0 : g.className) || "bg-gray-9") }) : null
      ]
    }
  );
}, lme = he.memo(sme), CT = (e) => Object.values(e).filter((t) => t !== null), dme = (e) => e.reduce(
  (t, n) => !t || n.getBoundingClientRect().right > t.getBoundingClientRect().right ? n : t,
  void 0
), ume = ({ root: e, tab: t }) => t.getBoundingClientRect().right - e.getBoundingClientRect().left - e.clientLeft + e.scrollLeft, wT = (e) => Number.parseFloat(e) || 0, hme = ({ root: e, tabs: t }) => {
  const n = dme(t);
  if (!n)
    return e.clientWidth;
  const a = wT(getComputedStyle(n).marginRight), o = wT(getComputedStyle(e).paddingRight);
  return Math.max(e.clientWidth, ume({ root: e, tab: n }) + a + o);
}, pme = ({ activeTab: e, tabItems: t, layoutKey: n }) => {
  const a = fe(null), o = fe(null), i = fe(null), c = fe({}), s = Q(() => {
    const u = c.current[e], h = o.current;
    if (u && h) {
      const { offsetLeft: y, offsetWidth: m } = u;
      h.style.left = `${y}px`, h.style.width = `${m}px`;
    }
    const k = a.current, f = i.current;
    k && f && (f.style.width = `${hme({ root: k, tabs: CT(c.current) })}px`);
  }, [e]), l = Q(({ name: u, element: h }) => {
    c.current[u] = h;
  }, []);
  return le(() => {
    s();
  }, [s, t, n]), le(() => {
    const u = a.current;
    if (!u || typeof ResizeObserver > "u")
      return;
    const h = new ResizeObserver(() => {
      s();
    });
    return h.observe(u), CT(c.current).forEach((k) => {
      h.observe(k);
    }), () => {
      h.disconnect();
    };
  }, [s, t]), { refRoot: a, refUnderline: o, refTrackLine: i, registerTab: l };
}, Pge = ({ tabItems: e, activeTab: t, onTabChange: n, className: a, classNames: o, hasTrackLine: i, "data-testid": c }) => {
  const s = Ve(() => JSON.stringify([a, o, i]), [a, o, i]), { refRoot: l, refUnderline: u, refTrackLine: h, registerTab: k } = pme({ activeTab: t, tabItems: e, layoutKey: s });
  return /* @__PURE__ */ C("div", { ref: l, className: Q5e(a), "data-testid": c, children: [
    e.map((f) => /* @__PURE__ */ p(
      lme,
      {
        tab: f,
        isActive: t === f.name,
        onTabChange: n,
        registerTab: k,
        classNames: o,
        rootTestId: c
      },
      f.name
    )),
    i ? /* @__PURE__ */ p(
      "span",
      {
        ref: h,
        "aria-hidden": "true",
        className: eme(o == null ? void 0 : o.trackLine),
        "data-testid": c ? `${c}-TrackLine` : void 0
      }
    ) : null,
    /* @__PURE__ */ p(
      "span",
      {
        ref: u,
        className: J5e(o == null ? void 0 : o.underline),
        "data-testid": c ? `${c}-Underline` : void 0
      }
    )
  ] });
};
var U1 = /* @__PURE__ */ ((e) => (e.RESET = "Reset", e.SEARCH = "Search", e.INCLUDE = "Include", e.EXCLUDE = "Exclude", e.DEFAULT = "Default", e))(U1 || {});
function yme({
  variant: e = ut.DEFAULT,
  label: t = "",
  value: n = "",
  count: a = null,
  actionHandler: o = () => null,
  className: i = "",
  ...c
}) {
  const s = e === ut.DEFAULT, l = e === ut.INCLUDE, u = e === ut.EXCLUDE, h = () => {
    const y = e === ut.EXCLUDE ? U1.EXCLUDE : U1.INCLUDE;
    o(y, n);
  }, k = () => {
    o(U1.INCLUDE, n);
  }, f = () => {
    o(U1.EXCLUDE, n);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      onClick: h,
      className: `
        flex items-center justify-between
        min-w-[200px] px-2.5 py-1
        cursor-pointer
        transition-colors duration-200
        ${i}
        ${!s && "bg-gray-6"}
      `,
      ...c,
      children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2 flex-shrink", children: [
          /* @__PURE__ */ p(Nt, { title: "Include", visible: s, children: /* @__PURE__ */ p(
            gi,
            {
              id: `include_${n}`,
              size: me.SMALL,
              checked: l,
              className: `flex items-center ${l && "!bg-blue-2 !border-blue-5"} ${u && "!bg-gray-4 !border-gray-7/20 dark:!border-gray-6/10 dark:!bg-gray-4"} ${s && "!bg-gray-3 !border-gray-7/30 dark:!border-gray-6"}`,
              classNames: {
                icon: "!text-black dark:!text-white"
              },
              disabled: u,
              icon: R.PLUS,
              onChange: k,
              onClick: (y) => y == null ? void 0 : y.stopPropagation()
            }
          ) }),
          /* @__PURE__ */ C("div", { className: "flex items-center gap-1 cursor-pointer select-none break-all", children: [
            /* @__PURE__ */ p(
              q,
              {
                as: "label",
                htmlFor: u ? `exclude_${n}` : `include_${n}`,
                variant: x.LABEL_LARGE_REGULAR,
                className: "text-gray-900 dark:text-white flex-shrink line-clamp-1",
                children: t
              }
            ),
            a !== null && /* @__PURE__ */ p(
              q,
              {
                variant: x.LABEL_SMALL_REGULAR,
                className: "text-gray-8 dark:text-gray-12/80 italic align-bottom whitespace-nowrap mr-1",
                children: a
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ p(Nt, { title: "Exclude", visible: s, children: /* @__PURE__ */ p(
          gi,
          {
            id: `exclude_${n}`,
            size: me.SMALL,
            checked: u,
            className: `flex items-center ${u && "!bg-red-2 !border-red-5"} ${s && "!bg-gray-6/80 !border-gray-6/10"} ${l && "!bg-gray-7/10 !border-gray-6/10"}`,
            classNames: {
              icon: `${(s || l) && "!text-black/40 dark:!text-white"} ${u && "!text-black dark:!text-white"} ${l && "opacity-50 dark:opacity-30"} `
            },
            disabled: l,
            icon: R.MINUS,
            onChange: f,
            indeterminate: !0,
            onClick: (y) => y == null ? void 0 : y.stopPropagation()
          }
        ) })
      ]
    }
  );
}
const kme = he.memo(yme);
function fme({ oldTags: e, newTags: t }) {
  return EN({ oldTags: e, newTags: t }).flatMap(
    (a) => a.value.map((o) => ({
      tag: o,
      status: a.added ? q1.ADDED : a.removed ? q1.REMOVED : q1.UNCHANGED
    }))
  );
}
const mme = ({
  className: e,
  label: t,
  optional: n = !1,
  description: a,
  oldTags: o,
  newTags: i,
  variant: c,
  isBadgeHidden: s = !1,
  size: l = We.MEDIUM,
  isDisabled: u = !1
}) => {
  const h = Ve(() => fme({ oldTags: o, newTags: i }), [o, i]);
  return /* @__PURE__ */ C("div", { className: P("flex flex-col w-full flex-shrink", PN[l], e), "data-testid": "TagDiff", children: [
    t || a || c && !s ? /* @__PURE__ */ p(Gv, { label: t, description: a, optional: n, variant: c, isBadgeHidden: s, size: l }) : null,
    /* @__PURE__ */ p(
      "div",
      {
        className: P(
          "flex flex-wrap rounded-md",
          V0e[l],
          ON[l],
          c === Et.SUBMITTED ? "bg-yellow-2" : "bg-gray-4",
          c === Et.BASIC && "!p-0 bg-transparent"
        ),
        children: h.map(({ tag: k, status: f }, y) => {
          const m = f === q1.UNCHANGED ? Ze.DEFAULT : Ze.OUTLINED;
          let g;
          if (f === q1.ADDED) {
            if (g = ac.SUCCESS, c === Et.BASIC)
              return /* @__PURE__ */ C(q, { variant: x.LABEL_XSMALL_REGULAR, className: u ? "text-gray-10" : "text-green-10", children: [
                "+ ",
                k
              ] }, `${k}-${y}`);
          } else if (f === q1.REMOVED && (g = ac.ERROR, c === Et.BASIC))
            return /* @__PURE__ */ C(q, { variant: x.LABEL_XSMALL_REGULAR, className: u ? "text-gray-10" : "text-red-9", children: [
              "- ",
              k
            ] }, `${k}-${y}`);
          return c === Et.BASIC ? null : /* @__PURE__ */ p(
            Vt,
            {
              variant: m,
              color: g,
              size: Y0e[l],
              classNames: { text: u ? "!text-gray-10 dark:!text-gray-10" : void 0 },
              children: k
            },
            `${k}-${y}`
          );
        })
      }
    )
  ] });
}, Hge = he.memo(mme), tn = 100, oa = 3, Bge = ({
  label: e,
  description: t,
  placeholder: n = "Type and press Enter to add tags",
  selectedValues: a = [],
  onChange: o,
  disabled: i = !1,
  error: c = !1,
  errorMessage: s = "",
  maxCount: l,
  helperText: u,
  allowDuplicates: h = !1,
  required: k = !1,
  width: f = "100%",
  tooltipLabel: y = "",
  readOnly: m = !1
}) => {
  const [g, _] = ae(""), [L, N] = ae(!1), [I, S] = ae(""), O = fe(null), A = (U) => {
    const Z = U.map((E) => E.trim()).filter((E) => E.length > 0);
    if (Z.length === 0)
      return !1;
    const te = [...a];
    let re = !1, ue = "";
    for (const E of Z) {
      if (E.length > tn) {
        ue || (ue = `Maximum tag length is ${tn} characters.`);
        continue;
      }
      if (E.length < oa) {
        ue || (ue = `Must be at least ${oa} characters.`);
        continue;
      }
      if (!(!h && te.includes(E))) {
        if (l && te.length >= l) {
          ue || (ue = `Maximum ${l} tags reached.`);
          break;
        }
        te.push(E), re = !0;
      }
    }
    return re && (o == null || o(te), _("")), ue ? S(ue) : re && S(""), re;
  }, B = (U) => {
    if (/[,\n\r]/.test(U)) {
      A(U.split(/[,\n\r]+/));
      return;
    }
    U.length > tn ? (S(`Maximum tag length is ${tn} characters.`), U = U.slice(0, tn)) : S(""), _(U);
  }, z = (U) => {
    A([U]);
  }, j = (U) => {
    const Z = a.filter((te) => te !== U);
    o == null || o(Z);
  }, G = (U) => {
    const Z = g.trim();
    if (U.key === "Enter" || U.key === ",") {
      if (U.preventDefault(), Z.length < oa) {
        Z.length > 0 ? S(`Tag must be at least ${oa} characters.`) : S("");
        return;
      }
      if (Z.length > tn) {
        S(`Maximum tag length is ${tn} characters.`);
        return;
      }
      z(g);
    } else if (U.key === "Backspace" && g === "" && a.length > 0) {
      const te = a[a.length - 1];
      j(te);
    }
  }, $ = () => {
    i || (o == null || o([]), _(""), S(""));
  }, H = (U) => {
    j(U);
  }, ee = () => {
    N(!0);
  }, Y = () => {
    N(!1);
    const U = g.trim();
    U.length > 0 && U.length < oa ? S(`Tag must be at least ${oa} characters.`) : U.length >= oa && U.length <= tn ? z(U) : U.length > tn && S(`Maximum tag length is ${tn} characters.`);
  };
  return /* @__PURE__ */ C(
    "div",
    {
      className: "flex flex-col gap-1.5 w-full flex-shrink",
      style: {
        maxWidth: f
      },
      children: [
        /* @__PURE__ */ p(
          Vv,
          {
            label: e,
            description: m ? "" : t,
            required: m ? !1 : k,
            size: me.MEDIUM,
            tooltipLabel: m ? "" : y
          }
        ),
        /* @__PURE__ */ C(
          "div",
          {
            className: P(
              "relative w-full min-h-11 px-3 py-1  ring-1 ring-gray-8 rounded-md bg-transparent flex flex-wrap items-center gap-2",
              c ? "ring-2 ring-red-9 ring-inset" : L ? "border-blue-10 ring-2 ring-inset" : "ring-1 ring-gray-7 dark:ring-gray-8 ring-inset",
              i && "opacity-50 cursor-not-allowed !bg-transparent",
              m && "bg-gray-4 cursor-default !ring-gray-4 dark:!ring-gray-4"
            ),
            onClick: () => {
              var U;
              return !i && ((U = O.current) == null ? void 0 : U.focus());
            },
            children: [
              a.map((U, Z) => /* @__PURE__ */ p(
                Vt,
                {
                  size: dt.MEDIUM,
                  variant: Ze.DEFAULT,
                  iconEnd: m ? void 0 : R.CLOSE,
                  onClick: () => !i && !m && H(U),
                  onMouseDown: (te) => {
                    te.preventDefault();
                  },
                  className: P("cursor-pointer", i && "cursor-not-allowed opacity-50", m && "cursor-default"),
                  children: U
                },
                `${U}-${Z}`
              )),
              m ? null : /* @__PURE__ */ p(
                "input",
                {
                  ref: O,
                  type: "text",
                  value: g,
                  onChange: (U) => B(U.target.value),
                  onKeyDown: G,
                  onFocus: ee,
                  onBlur: Y,
                  placeholder: l && a.length >= l ? `Maximum ${l} tags reached` : a.length === 0 ? n : "Type to add more...",
                  maxLength: tn,
                  disabled: i || l && a.length >= l,
                  className: "flex-grow min-w-0 outline-none bg-transparent text-sm"
                }
              ),
              !m && a.length > 0 ? /* @__PURE__ */ p(
                "button",
                {
                  type: "button",
                  onClick: $,
                  className: P(
                    "inline-flex items-center justify-center transition-all duration-200 rounded-full bg-transparent text-black dark:text-white size-auto flex-shrink-0",
                    i && "cursor-not-allowed opacity-50"
                  ),
                  "aria-label": "Clear all tags",
                  disabled: i,
                  children: /* @__PURE__ */ p(oe, { icon: R.CLOSE, size: ye.MEDIUM })
                }
              ) : null
            ]
          }
        ),
        m ? null : /* @__PURE__ */ p(
          jv,
          {
            helperText: I || u,
            error: I ? !0 : c || (l ? a.length > l : !1),
            errorMessage: s,
            maxLength: l,
            characterLength: a.length
          }
        )
      ]
    }
  );
};
function gme(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var bw = gme, Mme = typeof Wn == "object" && Wn && Wn.Object === Object && Wn, _me = Mme, bme = _me, Lme = typeof self == "object" && self && self.Object === Object && self, xme = bme || Lme || Function("return this")(), Lw = xme, Eme = Lw, vme = function() {
  return Eme.Date.now();
}, Ame = vme, Ime = /\s/;
function Tme(e) {
  for (var t = e.length; t-- && Ime.test(e.charAt(t)); )
    ;
  return t;
}
var Nme = Tme, Cme = Nme, wme = /^\s+/;
function Sme(e) {
  return e && e.slice(0, Cme(e) + 1).replace(wme, "");
}
var Rme = Sme, Dme = Lw, Ome = Dme.Symbol, xw = Ome, ST = xw, Ew = Object.prototype, Pme = Ew.hasOwnProperty, Hme = Ew.toString, $i = ST ? ST.toStringTag : void 0;
function Bme(e) {
  var t = Pme.call(e, $i), n = e[$i];
  try {
    e[$i] = void 0;
    var a = !0;
  } catch {
  }
  var o = Hme.call(e);
  return a && (t ? e[$i] = n : delete e[$i]), o;
}
var Fme = Bme, $me = Object.prototype, Ume = $me.toString;
function qme(e) {
  return Ume.call(e);
}
var zme = qme, RT = xw, jme = Fme, Vme = zme, Gme = "[object Null]", Wme = "[object Undefined]", DT = RT ? RT.toStringTag : void 0;
function Xme(e) {
  return e == null ? e === void 0 ? Wme : Gme : DT && DT in Object(e) ? jme(e) : Vme(e);
}
var Yme = Xme;
function Kme(e) {
  return e != null && typeof e == "object";
}
var Zme = Kme, Qme = Yme, Jme = Zme, e6e = "[object Symbol]";
function t6e(e) {
  return typeof e == "symbol" || Jme(e) && Qme(e) == e6e;
}
var n6e = t6e, a6e = Rme, OT = bw, o6e = n6e, PT = NaN, r6e = /^[-+]0x[0-9a-f]+$/i, i6e = /^0b[01]+$/i, c6e = /^0o[0-7]+$/i, s6e = parseInt;
function l6e(e) {
  if (typeof e == "number")
    return e;
  if (o6e(e))
    return PT;
  if (OT(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = OT(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = a6e(e);
  var n = i6e.test(e);
  return n || c6e.test(e) ? s6e(e.slice(2), n ? 2 : 8) : r6e.test(e) ? PT : +e;
}
var d6e = l6e, u6e = bw, ZE = Ame, HT = d6e, h6e = "Expected a function", p6e = Math.max, y6e = Math.min;
function k6e(e, t, n) {
  var a, o, i, c, s, l, u = 0, h = !1, k = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(h6e);
  t = HT(t) || 0, u6e(n) && (h = !!n.leading, k = "maxWait" in n, i = k ? p6e(HT(n.maxWait) || 0, t) : i, f = "trailing" in n ? !!n.trailing : f);
  function y(A) {
    var B = a, z = o;
    return a = o = void 0, u = A, c = e.apply(z, B), c;
  }
  function m(A) {
    return u = A, s = setTimeout(L, t), h ? y(A) : c;
  }
  function g(A) {
    var B = A - l, z = A - u, j = t - B;
    return k ? y6e(j, i - z) : j;
  }
  function _(A) {
    var B = A - l, z = A - u;
    return l === void 0 || B >= t || B < 0 || k && z >= i;
  }
  function L() {
    var A = ZE();
    if (_(A))
      return N(A);
    s = setTimeout(L, g(A));
  }
  function N(A) {
    return s = void 0, f && a ? y(A) : (a = o = void 0, c);
  }
  function I() {
    s !== void 0 && clearTimeout(s), u = 0, a = l = o = s = void 0;
  }
  function S() {
    return s === void 0 ? c : N(ZE());
  }
  function O() {
    var A = ZE(), B = _(A);
    if (a = arguments, o = this, l = A, B) {
      if (s === void 0)
        return m(l);
      if (k)
        return clearTimeout(s), s = setTimeout(L, t), y(l);
    }
    return s === void 0 && (s = setTimeout(L, t)), c;
  }
  return O.cancel = I, O.flush = S, O;
}
var f6e = k6e;
const m6e = /* @__PURE__ */ yE(f6e);
function BT({
  title: e = "Narrow by tag",
  searchPlaceholder: t = "Search tags",
  resetLabel: n = "Reset",
  data: a = [],
  actionHandler: o = () => null,
  style: i
}) {
  const { isDesktop: s } = Dn(), [l, u] = ae(""), h = a == null ? void 0 : a.filter(
    (y) => {
      var m, g;
      return (g = (m = y == null ? void 0 : y.value) == null ? void 0 : m.toLowerCase()) == null ? void 0 : g.includes(l == null ? void 0 : l.toLowerCase());
    }
  ), k = h.some(
    (y) => (y == null ? void 0 : y.variant) && y.variant !== ut.DEFAULT
  ), f = Q(
    m6e((y) => {
      u(y), o(U1.SEARCH, y);
    }, 300),
    [o]
  );
  return /* @__PURE__ */ p(
    "div",
    {
      className: "flex flex-col flex-grow flex-shrink w-full",
      style: { ...i, maxHeight: s ? 720 : "100%" },
      children: /* @__PURE__ */ C(
        "div",
        {
          className: `
        border border-solid border-gray-7/40 dark:border-gray-8
        rounded-md flex-shrink h-full flex flex-col overflow-hidden`,
          children: [
            /* @__PURE__ */ C("div", { className: "flex justify-between items-center px-2.5 py-2.5 bg-gray-5 ", children: [
              /* @__PURE__ */ p(
                q,
                {
                  variant: x.LABEL_MEDIUM_MEDIUM,
                  className: "text-gray-900 dark:text-white",
                  children: e
                }
              ),
              k && /* @__PURE__ */ p(
                "button",
                {
                  onClick: () => o(U1.RESET, ""),
                  className: "text-sm text-blue-10 cursor-pointer bg-transparent",
                  children: /* @__PURE__ */ p(q, { variant: x.LABEL_MEDIUM_REGULAR, children: n })
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: "p-2.5", children: /* @__PURE__ */ p(
              xi,
              {
                isClearable: !!l,
                onChange: f,
                size: me.XSMALL,
                placeholder: t
              }
            ) }),
            /* @__PURE__ */ p("div", { id: "tagListScroller", className: "overflow-y-auto overflow-x-hidden", children: h.map((y, m) => /* @__PURE__ */ p(
              kme,
              {
                label: y.label,
                value: y.value,
                count: y.count,
                variant: y.variant,
                actionHandler: o
              },
              `${y.value}_${y.variant}_${m}`
            )) })
          ]
        }
      )
    }
  );
}
function Fge({
  title: e,
  searchPlaceholder: t,
  resetLabel: n,
  data: a = [],
  open: o = !1,
  setOpen: i = () => null,
  actionHandler: c = () => null
}) {
  const { isDesktop: s } = Dn(), l = s ? 220 : 274;
  return s ? /* @__PURE__ */ p(
    BT,
    {
      title: e,
      searchPlaceholder: t,
      resetLabel: n,
      data: a,
      actionHandler: c,
      style: { width: l }
    }
  ) : /* @__PURE__ */ p(
    mE,
    {
      open: o,
      onOpenChange: i,
      position: tt.RIGHT,
      className: "p-2.5 bg-gray-3",
      style: { width: l },
      children: /* @__PURE__ */ p(
        BT,
        {
          title: e,
          searchPlaceholder: t,
          resetLabel: n,
          data: a,
          actionHandler: c,
          style: { maxWidth: l }
        }
      )
    }
  );
}
const g6e = /^(label|paragraph|heading|mobile-heading|display)-/, M6e = ["sm", "md", "lg", "xl"], _6e = (e) => g6e.test(e), FT = pc({
  extend: {
    theme: {
      spacing: M6e
    },
    classGroups: {
      "font-size": [{ text: [_6e] }]
    }
  }
}), iE = ({ base: e, override: t }) => {
  const n = wn(e);
  if (!(t != null && t.trim()))
    return n;
  const a = FT(t), o = new Set(a.split(" "));
  return [...n.split(/\s+/).filter((c) => c && !o.has(c)).filter((c) => FT(`${c} ${a}`).split(" ").includes(c)), a].join(" ");
};
var yA = /* @__PURE__ */ ((e) => (e.DEFAULT = "Default", e.EDITOR = "Editor", e))(yA || {});
const $T = {
  [me.XSMALL]: "text-sm",
  [me.SMALL]: "text-label-lg",
  [me.MEDIUM]: "text-label-lg"
}, cE = "col-start-1 col-end-2 row-start-1 row-end-2", vw = "whitespace-pre-wrap break-words invisible overflow-hidden", b6e = "ring-2 ring-red-9 ring-inset", L6e = "ring-2 ring-blue-10 ring-inset", x6e = "ring-1 ring-gray-8 ring-inset", E6e = "opacity-50 cursor-not-allowed !bg-transparent", v6e = "bg-transparent text-gray-12 placeholder:text-gray-10 disabled:cursor-not-allowed focus:outline-none", A6e = "!cursor-default ring-gray-4 !bg-gray-4 dark:ring-gray-4", UT = "px-3 py-[9px] text-[13px] leading-[1.45]", I6e = "w-full rounded-[8px] border border-solid bg-gray-3 text-gray-12 placeholder:text-gray-11 focus:outline-none transition-colors duration-200", T6e = "border-red-9", N6e = "border-blue-10", C6e = "border-gray-8", w6e = "opacity-50 cursor-not-allowed", S6e = "bg-gray-4 border-gray-4 cursor-default", R6e = "border border-solid border-transparent", Aw = {
  none: "resize-none",
  vertical: "resize-y"
}, Iw = ({ autoResize: e, isOverflowing: t }) => !e || t ? "overflow-y-auto" : "overflow-hidden", Tw = ({
  error: e,
  isFocused: t,
  classNames: n
}) => e ? n.error : t ? n.focused : n.idle, D6e = ({
  error: e,
  isFocused: t,
  disabled: n,
  readOnly: a,
  autoResize: o,
  isOverflowing: i,
  resize: c,
  className: s
}) => ({
  textarea: iE({
    base: [
      cE,
      UT,
      I6e,
      Tw({
        error: e,
        isFocused: t,
        classNames: { error: T6e, focused: N6e, idle: C6e }
      }),
      n ? w6e : "",
      a && !n ? S6e : "",
      Aw[c],
      Iw({ autoResize: o, isOverflowing: i })
    ],
    override: s
  }),
  mirror: iE({ base: [cE, R6e, UT, vw], override: s })
}), O6e = ({
  size: e,
  error: t,
  isFocused: n,
  disabled: a,
  readOnly: o,
  autoResize: i,
  isOverflowing: c,
  resize: s,
  className: l
}) => ({
  textarea: iE({
    base: [
      cE,
      "p-2.5 rounded-md bg-transparent",
      $T[e],
      Tw({
        error: t,
        isFocused: n,
        classNames: { error: b6e, focused: L6e, idle: x6e }
      }),
      a ? E6e : "",
      "transition-colors duration-200 flex-shrink",
      v6e,
      Aw[s],
      "border-0",
      o ? A6e : "",
      Iw({ autoResize: i, isOverflowing: c })
    ],
    override: l
  }),
  mirror: iE({ base: [cE, "p-2.5", $T[e], vw], override: l })
}), P6e = (e) => e.variant === yA.EDITOR ? D6e(e) : O6e(e), H6e = 1.5, B6e = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.lineHeight), a = isNaN(n) ? parseFloat(t.fontSize) * H6e : n, o = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom) + (parseFloat(t.borderTopWidth) || 0) + (parseFloat(t.borderBottomWidth) || 0);
  return { lineHeight: a, paddingY: o };
}, F6e = ({ rows: e, maxRows: t, variant: n, size: a, className: o, value: i }) => {
  const c = fe(null), [s, l] = ae(void 0), [u, h] = ae(void 0), [k, f] = ae(!1);
  return Sn(() => {
    if (!c.current) return;
    const { lineHeight: y, paddingY: m } = B6e(c.current);
    l(e * y + m), h(t ? t * y + m : void 0);
  }, [e, t, n, a, o]), Sn(() => {
    if (!c.current || !u) {
      f(!1);
      return;
    }
    f(c.current.scrollHeight > u);
  }, [i, u]), { refMirror: c, minHeight: s, maxHeight: u, isOverflowing: k };
}, QE = (e) => e ? `${e}px` : void 0, $6e = ({ autoResize: e, minHeight: t, maxHeight: n, style: a }) => {
  const o = Ve(
    () => ({
      minHeight: e ? QE(t) : void 0
    }),
    [e, t]
  ), i = Ve(
    () => ({
      ...a,
      maxHeight: e ? QE(n) : void 0
    }),
    [a, e, n]
  ), c = Ve(
    () => ({
      maxHeight: QE(n)
    }),
    [n]
  );
  return { wrapperStyle: o, textareaStyle: i, mirrorStyle: c };
}, U6e = ({ disabled: e, focused: t, onFocus: n, onBlur: a }) => {
  const [o, i] = ae(!1), c = Q(
    (l) => {
      e || (n == null || n(l), i(!0));
    },
    [e, n]
  ), s = Q(
    (l) => {
      e || (a == null || a(l), i(!1));
    },
    [e, a]
  );
  return { isComponentFocused: !!(t || o), handleFocus: c, handleBlur: s };
}, q6e = ({
  size: e = me.MEDIUM,
  variant: t = yA.DEFAULT,
  resize: n = "none",
  placeholder: a = "Enter something",
  error: o,
  disabled: i = !1,
  onChange: c,
  onFocus: s,
  onBlur: l,
  className: u = "",
  focused: h,
  value: k,
  rows: f = 3,
  maxRows: y,
  autoResize: m = !0,
  maxLength: g,
  readOnly: _,
  ...L
}) => {
  const { isComponentFocused: N, handleFocus: I, handleBlur: S } = U6e({ disabled: i, focused: h, onFocus: s, onBlur: l }), { refMirror: O, minHeight: A, maxHeight: B, isOverflowing: z } = F6e({ rows: f, maxRows: y, variant: t, size: e, className: u, value: k }), { wrapperStyle: j, textareaStyle: G, mirrorStyle: $ } = $6e({ autoResize: m, minHeight: A, maxHeight: B, style: L.style }), H = P6e({
    variant: t,
    size: e,
    error: o,
    isFocused: N,
    disabled: i,
    readOnly: _,
    autoResize: m,
    isOverflowing: z,
    resize: n,
    className: u
  });
  return /* @__PURE__ */ C("div", { className: "grid", style: j, children: [
    /* @__PURE__ */ p(
      "textarea",
      {
        value: k,
        onChange: c,
        placeholder: a,
        disabled: i || _,
        rows: m ? 1 : f,
        maxLength: g,
        className: H.textarea,
        ...L,
        style: G,
        onFocus: I,
        onBlur: S
      }
    ),
    m ? /* @__PURE__ */ p("span", { ref: O, translate: "no", className: H.mirror, style: $, children: `${k || a} ` }) : null
  ] });
}, Ui = (e) => !!(e && e > 0), qi = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, z6e = (e) => {
  var t, n;
  return ((n = (t = e == null ? void 0 : e.toString()) == null ? void 0 : t.trim()) == null ? void 0 : n.length) || 0;
}, j6e = ({ value: e, debounceTimeout: t, onChange: n }) => {
  const [a, o] = ae(e || ""), i = e !== void 0, c = Ui(t), s = i && !c ? e : a, l = fe(null), u = fe((s == null ? void 0 : s.toString()) || "");
  le(() => {
    i && Ui(t) && (o(e || ""), qi(l), u.current = (e || "").toString());
  }, [e, i, t]), le(() => {
    Ui(t) || qi(l);
  }, [t]), le(() => () => qi(l), []);
  const h = Q(
    (k) => {
      const f = k.target.value;
      if ((!i || Ui(t)) && o(f), !Ui(t)) {
        qi(l), n == null || n(f);
        return;
      }
      u.current = f, qi(l), l.current = setTimeout(() => {
        n == null || n(u.current);
      }, t);
    },
    [i, t, n]
  );
  return { currentInputValue: s, characterLength: z6e(s), handleChange: h };
}, V6e = ({
  error: e = !1,
  width: t,
  label: n = "",
  description: a = "",
  helperText: o = "",
  onChange: i,
  value: c,
  errorMessage: s,
  required: l = !1,
  maxLength: u,
  countLabel: h,
  count: k,
  labelRightElement: f,
  showMaxLengthLabel: y = !0,
  hideEmptyFooter: m,
  fieldInfoLink: g,
  fieldInfoLinkTarget: _,
  tooltipLabel: L,
  debounceTimeout: N,
  readOnly: I = !1,
  ...S
}) => {
  const { currentInputValue: O, characterLength: A, handleChange: B } = j6e({ value: c, debounceTimeout: N, onChange: i }), z = I || m && !AN({ error: e, errorMessage: s, helperText: o, maxLength: u, showMaxLengthLabel: y, count: k, countLabel: h }), j = Ve(() => ({ maxWidth: t || "100%" }), [t]);
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-1.5 w-full flex-shrink", style: j, children: [
    /* @__PURE__ */ p(
      Vv,
      {
        label: n,
        description: I ? "" : a,
        labelRightElement: I ? null : f,
        size: me.MEDIUM,
        required: I ? !1 : l,
        fieldInfoLink: g,
        fieldInfoLinkTarget: _,
        tooltipLabel: I ? "" : L
      }
    ),
    /* @__PURE__ */ p(q6e, { ...S, value: O, onChange: B, error: e, readOnly: I, maxLength: u }),
    z ? null : /* @__PURE__ */ p(
      jv,
      {
        error: e,
        errorMessage: s,
        helperText: o,
        maxLength: u,
        count: k,
        countLabel: h,
        characterLength: A,
        showMaxLengthLabel: y
      }
    )
  ] });
};
V6e.displayName = "TextArea";
const G6e = 1, W6e = ({ node: e, maxLines: t }) => {
  const n = e.style.cssText;
  e.style.setProperty("overflow", "hidden"), e.style.setProperty("-webkit-line-clamp", String(t));
  const a = e.scrollHeight - e.clientHeight > G6e;
  return e.style.cssText = n, a;
};
function X6e({ text: e, maxLines: t }) {
  const n = fe(null), [a, o] = ae(!1), i = Q(() => {
    const c = n.current;
    c && o(W6e({ node: c, maxLines: t }));
  }, [t]);
  return Sn(() => {
    i();
    const c = n.current;
    if (!c || typeof ResizeObserver > "u")
      return;
    const s = new ResizeObserver(i);
    return s.observe(c), () => {
      s.disconnect();
    };
  }, [e, i]), { refText: n, isOverflowing: a };
}
const Nw = 3;
function Cw(e) {
  const t = {
    display: "-webkit-box",
    overflow: e ? "visible" : "hidden",
    textOverflow: "ellipsis"
  };
  return t.WebkitBoxOrient = "vertical", e || (t.WebkitLineClamp = Nw), t;
}
const Y6e = Cw(!1), K6e = Cw(!0);
function $ge({
  text: e,
  label: t,
  active: n,
  collapsed: a = !0,
  showMoreLabel: o = "SHOW MORE",
  showLessLabel: i = "SHOW LESS",
  "data-testid": c = "TextBox"
}) {
  const [s, l] = ae(!a), { refText: u, isOverflowing: h } = X6e({ text: e, maxLines: Nw }), k = Q(() => {
    l((f) => !f);
  }, []);
  return le(() => {
    l(!a);
  }, [a]), /* @__PURE__ */ C("div", { className: "w-full flex flex-col gap-[7px]", "data-testid": c, children: [
    /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_MEDIUM, className: "text-gray-11", children: t }),
    /* @__PURE__ */ C("div", { className: "bg-gray-2 dark:bg-gray-4 rounded-md p-md", children: [
      /* @__PURE__ */ p(
        q,
        {
          variant: x.PARAGRAPH_MEDIUM_REGULAR,
          ref: u,
          className: `[overflow-wrap:anywhere] ${n ? "text-cyan-600" : "text-gray-12"} m-0 p-0`,
          style: s ? K6e : Y6e,
          "data-testid": `${c}-Text`,
          children: /* @__PURE__ */ p(Hfe, { children: e })
        }
      ),
      h ? /* @__PURE__ */ C(
        "button",
        {
          type: "button",
          onClick: k,
          className: "flex bg-transparent items-center gap-2 mt-2 text-xs text-gray-11 hover:text-primary-600 cursor-pointer",
          "data-testid": `${c}-Toggle`,
          children: [
            /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_MEDIUM, children: s ? i : o }),
            /* @__PURE__ */ p(oe, { icon: s ? R.CHEVRON_UP : R.CHEVRON_DOWN, size: ye.SMALL })
          ]
        }
      ) : null
    ] })
  ] });
}
function ww({ oldText: e, newText: t, compareType: n }) {
  return Ve(() => vN({ oldText: e, newText: t, compareType: n }), [e, t, n]);
}
function Z6e({ oldText: e = "", newText: t = "", compareType: n, size: a = We.MEDIUM, isDisabled: o = !1 }) {
  const i = ww({ oldText: e, newText: t, compareType: n }), c = i.filter((u) => !u.added), s = i.filter((u) => !u.removed), l = P(X0e[a], "whitespace-pre-wrap break-words", o ? "text-gray-10" : "text-gray-12");
  return /* @__PURE__ */ C("div", { className: "grid grid-cols-2 gap-2 w-full", "data-testid": "DiffContentSplit", children: [
    /* @__PURE__ */ p("div", { className: l, children: c.map(
      (u, h) => u.removed ? /* @__PURE__ */ p("span", { className: "text-red-9 line-through", children: u.value }, h) : /* @__PURE__ */ p("span", { children: u.value }, h)
    ) }),
    /* @__PURE__ */ p("div", { className: l, children: s.map(
      (u, h) => u.added ? /* @__PURE__ */ p("span", { className: "text-green-10", children: u.value }, h) : /* @__PURE__ */ p("span", { children: u.value }, h)
    ) })
  ] });
}
const Q6e = he.memo(Z6e);
function J6e({
  oldText: e = "",
  newText: t = "",
  compareType: n,
  variant: a,
  size: o = We.MEDIUM,
  isDisabled: i = !1
}) {
  const c = ww({ oldText: e, newText: t, compareType: n }), s = a === Et.BASIC ? x.LABEL_XSMALL_REGULAR : G0e[o];
  return /* @__PURE__ */ p(
    q,
    {
      variant: s,
      className: P(
        "whitespace-pre-wrap break-words",
        i ? "text-gray-10" : "text-gray-12",
        a === Et.BASIC && "flex flex-col"
      ),
      "data-testid": "DiffContentUnified",
      children: c.map((l, u) => l.added ? /* @__PURE__ */ p("span", { className: P("mx-0.5", i ? "text-gray-10" : "text-green-10"), children: l.value }, u) : l.removed ? /* @__PURE__ */ p("span", { className: P("line-through mx-0.5", i ? "text-gray-10" : "text-red-9"), children: l.value }, u) : /* @__PURE__ */ p("span", { children: l.value }, u))
    }
  );
}
const ege = he.memo(J6e);
var Rv = /* @__PURE__ */ ((e) => (e.SPLIT = "split", e.UNIFIED = "unified", e))(Rv || {});
function tge({ isEnabled: e, contentKey: t, isDefaultExpanded: n = !1 }) {
  const a = fe(null), o = fe(!1), [i, c] = ae(!1), [s, l] = ae(!1);
  Sn(() => {
    c(!1), o.current = !1;
  }, [t]), Sn(() => {
    if (!e) {
      l(!1);
      return;
    }
    const h = a.current;
    if (!h)
      return;
    if (i) {
      l(!0);
      return;
    }
    const k = h.scrollHeight > h.clientHeight;
    l(k), k && n && !o.current && (o.current = !0, c(!0));
  }, [e, i, t, n]);
  const u = Q(() => {
    c((h) => !h);
  }, []);
  return {
    refContent: a,
    stateIsExpanded: i,
    stateIsOverflowing: s,
    handleToggleExpand: u
  };
}
const nge = ({
  className: e,
  layout: t = Rv.UNIFIED,
  label: n,
  optional: a = !1,
  description: o,
  oldText: i,
  newText: c,
  compareType: s = di.WORDS,
  variant: l,
  isExpandable: u = !1,
  isDefaultExpanded: h = !1,
  isBadgeHidden: k = !1,
  size: f = We.MEDIUM,
  isDisabled: y = !1
}) => {
  const { refContent: m, stateIsExpanded: g, stateIsOverflowing: _, handleToggleExpand: L } = tge({
    isEnabled: u,
    isDefaultExpanded: h,
    contentKey: `${i ?? ""}\0${c ?? ""}`
  }), N = u && !g, I = i ?? "", S = c ?? "", O = t === Rv.UNIFIED ? /* @__PURE__ */ p(
    ege,
    {
      oldText: I,
      newText: S,
      compareType: s,
      variant: l,
      size: f,
      isDisabled: y
    }
  ) : /* @__PURE__ */ p(Q6e, { oldText: I, newText: S, compareType: s, size: f, isDisabled: y });
  return /* @__PURE__ */ C("div", { className: P("flex flex-col w-full flex-shrink", PN[f], e), "data-testid": "TextDiff", children: [
    /* @__PURE__ */ p(Gv, { label: n, description: o, optional: a, variant: l, isBadgeHidden: k, size: f }),
    /* @__PURE__ */ p(
      "div",
      {
        className: P(
          "flex flex-col rounded-md bg-gray-4",
          ON[f],
          l === Et.BASIC && "!p-0",
          l === Et.SUBMITTED && "bg-yellow-2",
          l === Et.BASIC && "bg-transparent"
        ),
        role: "document",
        "aria-readonly": "true",
        children: u ? /* @__PURE__ */ C(at, { children: [
          /* @__PURE__ */ p("div", { ref: m, className: P(N && K0e[f]), children: O }),
          _ ? /* @__PURE__ */ C(
            "button",
            {
              type: "button",
              onClick: L,
              className: "flex bg-transparent items-center gap-2 mt-2 text-xs text-gray-11 hover:text-primary-600 cursor-pointer",
              "data-testid": "TextDiff-ExpandButton",
              "aria-expanded": g,
              children: [
                /* @__PURE__ */ p(q, { variant: x.LABEL_SMALL_MEDIUM, className: y ? "text-gray-10" : void 0, children: g ? "SHOW LESS" : "SHOW MORE" }),
                /* @__PURE__ */ p(oe, { icon: g ? R.CHEVRON_UP : R.CHEVRON_DOWN, size: ye.SMALL })
              ]
            }
          ) : null
        ] }) : O
      }
    )
  ] });
}, Uge = he.memo(nge);
var age = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(age || {});
const Sw = ({
  mode: e = "secondary",
  onPrimaryClick: t,
  onSecondaryClick: n,
  disabled: a = !1,
  primaryLabel: o = "Save Members",
  secondaryLabel: i = "Add Members",
  primaryIcon: c,
  secondaryIcon: s = R.USERS,
  className: l = "",
  classNames: u = {}
}) => {
  const h = e === "primary", k = h ? o : i, f = h ? t : n, y = h ? J.INVERSE : J.OUTLINED, m = h ? c : s;
  return /* @__PURE__ */ p(
    nt,
    {
      variant: y,
      size: _e.MEDIUM,
      onClick: f,
      disabled: a,
      className: P(
        "flex items-center",
        l,
        u.button
      ),
      children: /* @__PURE__ */ C("span", { className: "flex items-center justify-center", children: [
        m && /* @__PURE__ */ p(
          oe,
          {
            icon: m,
            className: P("w-4 h-4 mr-2", u.icon)
          }
        ),
        /* @__PURE__ */ p("span", { className: "font-medium text-sm leading-none", children: k })
      ] })
    }
  );
};
Sw.displayName = "ToggleActionButton";
he.memo(Sw);
const oge = ({
  currentTokens: e,
  maxTokens: t,
  hasError: n = !1,
  hasWarning: a = !1,
  errorMessage: o,
  warningMessage: i,
  helperText: c,
  infoLinkSlot: s,
  className: l = "",
  classNames: u = {},
  label: h = "Tokens"
}) => {
  const k = o || i || c, f = P({
    "text-red-9": n && o,
    "text-yellow-9": a && i
  }), y = P("text-gray-11", {
    "text-red-9": n && o,
    "text-yellow-9": a && i
  });
  return /* @__PURE__ */ C("div", { className: P(l, u.container), children: [
    /* @__PURE__ */ C("div", { className: P("flex items-center gap-sm", u.header), children: [
      /* @__PURE__ */ C(q, { variant: x.MOBILE_HEADING_6_BOLD, children: [
        h,
        ":",
        /* @__PURE__ */ p("span", { className: P(f, u.count), children: e }),
        "/",
        t
      ] }),
      s && s
    ] }),
    k && /* @__PURE__ */ p(
      q,
      {
        variant: x.LABEL_SMALL_REGULAR,
        className: P(y, u.helperText),
        children: k
      }
    )
  ] });
};
he.memo(oge);
export {
  lge as Accordion,
  $ie as AccordionContent,
  Fie as AccordionHeader,
  Uie as AccordionItem,
  Ke as ActionPlacement,
  dge as Alert,
  U9 as AlertActions,
  z1 as AlertVariant,
  uge as AppliedFilterChip,
  sce as AppliedFilterChipVariant,
  hge as AppliedFilters,
  hce as AppliedFiltersClearAll,
  pce as AppliedFiltersDivider,
  yce as AppliedFiltersResultCount,
  bi as Avatar,
  oN as AvatarChip,
  G1 as AvatarShape,
  Xt as AvatarSize,
  _ge as AvatarStack,
  ki as Badge,
  V3e as BadgeColorVariant,
  Yn as BadgeSize,
  Bt as BadgeVariant,
  pge as Banner,
  z9 as BannerImageDirection,
  Y9 as BannerVariant,
  nt as Button,
  ft as ButtonColorVariant,
  wt as ButtonIcon,
  _e as ButtonSize,
  J as ButtonVariant,
  Zse as CharacterCard,
  Re as CharacterCardActions,
  lv as CharacterCardDisplayMode,
  qn as CharacterCardOrientation,
  Ne as CharacterCardVariant,
  gi as Checkbox,
  rc as CheckboxVariant,
  Vt as Chip,
  ac as ChipColorVariant,
  dt as ChipSize,
  Ze as ChipVariant,
  AS as ColorVariant,
  xt as ContentPlacement,
  yge as CountHeader,
  Jse as CountHeaderSize,
  kge as DetailDiff,
  di as DiffCompare,
  We as DiffSize,
  q1 as DiffTagStatus,
  Et as DiffVariant,
  mE as Drawer,
  lE as DropDownMenu,
  Vi as DropDownMenuDividerPositions,
  fge as Dropdown,
  e2e as EmptyState,
  mc as Filter,
  nn as FilterActions,
  mge as FilterToggleButton,
  gge as FilterV2,
  O0e as FilterV2Body,
  P0e as FilterV2Count,
  H0e as FilterV2Header,
  Mge as FilterV2Panel,
  B0e as FilterV2Reset,
  $0e as FilterV2Search,
  U0e as FilterV2Title,
  ut as FilterVariant,
  DN as HorizontalListItem,
  oe as Icon,
  IS as IconPlacement,
  ye as IconSize,
  R as IconVariants,
  Kt as Image,
  bge as ImageDiff,
  xi as Input,
  gE as InputVariant,
  F1 as LabelPosition,
  Lge as ListEmpty,
  xge as ListItem,
  ES as ListItemBadgeVariant,
  wS as ListItemStatusVariant,
  oc as ListItemVariant,
  TA as LorebookBadge,
  Ege as LorebookCard,
  Hfe as Markdown,
  vge as MediaFileDetails,
  Age as MediaFilePreview,
  $fe as MediaFileUnavailable,
  Rce as Modal,
  pn as ModalSize,
  ZT as ModalVariant,
  Ige as MultiSelect,
  Tge as Navigation,
  Nge as NumberInput,
  Cge as Pagination,
  OS as Platform,
  tt as Position,
  wge as ProgressBar,
  Sge as RadioGroup,
  ji as RadioGroupSize,
  TS as Radius,
  NS as Role,
  Rge as SegmentedControl,
  we as Shape,
  me as Size,
  Dge as Slider,
  CS as Space,
  Rn as Spinner,
  Ue as SpinnerSize,
  W1 as SpinnerVariant,
  Oge as Switch,
  ii as SwitchSize,
  RS as TabStatusVariant,
  Pge as Tabs,
  kme as Tag,
  U1 as TagActions,
  Hge as TagDiff,
  Bge as TagInput,
  Fge as TagListContainer,
  BT as TagListContainerContent,
  q as Text,
  V6e as TextArea,
  yA as TextAreaVariant,
  $ge as TextBox,
  av as TextColorVariant,
  Uge as TextDiff,
  x as TextVariants,
  Sw as ToggleActionButton,
  age as ToggleActionMode,
  oge as TokenCounter,
  Nt as Tooltip,
  hi as getFilterVariantState,
  vS as listItemBadgeStyles,
  SS as listItemStatusStyles,
  DS as tabStatusStyles,
  Dn as useMedia
};
//# sourceMappingURL=index.es.js.map
